//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { BaseClient } from './BaseClient';

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ActualBudgetRowClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number, projectId: number): Promise<BudgetRowResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ActualBudgetRow/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<BudgetRowResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetRowResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetRowResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: BudgetRowDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ActualBudgetRow/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getHeaders(tenantId: number, projectId: number): Promise<BudgetDateValueHeaderResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ActualBudgetRow/headers/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHeaders(_response);
        });
    }

    protected processGetHeaders(response: Response): Promise<BudgetDateValueHeaderResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetDateValueHeaderResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetDateValueHeaderResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, projectId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ActualBudgetRow/{tenantId}/{projectId}/exportAll";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AlertsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<AlertResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Alerts/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<AlertResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    seenAll(tenantId: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Alerts/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSeenAll(_response);
        });
    }

    protected processSeenAll(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    deleteAll(tenantId: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Alerts/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, alertId: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Alerts/{tenantId}/{alertId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (alertId === undefined || alertId === null)
            throw new Error("The parameter 'alertId' must be defined.");
        url_ = url_.replace("{alertId}", encodeURIComponent("" + alertId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class ApprovalRequestClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getMine(tenantId: number): Promise<ApprovalRequestResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ApprovalRequest/{tenantId}/my";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMine(_response);
        });
    }

    protected processGetMine(response: Response): Promise<ApprovalRequestResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalRequestResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalRequestResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getPending(tenantId: number): Promise<ApprovalRequestResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ApprovalRequest/{tenantId}/pending";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPending(_response);
        });
    }

    protected processGetPending(response: Response): Promise<ApprovalRequestResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalRequestResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalRequestResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAssignableProjects(tenantId: number): Promise<IdNameResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ApprovalRequest/{tenantId}/assignable-projects";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignableProjects(_response);
        });
    }

    protected processGetAssignableProjects(response: Response): Promise<IdNameResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAssignableTeams(tenantId: number, projectId: number): Promise<IdNameResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ApprovalRequest/{tenantId}/assignable-projects/{projectId}/teams";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignableTeams(_response);
        });
    }

    protected processGetAssignableTeams(response: Response): Promise<IdNameResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAssignableRoles(tenantId: number, projectId: number): Promise<IdNameResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ApprovalRequest/{tenantId}/assignable-projects/{projectId}/roles";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignableRoles(_response);
        });
    }

    protected processGetAssignableRoles(response: Response): Promise<IdNameResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, id: number): Promise<ApprovalRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ApprovalRequest/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ApprovalRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    withdraw(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ApprovalRequest/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWithdraw(_response);
        });
    }

    protected processWithdraw(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProject(tenantId: number, body: CreateProjectApprovalRequest | undefined): Promise<ApprovalRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ApprovalRequest/{tenantId}/project";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateProject(_response);
        });
    }

    protected processCreateProject(response: Response): Promise<ApprovalRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPartner(tenantId: number, body: CreatePartnerApprovalRequest | undefined): Promise<ApprovalRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ApprovalRequest/{tenantId}/partner";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePartner(_response);
        });
    }

    protected processCreatePartner(response: Response): Promise<ApprovalRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTeamMember(tenantId: number, body: CreateTeamMemberApprovalRequest | undefined): Promise<ApprovalRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ApprovalRequest/{tenantId}/team-member";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateTeamMember(_response);
        });
    }

    protected processCreateTeamMember(response: Response): Promise<ApprovalRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approve(tenantId: number, id: number, body: ApproveApprovalRequest | undefined): Promise<ApprovalRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ApprovalRequest/{tenantId}/{id}/approve";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApprove(_response);
        });
    }

    protected processApprove(response: Response): Promise<ApprovalRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reject(tenantId: number, id: number, body: RejectApprovalRequest | undefined): Promise<ApprovalRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ApprovalRequest/{tenantId}/{id}/reject";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReject(_response);
        });
    }

    protected processReject(response: Response): Promise<ApprovalRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    dismiss(tenantId: number, id: number): Promise<ApprovalRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ApprovalRequest/{tenantId}/{id}/dismiss";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDismiss(_response);
        });
    }

    protected processDismiss(response: Response): Promise<ApprovalRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalRequestResponseSimpleResponseModel>(null as any);
    }
}

export class BudgetConfigurationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number): Promise<BudgetConfigurationResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/BudgetConfiguration/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<BudgetConfigurationResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetConfigurationResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetConfigurationResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: UpdateBudgetConfigurationRequest | undefined): Promise<BudgetConfigurationResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/BudgetConfiguration/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BudgetConfigurationResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetConfigurationResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetConfigurationResponseSimpleResponseModel>(null as any);
    }
}

export class BudgetRowClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number, projectId: number): Promise<BudgetRowResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/BudgetRow/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<BudgetRowResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetRowResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetRowResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: BudgetRowDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/BudgetRow/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getHeaders(tenantId: number, projectId: number): Promise<BudgetDateValueHeaderResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/BudgetRow/headers/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHeaders(_response);
        });
    }

    protected processGetHeaders(response: Response): Promise<BudgetDateValueHeaderResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetDateValueHeaderResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetDateValueHeaderResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    release(tenantId: number, projectId: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/BudgetRow/release/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRelease(_response);
        });
    }

    protected processRelease(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, projectId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BudgetRow/{tenantId}/{projectId}/exportAll";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class BudgetStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<BudgetStatusResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/BudgetStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<BudgetStatusResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetStatusResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetStatusResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: SimpleStatusRequestUpdateSimpleStatusRequestItems | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/BudgetStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class BusinessPartnerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(id: number, tenantId: number): Promise<BusinessPartnerResponseModelSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/BusinessPartner/{tenantId}/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<BusinessPartnerResponseModelSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessPartnerResponseModelSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BusinessPartnerResponseModelSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<BusinessPartnerResponseModelItemsResponseModel> {
        let url_ = this.baseUrl + "/api/BusinessPartner/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<BusinessPartnerResponseModelItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessPartnerResponseModelItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BusinessPartnerResponseModelItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(tenantId: number, body: BusinessPartnerInsertRequestModel | undefined): Promise<BusinessPartnerResponseModelSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/BusinessPartner/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<BusinessPartnerResponseModelSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessPartnerResponseModelSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BusinessPartnerResponseModelSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: BusinessPartnerUpdateRequestModel | undefined): Promise<BusinessPartnerResponseModelSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/BusinessPartner/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BusinessPartnerResponseModelSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessPartnerResponseModelSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BusinessPartnerResponseModelSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, body: GenericFilterModelCollection | undefined): Promise<BusinessPartnerResponseModelItemsResponseModel> {
        let url_ = this.baseUrl + "/api/BusinessPartner/{tenantId}/genericFilter";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<BusinessPartnerResponseModelItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BusinessPartnerResponseModelItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BusinessPartnerResponseModelItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BusinessPartner/{tenantId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CalendarClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(tenantId: number, countryId: number): Promise<CalendarResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Calendar/{tenantId}/{countryId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<CalendarResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: InsertOrUpdateCalendarRequest | undefined): Promise<CalendarResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Calendar/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<CalendarResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getDifferenceInSpecificMeasurement(tenantId: number, projectId: number, from: Date | undefined, to: Date | undefined): Promise<DoubleSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Calendar/difference/{tenantId}/{projectId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDifferenceInSpecificMeasurement(_response);
        });
    }

    protected processGetDifferenceInSpecificMeasurement(response: Response): Promise<DoubleSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoubleSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DoubleSimpleResponseModel>(null as any);
    }
}

export class ChangeRequestClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getSimple(tenantId: number, id: number): Promise<SimpleChangeRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/simple/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimple(_response);
        });
    }

    protected processGetSimple(response: Response): Promise<SimpleChangeRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleChangeRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimpleChangeRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    getSimpleByIds(tenantId: number, ids: number[] | undefined): Promise<SimpleChangeRequestResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/simpleByIds/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimpleByIds(_response);
        });
    }

    protected processGetSimpleByIds(response: Response): Promise<SimpleChangeRequestResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleChangeRequestResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimpleChangeRequestResponseItemsResponseModel>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param projectIds (optional) 
     * @param statusId (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, projectId: number | undefined, projectIds: number[] | undefined, statusId: number | undefined, offset: number | undefined, limit: number | undefined): Promise<ChangeRequestResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (projectIds === null)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ChangeRequestResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRequestResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRequestResponseItemsResponseModel>(null as any);
    }

    /**
     * @param idFormatPrefix (optional) 
     * @param searchValue (optional) 
     * @param body (optional) 
     * @return Success
     */
    search(tenantId: number, idFormatPrefix: string | undefined, searchValue: string | undefined, body: GenericFilterModelCollection | undefined): Promise<SimpleChangeRequestResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/search/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (idFormatPrefix === null)
            throw new Error("The parameter 'idFormatPrefix' cannot be null.");
        else if (idFormatPrefix !== undefined)
            url_ += "idFormatPrefix=" + encodeURIComponent("" + idFormatPrefix) + "&";
        if (searchValue === null)
            throw new Error("The parameter 'searchValue' cannot be null.");
        else if (searchValue !== undefined)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<SimpleChangeRequestResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleChangeRequestResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimpleChangeRequestResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, projectId: number, body: GenericFilterModelCollection | undefined): Promise<ChangeRequestResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/{tenantId}/{projectId}/genericFilter";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<ChangeRequestResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRequestResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRequestResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilterCounts(tenantId: number, projectId: number, body: GenericFilterModelCollection | undefined): Promise<ChangeRequestCountsResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/{tenantId}/{projectId}/genericFilterCounts";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilterCounts(_response);
        });
    }

    protected processGetAllGenericFilterCounts(response: Response): Promise<ChangeRequestCountsResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRequestCountsResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRequestCountsResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number, id: number): Promise<ChangeRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ChangeRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, projectId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, projectId: number, body: InsertChangeRequestRequest | undefined): Promise<ChangeRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ChangeRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: UpdateChangeRequestRequest | undefined): Promise<ChangeRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ChangeRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    crAnalysis(tenantId: number, projectId: number, body: ChangeRequestAnalysisRequest | undefined): Promise<ChangeRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/analysis/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCrAnalysis(_response);
        });
    }

    protected processCrAnalysis(response: Response): Promise<ChangeRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    crApproval(tenantId: number, projectId: number, body: ChangeRequestApprovalRequest | undefined): Promise<ChangeRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/approval/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCrApproval(_response);
        });
    }

    protected processCrApproval(response: Response): Promise<ChangeRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    crRealization(tenantId: number, projectId: number, body: ChangeRequestRealizationRequest | undefined): Promise<ChangeRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/realization/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCrRealization(_response);
        });
    }

    protected processCrRealization(response: Response): Promise<ChangeRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    crAcceptance(tenantId: number, projectId: number, body: ChangeRequestAcceptanceRequest | undefined): Promise<ChangeRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/acceptance/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCrAcceptance(_response);
        });
    }

    protected processCrAcceptance(response: Response): Promise<ChangeRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    resetStatus(tenantId: number, projectId: number, id: number): Promise<ChangeRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/resetStatus/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetStatus(_response);
        });
    }

    protected processResetStatus(response: Response): Promise<ChangeRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    download(tenantId: number, projectId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ChangeRequest/download/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    removeAttachment(tenantId: number, projectId: number, changeRequestId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequest/attachment/{tenantId}/{projectId}/{changeRequestId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (changeRequestId === undefined || changeRequestId === null)
            throw new Error("The parameter 'changeRequestId' must be defined.");
        url_ = url_.replace("{changeRequestId}", encodeURIComponent("" + changeRequestId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveAttachment(_response);
        });
    }

    protected processRemoveAttachment(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, projectId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ChangeRequest/{tenantId}/{projectId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ChangeRequestStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<ChangeRequestStatusResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequestStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ChangeRequestStatusResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangeRequestStatusResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangeRequestStatusResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: SimpleStatusRequestUpdateSimpleStatusRequestItems | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequestStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class ChangeRequestTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(tenantId: number): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequestType/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: TenantIsActiveDeltaRequest | undefined): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ChangeRequestType/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }
}

export class CommunicationCalendarClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param projectIds (optional) 
     * @param nonProjectCategoryIds (optional) 
     * @param types (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getAllMy(tenantId: number, projectIds: number[] | undefined, nonProjectCategoryIds: number[] | undefined, types: EntityTypeEnum[] | undefined, from: Date | undefined, to: Date | undefined): Promise<CommunicationCalendarResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/CommunicationCalendar/getMy/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectIds === null)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (nonProjectCategoryIds === null)
            throw new Error("The parameter 'nonProjectCategoryIds' cannot be null.");
        else if (nonProjectCategoryIds !== undefined)
            nonProjectCategoryIds && nonProjectCategoryIds.forEach(item => { url_ += "nonProjectCategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (types === null)
            throw new Error("The parameter 'types' cannot be null.");
        else if (types !== undefined)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMy(_response);
        });
    }

    protected processGetAllMy(response: Response): Promise<CommunicationCalendarResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunicationCalendarResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommunicationCalendarResponseItemsResponseModel>(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param nonProjectCategoryIds (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getAllMeetings(tenantId: number, projectIds: number[] | undefined, nonProjectCategoryIds: number[] | undefined, from: Date | undefined, to: Date | undefined): Promise<CommunicationCalendarResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/CommunicationCalendar/getAllMeetings/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectIds === null)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (nonProjectCategoryIds === null)
            throw new Error("The parameter 'nonProjectCategoryIds' cannot be null.");
        else if (nonProjectCategoryIds !== undefined)
            nonProjectCategoryIds && nonProjectCategoryIds.forEach(item => { url_ += "nonProjectCategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMeetings(_response);
        });
    }

    protected processGetAllMeetings(response: Response): Promise<CommunicationCalendarResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunicationCalendarResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommunicationCalendarResponseItemsResponseModel>(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllVacations(tenantId: number, from: Date | undefined, to: Date | undefined, body: GetVacationsCalendarRequest | undefined): Promise<CommunicationCalendarResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/CommunicationCalendar/getAllVacations/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllVacations(_response);
        });
    }

    protected processGetAllVacations(response: Response): Promise<CommunicationCalendarResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunicationCalendarResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommunicationCalendarResponseItemsResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateTaskDate(tenantId: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined, body: UpdateTaskCalendarItemRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/CommunicationCalendar/updateDates/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTaskDate(_response);
        });
    }

    protected processUpdateTaskDate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class CommunicationConfigClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getTaskGeneralConfig(tenantId: number): Promise<TaskGeneralConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/CommunicationConfig/taskGeneralConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTaskGeneralConfig(_response);
        });
    }

    protected processGetTaskGeneralConfig(response: Response): Promise<TaskGeneralConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskGeneralConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskGeneralConfigResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTaskGeneralConfig(tenantId: number, body: UpdateTaskGeneralConfigRequest | undefined): Promise<TaskGeneralConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/CommunicationConfig/taskGeneralConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTaskGeneralConfig(_response);
        });
    }

    protected processUpdateTaskGeneralConfig(response: Response): Promise<TaskGeneralConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskGeneralConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskGeneralConfigResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getMeetingGeneralConfig(tenantId: number): Promise<MeetingGeneralConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/CommunicationConfig/meetingGeneralConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeetingGeneralConfig(_response);
        });
    }

    protected processGetMeetingGeneralConfig(response: Response): Promise<MeetingGeneralConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingGeneralConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingGeneralConfigResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMeetingGeneralConfig(tenantId: number, body: UpdateMeetingGeneralConfigRequest | undefined): Promise<MeetingGeneralConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/CommunicationConfig/meetingGeneralConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMeetingGeneralConfig(_response);
        });
    }

    protected processUpdateMeetingGeneralConfig(response: Response): Promise<MeetingGeneralConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingGeneralConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingGeneralConfigResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getStatusReportGeneralConfig(tenantId: number): Promise<StatusReportGeneralConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/CommunicationConfig/statusReportGeneralConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStatusReportGeneralConfig(_response);
        });
    }

    protected processGetStatusReportGeneralConfig(response: Response): Promise<StatusReportGeneralConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusReportGeneralConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusReportGeneralConfigResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateStatusReportGeneralConfig(tenantId: number, body: UpdateStatusReportGeneralConfigRequest | undefined): Promise<StatusReportGeneralConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/CommunicationConfig/statusReportGeneralConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateStatusReportGeneralConfig(_response);
        });
    }

    protected processUpdateStatusReportGeneralConfig(response: Response): Promise<StatusReportGeneralConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusReportGeneralConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusReportGeneralConfigResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getMeetingTypes(tenantId: number): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/CommunicationConfig/meetingType/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeetingTypes(_response);
        });
    }

    protected processGetMeetingTypes(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMeetingTypes(tenantId: number, body: TenantIsActiveDeltaRequest | undefined): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/CommunicationConfig/financeCategory/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMeetingTypes(_response);
        });
    }

    protected processUpdateMeetingTypes(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }
}

export class CommunicationDashboardClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    get(tenantId: number, body: CommunicationDashboardFilterRequest | undefined): Promise<CommunicationDashboardResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/CommunicationDashboard/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<CommunicationDashboardResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunicationDashboardResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommunicationDashboardResponseSimpleResponseModel>(null as any);
    }
}

export class CountryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getCountries(): Promise<IdNameSymbolResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Country";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCountries(_response);
        });
    }

    protected processGetCountries(response: Response): Promise<IdNameSymbolResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameSymbolResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameSymbolResponseItemsResponseModel>(null as any);
    }
}

export class CurrencyClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getCurrencies(): Promise<IdNameSymbolResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Currency";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrencies(_response);
        });
    }

    protected processGetCurrencies(response: Response): Promise<IdNameSymbolResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameSymbolResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameSymbolResponseItemsResponseModel>(null as any);
    }
}

export class DateTimePatternClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getDatePatterns(): Promise<DateTimePatternResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/DateTimePattern/date";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDatePatterns(_response);
        });
    }

    protected processGetDatePatterns(response: Response): Promise<DateTimePatternResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateTimePatternResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DateTimePatternResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getTimePatterns(): Promise<DateTimePatternResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/DateTimePattern/time";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTimePatterns(_response);
        });
    }

    protected processGetTimePatterns(response: Response): Promise<DateTimePatternResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateTimePatternResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DateTimePatternResponseItemsResponseModel>(null as any);
    }
}

export class DefaultProjectClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(tenantId: number, userId: number): Promise<DefaultProjectResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/DefaultProject/{tenantId}/{userId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<DefaultProjectResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultProjectResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefaultProjectResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    set(tenantId: number, body: SetDefaultProjectRequest | undefined): Promise<DefaultProjectResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/DefaultProject/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSet(_response);
        });
    }

    protected processSet(response: Response): Promise<DefaultProjectResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultProjectResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DefaultProjectResponseSimpleResponseModel>(null as any);
    }
}

export class EmailClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(offset: number | undefined, limit: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Email/template?";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    add(body: AddEmailTemplateRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Email/template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Email/template/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(id: number, body: UpdateEmailTemplateRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Email/template/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllData(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Email/templateData/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllData(_response);
        });
    }

    protected processGetAllData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addData(id: number, body: AddUpdateEmailTemplateDataRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Email/templateData/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddData(_response);
        });
    }

    protected processAddData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteData(id: number, languageId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Email/templateData/{id}/{languageId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined.");
        url_ = url_.replace("{languageId}", encodeURIComponent("" + languageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteData(_response);
        });
    }

    protected processDeleteData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateData(id: number, languageId: number, body: AddUpdateEmailTemplateDataRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Email/templateData/{id}/{languageId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined.");
        url_ = url_.replace("{languageId}", encodeURIComponent("" + languageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateData(_response);
        });
    }

    protected processUpdateData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    send(body: SendEmailRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Email/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSend(_response);
        });
    }

    protected processSend(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ExpenseClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllMy(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: GenericFilterModelCollection | undefined): Promise<ExpenseResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Expense/allMy/{tenantId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMy(_response);
        });
    }

    protected processGetAllMy(response: Response): Promise<ExpenseResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseResponseItemsResponseModel>(null as any);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllMyGenericTotals(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: GenericFilterModelCollection | undefined): Promise<ExpenseTotalsResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Expense/allMyTotals/{tenantId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMyGenericTotals(_response);
        });
    }

    protected processGetAllMyGenericTotals(response: Response): Promise<ExpenseTotalsResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseTotalsResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseTotalsResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGeneric(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: GenericFilterModelCollection | undefined): Promise<ExpenseResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Expense/allGeneric/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGeneric(_response);
        });
    }

    protected processGetAllGeneric(response: Response): Promise<ExpenseResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseResponseItemsResponseModel>(null as any);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericTotals(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: GenericFilterModelCollection | undefined): Promise<ExpenseTotalsResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Expense/allGenericTotals/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericTotals(_response);
        });
    }

    protected processGetAllGenericTotals(response: Response): Promise<ExpenseTotalsResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseTotalsResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseTotalsResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, id: number): Promise<ExpenseResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Expense/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ExpenseResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Expense/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, body: InsertExpenseRequest | undefined): Promise<ExpenseResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Expense/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ExpenseResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: UpdateExpenseRequest | undefined): Promise<ExpenseResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Expense/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ExpenseResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    releaseMy(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Expense/releaseMy/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReleaseMy(_response);
        });
    }

    protected processReleaseMy(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approval(tenantId: number, id: number, body: ApprovalTimeTravelDescriptiveRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Expense/approval/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproval(_response);
        });
    }

    protected processApproval(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    clone(tenantId: number, id: number): Promise<ExpenseResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Expense/{tenantId}/{id}/clone";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClone(_response);
        });
    }

    protected processClone(response: Response): Promise<ExpenseResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    downloadAttachment(tenantId: number, expenseItemId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Expense/attachment/{tenantId}/{expenseItemId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (expenseItemId === undefined || expenseItemId === null)
            throw new Error("The parameter 'expenseItemId' must be defined.");
        url_ = url_.replace("{expenseItemId}", encodeURIComponent("" + expenseItemId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadAttachment(_response);
        });
    }

    protected processDownloadAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Expense/{tenantId}/exportAll?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class FinanceConfigClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getFinanceCategories(tenantId: number): Promise<FinanceCategoryResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/FinanceConfig/financeCategory/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFinanceCategories(_response);
        });
    }

    protected processGetFinanceCategories(response: Response): Promise<FinanceCategoryResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinanceCategoryResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinanceCategoryResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFinanceCategories(tenantId: number, body: TenantIsActiveDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/FinanceConfig/financeCategory/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFinanceCategories(_response);
        });
    }

    protected processUpdateFinanceCategories(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getFinanceGeneralConfig(tenantId: number): Promise<FinanceGeneralConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/FinanceConfig/financeGeneralConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFinanceGeneralConfig(_response);
        });
    }

    protected processGetFinanceGeneralConfig(response: Response): Promise<FinanceGeneralConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinanceGeneralConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinanceGeneralConfigResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFinanceGeneralConfig(tenantId: number, body: UpdateFinanceGeneralConfigRequest | undefined): Promise<FinanceGeneralConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/FinanceConfig/financeGeneralConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFinanceGeneralConfig(_response);
        });
    }

    protected processUpdateFinanceGeneralConfig(response: Response): Promise<FinanceGeneralConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinanceGeneralConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinanceGeneralConfigResponseSimpleResponseModel>(null as any);
    }
}

export class FinanceDashboardClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    get(tenantId: number, body: FinanceDashboardFilterRequest | undefined): Promise<FinanceDashboardResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/FinanceDashboard/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FinanceDashboardResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinanceDashboardResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinanceDashboardResponseSimpleResponseModel>(null as any);
    }
}

export class ForgotClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    forgotPasswordStart(email: string, domain: string): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Forgot/password?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (domain === undefined || domain === null)
            throw new Error("The parameter 'domain' must be defined and cannot be null.");
        else
            url_ += "Domain=" + encodeURIComponent("" + domain) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForgotPasswordStart(_response);
        });
    }

    protected processForgotPasswordStart(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPasswordFinish(body: ForgotPasswordFinishRequestModel | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Forgot/password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForgotPasswordFinish(_response);
        });
    }

    protected processForgotPasswordFinish(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    forgetEmail(username: string, domain: string): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Forgot/email?";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined and cannot be null.");
        else
            url_ += "Username=" + encodeURIComponent("" + username) + "&";
        if (domain === undefined || domain === null)
            throw new Error("The parameter 'domain' must be defined and cannot be null.");
        else
            url_ += "Domain=" + encodeURIComponent("" + domain) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForgetEmail(_response);
        });
    }

    protected processForgetEmail(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class IndustryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getIndustries(): Promise<IdNameSymbolResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Industry";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIndustries(_response);
        });
    }

    protected processGetIndustries(response: Response): Promise<IdNameSymbolResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameSymbolResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameSymbolResponseItemsResponseModel>(null as any);
    }
}

export class InvoiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, projectId: number, body: GenericFilterModelCollection | undefined): Promise<InvoiceResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Invoice/{tenantId}/{projectId}/genericFilter";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<InvoiceResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilterCounts(tenantId: number, projectId: number, body: GenericFilterModelCollection | undefined): Promise<InvoiceCountsResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Invoice/{tenantId}/{projectId}/genericFilterCounts";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilterCounts(_response);
        });
    }

    protected processGetAllGenericFilterCounts(response: Response): Promise<InvoiceCountsResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceCountsResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceCountsResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number, id: number): Promise<InvoiceResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Invoice/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<InvoiceResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, projectId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Invoice/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, projectId: number, body: InsertInvoiceRequest | undefined): Promise<InvoiceResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Invoice/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<InvoiceResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: UpdateInvoiceRequest | undefined): Promise<InvoiceResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Invoice/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<InvoiceResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    download(tenantId: number, projectId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Invoice/attachment/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    removeAttachment(tenantId: number, projectId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Invoice/attachment/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveAttachment(_response);
        });
    }

    protected processRemoveAttachment(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, projectId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Invoice/{tenantId}/{projectId}/exportAll";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class InvoiceStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<InvoiceStatusResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/InvoiceStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<InvoiceStatusResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceStatusResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceStatusResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: SimpleStatusRequestUpdateSimpleStatusRequestItems | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/InvoiceStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class LanguageClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(): Promise<void> {
        let url_ = this.baseUrl + "/api/Language";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    download(): Promise<void> {
        let url_ = this.baseUrl + "/api/Language/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    upload(body: UploadLanguagesExcelRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Language/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LoginClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginRequestModel | undefined): Promise<TokenResponseModel> {
        let url_ = this.baseUrl + "/api/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<TokenResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    refreshToken(): Promise<TokenResponseModel> {
        let url_ = this.baseUrl + "/api/Login/refreshToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: Response): Promise<TokenResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getRefreshToken(): Promise<RefreshTokenResponseModel> {
        let url_ = this.baseUrl + "/api/Login/refreshToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRefreshToken(_response);
        });
    }

    protected processGetRefreshToken(response: Response): Promise<RefreshTokenResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RefreshTokenResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshTokenWithToken(body: RefreshTokenWithTokenRequestModel | undefined): Promise<TokenResponseModel> {
        let url_ = this.baseUrl + "/api/Login/refreshTokenWithToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRefreshTokenWithToken(_response);
        });
    }

    protected processRefreshTokenWithToken(response: Response): Promise<TokenResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = TokenResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenResponseModel>(null as any);
    }
}

export class MeetingClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getSimple(tenantId: number, id: number): Promise<IdNameResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Meeting/simple/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimple(_response);
        });
    }

    protected processGetSimple(response: Response): Promise<IdNameResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    getSimpleByIds(tenantId: number, ids: number[] | undefined): Promise<IdNameResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Meeting/simpleByIds/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimpleByIds(_response);
        });
    }

    protected processGetSimpleByIds(response: Response): Promise<IdNameResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameResponseItemsResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @param statusId (optional) 
     * @param notEqualStatusId (optional) 
     * @return Success
     */
    getAll(tenantId: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined, statusId: number | undefined, notEqualStatusId: number | undefined): Promise<MeetingResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Meeting/{tenantId}/getAll?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        if (notEqualStatusId === null)
            throw new Error("The parameter 'notEqualStatusId' cannot be null.");
        else if (notEqualStatusId !== undefined)
            url_ += "notEqualStatusId=" + encodeURIComponent("" + notEqualStatusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<MeetingResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAllSimple(tenantId: number): Promise<SimpleIdNameModelItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Meeting/{tenantId}/getAllSimple";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSimple(_response);
        });
    }

    protected processGetAllSimple(response: Response): Promise<SimpleIdNameModelItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleIdNameModelItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimpleIdNameModelItemsResponseModel>(null as any);
    }

    /**
     * @param idFormatPrefix (optional) 
     * @param searchValue (optional) 
     * @param body (optional) 
     * @return Success
     */
    search(tenantId: number, idFormatPrefix: string | undefined, searchValue: string | undefined, body: GenericFilterModelCollection | undefined): Promise<IdNameResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Meeting/search/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (idFormatPrefix === null)
            throw new Error("The parameter 'idFormatPrefix' cannot be null.");
        else if (idFormatPrefix !== undefined)
            url_ += "idFormatPrefix=" + encodeURIComponent("" + idFormatPrefix) + "&";
        if (searchValue === null)
            throw new Error("The parameter 'searchValue' cannot be null.");
        else if (searchValue !== undefined)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<IdNameResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameResponseItemsResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined, body: GenericFilterModelCollection | undefined): Promise<MeetingResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Meeting/{tenantId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<MeetingResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingResponseItemsResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    get(tenantId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<MeetingResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Meeting/{tenantId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<MeetingResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    delete(tenantId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Meeting/{tenantId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param isRelease (optional) 
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, isRelease: boolean | undefined, body: InsertMeetingRequest | undefined): Promise<MeetingResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Meeting/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (isRelease === null)
            throw new Error("The parameter 'isRelease' cannot be null.");
        else if (isRelease !== undefined)
            url_ += "isRelease=" + encodeURIComponent("" + isRelease) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<MeetingResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param isRelease (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, isRelease: boolean | undefined, body: UpdateMeetingRequest | undefined): Promise<MeetingResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Meeting/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (isRelease === null)
            throw new Error("The parameter 'isRelease' cannot be null.");
        else if (isRelease !== undefined)
            url_ += "isRelease=" + encodeURIComponent("" + isRelease) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<MeetingResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    resetStatus(tenantId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Meeting/resetStatus/{tenantId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetStatus(_response);
        });
    }

    protected processResetStatus(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    release(tenantId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Meeting/release/{tenantId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRelease(_response);
        });
    }

    protected processRelease(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    clone(tenantId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<MeetingResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Meeting/clone/{tenantId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClone(_response);
        });
    }

    protected processClone(response: Response): Promise<MeetingResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @param isPrivate (optional) 
     * @return Success
     */
    setIsPrivate(tenantId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined, isPrivate: boolean | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Meeting/isPrivate/{tenantId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        if (isPrivate === null)
            throw new Error("The parameter 'isPrivate' cannot be null.");
        else if (isPrivate !== undefined)
            url_ += "isPrivate=" + encodeURIComponent("" + isPrivate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetIsPrivate(_response);
        });
    }

    protected processSetIsPrivate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    download(tenantId: number, meetingId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Meeting/download/{tenantId}/{meetingId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    removeAttachment(tenantId: number, meetingId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Meeting/attachment/{tenantId}/{meetingId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveAttachment(_response);
        });
    }

    protected processRemoveAttachment(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Meeting/{tenantId}/exportAll?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MeetingCommentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, body: InsertMeetingCommentRequest | undefined): Promise<MeetingCommentResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/MeetingComment/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<MeetingCommentResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingCommentResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingCommentResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: UpdateMeetingCommentRequest | undefined): Promise<MeetingCommentResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/MeetingComment/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<MeetingCommentResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingCommentResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingCommentResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/MeetingComment/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class MeetingDecisionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined, body: GenericFilterModelCollection | undefined): Promise<MeetingDecisionResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/MeetingDecision/{tenantId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<MeetingDecisionResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingDecisionResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingDecisionResponseItemsResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MeetingDecision/{tenantId}/exportAll?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MeetingStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<MeetingStatusResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/MeetingStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<MeetingStatusResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingStatusResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingStatusResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: SimpleStatusRequestUpdateSimpleStatusRequestItems | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/MeetingStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class OrganizationalUnitClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(tenantId: number, id: number): Promise<OrganizationalUnitResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/OrganizationalUnit/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<OrganizationalUnitResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalUnitResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationalUnitResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/OrganizationalUnit/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param parentId (optional) 
     * @param levelNumber (optional) 
     * @return Success
     */
    getAll(tenantId: number, parentId: number | undefined, levelNumber: number | undefined): Promise<OrganizationalUnitResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/OrganizationalUnit/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&";
        if (levelNumber === null)
            throw new Error("The parameter 'levelNumber' cannot be null.");
        else if (levelNumber !== undefined)
            url_ += "LevelNumber=" + encodeURIComponent("" + levelNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<OrganizationalUnitResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalUnitResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationalUnitResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, body: InsertOrganizationalUnitRequest | undefined): Promise<OrganizationalUnitResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/OrganizationalUnit/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<OrganizationalUnitResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalUnitResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationalUnitResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: UpdateOrganizationalUnitRequest | undefined): Promise<OrganizationalUnitResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/OrganizationalUnit/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<OrganizationalUnitResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalUnitResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationalUnitResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrders(tenantId: number, body: UpdateOrderRequest[] | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/OrganizationalUnit/orders/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateOrders(_response);
        });
    }

    protected processUpdateOrders(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class OrganizationalUnitManagerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(tenantId: number, id: number): Promise<OrganizationalUnitManagerResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/OrganizationalUnitManager/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<OrganizationalUnitManagerResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalUnitManagerResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationalUnitManagerResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/OrganizationalUnitManager/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param organizationalUnitId (optional) 
     * @param isResourceManager (optional) 
     * @param date (optional) 
     * @return Success
     */
    getAll(tenantId: number, userId: number | undefined, organizationalUnitId: number | undefined, isResourceManager: boolean | undefined, date: Date | undefined): Promise<OrganizationalUnitManagerResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/OrganizationalUnitManager/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organizationalUnitId === null)
            throw new Error("The parameter 'organizationalUnitId' cannot be null.");
        else if (organizationalUnitId !== undefined)
            url_ += "OrganizationalUnitId=" + encodeURIComponent("" + organizationalUnitId) + "&";
        if (isResourceManager === null)
            throw new Error("The parameter 'isResourceManager' cannot be null.");
        else if (isResourceManager !== undefined)
            url_ += "IsResourceManager=" + encodeURIComponent("" + isResourceManager) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<OrganizationalUnitManagerResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalUnitManagerResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationalUnitManagerResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, body: InsertOrganizationalUnitManagerRequest | undefined): Promise<OrganizationalUnitManagerResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/OrganizationalUnitManager/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<OrganizationalUnitManagerResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalUnitManagerResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationalUnitManagerResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: UpdateOrganizationalUnitManagerRequest | undefined): Promise<OrganizationalUnitManagerResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/OrganizationalUnitManager/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<OrganizationalUnitManagerResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationalUnitManagerResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationalUnitManagerResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    isUserManager(tenantId: number): Promise<BooleanSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/OrganizationalUnitManager/isManager/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsUserManager(_response);
        });
    }

    protected processIsUserManager(response: Response): Promise<BooleanSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanSimpleResponseModel>(null as any);
    }
}

export class PaymentInfoClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    createSetupIntent(tenantId: number): Promise<StringSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/PaymentInfo/CreateSetupIntent/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSetupIntent(_response);
        });
    }

    protected processCreateSetupIntent(response: Response): Promise<StringSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getPaymentMethods(tenantId: number): Promise<PaymentMethodResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/PaymentInfo/GetPaymentMethods/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPaymentMethods(_response);
        });
    }

    protected processGetPaymentMethods(response: Response): Promise<PaymentMethodResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentMethodResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentMethodResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getDefaultPaymentSourceId(tenantId: number): Promise<StringSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/PaymentInfo/GetDefaultPaymentSourceId/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDefaultPaymentSourceId(_response);
        });
    }

    protected processGetDefaultPaymentSourceId(response: Response): Promise<StringSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    setDefaultPaymentSourceId(tenantId: number, paymentMethodId: string): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/PaymentInfo/SetDefaultPaymentSourceId/{tenantId}/{paymentMethodId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (paymentMethodId === undefined || paymentMethodId === null)
            throw new Error("The parameter 'paymentMethodId' must be defined.");
        url_ = url_.replace("{paymentMethodId}", encodeURIComponent("" + paymentMethodId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetDefaultPaymentSourceId(_response);
        });
    }

    protected processSetDefaultPaymentSourceId(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    removePaymentMethod(tenantId: number, paymentMethodId: string): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/PaymentInfo/RemovePaymentMethod/{tenantId}/{paymentMethodId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (paymentMethodId === undefined || paymentMethodId === null)
            throw new Error("The parameter 'paymentMethodId' must be defined.");
        url_ = url_.replace("{paymentMethodId}", encodeURIComponent("" + paymentMethodId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemovePaymentMethod(_response);
        });
    }

    protected processRemovePaymentMethod(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class PricelistClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(tenantId: number): Promise<PricelistRowResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Pricelist/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PricelistRowResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PricelistRowResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PricelistRowResponseItemsResponseModel>(null as any);
    }
}

export class PricingPlanClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(tenantId: number): Promise<PricingPlanResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/PricingPlan/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PricingPlanResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PricingPlanResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PricingPlanResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: PricingPlanRequestModel | undefined): Promise<PricingPlanResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/PricingPlan/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<PricingPlanResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PricingPlanResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PricingPlanResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getFull(tenantId: number): Promise<PricingPlanFullResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/PricingPlan/getFull/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFull(_response);
        });
    }

    protected processGetFull(response: Response): Promise<PricingPlanFullResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PricingPlanFullResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PricingPlanFullResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    cancel(tenantId: number): Promise<PricingPlanResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/PricingPlan/cancel/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: Response): Promise<PricingPlanResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PricingPlanResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PricingPlanResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    reactivate(tenantId: number): Promise<PricingPlanResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/PricingPlan/reactivate/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReactivate(_response);
        });
    }

    protected processReactivate(response: Response): Promise<PricingPlanResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PricingPlanResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PricingPlanResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    checkForExpired(): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/PricingPlan/check";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckForExpired(_response);
        });
    }

    protected processCheckForExpired(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    checkStatusOfInvoices(): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/PricingPlan/checkStatusOfInvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckStatusOfInvoices(_response);
        });
    }

    protected processCheckStatusOfInvoices(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    checkInvoicesForPayment(): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/PricingPlan/checkInvoicesForPayment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckInvoicesForPayment(_response);
        });
    }

    protected processCheckInvoicesForPayment(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class PricingPlanInvoiceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<PricingPlanInvoiceResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/PricingPlanInvoice/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<PricingPlanInvoiceResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PricingPlanInvoiceResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PricingPlanInvoiceResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getFileContent(tenantId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/PricingPlanInvoice/fileContent/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileContent(_response);
        });
    }

    protected processGetFileContent(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProjectClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<ProjectResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Project/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, body: InsertProjectRequest | undefined): Promise<ProjectResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Project/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ProjectResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: UpdateProjectRequest | undefined): Promise<ProjectResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Project/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAllForOrgUnitManager(tenantId: number): Promise<ProjectResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Project/getAllForOrgUnitManager/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllForOrgUnitManager(_response);
        });
    }

    protected processGetAllForOrgUnitManager(response: Response): Promise<ProjectResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAllForOrgUnitManagerUsers(tenantId: number): Promise<ProjectResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Project/getAllForOrgUnitManagerUsers/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllForOrgUnitManagerUsers(_response);
        });
    }

    protected processGetAllForOrgUnitManagerUsers(response: Response): Promise<ProjectResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, body: GenericFilterModelCollection | undefined): Promise<ProjectGetAllResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Project/{tenantId}/genericFilter";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<ProjectGetAllResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectGetAllResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectGetAllResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number): Promise<ProjectResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Project/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, projectId: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Project/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    releas(tenantId: number, body: ProjectIdRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Project/releas/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReleas(_response);
        });
    }

    protected processReleas(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    achive(tenantId: number, body: ProjectIdRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Project/archive/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAchive(_response);
        });
    }

    protected processAchive(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    restore(tenantId: number, body: ProjectIdRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Project/restore/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProjectData(tenantId: number, body: UpdateProjectDataRequest | undefined): Promise<ProjectResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Project/updatedata/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProjectData(_response);
        });
    }

    protected processUpdateProjectData(response: Response): Promise<ProjectResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getProjectInformation(tenantId: number, projectId: number): Promise<StringSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Project/getInformation/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProjectInformation(_response);
        });
    }

    protected processGetProjectInformation(response: Response): Promise<StringSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProjectInformation(tenantId: number, projectId: number, body: UpdateProjectInformationRequest | undefined): Promise<StringSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Project/updateInformation/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProjectInformation(_response);
        });
    }

    protected processUpdateProjectInformation(response: Response): Promise<StringSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    isUserPM(tenantId: number): Promise<BooleanSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Project/ispm/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsUserPM(_response);
        });
    }

    protected processIsUserPM(response: Response): Promise<BooleanSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    downloadAttachment(tenantId: number, projectId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Project/attachment/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadAttachment(_response);
        });
    }

    protected processDownloadAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    removeAttachment(tenantId: number, projectId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Project/attachment/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveAttachment(_response);
        });
    }

    protected processRemoveAttachment(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Project/{tenantId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProjectAccomplishmentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param isActive (optional) 
     * @param status (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, reportId: number, isActive: boolean | undefined, status: ReportItemStatusEnum | undefined, offset: number | undefined, limit: number | undefined): Promise<ProjectAccomplishmentResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectAccomplishment/{tenantId}/{reportId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectAccomplishmentResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectAccomplishmentResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectAccomplishmentResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, reportId: number, body: InsertProjectAccomplishmentRequest | undefined): Promise<ProjectAccomplishmentResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectAccomplishment/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ProjectAccomplishmentResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectAccomplishmentResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectAccomplishmentResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, reportId: number, body: UpdateProjectAccomplishmentRequest | undefined): Promise<ProjectAccomplishmentResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectAccomplishment/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectAccomplishmentResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectAccomplishmentResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectAccomplishmentResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, reportId: number, body: GenericFilterModelCollection | undefined): Promise<ProjectAccomplishmentResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectAccomplishment/{tenantId}/{reportId}/genericFilter";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<ProjectAccomplishmentResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectAccomplishmentResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectAccomplishmentResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, reportId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectAccomplishment/{tenantId}/{reportId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, reportId: number, id: number): Promise<ProjectAccomplishmentResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectAccomplishment/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectAccomplishmentResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectAccomplishmentResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectAccomplishmentResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, reportId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectAccomplishment/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class ProjectActionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param isActive (optional) 
     * @param status (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, reportId: number, isActive: boolean | undefined, status: ReportItemStatusEnum | undefined, offset: number | undefined, limit: number | undefined): Promise<ProjectActionResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectAction/{tenantId}/{reportId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectActionResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectActionResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectActionResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, reportId: number, body: InsertProjectActionRequest | undefined): Promise<ProjectActionResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectAction/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ProjectActionResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectActionResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectActionResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, reportId: number, body: UpdateProjectActionRequest | undefined): Promise<ProjectActionResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectAction/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectActionResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectActionResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectActionResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilterExample(tenantId: number, reportId: number, body: GenericFilterModelCollection | undefined): Promise<ProjectActionResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectAction/{tenantId}/{reportId}/genericFilter";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilterExample(_response);
        });
    }

    protected processGetAllGenericFilterExample(response: Response): Promise<ProjectActionResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectActionResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectActionResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, reportId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectAction/{tenantId}/{reportId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, reportId: number, id: number): Promise<ProjectActionResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectAction/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectActionResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectActionResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectActionResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, reportId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectAction/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class ProjectBusinessClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param isActive (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, reportId: number, isActive: boolean | undefined, offset: number | undefined, limit: number | undefined): Promise<ProjectBusinessResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectBusiness/{tenantId}/{reportId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectBusinessResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectBusinessResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectBusinessResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, reportId: number, body: InsertProjectBusinessRequest | undefined): Promise<ProjectBusinessResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectBusiness/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ProjectBusinessResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectBusinessResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectBusinessResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, reportId: number, body: UpdateProjectBusinessRequest | undefined): Promise<ProjectBusinessResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectBusiness/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectBusinessResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectBusinessResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectBusinessResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, reportId: number, body: GenericFilterModelCollection | undefined): Promise<ProjectBusinessResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectBusiness/{tenantId}/{reportId}/genericFilter";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<ProjectBusinessResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectBusinessResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectBusinessResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, reportId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectBusiness/{tenantId}/{reportId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, reportId: number, id: number): Promise<ProjectBusinessResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectBusiness/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectBusinessResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectBusinessResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectBusinessResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, reportId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectBusiness/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class ProjectChangeRequestClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param statusId (optional) 
     * @param isGenerated (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, reportId: number, statusId: number | undefined, isGenerated: boolean | undefined, offset: number | undefined, limit: number | undefined): Promise<ProjectChangeRequestResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectChangeRequest/{tenantId}/{reportId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (isGenerated === null)
            throw new Error("The parameter 'isGenerated' cannot be null.");
        else if (isGenerated !== undefined)
            url_ += "IsGenerated=" + encodeURIComponent("" + isGenerated) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectChangeRequestResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectChangeRequestResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectChangeRequestResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, reportId: number, body: InsertProjectChangeRequestRequest | undefined): Promise<ProjectChangeRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectChangeRequest/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ProjectChangeRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectChangeRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectChangeRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, reportId: number, body: UpdateProjectChangeRequestRequest | undefined): Promise<ProjectChangeRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectChangeRequest/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectChangeRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectChangeRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectChangeRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param copyFromScope (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, reportId: number, copyFromScope: boolean | undefined, body: GenericFilterModelCollection | undefined): Promise<ProjectChangeRequestResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectChangeRequest/{tenantId}/{reportId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (copyFromScope === null)
            throw new Error("The parameter 'copyFromScope' cannot be null.");
        else if (copyFromScope !== undefined)
            url_ += "copyFromScope=" + encodeURIComponent("" + copyFromScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<ProjectChangeRequestResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectChangeRequestResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectChangeRequestResponseItemsResponseModel>(null as any);
    }

    /**
     * @param copyFromScope (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilterCounts(tenantId: number, reportId: number, copyFromScope: boolean | undefined, body: GenericFilterModelCollection | undefined): Promise<ProjectChangeRequestCountsResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectChangeRequest/{tenantId}/{reportId}/genericFilterCounts?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (copyFromScope === null)
            throw new Error("The parameter 'copyFromScope' cannot be null.");
        else if (copyFromScope !== undefined)
            url_ += "copyFromScope=" + encodeURIComponent("" + copyFromScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilterCounts(_response);
        });
    }

    protected processGetAllGenericFilterCounts(response: Response): Promise<ProjectChangeRequestCountsResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectChangeRequestCountsResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectChangeRequestCountsResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param copyFromScope (optional) 
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, reportId: number, copyFromScope: boolean | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectChangeRequest/{tenantId}/{reportId}/export?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (copyFromScope === null)
            throw new Error("The parameter 'copyFromScope' cannot be null.");
        else if (copyFromScope !== undefined)
            url_ += "copyFromScope=" + encodeURIComponent("" + copyFromScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, reportId: number, id: number): Promise<ProjectChangeRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectChangeRequest/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectChangeRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectChangeRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectChangeRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, reportId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectChangeRequest/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    copyFromScope(tenantId: number, reportId: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectChangeRequest/copyFromScope/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCopyFromScope(_response);
        });
    }

    protected processCopyFromScope(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class ProjectConfigClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getProjectCategories(tenantId: number): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectConfig/category/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProjectCategories(_response);
        });
    }

    protected processGetProjectCategories(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProjectCategories(tenantId: number, body: TenantIsActiveDeltaRequest | undefined): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectConfig/category/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProjectCategories(_response);
        });
    }

    protected processUpdateProjectCategories(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getProjectTypes(tenantId: number): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectConfig/type/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProjectTypes(_response);
        });
    }

    protected processGetProjectTypes(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProjectTypes(tenantId: number, body: TenantIsActiveDeltaRequest | undefined): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectConfig/type/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProjectTypes(_response);
        });
    }

    protected processUpdateProjectTypes(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }
}

export class ProjectDashboardClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    get(tenantId: number, body: ProjectDashboardFilterRequest | undefined): Promise<ProjectDashboardResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectDashboard/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectDashboardResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDashboardResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDashboardResponseSimpleResponseModel>(null as any);
    }
}

export class ProjectDeliverableClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param isGenerated (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, reportId: number, isGenerated: boolean | undefined, offset: number | undefined, limit: number | undefined): Promise<ProjectDeliverableResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectDeliverable/{tenantId}/{reportId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (isGenerated === null)
            throw new Error("The parameter 'isGenerated' cannot be null.");
        else if (isGenerated !== undefined)
            url_ += "IsGenerated=" + encodeURIComponent("" + isGenerated) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectDeliverableResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDeliverableResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDeliverableResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, reportId: number, body: InsertProjectDeliverableRequest | undefined): Promise<ProjectDeliverableResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectDeliverable/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ProjectDeliverableResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDeliverableResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDeliverableResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, reportId: number, body: UpdateProjectDeliverableRequest | undefined): Promise<ProjectDeliverableResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectDeliverable/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectDeliverableResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDeliverableResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDeliverableResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param copyFromSchedule (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, reportId: number, copyFromSchedule: boolean | undefined, body: GenericFilterModelCollection | undefined): Promise<ProjectDeliverableResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectDeliverable/{tenantId}/{reportId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (copyFromSchedule === null)
            throw new Error("The parameter 'copyFromSchedule' cannot be null.");
        else if (copyFromSchedule !== undefined)
            url_ += "copyFromSchedule=" + encodeURIComponent("" + copyFromSchedule) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<ProjectDeliverableResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDeliverableResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDeliverableResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, reportId: number, id: number): Promise<ProjectDeliverableResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectDeliverable/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectDeliverableResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectDeliverableResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDeliverableResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, reportId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectDeliverable/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    copyFromSchedule(tenantId: number, reportId: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectDeliverable/copyFromSchedule/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCopyFromSchedule(_response);
        });
    }

    protected processCopyFromSchedule(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param copyFromSchedule (optional) 
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, reportId: number, copyFromSchedule: boolean | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectDeliverable/{tenantId}/{reportId}/export?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (copyFromSchedule === null)
            throw new Error("The parameter 'copyFromSchedule' cannot be null.");
        else if (copyFromSchedule !== undefined)
            url_ += "copyFromSchedule=" + encodeURIComponent("" + copyFromSchedule) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProjectFinanceClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param statusId (optional) 
     * @param isGenerated (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, reportId: number, statusId: number | undefined, isGenerated: boolean | undefined, offset: number | undefined, limit: number | undefined): Promise<ProjectFinanceResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectFinance/{tenantId}/{reportId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (isGenerated === null)
            throw new Error("The parameter 'isGenerated' cannot be null.");
        else if (isGenerated !== undefined)
            url_ += "IsGenerated=" + encodeURIComponent("" + isGenerated) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectFinanceResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectFinanceResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFinanceResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, reportId: number, body: InsertProjectFinanceRequest | undefined): Promise<ProjectFinanceResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectFinance/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ProjectFinanceResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectFinanceResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFinanceResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, reportId: number, body: UpdateProjectFinanceRequest | undefined): Promise<ProjectFinanceResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectFinance/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectFinanceResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectFinanceResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFinanceResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param copyFromFinance (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, reportId: number, copyFromFinance: boolean | undefined, body: GenericFilterModelCollection | undefined): Promise<ProjectFinanceResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectFinance/{tenantId}/{reportId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (copyFromFinance === null)
            throw new Error("The parameter 'copyFromFinance' cannot be null.");
        else if (copyFromFinance !== undefined)
            url_ += "copyFromFinance=" + encodeURIComponent("" + copyFromFinance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<ProjectFinanceResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectFinanceResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFinanceResponseItemsResponseModel>(null as any);
    }

    /**
     * @param copyFromFinance (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilterCounts(tenantId: number, reportId: number, copyFromFinance: boolean | undefined, body: GenericFilterModelCollection | undefined): Promise<ProjectFinanceCountsResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectFinance/{tenantId}/{reportId}/genericFilterCounts?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (copyFromFinance === null)
            throw new Error("The parameter 'copyFromFinance' cannot be null.");
        else if (copyFromFinance !== undefined)
            url_ += "copyFromFinance=" + encodeURIComponent("" + copyFromFinance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilterCounts(_response);
        });
    }

    protected processGetAllGenericFilterCounts(response: Response): Promise<ProjectFinanceCountsResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectFinanceCountsResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFinanceCountsResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, reportId: number, id: number): Promise<ProjectFinanceResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectFinance/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectFinanceResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectFinanceResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectFinanceResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, reportId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectFinance/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    copyFromFinance(tenantId: number, reportId: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectFinance/copyFromFinance/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCopyFromFinance(_response);
        });
    }

    protected processCopyFromFinance(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param copyFromFinance (optional) 
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, reportId: number, copyFromFinance: boolean | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectFinance/{tenantId}/{reportId}/export?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (copyFromFinance === null)
            throw new Error("The parameter 'copyFromFinance' cannot be null.");
        else if (copyFromFinance !== undefined)
            url_ += "copyFromFinance=" + encodeURIComponent("" + copyFromFinance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProjectIssueClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param isActive (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, reportId: number, isActive: boolean | undefined, offset: number | undefined, limit: number | undefined): Promise<ProjectIssueResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectIssue/{tenantId}/{reportId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectIssueResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectIssueResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectIssueResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, reportId: number, body: InsertProjectIssueRequest | undefined): Promise<ProjectIssueResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectIssue/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ProjectIssueResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectIssueResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectIssueResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, reportId: number, body: UpdateProjectIssueRequest | undefined): Promise<ProjectIssueResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectIssue/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectIssueResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectIssueResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectIssueResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, reportId: number, body: GenericFilterModelCollection | undefined): Promise<ProjectIssueResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectIssue/{tenantId}/{reportId}/genericFilter";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<ProjectIssueResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectIssueResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectIssueResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, reportId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectIssue/{tenantId}/{reportId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, reportId: number, id: number): Promise<ProjectIssueResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectIssue/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectIssueResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectIssueResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectIssueResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, reportId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectIssue/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class ProjectMilestoneClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param isGenerated (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, reportId: number, isGenerated: boolean | undefined, offset: number | undefined, limit: number | undefined): Promise<ProjectMilestoneResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectMilestone/{tenantId}/{reportId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (isGenerated === null)
            throw new Error("The parameter 'isGenerated' cannot be null.");
        else if (isGenerated !== undefined)
            url_ += "IsGenerated=" + encodeURIComponent("" + isGenerated) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectMilestoneResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectMilestoneResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectMilestoneResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, reportId: number, body: InsertProjectMilestoneRequest | undefined): Promise<ProjectMilestoneResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectMilestone/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ProjectMilestoneResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectMilestoneResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectMilestoneResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, reportId: number, body: UpdateProjectMilestoneRequest | undefined): Promise<ProjectMilestoneResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectMilestone/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectMilestoneResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectMilestoneResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectMilestoneResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param copyFromSchedule (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, reportId: number, copyFromSchedule: boolean | undefined, body: GenericFilterModelCollection | undefined): Promise<ProjectMilestoneResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectMilestone/{tenantId}/{reportId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (copyFromSchedule === null)
            throw new Error("The parameter 'copyFromSchedule' cannot be null.");
        else if (copyFromSchedule !== undefined)
            url_ += "copyFromSchedule=" + encodeURIComponent("" + copyFromSchedule) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<ProjectMilestoneResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectMilestoneResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectMilestoneResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, reportId: number, id: number): Promise<ProjectMilestoneResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectMilestone/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectMilestoneResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectMilestoneResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectMilestoneResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, reportId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectMilestone/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGenerated(tenantId: number, reportId: number, body: UpdateGeneratedProjectMilestoneRequest | undefined): Promise<ProjectMilestoneResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectMilestone/{tenantId}/{reportId}/generated";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGenerated(_response);
        });
    }

    protected processUpdateGenerated(response: Response): Promise<ProjectMilestoneResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectMilestoneResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectMilestoneResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    copyFromSchedule(tenantId: number, reportId: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectMilestone/copyFromSchedule/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCopyFromSchedule(_response);
        });
    }

    protected processCopyFromSchedule(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param copyFromSchedule (optional) 
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, reportId: number, copyFromSchedule: boolean | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectMilestone/{tenantId}/{reportId}/export?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (copyFromSchedule === null)
            throw new Error("The parameter 'copyFromSchedule' cannot be null.");
        else if (copyFromSchedule !== undefined)
            url_ += "copyFromSchedule=" + encodeURIComponent("" + copyFromSchedule) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProjectOrganizationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAllByProjectId(tenantId: number, projectId: number): Promise<ProjectIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectOrganization/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllByProjectId(_response);
        });
    }

    protected processGetAllByProjectId(response: Response): Promise<ProjectIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: TenantIsActiveDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectOrganization/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class ProjectQualityClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param status (optional) 
     * @param isGenerated (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, reportId: number, status: ReportItemStatusEnum | undefined, isGenerated: boolean | undefined, offset: number | undefined, limit: number | undefined): Promise<ProjectQualityResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectQuality/{tenantId}/{reportId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (isGenerated === null)
            throw new Error("The parameter 'isGenerated' cannot be null.");
        else if (isGenerated !== undefined)
            url_ += "IsGenerated=" + encodeURIComponent("" + isGenerated) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectQualityResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectQualityResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectQualityResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, reportId: number, body: InsertProjectQualityRequest | undefined): Promise<ProjectQualityResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectQuality/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ProjectQualityResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectQualityResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectQualityResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, reportId: number, body: UpdateProjectQualityRequest | undefined): Promise<ProjectQualityResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectQuality/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectQualityResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectQualityResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectQualityResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param copyFromSchedule (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, reportId: number, copyFromSchedule: boolean | undefined, body: GenericFilterModelCollection | undefined): Promise<ProjectQualityResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectQuality/{tenantId}/{reportId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (copyFromSchedule === null)
            throw new Error("The parameter 'copyFromSchedule' cannot be null.");
        else if (copyFromSchedule !== undefined)
            url_ += "copyFromSchedule=" + encodeURIComponent("" + copyFromSchedule) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<ProjectQualityResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectQualityResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectQualityResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, reportId: number, id: number): Promise<ProjectQualityResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectQuality/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectQualityResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectQualityResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectQualityResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, reportId: number, id: number): Promise<ProjectQualityResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectQuality/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<ProjectQualityResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectQualityResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectQualityResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGenerated(tenantId: number, reportId: number, body: UpdateGeneratedProjectQualityRequest | undefined): Promise<ProjectQualityResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectQuality/{tenantId}/{reportId}/generated";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGenerated(_response);
        });
    }

    protected processUpdateGenerated(response: Response): Promise<ProjectQualityResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectQualityResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectQualityResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    copyFromSchedule(tenantId: number, reportId: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectQuality/copyFromSchedule/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCopyFromSchedule(_response);
        });
    }

    protected processCopyFromSchedule(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param copyFromSchedule (optional) 
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, reportId: number, copyFromSchedule: boolean | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectQuality/{tenantId}/{reportId}/export?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (copyFromSchedule === null)
            throw new Error("The parameter 'copyFromSchedule' cannot be null.");
        else if (copyFromSchedule !== undefined)
            url_ += "copyFromSchedule=" + encodeURIComponent("" + copyFromSchedule) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProjectReportClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param statusId (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, projectId: number, statusId: number | undefined, offset: number | undefined, limit: number | undefined): Promise<ProjectReportResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectReport/{tenantId}/{projectId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectReportResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectReportResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectReportResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, projectId: number, body: InsertProjectReportRequest | undefined): Promise<ProjectReportResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectReport/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ProjectReportResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectReportResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectReportResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: UpdateProjectReportRequest | undefined): Promise<ProjectReportResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectReport/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectReportResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectReportResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectReportResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, projectId: number, body: GenericFilterModelCollection | undefined): Promise<ProjectReportResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectReport/{tenantId}/{projectId}/genericFilter";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<ProjectReportResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectReportResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectReportResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number, id: number): Promise<ProjectReportResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectReport/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectReportResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectReportResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectReportResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, projectId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectReport/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    releas(tenantId: number, projectId: number, body: GetProjectReportRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectReport/releas/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReleas(_response);
        });
    }

    protected processReleas(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    clone(tenantId: number, projectId: number, id: number): Promise<ProjectReportResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectReport/clone/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClone(_response);
        });
    }

    protected processClone(response: Response): Promise<ProjectReportResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectReportResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectReportResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, projectId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectReport/exportAll/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, projectId: number, id: number, body: ExportProjectReportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectReport/export/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProjectRiskClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param statusId (optional) 
     * @param isGenerated (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, reportId: number, statusId: number | undefined, isGenerated: boolean | undefined, offset: number | undefined, limit: number | undefined): Promise<ProjectRiskResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectRisk/{tenantId}/{reportId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "StatusId=" + encodeURIComponent("" + statusId) + "&";
        if (isGenerated === null)
            throw new Error("The parameter 'isGenerated' cannot be null.");
        else if (isGenerated !== undefined)
            url_ += "IsGenerated=" + encodeURIComponent("" + isGenerated) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectRiskResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectRiskResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectRiskResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, reportId: number, body: InsertProjectRiskRequest | undefined): Promise<ProjectRiskResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectRisk/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ProjectRiskResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectRiskResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectRiskResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, reportId: number, body: UpdateProjectRiskRequest | undefined): Promise<ProjectRiskResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectRisk/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectRiskResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectRiskResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectRiskResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param copyFromRisk (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, reportId: number, copyFromRisk: boolean | undefined, body: GenericFilterModelCollection | undefined): Promise<ProjectRiskResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectRisk/{tenantId}/{reportId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (copyFromRisk === null)
            throw new Error("The parameter 'copyFromRisk' cannot be null.");
        else if (copyFromRisk !== undefined)
            url_ += "copyFromRisk=" + encodeURIComponent("" + copyFromRisk) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<ProjectRiskResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectRiskResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectRiskResponseItemsResponseModel>(null as any);
    }

    /**
     * @param copyFromRisk (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilterCounts(tenantId: number, reportId: number, copyFromRisk: boolean | undefined, body: GenericFilterModelCollection | undefined): Promise<ProjectRiskCountsResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectRisk/{tenantId}/{reportId}/genericFilterCounts?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (copyFromRisk === null)
            throw new Error("The parameter 'copyFromRisk' cannot be null.");
        else if (copyFromRisk !== undefined)
            url_ += "copyFromRisk=" + encodeURIComponent("" + copyFromRisk) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilterCounts(_response);
        });
    }

    protected processGetAllGenericFilterCounts(response: Response): Promise<ProjectRiskCountsResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectRiskCountsResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectRiskCountsResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, reportId: number, id: number): Promise<ProjectRiskResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectRisk/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectRiskResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectRiskResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectRiskResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, reportId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectRisk/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    copyFromRisk(tenantId: number, reportId: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectRisk/copyFromRisk/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCopyFromRisk(_response);
        });
    }

    protected processCopyFromRisk(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param copyFromRisk (optional) 
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, reportId: number, copyFromRisk: boolean | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectRisk/{tenantId}/{reportId}/export?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (copyFromRisk === null)
            throw new Error("The parameter 'copyFromRisk' cannot be null.");
        else if (copyFromRisk !== undefined)
            url_ += "copyFromRisk=" + encodeURIComponent("" + copyFromRisk) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProjectRoleClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAllByProjectId(tenantId: number, projectId: number): Promise<ProjectIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectRole/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllByProjectId(_response);
        });
    }

    protected processGetAllByProjectId(response: Response): Promise<ProjectIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: TenantIsActiveDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectRole/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<ProjectIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectRole/getAll/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectIsActiveResponseItemsResponseModel>(null as any);
    }
}

export class ProjectSLAClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number): Promise<ProjectSLAResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectSLA/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectSLAResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectSLAResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSLAResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: UpdateProjectSLARequest | undefined): Promise<ProjectSLAResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectSLA/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectSLAResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectSLAResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSLAResponseSimpleResponseModel>(null as any);
    }
}

export class ProjectStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<ProjectStatusResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectStatusResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectStatusResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectStatusResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: SimpleStatusRequestUpdateSimpleStatusRequestItems | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class ProjectSubcontractorClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param isActive (optional) 
     * @param status (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, reportId: number, isActive: boolean | undefined, status: ReportItemStatusEnum | undefined, offset: number | undefined, limit: number | undefined): Promise<ProjectSubcontractorResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/{tenantId}/{reportId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectSubcontractorResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectSubcontractorResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSubcontractorResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, reportId: number, body: InsertProjectSubcontractorRequest | undefined): Promise<ProjectSubcontractorResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ProjectSubcontractorResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectSubcontractorResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSubcontractorResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, reportId: number, body: UpdateProjectSubcontractorRequest | undefined): Promise<ProjectSubcontractorResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/{tenantId}/{reportId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectSubcontractorResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectSubcontractorResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSubcontractorResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, reportId: number, body: GenericFilterModelCollection | undefined): Promise<ProjectSubcontractorResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/{tenantId}/{reportId}/genericFilter";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<ProjectSubcontractorResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectSubcontractorResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSubcontractorResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, reportId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/{tenantId}/{reportId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, reportId: number, id: number): Promise<ProjectSubcontractorResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectSubcontractorResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectSubcontractorResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSubcontractorResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, reportId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectSubcontractor/{tenantId}/{reportId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined.");
        url_ = url_.replace("{reportId}", encodeURIComponent("" + reportId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class ProjectTeamClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAllByProjectId(tenantId: number, projectId: number): Promise<ProjectTeamResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectTeam/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllByProjectId(_response);
        });
    }

    protected processGetAllByProjectId(response: Response): Promise<ProjectTeamResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectTeamResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectTeamResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: ProjectTeamDeltaRequest | undefined): Promise<ProjectTeamResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectTeam/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectTeamResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectTeamResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectTeamResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<ProjectTeamResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectTeam/getAll/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectTeamResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectTeamResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectTeamResponseItemsResponseModel>(null as any);
    }
}

export class ProjectTeamMemberClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number, id: number): Promise<ProjectTeamMemberResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectTeamMember/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectTeamMemberResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectTeamMemberResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectTeamMemberResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, projectId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectTeamMember/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param roleType (optional) 
     * @param isActive (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, projectId: number, roleType: TokenTypeEnum | undefined, isActive: boolean | undefined, offset: number | undefined, limit: number | undefined): Promise<ProjectTeamMemberResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectTeamMember/{tenantId}/{projectId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (roleType === null)
            throw new Error("The parameter 'roleType' cannot be null.");
        else if (roleType !== undefined)
            url_ += "RoleType=" + encodeURIComponent("" + roleType) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectTeamMemberResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectTeamMemberResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectTeamMemberResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(tenantId: number, projectId: number, body: InsertProjectTeamMemberRequest | undefined): Promise<ProjectTeamMemberResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectTeamMember/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<ProjectTeamMemberResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectTeamMemberResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectTeamMemberResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: UpdateProjectTeamMemberRequest | undefined): Promise<ProjectTeamMemberResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectTeamMember/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ProjectTeamMemberResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectTeamMemberResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectTeamMemberResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAllTeamMemberUsers(tenantId: number, projectId: number): Promise<ProjectTeamMemberUserResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectTeamMember/users/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllTeamMemberUsers(_response);
        });
    }

    protected processGetAllTeamMemberUsers(response: Response): Promise<ProjectTeamMemberUserResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectTeamMemberUserResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectTeamMemberUserResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllByProjectGenericFiltering(tenantId: number, projectId: number, body: GenericFilterModelCollection | undefined): Promise<ProjectTeamMemberResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectTeamMember/genericFilter/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllByProjectGenericFiltering(_response);
        });
    }

    protected processGetAllByProjectGenericFiltering(response: Response): Promise<ProjectTeamMemberResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectTeamMemberResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectTeamMemberResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFiltering(tenantId: number, body: GenericFilterModelCollection | undefined): Promise<ProjectTeamMemberResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectTeamMember/genericFilter/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFiltering(_response);
        });
    }

    protected processGetAllGenericFiltering(response: Response): Promise<ProjectTeamMemberResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectTeamMemberResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectTeamMemberResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, projectId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectTeamMember/{tenantId}/{projectId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ProjectTeamMember/{tenantId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProjectTeamMemberPermissionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number, projectId: number): Promise<PermissionCollectionResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectTeamMemberPermission/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<PermissionCollectionResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionCollectionResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PermissionCollectionResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: PermissionCollectionRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectTeamMemberPermission/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class ProjectTeamMemberValidityPeriodClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number, projectId: number): Promise<ProjectTeamMemberValidityPeriodResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectTeamMemberValidityPeriod/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectTeamMemberValidityPeriodResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectTeamMemberValidityPeriodResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectTeamMemberValidityPeriodResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: ProjectTeamMemberValidityPeriodDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ProjectTeamMemberValidityPeriod/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class RegisterClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerTenant(body: TenantRegistrationRequestModel | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterTenant(_response);
        });
    }

    protected processRegisterTenant(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class RegistrationConfirmClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerConfirm(body: TenantRegistrationConfirmRequestModel | undefined): Promise<TenantRegistrationConfirmStatusResponseModel> {
        let url_ = this.baseUrl + "/api/RegistrationConfirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterConfirm(_response);
        });
    }

    protected processRegisterConfirm(response: Response): Promise<TenantRegistrationConfirmStatusResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantRegistrationConfirmStatusResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = BaseResponseModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantRegistrationConfirmStatusResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    registerConfirmStatus(tenantId: number, userId: number): Promise<TenantRegistrationConfirmStatusResponseModel> {
        let url_ = this.baseUrl + "/api/RegistrationConfirm/{tenantId}/{userId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterConfirmStatus(_response);
        });
    }

    protected processRegisterConfirmStatus(response: Response): Promise<TenantRegistrationConfirmStatusResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantRegistrationConfirmStatusResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = BaseResponseModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantRegistrationConfirmStatusResponseModel>(null as any);
    }
}

export class ReminderClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined, body: GenericFilterModelCollection | undefined): Promise<ReminderResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Reminder/{tenantId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<ReminderResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReminderResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReminderResponseItemsResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    get(tenantId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<ReminderResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Reminder/{tenantId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ReminderResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReminderResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReminderResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    delete(tenantId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Reminder/{tenantId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, body: InsertReminderRequest | undefined): Promise<ReminderResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Reminder/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ReminderResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReminderResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReminderResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: UpdateReminderRequest | undefined): Promise<ReminderResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Reminder/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ReminderResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReminderResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReminderResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Reminder/{tenantId}/exportAll?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ReportStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<ReportStatusResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ReportStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ReportStatusResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportStatusResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportStatusResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: SimpleStatusRequestUpdateSimpleStatusRequestItems | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ReportStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class RiskClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getSimple(tenantId: number, id: number): Promise<IdNameResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Risk/simple/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimple(_response);
        });
    }

    protected processGetSimple(response: Response): Promise<IdNameResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    getSimpleByIds(tenantId: number, ids: number[] | undefined): Promise<IdNameResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Risk/simpleByIds/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimpleByIds(_response);
        });
    }

    protected processGetSimpleByIds(response: Response): Promise<IdNameResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number, projectId: number): Promise<RiskResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Risk/{tenantId}/{projectId}/all";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<RiskResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiskResponseItemsResponseModel>(null as any);
    }

    /**
     * @param idFormatPrefix (optional) 
     * @param searchValue (optional) 
     * @param body (optional) 
     * @return Success
     */
    search(tenantId: number, idFormatPrefix: string | undefined, searchValue: string | undefined, body: GenericFilterModelCollection | undefined): Promise<IdNameResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Risk/search/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (idFormatPrefix === null)
            throw new Error("The parameter 'idFormatPrefix' cannot be null.");
        else if (idFormatPrefix !== undefined)
            url_ += "idFormatPrefix=" + encodeURIComponent("" + idFormatPrefix) + "&";
        if (searchValue === null)
            throw new Error("The parameter 'searchValue' cannot be null.");
        else if (searchValue !== undefined)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<IdNameResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, projectId: number, body: GenericFilterModelCollection | undefined): Promise<RiskResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Risk/{tenantId}/{projectId}/genericFilter";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<RiskResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiskResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilterCounts(tenantId: number, projectId: number, body: GenericFilterModelCollection | undefined): Promise<RiskCountsResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Risk/{tenantId}/{projectId}/genericFilterCounts";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilterCounts(_response);
        });
    }

    protected processGetAllGenericFilterCounts(response: Response): Promise<RiskCountsResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskCountsResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiskCountsResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number, id: number): Promise<RiskResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Risk/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<RiskResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiskResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, projectId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Risk/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, projectId: number, body: InsertRiskRequest | undefined): Promise<RiskResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Risk/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<RiskResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiskResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: UpdateRiskRequest | undefined): Promise<RiskResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Risk/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<RiskResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiskResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, projectId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Risk/{tenantId}/{projectId}/exportAll";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class RiskConfigClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getRiskTypes(tenantId: number): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/RiskConfig/type/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRiskTypes(_response);
        });
    }

    protected processGetRiskTypes(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRiskTypes(tenantId: number, body: TenantIsActiveDeltaRequest | undefined): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/RiskConfig/type/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateRiskTypes(_response);
        });
    }

    protected processUpdateRiskTypes(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }
}

export class RiskDashboardClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    get(tenantId: number, body: RiskDashboardFilterRequest | undefined): Promise<RiskDashboardResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/RiskDashboard/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<RiskDashboardResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskDashboardResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiskDashboardResponseSimpleResponseModel>(null as any);
    }
}

export class RiskStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<RiskStatusResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/RiskStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<RiskStatusResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskStatusResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RiskStatusResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: StatusDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/RiskStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class ScheduleClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getSimple(tenantId: number, id: number): Promise<IdNameProjectResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Schedule/simple/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimple(_response);
        });
    }

    protected processGetSimple(response: Response): Promise<IdNameProjectResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameProjectResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameProjectResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    getSimpleByIds(tenantId: number, ids: number[] | undefined): Promise<IdNameProjectResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Schedule/simpleByIds/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimpleByIds(_response);
        });
    }

    protected processGetSimpleByIds(response: Response): Promise<IdNameProjectResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameProjectResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameProjectResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number, projectId: number): Promise<ScheduleResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Schedule/{tenantId}/{projectId}/all";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ScheduleResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleResponseItemsResponseModel>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param parentId (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAllSimple(tenantId: number, projectId: number | undefined, parentId: number | undefined, offset: number | undefined, limit: number | undefined): Promise<SimpleScheduleResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Schedule/{tenantId}/allSimple?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSimple(_response);
        });
    }

    protected processGetAllSimple(response: Response): Promise<SimpleScheduleResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleScheduleResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimpleScheduleResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number, id: number): Promise<ScheduleResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Schedule/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ScheduleResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, projectId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Schedule/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param idFormatPrefix (optional) 
     * @param searchValue (optional) 
     * @param body (optional) 
     * @return Success
     */
    search(tenantId: number, idFormatPrefix: string | undefined, searchValue: string | undefined, body: GenericFilterModelCollection | undefined): Promise<IdNameProjectResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Schedule/search/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (idFormatPrefix === null)
            throw new Error("The parameter 'idFormatPrefix' cannot be null.");
        else if (idFormatPrefix !== undefined)
            url_ += "idFormatPrefix=" + encodeURIComponent("" + idFormatPrefix) + "&";
        if (searchValue === null)
            throw new Error("The parameter 'searchValue' cannot be null.");
        else if (searchValue !== undefined)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<IdNameProjectResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameProjectResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameProjectResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, projectId: number, body: InsertScheduleRequest | undefined): Promise<ScheduleResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Schedule/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ScheduleResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: UpdateScheduleRequest | undefined): Promise<ScheduleResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Schedule/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ScheduleResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    patch(tenantId: number, projectId: number, body: PatchScheduleRequest | undefined): Promise<ScheduleResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Schedule/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<ScheduleResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bulkPatch(tenantId: number, projectId: number, body: PatchScheduleRequest[] | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Schedule/bulkPatch/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkPatch(_response);
        });
    }

    protected processBulkPatch(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWbs(tenantId: number, projectId: number, body: UpdateWbsRequest[] | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Schedule/wbs/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateWbs(_response);
        });
    }

    protected processUpdateWbs(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateResourcePlans(tenantId: number, projectId: number, body: UpdateScheduleResourcePlansRequest | undefined): Promise<ScheduleResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Schedule/resourcePlans/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateResourcePlans(_response);
        });
    }

    protected processUpdateResourcePlans(response: Response): Promise<ScheduleResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clone(tenantId: number, projectId: number, body: CopyFromProjectRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Schedule/clone/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClone(_response);
        });
    }

    protected processClone(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, projectId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Schedule/exportAll/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ScheduleConfigurationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number): Promise<ScheduleConfigurationResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ScheduleConfiguration/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ScheduleConfigurationResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleConfigurationResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleConfigurationResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: ScheduleConfigurationRequest | undefined): Promise<ScheduleConfigurationResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ScheduleConfiguration/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ScheduleConfigurationResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleConfigurationResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleConfigurationResponseSimpleResponseModel>(null as any);
    }
}

export class ScheduleDashboardClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    get(tenantId: number, body: ScheduleDashboardFilterRequest | undefined): Promise<ScheduleDashboardResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ScheduleDashboard/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ScheduleDashboardResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleDashboardResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleDashboardResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getGantt(tenantId: number, body: ScheduleGanttDashboardFilterRequest | undefined): Promise<ScheduleGanttDashboardResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ScheduleDashboard/gantt/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGantt(_response);
        });
    }

    protected processGetGantt(response: Response): Promise<ScheduleGanttDashboardResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleGanttDashboardResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleGanttDashboardResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUtilization(tenantId: number, body: ScheduleUtilizationDashboardFilterRequest | undefined): Promise<ScheduleUtilizationRowDashboardResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ScheduleDashboard/utilization/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUtilization(_response);
        });
    }

    protected processGetUtilization(response: Response): Promise<ScheduleUtilizationRowDashboardResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleUtilizationRowDashboardResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleUtilizationRowDashboardResponseItemsResponseModel>(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportUserReport(tenantId: number, projectId: number, from: Date | undefined, to: Date | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduleDashboard/exportUserReport/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + formatDate(from) : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + formatDate(to) : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportUserReport(_response);
        });
    }

    protected processExportUserReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportProjectTeamReport(tenantId: number, projectId: number, from: Date | undefined, to: Date | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ScheduleDashboard/exportProjectTeamReport/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + formatDate(from) : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + formatDate(to) : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportProjectTeamReport(_response);
        });
    }

    protected processExportProjectTeamReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SchedulePredecessorClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number, projectId: number): Promise<SchedulePredecessorResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/SchedulePredecessor/{tenantId}/{projectId}/all";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<SchedulePredecessorResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SchedulePredecessorResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SchedulePredecessorResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number, id: number): Promise<SchedulePredecessorResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/SchedulePredecessor/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SchedulePredecessorResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SchedulePredecessorResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SchedulePredecessorResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, projectId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/SchedulePredecessor/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, projectId: number, body: InsertSchedulePredecessorRequest | undefined): Promise<SchedulePredecessorResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/SchedulePredecessor/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<SchedulePredecessorResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SchedulePredecessorResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SchedulePredecessorResponseSimpleResponseModel>(null as any);
    }
}

export class ScopeDashboardClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getForProcesses(tenantId: number, projectId: number, body: ScopeProcessesDashboardFilterRequest | undefined): Promise<ScopeProcessesDashboardResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeDashboard/getForProcesses/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForProcesses(_response);
        });
    }

    protected processGetForProcesses(response: Response): Promise<ScopeProcessesDashboardResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeProcessesDashboardResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScopeProcessesDashboardResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getForChangeRequests(tenantId: number, projectId: number, body: ScopeChangeRequestsDashboardFilterRequest | undefined): Promise<ScopeChangeRequestsDashboardResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeDashboard/getForChangeRequests/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForChangeRequests(_response);
        });
    }

    protected processGetForChangeRequests(response: Response): Promise<ScopeChangeRequestsDashboardResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeChangeRequestsDashboardResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScopeChangeRequestsDashboardResponseSimpleResponseModel>(null as any);
    }
}

export class ScopeDepartmentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number, projectId: number): Promise<ProjectIsActiveOrderResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeDepartment/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectIsActiveOrderResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectIsActiveOrderResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectIsActiveOrderResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: TenantIsActiveOrderDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeDepartment/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, body: ExportProjectsDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ScopeDepartment/{tenantId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ScopeItemLevelClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getSimple(tenantId: number, id: number): Promise<IdNameProjectResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/simple/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimple(_response);
        });
    }

    protected processGetSimple(response: Response): Promise<IdNameProjectResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameProjectResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameProjectResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    getSimpleByIds(tenantId: number, ids: number[] | undefined): Promise<IdNameProjectResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/simpleByIds/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimpleByIds(_response);
        });
    }

    protected processGetSimpleByIds(response: Response): Promise<IdNameProjectResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameProjectResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameProjectResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number, id: number): Promise<ScopeItemLevelResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ScopeItemLevelResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeItemLevelResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScopeItemLevelResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, projectId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param searchValue (optional) 
     * @param body (optional) 
     * @return Success
     */
    search(tenantId: number, searchValue: string | undefined, body: GenericFilterModelCollection | undefined): Promise<IdNameProjectResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/search/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (searchValue === null)
            throw new Error("The parameter 'searchValue' cannot be null.");
        else if (searchValue !== undefined)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<IdNameProjectResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameProjectResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameProjectResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getSimpleLevel3FullName(tenantId: number, id: number): Promise<IdNameProjectResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/simpleLevel3/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimpleLevel3FullName(_response);
        });
    }

    protected processGetSimpleLevel3FullName(response: Response): Promise<IdNameProjectResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameProjectResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameProjectResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    getSimpleLevel3FullNameByIds(tenantId: number, ids: number[] | undefined): Promise<IdNameProjectResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/simpleLevel3ByIds/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimpleLevel3FullNameByIds(_response);
        });
    }

    protected processGetSimpleLevel3FullNameByIds(response: Response): Promise<IdNameProjectResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameProjectResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameProjectResponseItemsResponseModel>(null as any);
    }

    /**
     * @param searchValue (optional) 
     * @param body (optional) 
     * @return Success
     */
    searchLevel3FullName(tenantId: number, searchValue: string | undefined, body: GenericFilterModelCollection | undefined): Promise<IdNameProjectResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/searchLevel3/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (searchValue === null)
            throw new Error("The parameter 'searchValue' cannot be null.");
        else if (searchValue !== undefined)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchLevel3FullName(_response);
        });
    }

    protected processSearchLevel3FullName(response: Response): Promise<IdNameProjectResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameProjectResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameProjectResponseItemsResponseModel>(null as any);
    }

    /**
     * @param parentId (optional) 
     * @param levelNumber (optional) 
     * @param includeChildren (optional) 
     * @return Success
     */
    getAll(tenantId: number, projectId: number, parentId: number | undefined, levelNumber: number | undefined, includeChildren: boolean | undefined): Promise<ScopeItemLevelResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/{tenantId}/{projectId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&";
        if (levelNumber === null)
            throw new Error("The parameter 'levelNumber' cannot be null.");
        else if (levelNumber !== undefined)
            url_ += "LevelNumber=" + encodeURIComponent("" + levelNumber) + "&";
        if (includeChildren === null)
            throw new Error("The parameter 'includeChildren' cannot be null.");
        else if (includeChildren !== undefined)
            url_ += "IncludeChildren=" + encodeURIComponent("" + includeChildren) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ScopeItemLevelResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeItemLevelResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScopeItemLevelResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, projectId: number, body: InsertScopeItemLevelRequest | undefined): Promise<ScopeItemLevelResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ScopeItemLevelResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeItemLevelResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScopeItemLevelResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: UpdateScopeItemLevelRequest | undefined): Promise<ScopeItemLevelResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ScopeItemLevelResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeItemLevelResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScopeItemLevelResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFiltering(tenantId: number, body: GenericFilterModelCollection | undefined): Promise<ScopeItemLevelResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/genericFilter/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFiltering(_response);
        });
    }

    protected processGetAllGenericFiltering(response: Response): Promise<ScopeItemLevelResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeItemLevelResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScopeItemLevelResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrders(tenantId: number, projectId: number, body: UpdateOrderRequest[] | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/orders/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateOrders(_response);
        });
    }

    protected processUpdateOrders(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAllReport(tenantId: number, projectId: number): Promise<ScopeItemLevelReportResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/{tenantId}/{projectId}/report";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllReport(_response);
        });
    }

    protected processGetAllReport(response: Response): Promise<ScopeItemLevelReportResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeItemLevelReportResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScopeItemLevelReportResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clone(tenantId: number, projectId: number, body: CopyFromProjectRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/clone/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClone(_response);
        });
    }

    protected processClone(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getDiagram(tenantId: number, projectId: number, id: number): Promise<StringSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/diagram/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDiagram(_response);
        });
    }

    protected processGetDiagram(response: Response): Promise<StringSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDiagram(tenantId: number, projectId: number, id: number, body: string | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/diagram/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDiagram(_response);
        });
    }

    protected processUpdateDiagram(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, projectId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/{tenantId}/{projectId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    downloadDesignAttachment(tenantId: number, projectId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/designAttachment/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadDesignAttachment(_response);
        });
    }

    protected processDownloadDesignAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    removeDesignAttachment(tenantId: number, projectId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/designAttachment/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveDesignAttachment(_response);
        });
    }

    protected processRemoveDesignAttachment(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    downloadTrainingAttachment(tenantId: number, projectId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/trainingAttachment/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadTrainingAttachment(_response);
        });
    }

    protected processDownloadTrainingAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    removeTrainingAttachment(tenantId: number, projectId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/trainingAttachment/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveTrainingAttachment(_response);
        });
    }

    protected processRemoveTrainingAttachment(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    downloadOtherAttachment(tenantId: number, projectId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/otherAttachment/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadOtherAttachment(_response);
        });
    }

    protected processDownloadOtherAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    removeOtherAttachment(tenantId: number, projectId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/otherAttachment/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveOtherAttachment(_response);
        });
    }

    protected processRemoveOtherAttachment(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllDesignAttachmentsGenericFiltering(tenantId: number, projectId: number, body: GenericFilterModelCollection | undefined): Promise<ScopeLevelAttachmentResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/designAttachment/genericFilter/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllDesignAttachmentsGenericFiltering(_response);
        });
    }

    protected processGetAllDesignAttachmentsGenericFiltering(response: Response): Promise<ScopeLevelAttachmentResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeLevelAttachmentResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScopeLevelAttachmentResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllTrainingAttachmentsGenericFiltering(tenantId: number, projectId: number, body: GenericFilterModelCollection | undefined): Promise<ScopeLevelAttachmentResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/trainingAttachment/genericFilter/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllTrainingAttachmentsGenericFiltering(_response);
        });
    }

    protected processGetAllTrainingAttachmentsGenericFiltering(response: Response): Promise<ScopeLevelAttachmentResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeLevelAttachmentResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScopeLevelAttachmentResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllOtherAttachmentsGenericFiltering(tenantId: number, projectId: number, body: GenericFilterModelCollection | undefined): Promise<ScopeLevelAttachmentResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/otherAttachment/genericFilter/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllOtherAttachmentsGenericFiltering(_response);
        });
    }

    protected processGetAllOtherAttachmentsGenericFiltering(response: Response): Promise<ScopeLevelAttachmentResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeLevelAttachmentResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScopeLevelAttachmentResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllScopeItemHasDiagramGenericFiltering(tenantId: number, projectId: number, body: GenericFilterModelCollection | undefined): Promise<ScopeItemLevelHasDiagramResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeItemLevel/hasDiagrams/genericFilter/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllScopeItemHasDiagramGenericFiltering(_response);
        });
    }

    protected processGetAllScopeItemHasDiagramGenericFiltering(response: Response): Promise<ScopeItemLevelHasDiagramResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeItemLevelHasDiagramResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScopeItemLevelHasDiagramResponseItemsResponseModel>(null as any);
    }
}

export class ScopeStepTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number, projectId: number): Promise<ProjectIsActiveOrderResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeStepType/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectIsActiveOrderResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectIsActiveOrderResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectIsActiveOrderResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: TenantIsActiveOrderDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeStepType/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, body: ExportProjectsDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ScopeStepType/{tenantId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ScopeUserRoleClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number, projectId: number): Promise<ProjectIsActiveOrderResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeUserRole/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ProjectIsActiveOrderResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectIsActiveOrderResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectIsActiveOrderResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: TenantIsActiveOrderDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/ScopeUserRole/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, body: ExportProjectsDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ScopeUserRole/{tenantId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class StatusReportClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    getAll(tenantId: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<StatusReportResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/StatusReport/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<StatusReportResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusReportResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusReportResponseItemsResponseModel>(null as any);
    }

    /**
     * @param isRelease (optional) 
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, isRelease: boolean | undefined, body: InsertStatusReportRequest | undefined): Promise<StatusReportResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/StatusReport/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (isRelease === null)
            throw new Error("The parameter 'isRelease' cannot be null.");
        else if (isRelease !== undefined)
            url_ += "isRelease=" + encodeURIComponent("" + isRelease) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<StatusReportResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusReportResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusReportResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param isRelease (optional) 
     * @param isAlign (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, isRelease: boolean | undefined, isAlign: boolean | undefined, body: UpdateStatusReportRequest | undefined): Promise<StatusReportResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/StatusReport/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (isRelease === null)
            throw new Error("The parameter 'isRelease' cannot be null.");
        else if (isRelease !== undefined)
            url_ += "isRelease=" + encodeURIComponent("" + isRelease) + "&";
        if (isAlign === null)
            throw new Error("The parameter 'isAlign' cannot be null.");
        else if (isAlign !== undefined)
            url_ += "isAlign=" + encodeURIComponent("" + isAlign) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<StatusReportResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusReportResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusReportResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined, body: GenericFilterModelCollection | undefined): Promise<StatusReportResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/StatusReport/{tenantId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<StatusReportResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusReportResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusReportResponseItemsResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    get(tenantId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<StatusReportResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/StatusReport/{tenantId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<StatusReportResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusReportResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusReportResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    delete(tenantId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/StatusReport/{tenantId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    release(tenantId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/StatusReport/release/{tenantId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRelease(_response);
        });
    }

    protected processRelease(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    align(tenantId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/StatusReport/align/{tenantId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAlign(_response);
        });
    }

    protected processAlign(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    clone(tenantId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<StatusReportResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/StatusReport/clone/{tenantId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClone(_response);
        });
    }

    protected processClone(response: Response): Promise<StatusReportResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusReportResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusReportResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/StatusReport/{tenantId}/exportAll?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class StatusReportStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<StatusReportStatusResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/StatusReportStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<StatusReportStatusResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StatusReportStatusResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusReportStatusResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: SimpleStatusRequestUpdateSimpleStatusRequestItems | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/StatusReportStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class SurveyClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getSimple(tenantId: number, id: number): Promise<IdNameResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Survey/simple/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimple(_response);
        });
    }

    protected processGetSimple(response: Response): Promise<IdNameResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    getSimpleByIds(tenantId: number, ids: number[] | undefined): Promise<IdNameResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Survey/simpleByIds/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimpleByIds(_response);
        });
    }

    protected processGetSimpleByIds(response: Response): Promise<IdNameResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number, id: number): Promise<SurveyResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Survey/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SurveyResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param idFormatPrefix (optional) 
     * @param searchValue (optional) 
     * @param body (optional) 
     * @return Success
     */
    search(tenantId: number, idFormatPrefix: string | undefined, searchValue: string | undefined, body: GenericFilterModelCollection | undefined): Promise<IdNameResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Survey/search/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (idFormatPrefix === null)
            throw new Error("The parameter 'idFormatPrefix' cannot be null.");
        else if (idFormatPrefix !== undefined)
            url_ += "idFormatPrefix=" + encodeURIComponent("" + idFormatPrefix) + "&";
        if (searchValue === null)
            throw new Error("The parameter 'searchValue' cannot be null.");
        else if (searchValue !== undefined)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<IdNameResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameResponseItemsResponseModel>(null as any);
    }

    /**
     * @param surveyStatus (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, projectId: number, surveyStatus: SurveyStatusEnum | undefined, offset: number | undefined, limit: number | undefined): Promise<SurveyResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Survey/{tenantId}/{projectId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (surveyStatus === null)
            throw new Error("The parameter 'surveyStatus' cannot be null.");
        else if (surveyStatus !== undefined)
            url_ += "SurveyStatus=" + encodeURIComponent("" + surveyStatus) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<SurveyResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, projectId: number, body: InsertSurveyRequest | undefined): Promise<SurveyResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Survey/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<SurveyResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: UpdateTenantDescriptiveRequest | undefined): Promise<SurveyResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Survey/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<SurveyResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, projectId: number, surveyId: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Survey/{tenantId}/{projectId}/{surveyId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clone(tenantId: number, projectId: number, body: CloneSurveyRequest | undefined): Promise<SurveyResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Survey/clone/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClone(_response);
        });
    }

    protected processClone(response: Response): Promise<SurveyResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAllMy(tenantId: number, projectId: number, offset: number | undefined, limit: number | undefined): Promise<MySurveyResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Survey/allMy/{tenantId}/{projectId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMy(_response);
        });
    }

    protected processGetAllMy(response: Response): Promise<MySurveyResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MySurveyResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MySurveyResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getMy(tenantId: number, projectId: number, id: number): Promise<MySurveyResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Survey/my/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMy(_response);
        });
    }

    protected processGetMy(response: Response): Promise<MySurveyResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MySurveyResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MySurveyResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitMy(tenantId: number, surveyId: number, projectId: string, body: SubmitMySurveyRequest | undefined): Promise<MySurveyResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Survey/submitMy/{tenantId}/{projectId}/{surveyId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitMy(_response);
        });
    }

    protected processSubmitMy(response: Response): Promise<MySurveyResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MySurveyResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MySurveyResponseSimpleResponseModel>(null as any);
    }
}

export class SurveyAnswerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAll(tenantId: number, projectId: number, surveyId: number, body: GenericFilterModelCollection | undefined): Promise<SurveyAnswerResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/SurveyAnswer/{tenantId}/{projectId}/{surveyId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<SurveyAnswerResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyAnswerResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyAnswerResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, projectId: number, surveyId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/SurveyAnswer/export/{tenantId}/{projectId}/{surveyId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SurveyParticipantClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, surveyId: number, offset: number | undefined, limit: number | undefined, projectId: string): Promise<SurveyParticipantResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/SurveyParticipant/{tenantId}/{projectId}/{surveyId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<SurveyParticipantResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyParticipantResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyParticipantResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSurveyParticipants(tenantId: number, projectId: number, surveyId: number, body: UpdateSurveyParticipantsRequest | undefined): Promise<SurveyParticipantResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/SurveyParticipant/updateSurveyParticipants/{tenantId}/{projectId}/{surveyId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSurveyParticipants(_response);
        });
    }

    protected processUpdateSurveyParticipants(response: Response): Promise<SurveyParticipantResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyParticipantResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyParticipantResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    releaseAndSendToSurveyParticipants(tenantId: number, surveyId: number, projectId: string): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/SurveyParticipant/releaseAndSendToSurveyParticipants/{tenantId}/{projectId}/{surveyId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReleaseAndSendToSurveyParticipants(_response);
        });
    }

    protected processReleaseAndSendToSurveyParticipants(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class SurveyQuestionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(tenantId: number, surveyId: number, id: number, projectId: string): Promise<SurveyQuestionResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/SurveyQuestion/{tenantId}/{projectId}/{surveyId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SurveyQuestionResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyQuestionResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyQuestionResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, surveyId: number, id: number, projectId: string): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/SurveyQuestion/{tenantId}/{projectId}/{surveyId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, surveyId: number, offset: number | undefined, limit: number | undefined, projectId: string): Promise<SurveyQuestionResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/SurveyQuestion/{tenantId}/{projectId}/{surveyId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<SurveyQuestionResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyQuestionResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyQuestionResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, surveyId: number, projectId: string, body: InsertSurveyQuestionRequest | undefined): Promise<SurveyQuestionResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/SurveyQuestion/{tenantId}/{projectId}/{surveyId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<SurveyQuestionResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyQuestionResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyQuestionResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, surveyId: number, projectId: string, body: UpdateSurveyQuestionRequest | undefined): Promise<SurveyQuestionResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/SurveyQuestion/{tenantId}/{projectId}/{surveyId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<SurveyQuestionResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyQuestionResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyQuestionResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getMy(tenantId: number, surveyId: number, offset: number | undefined, limit: number | undefined, projectId: string): Promise<MySurveyQuestionResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/SurveyQuestion/my/{tenantId}/{projectId}/{surveyId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMy(_response);
        });
    }

    protected processGetMy(response: Response): Promise<MySurveyQuestionResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MySurveyQuestionResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MySurveyQuestionResponseItemsResponseModel>(null as any);
    }
}

export class TaskClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getSimple(tenantId: number, id: number): Promise<IdNameResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Task/simple/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimple(_response);
        });
    }

    protected processGetSimple(response: Response): Promise<IdNameResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    getSimpleByIds(tenantId: number, ids: number[] | undefined): Promise<IdNameResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Task/simpleByIds/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimpleByIds(_response);
        });
    }

    protected processGetSimpleByIds(response: Response): Promise<IdNameResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, id: number): Promise<TaskResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Task/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TaskResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    delete(tenantId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Task/{tenantId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param idFormatPrefix (optional) 
     * @param searchValue (optional) 
     * @param body (optional) 
     * @return Success
     */
    search(tenantId: number, idFormatPrefix: string | undefined, searchValue: string | undefined, body: GenericFilterModelCollection | undefined): Promise<IdNameResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Task/search/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (idFormatPrefix === null)
            throw new Error("The parameter 'idFormatPrefix' cannot be null.");
        else if (idFormatPrefix !== undefined)
            url_ += "idFormatPrefix=" + encodeURIComponent("" + idFormatPrefix) + "&";
        if (searchValue === null)
            throw new Error("The parameter 'searchValue' cannot be null.");
        else if (searchValue !== undefined)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<IdNameResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameResponseItemsResponseModel>(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param nonProjectCategoryIds (optional) 
     * @param partialRequest (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, projectIds: number[] | undefined, nonProjectCategoryIds: number[] | undefined, partialRequest: PartialTaskRequestEnum[] | undefined, body: GenericFilterModelCollection | undefined): Promise<TaskResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Task/{tenantId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectIds === null)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (nonProjectCategoryIds === null)
            throw new Error("The parameter 'nonProjectCategoryIds' cannot be null.");
        else if (nonProjectCategoryIds !== undefined)
            nonProjectCategoryIds && nonProjectCategoryIds.forEach(item => { url_ += "nonProjectCategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (partialRequest === null)
            throw new Error("The parameter 'partialRequest' cannot be null.");
        else if (partialRequest !== undefined)
            partialRequest && partialRequest.forEach(item => { url_ += "partialRequest=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<TaskResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskResponseItemsResponseModel>(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param nonProjectCategoryIds (optional) 
     * @param statusId (optional) 
     * @param notEqualStatusId (optional) 
     * @return Success
     */
    getAll(tenantId: number, projectIds: number[] | undefined, nonProjectCategoryIds: number[] | undefined, statusId: number | undefined, notEqualStatusId: number | undefined): Promise<TaskResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Task/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectIds === null)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (nonProjectCategoryIds === null)
            throw new Error("The parameter 'nonProjectCategoryIds' cannot be null.");
        else if (nonProjectCategoryIds !== undefined)
            nonProjectCategoryIds && nonProjectCategoryIds.forEach(item => { url_ += "nonProjectCategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (statusId === null)
            throw new Error("The parameter 'statusId' cannot be null.");
        else if (statusId !== undefined)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        if (notEqualStatusId === null)
            throw new Error("The parameter 'notEqualStatusId' cannot be null.");
        else if (notEqualStatusId !== undefined)
            url_ += "notEqualStatusId=" + encodeURIComponent("" + notEqualStatusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TaskResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, body: InsertTaskRequest | undefined): Promise<TaskResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Task/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<TaskResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: UpdateTaskRequest | undefined): Promise<TaskResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Task/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TaskResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAllSimple(tenantId: number): Promise<SimpleIdNameModelItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Task/{tenantId}/simple";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSimple(_response);
        });
    }

    protected processGetAllSimple(response: Response): Promise<SimpleIdNameModelItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleIdNameModelItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimpleIdNameModelItemsResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    downloadAttachment(tenantId: number, taskId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Task/attachment/{tenantId}/{taskId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadAttachment(_response);
        });
    }

    protected processDownloadAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    removeAttachment(tenantId: number, taskId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Task/attachment/{tenantId}/{taskId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveAttachment(_response);
        });
    }

    protected processRemoveAttachment(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param nonProjectCategoryIds (optional) 
     * @param partialRequest (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, projectIds: number[] | undefined, nonProjectCategoryIds: number[] | undefined, partialRequest: PartialTaskRequestEnum[] | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Task/{tenantId}/exportAll?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectIds === null)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (nonProjectCategoryIds === null)
            throw new Error("The parameter 'nonProjectCategoryIds' cannot be null.");
        else if (nonProjectCategoryIds !== undefined)
            nonProjectCategoryIds && nonProjectCategoryIds.forEach(item => { url_ += "nonProjectCategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (partialRequest === null)
            throw new Error("The parameter 'partialRequest' cannot be null.");
        else if (partialRequest !== undefined)
            partialRequest && partialRequest.forEach(item => { url_ += "partialRequest=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getHistoryFromTo(tenantId: number, id: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined, from: Date | undefined, to: Date | undefined): Promise<TaskHistoryResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Task/history/{tenantId}/{id}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHistoryFromTo(_response);
        });
    }

    protected processGetHistoryFromTo(response: Response): Promise<TaskHistoryResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskHistoryResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskHistoryResponseItemsResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    getTimesheets(tenantId: number, taskId: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<TaskTimesheetResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Task/timesheets/{tenantId}/{taskId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTimesheets(_response);
        });
    }

    protected processGetTimesheets(response: Response): Promise<TaskTimesheetResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskTimesheetResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskTimesheetResponseItemsResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateTimesheets(tenantId: number, taskId: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined, body: TaskTimesheetDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Task/timesheets/{tenantId}/{taskId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTimesheets(_response);
        });
    }

    protected processUpdateTimesheets(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @param follow (optional) 
     * @return Success
     */
    followTask(tenantId: number, taskId: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined, follow: boolean | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Task/follow/{tenantId}/{taskId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        if (follow === null)
            throw new Error("The parameter 'follow' cannot be null.");
        else if (follow !== undefined)
            url_ += "follow=" + encodeURIComponent("" + follow) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFollowTask(_response);
        });
    }

    protected processFollowTask(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class TaskCommentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param projectOrCategoryId (optional) 
     * @param isProjectConnected (optional) 
     * @return Success
     */
    getAll(tenantId: number, taskId: number, projectOrCategoryId: number | undefined, isProjectConnected: boolean | undefined): Promise<TaskCommentResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TaskComment/{tenantId}/{taskId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        if (projectOrCategoryId === null)
            throw new Error("The parameter 'projectOrCategoryId' cannot be null.");
        else if (projectOrCategoryId !== undefined)
            url_ += "projectOrCategoryId=" + encodeURIComponent("" + projectOrCategoryId) + "&";
        if (isProjectConnected === null)
            throw new Error("The parameter 'isProjectConnected' cannot be null.");
        else if (isProjectConnected !== undefined)
            url_ += "isProjectConnected=" + encodeURIComponent("" + isProjectConnected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TaskCommentResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskCommentResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskCommentResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, body: InsertTaskCommentRequest | undefined): Promise<TaskCommentResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TaskComment/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<TaskCommentResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskCommentResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskCommentResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: UpdateTaskCommentRequest | undefined): Promise<TaskCommentResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TaskComment/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TaskCommentResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskCommentResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskCommentResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TaskComment/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class TaskStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<TaskStatusResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TaskStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TaskStatusResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskStatusResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskStatusResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: StatusDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TaskStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class TeamSizeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getTeamSizes(): Promise<IdNameSymbolResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TeamSize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTeamSizes(_response);
        });
    }

    protected processGetTeamSizes(response: Response): Promise<IdNameSymbolResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameSymbolResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameSymbolResponseItemsResponseModel>(null as any);
    }
}

export class TenantClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(id: number, body: TenantUpdateRequestModel | undefined): Promise<TenantResponseModelSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Tenant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TenantResponseModelSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantResponseModelSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantResponseModelSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getTenant(id: number): Promise<TenantResponseModelSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Tenant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTenant(_response);
        });
    }

    protected processGetTenant(response: Response): Promise<TenantResponseModelSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantResponseModelSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantResponseModelSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    tenantExists(body: CheckTenantRequestModel | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Tenant/exists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTenantExists(_response);
        });
    }

    protected processTenantExists(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getCompany(id: number): Promise<CompanyResponseModelSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Tenant/companyinfo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompany(_response);
        });
    }

    protected processGetCompany(response: Response): Promise<CompanyResponseModelSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyResponseModelSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyResponseModelSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCompany(id: number, body: CompanyRequestModel | undefined): Promise<CompanyResponseModelSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Tenant/companyinfo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCompany(_response);
        });
    }

    protected processUpdateCompany(response: Response): Promise<CompanyResponseModelSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyResponseModelSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyResponseModelSimpleResponseModel>(null as any);
    }
}

export class TenantDiscoveryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    discover(body: DiscoverTenantsRequestModel | undefined): Promise<DiscoveredTenantResponseModelItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TenantDiscovery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDiscover(_response);
        });
    }

    protected processDiscover(response: Response): Promise<DiscoveredTenantResponseModelItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscoveredTenantResponseModelItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscoveredTenantResponseModelItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    discoverLocal(body: DiscoverTenantsRequestModel | undefined): Promise<DiscoveredTenantResponseModelItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TenantDiscovery/local";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDiscoverLocal(_response);
        });
    }

    protected processDiscoverLocal(response: Response): Promise<DiscoveredTenantResponseModelItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscoveredTenantResponseModelItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscoveredTenantResponseModelItemsResponseModel>(null as any);
    }
}

export class TestCycleClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number, id: number): Promise<TenantIsActiveResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TestCycle/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TenantIsActiveResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, projectId: number, offset: number | undefined, limit: number | undefined): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TestCycle/{tenantId}/{projectId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: TenantIsActiveDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TestCycle/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, projectId: number, body: GenericFilterModelCollection | undefined): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TestCycle/genericFilter/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }
}

export class TestDashboardClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    get(tenantId: number, projectId: number, cycleId: number, body: TestDashboardFilterRequest | undefined): Promise<TestDashboardResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TestDashboard/{tenantId}/{projectId}/{cycleId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (cycleId === undefined || cycleId === null)
            throw new Error("The parameter 'cycleId' must be defined.");
        url_ = url_.replace("{cycleId}", encodeURIComponent("" + cycleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TestDashboardResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestDashboardResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestDashboardResponseSimpleResponseModel>(null as any);
    }
}

export class TestPlanClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number, testCycleId: number, id: number): Promise<TestPlanResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TestPlan/{tenantId}/{projectId}/{testCycleId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (testCycleId === undefined || testCycleId === null)
            throw new Error("The parameter 'testCycleId' must be defined.");
        url_ = url_.replace("{testCycleId}", encodeURIComponent("" + testCycleId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TestPlanResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestPlanResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestPlanResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, projectId: number, testCycleId: number, includeLevel4: boolean, body: GenericFilterModelCollection | undefined): Promise<TestPlanRowResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TestPlan/genericFilter/{tenantId}/{projectId}/{testCycleId}/{includeLevel4}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (testCycleId === undefined || testCycleId === null)
            throw new Error("The parameter 'testCycleId' must be defined.");
        url_ = url_.replace("{testCycleId}", encodeURIComponent("" + testCycleId));
        if (includeLevel4 === undefined || includeLevel4 === null)
            throw new Error("The parameter 'includeLevel4' must be defined.");
        url_ = url_.replace("{includeLevel4}", encodeURIComponent("" + includeLevel4));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<TestPlanRowResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestPlanRowResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestPlanRowResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAllSimple(tenantId: number): Promise<SimpleIdNameModelItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TestPlan/{tenantId}/simple";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSimple(_response);
        });
    }

    protected processGetAllSimple(response: Response): Promise<SimpleIdNameModelItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleIdNameModelItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimpleIdNameModelItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setAllIsActive(tenantId: number, projectId: number, testCycleId: number, isActive: boolean, body: GenericFilterModelCollection | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TestPlan/setAll/{tenantId}/{projectId}/{testCycleId}/{isActive}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (testCycleId === undefined || testCycleId === null)
            throw new Error("The parameter 'testCycleId' must be defined.");
        url_ = url_.replace("{testCycleId}", encodeURIComponent("" + testCycleId));
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined.");
        url_ = url_.replace("{isActive}", encodeURIComponent("" + isActive));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetAllIsActive(_response);
        });
    }

    protected processSetAllIsActive(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMy(tenantId: number, projectId: number, testCycleId: number, includeLevel4: boolean, body: GenericFilterModelCollection | undefined): Promise<MyTestPlanResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TestPlan/my/genericFilter/{tenantId}/{projectId}/{testCycleId}/{includeLevel4}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (testCycleId === undefined || testCycleId === null)
            throw new Error("The parameter 'testCycleId' must be defined.");
        url_ = url_.replace("{testCycleId}", encodeURIComponent("" + testCycleId));
        if (includeLevel4 === undefined || includeLevel4 === null)
            throw new Error("The parameter 'includeLevel4' must be defined.");
        url_ = url_.replace("{includeLevel4}", encodeURIComponent("" + includeLevel4));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMy(_response);
        });
    }

    protected processGetMy(response: Response): Promise<MyTestPlanResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyTestPlanResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MyTestPlanResponseItemsResponseModel>(null as any);
    }

    /**
     * @param showTestStatus (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllReport(tenantId: number, projectId: number, testCycleId: number, showTestStatus: ShowTestStatusEnum | undefined, body: GenericFilterModelCollection | undefined): Promise<ReportTestPlanResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TestPlan/report/genericFilter/{tenantId}/{projectId}/{testCycleId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (testCycleId === undefined || testCycleId === null)
            throw new Error("The parameter 'testCycleId' must be defined.");
        url_ = url_.replace("{testCycleId}", encodeURIComponent("" + testCycleId));
        if (showTestStatus === null)
            throw new Error("The parameter 'showTestStatus' cannot be null.");
        else if (showTestStatus !== undefined)
            url_ += "showTestStatus=" + encodeURIComponent("" + showTestStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllReport(_response);
        });
    }

    protected processGetAllReport(response: Response): Promise<ReportTestPlanResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportTestPlanResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportTestPlanResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLevel3(tenantId: number, projectId: number, testCycleId: number, body: UpdateLevel3TestPlanRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TestPlan/updateLevel3/{tenantId}/{projectId}/{testCycleId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (testCycleId === undefined || testCycleId === null)
            throw new Error("The parameter 'testCycleId' must be defined.");
        url_ = url_.replace("{testCycleId}", encodeURIComponent("" + testCycleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLevel3(_response);
        });
    }

    protected processUpdateLevel3(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLevel4(tenantId: number, projectId: number, testCycleId: number, body: UpdateLevel4TestPlanRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TestPlan/updateLevel4/{tenantId}/{projectId}/{testCycleId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (testCycleId === undefined || testCycleId === null)
            throw new Error("The parameter 'testCycleId' must be defined.");
        url_ = url_.replace("{testCycleId}", encodeURIComponent("" + testCycleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLevel4(_response);
        });
    }

    protected processUpdateLevel4(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, testCycleId: number, body: UpdateTestPlanRequest | undefined): Promise<TestPlanResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TestPlan/{tenantId}/{projectId}/{testCycleId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (testCycleId === undefined || testCycleId === null)
            throw new Error("The parameter 'testCycleId' must be defined.");
        url_ = url_.replace("{testCycleId}", encodeURIComponent("" + testCycleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TestPlanResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestPlanResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestPlanResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clone(tenantId: number, projectId: number, testCycleId: number, body: CopyFromTestCycleRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TestPlan/clone/{tenantId}/{projectId}/{testCycleId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (testCycleId === undefined || testCycleId === null)
            throw new Error("The parameter 'testCycleId' must be defined.");
        url_ = url_.replace("{testCycleId}", encodeURIComponent("" + testCycleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClone(_response);
        });
    }

    protected processClone(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportTestPlans(tenantId: number, projectId: number, testCycleId: number, includeLevel4: boolean, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TestPlan/{tenantId}/{projectId}/{testCycleId}/{includeLevel4}/exportTestPlans";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (testCycleId === undefined || testCycleId === null)
            throw new Error("The parameter 'testCycleId' must be defined.");
        url_ = url_.replace("{testCycleId}", encodeURIComponent("" + testCycleId));
        if (includeLevel4 === undefined || includeLevel4 === null)
            throw new Error("The parameter 'includeLevel4' must be defined.");
        url_ = url_.replace("{includeLevel4}", encodeURIComponent("" + includeLevel4));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportTestPlans(_response);
        });
    }

    protected processExportTestPlans(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportMyTestPlans(tenantId: number, projectId: number, testCycleId: number, includeLevel4: boolean, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TestPlan/{tenantId}/{projectId}/{testCycleId}/{includeLevel4}/exportMyTestPlans";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (testCycleId === undefined || testCycleId === null)
            throw new Error("The parameter 'testCycleId' must be defined.");
        url_ = url_.replace("{testCycleId}", encodeURIComponent("" + testCycleId));
        if (includeLevel4 === undefined || includeLevel4 === null)
            throw new Error("The parameter 'includeLevel4' must be defined.");
        url_ = url_.replace("{includeLevel4}", encodeURIComponent("" + includeLevel4));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportMyTestPlans(_response);
        });
    }

    protected processExportMyTestPlans(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param showTestStatus (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportTestStatus(tenantId: number, projectId: number, testCycleId: number, showTestStatus: ShowTestStatusEnum | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TestPlan/{tenantId}/{projectId}/{testCycleId}/exportTestStatus?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (testCycleId === undefined || testCycleId === null)
            throw new Error("The parameter 'testCycleId' must be defined.");
        url_ = url_.replace("{testCycleId}", encodeURIComponent("" + testCycleId));
        if (showTestStatus === null)
            throw new Error("The parameter 'showTestStatus' cannot be null.");
        else if (showTestStatus !== undefined)
            url_ += "showTestStatus=" + encodeURIComponent("" + showTestStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportTestStatus(_response);
        });
    }

    protected processExportTestStatus(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getHistoryFromTo(tenantId: number, projectId: number, testCycleId: number, id: number): Promise<TestPlanHistoryResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TestPlan/history/{tenantId}/{projectId}/{testCycleId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (testCycleId === undefined || testCycleId === null)
            throw new Error("The parameter 'testCycleId' must be defined.");
        url_ = url_.replace("{testCycleId}", encodeURIComponent("" + testCycleId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHistoryFromTo(_response);
        });
    }

    protected processGetHistoryFromTo(response: Response): Promise<TestPlanHistoryResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestPlanHistoryResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestPlanHistoryResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    downloadAttachment(tenantId: number, projectId: number, testCycleId: number, testPlanId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TestPlan/attachment/{tenantId}/{projectId}/{testCycleId}/{testPlanId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (testCycleId === undefined || testCycleId === null)
            throw new Error("The parameter 'testCycleId' must be defined.");
        url_ = url_.replace("{testCycleId}", encodeURIComponent("" + testCycleId));
        if (testPlanId === undefined || testPlanId === null)
            throw new Error("The parameter 'testPlanId' must be defined.");
        url_ = url_.replace("{testPlanId}", encodeURIComponent("" + testPlanId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadAttachment(_response);
        });
    }

    protected processDownloadAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    removeAttachment(tenantId: number, projectId: number, testCycleId: number, testPlanId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TestPlan/attachment/{tenantId}/{projectId}/{testCycleId}/{testPlanId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (testCycleId === undefined || testCycleId === null)
            throw new Error("The parameter 'testCycleId' must be defined.");
        url_ = url_.replace("{testCycleId}", encodeURIComponent("" + testCycleId));
        if (testPlanId === undefined || testPlanId === null)
            throw new Error("The parameter 'testPlanId' must be defined.");
        url_ = url_.replace("{testPlanId}", encodeURIComponent("" + testPlanId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveAttachment(_response);
        });
    }

    protected processRemoveAttachment(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class TestStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<TestStatusResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TestStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TestStatusResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TestStatusResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestStatusResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: TestStatusDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TestStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class TicketClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getSimple(tenantId: number, id: number): Promise<IdNameProjectResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/simple/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimple(_response);
        });
    }

    protected processGetSimple(response: Response): Promise<IdNameProjectResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameProjectResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameProjectResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    getSimpleByIds(tenantId: number, ids: number[] | undefined): Promise<IdNameProjectResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/simpleByIds/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimpleByIds(_response);
        });
    }

    protected processGetSimpleByIds(response: Response): Promise<IdNameProjectResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameProjectResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameProjectResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number, id: number): Promise<TicketResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TicketResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, projectId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param idFormatPrefix (optional) 
     * @param searchValue (optional) 
     * @param body (optional) 
     * @return Success
     */
    search(tenantId: number, idFormatPrefix: string | undefined, searchValue: string | undefined, body: GenericFilterModelCollection | undefined): Promise<IdNameProjectResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/search/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (idFormatPrefix === null)
            throw new Error("The parameter 'idFormatPrefix' cannot be null.");
        else if (idFormatPrefix !== undefined)
            url_ += "idFormatPrefix=" + encodeURIComponent("" + idFormatPrefix) + "&";
        if (searchValue === null)
            throw new Error("The parameter 'searchValue' cannot be null.");
        else if (searchValue !== undefined)
            url_ += "searchValue=" + encodeURIComponent("" + searchValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<IdNameProjectResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdNameProjectResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdNameProjectResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, body: GenericProjectsFilterModelCollection | undefined): Promise<TicketResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/genericFilter/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<TicketResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, body: InsertTicketRequest | undefined): Promise<TicketResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<TicketResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: UpdateTicketRequest | undefined): Promise<TicketResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TicketResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    patch(tenantId: number, projectId: number, body: PatchTenantIdentifyRequest | undefined): Promise<TicketSubtaskResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<TicketSubtaskResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketSubtaskResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketSubtaskResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, body: ExportProjectsDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Ticket/{tenantId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSla(tenantId: number, projectId: number, ticketId: number): Promise<TicketSlaResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/sla/{tenantId}/{projectId}/{ticketId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSla(_response);
        });
    }

    protected processGetSla(response: Response): Promise<TicketSlaResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketSlaResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketSlaResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getClosing(tenantId: number, projectId: number, ticketId: number): Promise<TicketClosingResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/closing/{tenantId}/{projectId}/{ticketId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClosing(_response);
        });
    }

    protected processGetClosing(response: Response): Promise<TicketClosingResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketClosingResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketClosingResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getEffort(tenantId: number, projectId: number, ticketId: number): Promise<TicketEffortResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/effort/{tenantId}/{projectId}/{ticketId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEffort(_response);
        });
    }

    protected processGetEffort(response: Response): Promise<TicketEffortResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketEffortResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketEffortResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param follow (optional) 
     * @return Success
     */
    followTicket(tenantId: number, projectId: number, ticketId: number, follow: boolean | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/follow/{tenantId}/{projectId}/{ticketId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (follow === null)
            throw new Error("The parameter 'follow' cannot be null.");
        else if (follow !== undefined)
            url_ += "follow=" + encodeURIComponent("" + follow) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFollowTicket(_response);
        });
    }

    protected processFollowTicket(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateClosing(tenantId: number, projectId: number, body: UpdateTicketClosingRequest | undefined): Promise<TicketClosingResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/closing/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateClosing(_response);
        });
    }

    protected processUpdateClosing(response: Response): Promise<TicketClosingResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketClosingResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketClosingResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEffort(tenantId: number, projectId: number, body: UpdateTicketEffortRequest | undefined): Promise<TicketEffortResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/effort/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateEffort(_response);
        });
    }

    protected processUpdateEffort(response: Response): Promise<TicketEffortResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketEffortResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketEffortResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    downloadAttachment(tenantId: number, projectId: number, ticketId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Ticket/attachment/{tenantId}/{projectId}/{ticketId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadAttachment(_response);
        });
    }

    protected processDownloadAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    removeAttachment(tenantId: number, projectId: number, ticketId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/attachment/{tenantId}/{projectId}/{ticketId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveAttachment(_response);
        });
    }

    protected processRemoveAttachment(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    downloadDesignAttachment(tenantId: number, projectId: number, ticketId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Ticket/designAttachment/{tenantId}/{projectId}/{ticketId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadDesignAttachment(_response);
        });
    }

    protected processDownloadDesignAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    removeDesignAttachment(tenantId: number, projectId: number, ticketId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/designAttachment/{tenantId}/{projectId}/{ticketId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveDesignAttachment(_response);
        });
    }

    protected processRemoveDesignAttachment(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    downloadDevelopmentSpecificationAttachment(tenantId: number, projectId: number, ticketId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Ticket/developmentSpecificationAttachment/{tenantId}/{projectId}/{ticketId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadDevelopmentSpecificationAttachment(_response);
        });
    }

    protected processDownloadDevelopmentSpecificationAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    removeDevelopmentSpecificationAttachment(tenantId: number, projectId: number, ticketId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/developmentSpecificationAttachment/{tenantId}/{projectId}/{ticketId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveDevelopmentSpecificationAttachment(_response);
        });
    }

    protected processRemoveDevelopmentSpecificationAttachment(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    downloadTrainingManualAttachment(tenantId: number, projectId: number, ticketId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Ticket/trainingManualAttachment/{tenantId}/{projectId}/{ticketId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadTrainingManualAttachment(_response);
        });
    }

    protected processDownloadTrainingManualAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    removeTrainingManualAttachment(tenantId: number, projectId: number, ticketId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/trainingManualAttachment/{tenantId}/{projectId}/{ticketId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveTrainingManualAttachment(_response);
        });
    }

    protected processRemoveTrainingManualAttachment(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    downloadTestEvidenceAttachment(tenantId: number, projectId: number, ticketId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Ticket/testEvidenceAttachment/{tenantId}/{projectId}/{ticketId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadTestEvidenceAttachment(_response);
        });
    }

    protected processDownloadTestEvidenceAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    removeTestEvidenceAttachment(tenantId: number, projectId: number, ticketId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/testEvidenceAttachment/{tenantId}/{projectId}/{ticketId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveTestEvidenceAttachment(_response);
        });
    }

    protected processRemoveTestEvidenceAttachment(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getHistoryFromTo(tenantId: number, projectId: number, ticketId: number, from: Date | undefined, to: Date | undefined): Promise<TicketHistoryResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Ticket/history/{tenantId}/{projectId}/{ticketId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHistoryFromTo(_response);
        });
    }

    protected processGetHistoryFromTo(response: Response): Promise<TicketHistoryResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHistoryResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketHistoryResponseItemsResponseModel>(null as any);
    }
}

export class TicketCommentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, projectId: number, ticketId: number, offset: number | undefined, limit: number | undefined): Promise<TicketCommentResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketComment/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined and cannot be null.");
        else
            url_ += "TicketId=" + encodeURIComponent("" + ticketId) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TicketCommentResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketCommentResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketCommentResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, projectId: number, ticketId: number, body: InsertTicketCommentRequest | undefined): Promise<TicketCommentResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketComment/{tenantId}/{projectId}/{ticketId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<TicketCommentResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketCommentResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketCommentResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, ticketId: number, body: UpdateTicketCommentRequest | undefined): Promise<TicketCommentResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketComment/{tenantId}/{projectId}/{ticketId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TicketCommentResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketCommentResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketCommentResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, projectId: number, id: number): Promise<TicketCommentResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketComment/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<TicketCommentResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketCommentResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketCommentResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    downloadAttachment(tenantId: number, projectId: number, ticketCommentId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TicketComment/attachment/{tenantId}/{projectId}/{ticketCommentId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketCommentId === undefined || ticketCommentId === null)
            throw new Error("The parameter 'ticketCommentId' must be defined.");
        url_ = url_.replace("{ticketCommentId}", encodeURIComponent("" + ticketCommentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadAttachment(_response);
        });
    }

    protected processDownloadAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TicketConfigClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getTicketTypes(tenantId: number): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/type/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTicketTypes(_response);
        });
    }

    protected processGetTicketTypes(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTicketTypes(tenantId: number, body: TenantIsActiveDeltaRequest | undefined): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/type/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTicketTypes(_response);
        });
    }

    protected processUpdateTicketTypes(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getTicketEnvironments(tenantId: number): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/environment/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTicketEnvironments(_response);
        });
    }

    protected processGetTicketEnvironments(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTicketEnvironments(tenantId: number, body: TenantIsActiveDeltaRequest | undefined): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/environment/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTicketEnvironments(_response);
        });
    }

    protected processUpdateTicketEnvironments(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getTicketClosingIds(tenantId: number): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/closingId/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTicketClosingIds(_response);
        });
    }

    protected processGetTicketClosingIds(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTicketClosingIds(tenantId: number, body: TenantIsActiveDeltaRequest | undefined): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/closingId/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTicketClosingIds(_response);
        });
    }

    protected processUpdateTicketClosingIds(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getSupportOrganizations(tenantId: number): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/supportOrganization/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportOrganizations(_response);
        });
    }

    protected processGetSupportOrganizations(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSupportOrganization(tenantId: number, body: InsertTenantIsActiveRequest | undefined): Promise<TenantIsActiveResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/supportOrganization/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSupportOrganization(_response);
        });
    }

    protected processCreateSupportOrganization(response: Response): Promise<TenantIsActiveResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    patchSupportOrganization(tenantId: number, body: PatchTenantIdentifyRequest | undefined): Promise<TenantIsActiveResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/supportOrganization/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatchSupportOrganization(_response);
        });
    }

    protected processPatchSupportOrganization(response: Response): Promise<TenantIsActiveResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    deleteSupportOrganization(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/supportOrganization/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSupportOrganization(_response);
        });
    }

    protected processDeleteSupportOrganization(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param supportOrganizationId (optional) 
     * @return Success
     */
    getAssignedGroups(tenantId: number, supportOrganizationId: number | undefined): Promise<TicketAssignedGroupResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/assignedGroup/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (supportOrganizationId === null)
            throw new Error("The parameter 'supportOrganizationId' cannot be null.");
        else if (supportOrganizationId !== undefined)
            url_ += "SupportOrganizationId=" + encodeURIComponent("" + supportOrganizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssignedGroups(_response);
        });
    }

    protected processGetAssignedGroups(response: Response): Promise<TicketAssignedGroupResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketAssignedGroupResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketAssignedGroupResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAssignedGroup(tenantId: number, body: InsertTicketAssignedGroupRequest | undefined): Promise<TicketAssignedGroupResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/assignedGroup/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAssignedGroup(_response);
        });
    }

    protected processCreateAssignedGroup(response: Response): Promise<TicketAssignedGroupResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketAssignedGroupResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketAssignedGroupResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    patchAssignedGroup(tenantId: number, body: PatchTenantIdentifyRequest | undefined): Promise<TicketAssignedGroupResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/assignedGroup/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatchAssignedGroup(_response);
        });
    }

    protected processPatchAssignedGroup(response: Response): Promise<TicketAssignedGroupResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketAssignedGroupResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketAssignedGroupResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    deleteAssignedGroup(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/assignedGroup/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAssignedGroup(_response);
        });
    }

    protected processDeleteAssignedGroup(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getCategory(tenantId: number, id: number): Promise<TicketCategoryResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/category/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCategory(_response);
        });
    }

    protected processGetCategory(response: Response): Promise<TicketCategoryResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketCategoryResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketCategoryResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    deleteCategory(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/category/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCategory(_response);
        });
    }

    protected processDeleteCategory(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param supportOrganizationId (optional) 
     * @param parentId (optional) 
     * @param levelNumber (optional) 
     * @return Success
     */
    getAllCategories(tenantId: number, supportOrganizationId: number | undefined, parentId: number | undefined, levelNumber: number | undefined): Promise<TicketCategoryResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/category/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (supportOrganizationId === null)
            throw new Error("The parameter 'supportOrganizationId' cannot be null.");
        else if (supportOrganizationId !== undefined)
            url_ += "SupportOrganizationId=" + encodeURIComponent("" + supportOrganizationId) + "&";
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&";
        if (levelNumber === null)
            throw new Error("The parameter 'levelNumber' cannot be null.");
        else if (levelNumber !== undefined)
            url_ += "LevelNumber=" + encodeURIComponent("" + levelNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllCategories(_response);
        });
    }

    protected processGetAllCategories(response: Response): Promise<TicketCategoryResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketCategoryResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketCategoryResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCategory(tenantId: number, body: InsertTicketCategoryRequest | undefined): Promise<TicketCategoryResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/category/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCategory(_response);
        });
    }

    protected processCreateCategory(response: Response): Promise<TicketCategoryResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketCategoryResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketCategoryResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCategory(tenantId: number, body: UpdateTicketCategoryRequest | undefined): Promise<TicketCategoryResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/category/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCategory(_response);
        });
    }

    protected processUpdateCategory(response: Response): Promise<TicketCategoryResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketCategoryResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketCategoryResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTicketCategoryOrders(tenantId: number, body: UpdateOrderRequest[] | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/category/orders/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTicketCategoryOrders(_response);
        });
    }

    protected processUpdateTicketCategoryOrders(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getPriorityDescs(tenantId: number): Promise<TicketPriorityDescriptionResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/priorityDescs/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPriorityDescs(_response);
        });
    }

    protected processGetPriorityDescs(response: Response): Promise<TicketPriorityDescriptionResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketPriorityDescriptionResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketPriorityDescriptionResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePriorityDescs(tenantId: number, body: TicketPriorityDescriptionRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/priorityDescs/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePriorityDescs(_response);
        });
    }

    protected processUpdatePriorityDescs(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getUrgencies(tenantId: number): Promise<UrgencyResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/urgency/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUrgencies(_response);
        });
    }

    protected processGetUrgencies(response: Response): Promise<UrgencyResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UrgencyResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UrgencyResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getImpacts(tenantId: number): Promise<ImpactResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/impact/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetImpacts(_response);
        });
    }

    protected processGetImpacts(response: Response): Promise<ImpactResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpactResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImpactResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getPriorites(tenantId: number): Promise<PriorityResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketConfig/priority/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPriorites(_response);
        });
    }

    protected processGetPriorites(response: Response): Promise<PriorityResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriorityResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PriorityResponseItemsResponseModel>(null as any);
    }
}

export class TicketDashboardClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    get(tenantId: number, body: TicketDashboardFilterRequest | undefined): Promise<TicketDashboardResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketDashboard/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TicketDashboardResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketDashboardResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketDashboardResponseSimpleResponseModel>(null as any);
    }
}

export class TicketHelpDeskClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, body: GenericProjectsFilterModelCollection | undefined): Promise<TicketHelpDeskResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketHelpDesk/genericFilter/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<TicketHelpDeskResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHelpDeskResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketHelpDeskResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, body: InsertTicketHelpDeskRequest | undefined): Promise<TicketHelpDeskResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketHelpDesk/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<TicketHelpDeskResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHelpDeskResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketHelpDeskResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: UpdateTicketHelpDeskRequest | undefined): Promise<TicketHelpDeskResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketHelpDesk/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TicketHelpDeskResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketHelpDeskResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketHelpDeskResponseSimpleResponseModel>(null as any);
    }
}

export class TicketHelpDeskCommentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, projectId: number, ticketId: number, offset: number | undefined, limit: number | undefined): Promise<TicketCommentResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketHelpDeskComment/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined and cannot be null.");
        else
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined and cannot be null.");
        else
            url_ += "TicketId=" + encodeURIComponent("" + ticketId) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TicketCommentResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketCommentResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketCommentResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, projectId: number, ticketId: number, body: InsertTicketCommentRequest | undefined): Promise<TicketCommentResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketHelpDeskComment/{tenantId}/{projectId}/{ticketId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<TicketCommentResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketCommentResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketCommentResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, ticketId: number, body: UpdateTicketCommentRequest | undefined): Promise<TicketCommentResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketHelpDeskComment/{tenantId}/{projectId}/{ticketId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TicketCommentResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketCommentResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketCommentResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, projectId: number, id: number): Promise<TicketCommentResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketHelpDeskComment/{tenantId}/{projectId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<TicketCommentResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketCommentResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketCommentResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    downloadAttachment(tenantId: number, projectId: number, ticketCommentId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TicketHelpDeskComment/attachment/{tenantId}/{projectId}/{ticketCommentId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (ticketCommentId === undefined || ticketCommentId === null)
            throw new Error("The parameter 'ticketCommentId' must be defined.");
        url_ = url_.replace("{ticketCommentId}", encodeURIComponent("" + ticketCommentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadAttachment(_response);
        });
    }

    protected processDownloadAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TicketStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<TicketStatusResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TicketStatusResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketStatusResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketStatusResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: TicketStatusDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TicketStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class TicketSubtaskClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, ticketId: number, offset: number | undefined, limit: number | undefined): Promise<TicketSubtaskResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TicketSubtask/{tenantId}/{ticketId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TicketSubtaskResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketSubtaskResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketSubtaskResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, ticketId: number, body: InsertTicketSubtaskRequest | undefined): Promise<TicketSubtaskResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketSubtask/{tenantId}/{ticketId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<TicketSubtaskResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketSubtaskResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketSubtaskResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, ticketId: number, body: UpdateTicketSubtaskRequest | undefined): Promise<TicketSubtaskResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketSubtask/{tenantId}/{ticketId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TicketSubtaskResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketSubtaskResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketSubtaskResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    patch(tenantId: number, ticketId: number, body: PatchTenantIdentifyRequest | undefined): Promise<TicketSubtaskResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TicketSubtask/{tenantId}/{ticketId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<TicketSubtaskResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TicketSubtaskResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TicketSubtaskResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TicketSubtask/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class TimesheetClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllMy(tenantId: number, body: TimesheetsOneDayRequest | undefined): Promise<TimesheetResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Timesheet/allMy/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMy(_response);
        });
    }

    protected processGetAllMy(response: Response): Promise<TimesheetResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllMyRecoredStatusesForPeriod(tenantId: number, body: TimesheetsPeriodRequest | undefined): Promise<TimesheetRecordedStatusResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Timesheet/myRecordedStatuses/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMyRecoredStatusesForPeriod(_response);
        });
    }

    protected processGetAllMyRecoredStatusesForPeriod(response: Response): Promise<TimesheetRecordedStatusResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetRecordedStatusResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetRecordedStatusResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllMerged(tenantId: number, body: TimesheetsPeriodRequest | undefined): Promise<TimesheetMergedResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Timesheet/all/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMerged(_response);
        });
    }

    protected processGetAllMerged(response: Response): Promise<TimesheetMergedResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetMergedResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetMergedResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getForPeriod(tenantId: number, projectId: number, statusId: number, userId: number, body: TimesheetsPeriodRequest | undefined): Promise<TimesheetResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Timesheet/get/{tenantId}/{projectId}/{statusId}/{userId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (statusId === undefined || statusId === null)
            throw new Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForPeriod(_response);
        });
    }

    protected processGetForPeriod(response: Response): Promise<TimesheetResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: TimesheetDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Timesheet/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    patch(tenantId: number, projectId: number, body: PatchTenantIdentifyRequest | undefined): Promise<TimesheetResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/Timesheet/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<TimesheetResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    release(tenantId: number, body: TimesheetsPeriodRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Timesheet/release/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRelease(_response);
        });
    }

    protected processRelease(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approval(tenantId: number, body: ApprovalTimesheetRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Timesheet/approval/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproval(_response);
        });
    }

    protected processApproval(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param nonProjectCategoryId (optional) 
     * @param projectId (optional) 
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportMy(tenantId: number, nonProjectCategoryId: number | undefined, projectId: number | undefined, years: number[] | undefined, months: MonthEnum[] | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Timesheet/exportMy/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (nonProjectCategoryId === null)
            throw new Error("The parameter 'nonProjectCategoryId' cannot be null.");
        else if (nonProjectCategoryId !== undefined)
            url_ += "NonProjectCategoryId=" + encodeURIComponent("" + nonProjectCategoryId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "Years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "Months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportMy(_response);
        });
    }

    protected processExportMy(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportMerged(tenantId: number, body: ExportForPeriodTimesheetsRequest | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Timesheet/exportMerged/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportMerged(_response);
        });
    }

    protected processExportMerged(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportForPeriod(tenantId: number, projectId: number, statusId: number, userId: number, body: ExportForPeriodTimesheetsRequest | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Timesheet/exportForPeriod/{tenantId}/{projectId}/{statusId}/{userId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (statusId === undefined || statusId === null)
            throw new Error("The parameter 'statusId' must be defined.");
        url_ = url_.replace("{statusId}", encodeURIComponent("" + statusId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportForPeriod(_response);
        });
    }

    protected processExportForPeriod(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importExcel(tenantId: number, body: UploadExcelFileRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Timesheet/importExcel/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportExcel(_response);
        });
    }

    protected processImportExcel(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getImportedExcels(tenantId: number): Promise<ImportedFileResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/Timesheet/importExcel/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetImportedExcels(_response);
        });
    }

    protected processGetImportedExcels(response: Response): Promise<ImportedFileResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportedFileResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportedFileResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    deleteImportedExcel(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/Timesheet/importExcel/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteImportedExcel(_response);
        });
    }

    protected processDeleteImportedExcel(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class TimesheetRequiredFieldsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(tenantId: number, projectId: number): Promise<TimesheetRequiredFieldsResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TimesheetRequiredFields/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TimesheetRequiredFieldsResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetRequiredFieldsResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetRequiredFieldsResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: TimesheetRequiredFieldsRequest | undefined): Promise<TimesheetRequiredFieldsResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TimesheetRequiredFields/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TimesheetRequiredFieldsResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetRequiredFieldsResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetRequiredFieldsResponseSimpleResponseModel>(null as any);
    }
}

export class TimeTravelConfigClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getExpenseTypes(tenantId: number): Promise<CostExpenseTypeResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelConfig/expenseType/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExpenseTypes(_response);
        });
    }

    protected processGetExpenseTypes(response: Response): Promise<CostExpenseTypeResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostExpenseTypeResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CostExpenseTypeResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateExpenseTypes(tenantId: number, body: CostExpenseTypeDeltaRequest | undefined): Promise<CostExpenseTypeResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelConfig/expenseType/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateExpenseTypes(_response);
        });
    }

    protected processUpdateExpenseTypes(response: Response): Promise<CostExpenseTypeResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostExpenseTypeResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CostExpenseTypeResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getNonProjectCategories(tenantId: number): Promise<NonProjectCategoryResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelConfig/nonProjectCategory/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNonProjectCategories(_response);
        });
    }

    protected processGetNonProjectCategories(response: Response): Promise<NonProjectCategoryResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NonProjectCategoryResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NonProjectCategoryResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNonProjectCategories(tenantId: number, body: NonProjectCategoryDeltaRequest | undefined): Promise<NonProjectCategoryResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelConfig/nonProjectCategory/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNonProjectCategories(_response);
        });
    }

    protected processUpdateNonProjectCategories(response: Response): Promise<NonProjectCategoryResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NonProjectCategoryResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NonProjectCategoryResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getTimesheetsConfig(tenantId: number): Promise<TimesheetsConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelConfig/timesheetsConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTimesheetsConfig(_response);
        });
    }

    protected processGetTimesheetsConfig(response: Response): Promise<TimesheetsConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetsConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetsConfigResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTimesheetsConfig(tenantId: number, body: UpdateTimesheetsConfigRequest | undefined): Promise<TimesheetsConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelConfig/timesheetsConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTimesheetsConfig(_response);
        });
    }

    protected processUpdateTimesheetsConfig(response: Response): Promise<TimesheetsConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetsConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetsConfigResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getTravelCostTypes(tenantId: number): Promise<CostExpenseTypeResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelConfig/travelCostType/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTravelCostTypes(_response);
        });
    }

    protected processGetTravelCostTypes(response: Response): Promise<CostExpenseTypeResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostExpenseTypeResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CostExpenseTypeResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTravelCostTypes(tenantId: number, body: CostExpenseTypeDeltaRequest | undefined): Promise<CostExpenseTypeResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelConfig/travelCostType/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTravelCostTypes(_response);
        });
    }

    protected processUpdateTravelCostTypes(response: Response): Promise<CostExpenseTypeResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostExpenseTypeResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CostExpenseTypeResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getTravelConfig(tenantId: number): Promise<TimeTravelConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelConfig/travelConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTravelConfig(_response);
        });
    }

    protected processGetTravelConfig(response: Response): Promise<TimeTravelConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeTravelConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeTravelConfigResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTravelConfig(tenantId: number, body: UpdateTimeTravelConfigRequest | undefined): Promise<TimeTravelConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelConfig/travelConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTravelConfig(_response);
        });
    }

    protected processUpdateTravelConfig(response: Response): Promise<TimeTravelConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeTravelConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeTravelConfigResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getVacationConfig(tenantId: number): Promise<TimeTravelConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelConfig/vacationConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVacationConfig(_response);
        });
    }

    protected processGetVacationConfig(response: Response): Promise<TimeTravelConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeTravelConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeTravelConfigResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateVacationConfig(tenantId: number, body: UpdateTimeTravelConfigRequest | undefined): Promise<TimeTravelConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelConfig/vacationConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateVacationConfig(_response);
        });
    }

    protected processUpdateVacationConfig(response: Response): Promise<TimeTravelConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeTravelConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeTravelConfigResponseSimpleResponseModel>(null as any);
    }
}

export class TimeTravelDashboardClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMy(tenantId: number, body: MyTimeTravelDashboardFilterRequest | undefined): Promise<MyTimeTravelDashboardResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelDashboard/myDashboards/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMy(_response);
        });
    }

    protected processGetMy(response: Response): Promise<MyTimeTravelDashboardResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyTimeTravelDashboardResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MyTimeTravelDashboardResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    get(tenantId: number, body: ProjectTimeTravelDashboardFilterRequest | undefined): Promise<ProjectTimeTravelDashboardResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelDashboard/projectDashboard/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ProjectTimeTravelDashboardResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectTimeTravelDashboardResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectTimeTravelDashboardResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param nonProjectCategoryIds (optional) 
     * @param userIds (optional) 
     * @param partnerIds (optional) 
     * @param organizationalUnitIds (optional) 
     * @param body (optional) 
     * @return Success
     */
    getTimesheetsGenericFiltering(tenantId: number, projectIds: number[] | undefined, nonProjectCategoryIds: number[] | undefined, userIds: number[] | undefined, partnerIds: number[] | undefined, organizationalUnitIds: number[] | undefined, dateRange_From: Date, dateRange_To: Date, body: GenericFilterModelCollection | undefined): Promise<TimesheetDashboardResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelDashboard/timesheets/genericFiltering/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectIds === null)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (nonProjectCategoryIds === null)
            throw new Error("The parameter 'nonProjectCategoryIds' cannot be null.");
        else if (nonProjectCategoryIds !== undefined)
            nonProjectCategoryIds && nonProjectCategoryIds.forEach(item => { url_ += "NonProjectCategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (userIds === null)
            throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (partnerIds === null)
            throw new Error("The parameter 'partnerIds' cannot be null.");
        else if (partnerIds !== undefined)
            partnerIds && partnerIds.forEach(item => { url_ += "PartnerIds=" + encodeURIComponent("" + item) + "&"; });
        if (organizationalUnitIds === null)
            throw new Error("The parameter 'organizationalUnitIds' cannot be null.");
        else if (organizationalUnitIds !== undefined)
            organizationalUnitIds && organizationalUnitIds.forEach(item => { url_ += "OrganizationalUnitIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange_From === undefined || dateRange_From === null)
            throw new Error("The parameter 'dateRange_From' must be defined and cannot be null.");
        else
            url_ += "DateRange.From=" + encodeURIComponent(dateRange_From ? "" + formatDate(dateRange_From) : "") + "&";
        if (dateRange_To === undefined || dateRange_To === null)
            throw new Error("The parameter 'dateRange_To' must be defined and cannot be null.");
        else
            url_ += "DateRange.To=" + encodeURIComponent(dateRange_To ? "" + formatDate(dateRange_To) : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTimesheetsGenericFiltering(_response);
        });
    }

    protected processGetTimesheetsGenericFiltering(response: Response): Promise<TimesheetDashboardResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimesheetDashboardResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimesheetDashboardResponseItemsResponseModel>(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param nonProjectCategoryIds (optional) 
     * @param userIds (optional) 
     * @param partnerIds (optional) 
     * @param organizationalUnitIds (optional) 
     * @param body (optional) 
     * @return Success
     */
    getTimesheetsTotals(tenantId: number, projectIds: number[] | undefined, nonProjectCategoryIds: number[] | undefined, userIds: number[] | undefined, partnerIds: number[] | undefined, organizationalUnitIds: number[] | undefined, dateRange_From: Date, dateRange_To: Date, body: GenericFilterModelCollection | undefined): Promise<TotalTimesheetDashboardResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelDashboard/timesheets/totals/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectIds === null)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (nonProjectCategoryIds === null)
            throw new Error("The parameter 'nonProjectCategoryIds' cannot be null.");
        else if (nonProjectCategoryIds !== undefined)
            nonProjectCategoryIds && nonProjectCategoryIds.forEach(item => { url_ += "NonProjectCategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (userIds === null)
            throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (partnerIds === null)
            throw new Error("The parameter 'partnerIds' cannot be null.");
        else if (partnerIds !== undefined)
            partnerIds && partnerIds.forEach(item => { url_ += "PartnerIds=" + encodeURIComponent("" + item) + "&"; });
        if (organizationalUnitIds === null)
            throw new Error("The parameter 'organizationalUnitIds' cannot be null.");
        else if (organizationalUnitIds !== undefined)
            organizationalUnitIds && organizationalUnitIds.forEach(item => { url_ += "OrganizationalUnitIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange_From === undefined || dateRange_From === null)
            throw new Error("The parameter 'dateRange_From' must be defined and cannot be null.");
        else
            url_ += "DateRange.From=" + encodeURIComponent(dateRange_From ? "" + formatDate(dateRange_From) : "") + "&";
        if (dateRange_To === undefined || dateRange_To === null)
            throw new Error("The parameter 'dateRange_To' must be defined and cannot be null.");
        else
            url_ += "DateRange.To=" + encodeURIComponent(dateRange_To ? "" + formatDate(dateRange_To) : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTimesheetsTotals(_response);
        });
    }

    protected processGetTimesheetsTotals(response: Response): Promise<TotalTimesheetDashboardResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TotalTimesheetDashboardResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TotalTimesheetDashboardResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param nonProjectCategoryIds (optional) 
     * @param userIds (optional) 
     * @param partnerIds (optional) 
     * @param organizationalUnitIds (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportTime(tenantId: number, projectIds: number[] | undefined, nonProjectCategoryIds: number[] | undefined, userIds: number[] | undefined, partnerIds: number[] | undefined, organizationalUnitIds: number[] | undefined, dateRange_From: Date, dateRange_To: Date, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TimeTravelDashboard/exportTime/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectIds === null)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (nonProjectCategoryIds === null)
            throw new Error("The parameter 'nonProjectCategoryIds' cannot be null.");
        else if (nonProjectCategoryIds !== undefined)
            nonProjectCategoryIds && nonProjectCategoryIds.forEach(item => { url_ += "NonProjectCategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (userIds === null)
            throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (partnerIds === null)
            throw new Error("The parameter 'partnerIds' cannot be null.");
        else if (partnerIds !== undefined)
            partnerIds && partnerIds.forEach(item => { url_ += "PartnerIds=" + encodeURIComponent("" + item) + "&"; });
        if (organizationalUnitIds === null)
            throw new Error("The parameter 'organizationalUnitIds' cannot be null.");
        else if (organizationalUnitIds !== undefined)
            organizationalUnitIds && organizationalUnitIds.forEach(item => { url_ += "OrganizationalUnitIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange_From === undefined || dateRange_From === null)
            throw new Error("The parameter 'dateRange_From' must be defined and cannot be null.");
        else
            url_ += "DateRange.From=" + encodeURIComponent(dateRange_From ? "" + formatDate(dateRange_From) : "") + "&";
        if (dateRange_To === undefined || dateRange_To === null)
            throw new Error("The parameter 'dateRange_To' must be defined and cannot be null.");
        else
            url_ += "DateRange.To=" + encodeURIComponent(dateRange_To ? "" + formatDate(dateRange_To) : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportTime(_response);
        });
    }

    protected processExportTime(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param exportGrouped (optional) 
     * @param projectIds (optional) 
     * @param nonProjectCategoryIds (optional) 
     * @param userIds (optional) 
     * @param partnerIds (optional) 
     * @param organizationalUnitIds (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportTravelExpense(tenantId: number, exportGrouped: boolean | undefined, projectIds: number[] | undefined, nonProjectCategoryIds: number[] | undefined, userIds: number[] | undefined, partnerIds: number[] | undefined, organizationalUnitIds: number[] | undefined, dateRange_From: Date, dateRange_To: Date, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TimeTravelDashboard/exportTravelExpense/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (exportGrouped === null)
            throw new Error("The parameter 'exportGrouped' cannot be null.");
        else if (exportGrouped !== undefined)
            url_ += "exportGrouped=" + encodeURIComponent("" + exportGrouped) + "&";
        if (projectIds === null)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (nonProjectCategoryIds === null)
            throw new Error("The parameter 'nonProjectCategoryIds' cannot be null.");
        else if (nonProjectCategoryIds !== undefined)
            nonProjectCategoryIds && nonProjectCategoryIds.forEach(item => { url_ += "NonProjectCategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (userIds === null)
            throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (partnerIds === null)
            throw new Error("The parameter 'partnerIds' cannot be null.");
        else if (partnerIds !== undefined)
            partnerIds && partnerIds.forEach(item => { url_ += "PartnerIds=" + encodeURIComponent("" + item) + "&"; });
        if (organizationalUnitIds === null)
            throw new Error("The parameter 'organizationalUnitIds' cannot be null.");
        else if (organizationalUnitIds !== undefined)
            organizationalUnitIds && organizationalUnitIds.forEach(item => { url_ += "OrganizationalUnitIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange_From === undefined || dateRange_From === null)
            throw new Error("The parameter 'dateRange_From' must be defined and cannot be null.");
        else
            url_ += "DateRange.From=" + encodeURIComponent(dateRange_From ? "" + formatDate(dateRange_From) : "") + "&";
        if (dateRange_To === undefined || dateRange_To === null)
            throw new Error("The parameter 'dateRange_To' must be defined and cannot be null.");
        else
            url_ += "DateRange.To=" + encodeURIComponent(dateRange_To ? "" + formatDate(dateRange_To) : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportTravelExpense(_response);
        });
    }

    protected processExportTravelExpense(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param projectIds (optional) 
     * @param nonProjectCategoryIds (optional) 
     * @param userIds (optional) 
     * @param partnerIds (optional) 
     * @param organizationalUnitIds (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportVacationRequest(tenantId: number, projectIds: number[] | undefined, nonProjectCategoryIds: number[] | undefined, userIds: number[] | undefined, partnerIds: number[] | undefined, organizationalUnitIds: number[] | undefined, dateRange_From: Date, dateRange_To: Date, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TimeTravelDashboard/exportVacationRequest/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectIds === null)
            throw new Error("The parameter 'projectIds' cannot be null.");
        else if (projectIds !== undefined)
            projectIds && projectIds.forEach(item => { url_ += "ProjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (nonProjectCategoryIds === null)
            throw new Error("The parameter 'nonProjectCategoryIds' cannot be null.");
        else if (nonProjectCategoryIds !== undefined)
            nonProjectCategoryIds && nonProjectCategoryIds.forEach(item => { url_ += "NonProjectCategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (userIds === null)
            throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (partnerIds === null)
            throw new Error("The parameter 'partnerIds' cannot be null.");
        else if (partnerIds !== undefined)
            partnerIds && partnerIds.forEach(item => { url_ += "PartnerIds=" + encodeURIComponent("" + item) + "&"; });
        if (organizationalUnitIds === null)
            throw new Error("The parameter 'organizationalUnitIds' cannot be null.");
        else if (organizationalUnitIds !== undefined)
            organizationalUnitIds && organizationalUnitIds.forEach(item => { url_ += "OrganizationalUnitIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateRange_From === undefined || dateRange_From === null)
            throw new Error("The parameter 'dateRange_From' must be defined and cannot be null.");
        else
            url_ += "DateRange.From=" + encodeURIComponent(dateRange_From ? "" + formatDate(dateRange_From) : "") + "&";
        if (dateRange_To === undefined || dateRange_To === null)
            throw new Error("The parameter 'dateRange_To' must be defined and cannot be null.");
        else
            url_ += "DateRange.To=" + encodeURIComponent(dateRange_To ? "" + formatDate(dateRange_To) : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportVacationRequest(_response);
        });
    }

    protected processExportVacationRequest(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TimeTravelStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<TimeTravelStatusResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TimeTravelStatusResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeTravelStatusResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeTravelStatusResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: SimpleStatusRequestUpdateSimpleStatusRequestItems | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TimeTravelStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class TrainingCycleClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, projectId: number, offset: number | undefined, limit: number | undefined): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TrainingCycle/{tenantId}/{projectId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, projectId: number, body: TenantIsActiveDeltaRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TrainingCycle/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, projectId: number, body: GenericFilterModelCollection | undefined): Promise<TenantIsActiveResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TrainingCycle/genericFilter/{tenantId}/{projectId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<TenantIsActiveResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantIsActiveResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantIsActiveResponseItemsResponseModel>(null as any);
    }
}

export class TrainingDashboardClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    get(tenantId: number, projectId: number, cycleId: number, body: TrainingDashboardFilterRequest | undefined): Promise<TrainingDashboardResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TrainingDashboard/{tenantId}/{projectId}/{cycleId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (cycleId === undefined || cycleId === null)
            throw new Error("The parameter 'cycleId' must be defined.");
        url_ = url_.replace("{cycleId}", encodeURIComponent("" + cycleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TrainingDashboardResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingDashboardResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingDashboardResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    get2(tenantId: number, projectId: number, surveyId: number, body: SurveyDashboardFilterRequest | undefined): Promise<SurveyDashboardResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TrainingDashboard/surveys/{tenantId}/{projectId}/{surveyId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet2(_response);
        });
    }

    protected processGet2(response: Response): Promise<SurveyDashboardResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyDashboardResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SurveyDashboardResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param userIds (optional) 
     * @param projectTeamIds (optional) 
     * @param projectRoleIds (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportAverageRatings(tenantId: number, projectId: number, surveyId: number, userIds: number[] | undefined, projectTeamIds: number[] | undefined, projectRoleIds: number[] | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TrainingDashboard/exportAverageRatings/{tenantId}/{projectId}/{surveyId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (userIds === null)
            throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTeamIds === null)
            throw new Error("The parameter 'projectTeamIds' cannot be null.");
        else if (projectTeamIds !== undefined)
            projectTeamIds && projectTeamIds.forEach(item => { url_ += "ProjectTeamIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectRoleIds === null)
            throw new Error("The parameter 'projectRoleIds' cannot be null.");
        else if (projectRoleIds !== undefined)
            projectRoleIds && projectRoleIds.forEach(item => { url_ += "ProjectRoleIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAverageRatings(_response);
        });
    }

    protected processExportAverageRatings(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param userIds (optional) 
     * @param projectTeamIds (optional) 
     * @param projectRoleIds (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportQuestionGroupAverageRatings(tenantId: number, projectId: number, surveyId: number, userIds: number[] | undefined, projectTeamIds: number[] | undefined, projectRoleIds: number[] | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TrainingDashboard/exportQuestionGroupAverageRatings/{tenantId}/{projectId}/{surveyId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (userIds === null)
            throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTeamIds === null)
            throw new Error("The parameter 'projectTeamIds' cannot be null.");
        else if (projectTeamIds !== undefined)
            projectTeamIds && projectTeamIds.forEach(item => { url_ += "ProjectTeamIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectRoleIds === null)
            throw new Error("The parameter 'projectRoleIds' cannot be null.");
        else if (projectRoleIds !== undefined)
            projectRoleIds && projectRoleIds.forEach(item => { url_ += "ProjectRoleIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportQuestionGroupAverageRatings(_response);
        });
    }

    protected processExportQuestionGroupAverageRatings(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param userIds (optional) 
     * @param projectTeamIds (optional) 
     * @param projectRoleIds (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportTextAnswers(tenantId: number, projectId: number, surveyId: number, userIds: number[] | undefined, projectTeamIds: number[] | undefined, projectRoleIds: number[] | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TrainingDashboard/exportTextAnswers/{tenantId}/{projectId}/{surveyId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (userIds === null)
            throw new Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectTeamIds === null)
            throw new Error("The parameter 'projectTeamIds' cannot be null.");
        else if (projectTeamIds !== undefined)
            projectTeamIds && projectTeamIds.forEach(item => { url_ += "ProjectTeamIds=" + encodeURIComponent("" + item) + "&"; });
        if (projectRoleIds === null)
            throw new Error("The parameter 'projectRoleIds' cannot be null.");
        else if (projectRoleIds !== undefined)
            projectRoleIds && projectRoleIds.forEach(item => { url_ += "ProjectRoleIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportTextAnswers(_response);
        });
    }

    protected processExportTextAnswers(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TrainingPlanClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, projectId: number, trainingCycleId: number, body: GenericFilterModelCollection | undefined): Promise<TrainingPlanRowResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TrainingPlan/genericFilter/{tenantId}/{projectId}/{trainingCycleId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (trainingCycleId === undefined || trainingCycleId === null)
            throw new Error("The parameter 'trainingCycleId' must be defined.");
        url_ = url_.replace("{trainingCycleId}", encodeURIComponent("" + trainingCycleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<TrainingPlanRowResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingPlanRowResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingPlanRowResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setAllIsActive(tenantId: number, projectId: number, trainingCycleId: number, isActive: boolean, body: GenericFilterModelCollection | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TrainingPlan/setAll/{tenantId}/{projectId}/{trainingCycleId}/{isActive}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (trainingCycleId === undefined || trainingCycleId === null)
            throw new Error("The parameter 'trainingCycleId' must be defined.");
        url_ = url_.replace("{trainingCycleId}", encodeURIComponent("" + trainingCycleId));
        if (isActive === undefined || isActive === null)
            throw new Error("The parameter 'isActive' must be defined.");
        url_ = url_.replace("{isActive}", encodeURIComponent("" + isActive));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetAllIsActive(_response);
        });
    }

    protected processSetAllIsActive(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMy(tenantId: number, projectId: number, trainingCycleId: number, body: GenericFilterModelCollection | undefined): Promise<MyTrainingPlanResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TrainingPlan/my/genericFilter/{tenantId}/{projectId}/{trainingCycleId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (trainingCycleId === undefined || trainingCycleId === null)
            throw new Error("The parameter 'trainingCycleId' must be defined.");
        url_ = url_.replace("{trainingCycleId}", encodeURIComponent("" + trainingCycleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMy(_response);
        });
    }

    protected processGetMy(response: Response): Promise<MyTrainingPlanResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyTrainingPlanResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MyTrainingPlanResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMyStatus(tenantId: number, projectId: number, trainingCycleId: number, body: UpdateTrainingPlanStatusRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TrainingPlan/my/updateStatus/{tenantId}/{projectId}/{trainingCycleId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (trainingCycleId === undefined || trainingCycleId === null)
            throw new Error("The parameter 'trainingCycleId' must be defined.");
        url_ = url_.replace("{trainingCycleId}", encodeURIComponent("" + trainingCycleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMyStatus(_response);
        });
    }

    protected processUpdateMyStatus(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    patch(tenantId: number, projectId: number, trainingCycleId: number, body: PatchTenantIdentifyRequest | undefined): Promise<TrainingPlanRowResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TrainingPlan/{tenantId}/{projectId}/{trainingCycleId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (trainingCycleId === undefined || trainingCycleId === null)
            throw new Error("The parameter 'trainingCycleId' must be defined.");
        url_ = url_.replace("{trainingCycleId}", encodeURIComponent("" + trainingCycleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatch(_response);
        });
    }

    protected processPatch(response: Response): Promise<TrainingPlanRowResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingPlanRowResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingPlanRowResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clone(tenantId: number, projectId: number, trainingCycleId: number, body: CopyFromTrainingCycleRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TrainingPlan/clone/{tenantId}/{projectId}/{trainingCycleId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (trainingCycleId === undefined || trainingCycleId === null)
            throw new Error("The parameter 'trainingCycleId' must be defined.");
        url_ = url_.replace("{trainingCycleId}", encodeURIComponent("" + trainingCycleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClone(_response);
        });
    }

    protected processClone(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportTrainingPlans(tenantId: number, projectId: number, trainingCycleId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TrainingPlan/{tenantId}/{projectId}/{trainingCycleId}/exportTrainingPlans";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (trainingCycleId === undefined || trainingCycleId === null)
            throw new Error("The parameter 'trainingCycleId' must be defined.");
        url_ = url_.replace("{trainingCycleId}", encodeURIComponent("" + trainingCycleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportTrainingPlans(_response);
        });
    }

    protected processExportTrainingPlans(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportMyTrainingPlans(tenantId: number, projectId: number, trainingCycleId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TrainingPlan/{tenantId}/{projectId}/{trainingCycleId}/exportMyTrainingPlans";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (trainingCycleId === undefined || trainingCycleId === null)
            throw new Error("The parameter 'trainingCycleId' must be defined.");
        url_ = url_.replace("{trainingCycleId}", encodeURIComponent("" + trainingCycleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportMyTrainingPlans(_response);
        });
    }

    protected processExportMyTrainingPlans(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TrainingStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<TrainingStatusResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TrainingStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<TrainingStatusResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingStatusResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingStatusResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: SimpleStatusRequestUpdateSimpleStatusRequestItems | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TrainingStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class TravelExpenseClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllMy(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: GenericFilterModelCollection | undefined): Promise<TravelExpenseResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TravelExpense/allMy/{tenantId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMy(_response);
        });
    }

    protected processGetAllMy(response: Response): Promise<TravelExpenseResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelExpenseResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelExpenseResponseItemsResponseModel>(null as any);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllMyGenericTotals(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: GenericFilterModelCollection | undefined): Promise<TravelExpenseTotalsResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TravelExpense/allMyTotals/{tenantId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMyGenericTotals(_response);
        });
    }

    protected processGetAllMyGenericTotals(response: Response): Promise<TravelExpenseTotalsResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelExpenseTotalsResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelExpenseTotalsResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGeneric(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: GenericFilterModelCollection | undefined): Promise<TravelExpenseResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TravelExpense/allGeneric/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGeneric(_response);
        });
    }

    protected processGetAllGeneric(response: Response): Promise<TravelExpenseResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelExpenseResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelExpenseResponseItemsResponseModel>(null as any);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericTotals(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: GenericFilterModelCollection | undefined): Promise<TravelExpenseTotalsResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TravelExpense/allGenericTotals/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericTotals(_response);
        });
    }

    protected processGetAllGenericTotals(response: Response): Promise<TravelExpenseTotalsResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelExpenseTotalsResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelExpenseTotalsResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, id: number): Promise<TravelExpenseResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TravelExpense/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TravelExpenseResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelExpenseResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelExpenseResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TravelExpense/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, body: InsertTravelExpenseRequest | undefined): Promise<TravelExpenseResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TravelExpense/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<TravelExpenseResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelExpenseResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelExpenseResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: UpdateTravelExpenseRequest | undefined): Promise<TravelExpenseResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TravelExpense/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TravelExpenseResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelExpenseResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelExpenseResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    releaseMy(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TravelExpense/releaseMy/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReleaseMy(_response);
        });
    }

    protected processReleaseMy(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approval(tenantId: number, id: number, body: ApprovalTimeTravelDescriptiveRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TravelExpense/approval/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproval(_response);
        });
    }

    protected processApproval(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    clone(tenantId: number, id: number): Promise<TravelExpenseResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TravelExpense/{tenantId}/{id}/clone";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClone(_response);
        });
    }

    protected processClone(response: Response): Promise<TravelExpenseResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelExpenseResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelExpenseResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    downloadAttachment(tenantId: number, travelExpenseItemId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TravelExpense/attachment/{tenantId}/{travelExpenseItemId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (travelExpenseItemId === undefined || travelExpenseItemId === null)
            throw new Error("The parameter 'travelExpenseItemId' must be defined.");
        url_ = url_.replace("{travelExpenseItemId}", encodeURIComponent("" + travelExpenseItemId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadAttachment(_response);
        });
    }

    protected processDownloadAttachment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TravelExpense/{tenantId}/exportAll?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TravelRequestClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllMyGeneric(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: GenericFilterModelCollection | undefined): Promise<TravelRequestResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TravelRequest/allMyGeneric/{tenantId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMyGeneric(_response);
        });
    }

    protected processGetAllMyGeneric(response: Response): Promise<TravelRequestResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelRequestResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelRequestResponseItemsResponseModel>(null as any);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllMyGenericTotals(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: GenericFilterModelCollection | undefined): Promise<TravelRequestTotalsResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TravelRequest/allMyGenericTotals/{tenantId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMyGenericTotals(_response);
        });
    }

    protected processGetAllMyGenericTotals(response: Response): Promise<TravelRequestTotalsResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelRequestTotalsResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelRequestTotalsResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAllMy(tenantId: number): Promise<TravelRequestResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TravelRequest/allMy/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMy(_response);
        });
    }

    protected processGetAllMy(response: Response): Promise<TravelRequestResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelRequestResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelRequestResponseItemsResponseModel>(null as any);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGeneric(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: GenericFilterModelCollection | undefined): Promise<TravelRequestResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/TravelRequest/allGeneric/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGeneric(_response);
        });
    }

    protected processGetAllGeneric(response: Response): Promise<TravelRequestResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelRequestResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelRequestResponseItemsResponseModel>(null as any);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGenericTotals(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: GenericFilterModelCollection | undefined): Promise<TravelRequestTotalsResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TravelRequest/allGenericTotals/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericTotals(_response);
        });
    }

    protected processGetAllGenericTotals(response: Response): Promise<TravelRequestTotalsResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelRequestTotalsResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelRequestTotalsResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, id: number): Promise<TravelRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TravelRequest/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TravelRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TravelRequest/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, body: InsertTravelRequestRequest | undefined): Promise<TravelRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TravelRequest/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<TravelRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: UpdateTravelRequestRequest | undefined): Promise<TravelRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/TravelRequest/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<TravelRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    releaseMy(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TravelRequest/releaseMy/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReleaseMy(_response);
        });
    }

    protected processReleaseMy(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approval(tenantId: number, id: number, body: ApprovalTimeTravelDescriptiveRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/TravelRequest/approval/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproval(_response);
        });
    }

    protected processApproval(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TravelRequest/{tenantId}/exportAll?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UserClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(tenantId: number, body: InsertUserRequestModel | undefined): Promise<UserModelSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/User/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<UserModelSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModelSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModelSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: UpdateUserDataRequestModel | undefined): Promise<UserModelSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/User/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<UserModelSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModelSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModelSimpleResponseModel>(null as any);
    }

    /**
     * @param ids (optional) 
     * @param roleId (optional) 
     * @param search (optional) 
     * @param isActive (optional) 
     * @param sort (optional) 
     * @param offset (optional) 
     * @param limit (optional) 
     * @return Success
     */
    getAll(tenantId: number, ids: number[] | undefined, roleId: number | undefined, search: string | undefined, isActive: boolean | undefined, sort: boolean | undefined, offset: number | undefined, limit: number | undefined): Promise<UserModelItemsResponseModel> {
        let url_ = this.baseUrl + "/api/User/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<UserModelItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModelItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModelItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfile(tenantId: number, body: MyProfileUpdateRequestModel | undefined): Promise<UserModelSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/User/myprofile/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProfile(_response);
        });
    }

    protected processUpdateProfile(response: Response): Promise<UserModelSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModelSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModelSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getMyProfile(tenantId: number): Promise<UserModelSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/User/myprofile/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMyProfile(_response);
        });
    }

    protected processGetMyProfile(response: Response): Promise<UserModelSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModelSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModelSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLanguage(tenantId: number, body: LanguagesEnum | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/User/mylanguage/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLanguage(_response);
        });
    }

    protected processUpdateLanguage(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePicture(tenantId: number, body: UpdateUserPictureRequestModel | undefined): Promise<StringSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/User/picture/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePicture(_response);
        });
    }

    protected processUpdatePicture(response: Response): Promise<StringSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePassword(tenantId: number, body: ChangePasswordRequestModel | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/User/password/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePassword(_response);
        });
    }

    protected processUpdatePassword(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateActivity(tenantId: number, body: UpdateUserActivityRequestModel | undefined): Promise<BooleanSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/User/activity/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateActivity(_response);
        });
    }

    protected processUpdateActivity(response: Response): Promise<BooleanSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllGenericFilter(tenantId: number, body: GenericFilterModelCollection | undefined): Promise<UserModelItemsResponseModel> {
        let url_ = this.baseUrl + "/api/User/{tenantId}/genericFilter";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGenericFilter(_response);
        });
    }

    protected processGetAllGenericFilter(response: Response): Promise<UserModelItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModelItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModelItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, id: number): Promise<UserModelSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/User/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<UserModelSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModelSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModelSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkUserExists(body: CheckUserExistsRequestModel | undefined): Promise<CheckUserExistsReponseModelSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/User/exists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckUserExists(_response);
        });
    }

    protected processCheckUserExists(response: Response): Promise<CheckUserExistsReponseModelSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckUserExistsReponseModelSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckUserExistsReponseModelSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getAllSiteAdmins(tenantId: number): Promise<UserModelItemsResponseModel> {
        let url_ = this.baseUrl + "/api/User/admins/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSiteAdmins(_response);
        });
    }

    protected processGetAllSiteAdmins(response: Response): Promise<UserModelItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModelItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModelItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    setUserAsSiteAdmin(tenantId: number, userId: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/User/setAdmin/{tenantId}/{userId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetUserAsSiteAdmin(_response);
        });
    }

    protected processSetUserAsSiteAdmin(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    setSiteAdminAsCompanyUser(tenantId: number, userId: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/User/removeAdmin/{tenantId}/{userId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetSiteAdminAsCompanyUser(_response);
        });
    }

    protected processSetSiteAdminAsCompanyUser(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    export(tenantId: number, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/{tenantId}/export";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getActiveUsersForPeriod(tenantId: number, body: ActivityPeriodRequest | undefined): Promise<UserModelItemsResponseModel> {
        let url_ = this.baseUrl + "/api/User/getActiveUsersForPeriod/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveUsersForPeriod(_response);
        });
    }

    protected processGetActiveUsersForPeriod(response: Response): Promise<UserModelItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModelItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModelItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getCurrentActiveUsers(tenantId: number): Promise<UserModelItemsResponseModel> {
        let url_ = this.baseUrl + "/api/User/getCurrentActiveUsers/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentActiveUsers(_response);
        });
    }

    protected processGetCurrentActiveUsers(response: Response): Promise<UserModelItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModelItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModelItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getActiveTeamMembersForPeriod(tenantId: number, body: ActivityPeriodRequest | undefined): Promise<SimpleUserIdProjectIdPairItemsResponseModel> {
        let url_ = this.baseUrl + "/api/User/getActiveTeamMembersForPeriod/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveTeamMembersForPeriod(_response);
        });
    }

    protected processGetActiveTeamMembersForPeriod(response: Response): Promise<SimpleUserIdProjectIdPairItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimpleUserIdProjectIdPairItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimpleUserIdProjectIdPairItemsResponseModel>(null as any);
    }
}

export class UserAlertConfigurationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<UserAlertConfigurationResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/UserAlertConfiguration/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<UserAlertConfigurationResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAlertConfigurationResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAlertConfigurationResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUpdate(tenantId: number, body: AddUpdateUserAlertConfigurationsRequest | undefined): Promise<UserAlertConfigurationResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/UserAlertConfiguration/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddUpdate(_response);
        });
    }

    protected processAddUpdate(response: Response): Promise<UserAlertConfigurationResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAlertConfigurationResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAlertConfigurationResponseItemsResponseModel>(null as any);
    }
}

export class UserStatusClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(tenantId: number): Promise<UserStatusResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/UserStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<UserStatusResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserStatusResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserStatusResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: SimpleStatusRequestUpdateSimpleStatusRequestItems | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/UserStatus/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class UserTableViewConfigClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAll(tenantId: number, body: UserTableViewConfigFilter | undefined): Promise<UserTableViewConfigResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/UserTableViewConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<UserTableViewConfigResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTableViewConfigResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserTableViewConfigResponseItemsResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, body: InsertUpdateUserTableViewConfigRequest | undefined): Promise<UserTableViewConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/UserTableViewConfig/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<UserTableViewConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTableViewConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserTableViewConfigResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, viewType: string): Promise<UserTableViewConfigResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/UserTableViewConfig/{tenantId}/{viewType}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (viewType === undefined || viewType === null)
            throw new Error("The parameter 'viewType' must be defined.");
        url_ = url_.replace("{viewType}", encodeURIComponent("" + viewType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<UserTableViewConfigResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTableViewConfigResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserTableViewConfigResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, viewType: string): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/UserTableViewConfig/{tenantId}/{viewType}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (viewType === undefined || viewType === null)
            throw new Error("The parameter 'viewType' must be defined.");
        url_ = url_.replace("{viewType}", encodeURIComponent("" + viewType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class VacationRequestClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllMyGeneric(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: GenericFilterModelCollection | undefined): Promise<VacationRequestResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/VacationRequest/allMyGeneric/{tenantId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMyGeneric(_response);
        });
    }

    protected processGetAllMyGeneric(response: Response): Promise<VacationRequestResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VacationRequestResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VacationRequestResponseItemsResponseModel>(null as any);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    getAllGeneric(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: GenericFilterModelCollection | undefined): Promise<VacationRequestStatusFullResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/VacationRequest/allGeneric/{tenantId}/genericFilter?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllGeneric(_response);
        });
    }

    protected processGetAllGeneric(response: Response): Promise<VacationRequestStatusFullResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VacationRequestStatusFullResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VacationRequestStatusFullResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getVacationRequestStatus(tenantId: number, id: number): Promise<VacationRequestStatusResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/VacationRequest/vacationRequestStatus/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVacationRequestStatus(_response);
        });
    }

    protected processGetVacationRequestStatus(response: Response): Promise<VacationRequestStatusResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VacationRequestStatusResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VacationRequestStatusResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    get(tenantId: number, id: number): Promise<VacationRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/VacationRequest/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<VacationRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VacationRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VacationRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    delete(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/VacationRequest/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(tenantId: number, body: InsertVacationRequestRequest | undefined): Promise<VacationRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/VacationRequest/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<VacationRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VacationRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VacationRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(tenantId: number, body: UpdateVacationRequestRequest | undefined): Promise<VacationRequestResponseSimpleResponseModel> {
        let url_ = this.baseUrl + "/api/VacationRequest/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<VacationRequestResponseSimpleResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VacationRequestResponseSimpleResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VacationRequestResponseSimpleResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    releaseMy(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/VacationRequest/releaseMy/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReleaseMy(_response);
        });
    }

    protected processReleaseMy(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approval(tenantId: number, vacationRequestStatusId: number, body: ApprovalTimeTravelDescriptiveRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/VacationRequest/approval/{tenantId}/{vacationRequestStatusId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (vacationRequestStatusId === undefined || vacationRequestStatusId === null)
            throw new Error("The parameter 'vacationRequestStatusId' must be defined.");
        url_ = url_.replace("{vacationRequestStatusId}", encodeURIComponent("" + vacationRequestStatusId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproval(_response);
        });
    }

    protected processApproval(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @param years (optional) 
     * @param months (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportAll(tenantId: number, years: number[] | undefined, months: MonthEnum[] | undefined, body: ExportDataModel | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/VacationRequest/{tenantId}/exportVacations?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (years === null)
            throw new Error("The parameter 'years' cannot be null.");
        else if (years !== undefined)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (months === null)
            throw new Error("The parameter 'months' cannot be null.");
        else if (months !== undefined)
            months && months.forEach(item => { url_ += "months=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportAll(_response);
        });
    }

    protected processExportAll(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = BaseResponseModel.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importExcel(tenantId: number, body: UploadExcelFileRequest | undefined): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/VacationRequest/importExcel/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportExcel(_response);
        });
    }

    protected processImportExcel(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    getImportedExcels(tenantId: number): Promise<ImportedFileResponseItemsResponseModel> {
        let url_ = this.baseUrl + "/api/VacationRequest/importExcel/{tenantId}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetImportedExcels(_response);
        });
    }

    protected processGetImportedExcels(response: Response): Promise<ImportedFileResponseItemsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportedFileResponseItemsResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportedFileResponseItemsResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    deleteImportedExcel(tenantId: number, id: number): Promise<BaseResponseModel> {
        let url_ = this.baseUrl + "/api/VacationRequest/importExcel/{tenantId}/{id}";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteImportedExcel(_response);
        });
    }

    protected processDeleteImportedExcel(response: Response): Promise<BaseResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = BaseResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaseResponseModel>(null as any);
    }
}

export class ActiveModule implements IActiveModule {
    id!: ModuleActivityEnum;
    isActive!: boolean;

    constructor(data?: IActiveModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ActiveModule {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveModule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IActiveModule {
    id: ModuleActivityEnum;
    isActive: boolean;
}

export class ActivityPeriodRequest implements IActivityPeriodRequest {
    from!: Date;
    to!: Date;

    constructor(data?: IActivityPeriodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ActivityPeriodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityPeriodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        return data;
    }
}

export interface IActivityPeriodRequest {
    from: Date;
    to: Date;
}

export class ActualBudgetResponse implements IActualBudgetResponse {
    income!: number;
    expense!: number;
    readonly profit!: number;

    constructor(data?: IActualBudgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.income = _data["income"];
            this.expense = _data["expense"];
            (this as any).profit = _data["profit"];
        }
    }

    static fromJS(data: any): ActualBudgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActualBudgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["income"] = this.income;
        data["expense"] = this.expense;
        data["profit"] = this.profit;
        return data;
    }
}

export interface IActualBudgetResponse {
    income: number;
    expense: number;
    profit: number;
}

export class AddEmailTemplateRequestModel implements IAddEmailTemplateRequestModel {
    name?: string | undefined;

    constructor(data?: IAddEmailTemplateRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AddEmailTemplateRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddEmailTemplateRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IAddEmailTemplateRequestModel {
    name?: string | undefined;
}

export class AddUpdateEmailTemplateDataRequestModel implements IAddUpdateEmailTemplateDataRequestModel {
    id!: number;
    languageId!: number;
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: IAddUpdateEmailTemplateDataRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.languageId = _data["languageId"];
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): AddUpdateEmailTemplateDataRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddUpdateEmailTemplateDataRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["languageId"] = this.languageId;
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface IAddUpdateEmailTemplateDataRequestModel {
    id: number;
    languageId: number;
    subject?: string | undefined;
    body?: string | undefined;
}

export class AddUpdateUserAlertConfigurationsRequest implements IAddUpdateUserAlertConfigurationsRequest {
    addedItems?: AddUserAlertConfigurationRequest[] | undefined;
    updatedItems?: UpdateUserAlertConfigurationRequest[] | undefined;

    constructor(data?: IAddUpdateUserAlertConfigurationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["addedItems"])) {
                this.addedItems = [] as any;
                for (let item of _data["addedItems"])
                    this.addedItems!.push(AddUserAlertConfigurationRequest.fromJS(item));
            }
            if (Array.isArray(_data["updatedItems"])) {
                this.updatedItems = [] as any;
                for (let item of _data["updatedItems"])
                    this.updatedItems!.push(UpdateUserAlertConfigurationRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddUpdateUserAlertConfigurationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUpdateUserAlertConfigurationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.addedItems)) {
            data["addedItems"] = [];
            for (let item of this.addedItems)
                data["addedItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.updatedItems)) {
            data["updatedItems"] = [];
            for (let item of this.updatedItems)
                data["updatedItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAddUpdateUserAlertConfigurationsRequest {
    addedItems?: AddUserAlertConfigurationRequest[] | undefined;
    updatedItems?: UpdateUserAlertConfigurationRequest[] | undefined;
}

export class AddUserAlertConfigurationRequest implements IAddUserAlertConfigurationRequest {
    enabled!: boolean;
    sendEmail!: boolean;
    entityIds?: number[] | undefined;
    entity!: AlertEntitiesEnum;
    trigger!: AlertTriggersEnum;

    constructor(data?: IAddUserAlertConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.sendEmail = _data["sendEmail"];
            if (Array.isArray(_data["entityIds"])) {
                this.entityIds = [] as any;
                for (let item of _data["entityIds"])
                    this.entityIds!.push(item);
            }
            this.entity = _data["entity"];
            this.trigger = _data["trigger"];
        }
    }

    static fromJS(data: any): AddUserAlertConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserAlertConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["sendEmail"] = this.sendEmail;
        if (Array.isArray(this.entityIds)) {
            data["entityIds"] = [];
            for (let item of this.entityIds)
                data["entityIds"].push(item);
        }
        data["entity"] = this.entity;
        data["trigger"] = this.trigger;
        return data;
    }
}

export interface IAddUserAlertConfigurationRequest {
    enabled: boolean;
    sendEmail: boolean;
    entityIds?: number[] | undefined;
    entity: AlertEntitiesEnum;
    trigger: AlertTriggersEnum;
}

export enum AlertEntitiesEnum {
    TestPlan = "TestPlan",
    Ticket = "Ticket",
    ChangeRequest = "ChangeRequest",
    TimeSheets = "TimeSheets",
    Expense = "Expense",
    Vacation = "Vacation",
    Reminder = "Reminder",
    Meeting = "Meeting",
    StatusReport = "StatusReport",
    Task = "Task",
    ApprovalRequest = "ApprovalRequest",
}

export class AlertResponse implements IAlertResponse {
    id!: number;
    tenantId!: number;
    userId!: number;
    entity!: AlertEntitiesEnum;
    trigger!: AlertTriggersEnum;
    initiatorUserId!: number;
    entityId?: number | undefined;
    additionalData?: string | undefined;
    seen!: boolean;

    constructor(data?: IAlertResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.entity = _data["entity"];
            this.trigger = _data["trigger"];
            this.initiatorUserId = _data["initiatorUserId"];
            this.entityId = _data["entityId"];
            this.additionalData = _data["additionalData"];
            this.seen = _data["seen"];
        }
    }

    static fromJS(data: any): AlertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AlertResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["entity"] = this.entity;
        data["trigger"] = this.trigger;
        data["initiatorUserId"] = this.initiatorUserId;
        data["entityId"] = this.entityId;
        data["additionalData"] = this.additionalData;
        data["seen"] = this.seen;
        return data;
    }
}

export interface IAlertResponse {
    id: number;
    tenantId: number;
    userId: number;
    entity: AlertEntitiesEnum;
    trigger: AlertTriggersEnum;
    initiatorUserId: number;
    entityId?: number | undefined;
    additionalData?: string | undefined;
    seen: boolean;
}

export class AlertResponseItemsResponseModel implements IAlertResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: AlertResponse[] | undefined;

    constructor(data?: IAlertResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AlertResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlertResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AlertResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAlertResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: AlertResponse[] | undefined;
}

export enum AlertTriggersEnum {
    Created = "Created",
    Updated = "Updated",
    Deleted = "Deleted",
    Submitted = "Submitted",
    Approved = "Approved",
    Rejected = "Rejected",
    Automatic = "Automatic",
    Released = "Released",
    Aligned = "Aligned",
}

export class ApprovalRequestResponse implements IApprovalRequestResponse {
    id!: number;
    type!: ApprovalRequestTypeEnum;
    status!: ApprovalRequestStatusEnum;
    requesterUserId!: number;
    createdAt!: Date;
    resolvedByUserId?: number | undefined;
    resolvedAt?: Date | undefined;
    rejectionComment?: string | undefined;
    createdEntityId?: number | undefined;
    isDismissed!: boolean;
    projectName?: string | undefined;
    projectManagerUserId?: number | undefined;
    projectFrom?: Date | undefined;
    projectTo?: Date | undefined;
    memberValidUntil?: Date | undefined;
    partnerName?: string | undefined;
    city?: string | undefined;
    address?: string | undefined;
    countryId?: number | undefined;
    contactPerson?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    regNo?: string | undefined;
    vatNo?: string | undefined;
    iban?: string | undefined;
    swift?: string | undefined;
    projectId?: number | undefined;
    projectTeamId?: number | undefined;
    projectTeamName?: string | undefined;
    projectRoleId?: number | undefined;
    projectRoleName?: string | undefined;

    constructor(data?: IApprovalRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.requesterUserId = _data["requesterUserId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.resolvedByUserId = _data["resolvedByUserId"];
            this.resolvedAt = _data["resolvedAt"] ? new Date(_data["resolvedAt"].toString()) : undefined as any;
            this.rejectionComment = _data["rejectionComment"];
            this.createdEntityId = _data["createdEntityId"];
            this.isDismissed = _data["isDismissed"];
            this.projectName = _data["projectName"];
            this.projectManagerUserId = _data["projectManagerUserId"];
            this.projectFrom = _data["projectFrom"] ? new Date(_data["projectFrom"].toString()) : undefined as any;
            this.projectTo = _data["projectTo"] ? new Date(_data["projectTo"].toString()) : undefined as any;
            this.memberValidUntil = _data["memberValidUntil"] ? new Date(_data["memberValidUntil"].toString()) : undefined as any;
            this.partnerName = _data["partnerName"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.countryId = _data["countryId"];
            this.contactPerson = _data["contactPerson"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.regNo = _data["regNo"];
            this.vatNo = _data["vatNo"];
            this.iban = _data["iban"];
            this.swift = _data["swift"];
            this.projectId = _data["projectId"];
            this.projectTeamId = _data["projectTeamId"];
            this.projectTeamName = _data["projectTeamName"];
            this.projectRoleId = _data["projectRoleId"];
            this.projectRoleName = _data["projectRoleName"];
        }
    }

    static fromJS(data: any): ApprovalRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["status"] = this.status;
        data["requesterUserId"] = this.requesterUserId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["resolvedByUserId"] = this.resolvedByUserId;
        data["resolvedAt"] = this.resolvedAt ? this.resolvedAt.toISOString() : undefined as any;
        data["rejectionComment"] = this.rejectionComment;
        data["createdEntityId"] = this.createdEntityId;
        data["isDismissed"] = this.isDismissed;
        data["projectName"] = this.projectName;
        data["projectManagerUserId"] = this.projectManagerUserId;
        data["projectFrom"] = this.projectFrom ? formatDate(this.projectFrom) : undefined as any;
        data["projectTo"] = this.projectTo ? formatDate(this.projectTo) : undefined as any;
        data["memberValidUntil"] = this.memberValidUntil ? formatDate(this.memberValidUntil) : undefined as any;
        data["partnerName"] = this.partnerName;
        data["city"] = this.city;
        data["address"] = this.address;
        data["countryId"] = this.countryId;
        data["contactPerson"] = this.contactPerson;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["regNo"] = this.regNo;
        data["vatNo"] = this.vatNo;
        data["iban"] = this.iban;
        data["swift"] = this.swift;
        data["projectId"] = this.projectId;
        data["projectTeamId"] = this.projectTeamId;
        data["projectTeamName"] = this.projectTeamName;
        data["projectRoleId"] = this.projectRoleId;
        data["projectRoleName"] = this.projectRoleName;
        return data;
    }
}

export interface IApprovalRequestResponse {
    id: number;
    type: ApprovalRequestTypeEnum;
    status: ApprovalRequestStatusEnum;
    requesterUserId: number;
    createdAt: Date;
    resolvedByUserId?: number | undefined;
    resolvedAt?: Date | undefined;
    rejectionComment?: string | undefined;
    createdEntityId?: number | undefined;
    isDismissed: boolean;
    projectName?: string | undefined;
    projectManagerUserId?: number | undefined;
    projectFrom?: Date | undefined;
    projectTo?: Date | undefined;
    memberValidUntil?: Date | undefined;
    partnerName?: string | undefined;
    city?: string | undefined;
    address?: string | undefined;
    countryId?: number | undefined;
    contactPerson?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    regNo?: string | undefined;
    vatNo?: string | undefined;
    iban?: string | undefined;
    swift?: string | undefined;
    projectId?: number | undefined;
    projectTeamId?: number | undefined;
    projectTeamName?: string | undefined;
    projectRoleId?: number | undefined;
    projectRoleName?: string | undefined;
}

export class ApprovalRequestResponseItemsResponseModel implements IApprovalRequestResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ApprovalRequestResponse[] | undefined;

    constructor(data?: IApprovalRequestResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApprovalRequestResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApprovalRequestResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalRequestResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IApprovalRequestResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ApprovalRequestResponse[] | undefined;
}

export class ApprovalRequestResponseSimpleResponseModel implements IApprovalRequestResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ApprovalRequestResponse;

    constructor(data?: IApprovalRequestResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ApprovalRequestResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ApprovalRequestResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalRequestResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IApprovalRequestResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ApprovalRequestResponse;
}

export enum ApprovalRequestStatusEnum {
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected",
}

export enum ApprovalRequestTypeEnum {
    Project = "Project",
    Partner = "Partner",
    TeamMember = "TeamMember",
}

export class ApprovalTimesheetRequest implements IApprovalTimesheetRequest {
    approve!: boolean;
    rejectionText?: string | undefined;
    from!: Date;
    to!: Date;
    userId!: number;
    projectId!: number;
    statusId!: number;

    constructor(data?: IApprovalTimesheetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approve = _data["approve"];
            this.rejectionText = _data["rejectionText"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): ApprovalTimesheetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalTimesheetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approve"] = this.approve;
        data["rejectionText"] = this.rejectionText;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface IApprovalTimesheetRequest {
    approve: boolean;
    rejectionText?: string | undefined;
    from: Date;
    to: Date;
    userId: number;
    projectId: number;
    statusId: number;
}

export class ApprovalTimeTravelDescriptiveRequest implements IApprovalTimeTravelDescriptiveRequest {
    approve!: boolean;
    rejectionText?: string | undefined;

    constructor(data?: IApprovalTimeTravelDescriptiveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approve = _data["approve"];
            this.rejectionText = _data["rejectionText"];
        }
    }

    static fromJS(data: any): ApprovalTimeTravelDescriptiveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalTimeTravelDescriptiveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approve"] = this.approve;
        data["rejectionText"] = this.rejectionText;
        return data;
    }
}

export interface IApprovalTimeTravelDescriptiveRequest {
    approve: boolean;
    rejectionText?: string | undefined;
}

export class ApproveApprovalRequest implements IApproveApprovalRequest {
    project?: CreateProjectApprovalRequest;
    partner?: CreatePartnerApprovalRequest;
    teamMember?: UpdateTeamMemberApprovalRequest;

    constructor(data?: IApproveApprovalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? CreateProjectApprovalRequest.fromJS(_data["project"]) : undefined as any;
            this.partner = _data["partner"] ? CreatePartnerApprovalRequest.fromJS(_data["partner"]) : undefined as any;
            this.teamMember = _data["teamMember"] ? UpdateTeamMemberApprovalRequest.fromJS(_data["teamMember"]) : undefined as any;
        }
    }

    static fromJS(data: any): ApproveApprovalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveApprovalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["partner"] = this.partner ? this.partner.toJSON() : undefined as any;
        data["teamMember"] = this.teamMember ? this.teamMember.toJSON() : undefined as any;
        return data;
    }
}

export interface IApproveApprovalRequest {
    project?: CreateProjectApprovalRequest;
    partner?: CreatePartnerApprovalRequest;
    teamMember?: UpdateTeamMemberApprovalRequest;
}

export enum AttachmentAccessEnum {
    Direct = "Direct",
    Controller = "Controller",
}

export class AttachmentResponse implements IAttachmentResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    accessType!: AttachmentAccessEnum;
    uri?: string | undefined;
    contentType?: string | undefined;
    userId!: number;
    date!: Date;

    constructor(data?: IAttachmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.accessType = _data["accessType"];
            this.uri = _data["uri"];
            this.contentType = _data["contentType"];
            this.userId = _data["userId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AttachmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["accessType"] = this.accessType;
        data["uri"] = this.uri;
        data["contentType"] = this.contentType;
        data["userId"] = this.userId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }
}

export interface IAttachmentResponse {
    id: number;
    name: string;
    description?: string | undefined;
    accessType: AttachmentAccessEnum;
    uri?: string | undefined;
    contentType?: string | undefined;
    userId: number;
    date: Date;
}

export class BaseResponseModel implements IBaseResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;

    constructor(data?: IBaseResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
        }
    }

    static fromJS(data: any): BaseResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IBaseResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
}

export class BooleanSimpleResponseModel implements IBooleanSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value!: boolean;

    constructor(data?: IBooleanSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BooleanSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value;
        return data;
    }
}

export interface IBooleanSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value: boolean;
}

export class BoolNewOld implements IBoolNewOld {
    oldValue!: boolean;
    newValue!: boolean;

    constructor(data?: IBoolNewOld) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): BoolNewOld {
        data = typeof data === 'object' ? data : {};
        let result = new BoolNewOld();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IBoolNewOld {
    oldValue: boolean;
    newValue: boolean;
}

export class BudgetConfigurationResponse implements IBudgetConfigurationResponse {
    id!: number;
    planFrom!: Date;
    planTo!: Date;
    includeRiskInBudget!: boolean;
    includePlannedInvoicesInBudget!: boolean;
    includeApprovedChangeRequestsInBudget!: boolean;
    includeScheduleInBudget!: boolean;
    includeCompletedChangeRequests!: boolean;
    includeApprovedTimesheetsInActual!: boolean;
    includeApprovedGuestTimesheetsInActual!: boolean;
    includeApprovedTravelExpensesInActual!: boolean;
    includeIssuedReceivedAndPayedInvoicesInActual!: boolean;
    actualsTimesheetsPerUser!: boolean;
    actualsTravelExpensesPerUser!: boolean;
    actualsInvoicesPerPartner!: boolean;

    constructor(data?: IBudgetConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.planFrom = _data["planFrom"] ? new Date(_data["planFrom"].toString()) : undefined as any;
            this.planTo = _data["planTo"] ? new Date(_data["planTo"].toString()) : undefined as any;
            this.includeRiskInBudget = _data["includeRiskInBudget"];
            this.includePlannedInvoicesInBudget = _data["includePlannedInvoicesInBudget"];
            this.includeApprovedChangeRequestsInBudget = _data["includeApprovedChangeRequestsInBudget"];
            this.includeScheduleInBudget = _data["includeScheduleInBudget"];
            this.includeCompletedChangeRequests = _data["includeCompletedChangeRequests"];
            this.includeApprovedTimesheetsInActual = _data["includeApprovedTimesheetsInActual"];
            this.includeApprovedGuestTimesheetsInActual = _data["includeApprovedGuestTimesheetsInActual"];
            this.includeApprovedTravelExpensesInActual = _data["includeApprovedTravelExpensesInActual"];
            this.includeIssuedReceivedAndPayedInvoicesInActual = _data["includeIssuedReceivedAndPayedInvoicesInActual"];
            this.actualsTimesheetsPerUser = _data["actualsTimesheetsPerUser"];
            this.actualsTravelExpensesPerUser = _data["actualsTravelExpensesPerUser"];
            this.actualsInvoicesPerPartner = _data["actualsInvoicesPerPartner"];
        }
    }

    static fromJS(data: any): BudgetConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["planFrom"] = this.planFrom ? formatDate(this.planFrom) : undefined as any;
        data["planTo"] = this.planTo ? formatDate(this.planTo) : undefined as any;
        data["includeRiskInBudget"] = this.includeRiskInBudget;
        data["includePlannedInvoicesInBudget"] = this.includePlannedInvoicesInBudget;
        data["includeApprovedChangeRequestsInBudget"] = this.includeApprovedChangeRequestsInBudget;
        data["includeScheduleInBudget"] = this.includeScheduleInBudget;
        data["includeCompletedChangeRequests"] = this.includeCompletedChangeRequests;
        data["includeApprovedTimesheetsInActual"] = this.includeApprovedTimesheetsInActual;
        data["includeApprovedGuestTimesheetsInActual"] = this.includeApprovedGuestTimesheetsInActual;
        data["includeApprovedTravelExpensesInActual"] = this.includeApprovedTravelExpensesInActual;
        data["includeIssuedReceivedAndPayedInvoicesInActual"] = this.includeIssuedReceivedAndPayedInvoicesInActual;
        data["actualsTimesheetsPerUser"] = this.actualsTimesheetsPerUser;
        data["actualsTravelExpensesPerUser"] = this.actualsTravelExpensesPerUser;
        data["actualsInvoicesPerPartner"] = this.actualsInvoicesPerPartner;
        return data;
    }
}

export interface IBudgetConfigurationResponse {
    id: number;
    planFrom: Date;
    planTo: Date;
    includeRiskInBudget: boolean;
    includePlannedInvoicesInBudget: boolean;
    includeApprovedChangeRequestsInBudget: boolean;
    includeScheduleInBudget: boolean;
    includeCompletedChangeRequests: boolean;
    includeApprovedTimesheetsInActual: boolean;
    includeApprovedGuestTimesheetsInActual: boolean;
    includeApprovedTravelExpensesInActual: boolean;
    includeIssuedReceivedAndPayedInvoicesInActual: boolean;
    actualsTimesheetsPerUser: boolean;
    actualsTravelExpensesPerUser: boolean;
    actualsInvoicesPerPartner: boolean;
}

export class BudgetConfigurationResponseSimpleResponseModel implements IBudgetConfigurationResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: BudgetConfigurationResponse;

    constructor(data?: IBudgetConfigurationResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? BudgetConfigurationResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): BudgetConfigurationResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetConfigurationResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IBudgetConfigurationResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: BudgetConfigurationResponse;
}

export class BudgetDateValueHeaderResponse implements IBudgetDateValueHeaderResponse {
    date!: Date;
    title!: string;

    constructor(data?: IBudgetDateValueHeaderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): BudgetDateValueHeaderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetDateValueHeaderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["title"] = this.title;
        return data;
    }
}

export interface IBudgetDateValueHeaderResponse {
    date: Date;
    title: string;
}

export class BudgetDateValueHeaderResponseItemsResponseModel implements IBudgetDateValueHeaderResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: BudgetDateValueHeaderResponse[] | undefined;

    constructor(data?: IBudgetDateValueHeaderResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BudgetDateValueHeaderResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetDateValueHeaderResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetDateValueHeaderResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBudgetDateValueHeaderResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: BudgetDateValueHeaderResponse[] | undefined;
}

export class BudgetDateValueRequest implements IBudgetDateValueRequest {
    date!: Date;
    value!: number;

    constructor(data?: IBudgetDateValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BudgetDateValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetDateValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["value"] = this.value;
        return data;
    }
}

export interface IBudgetDateValueRequest {
    date: Date;
    value: number;
}

export class BudgetDateValueResponse implements IBudgetDateValueResponse {
    date!: Date;
    value!: number;

    constructor(data?: IBudgetDateValueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BudgetDateValueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetDateValueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["value"] = this.value;
        return data;
    }
}

export interface IBudgetDateValueResponse {
    date: Date;
    value: number;
}

export class BudgetRowDeltaRequest implements IBudgetRowDeltaRequest {
    insert?: InsertBudgetRowRequest[] | undefined;
    update?: UpdateBudgetRowRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;

    constructor(data?: IBudgetRowDeltaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertBudgetRowRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateBudgetRowRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteTenantIndetifyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetRowDeltaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetRowDeltaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBudgetRowDeltaRequest {
    insert?: InsertBudgetRowRequest[] | undefined;
    update?: UpdateBudgetRowRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;
}

export class BudgetRowResponse implements IBudgetRowResponse {
    id!: number;
    financeCategoryId!: number;
    versionId?: number | undefined;
    userId?: number | undefined;
    partnerId?: number | undefined;
    changeRequestId?: number | undefined;
    projectTeamId?: number | undefined;
    incomeExpense!: IncomeExpenseEnum;
    customField?: string | undefined;
    readonly isChangeable!: boolean;
    isIncomeExpenseChangeable!: boolean;
    budgetDateValues?: BudgetDateValueResponse[] | undefined;

    constructor(data?: IBudgetRowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.financeCategoryId = _data["financeCategoryId"];
            this.versionId = _data["versionId"];
            this.userId = _data["userId"];
            this.partnerId = _data["partnerId"];
            this.changeRequestId = _data["changeRequestId"];
            this.projectTeamId = _data["projectTeamId"];
            this.incomeExpense = _data["incomeExpense"];
            this.customField = _data["customField"];
            (this as any).isChangeable = _data["isChangeable"];
            this.isIncomeExpenseChangeable = _data["isIncomeExpenseChangeable"];
            if (Array.isArray(_data["budgetDateValues"])) {
                this.budgetDateValues = [] as any;
                for (let item of _data["budgetDateValues"])
                    this.budgetDateValues!.push(BudgetDateValueResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetRowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetRowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["financeCategoryId"] = this.financeCategoryId;
        data["versionId"] = this.versionId;
        data["userId"] = this.userId;
        data["partnerId"] = this.partnerId;
        data["changeRequestId"] = this.changeRequestId;
        data["projectTeamId"] = this.projectTeamId;
        data["incomeExpense"] = this.incomeExpense;
        data["customField"] = this.customField;
        data["isChangeable"] = this.isChangeable;
        data["isIncomeExpenseChangeable"] = this.isIncomeExpenseChangeable;
        if (Array.isArray(this.budgetDateValues)) {
            data["budgetDateValues"] = [];
            for (let item of this.budgetDateValues)
                data["budgetDateValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBudgetRowResponse {
    id: number;
    financeCategoryId: number;
    versionId?: number | undefined;
    userId?: number | undefined;
    partnerId?: number | undefined;
    changeRequestId?: number | undefined;
    projectTeamId?: number | undefined;
    incomeExpense: IncomeExpenseEnum;
    customField?: string | undefined;
    isChangeable: boolean;
    isIncomeExpenseChangeable: boolean;
    budgetDateValues?: BudgetDateValueResponse[] | undefined;
}

export class BudgetRowResponseItemsResponseModel implements IBudgetRowResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: BudgetRowResponse[] | undefined;

    constructor(data?: IBudgetRowResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BudgetRowResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetRowResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetRowResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBudgetRowResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: BudgetRowResponse[] | undefined;
}

export enum BudgetStatusEnum {
    Created = "Created",
    Released = "Released",
}

export class BudgetStatusResponse implements IBudgetStatusResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isReadonly!: boolean;
    color!: string;
    isInitial!: boolean;
    nextStates?: number[] | undefined;
    order!: number;
    semantics!: BudgetStatusEnum;

    constructor(data?: IBudgetStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isReadonly = _data["isReadonly"];
            this.color = _data["color"];
            this.isInitial = _data["isInitial"];
            if (Array.isArray(_data["nextStates"])) {
                this.nextStates = [] as any;
                for (let item of _data["nextStates"])
                    this.nextStates!.push(item);
            }
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): BudgetStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isReadonly"] = this.isReadonly;
        data["color"] = this.color;
        data["isInitial"] = this.isInitial;
        if (Array.isArray(this.nextStates)) {
            data["nextStates"] = [];
            for (let item of this.nextStates)
                data["nextStates"].push(item);
        }
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IBudgetStatusResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isReadonly: boolean;
    color: string;
    isInitial: boolean;
    nextStates?: number[] | undefined;
    order: number;
    semantics: BudgetStatusEnum;
}

export class BudgetStatusResponseItemsResponseModel implements IBudgetStatusResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: BudgetStatusResponse[] | undefined;

    constructor(data?: IBudgetStatusResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BudgetStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetStatusResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetStatusResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBudgetStatusResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: BudgetStatusResponse[] | undefined;
}

export class BudgetVsActualDashboardResponse implements IBudgetVsActualDashboardResponse {
    budgetIncome!: number;
    actualBudgetIncome!: number;
    readonly differenceIncome!: number;
    budgetExpense!: number;
    actualBudgetExpense!: number;
    readonly differenceExpense!: number;
    readonly budgetProfit!: number;
    readonly budgetProfitPercent!: number;
    readonly actualBudgetProfit!: number;
    readonly actualBudgetProfitPercent!: number;
    readonly differenceProfit!: number;
    budgetVsActualProjectRows?: BudgetVsActualFullRowDashboardResponse[] | undefined;
    budgetVsActualCategoryRows?: BudgetVsActualFullRowDashboardResponse[] | undefined;
    budgetVsActualCategoryAndProjectRows?: BudgetVsActualFullRowDashboardResponse[] | undefined;

    constructor(data?: IBudgetVsActualDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetIncome = _data["budgetIncome"];
            this.actualBudgetIncome = _data["actualBudgetIncome"];
            (this as any).differenceIncome = _data["differenceIncome"];
            this.budgetExpense = _data["budgetExpense"];
            this.actualBudgetExpense = _data["actualBudgetExpense"];
            (this as any).differenceExpense = _data["differenceExpense"];
            (this as any).budgetProfit = _data["budgetProfit"];
            (this as any).budgetProfitPercent = _data["budgetProfitPercent"];
            (this as any).actualBudgetProfit = _data["actualBudgetProfit"];
            (this as any).actualBudgetProfitPercent = _data["actualBudgetProfitPercent"];
            (this as any).differenceProfit = _data["differenceProfit"];
            if (Array.isArray(_data["budgetVsActualProjectRows"])) {
                this.budgetVsActualProjectRows = [] as any;
                for (let item of _data["budgetVsActualProjectRows"])
                    this.budgetVsActualProjectRows!.push(BudgetVsActualFullRowDashboardResponse.fromJS(item));
            }
            if (Array.isArray(_data["budgetVsActualCategoryRows"])) {
                this.budgetVsActualCategoryRows = [] as any;
                for (let item of _data["budgetVsActualCategoryRows"])
                    this.budgetVsActualCategoryRows!.push(BudgetVsActualFullRowDashboardResponse.fromJS(item));
            }
            if (Array.isArray(_data["budgetVsActualCategoryAndProjectRows"])) {
                this.budgetVsActualCategoryAndProjectRows = [] as any;
                for (let item of _data["budgetVsActualCategoryAndProjectRows"])
                    this.budgetVsActualCategoryAndProjectRows!.push(BudgetVsActualFullRowDashboardResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetVsActualDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetVsActualDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetIncome"] = this.budgetIncome;
        data["actualBudgetIncome"] = this.actualBudgetIncome;
        data["differenceIncome"] = this.differenceIncome;
        data["budgetExpense"] = this.budgetExpense;
        data["actualBudgetExpense"] = this.actualBudgetExpense;
        data["differenceExpense"] = this.differenceExpense;
        data["budgetProfit"] = this.budgetProfit;
        data["budgetProfitPercent"] = this.budgetProfitPercent;
        data["actualBudgetProfit"] = this.actualBudgetProfit;
        data["actualBudgetProfitPercent"] = this.actualBudgetProfitPercent;
        data["differenceProfit"] = this.differenceProfit;
        if (Array.isArray(this.budgetVsActualProjectRows)) {
            data["budgetVsActualProjectRows"] = [];
            for (let item of this.budgetVsActualProjectRows)
                data["budgetVsActualProjectRows"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.budgetVsActualCategoryRows)) {
            data["budgetVsActualCategoryRows"] = [];
            for (let item of this.budgetVsActualCategoryRows)
                data["budgetVsActualCategoryRows"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.budgetVsActualCategoryAndProjectRows)) {
            data["budgetVsActualCategoryAndProjectRows"] = [];
            for (let item of this.budgetVsActualCategoryAndProjectRows)
                data["budgetVsActualCategoryAndProjectRows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBudgetVsActualDashboardResponse {
    budgetIncome: number;
    actualBudgetIncome: number;
    differenceIncome: number;
    budgetExpense: number;
    actualBudgetExpense: number;
    differenceExpense: number;
    budgetProfit: number;
    budgetProfitPercent: number;
    actualBudgetProfit: number;
    actualBudgetProfitPercent: number;
    differenceProfit: number;
    budgetVsActualProjectRows?: BudgetVsActualFullRowDashboardResponse[] | undefined;
    budgetVsActualCategoryRows?: BudgetVsActualFullRowDashboardResponse[] | undefined;
    budgetVsActualCategoryAndProjectRows?: BudgetVsActualFullRowDashboardResponse[] | undefined;
}

export class BudgetVsActualFullRowDashboardResponse implements IBudgetVsActualFullRowDashboardResponse {
    date!: Date;
    projectId!: number;
    financeCategoryId!: number;
    budgetIncomeValue!: number;
    actualBudgetIncomeValue!: number;
    readonly differenceIncome!: number;
    readonly percentageOfBudgetIncome!: number;
    budgetExpenseValue!: number;
    actualBudgetExpenseValue!: number;
    readonly differenceExpense!: number;
    readonly percentageOfBudgetExpense!: number;
    readonly budgetProfitValue!: number;
    readonly actualBudgetProfitValue!: number;
    readonly differenceProfit!: number;
    readonly percentageOfBudgetProfit!: number;
    children?: BudgetVsActualFullRowDashboardResponse[] | undefined;

    constructor(data?: IBudgetVsActualFullRowDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.projectId = _data["projectId"];
            this.financeCategoryId = _data["financeCategoryId"];
            this.budgetIncomeValue = _data["budgetIncomeValue"];
            this.actualBudgetIncomeValue = _data["actualBudgetIncomeValue"];
            (this as any).differenceIncome = _data["differenceIncome"];
            (this as any).percentageOfBudgetIncome = _data["percentageOfBudgetIncome"];
            this.budgetExpenseValue = _data["budgetExpenseValue"];
            this.actualBudgetExpenseValue = _data["actualBudgetExpenseValue"];
            (this as any).differenceExpense = _data["differenceExpense"];
            (this as any).percentageOfBudgetExpense = _data["percentageOfBudgetExpense"];
            (this as any).budgetProfitValue = _data["budgetProfitValue"];
            (this as any).actualBudgetProfitValue = _data["actualBudgetProfitValue"];
            (this as any).differenceProfit = _data["differenceProfit"];
            (this as any).percentageOfBudgetProfit = _data["percentageOfBudgetProfit"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(BudgetVsActualFullRowDashboardResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetVsActualFullRowDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetVsActualFullRowDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["projectId"] = this.projectId;
        data["financeCategoryId"] = this.financeCategoryId;
        data["budgetIncomeValue"] = this.budgetIncomeValue;
        data["actualBudgetIncomeValue"] = this.actualBudgetIncomeValue;
        data["differenceIncome"] = this.differenceIncome;
        data["percentageOfBudgetIncome"] = this.percentageOfBudgetIncome;
        data["budgetExpenseValue"] = this.budgetExpenseValue;
        data["actualBudgetExpenseValue"] = this.actualBudgetExpenseValue;
        data["differenceExpense"] = this.differenceExpense;
        data["percentageOfBudgetExpense"] = this.percentageOfBudgetExpense;
        data["budgetProfitValue"] = this.budgetProfitValue;
        data["actualBudgetProfitValue"] = this.actualBudgetProfitValue;
        data["differenceProfit"] = this.differenceProfit;
        data["percentageOfBudgetProfit"] = this.percentageOfBudgetProfit;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBudgetVsActualFullRowDashboardResponse {
    date: Date;
    projectId: number;
    financeCategoryId: number;
    budgetIncomeValue: number;
    actualBudgetIncomeValue: number;
    differenceIncome: number;
    percentageOfBudgetIncome: number;
    budgetExpenseValue: number;
    actualBudgetExpenseValue: number;
    differenceExpense: number;
    percentageOfBudgetExpense: number;
    budgetProfitValue: number;
    actualBudgetProfitValue: number;
    differenceProfit: number;
    percentageOfBudgetProfit: number;
    children?: BudgetVsActualFullRowDashboardResponse[] | undefined;
}

export class BudgetVsActualPartnerRowDashboardResponse implements IBudgetVsActualPartnerRowDashboardResponse {
    date!: Date;
    budgetValue!: number;
    actualBudgetValue!: number;
    readonly difference!: number;
    readonly percentageOfBudget!: number;
    partnerId!: number;
    children?: BudgetVsActualPartnerRowDashboardResponse[] | undefined;

    constructor(data?: IBudgetVsActualPartnerRowDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.budgetValue = _data["budgetValue"];
            this.actualBudgetValue = _data["actualBudgetValue"];
            (this as any).difference = _data["difference"];
            (this as any).percentageOfBudget = _data["percentageOfBudget"];
            this.partnerId = _data["partnerId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(BudgetVsActualPartnerRowDashboardResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetVsActualPartnerRowDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetVsActualPartnerRowDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["budgetValue"] = this.budgetValue;
        data["actualBudgetValue"] = this.actualBudgetValue;
        data["difference"] = this.difference;
        data["percentageOfBudget"] = this.percentageOfBudget;
        data["partnerId"] = this.partnerId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBudgetVsActualPartnerRowDashboardResponse {
    date: Date;
    budgetValue: number;
    actualBudgetValue: number;
    difference: number;
    percentageOfBudget: number;
    partnerId: number;
    children?: BudgetVsActualPartnerRowDashboardResponse[] | undefined;
}

export class BudgetVsActualRowDashboardResponse implements IBudgetVsActualRowDashboardResponse {
    date!: Date;
    budgetValue!: number;
    actualBudgetValue!: number;
    readonly difference!: number;
    readonly percentageOfBudget!: number;

    constructor(data?: IBudgetVsActualRowDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.budgetValue = _data["budgetValue"];
            this.actualBudgetValue = _data["actualBudgetValue"];
            (this as any).difference = _data["difference"];
            (this as any).percentageOfBudget = _data["percentageOfBudget"];
        }
    }

    static fromJS(data: any): BudgetVsActualRowDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetVsActualRowDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["budgetValue"] = this.budgetValue;
        data["actualBudgetValue"] = this.actualBudgetValue;
        data["difference"] = this.difference;
        data["percentageOfBudget"] = this.percentageOfBudget;
        return data;
    }
}

export interface IBudgetVsActualRowDashboardResponse {
    date: Date;
    budgetValue: number;
    actualBudgetValue: number;
    difference: number;
    percentageOfBudget: number;
}

export class BusinessPartnerInsertRequestModel implements IBusinessPartnerInsertRequestModel {
    countryId!: number;
    name!: string;
    city!: string;
    address?: string | undefined;
    contactPerson?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    regNo?: string | undefined;
    vatNo!: string;
    iban?: string | undefined;
    swift?: string | undefined;

    constructor(data?: IBusinessPartnerInsertRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.contactPerson = _data["contactPerson"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.regNo = _data["regNo"];
            this.vatNo = _data["vatNo"];
            this.iban = _data["iban"];
            this.swift = _data["swift"];
        }
    }

    static fromJS(data: any): BusinessPartnerInsertRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessPartnerInsertRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["name"] = this.name;
        data["city"] = this.city;
        data["address"] = this.address;
        data["contactPerson"] = this.contactPerson;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["regNo"] = this.regNo;
        data["vatNo"] = this.vatNo;
        data["iban"] = this.iban;
        data["swift"] = this.swift;
        return data;
    }
}

export interface IBusinessPartnerInsertRequestModel {
    countryId: number;
    name: string;
    city: string;
    address?: string | undefined;
    contactPerson?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    regNo?: string | undefined;
    vatNo: string;
    iban?: string | undefined;
    swift?: string | undefined;
}

export class BusinessPartnerResponseModel implements IBusinessPartnerResponseModel {
    countryId!: number;
    name!: string;
    city!: string;
    address?: string | undefined;
    contactPerson?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    regNo?: string | undefined;
    vatNo!: string;
    iban?: string | undefined;
    swift?: string | undefined;
    id!: number;

    constructor(data?: IBusinessPartnerResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.contactPerson = _data["contactPerson"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.regNo = _data["regNo"];
            this.vatNo = _data["vatNo"];
            this.iban = _data["iban"];
            this.swift = _data["swift"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BusinessPartnerResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessPartnerResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["name"] = this.name;
        data["city"] = this.city;
        data["address"] = this.address;
        data["contactPerson"] = this.contactPerson;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["regNo"] = this.regNo;
        data["vatNo"] = this.vatNo;
        data["iban"] = this.iban;
        data["swift"] = this.swift;
        data["id"] = this.id;
        return data;
    }
}

export interface IBusinessPartnerResponseModel {
    countryId: number;
    name: string;
    city: string;
    address?: string | undefined;
    contactPerson?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    regNo?: string | undefined;
    vatNo: string;
    iban?: string | undefined;
    swift?: string | undefined;
    id: number;
}

export class BusinessPartnerResponseModelItemsResponseModel implements IBusinessPartnerResponseModelItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: BusinessPartnerResponseModel[] | undefined;

    constructor(data?: IBusinessPartnerResponseModelItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BusinessPartnerResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BusinessPartnerResponseModelItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessPartnerResponseModelItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBusinessPartnerResponseModelItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: BusinessPartnerResponseModel[] | undefined;
}

export class BusinessPartnerResponseModelSimpleResponseModel implements IBusinessPartnerResponseModelSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: BusinessPartnerResponseModel;

    constructor(data?: IBusinessPartnerResponseModelSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? BusinessPartnerResponseModel.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): BusinessPartnerResponseModelSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessPartnerResponseModelSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IBusinessPartnerResponseModelSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: BusinessPartnerResponseModel;
}

export class BusinessPartnerUpdateRequestModel implements IBusinessPartnerUpdateRequestModel {
    countryId!: number;
    name!: string;
    city!: string;
    address?: string | undefined;
    contactPerson?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    regNo?: string | undefined;
    vatNo!: string;
    iban?: string | undefined;
    swift?: string | undefined;
    id!: number;

    constructor(data?: IBusinessPartnerUpdateRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.contactPerson = _data["contactPerson"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.regNo = _data["regNo"];
            this.vatNo = _data["vatNo"];
            this.iban = _data["iban"];
            this.swift = _data["swift"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BusinessPartnerUpdateRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessPartnerUpdateRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["name"] = this.name;
        data["city"] = this.city;
        data["address"] = this.address;
        data["contactPerson"] = this.contactPerson;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["regNo"] = this.regNo;
        data["vatNo"] = this.vatNo;
        data["iban"] = this.iban;
        data["swift"] = this.swift;
        data["id"] = this.id;
        return data;
    }
}

export interface IBusinessPartnerUpdateRequestModel {
    countryId: number;
    name: string;
    city: string;
    address?: string | undefined;
    contactPerson?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    regNo?: string | undefined;
    vatNo: string;
    iban?: string | undefined;
    swift?: string | undefined;
    id: number;
}

export class CalendarResponse implements ICalendarResponse {
    id!: number;
    countryId!: number;
    workWeekFrom!: WeekDayEnum;
    workWeekTo!: WeekDayEnum;
    workTimeFrom!: number;
    workTimeTo!: number;
    holidays?: HolidayResponse[] | undefined;

    constructor(data?: ICalendarResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.countryId = _data["countryId"];
            this.workWeekFrom = _data["workWeekFrom"];
            this.workWeekTo = _data["workWeekTo"];
            this.workTimeFrom = _data["workTimeFrom"];
            this.workTimeTo = _data["workTimeTo"];
            if (Array.isArray(_data["holidays"])) {
                this.holidays = [] as any;
                for (let item of _data["holidays"])
                    this.holidays!.push(HolidayResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalendarResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["countryId"] = this.countryId;
        data["workWeekFrom"] = this.workWeekFrom;
        data["workWeekTo"] = this.workWeekTo;
        data["workTimeFrom"] = this.workTimeFrom;
        data["workTimeTo"] = this.workTimeTo;
        if (Array.isArray(this.holidays)) {
            data["holidays"] = [];
            for (let item of this.holidays)
                data["holidays"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICalendarResponse {
    id: number;
    countryId: number;
    workWeekFrom: WeekDayEnum;
    workWeekTo: WeekDayEnum;
    workTimeFrom: number;
    workTimeTo: number;
    holidays?: HolidayResponse[] | undefined;
}

export class CalendarResponseSimpleResponseModel implements ICalendarResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: CalendarResponse;

    constructor(data?: ICalendarResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? CalendarResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): CalendarResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ICalendarResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: CalendarResponse;
}

export class ChangePasswordRequestModel implements IChangePasswordRequestModel {
    oldPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordRequestModel {
    oldPassword: string;
    newPassword: string;
}

export class ChangeRequestAcceptanceRequest implements IChangeRequestAcceptanceRequest {
    id!: number;
    acceptedOn?: Date | undefined;
    comment?: string | undefined;

    constructor(data?: IChangeRequestAcceptanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.acceptedOn = _data["acceptedOn"] ? new Date(_data["acceptedOn"].toString()) : undefined as any;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ChangeRequestAcceptanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestAcceptanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["acceptedOn"] = this.acceptedOn ? formatDate(this.acceptedOn) : undefined as any;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IChangeRequestAcceptanceRequest {
    id: number;
    acceptedOn?: Date | undefined;
    comment?: string | undefined;
}

export class ChangeRequestActivityResponse implements IChangeRequestActivityResponse {
    id!: number;
    name?: string | undefined;
    expectedDeliveryOn?: Date | undefined;
    effortInHours?: number | undefined;
    cost?: number | undefined;

    constructor(data?: IChangeRequestActivityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.expectedDeliveryOn = _data["expectedDeliveryOn"] ? new Date(_data["expectedDeliveryOn"].toString()) : undefined as any;
            this.effortInHours = _data["effortInHours"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): ChangeRequestActivityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestActivityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["expectedDeliveryOn"] = this.expectedDeliveryOn ? formatDate(this.expectedDeliveryOn) : undefined as any;
        data["effortInHours"] = this.effortInHours;
        data["cost"] = this.cost;
        return data;
    }
}

export interface IChangeRequestActivityResponse {
    id: number;
    name?: string | undefined;
    expectedDeliveryOn?: Date | undefined;
    effortInHours?: number | undefined;
    cost?: number | undefined;
}

export class ChangeRequestAnalysisRequest implements IChangeRequestAnalysisRequest {
    id!: number;
    approvalUserId?: number | undefined;
    estimatedByUserId?: number | undefined;
    estimatedOn?: Date | undefined;
    completionOn?: Date | undefined;
    analysisDescription?: string | undefined;
    assumptions?: string | undefined;
    regressionRelevant!: boolean;
    dependencyDescription?: string | undefined;
    activities?: InsertChangeRequestActivityRequestUpdateChangeRequestActivityRequestInt32DeltaModel;
    approve!: ChangeRequestApproveEnum;
    sendEmail!: boolean;
    newAttachments?: InsertAttachmentRequest[] | undefined;

    constructor(data?: IChangeRequestAnalysisRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.approvalUserId = _data["approvalUserId"];
            this.estimatedByUserId = _data["estimatedByUserId"];
            this.estimatedOn = _data["estimatedOn"] ? new Date(_data["estimatedOn"].toString()) : undefined as any;
            this.completionOn = _data["completionOn"] ? new Date(_data["completionOn"].toString()) : undefined as any;
            this.analysisDescription = _data["analysisDescription"];
            this.assumptions = _data["assumptions"];
            this.regressionRelevant = _data["regressionRelevant"];
            this.dependencyDescription = _data["dependencyDescription"];
            this.activities = _data["activities"] ? InsertChangeRequestActivityRequestUpdateChangeRequestActivityRequestInt32DeltaModel.fromJS(_data["activities"]) : undefined as any;
            this.approve = _data["approve"];
            this.sendEmail = _data["sendEmail"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChangeRequestAnalysisRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestAnalysisRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["approvalUserId"] = this.approvalUserId;
        data["estimatedByUserId"] = this.estimatedByUserId;
        data["estimatedOn"] = this.estimatedOn ? formatDate(this.estimatedOn) : undefined as any;
        data["completionOn"] = this.completionOn ? formatDate(this.completionOn) : undefined as any;
        data["analysisDescription"] = this.analysisDescription;
        data["assumptions"] = this.assumptions;
        data["regressionRelevant"] = this.regressionRelevant;
        data["dependencyDescription"] = this.dependencyDescription;
        data["activities"] = this.activities ? this.activities.toJSON() : undefined as any;
        data["approve"] = this.approve;
        data["sendEmail"] = this.sendEmail;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IChangeRequestAnalysisRequest {
    id: number;
    approvalUserId?: number | undefined;
    estimatedByUserId?: number | undefined;
    estimatedOn?: Date | undefined;
    completionOn?: Date | undefined;
    analysisDescription?: string | undefined;
    assumptions?: string | undefined;
    regressionRelevant: boolean;
    dependencyDescription?: string | undefined;
    activities?: InsertChangeRequestActivityRequestUpdateChangeRequestActivityRequestInt32DeltaModel;
    approve: ChangeRequestApproveEnum;
    sendEmail: boolean;
    newAttachments?: InsertAttachmentRequest[] | undefined;
}

export class ChangeRequestApprovalRequest implements IChangeRequestApprovalRequest {
    id!: number;
    approvalActionOn?: Date | undefined;
    reasonForRejection?: string | undefined;
    realizationUserId?: number | undefined;
    approve?: ChangeRequestApproveEnum;
    sendEmail!: boolean;

    constructor(data?: IChangeRequestApprovalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.approvalActionOn = _data["approvalActionOn"] ? new Date(_data["approvalActionOn"].toString()) : undefined as any;
            this.reasonForRejection = _data["reasonForRejection"];
            this.realizationUserId = _data["realizationUserId"];
            this.approve = _data["approve"];
            this.sendEmail = _data["sendEmail"];
        }
    }

    static fromJS(data: any): ChangeRequestApprovalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestApprovalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["approvalActionOn"] = this.approvalActionOn ? formatDate(this.approvalActionOn) : undefined as any;
        data["reasonForRejection"] = this.reasonForRejection;
        data["realizationUserId"] = this.realizationUserId;
        data["approve"] = this.approve;
        data["sendEmail"] = this.sendEmail;
        return data;
    }
}

export interface IChangeRequestApprovalRequest {
    id: number;
    approvalActionOn?: Date | undefined;
    reasonForRejection?: string | undefined;
    realizationUserId?: number | undefined;
    approve?: ChangeRequestApproveEnum;
    sendEmail: boolean;
}

export enum ChangeRequestApproveEnum {
    None = "None",
    Approve = "Approve",
    Reject = "Reject",
    AdditionalInfoNeeded = "AdditionalInfoNeeded",
}

export class ChangeRequestCountsResponse implements IChangeRequestCountsResponse {
    totalEstimatedCostSum!: number;
    totalEstimatedEffortSum!: number;
    totalRealizationCostSum!: number;
    totalRealizationEffortSum!: number;

    constructor(data?: IChangeRequestCountsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalEstimatedCostSum = _data["totalEstimatedCostSum"];
            this.totalEstimatedEffortSum = _data["totalEstimatedEffortSum"];
            this.totalRealizationCostSum = _data["totalRealizationCostSum"];
            this.totalRealizationEffortSum = _data["totalRealizationEffortSum"];
        }
    }

    static fromJS(data: any): ChangeRequestCountsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestCountsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalEstimatedCostSum"] = this.totalEstimatedCostSum;
        data["totalEstimatedEffortSum"] = this.totalEstimatedEffortSum;
        data["totalRealizationCostSum"] = this.totalRealizationCostSum;
        data["totalRealizationEffortSum"] = this.totalRealizationEffortSum;
        return data;
    }
}

export interface IChangeRequestCountsResponse {
    totalEstimatedCostSum: number;
    totalEstimatedEffortSum: number;
    totalRealizationCostSum: number;
    totalRealizationEffortSum: number;
}

export class ChangeRequestCountsResponseSimpleResponseModel implements IChangeRequestCountsResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ChangeRequestCountsResponse;

    constructor(data?: IChangeRequestCountsResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ChangeRequestCountsResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ChangeRequestCountsResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestCountsResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IChangeRequestCountsResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ChangeRequestCountsResponse;
}

export enum ChangeRequestPriorityEnum {
    Low = "Low",
    Medium = "Medium",
    High = "High",
    Critical = "Critical",
}

export class ChangeRequestRealizationRequest implements IChangeRequestRealizationRequest {
    id!: number;
    approve?: ChangeRequestApproveEnum;
    acceptanceUserId?: number | undefined;
    linkToEvidence?: string | undefined;
    scopeItemLevelIdsToAdd?: number[] | undefined;
    scopeItemLevelIdsToRemove?: number[] | undefined;
    sendEmail!: boolean;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    activities?: InsertChangeRequestActivityRequestUpdateChangeRequestActivityRequestInt32DeltaModel;

    constructor(data?: IChangeRequestRealizationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.approve = _data["approve"];
            this.acceptanceUserId = _data["acceptanceUserId"];
            this.linkToEvidence = _data["linkToEvidence"];
            if (Array.isArray(_data["scopeItemLevelIdsToAdd"])) {
                this.scopeItemLevelIdsToAdd = [] as any;
                for (let item of _data["scopeItemLevelIdsToAdd"])
                    this.scopeItemLevelIdsToAdd!.push(item);
            }
            if (Array.isArray(_data["scopeItemLevelIdsToRemove"])) {
                this.scopeItemLevelIdsToRemove = [] as any;
                for (let item of _data["scopeItemLevelIdsToRemove"])
                    this.scopeItemLevelIdsToRemove!.push(item);
            }
            this.sendEmail = _data["sendEmail"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            this.activities = _data["activities"] ? InsertChangeRequestActivityRequestUpdateChangeRequestActivityRequestInt32DeltaModel.fromJS(_data["activities"]) : undefined as any;
        }
    }

    static fromJS(data: any): ChangeRequestRealizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestRealizationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["approve"] = this.approve;
        data["acceptanceUserId"] = this.acceptanceUserId;
        data["linkToEvidence"] = this.linkToEvidence;
        if (Array.isArray(this.scopeItemLevelIdsToAdd)) {
            data["scopeItemLevelIdsToAdd"] = [];
            for (let item of this.scopeItemLevelIdsToAdd)
                data["scopeItemLevelIdsToAdd"].push(item);
        }
        if (Array.isArray(this.scopeItemLevelIdsToRemove)) {
            data["scopeItemLevelIdsToRemove"] = [];
            for (let item of this.scopeItemLevelIdsToRemove)
                data["scopeItemLevelIdsToRemove"].push(item);
        }
        data["sendEmail"] = this.sendEmail;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["activities"] = this.activities ? this.activities.toJSON() : undefined as any;
        return data;
    }
}

export interface IChangeRequestRealizationRequest {
    id: number;
    approve?: ChangeRequestApproveEnum;
    acceptanceUserId?: number | undefined;
    linkToEvidence?: string | undefined;
    scopeItemLevelIdsToAdd?: number[] | undefined;
    scopeItemLevelIdsToRemove?: number[] | undefined;
    sendEmail: boolean;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    activities?: InsertChangeRequestActivityRequestUpdateChangeRequestActivityRequestInt32DeltaModel;
}

export class ChangeRequestResponse implements IChangeRequestResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    projectId!: number;
    initiatedBy?: string | undefined;
    requestedOn?: Date | undefined;
    typeId?: number | undefined;
    goLiveCritical!: boolean;
    impactId!: number;
    urgencyId!: number;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    statusId!: number;
    expectedCompletionDate?: Date | undefined;
    reasonOfChange?: string | undefined;
    expectedBenefit?: string | undefined;
    estimatedOn?: Date | undefined;
    completionOn?: Date | undefined;
    analysisDescription?: string | undefined;
    assumptions?: string | undefined;
    regressionRelevant!: boolean;
    dependencyDescription?: string | undefined;
    approvalActionOn?: Date | undefined;
    reasonForRejection?: string | undefined;
    linkToEvidence?: string | undefined;
    acceptedOn?: Date | undefined;
    comment?: string | undefined;
    requestedByUserId!: number;
    analysisUserId?: number | undefined;
    estimatedByUserId?: number | undefined;
    approvalUserId?: number | undefined;
    approvedOrRejectedByUserId?: number | undefined;
    realizationUserId?: number | undefined;
    acceptanceUserId?: number | undefined;
    acceptedByUserId?: number | undefined;
    sendEmailInitial!: boolean;
    sendEmailAnalysis!: boolean;
    sendEmailApproval!: boolean;
    sendEmailRealization!: boolean;
    estimatedActivities?: ChangeRequestActivityResponse[] | undefined;
    realizationActivities?: ChangeRequestActivityResponse[] | undefined;
    problemReportAttachments?: AttachmentResponse[] | undefined;
    analysisAttachments?: AttachmentResponse[] | undefined;
    realizationAttachments?: AttachmentResponse[] | undefined;
    scopeItemLevelIds?: number[] | undefined;
    ticketIds?: number[] | undefined;

    constructor(data?: IChangeRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.projectId = _data["projectId"];
            this.initiatedBy = _data["initiatedBy"];
            this.requestedOn = _data["requestedOn"] ? new Date(_data["requestedOn"].toString()) : undefined as any;
            this.typeId = _data["typeId"];
            this.goLiveCritical = _data["goLiveCritical"];
            this.impactId = _data["impactId"];
            this.urgencyId = _data["urgencyId"];
            this.projectTeamId = _data["projectTeamId"];
            this.projectOrganizationId = _data["projectOrganizationId"];
            this.statusId = _data["statusId"];
            this.expectedCompletionDate = _data["expectedCompletionDate"] ? new Date(_data["expectedCompletionDate"].toString()) : undefined as any;
            this.reasonOfChange = _data["reasonOfChange"];
            this.expectedBenefit = _data["expectedBenefit"];
            this.estimatedOn = _data["estimatedOn"] ? new Date(_data["estimatedOn"].toString()) : undefined as any;
            this.completionOn = _data["completionOn"] ? new Date(_data["completionOn"].toString()) : undefined as any;
            this.analysisDescription = _data["analysisDescription"];
            this.assumptions = _data["assumptions"];
            this.regressionRelevant = _data["regressionRelevant"];
            this.dependencyDescription = _data["dependencyDescription"];
            this.approvalActionOn = _data["approvalActionOn"] ? new Date(_data["approvalActionOn"].toString()) : undefined as any;
            this.reasonForRejection = _data["reasonForRejection"];
            this.linkToEvidence = _data["linkToEvidence"];
            this.acceptedOn = _data["acceptedOn"] ? new Date(_data["acceptedOn"].toString()) : undefined as any;
            this.comment = _data["comment"];
            this.requestedByUserId = _data["requestedByUserId"];
            this.analysisUserId = _data["analysisUserId"];
            this.estimatedByUserId = _data["estimatedByUserId"];
            this.approvalUserId = _data["approvalUserId"];
            this.approvedOrRejectedByUserId = _data["approvedOrRejectedByUserId"];
            this.realizationUserId = _data["realizationUserId"];
            this.acceptanceUserId = _data["acceptanceUserId"];
            this.acceptedByUserId = _data["acceptedByUserId"];
            this.sendEmailInitial = _data["sendEmailInitial"];
            this.sendEmailAnalysis = _data["sendEmailAnalysis"];
            this.sendEmailApproval = _data["sendEmailApproval"];
            this.sendEmailRealization = _data["sendEmailRealization"];
            if (Array.isArray(_data["estimatedActivities"])) {
                this.estimatedActivities = [] as any;
                for (let item of _data["estimatedActivities"])
                    this.estimatedActivities!.push(ChangeRequestActivityResponse.fromJS(item));
            }
            if (Array.isArray(_data["realizationActivities"])) {
                this.realizationActivities = [] as any;
                for (let item of _data["realizationActivities"])
                    this.realizationActivities!.push(ChangeRequestActivityResponse.fromJS(item));
            }
            if (Array.isArray(_data["problemReportAttachments"])) {
                this.problemReportAttachments = [] as any;
                for (let item of _data["problemReportAttachments"])
                    this.problemReportAttachments!.push(AttachmentResponse.fromJS(item));
            }
            if (Array.isArray(_data["analysisAttachments"])) {
                this.analysisAttachments = [] as any;
                for (let item of _data["analysisAttachments"])
                    this.analysisAttachments!.push(AttachmentResponse.fromJS(item));
            }
            if (Array.isArray(_data["realizationAttachments"])) {
                this.realizationAttachments = [] as any;
                for (let item of _data["realizationAttachments"])
                    this.realizationAttachments!.push(AttachmentResponse.fromJS(item));
            }
            if (Array.isArray(_data["scopeItemLevelIds"])) {
                this.scopeItemLevelIds = [] as any;
                for (let item of _data["scopeItemLevelIds"])
                    this.scopeItemLevelIds!.push(item);
            }
            if (Array.isArray(_data["ticketIds"])) {
                this.ticketIds = [] as any;
                for (let item of _data["ticketIds"])
                    this.ticketIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ChangeRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        data["initiatedBy"] = this.initiatedBy;
        data["requestedOn"] = this.requestedOn ? formatDate(this.requestedOn) : undefined as any;
        data["typeId"] = this.typeId;
        data["goLiveCritical"] = this.goLiveCritical;
        data["impactId"] = this.impactId;
        data["urgencyId"] = this.urgencyId;
        data["projectTeamId"] = this.projectTeamId;
        data["projectOrganizationId"] = this.projectOrganizationId;
        data["statusId"] = this.statusId;
        data["expectedCompletionDate"] = this.expectedCompletionDate ? formatDate(this.expectedCompletionDate) : undefined as any;
        data["reasonOfChange"] = this.reasonOfChange;
        data["expectedBenefit"] = this.expectedBenefit;
        data["estimatedOn"] = this.estimatedOn ? formatDate(this.estimatedOn) : undefined as any;
        data["completionOn"] = this.completionOn ? formatDate(this.completionOn) : undefined as any;
        data["analysisDescription"] = this.analysisDescription;
        data["assumptions"] = this.assumptions;
        data["regressionRelevant"] = this.regressionRelevant;
        data["dependencyDescription"] = this.dependencyDescription;
        data["approvalActionOn"] = this.approvalActionOn ? formatDate(this.approvalActionOn) : undefined as any;
        data["reasonForRejection"] = this.reasonForRejection;
        data["linkToEvidence"] = this.linkToEvidence;
        data["acceptedOn"] = this.acceptedOn ? formatDate(this.acceptedOn) : undefined as any;
        data["comment"] = this.comment;
        data["requestedByUserId"] = this.requestedByUserId;
        data["analysisUserId"] = this.analysisUserId;
        data["estimatedByUserId"] = this.estimatedByUserId;
        data["approvalUserId"] = this.approvalUserId;
        data["approvedOrRejectedByUserId"] = this.approvedOrRejectedByUserId;
        data["realizationUserId"] = this.realizationUserId;
        data["acceptanceUserId"] = this.acceptanceUserId;
        data["acceptedByUserId"] = this.acceptedByUserId;
        data["sendEmailInitial"] = this.sendEmailInitial;
        data["sendEmailAnalysis"] = this.sendEmailAnalysis;
        data["sendEmailApproval"] = this.sendEmailApproval;
        data["sendEmailRealization"] = this.sendEmailRealization;
        if (Array.isArray(this.estimatedActivities)) {
            data["estimatedActivities"] = [];
            for (let item of this.estimatedActivities)
                data["estimatedActivities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.realizationActivities)) {
            data["realizationActivities"] = [];
            for (let item of this.realizationActivities)
                data["realizationActivities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.problemReportAttachments)) {
            data["problemReportAttachments"] = [];
            for (let item of this.problemReportAttachments)
                data["problemReportAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.analysisAttachments)) {
            data["analysisAttachments"] = [];
            for (let item of this.analysisAttachments)
                data["analysisAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.realizationAttachments)) {
            data["realizationAttachments"] = [];
            for (let item of this.realizationAttachments)
                data["realizationAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.scopeItemLevelIds)) {
            data["scopeItemLevelIds"] = [];
            for (let item of this.scopeItemLevelIds)
                data["scopeItemLevelIds"].push(item);
        }
        if (Array.isArray(this.ticketIds)) {
            data["ticketIds"] = [];
            for (let item of this.ticketIds)
                data["ticketIds"].push(item);
        }
        return data;
    }
}

export interface IChangeRequestResponse {
    id: number;
    name: string;
    description?: string | undefined;
    projectId: number;
    initiatedBy?: string | undefined;
    requestedOn?: Date | undefined;
    typeId?: number | undefined;
    goLiveCritical: boolean;
    impactId: number;
    urgencyId: number;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    statusId: number;
    expectedCompletionDate?: Date | undefined;
    reasonOfChange?: string | undefined;
    expectedBenefit?: string | undefined;
    estimatedOn?: Date | undefined;
    completionOn?: Date | undefined;
    analysisDescription?: string | undefined;
    assumptions?: string | undefined;
    regressionRelevant: boolean;
    dependencyDescription?: string | undefined;
    approvalActionOn?: Date | undefined;
    reasonForRejection?: string | undefined;
    linkToEvidence?: string | undefined;
    acceptedOn?: Date | undefined;
    comment?: string | undefined;
    requestedByUserId: number;
    analysisUserId?: number | undefined;
    estimatedByUserId?: number | undefined;
    approvalUserId?: number | undefined;
    approvedOrRejectedByUserId?: number | undefined;
    realizationUserId?: number | undefined;
    acceptanceUserId?: number | undefined;
    acceptedByUserId?: number | undefined;
    sendEmailInitial: boolean;
    sendEmailAnalysis: boolean;
    sendEmailApproval: boolean;
    sendEmailRealization: boolean;
    estimatedActivities?: ChangeRequestActivityResponse[] | undefined;
    realizationActivities?: ChangeRequestActivityResponse[] | undefined;
    problemReportAttachments?: AttachmentResponse[] | undefined;
    analysisAttachments?: AttachmentResponse[] | undefined;
    realizationAttachments?: AttachmentResponse[] | undefined;
    scopeItemLevelIds?: number[] | undefined;
    ticketIds?: number[] | undefined;
}

export class ChangeRequestResponseItemsResponseModel implements IChangeRequestResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ChangeRequestResponse[] | undefined;

    constructor(data?: IChangeRequestResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChangeRequestResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChangeRequestResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IChangeRequestResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ChangeRequestResponse[] | undefined;
}

export class ChangeRequestResponseSimpleResponseModel implements IChangeRequestResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ChangeRequestResponse;

    constructor(data?: IChangeRequestResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ChangeRequestResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ChangeRequestResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IChangeRequestResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ChangeRequestResponse;
}

export enum ChangeRequestStatusEnum {
    Created = "Created",
    Initiated = "Initiated",
    RejectedAnalysis = "RejectedAnalysis",
    ReleasedForApproval = "ReleasedForApproval",
    RejectedForRealization = "RejectedForRealization",
    ApprovedForRealization = "ApprovedForRealization",
    ReleasedForAcceptance = "ReleasedForAcceptance",
    Completed = "Completed",
}

export class ChangeRequestStatusResponse implements IChangeRequestStatusResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isReadonly!: boolean;
    color!: string;
    isInitial!: boolean;
    nextStates?: number[] | undefined;
    order!: number;
    semantics!: ChangeRequestStatusEnum;

    constructor(data?: IChangeRequestStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isReadonly = _data["isReadonly"];
            this.color = _data["color"];
            this.isInitial = _data["isInitial"];
            if (Array.isArray(_data["nextStates"])) {
                this.nextStates = [] as any;
                for (let item of _data["nextStates"])
                    this.nextStates!.push(item);
            }
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): ChangeRequestStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isReadonly"] = this.isReadonly;
        data["color"] = this.color;
        data["isInitial"] = this.isInitial;
        if (Array.isArray(this.nextStates)) {
            data["nextStates"] = [];
            for (let item of this.nextStates)
                data["nextStates"].push(item);
        }
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IChangeRequestStatusResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isReadonly: boolean;
    color: string;
    isInitial: boolean;
    nextStates?: number[] | undefined;
    order: number;
    semantics: ChangeRequestStatusEnum;
}

export class ChangeRequestStatusResponseItemsResponseModel implements IChangeRequestStatusResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ChangeRequestStatusResponse[] | undefined;

    constructor(data?: IChangeRequestStatusResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChangeRequestStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChangeRequestStatusResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeRequestStatusResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IChangeRequestStatusResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ChangeRequestStatusResponse[] | undefined;
}

export class CheckTenantRequestModel implements ICheckTenantRequestModel {
    domain!: string;
    email!: string;

    constructor(data?: ICheckTenantRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domain = _data["domain"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CheckTenantRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckTenantRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        data["email"] = this.email;
        return data;
    }
}

export interface ICheckTenantRequestModel {
    domain: string;
    email: string;
}

export class CheckUserExistsReponseModel implements ICheckUserExistsReponseModel {
    emailExists!: boolean;
    usernameExists!: boolean;
    domain!: boolean;

    constructor(data?: ICheckUserExistsReponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailExists = _data["emailExists"];
            this.usernameExists = _data["usernameExists"];
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): CheckUserExistsReponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckUserExistsReponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailExists"] = this.emailExists;
        data["usernameExists"] = this.usernameExists;
        data["domain"] = this.domain;
        return data;
    }
}

export interface ICheckUserExistsReponseModel {
    emailExists: boolean;
    usernameExists: boolean;
    domain: boolean;
}

export class CheckUserExistsReponseModelSimpleResponseModel implements ICheckUserExistsReponseModelSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: CheckUserExistsReponseModel;

    constructor(data?: ICheckUserExistsReponseModelSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? CheckUserExistsReponseModel.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): CheckUserExistsReponseModelSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckUserExistsReponseModelSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ICheckUserExistsReponseModelSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: CheckUserExistsReponseModel;
}

export class CheckUserExistsRequestModel implements ICheckUserExistsRequestModel {
    email?: string | undefined;
    username?: string | undefined;
    domain?: string | undefined;
    includeUser!: boolean;

    constructor(data?: ICheckUserExistsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.username = _data["username"];
            this.domain = _data["domain"];
            this.includeUser = _data["includeUser"];
        }
    }

    static fromJS(data: any): CheckUserExistsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CheckUserExistsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["username"] = this.username;
        data["domain"] = this.domain;
        data["includeUser"] = this.includeUser;
        return data;
    }
}

export interface ICheckUserExistsRequestModel {
    email?: string | undefined;
    username?: string | undefined;
    domain?: string | undefined;
    includeUser: boolean;
}

export class CloneSurveyRequest implements ICloneSurveyRequest {
    name!: string;
    description?: string | undefined;
    copyFromId!: number;

    constructor(data?: ICloneSurveyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.copyFromId = _data["copyFromId"];
        }
    }

    static fromJS(data: any): CloneSurveyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloneSurveyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["copyFromId"] = this.copyFromId;
        return data;
    }
}

export interface ICloneSurveyRequest {
    name: string;
    description?: string | undefined;
    copyFromId: number;
}

export class CommunicationCalendarResponse implements ICommunicationCalendarResponse {
    id!: number;
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    description?: string | undefined;
    type!: EntityTypeEnum;
    from!: Date;
    to?: Date | undefined;
    dueDate?: Date | undefined;
    statusId?: number | undefined;
    userId!: number;

    constructor(data?: ICommunicationCalendarResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CommunicationCalendarResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationCalendarResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["description"] = this.description;
        data["type"] = this.type;
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["to"] = this.to ? this.to.toISOString() : undefined as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["statusId"] = this.statusId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ICommunicationCalendarResponse {
    id: number;
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    description?: string | undefined;
    type: EntityTypeEnum;
    from: Date;
    to?: Date | undefined;
    dueDate?: Date | undefined;
    statusId?: number | undefined;
    userId: number;
}

export class CommunicationCalendarResponseItemsResponseModel implements ICommunicationCalendarResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: CommunicationCalendarResponse[] | undefined;

    constructor(data?: ICommunicationCalendarResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CommunicationCalendarResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommunicationCalendarResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationCalendarResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICommunicationCalendarResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: CommunicationCalendarResponse[] | undefined;
}

export class CommunicationDashboardFilterRequest implements ICommunicationDashboardFilterRequest {
    dateRange!: DateRangeRequest;
    projectIds?: number[] | undefined;
    projectTeamIds?: number[] | undefined;
    userIds?: number[] | undefined;
    taskStatusIds?: number[] | undefined;
    organizationalUnitIds?: number[] | undefined;
    taskIsPrivate?: boolean | undefined;

    constructor(data?: ICommunicationDashboardFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dateRange = new DateRangeRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateRange = _data["dateRange"] ? DateRangeRequest.fromJS(_data["dateRange"]) : new DateRangeRequest();
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
            if (Array.isArray(_data["projectTeamIds"])) {
                this.projectTeamIds = [] as any;
                for (let item of _data["projectTeamIds"])
                    this.projectTeamIds!.push(item);
            }
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["taskStatusIds"])) {
                this.taskStatusIds = [] as any;
                for (let item of _data["taskStatusIds"])
                    this.taskStatusIds!.push(item);
            }
            if (Array.isArray(_data["organizationalUnitIds"])) {
                this.organizationalUnitIds = [] as any;
                for (let item of _data["organizationalUnitIds"])
                    this.organizationalUnitIds!.push(item);
            }
            this.taskIsPrivate = _data["taskIsPrivate"];
        }
    }

    static fromJS(data: any): CommunicationDashboardFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationDashboardFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : undefined as any;
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        if (Array.isArray(this.projectTeamIds)) {
            data["projectTeamIds"] = [];
            for (let item of this.projectTeamIds)
                data["projectTeamIds"].push(item);
        }
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.taskStatusIds)) {
            data["taskStatusIds"] = [];
            for (let item of this.taskStatusIds)
                data["taskStatusIds"].push(item);
        }
        if (Array.isArray(this.organizationalUnitIds)) {
            data["organizationalUnitIds"] = [];
            for (let item of this.organizationalUnitIds)
                data["organizationalUnitIds"].push(item);
        }
        data["taskIsPrivate"] = this.taskIsPrivate;
        return data;
    }
}

export interface ICommunicationDashboardFilterRequest {
    dateRange: DateRangeRequest;
    projectIds?: number[] | undefined;
    projectTeamIds?: number[] | undefined;
    userIds?: number[] | undefined;
    taskStatusIds?: number[] | undefined;
    organizationalUnitIds?: number[] | undefined;
    taskIsPrivate?: boolean | undefined;
}

export class CommunicationDashboardResponse implements ICommunicationDashboardResponse {
    totalNumberOfTasks!: number;
    openTasks!: number;
    closedTasks!: number;
    overdueTasks!: number;
    tasksPerStatus?: { [key: string]: number; } | undefined;
    overdueTasksPerAssignedUser?: { [key: string]: number; } | undefined;
    tasksPerAssignedUserAndStatusCounts?: { [key: string]: { [key: string]: number; }; } | undefined;

    constructor(data?: ICommunicationDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalNumberOfTasks = _data["totalNumberOfTasks"];
            this.openTasks = _data["openTasks"];
            this.closedTasks = _data["closedTasks"];
            this.overdueTasks = _data["overdueTasks"];
            if (_data["tasksPerStatus"]) {
                this.tasksPerStatus = {} as any;
                for (let key in _data["tasksPerStatus"]) {
                    if (_data["tasksPerStatus"].hasOwnProperty(key))
                        (this.tasksPerStatus as any)![key] = _data["tasksPerStatus"][key];
                }
            }
            if (_data["overdueTasksPerAssignedUser"]) {
                this.overdueTasksPerAssignedUser = {} as any;
                for (let key in _data["overdueTasksPerAssignedUser"]) {
                    if (_data["overdueTasksPerAssignedUser"].hasOwnProperty(key))
                        (this.overdueTasksPerAssignedUser as any)![key] = _data["overdueTasksPerAssignedUser"][key];
                }
            }
            if (_data["tasksPerAssignedUserAndStatusCounts"]) {
                this.tasksPerAssignedUserAndStatusCounts = {} as any;
                for (let key in _data["tasksPerAssignedUserAndStatusCounts"]) {
                    if (_data["tasksPerAssignedUserAndStatusCounts"].hasOwnProperty(key))
                        (this.tasksPerAssignedUserAndStatusCounts as any)![key] = _data["tasksPerAssignedUserAndStatusCounts"][key] !== undefined ? _data["tasksPerAssignedUserAndStatusCounts"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): CommunicationDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalNumberOfTasks"] = this.totalNumberOfTasks;
        data["openTasks"] = this.openTasks;
        data["closedTasks"] = this.closedTasks;
        data["overdueTasks"] = this.overdueTasks;
        if (this.tasksPerStatus) {
            data["tasksPerStatus"] = {};
            for (let key in this.tasksPerStatus) {
                if (this.tasksPerStatus.hasOwnProperty(key))
                    (data["tasksPerStatus"] as any)[key] = (this.tasksPerStatus as any)[key];
            }
        }
        if (this.overdueTasksPerAssignedUser) {
            data["overdueTasksPerAssignedUser"] = {};
            for (let key in this.overdueTasksPerAssignedUser) {
                if (this.overdueTasksPerAssignedUser.hasOwnProperty(key))
                    (data["overdueTasksPerAssignedUser"] as any)[key] = (this.overdueTasksPerAssignedUser as any)[key];
            }
        }
        if (this.tasksPerAssignedUserAndStatusCounts) {
            data["tasksPerAssignedUserAndStatusCounts"] = {};
            for (let key in this.tasksPerAssignedUserAndStatusCounts) {
                if (this.tasksPerAssignedUserAndStatusCounts.hasOwnProperty(key))
                    (data["tasksPerAssignedUserAndStatusCounts"] as any)[key] = (this.tasksPerAssignedUserAndStatusCounts as any)[key];
            }
        }
        return data;
    }
}

export interface ICommunicationDashboardResponse {
    totalNumberOfTasks: number;
    openTasks: number;
    closedTasks: number;
    overdueTasks: number;
    tasksPerStatus?: { [key: string]: number; } | undefined;
    overdueTasksPerAssignedUser?: { [key: string]: number; } | undefined;
    tasksPerAssignedUserAndStatusCounts?: { [key: string]: { [key: string]: number; }; } | undefined;
}

export class CommunicationDashboardResponseSimpleResponseModel implements ICommunicationDashboardResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: CommunicationDashboardResponse;

    constructor(data?: ICommunicationDashboardResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? CommunicationDashboardResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): CommunicationDashboardResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationDashboardResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ICommunicationDashboardResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: CommunicationDashboardResponse;
}

export class CompanyRequestModel implements ICompanyRequestModel {
    companyName?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    webSite?: string | undefined;
    email?: string | undefined;
    regNumber?: string | undefined;
    taxVATNumber!: number;
    bankName?: string | undefined;
    iban?: string | undefined;
    swift?: string | undefined;
    bankAccountNumber?: string | undefined;
    countryId!: number;
    isPrivatePerson!: boolean;
    invoiceContactPerson?: string | undefined;
    invoicePhone?: string | undefined;
    invoiceEmail?: string | undefined;
    logoInHeader?: string | undefined;
    logoInPDF?: string | undefined;

    constructor(data?: ICompanyRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.webSite = _data["webSite"];
            this.email = _data["email"];
            this.regNumber = _data["regNumber"];
            this.taxVATNumber = _data["taxVATNumber"];
            this.bankName = _data["bankName"];
            this.iban = _data["iban"];
            this.swift = _data["swift"];
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.countryId = _data["countryId"];
            this.isPrivatePerson = _data["isPrivatePerson"];
            this.invoiceContactPerson = _data["invoiceContactPerson"];
            this.invoicePhone = _data["invoicePhone"];
            this.invoiceEmail = _data["invoiceEmail"];
            this.logoInHeader = _data["logoInHeader"];
            this.logoInPDF = _data["logoInPDF"];
        }
    }

    static fromJS(data: any): CompanyRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["webSite"] = this.webSite;
        data["email"] = this.email;
        data["regNumber"] = this.regNumber;
        data["taxVATNumber"] = this.taxVATNumber;
        data["bankName"] = this.bankName;
        data["iban"] = this.iban;
        data["swift"] = this.swift;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["countryId"] = this.countryId;
        data["isPrivatePerson"] = this.isPrivatePerson;
        data["invoiceContactPerson"] = this.invoiceContactPerson;
        data["invoicePhone"] = this.invoicePhone;
        data["invoiceEmail"] = this.invoiceEmail;
        data["logoInHeader"] = this.logoInHeader;
        data["logoInPDF"] = this.logoInPDF;
        return data;
    }
}

export interface ICompanyRequestModel {
    companyName?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    webSite?: string | undefined;
    email?: string | undefined;
    regNumber?: string | undefined;
    taxVATNumber: number;
    bankName?: string | undefined;
    iban?: string | undefined;
    swift?: string | undefined;
    bankAccountNumber?: string | undefined;
    countryId: number;
    isPrivatePerson: boolean;
    invoiceContactPerson?: string | undefined;
    invoicePhone?: string | undefined;
    invoiceEmail?: string | undefined;
    logoInHeader?: string | undefined;
    logoInPDF?: string | undefined;
}

export class CompanyResponseModel implements ICompanyResponseModel {
    companyName?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    webSite?: string | undefined;
    email?: string | undefined;
    regNumber?: string | undefined;
    taxVATNumber!: number;
    bankName?: string | undefined;
    iban?: string | undefined;
    swift?: string | undefined;
    bankAccountNumber?: string | undefined;
    countryId!: number;
    isPrivatePerson!: boolean;
    invoiceContactPerson?: string | undefined;
    invoicePhone?: string | undefined;
    invoiceEmail?: string | undefined;
    logoInHeader?: string | undefined;
    logoInPDF?: string | undefined;

    constructor(data?: ICompanyResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.webSite = _data["webSite"];
            this.email = _data["email"];
            this.regNumber = _data["regNumber"];
            this.taxVATNumber = _data["taxVATNumber"];
            this.bankName = _data["bankName"];
            this.iban = _data["iban"];
            this.swift = _data["swift"];
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.countryId = _data["countryId"];
            this.isPrivatePerson = _data["isPrivatePerson"];
            this.invoiceContactPerson = _data["invoiceContactPerson"];
            this.invoicePhone = _data["invoicePhone"];
            this.invoiceEmail = _data["invoiceEmail"];
            this.logoInHeader = _data["logoInHeader"];
            this.logoInPDF = _data["logoInPDF"];
        }
    }

    static fromJS(data: any): CompanyResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["webSite"] = this.webSite;
        data["email"] = this.email;
        data["regNumber"] = this.regNumber;
        data["taxVATNumber"] = this.taxVATNumber;
        data["bankName"] = this.bankName;
        data["iban"] = this.iban;
        data["swift"] = this.swift;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["countryId"] = this.countryId;
        data["isPrivatePerson"] = this.isPrivatePerson;
        data["invoiceContactPerson"] = this.invoiceContactPerson;
        data["invoicePhone"] = this.invoicePhone;
        data["invoiceEmail"] = this.invoiceEmail;
        data["logoInHeader"] = this.logoInHeader;
        data["logoInPDF"] = this.logoInPDF;
        return data;
    }
}

export interface ICompanyResponseModel {
    companyName?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    webSite?: string | undefined;
    email?: string | undefined;
    regNumber?: string | undefined;
    taxVATNumber: number;
    bankName?: string | undefined;
    iban?: string | undefined;
    swift?: string | undefined;
    bankAccountNumber?: string | undefined;
    countryId: number;
    isPrivatePerson: boolean;
    invoiceContactPerson?: string | undefined;
    invoicePhone?: string | undefined;
    invoiceEmail?: string | undefined;
    logoInHeader?: string | undefined;
    logoInPDF?: string | undefined;
}

export class CompanyResponseModelSimpleResponseModel implements ICompanyResponseModelSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: CompanyResponseModel;

    constructor(data?: ICompanyResponseModelSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? CompanyResponseModel.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): CompanyResponseModelSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyResponseModelSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ICompanyResponseModelSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: CompanyResponseModel;
}

export class CopyFromProjectRequest implements ICopyFromProjectRequest {
    projectId!: number;

    constructor(data?: ICopyFromProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CopyFromProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyFromProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ICopyFromProjectRequest {
    projectId: number;
}

export class CopyFromTestCycleRequest implements ICopyFromTestCycleRequest {
    testCycleId!: number;

    constructor(data?: ICopyFromTestCycleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.testCycleId = _data["testCycleId"];
        }
    }

    static fromJS(data: any): CopyFromTestCycleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyFromTestCycleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testCycleId"] = this.testCycleId;
        return data;
    }
}

export interface ICopyFromTestCycleRequest {
    testCycleId: number;
}

export class CopyFromTrainingCycleRequest implements ICopyFromTrainingCycleRequest {
    trainingCycleId!: number;

    constructor(data?: ICopyFromTrainingCycleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingCycleId = _data["trainingCycleId"];
        }
    }

    static fromJS(data: any): CopyFromTrainingCycleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyFromTrainingCycleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingCycleId"] = this.trainingCycleId;
        return data;
    }
}

export interface ICopyFromTrainingCycleRequest {
    trainingCycleId: number;
}

export class CostExpenseTypeDeltaRequest implements ICostExpenseTypeDeltaRequest {
    insert?: InsertCostExpenseTypeRequest[] | undefined;
    update?: UpdateCostExpenseTypeRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;

    constructor(data?: ICostExpenseTypeDeltaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertCostExpenseTypeRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateCostExpenseTypeRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteTenantIndetifyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostExpenseTypeDeltaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CostExpenseTypeDeltaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICostExpenseTypeDeltaRequest {
    insert?: InsertCostExpenseTypeRequest[] | undefined;
    update?: UpdateCostExpenseTypeRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;
}

export class CostExpenseTypeResponse implements ICostExpenseTypeResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    mandatoryAttachments!: boolean;

    constructor(data?: ICostExpenseTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.mandatoryAttachments = _data["mandatoryAttachments"];
        }
    }

    static fromJS(data: any): CostExpenseTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CostExpenseTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["mandatoryAttachments"] = this.mandatoryAttachments;
        return data;
    }
}

export interface ICostExpenseTypeResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    mandatoryAttachments: boolean;
}

export class CostExpenseTypeResponseItemsResponseModel implements ICostExpenseTypeResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: CostExpenseTypeResponse[] | undefined;

    constructor(data?: ICostExpenseTypeResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CostExpenseTypeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostExpenseTypeResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CostExpenseTypeResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICostExpenseTypeResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: CostExpenseTypeResponse[] | undefined;
}

export class CreatePartnerApprovalRequest implements ICreatePartnerApprovalRequest {
    countryId!: number;
    name!: string;
    city!: string;
    address?: string | undefined;
    contactPerson?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    regNo?: string | undefined;
    vatNo!: string;
    iban?: string | undefined;
    swift?: string | undefined;

    constructor(data?: ICreatePartnerApprovalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.name = _data["name"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.contactPerson = _data["contactPerson"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.regNo = _data["regNo"];
            this.vatNo = _data["vatNo"];
            this.iban = _data["iban"];
            this.swift = _data["swift"];
        }
    }

    static fromJS(data: any): CreatePartnerApprovalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePartnerApprovalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["name"] = this.name;
        data["city"] = this.city;
        data["address"] = this.address;
        data["contactPerson"] = this.contactPerson;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["regNo"] = this.regNo;
        data["vatNo"] = this.vatNo;
        data["iban"] = this.iban;
        data["swift"] = this.swift;
        return data;
    }
}

export interface ICreatePartnerApprovalRequest {
    countryId: number;
    name: string;
    city: string;
    address?: string | undefined;
    contactPerson?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    regNo?: string | undefined;
    vatNo: string;
    iban?: string | undefined;
    swift?: string | undefined;
}

export class CreateProjectApprovalRequest implements ICreateProjectApprovalRequest {
    name!: string;
    projectManagerUserId!: number;
    from!: Date;
    to!: Date;

    constructor(data?: ICreateProjectApprovalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectManagerUserId = _data["projectManagerUserId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateProjectApprovalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectApprovalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectManagerUserId"] = this.projectManagerUserId;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        return data;
    }
}

export interface ICreateProjectApprovalRequest {
    name: string;
    projectManagerUserId: number;
    from: Date;
    to: Date;
}

export class CreateTeamMemberApprovalRequest implements ICreateTeamMemberApprovalRequest {
    projectId!: number;
    projectTeamId!: number;
    projectRoleId!: number;

    constructor(data?: ICreateTeamMemberApprovalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectTeamId = _data["projectTeamId"];
            this.projectRoleId = _data["projectRoleId"];
        }
    }

    static fromJS(data: any): CreateTeamMemberApprovalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeamMemberApprovalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectTeamId"] = this.projectTeamId;
        data["projectRoleId"] = this.projectRoleId;
        return data;
    }
}

export interface ICreateTeamMemberApprovalRequest {
    projectId: number;
    projectTeamId: number;
    projectRoleId: number;
}

export class DateRangeRequest implements IDateRangeRequest {
    from!: Date;
    to!: Date;

    constructor(data?: IDateRangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DateRangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        return data;
    }
}

export interface IDateRangeRequest {
    from: Date;
    to: Date;
}

export class DateTimeNewOld implements IDateTimeNewOld {
    oldValue?: Date | undefined;
    newValue?: Date | undefined;

    constructor(data?: IDateTimeNewOld) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldValue = _data["oldValue"] ? new Date(_data["oldValue"].toString()) : undefined as any;
            this.newValue = _data["newValue"] ? new Date(_data["newValue"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DateTimeNewOld {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeNewOld();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldValue"] = this.oldValue ? this.oldValue.toISOString() : undefined as any;
        data["newValue"] = this.newValue ? this.newValue.toISOString() : undefined as any;
        return data;
    }
}

export interface IDateTimeNewOld {
    oldValue?: Date | undefined;
    newValue?: Date | undefined;
}

export class DateTimePatternResponse implements IDateTimePatternResponse {
    id!: number;
    pattern!: string;

    constructor(data?: IDateTimePatternResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pattern = _data["pattern"];
        }
    }

    static fromJS(data: any): DateTimePatternResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimePatternResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pattern"] = this.pattern;
        return data;
    }
}

export interface IDateTimePatternResponse {
    id: number;
    pattern: string;
}

export class DateTimePatternResponseItemsResponseModel implements IDateTimePatternResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: DateTimePatternResponse[] | undefined;

    constructor(data?: IDateTimePatternResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DateTimePatternResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DateTimePatternResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimePatternResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDateTimePatternResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: DateTimePatternResponse[] | undefined;
}

export class DefaultProjectResponse implements IDefaultProjectResponse {
    userId!: number;
    projectId!: number;

    constructor(data?: IDefaultProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): DefaultProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IDefaultProjectResponse {
    userId: number;
    projectId: number;
}

export class DefaultProjectResponseSimpleResponseModel implements IDefaultProjectResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: DefaultProjectResponse;

    constructor(data?: IDefaultProjectResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? DefaultProjectResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): DefaultProjectResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultProjectResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IDefaultProjectResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: DefaultProjectResponse;
}

export class DeleteMeetingTopicRequest implements IDeleteMeetingTopicRequest {
    id!: number;
    type!: MeetingTopicTypeEnum;

    constructor(data?: IDeleteMeetingTopicRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): DeleteMeetingTopicRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMeetingTopicRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IDeleteMeetingTopicRequest {
    id: number;
    type: MeetingTopicTypeEnum;
}

export class DeleteProjectIdentifyRequest implements IDeleteProjectIdentifyRequest {
    id!: number;
    projectId!: number;

    constructor(data?: IDeleteProjectIdentifyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): DeleteProjectIdentifyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProjectIdentifyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IDeleteProjectIdentifyRequest {
    id: number;
    projectId: number;
}

export class DeleteScheduleResourcePlanRequest implements IDeleteScheduleResourcePlanRequest {
    id!: number;

    constructor(data?: IDeleteScheduleResourcePlanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteScheduleResourcePlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteScheduleResourcePlanRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteScheduleResourcePlanRequest {
    id: number;
}

export class DeleteSurveyProposedAnswerRequest implements IDeleteSurveyProposedAnswerRequest {
    id!: number;

    constructor(data?: IDeleteSurveyProposedAnswerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteSurveyProposedAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSurveyProposedAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteSurveyProposedAnswerRequest {
    id: number;
}

export class DeleteTenantIndetifyRequest implements IDeleteTenantIndetifyRequest {
    id!: number;

    constructor(data?: IDeleteTenantIndetifyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteTenantIndetifyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTenantIndetifyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteTenantIndetifyRequest {
    id: number;
}

export class DiscoveredTenantResponseModel implements IDiscoveredTenantResponseModel {
    tenantId!: number;
    name?: string | undefined;
    domain?: string | undefined;
    apiBaseUrl?: string | undefined;

    constructor(data?: IDiscoveredTenantResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.domain = _data["domain"];
            this.apiBaseUrl = _data["apiBaseUrl"];
        }
    }

    static fromJS(data: any): DiscoveredTenantResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DiscoveredTenantResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["domain"] = this.domain;
        data["apiBaseUrl"] = this.apiBaseUrl;
        return data;
    }
}

export interface IDiscoveredTenantResponseModel {
    tenantId: number;
    name?: string | undefined;
    domain?: string | undefined;
    apiBaseUrl?: string | undefined;
}

export class DiscoveredTenantResponseModelItemsResponseModel implements IDiscoveredTenantResponseModelItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: DiscoveredTenantResponseModel[] | undefined;

    constructor(data?: IDiscoveredTenantResponseModelItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiscoveredTenantResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DiscoveredTenantResponseModelItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DiscoveredTenantResponseModelItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDiscoveredTenantResponseModelItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: DiscoveredTenantResponseModel[] | undefined;
}

export class DiscoverTenantsRequestModel implements IDiscoverTenantsRequestModel {
    usernameOrEmail!: string;

    constructor(data?: IDiscoverTenantsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usernameOrEmail = _data["usernameOrEmail"];
        }
    }

    static fromJS(data: any): DiscoverTenantsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new DiscoverTenantsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usernameOrEmail"] = this.usernameOrEmail;
        return data;
    }
}

export interface IDiscoverTenantsRequestModel {
    usernameOrEmail: string;
}

export class DoubleSimpleResponseModel implements IDoubleSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value!: number;

    constructor(data?: IDoubleSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DoubleSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DoubleSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value;
        return data;
    }
}

export interface IDoubleSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value: number;
}

export enum EntityTypeEnum {
    Meeting = "Meeting",
    Vacation = "Vacation",
    Task = "Task",
    Reminder = "Reminder",
}

export class ExpenseItemResponse implements IExpenseItemResponse {
    id!: number;
    expenseTypeId!: number;
    amountProjectCurrency!: number;
    receiptCurrencyId?: number | undefined;
    amountReceiptCurrency?: number | undefined;
    comment?: string | undefined;
    attachments?: AttachmentResponse[] | undefined;

    constructor(data?: IExpenseItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.expenseTypeId = _data["expenseTypeId"];
            this.amountProjectCurrency = _data["amountProjectCurrency"];
            this.receiptCurrencyId = _data["receiptCurrencyId"];
            this.amountReceiptCurrency = _data["amountReceiptCurrency"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExpenseItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expenseTypeId"] = this.expenseTypeId;
        data["amountProjectCurrency"] = this.amountProjectCurrency;
        data["receiptCurrencyId"] = this.receiptCurrencyId;
        data["amountReceiptCurrency"] = this.amountReceiptCurrency;
        data["comment"] = this.comment;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExpenseItemResponse {
    id: number;
    expenseTypeId: number;
    amountProjectCurrency: number;
    receiptCurrencyId?: number | undefined;
    amountReceiptCurrency?: number | undefined;
    comment?: string | undefined;
    attachments?: AttachmentResponse[] | undefined;
}

export class ExpenseResponse implements IExpenseResponse {
    id!: number;
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    description!: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    statusId!: number;
    userId!: number;
    approvedOrRejectedByUserId?: number | undefined;
    approvedOrRejectedOn?: Date | undefined;
    date!: Date;
    amount!: number;
    expenseItems?: ExpenseItemResponse[] | undefined;

    constructor(data?: IExpenseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.description = _data["description"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.statusId = _data["statusId"];
            this.userId = _data["userId"];
            this.approvedOrRejectedByUserId = _data["approvedOrRejectedByUserId"];
            this.approvedOrRejectedOn = _data["approvedOrRejectedOn"] ? new Date(_data["approvedOrRejectedOn"].toString()) : undefined as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.amount = _data["amount"];
            if (Array.isArray(_data["expenseItems"])) {
                this.expenseItems = [] as any;
                for (let item of _data["expenseItems"])
                    this.expenseItems!.push(ExpenseItemResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExpenseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["description"] = this.description;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["statusId"] = this.statusId;
        data["userId"] = this.userId;
        data["approvedOrRejectedByUserId"] = this.approvedOrRejectedByUserId;
        data["approvedOrRejectedOn"] = this.approvedOrRejectedOn ? this.approvedOrRejectedOn.toISOString() : undefined as any;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["amount"] = this.amount;
        if (Array.isArray(this.expenseItems)) {
            data["expenseItems"] = [];
            for (let item of this.expenseItems)
                data["expenseItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExpenseResponse {
    id: number;
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    description: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    statusId: number;
    userId: number;
    approvedOrRejectedByUserId?: number | undefined;
    approvedOrRejectedOn?: Date | undefined;
    date: Date;
    amount: number;
    expenseItems?: ExpenseItemResponse[] | undefined;
}

export class ExpenseResponseItemsResponseModel implements IExpenseResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ExpenseResponse[] | undefined;

    constructor(data?: IExpenseResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExpenseResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExpenseResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExpenseResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ExpenseResponse[] | undefined;
}

export class ExpenseResponseSimpleResponseModel implements IExpenseResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ExpenseResponse;

    constructor(data?: IExpenseResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ExpenseResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ExpenseResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IExpenseResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ExpenseResponse;
}

export class ExpenseTotalsResponse implements IExpenseTotalsResponse {
    totalAmounts!: number;

    constructor(data?: IExpenseTotalsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAmounts = _data["totalAmounts"];
        }
    }

    static fromJS(data: any): ExpenseTotalsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseTotalsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAmounts"] = this.totalAmounts;
        return data;
    }
}

export interface IExpenseTotalsResponse {
    totalAmounts: number;
}

export class ExpenseTotalsResponseSimpleResponseModel implements IExpenseTotalsResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ExpenseTotalsResponse;

    constructor(data?: IExpenseTotalsResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ExpenseTotalsResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ExpenseTotalsResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseTotalsResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IExpenseTotalsResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ExpenseTotalsResponse;
}

export class ExportDataDecoraterPropertyModel implements IExportDataDecoraterPropertyModel {
    name!: string;
    format?: string | undefined;
    formats?: string[] | undefined;
    formatMap?: { [key: string]: string; } | undefined;

    constructor(data?: IExportDataDecoraterPropertyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.format = _data["format"];
            if (Array.isArray(_data["formats"])) {
                this.formats = [] as any;
                for (let item of _data["formats"])
                    this.formats!.push(item);
            }
            if (_data["formatMap"]) {
                this.formatMap = {} as any;
                for (let key in _data["formatMap"]) {
                    if (_data["formatMap"].hasOwnProperty(key))
                        (this.formatMap as any)![key] = _data["formatMap"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExportDataDecoraterPropertyModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportDataDecoraterPropertyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["format"] = this.format;
        if (Array.isArray(this.formats)) {
            data["formats"] = [];
            for (let item of this.formats)
                data["formats"].push(item);
        }
        if (this.formatMap) {
            data["formatMap"] = {};
            for (let key in this.formatMap) {
                if (this.formatMap.hasOwnProperty(key))
                    (data["formatMap"] as any)[key] = (this.formatMap as any)[key];
            }
        }
        return data;
    }
}

export interface IExportDataDecoraterPropertyModel {
    name: string;
    format?: string | undefined;
    formats?: string[] | undefined;
    formatMap?: { [key: string]: string; } | undefined;
}

export enum ExportDataFileTypeEnum {
    CSV = "CSV",
    PDF = "PDF",
    XLSX = "XLSX",
}

export class ExportDataModel implements IExportDataModel {
    offset!: number;
    limit!: number;
    filters?: GenericFilterModel[] | undefined;
    sorts?: GenericSortModel[] | undefined;
    includes?: string[] | undefined;
    fileType!: ExportDataFileTypeEnum;
    properties?: ExportDataPropertyModel[] | undefined;
    title?: string | undefined;
    timeZone?: string | undefined;
    timeZoneOffsetInMunutes?: number | undefined;

    constructor(data?: IExportDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"];
            this.limit = _data["limit"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(GenericFilterModel.fromJS(item));
            }
            if (Array.isArray(_data["sorts"])) {
                this.sorts = [] as any;
                for (let item of _data["sorts"])
                    this.sorts!.push(GenericSortModel.fromJS(item));
            }
            if (Array.isArray(_data["includes"])) {
                this.includes = [] as any;
                for (let item of _data["includes"])
                    this.includes!.push(item);
            }
            this.fileType = _data["fileType"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(ExportDataPropertyModel.fromJS(item));
            }
            this.title = _data["title"];
            this.timeZone = _data["timeZone"];
            this.timeZoneOffsetInMunutes = _data["timeZoneOffsetInMunutes"];
        }
    }

    static fromJS(data: any): ExportDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sorts)) {
            data["sorts"] = [];
            for (let item of this.sorts)
                data["sorts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.includes)) {
            data["includes"] = [];
            for (let item of this.includes)
                data["includes"].push(item);
        }
        data["fileType"] = this.fileType;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        data["title"] = this.title;
        data["timeZone"] = this.timeZone;
        data["timeZoneOffsetInMunutes"] = this.timeZoneOffsetInMunutes;
        return data;
    }
}

export interface IExportDataModel {
    offset: number;
    limit: number;
    filters?: GenericFilterModel[] | undefined;
    sorts?: GenericSortModel[] | undefined;
    includes?: string[] | undefined;
    fileType: ExportDataFileTypeEnum;
    properties?: ExportDataPropertyModel[] | undefined;
    title?: string | undefined;
    timeZone?: string | undefined;
    timeZoneOffsetInMunutes?: number | undefined;
}

export class ExportDataPropertyModel implements IExportDataPropertyModel {
    name!: string;
    displayName?: string | undefined;
    displayNames?: string[] | undefined;
    format?: string | undefined;
    formats?: string[] | undefined;
    formatMap?: { [key: string]: string; } | undefined;
    decoraterProperties?: ExportDataDecoraterPropertyModel[] | undefined;

    constructor(data?: IExportDataPropertyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            if (Array.isArray(_data["displayNames"])) {
                this.displayNames = [] as any;
                for (let item of _data["displayNames"])
                    this.displayNames!.push(item);
            }
            this.format = _data["format"];
            if (Array.isArray(_data["formats"])) {
                this.formats = [] as any;
                for (let item of _data["formats"])
                    this.formats!.push(item);
            }
            if (_data["formatMap"]) {
                this.formatMap = {} as any;
                for (let key in _data["formatMap"]) {
                    if (_data["formatMap"].hasOwnProperty(key))
                        (this.formatMap as any)![key] = _data["formatMap"][key];
                }
            }
            if (Array.isArray(_data["decoraterProperties"])) {
                this.decoraterProperties = [] as any;
                for (let item of _data["decoraterProperties"])
                    this.decoraterProperties!.push(ExportDataDecoraterPropertyModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportDataPropertyModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportDataPropertyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        if (Array.isArray(this.displayNames)) {
            data["displayNames"] = [];
            for (let item of this.displayNames)
                data["displayNames"].push(item);
        }
        data["format"] = this.format;
        if (Array.isArray(this.formats)) {
            data["formats"] = [];
            for (let item of this.formats)
                data["formats"].push(item);
        }
        if (this.formatMap) {
            data["formatMap"] = {};
            for (let key in this.formatMap) {
                if (this.formatMap.hasOwnProperty(key))
                    (data["formatMap"] as any)[key] = (this.formatMap as any)[key];
            }
        }
        if (Array.isArray(this.decoraterProperties)) {
            data["decoraterProperties"] = [];
            for (let item of this.decoraterProperties)
                data["decoraterProperties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExportDataPropertyModel {
    name: string;
    displayName?: string | undefined;
    displayNames?: string[] | undefined;
    format?: string | undefined;
    formats?: string[] | undefined;
    formatMap?: { [key: string]: string; } | undefined;
    decoraterProperties?: ExportDataDecoraterPropertyModel[] | undefined;
}

export class ExportForPeriodTimesheetsRequest implements IExportForPeriodTimesheetsRequest {
    offset!: number;
    limit!: number;
    filters?: GenericFilterModel[] | undefined;
    sorts?: GenericSortModel[] | undefined;
    includes?: string[] | undefined;
    fileType!: ExportDataFileTypeEnum;
    properties?: ExportDataPropertyModel[] | undefined;
    title?: string | undefined;
    timeZone?: string | undefined;
    timeZoneOffsetInMunutes?: number | undefined;
    from!: Date;
    to!: Date;

    constructor(data?: IExportForPeriodTimesheetsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"];
            this.limit = _data["limit"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(GenericFilterModel.fromJS(item));
            }
            if (Array.isArray(_data["sorts"])) {
                this.sorts = [] as any;
                for (let item of _data["sorts"])
                    this.sorts!.push(GenericSortModel.fromJS(item));
            }
            if (Array.isArray(_data["includes"])) {
                this.includes = [] as any;
                for (let item of _data["includes"])
                    this.includes!.push(item);
            }
            this.fileType = _data["fileType"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(ExportDataPropertyModel.fromJS(item));
            }
            this.title = _data["title"];
            this.timeZone = _data["timeZone"];
            this.timeZoneOffsetInMunutes = _data["timeZoneOffsetInMunutes"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ExportForPeriodTimesheetsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportForPeriodTimesheetsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sorts)) {
            data["sorts"] = [];
            for (let item of this.sorts)
                data["sorts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.includes)) {
            data["includes"] = [];
            for (let item of this.includes)
                data["includes"].push(item);
        }
        data["fileType"] = this.fileType;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        data["title"] = this.title;
        data["timeZone"] = this.timeZone;
        data["timeZoneOffsetInMunutes"] = this.timeZoneOffsetInMunutes;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        return data;
    }
}

export interface IExportForPeriodTimesheetsRequest {
    offset: number;
    limit: number;
    filters?: GenericFilterModel[] | undefined;
    sorts?: GenericSortModel[] | undefined;
    includes?: string[] | undefined;
    fileType: ExportDataFileTypeEnum;
    properties?: ExportDataPropertyModel[] | undefined;
    title?: string | undefined;
    timeZone?: string | undefined;
    timeZoneOffsetInMunutes?: number | undefined;
    from: Date;
    to: Date;
}

export class ExportProjectReportDataModel implements IExportProjectReportDataModel {
    title?: string | undefined;
    propertiesPerTablePerArea?: { [key: string]: ExportDataPropertyModel[][]; } | undefined;
    timeZone?: string | undefined;
    timeZoneOffsetInMunutes?: number | undefined;

    constructor(data?: IExportProjectReportDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            if (_data["propertiesPerTablePerArea"]) {
                this.propertiesPerTablePerArea = {} as any;
                for (let key in _data["propertiesPerTablePerArea"]) {
                    if (_data["propertiesPerTablePerArea"].hasOwnProperty(key))
                        (this.propertiesPerTablePerArea as any)![key] = _data["propertiesPerTablePerArea"][key] !== undefined ? _data["propertiesPerTablePerArea"][key] : [];
                }
            }
            this.timeZone = _data["timeZone"];
            this.timeZoneOffsetInMunutes = _data["timeZoneOffsetInMunutes"];
        }
    }

    static fromJS(data: any): ExportProjectReportDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportProjectReportDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        if (this.propertiesPerTablePerArea) {
            data["propertiesPerTablePerArea"] = {};
            for (let key in this.propertiesPerTablePerArea) {
                if (this.propertiesPerTablePerArea.hasOwnProperty(key))
                    (data["propertiesPerTablePerArea"] as any)[key] = (this.propertiesPerTablePerArea as any)[key];
            }
        }
        data["timeZone"] = this.timeZone;
        data["timeZoneOffsetInMunutes"] = this.timeZoneOffsetInMunutes;
        return data;
    }
}

export interface IExportProjectReportDataModel {
    title?: string | undefined;
    propertiesPerTablePerArea?: { [key: string]: ExportDataPropertyModel[][]; } | undefined;
    timeZone?: string | undefined;
    timeZoneOffsetInMunutes?: number | undefined;
}

export class ExportProjectsDataModel implements IExportProjectsDataModel {
    offset!: number;
    limit!: number;
    filters?: GenericFilterModel[] | undefined;
    sorts?: GenericSortModel[] | undefined;
    includes?: string[] | undefined;
    fileType!: ExportDataFileTypeEnum;
    properties?: ExportDataPropertyModel[] | undefined;
    title?: string | undefined;
    timeZone?: string | undefined;
    timeZoneOffsetInMunutes?: number | undefined;
    projectIds!: number[];

    constructor(data?: IExportProjectsDataModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.projectIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"];
            this.limit = _data["limit"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(GenericFilterModel.fromJS(item));
            }
            if (Array.isArray(_data["sorts"])) {
                this.sorts = [] as any;
                for (let item of _data["sorts"])
                    this.sorts!.push(GenericSortModel.fromJS(item));
            }
            if (Array.isArray(_data["includes"])) {
                this.includes = [] as any;
                for (let item of _data["includes"])
                    this.includes!.push(item);
            }
            this.fileType = _data["fileType"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(ExportDataPropertyModel.fromJS(item));
            }
            this.title = _data["title"];
            this.timeZone = _data["timeZone"];
            this.timeZoneOffsetInMunutes = _data["timeZoneOffsetInMunutes"];
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ExportProjectsDataModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportProjectsDataModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sorts)) {
            data["sorts"] = [];
            for (let item of this.sorts)
                data["sorts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.includes)) {
            data["includes"] = [];
            for (let item of this.includes)
                data["includes"].push(item);
        }
        data["fileType"] = this.fileType;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        data["title"] = this.title;
        data["timeZone"] = this.timeZone;
        data["timeZoneOffsetInMunutes"] = this.timeZoneOffsetInMunutes;
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        return data;
    }
}

export interface IExportProjectsDataModel {
    offset: number;
    limit: number;
    filters?: GenericFilterModel[] | undefined;
    sorts?: GenericSortModel[] | undefined;
    includes?: string[] | undefined;
    fileType: ExportDataFileTypeEnum;
    properties?: ExportDataPropertyModel[] | undefined;
    title?: string | undefined;
    timeZone?: string | undefined;
    timeZoneOffsetInMunutes?: number | undefined;
    projectIds: number[];
}

export enum FinanceCategoryEnum {
    Timesheets = "Timesheets",
    TravelExpenses = "TravelExpenses",
    Risks = "Risks",
    ChangeRequests = "ChangeRequests",
    Expenses = "Expenses",
}

export class FinanceCategoryResponse implements IFinanceCategoryResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isReadonly!: boolean;
    semantics!: FinanceCategoryEnum;

    constructor(data?: IFinanceCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isReadonly = _data["isReadonly"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): FinanceCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isReadonly"] = this.isReadonly;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IFinanceCategoryResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isReadonly: boolean;
    semantics: FinanceCategoryEnum;
}

export class FinanceCategoryResponseItemsResponseModel implements IFinanceCategoryResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: FinanceCategoryResponse[] | undefined;

    constructor(data?: IFinanceCategoryResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FinanceCategoryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FinanceCategoryResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceCategoryResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFinanceCategoryResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: FinanceCategoryResponse[] | undefined;
}

export class FinanceDashboardFilterRequest implements IFinanceDashboardFilterRequest {
    projectIds?: number[] | undefined;
    dateRange!: DateRangeRequest;
    partnerIds?: number[] | undefined;
    pmUserIds?: number[] | undefined;
    projectTypeIds?: number[] | undefined;
    projectCategoryIds?: number[] | undefined;
    projectStatusIds?: number[] | undefined;
    financeCategoryIds?: number[] | undefined;
    organizationalUnitIds?: number[] | undefined;

    constructor(data?: IFinanceDashboardFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dateRange = new DateRangeRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
            this.dateRange = _data["dateRange"] ? DateRangeRequest.fromJS(_data["dateRange"]) : new DateRangeRequest();
            if (Array.isArray(_data["partnerIds"])) {
                this.partnerIds = [] as any;
                for (let item of _data["partnerIds"])
                    this.partnerIds!.push(item);
            }
            if (Array.isArray(_data["pmUserIds"])) {
                this.pmUserIds = [] as any;
                for (let item of _data["pmUserIds"])
                    this.pmUserIds!.push(item);
            }
            if (Array.isArray(_data["projectTypeIds"])) {
                this.projectTypeIds = [] as any;
                for (let item of _data["projectTypeIds"])
                    this.projectTypeIds!.push(item);
            }
            if (Array.isArray(_data["projectCategoryIds"])) {
                this.projectCategoryIds = [] as any;
                for (let item of _data["projectCategoryIds"])
                    this.projectCategoryIds!.push(item);
            }
            if (Array.isArray(_data["projectStatusIds"])) {
                this.projectStatusIds = [] as any;
                for (let item of _data["projectStatusIds"])
                    this.projectStatusIds!.push(item);
            }
            if (Array.isArray(_data["financeCategoryIds"])) {
                this.financeCategoryIds = [] as any;
                for (let item of _data["financeCategoryIds"])
                    this.financeCategoryIds!.push(item);
            }
            if (Array.isArray(_data["organizationalUnitIds"])) {
                this.organizationalUnitIds = [] as any;
                for (let item of _data["organizationalUnitIds"])
                    this.organizationalUnitIds!.push(item);
            }
        }
    }

    static fromJS(data: any): FinanceDashboardFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceDashboardFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : undefined as any;
        if (Array.isArray(this.partnerIds)) {
            data["partnerIds"] = [];
            for (let item of this.partnerIds)
                data["partnerIds"].push(item);
        }
        if (Array.isArray(this.pmUserIds)) {
            data["pmUserIds"] = [];
            for (let item of this.pmUserIds)
                data["pmUserIds"].push(item);
        }
        if (Array.isArray(this.projectTypeIds)) {
            data["projectTypeIds"] = [];
            for (let item of this.projectTypeIds)
                data["projectTypeIds"].push(item);
        }
        if (Array.isArray(this.projectCategoryIds)) {
            data["projectCategoryIds"] = [];
            for (let item of this.projectCategoryIds)
                data["projectCategoryIds"].push(item);
        }
        if (Array.isArray(this.projectStatusIds)) {
            data["projectStatusIds"] = [];
            for (let item of this.projectStatusIds)
                data["projectStatusIds"].push(item);
        }
        if (Array.isArray(this.financeCategoryIds)) {
            data["financeCategoryIds"] = [];
            for (let item of this.financeCategoryIds)
                data["financeCategoryIds"].push(item);
        }
        if (Array.isArray(this.organizationalUnitIds)) {
            data["organizationalUnitIds"] = [];
            for (let item of this.organizationalUnitIds)
                data["organizationalUnitIds"].push(item);
        }
        return data;
    }
}

export interface IFinanceDashboardFilterRequest {
    projectIds?: number[] | undefined;
    dateRange: DateRangeRequest;
    partnerIds?: number[] | undefined;
    pmUserIds?: number[] | undefined;
    projectTypeIds?: number[] | undefined;
    projectCategoryIds?: number[] | undefined;
    projectStatusIds?: number[] | undefined;
    financeCategoryIds?: number[] | undefined;
    organizationalUnitIds?: number[] | undefined;
}

export class FinanceDashboardResponse implements IFinanceDashboardResponse {
    budgetVsActual?: BudgetVsActualDashboardResponse;
    partnersInvoices?: PartnersInvoicesDashboardResponse;
    projectActualBudget?: ProjectActualBudgetDashboardResponse;
    timesheets?: FinanceTmesheetsDashboardResponse;
    travelExpenses?: FinanceTravelExpensesDashboardResponse;

    constructor(data?: IFinanceDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetVsActual = _data["budgetVsActual"] ? BudgetVsActualDashboardResponse.fromJS(_data["budgetVsActual"]) : undefined as any;
            this.partnersInvoices = _data["partnersInvoices"] ? PartnersInvoicesDashboardResponse.fromJS(_data["partnersInvoices"]) : undefined as any;
            this.projectActualBudget = _data["projectActualBudget"] ? ProjectActualBudgetDashboardResponse.fromJS(_data["projectActualBudget"]) : undefined as any;
            this.timesheets = _data["timesheets"] ? FinanceTmesheetsDashboardResponse.fromJS(_data["timesheets"]) : undefined as any;
            this.travelExpenses = _data["travelExpenses"] ? FinanceTravelExpensesDashboardResponse.fromJS(_data["travelExpenses"]) : undefined as any;
        }
    }

    static fromJS(data: any): FinanceDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetVsActual"] = this.budgetVsActual ? this.budgetVsActual.toJSON() : undefined as any;
        data["partnersInvoices"] = this.partnersInvoices ? this.partnersInvoices.toJSON() : undefined as any;
        data["projectActualBudget"] = this.projectActualBudget ? this.projectActualBudget.toJSON() : undefined as any;
        data["timesheets"] = this.timesheets ? this.timesheets.toJSON() : undefined as any;
        data["travelExpenses"] = this.travelExpenses ? this.travelExpenses.toJSON() : undefined as any;
        return data;
    }
}

export interface IFinanceDashboardResponse {
    budgetVsActual?: BudgetVsActualDashboardResponse;
    partnersInvoices?: PartnersInvoicesDashboardResponse;
    projectActualBudget?: ProjectActualBudgetDashboardResponse;
    timesheets?: FinanceTmesheetsDashboardResponse;
    travelExpenses?: FinanceTravelExpensesDashboardResponse;
}

export class FinanceDashboardResponseSimpleResponseModel implements IFinanceDashboardResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: FinanceDashboardResponse;

    constructor(data?: IFinanceDashboardResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? FinanceDashboardResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): FinanceDashboardResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceDashboardResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IFinanceDashboardResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: FinanceDashboardResponse;
}

export class FinanceGeneralConfigResponse implements IFinanceGeneralConfigResponse {
    id!: number;
    planingInterval!: FinancePlaningIntervalEnum;

    constructor(data?: IFinanceGeneralConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.planingInterval = _data["planingInterval"];
        }
    }

    static fromJS(data: any): FinanceGeneralConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceGeneralConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["planingInterval"] = this.planingInterval;
        return data;
    }
}

export interface IFinanceGeneralConfigResponse {
    id: number;
    planingInterval: FinancePlaningIntervalEnum;
}

export class FinanceGeneralConfigResponseSimpleResponseModel implements IFinanceGeneralConfigResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: FinanceGeneralConfigResponse;

    constructor(data?: IFinanceGeneralConfigResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? FinanceGeneralConfigResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): FinanceGeneralConfigResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceGeneralConfigResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IFinanceGeneralConfigResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: FinanceGeneralConfigResponse;
}

export enum FinancePlaningIntervalEnum {
    Weekly = "Weekly",
    Monthly = "Monthly",
    Quarterly = "Quarterly",
    Yearly = "Yearly",
}

export class FinanceTmesheetsDashboardResponse implements IFinanceTmesheetsDashboardResponse {
    hoursPerProject?: { [key: string]: number; } | undefined;
    budgetVsActualTimesheets?: BudgetVsActualRowDashboardResponse[] | undefined;
    projectHoursPerPeriod?: ProjectHoursRowDashboardResponse[] | undefined;

    constructor(data?: IFinanceTmesheetsDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["hoursPerProject"]) {
                this.hoursPerProject = {} as any;
                for (let key in _data["hoursPerProject"]) {
                    if (_data["hoursPerProject"].hasOwnProperty(key))
                        (this.hoursPerProject as any)![key] = _data["hoursPerProject"][key];
                }
            }
            if (Array.isArray(_data["budgetVsActualTimesheets"])) {
                this.budgetVsActualTimesheets = [] as any;
                for (let item of _data["budgetVsActualTimesheets"])
                    this.budgetVsActualTimesheets!.push(BudgetVsActualRowDashboardResponse.fromJS(item));
            }
            if (Array.isArray(_data["projectHoursPerPeriod"])) {
                this.projectHoursPerPeriod = [] as any;
                for (let item of _data["projectHoursPerPeriod"])
                    this.projectHoursPerPeriod!.push(ProjectHoursRowDashboardResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FinanceTmesheetsDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceTmesheetsDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.hoursPerProject) {
            data["hoursPerProject"] = {};
            for (let key in this.hoursPerProject) {
                if (this.hoursPerProject.hasOwnProperty(key))
                    (data["hoursPerProject"] as any)[key] = (this.hoursPerProject as any)[key];
            }
        }
        if (Array.isArray(this.budgetVsActualTimesheets)) {
            data["budgetVsActualTimesheets"] = [];
            for (let item of this.budgetVsActualTimesheets)
                data["budgetVsActualTimesheets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectHoursPerPeriod)) {
            data["projectHoursPerPeriod"] = [];
            for (let item of this.projectHoursPerPeriod)
                data["projectHoursPerPeriod"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFinanceTmesheetsDashboardResponse {
    hoursPerProject?: { [key: string]: number; } | undefined;
    budgetVsActualTimesheets?: BudgetVsActualRowDashboardResponse[] | undefined;
    projectHoursPerPeriod?: ProjectHoursRowDashboardResponse[] | undefined;
}

export class FinanceTravelExpensesDashboardResponse implements IFinanceTravelExpensesDashboardResponse {
    travelExpensesPerCostType?: { [key: string]: number; } | undefined;
    travelExpensesPerProject?: { [key: string]: number; } | undefined;
    expensesPerCostType?: { [key: string]: number; } | undefined;
    expensesPerProject?: { [key: string]: number; } | undefined;

    constructor(data?: IFinanceTravelExpensesDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["travelExpensesPerCostType"]) {
                this.travelExpensesPerCostType = {} as any;
                for (let key in _data["travelExpensesPerCostType"]) {
                    if (_data["travelExpensesPerCostType"].hasOwnProperty(key))
                        (this.travelExpensesPerCostType as any)![key] = _data["travelExpensesPerCostType"][key];
                }
            }
            if (_data["travelExpensesPerProject"]) {
                this.travelExpensesPerProject = {} as any;
                for (let key in _data["travelExpensesPerProject"]) {
                    if (_data["travelExpensesPerProject"].hasOwnProperty(key))
                        (this.travelExpensesPerProject as any)![key] = _data["travelExpensesPerProject"][key];
                }
            }
            if (_data["expensesPerCostType"]) {
                this.expensesPerCostType = {} as any;
                for (let key in _data["expensesPerCostType"]) {
                    if (_data["expensesPerCostType"].hasOwnProperty(key))
                        (this.expensesPerCostType as any)![key] = _data["expensesPerCostType"][key];
                }
            }
            if (_data["expensesPerProject"]) {
                this.expensesPerProject = {} as any;
                for (let key in _data["expensesPerProject"]) {
                    if (_data["expensesPerProject"].hasOwnProperty(key))
                        (this.expensesPerProject as any)![key] = _data["expensesPerProject"][key];
                }
            }
        }
    }

    static fromJS(data: any): FinanceTravelExpensesDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceTravelExpensesDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.travelExpensesPerCostType) {
            data["travelExpensesPerCostType"] = {};
            for (let key in this.travelExpensesPerCostType) {
                if (this.travelExpensesPerCostType.hasOwnProperty(key))
                    (data["travelExpensesPerCostType"] as any)[key] = (this.travelExpensesPerCostType as any)[key];
            }
        }
        if (this.travelExpensesPerProject) {
            data["travelExpensesPerProject"] = {};
            for (let key in this.travelExpensesPerProject) {
                if (this.travelExpensesPerProject.hasOwnProperty(key))
                    (data["travelExpensesPerProject"] as any)[key] = (this.travelExpensesPerProject as any)[key];
            }
        }
        if (this.expensesPerCostType) {
            data["expensesPerCostType"] = {};
            for (let key in this.expensesPerCostType) {
                if (this.expensesPerCostType.hasOwnProperty(key))
                    (data["expensesPerCostType"] as any)[key] = (this.expensesPerCostType as any)[key];
            }
        }
        if (this.expensesPerProject) {
            data["expensesPerProject"] = {};
            for (let key in this.expensesPerProject) {
                if (this.expensesPerProject.hasOwnProperty(key))
                    (data["expensesPerProject"] as any)[key] = (this.expensesPerProject as any)[key];
            }
        }
        return data;
    }
}

export interface IFinanceTravelExpensesDashboardResponse {
    travelExpensesPerCostType?: { [key: string]: number; } | undefined;
    travelExpensesPerProject?: { [key: string]: number; } | undefined;
    expensesPerCostType?: { [key: string]: number; } | undefined;
    expensesPerProject?: { [key: string]: number; } | undefined;
}

export class FloatOldNew implements IFloatOldNew {
    oldValue?: number | undefined;
    newValue?: number | undefined;

    constructor(data?: IFloatOldNew) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): FloatOldNew {
        data = typeof data === 'object' ? data : {};
        let result = new FloatOldNew();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IFloatOldNew {
    oldValue?: number | undefined;
    newValue?: number | undefined;
}

export class ForgotPasswordFinishRequestModel implements IForgotPasswordFinishRequestModel {
    password?: string | undefined;
    passwordConfirmation!: string;
    token!: string;
    userId!: number;
    tenantId!: number;

    constructor(data?: IForgotPasswordFinishRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
            this.passwordConfirmation = _data["passwordConfirmation"];
            this.token = _data["token"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): ForgotPasswordFinishRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordFinishRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["passwordConfirmation"] = this.passwordConfirmation;
        data["token"] = this.token;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IForgotPasswordFinishRequestModel {
    password?: string | undefined;
    passwordConfirmation: string;
    token: string;
    userId: number;
    tenantId: number;
}

export class GenericFilterModel implements IGenericFilterModel {
    property?: string | undefined;
    innerProperty?: string | undefined;
    value?: any | undefined;
    secondValue?: any | undefined;
    operation?: GenericFilterOperationEnum;
    orFilters?: GenericFilterModel[] | undefined;

    constructor(data?: IGenericFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.innerProperty = _data["innerProperty"];
            this.value = _data["value"];
            this.secondValue = _data["secondValue"];
            this.operation = _data["operation"];
            if (Array.isArray(_data["orFilters"])) {
                this.orFilters = [] as any;
                for (let item of _data["orFilters"])
                    this.orFilters!.push(GenericFilterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GenericFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenericFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["innerProperty"] = this.innerProperty;
        data["value"] = this.value;
        data["secondValue"] = this.secondValue;
        data["operation"] = this.operation;
        if (Array.isArray(this.orFilters)) {
            data["orFilters"] = [];
            for (let item of this.orFilters)
                data["orFilters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGenericFilterModel {
    property?: string | undefined;
    innerProperty?: string | undefined;
    value?: any | undefined;
    secondValue?: any | undefined;
    operation?: GenericFilterOperationEnum;
    orFilters?: GenericFilterModel[] | undefined;
}

export class GenericFilterModelCollection implements IGenericFilterModelCollection {
    offset!: number;
    limit!: number;
    filters?: GenericFilterModel[] | undefined;
    sorts?: GenericSortModel[] | undefined;
    includes?: string[] | undefined;

    constructor(data?: IGenericFilterModelCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"];
            this.limit = _data["limit"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(GenericFilterModel.fromJS(item));
            }
            if (Array.isArray(_data["sorts"])) {
                this.sorts = [] as any;
                for (let item of _data["sorts"])
                    this.sorts!.push(GenericSortModel.fromJS(item));
            }
            if (Array.isArray(_data["includes"])) {
                this.includes = [] as any;
                for (let item of _data["includes"])
                    this.includes!.push(item);
            }
        }
    }

    static fromJS(data: any): GenericFilterModelCollection {
        data = typeof data === 'object' ? data : {};
        let result = new GenericFilterModelCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sorts)) {
            data["sorts"] = [];
            for (let item of this.sorts)
                data["sorts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.includes)) {
            data["includes"] = [];
            for (let item of this.includes)
                data["includes"].push(item);
        }
        return data;
    }
}

export interface IGenericFilterModelCollection {
    offset: number;
    limit: number;
    filters?: GenericFilterModel[] | undefined;
    sorts?: GenericSortModel[] | undefined;
    includes?: string[] | undefined;
}

export enum GenericFilterOperationEnum {
    EQUALS = "EQUALS",
    NOT_EQUALS = "NOT_EQUALS",
    GREATER_THAN = "GREATER_THAN",
    LESS_THAN = "LESS_THAN",
    GREATER_EQUAL_THAN = "GREATER_EQUAL_THAN",
    LESS_EQUAL_THAN = "LESS_EQUAL_THAN",
    IS_NULL = "IS_NULL",
    IS_NOT_NULL = "IS_NOT_NULL",
    LIKE = "LIKE",
    LIKE_STARTSWITH = "LIKE_STARTSWITH",
    LIKE_ENDSWITH = "LIKE_ENDSWITH",
    BETWEEN = "BETWEEN",
    CONTAINS = "CONTAINS",
}

export class GenericProjectsFilterModelCollection implements IGenericProjectsFilterModelCollection {
    offset!: number;
    limit!: number;
    filters?: GenericFilterModel[] | undefined;
    sorts?: GenericSortModel[] | undefined;
    includes?: string[] | undefined;
    projectIds!: number[];

    constructor(data?: IGenericProjectsFilterModelCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.projectIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offset = _data["offset"];
            this.limit = _data["limit"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(GenericFilterModel.fromJS(item));
            }
            if (Array.isArray(_data["sorts"])) {
                this.sorts = [] as any;
                for (let item of _data["sorts"])
                    this.sorts!.push(GenericSortModel.fromJS(item));
            }
            if (Array.isArray(_data["includes"])) {
                this.includes = [] as any;
                for (let item of _data["includes"])
                    this.includes!.push(item);
            }
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GenericProjectsFilterModelCollection {
        data = typeof data === 'object' ? data : {};
        let result = new GenericProjectsFilterModelCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.sorts)) {
            data["sorts"] = [];
            for (let item of this.sorts)
                data["sorts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.includes)) {
            data["includes"] = [];
            for (let item of this.includes)
                data["includes"].push(item);
        }
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        return data;
    }
}

export interface IGenericProjectsFilterModelCollection {
    offset: number;
    limit: number;
    filters?: GenericFilterModel[] | undefined;
    sorts?: GenericSortModel[] | undefined;
    includes?: string[] | undefined;
    projectIds: number[];
}

export class GenericSortModel implements IGenericSortModel {
    property?: string | undefined;
    isAsc!: boolean;

    constructor(data?: IGenericSortModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.isAsc = _data["isAsc"];
        }
    }

    static fromJS(data: any): GenericSortModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenericSortModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["isAsc"] = this.isAsc;
        return data;
    }
}

export interface IGenericSortModel {
    property?: string | undefined;
    isAsc: boolean;
}

export class GetProjectReportRequest implements IGetProjectReportRequest {
    id!: number;

    constructor(data?: IGetProjectReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetProjectReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetProjectReportRequest {
    id: number;
}

export class GetVacationsCalendarRequest implements IGetVacationsCalendarRequest {
    onlyCompanyUsers!: boolean;
    partnerIds?: number[] | undefined;
    organizationalUnitIds?: number[] | undefined;

    constructor(data?: IGetVacationsCalendarRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onlyCompanyUsers = _data["onlyCompanyUsers"];
            if (Array.isArray(_data["partnerIds"])) {
                this.partnerIds = [] as any;
                for (let item of _data["partnerIds"])
                    this.partnerIds!.push(item);
            }
            if (Array.isArray(_data["organizationalUnitIds"])) {
                this.organizationalUnitIds = [] as any;
                for (let item of _data["organizationalUnitIds"])
                    this.organizationalUnitIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetVacationsCalendarRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetVacationsCalendarRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onlyCompanyUsers"] = this.onlyCompanyUsers;
        if (Array.isArray(this.partnerIds)) {
            data["partnerIds"] = [];
            for (let item of this.partnerIds)
                data["partnerIds"].push(item);
        }
        if (Array.isArray(this.organizationalUnitIds)) {
            data["organizationalUnitIds"] = [];
            for (let item of this.organizationalUnitIds)
                data["organizationalUnitIds"].push(item);
        }
        return data;
    }
}

export interface IGetVacationsCalendarRequest {
    onlyCompanyUsers: boolean;
    partnerIds?: number[] | undefined;
    organizationalUnitIds?: number[] | undefined;
}

export class HolidayResponse implements IHolidayResponse {
    id!: number;
    isActive!: boolean;
    name!: string;
    from!: Date;
    to!: Date;
    reccuringEntry!: boolean;

    constructor(data?: IHolidayResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.name = _data["name"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.reccuringEntry = _data["reccuringEntry"];
        }
    }

    static fromJS(data: any): HolidayResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["reccuringEntry"] = this.reccuringEntry;
        return data;
    }
}

export interface IHolidayResponse {
    id: number;
    isActive: boolean;
    name: string;
    from: Date;
    to: Date;
    reccuringEntry: boolean;
}

export class IdNameProjectResponse implements IIdNameProjectResponse {
    id!: number;
    name!: string;
    projectId!: number;

    constructor(data?: IIdNameProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): IdNameProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IdNameProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IIdNameProjectResponse {
    id: number;
    name: string;
    projectId: number;
}

export class IdNameProjectResponseItemsResponseModel implements IIdNameProjectResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: IdNameProjectResponse[] | undefined;

    constructor(data?: IIdNameProjectResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IdNameProjectResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdNameProjectResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdNameProjectResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIdNameProjectResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: IdNameProjectResponse[] | undefined;
}

export class IdNameProjectResponseSimpleResponseModel implements IIdNameProjectResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: IdNameProjectResponse;

    constructor(data?: IIdNameProjectResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? IdNameProjectResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): IdNameProjectResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdNameProjectResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IIdNameProjectResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: IdNameProjectResponse;
}

export class IdNameResponse implements IIdNameResponse {
    id!: number;
    name!: string;

    constructor(data?: IIdNameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IdNameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IdNameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IIdNameResponse {
    id: number;
    name: string;
}

export class IdNameResponseItemsResponseModel implements IIdNameResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: IdNameResponse[] | undefined;

    constructor(data?: IIdNameResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IdNameResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdNameResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdNameResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIdNameResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: IdNameResponse[] | undefined;
}

export class IdNameResponseSimpleResponseModel implements IIdNameResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: IdNameResponse;

    constructor(data?: IIdNameResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? IdNameResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): IdNameResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdNameResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IIdNameResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: IdNameResponse;
}

export class IdNameSymbolResponse implements IIdNameSymbolResponse {
    id!: number;
    name!: string;
    symbol!: string;

    constructor(data?: IIdNameSymbolResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.symbol = _data["symbol"];
        }
    }

    static fromJS(data: any): IdNameSymbolResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IdNameSymbolResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["symbol"] = this.symbol;
        return data;
    }
}

export interface IIdNameSymbolResponse {
    id: number;
    name: string;
    symbol: string;
}

export class IdNameSymbolResponseItemsResponseModel implements IIdNameSymbolResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: IdNameSymbolResponse[] | undefined;

    constructor(data?: IIdNameSymbolResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IdNameSymbolResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdNameSymbolResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdNameSymbolResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIdNameSymbolResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: IdNameSymbolResponse[] | undefined;
}

export enum ImpactEnum {
    High = "High",
    Medium = "Medium",
    Low = "Low",
}

export class ImpactResponse implements IImpactResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    semantics!: ImpactEnum;

    constructor(data?: IImpactResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): ImpactResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImpactResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IImpactResponse {
    id: number;
    name: string;
    description?: string | undefined;
    semantics: ImpactEnum;
}

export class ImpactResponseItemsResponseModel implements IImpactResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ImpactResponse[] | undefined;

    constructor(data?: IImpactResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ImpactResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImpactResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpactResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImpactResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ImpactResponse[] | undefined;
}

export class ImportedFileResponse implements IImportedFileResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    userId?: number | undefined;
    createdAt!: Date;

    constructor(data?: IImportedFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.userId = _data["userId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ImportedFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportedFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["userId"] = this.userId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IImportedFileResponse {
    id: number;
    name: string;
    description?: string | undefined;
    userId?: number | undefined;
    createdAt: Date;
}

export class ImportedFileResponseItemsResponseModel implements IImportedFileResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ImportedFileResponse[] | undefined;

    constructor(data?: IImportedFileResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ImportedFileResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportedFileResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportedFileResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportedFileResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ImportedFileResponse[] | undefined;
}

export enum IncomeExpenseEnum {
    Income = "Income",
    Expense = "Expense",
}

export class IncomeExpenseProfitDashboardResponse implements IIncomeExpenseProfitDashboardResponse {
    budgetIncome!: number;
    actualBudgetIncome!: number;
    readonly differenceIncome!: number;
    budgetExpense!: number;
    actualBudgetExpense!: number;
    readonly differenceExpense!: number;
    readonly budgetProfit!: number;
    readonly budgetProfitPercent!: number;
    readonly actualBudgetProfit!: number;
    readonly actualBudgetProfitPercent!: number;
    readonly differenceProfit!: number;

    constructor(data?: IIncomeExpenseProfitDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetIncome = _data["budgetIncome"];
            this.actualBudgetIncome = _data["actualBudgetIncome"];
            (this as any).differenceIncome = _data["differenceIncome"];
            this.budgetExpense = _data["budgetExpense"];
            this.actualBudgetExpense = _data["actualBudgetExpense"];
            (this as any).differenceExpense = _data["differenceExpense"];
            (this as any).budgetProfit = _data["budgetProfit"];
            (this as any).budgetProfitPercent = _data["budgetProfitPercent"];
            (this as any).actualBudgetProfit = _data["actualBudgetProfit"];
            (this as any).actualBudgetProfitPercent = _data["actualBudgetProfitPercent"];
            (this as any).differenceProfit = _data["differenceProfit"];
        }
    }

    static fromJS(data: any): IncomeExpenseProfitDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeExpenseProfitDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetIncome"] = this.budgetIncome;
        data["actualBudgetIncome"] = this.actualBudgetIncome;
        data["differenceIncome"] = this.differenceIncome;
        data["budgetExpense"] = this.budgetExpense;
        data["actualBudgetExpense"] = this.actualBudgetExpense;
        data["differenceExpense"] = this.differenceExpense;
        data["budgetProfit"] = this.budgetProfit;
        data["budgetProfitPercent"] = this.budgetProfitPercent;
        data["actualBudgetProfit"] = this.actualBudgetProfit;
        data["actualBudgetProfitPercent"] = this.actualBudgetProfitPercent;
        data["differenceProfit"] = this.differenceProfit;
        return data;
    }
}

export interface IIncomeExpenseProfitDashboardResponse {
    budgetIncome: number;
    actualBudgetIncome: number;
    differenceIncome: number;
    budgetExpense: number;
    actualBudgetExpense: number;
    differenceExpense: number;
    budgetProfit: number;
    budgetProfitPercent: number;
    actualBudgetProfit: number;
    actualBudgetProfitPercent: number;
    differenceProfit: number;
}

export class IncomingOutgoingDashboardResponse implements IIncomingOutgoingDashboardResponse {
    incoming!: number;
    outgoing!: number;

    constructor(data?: IIncomingOutgoingDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incoming = _data["incoming"];
            this.outgoing = _data["outgoing"];
        }
    }

    static fromJS(data: any): IncomingOutgoingDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingOutgoingDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incoming"] = this.incoming;
        data["outgoing"] = this.outgoing;
        return data;
    }
}

export interface IIncomingOutgoingDashboardResponse {
    incoming: number;
    outgoing: number;
}

export class IncomingOutgoingOverdueDashboardResponse implements IIncomingOutgoingOverdueDashboardResponse {
    totalIncomingPlanned!: number;
    totalIncomingActual!: number;
    overdue1DayIncoming!: number;
    overdue30DaysIncoming!: number;
    overdue60DaysIncoming!: number;
    overdue90DaysIncoming!: number;
    totalOutgoingPlanned!: number;
    totalOutgoingActual!: number;
    overdue1DayOutgoing!: number;
    overdue30DaysOutgoing!: number;
    overdue60DaysOutgoing!: number;
    overdue90DaysOutgoing!: number;

    constructor(data?: IIncomingOutgoingOverdueDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalIncomingPlanned = _data["totalIncomingPlanned"];
            this.totalIncomingActual = _data["totalIncomingActual"];
            this.overdue1DayIncoming = _data["overdue1DayIncoming"];
            this.overdue30DaysIncoming = _data["overdue30DaysIncoming"];
            this.overdue60DaysIncoming = _data["overdue60DaysIncoming"];
            this.overdue90DaysIncoming = _data["overdue90DaysIncoming"];
            this.totalOutgoingPlanned = _data["totalOutgoingPlanned"];
            this.totalOutgoingActual = _data["totalOutgoingActual"];
            this.overdue1DayOutgoing = _data["overdue1DayOutgoing"];
            this.overdue30DaysOutgoing = _data["overdue30DaysOutgoing"];
            this.overdue60DaysOutgoing = _data["overdue60DaysOutgoing"];
            this.overdue90DaysOutgoing = _data["overdue90DaysOutgoing"];
        }
    }

    static fromJS(data: any): IncomingOutgoingOverdueDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncomingOutgoingOverdueDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalIncomingPlanned"] = this.totalIncomingPlanned;
        data["totalIncomingActual"] = this.totalIncomingActual;
        data["overdue1DayIncoming"] = this.overdue1DayIncoming;
        data["overdue30DaysIncoming"] = this.overdue30DaysIncoming;
        data["overdue60DaysIncoming"] = this.overdue60DaysIncoming;
        data["overdue90DaysIncoming"] = this.overdue90DaysIncoming;
        data["totalOutgoingPlanned"] = this.totalOutgoingPlanned;
        data["totalOutgoingActual"] = this.totalOutgoingActual;
        data["overdue1DayOutgoing"] = this.overdue1DayOutgoing;
        data["overdue30DaysOutgoing"] = this.overdue30DaysOutgoing;
        data["overdue60DaysOutgoing"] = this.overdue60DaysOutgoing;
        data["overdue90DaysOutgoing"] = this.overdue90DaysOutgoing;
        return data;
    }
}

export interface IIncomingOutgoingOverdueDashboardResponse {
    totalIncomingPlanned: number;
    totalIncomingActual: number;
    overdue1DayIncoming: number;
    overdue30DaysIncoming: number;
    overdue60DaysIncoming: number;
    overdue90DaysIncoming: number;
    totalOutgoingPlanned: number;
    totalOutgoingActual: number;
    overdue1DayOutgoing: number;
    overdue30DaysOutgoing: number;
    overdue60DaysOutgoing: number;
    overdue90DaysOutgoing: number;
}

export class InnerTestPlanResponse implements IInnerTestPlanResponse {
    id!: number;
    processStepId?: string | undefined;
    processStepName?: string | undefined;
    stepExpectedResults?: string | undefined;
    stepDocumentsCreated?: string | undefined;
    stepComment?: string | undefined;
    stepRejectionComment?: string | undefined;
    stepStatusId!: number;
    stepTesterUserId?: number | undefined;

    constructor(data?: IInnerTestPlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processStepId = _data["processStepId"];
            this.processStepName = _data["processStepName"];
            this.stepExpectedResults = _data["stepExpectedResults"];
            this.stepDocumentsCreated = _data["stepDocumentsCreated"];
            this.stepComment = _data["stepComment"];
            this.stepRejectionComment = _data["stepRejectionComment"];
            this.stepStatusId = _data["stepStatusId"];
            this.stepTesterUserId = _data["stepTesterUserId"];
        }
    }

    static fromJS(data: any): InnerTestPlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InnerTestPlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processStepId"] = this.processStepId;
        data["processStepName"] = this.processStepName;
        data["stepExpectedResults"] = this.stepExpectedResults;
        data["stepDocumentsCreated"] = this.stepDocumentsCreated;
        data["stepComment"] = this.stepComment;
        data["stepRejectionComment"] = this.stepRejectionComment;
        data["stepStatusId"] = this.stepStatusId;
        data["stepTesterUserId"] = this.stepTesterUserId;
        return data;
    }
}

export interface IInnerTestPlanResponse {
    id: number;
    processStepId?: string | undefined;
    processStepName?: string | undefined;
    stepExpectedResults?: string | undefined;
    stepDocumentsCreated?: string | undefined;
    stepComment?: string | undefined;
    stepRejectionComment?: string | undefined;
    stepStatusId: number;
    stepTesterUserId?: number | undefined;
}

export class InnerTestRowPlanResponse implements IInnerTestRowPlanResponse {
    id!: number;
    level4Id?: number | undefined;
    complexForScopeItemLevel4Id?: number | undefined;
    processStepId?: string | undefined;
    processStepName?: string | undefined;
    scopeDepartmentId?: number | undefined;
    scopeStepTypeId?: number | undefined;
    stepTesterUserId?: number | undefined;

    constructor(data?: IInnerTestRowPlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.level4Id = _data["level4Id"];
            this.complexForScopeItemLevel4Id = _data["complexForScopeItemLevel4Id"];
            this.processStepId = _data["processStepId"];
            this.processStepName = _data["processStepName"];
            this.scopeDepartmentId = _data["scopeDepartmentId"];
            this.scopeStepTypeId = _data["scopeStepTypeId"];
            this.stepTesterUserId = _data["stepTesterUserId"];
        }
    }

    static fromJS(data: any): InnerTestRowPlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InnerTestRowPlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["level4Id"] = this.level4Id;
        data["complexForScopeItemLevel4Id"] = this.complexForScopeItemLevel4Id;
        data["processStepId"] = this.processStepId;
        data["processStepName"] = this.processStepName;
        data["scopeDepartmentId"] = this.scopeDepartmentId;
        data["scopeStepTypeId"] = this.scopeStepTypeId;
        data["stepTesterUserId"] = this.stepTesterUserId;
        return data;
    }
}

export interface IInnerTestRowPlanResponse {
    id: number;
    level4Id?: number | undefined;
    complexForScopeItemLevel4Id?: number | undefined;
    processStepId?: string | undefined;
    processStepName?: string | undefined;
    scopeDepartmentId?: number | undefined;
    scopeStepTypeId?: number | undefined;
    stepTesterUserId?: number | undefined;
}

export class InsertAttachmentRequest implements IInsertAttachmentRequest {
    name!: string;
    description?: string | undefined;
    base64EncodedFile!: string;

    constructor(data?: IInsertAttachmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.base64EncodedFile = _data["base64EncodedFile"];
        }
    }

    static fromJS(data: any): InsertAttachmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertAttachmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["base64EncodedFile"] = this.base64EncodedFile;
        return data;
    }
}

export interface IInsertAttachmentRequest {
    name: string;
    description?: string | undefined;
    base64EncodedFile: string;
}

export class InsertBudgetRowRequest implements IInsertBudgetRowRequest {
    financeCategoryId!: number;
    userId?: number | undefined;
    partnerId?: number | undefined;
    incomeExpense!: IncomeExpenseEnum;
    customField?: string | undefined;
    budgetDateValues?: BudgetDateValueRequest[] | undefined;

    constructor(data?: IInsertBudgetRowRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financeCategoryId = _data["financeCategoryId"];
            this.userId = _data["userId"];
            this.partnerId = _data["partnerId"];
            this.incomeExpense = _data["incomeExpense"];
            this.customField = _data["customField"];
            if (Array.isArray(_data["budgetDateValues"])) {
                this.budgetDateValues = [] as any;
                for (let item of _data["budgetDateValues"])
                    this.budgetDateValues!.push(BudgetDateValueRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertBudgetRowRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertBudgetRowRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financeCategoryId"] = this.financeCategoryId;
        data["userId"] = this.userId;
        data["partnerId"] = this.partnerId;
        data["incomeExpense"] = this.incomeExpense;
        data["customField"] = this.customField;
        if (Array.isArray(this.budgetDateValues)) {
            data["budgetDateValues"] = [];
            for (let item of this.budgetDateValues)
                data["budgetDateValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertBudgetRowRequest {
    financeCategoryId: number;
    userId?: number | undefined;
    partnerId?: number | undefined;
    incomeExpense: IncomeExpenseEnum;
    customField?: string | undefined;
    budgetDateValues?: BudgetDateValueRequest[] | undefined;
}

export class InsertChangeRequestActivityRequest implements IInsertChangeRequestActivityRequest {
    name!: string;
    expectedDeliveryOn?: Date | undefined;
    effortInHours?: number | undefined;
    cost?: number | undefined;
    order!: number;

    constructor(data?: IInsertChangeRequestActivityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.expectedDeliveryOn = _data["expectedDeliveryOn"] ? new Date(_data["expectedDeliveryOn"].toString()) : undefined as any;
            this.effortInHours = _data["effortInHours"];
            this.cost = _data["cost"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): InsertChangeRequestActivityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertChangeRequestActivityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["expectedDeliveryOn"] = this.expectedDeliveryOn ? formatDate(this.expectedDeliveryOn) : undefined as any;
        data["effortInHours"] = this.effortInHours;
        data["cost"] = this.cost;
        data["order"] = this.order;
        return data;
    }
}

export interface IInsertChangeRequestActivityRequest {
    name: string;
    expectedDeliveryOn?: Date | undefined;
    effortInHours?: number | undefined;
    cost?: number | undefined;
    order: number;
}

export class InsertChangeRequestActivityRequestUpdateChangeRequestActivityRequestInt32DeltaModel implements IInsertChangeRequestActivityRequestUpdateChangeRequestActivityRequestInt32DeltaModel {
    insert?: InsertChangeRequestActivityRequest[] | undefined;
    update?: UpdateChangeRequestActivityRequest[] | undefined;
    delete?: number[] | undefined;

    constructor(data?: IInsertChangeRequestActivityRequestUpdateChangeRequestActivityRequestInt32DeltaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertChangeRequestActivityRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateChangeRequestActivityRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(item);
            }
        }
    }

    static fromJS(data: any): InsertChangeRequestActivityRequestUpdateChangeRequestActivityRequestInt32DeltaModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsertChangeRequestActivityRequestUpdateChangeRequestActivityRequestInt32DeltaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item);
        }
        return data;
    }
}

export interface IInsertChangeRequestActivityRequestUpdateChangeRequestActivityRequestInt32DeltaModel {
    insert?: InsertChangeRequestActivityRequest[] | undefined;
    update?: UpdateChangeRequestActivityRequest[] | undefined;
    delete?: number[] | undefined;
}

export class InsertChangeRequestRequest implements IInsertChangeRequestRequest {
    name!: string;
    description?: string | undefined;
    analysisUserId?: number | undefined;
    initiatedBy?: string | undefined;
    requestedOn?: Date | undefined;
    typeId?: number | undefined;
    goLiveCritical!: boolean;
    impactId!: number;
    urgencyId!: number;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    expectedCompletionDate?: Date | undefined;
    scopeItemLevelIdsToAdd?: number[] | undefined;
    ticketIdsToAdd?: number[] | undefined;
    reasonOfChange?: string | undefined;
    expectedBenefit?: string | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    isInitiate!: boolean;
    sendEmail!: boolean;

    constructor(data?: IInsertChangeRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.analysisUserId = _data["analysisUserId"];
            this.initiatedBy = _data["initiatedBy"];
            this.requestedOn = _data["requestedOn"] ? new Date(_data["requestedOn"].toString()) : undefined as any;
            this.typeId = _data["typeId"];
            this.goLiveCritical = _data["goLiveCritical"];
            this.impactId = _data["impactId"];
            this.urgencyId = _data["urgencyId"];
            this.projectTeamId = _data["projectTeamId"];
            this.projectOrganizationId = _data["projectOrganizationId"];
            this.expectedCompletionDate = _data["expectedCompletionDate"] ? new Date(_data["expectedCompletionDate"].toString()) : undefined as any;
            if (Array.isArray(_data["scopeItemLevelIdsToAdd"])) {
                this.scopeItemLevelIdsToAdd = [] as any;
                for (let item of _data["scopeItemLevelIdsToAdd"])
                    this.scopeItemLevelIdsToAdd!.push(item);
            }
            if (Array.isArray(_data["ticketIdsToAdd"])) {
                this.ticketIdsToAdd = [] as any;
                for (let item of _data["ticketIdsToAdd"])
                    this.ticketIdsToAdd!.push(item);
            }
            this.reasonOfChange = _data["reasonOfChange"];
            this.expectedBenefit = _data["expectedBenefit"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            this.isInitiate = _data["isInitiate"];
            this.sendEmail = _data["sendEmail"];
        }
    }

    static fromJS(data: any): InsertChangeRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertChangeRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["analysisUserId"] = this.analysisUserId;
        data["initiatedBy"] = this.initiatedBy;
        data["requestedOn"] = this.requestedOn ? formatDate(this.requestedOn) : undefined as any;
        data["typeId"] = this.typeId;
        data["goLiveCritical"] = this.goLiveCritical;
        data["impactId"] = this.impactId;
        data["urgencyId"] = this.urgencyId;
        data["projectTeamId"] = this.projectTeamId;
        data["projectOrganizationId"] = this.projectOrganizationId;
        data["expectedCompletionDate"] = this.expectedCompletionDate ? formatDate(this.expectedCompletionDate) : undefined as any;
        if (Array.isArray(this.scopeItemLevelIdsToAdd)) {
            data["scopeItemLevelIdsToAdd"] = [];
            for (let item of this.scopeItemLevelIdsToAdd)
                data["scopeItemLevelIdsToAdd"].push(item);
        }
        if (Array.isArray(this.ticketIdsToAdd)) {
            data["ticketIdsToAdd"] = [];
            for (let item of this.ticketIdsToAdd)
                data["ticketIdsToAdd"].push(item);
        }
        data["reasonOfChange"] = this.reasonOfChange;
        data["expectedBenefit"] = this.expectedBenefit;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["isInitiate"] = this.isInitiate;
        data["sendEmail"] = this.sendEmail;
        return data;
    }
}

export interface IInsertChangeRequestRequest {
    name: string;
    description?: string | undefined;
    analysisUserId?: number | undefined;
    initiatedBy?: string | undefined;
    requestedOn?: Date | undefined;
    typeId?: number | undefined;
    goLiveCritical: boolean;
    impactId: number;
    urgencyId: number;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    expectedCompletionDate?: Date | undefined;
    scopeItemLevelIdsToAdd?: number[] | undefined;
    ticketIdsToAdd?: number[] | undefined;
    reasonOfChange?: string | undefined;
    expectedBenefit?: string | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    isInitiate: boolean;
    sendEmail: boolean;
}

export class InsertCostExpenseTypeRequest implements IInsertCostExpenseTypeRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    mandatoryAttachments!: boolean;

    constructor(data?: IInsertCostExpenseTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.mandatoryAttachments = _data["mandatoryAttachments"];
        }
    }

    static fromJS(data: any): InsertCostExpenseTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertCostExpenseTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["mandatoryAttachments"] = this.mandatoryAttachments;
        return data;
    }
}

export interface IInsertCostExpenseTypeRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    mandatoryAttachments: boolean;
}

export class InsertExpenseItemRequest implements IInsertExpenseItemRequest {
    expenseTypeId!: number;
    amountProjectCurrency!: number;
    receiptCurrencyId?: number | undefined;
    amountReceiptCurrency?: number | undefined;
    comment?: string | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;

    constructor(data?: IInsertExpenseItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenseTypeId = _data["expenseTypeId"];
            this.amountProjectCurrency = _data["amountProjectCurrency"];
            this.receiptCurrencyId = _data["receiptCurrencyId"];
            this.amountReceiptCurrency = _data["amountReceiptCurrency"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertExpenseItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertExpenseItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenseTypeId"] = this.expenseTypeId;
        data["amountProjectCurrency"] = this.amountProjectCurrency;
        data["receiptCurrencyId"] = this.receiptCurrencyId;
        data["amountReceiptCurrency"] = this.amountReceiptCurrency;
        data["comment"] = this.comment;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertExpenseItemRequest {
    expenseTypeId: number;
    amountProjectCurrency: number;
    receiptCurrencyId?: number | undefined;
    amountReceiptCurrency?: number | undefined;
    comment?: string | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
}

export class InsertExpenseItemRequestUpdateExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel implements IInsertExpenseItemRequestUpdateExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel {
    insert?: InsertExpenseItemRequest[] | undefined;
    update?: UpdateExpenseItemRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;

    constructor(data?: IInsertExpenseItemRequestUpdateExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertExpenseItemRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateExpenseItemRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteTenantIndetifyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertExpenseItemRequestUpdateExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsertExpenseItemRequestUpdateExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertExpenseItemRequestUpdateExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel {
    insert?: InsertExpenseItemRequest[] | undefined;
    update?: UpdateExpenseItemRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;
}

export class InsertExpenseRequest implements IInsertExpenseRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    description!: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease!: boolean;
    date!: Date;
    newExpenseItems?: InsertExpenseItemRequest[] | undefined;

    constructor(data?: IInsertExpenseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.description = _data["description"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.isRelease = _data["isRelease"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            if (Array.isArray(_data["newExpenseItems"])) {
                this.newExpenseItems = [] as any;
                for (let item of _data["newExpenseItems"])
                    this.newExpenseItems!.push(InsertExpenseItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertExpenseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertExpenseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["description"] = this.description;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["isRelease"] = this.isRelease;
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        if (Array.isArray(this.newExpenseItems)) {
            data["newExpenseItems"] = [];
            for (let item of this.newExpenseItems)
                data["newExpenseItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertExpenseRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    description: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease: boolean;
    date: Date;
    newExpenseItems?: InsertExpenseItemRequest[] | undefined;
}

export class InsertHolidayRequest implements IInsertHolidayRequest {
    isActive!: boolean;
    name!: string;
    from!: Date;
    to!: Date;
    reccuringEntry!: boolean;

    constructor(data?: IInsertHolidayRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.name = _data["name"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.reccuringEntry = _data["reccuringEntry"];
        }
    }

    static fromJS(data: any): InsertHolidayRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertHolidayRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["reccuringEntry"] = this.reccuringEntry;
        return data;
    }
}

export interface IInsertHolidayRequest {
    isActive: boolean;
    name: string;
    from: Date;
    to: Date;
    reccuringEntry: boolean;
}

export class InsertHolidayRequestUpdateHolidayRequestInt32DeltaModel implements IInsertHolidayRequestUpdateHolidayRequestInt32DeltaModel {
    insert?: InsertHolidayRequest[] | undefined;
    update?: UpdateHolidayRequest[] | undefined;
    delete?: number[] | undefined;

    constructor(data?: IInsertHolidayRequestUpdateHolidayRequestInt32DeltaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertHolidayRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateHolidayRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(item);
            }
        }
    }

    static fromJS(data: any): InsertHolidayRequestUpdateHolidayRequestInt32DeltaModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsertHolidayRequestUpdateHolidayRequestInt32DeltaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item);
        }
        return data;
    }
}

export interface IInsertHolidayRequestUpdateHolidayRequestInt32DeltaModel {
    insert?: InsertHolidayRequest[] | undefined;
    update?: UpdateHolidayRequest[] | undefined;
    delete?: number[] | undefined;
}

export class InsertInvoiceItemRequest implements IInsertInvoiceItemRequest {
    description!: string;
    amount!: number;
    taxAmount!: number;
    localCurrencyAmount?: number | undefined;
    localCurrencyTaxAmount?: number | undefined;

    constructor(data?: IInsertInvoiceItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.taxAmount = _data["taxAmount"];
            this.localCurrencyAmount = _data["localCurrencyAmount"];
            this.localCurrencyTaxAmount = _data["localCurrencyTaxAmount"];
        }
    }

    static fromJS(data: any): InsertInvoiceItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertInvoiceItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["taxAmount"] = this.taxAmount;
        data["localCurrencyAmount"] = this.localCurrencyAmount;
        data["localCurrencyTaxAmount"] = this.localCurrencyTaxAmount;
        return data;
    }
}

export interface IInsertInvoiceItemRequest {
    description: string;
    amount: number;
    taxAmount: number;
    localCurrencyAmount?: number | undefined;
    localCurrencyTaxAmount?: number | undefined;
}

export class InsertInvoiceItemRequestUpdateInvoiceItemRequestDeleteTenantIndetifyRequestDeltaModel implements IInsertInvoiceItemRequestUpdateInvoiceItemRequestDeleteTenantIndetifyRequestDeltaModel {
    insert?: InsertInvoiceItemRequest[] | undefined;
    update?: UpdateInvoiceItemRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;

    constructor(data?: IInsertInvoiceItemRequestUpdateInvoiceItemRequestDeleteTenantIndetifyRequestDeltaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertInvoiceItemRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateInvoiceItemRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteTenantIndetifyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertInvoiceItemRequestUpdateInvoiceItemRequestDeleteTenantIndetifyRequestDeltaModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsertInvoiceItemRequestUpdateInvoiceItemRequestDeleteTenantIndetifyRequestDeltaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertInvoiceItemRequestUpdateInvoiceItemRequestDeleteTenantIndetifyRequestDeltaModel {
    insert?: InsertInvoiceItemRequest[] | undefined;
    update?: UpdateInvoiceItemRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;
}

export class InsertInvoiceRequest implements IInsertInvoiceRequest {
    partnerId!: number;
    invoiceNumber!: string;
    description?: string | undefined;
    invoiceType!: InvoiceTypeEnum;
    issueDate!: Date;
    due!: Date;
    overdueDays?: number | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    excludeFromBudget!: boolean;
    amount!: number;
    taxAmount!: number;
    localCurrencyId?: number | undefined;
    localCurrencyAmount?: number | undefined;
    localCurrencyTaxAmount?: number | undefined;
    comment?: string | undefined;
    changeRequestId?: number | undefined;
    financeCategoryId!: number;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    invoiceItemsDelta?: InsertInvoiceItemRequestUpdateInvoiceItemRequestDeleteTenantIndetifyRequestDeltaModel;

    constructor(data?: IInsertInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.description = _data["description"];
            this.invoiceType = _data["invoiceType"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            this.overdueDays = _data["overdueDays"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.excludeFromBudget = _data["excludeFromBudget"];
            this.amount = _data["amount"];
            this.taxAmount = _data["taxAmount"];
            this.localCurrencyId = _data["localCurrencyId"];
            this.localCurrencyAmount = _data["localCurrencyAmount"];
            this.localCurrencyTaxAmount = _data["localCurrencyTaxAmount"];
            this.comment = _data["comment"];
            this.changeRequestId = _data["changeRequestId"];
            this.financeCategoryId = _data["financeCategoryId"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            this.invoiceItemsDelta = _data["invoiceItemsDelta"] ? InsertInvoiceItemRequestUpdateInvoiceItemRequestDeleteTenantIndetifyRequestDeltaModel.fromJS(_data["invoiceItemsDelta"]) : undefined as any;
        }
    }

    static fromJS(data: any): InsertInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["description"] = this.description;
        data["invoiceType"] = this.invoiceType;
        data["issueDate"] = this.issueDate ? formatDate(this.issueDate) : undefined as any;
        data["due"] = this.due ? formatDate(this.due) : undefined as any;
        data["overdueDays"] = this.overdueDays;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["excludeFromBudget"] = this.excludeFromBudget;
        data["amount"] = this.amount;
        data["taxAmount"] = this.taxAmount;
        data["localCurrencyId"] = this.localCurrencyId;
        data["localCurrencyAmount"] = this.localCurrencyAmount;
        data["localCurrencyTaxAmount"] = this.localCurrencyTaxAmount;
        data["comment"] = this.comment;
        data["changeRequestId"] = this.changeRequestId;
        data["financeCategoryId"] = this.financeCategoryId;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["invoiceItemsDelta"] = this.invoiceItemsDelta ? this.invoiceItemsDelta.toJSON() : undefined as any;
        return data;
    }
}

export interface IInsertInvoiceRequest {
    partnerId: number;
    invoiceNumber: string;
    description?: string | undefined;
    invoiceType: InvoiceTypeEnum;
    issueDate: Date;
    due: Date;
    overdueDays?: number | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    excludeFromBudget: boolean;
    amount: number;
    taxAmount: number;
    localCurrencyId?: number | undefined;
    localCurrencyAmount?: number | undefined;
    localCurrencyTaxAmount?: number | undefined;
    comment?: string | undefined;
    changeRequestId?: number | undefined;
    financeCategoryId: number;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    invoiceItemsDelta?: InsertInvoiceItemRequestUpdateInvoiceItemRequestDeleteTenantIndetifyRequestDeltaModel;
}

export class InsertMeetingCommentRequest implements IInsertMeetingCommentRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    meetingId!: number;
    comment!: string;
    meetingTopicId!: number;
    meetingTopicType!: MeetingTopicTypeEnum;

    constructor(data?: IInsertMeetingCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.meetingId = _data["meetingId"];
            this.comment = _data["comment"];
            this.meetingTopicId = _data["meetingTopicId"];
            this.meetingTopicType = _data["meetingTopicType"];
        }
    }

    static fromJS(data: any): InsertMeetingCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertMeetingCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["meetingId"] = this.meetingId;
        data["comment"] = this.comment;
        data["meetingTopicId"] = this.meetingTopicId;
        data["meetingTopicType"] = this.meetingTopicType;
        return data;
    }
}

export interface IInsertMeetingCommentRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    meetingId: number;
    comment: string;
    meetingTopicId: number;
    meetingTopicType: MeetingTopicTypeEnum;
}

export class InsertMeetingRequest implements IInsertMeetingRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    subject!: string;
    location?: string | undefined;
    duration?: number | undefined;
    starts!: Date;
    ends!: Date;
    agenda!: string;
    additionallParticipants?: string | undefined;
    isPrivate!: boolean;
    meetingTypeId?: number | undefined;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    participantUserIds?: number[] | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    topicsDelta?: InsertMeetingTopicRequestUpdateMeetingTopicRequestDeleteMeetingTopicRequestDeltaModel;

    constructor(data?: IInsertMeetingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.subject = _data["subject"];
            this.location = _data["location"];
            this.duration = _data["duration"];
            this.starts = _data["starts"] ? new Date(_data["starts"].toString()) : undefined as any;
            this.ends = _data["ends"] ? new Date(_data["ends"].toString()) : undefined as any;
            this.agenda = _data["agenda"];
            this.additionallParticipants = _data["additionallParticipants"];
            this.isPrivate = _data["isPrivate"];
            this.meetingTypeId = _data["meetingTypeId"];
            this.projectTeamId = _data["projectTeamId"];
            this.projectOrganizationId = _data["projectOrganizationId"];
            if (Array.isArray(_data["participantUserIds"])) {
                this.participantUserIds = [] as any;
                for (let item of _data["participantUserIds"])
                    this.participantUserIds!.push(item);
            }
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            this.topicsDelta = _data["topicsDelta"] ? InsertMeetingTopicRequestUpdateMeetingTopicRequestDeleteMeetingTopicRequestDeltaModel.fromJS(_data["topicsDelta"]) : undefined as any;
        }
    }

    static fromJS(data: any): InsertMeetingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertMeetingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["subject"] = this.subject;
        data["location"] = this.location;
        data["duration"] = this.duration;
        data["starts"] = this.starts ? this.starts.toISOString() : undefined as any;
        data["ends"] = this.ends ? this.ends.toISOString() : undefined as any;
        data["agenda"] = this.agenda;
        data["additionallParticipants"] = this.additionallParticipants;
        data["isPrivate"] = this.isPrivate;
        data["meetingTypeId"] = this.meetingTypeId;
        data["projectTeamId"] = this.projectTeamId;
        data["projectOrganizationId"] = this.projectOrganizationId;
        if (Array.isArray(this.participantUserIds)) {
            data["participantUserIds"] = [];
            for (let item of this.participantUserIds)
                data["participantUserIds"].push(item);
        }
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["topicsDelta"] = this.topicsDelta ? this.topicsDelta.toJSON() : undefined as any;
        return data;
    }
}

export interface IInsertMeetingRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    subject: string;
    location?: string | undefined;
    duration?: number | undefined;
    starts: Date;
    ends: Date;
    agenda: string;
    additionallParticipants?: string | undefined;
    isPrivate: boolean;
    meetingTypeId?: number | undefined;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    participantUserIds?: number[] | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    topicsDelta?: InsertMeetingTopicRequestUpdateMeetingTopicRequestDeleteMeetingTopicRequestDeltaModel;
}

export class InsertMeetingTopicRequest implements IInsertMeetingTopicRequest {
    description!: string;
    type!: MeetingTopicTypeEnum;
    order!: number;
    userId?: number | undefined;
    due?: Date | undefined;
    statusId?: number | undefined;

    constructor(data?: IInsertMeetingTopicRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.type = _data["type"];
            this.order = _data["order"];
            this.userId = _data["userId"];
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): InsertMeetingTopicRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertMeetingTopicRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["type"] = this.type;
        data["order"] = this.order;
        data["userId"] = this.userId;
        data["due"] = this.due ? formatDate(this.due) : undefined as any;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface IInsertMeetingTopicRequest {
    description: string;
    type: MeetingTopicTypeEnum;
    order: number;
    userId?: number | undefined;
    due?: Date | undefined;
    statusId?: number | undefined;
}

export class InsertMeetingTopicRequestUpdateMeetingTopicRequestDeleteMeetingTopicRequestDeltaModel implements IInsertMeetingTopicRequestUpdateMeetingTopicRequestDeleteMeetingTopicRequestDeltaModel {
    insert?: InsertMeetingTopicRequest[] | undefined;
    update?: UpdateMeetingTopicRequest[] | undefined;
    delete?: DeleteMeetingTopicRequest[] | undefined;

    constructor(data?: IInsertMeetingTopicRequestUpdateMeetingTopicRequestDeleteMeetingTopicRequestDeltaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertMeetingTopicRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateMeetingTopicRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteMeetingTopicRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertMeetingTopicRequestUpdateMeetingTopicRequestDeleteMeetingTopicRequestDeltaModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsertMeetingTopicRequestUpdateMeetingTopicRequestDeleteMeetingTopicRequestDeltaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertMeetingTopicRequestUpdateMeetingTopicRequestDeleteMeetingTopicRequestDeltaModel {
    insert?: InsertMeetingTopicRequest[] | undefined;
    update?: UpdateMeetingTopicRequest[] | undefined;
    delete?: DeleteMeetingTopicRequest[] | undefined;
}

export class InsertNonProjectCategoryRequest implements IInsertNonProjectCategoryRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    billable!: boolean;

    constructor(data?: IInsertNonProjectCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.billable = _data["billable"];
        }
    }

    static fromJS(data: any): InsertNonProjectCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertNonProjectCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["billable"] = this.billable;
        return data;
    }
}

export interface IInsertNonProjectCategoryRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    billable: boolean;
}

export class InsertOrganizationalUnitManagerRequest implements IInsertOrganizationalUnitManagerRequest {
    userId!: number;
    organizationalUnitId!: number;
    validUntil!: Date;
    isResourceManager!: boolean;

    constructor(data?: IInsertOrganizationalUnitManagerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.organizationalUnitId = _data["organizationalUnitId"];
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : undefined as any;
            this.isResourceManager = _data["isResourceManager"];
        }
    }

    static fromJS(data: any): InsertOrganizationalUnitManagerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertOrganizationalUnitManagerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organizationalUnitId"] = this.organizationalUnitId;
        data["validUntil"] = this.validUntil ? formatDate(this.validUntil) : undefined as any;
        data["isResourceManager"] = this.isResourceManager;
        return data;
    }
}

export interface IInsertOrganizationalUnitManagerRequest {
    userId: number;
    organizationalUnitId: number;
    validUntil: Date;
    isResourceManager: boolean;
}

export class InsertOrganizationalUnitRequest implements IInsertOrganizationalUnitRequest {
    name!: string;
    description?: string | undefined;
    parentId!: number;
    order!: number;

    constructor(data?: IInsertOrganizationalUnitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.parentId = _data["parentId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): InsertOrganizationalUnitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertOrganizationalUnitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentId"] = this.parentId;
        data["order"] = this.order;
        return data;
    }
}

export interface IInsertOrganizationalUnitRequest {
    name: string;
    description?: string | undefined;
    parentId: number;
    order: number;
}

export class InsertOrUpdateCalendarRequest implements IInsertOrUpdateCalendarRequest {
    countryId!: number;
    workWeekFrom!: WeekDayEnum;
    workWeekTo!: WeekDayEnum;
    workTimeFrom!: number;
    workTimeTo!: number;
    holidays?: InsertHolidayRequestUpdateHolidayRequestInt32DeltaModel;

    constructor(data?: IInsertOrUpdateCalendarRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.workWeekFrom = _data["workWeekFrom"];
            this.workWeekTo = _data["workWeekTo"];
            this.workTimeFrom = _data["workTimeFrom"];
            this.workTimeTo = _data["workTimeTo"];
            this.holidays = _data["holidays"] ? InsertHolidayRequestUpdateHolidayRequestInt32DeltaModel.fromJS(_data["holidays"]) : undefined as any;
        }
    }

    static fromJS(data: any): InsertOrUpdateCalendarRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertOrUpdateCalendarRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["workWeekFrom"] = this.workWeekFrom;
        data["workWeekTo"] = this.workWeekTo;
        data["workTimeFrom"] = this.workTimeFrom;
        data["workTimeTo"] = this.workTimeTo;
        data["holidays"] = this.holidays ? this.holidays.toJSON() : undefined as any;
        return data;
    }
}

export interface IInsertOrUpdateCalendarRequest {
    countryId: number;
    workWeekFrom: WeekDayEnum;
    workWeekTo: WeekDayEnum;
    workTimeFrom: number;
    workTimeTo: number;
    holidays?: InsertHolidayRequestUpdateHolidayRequestInt32DeltaModel;
}

export class InsertProjectAccomplishmentRequest implements IInsertProjectAccomplishmentRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    plannedDate?: Date | undefined;
    status!: ReportItemStatusEnum;

    constructor(data?: IInsertProjectAccomplishmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): InsertProjectAccomplishmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectAccomplishmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["plannedDate"] = this.plannedDate ? formatDate(this.plannedDate) : undefined as any;
        data["status"] = this.status;
        return data;
    }
}

export interface IInsertProjectAccomplishmentRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    plannedDate?: Date | undefined;
    status: ReportItemStatusEnum;
}

export class InsertProjectActionRequest implements IInsertProjectActionRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    reportId!: number;
    status!: ReportItemStatusEnum;

    constructor(data?: IInsertProjectActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.reportId = _data["reportId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): InsertProjectActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["reportId"] = this.reportId;
        data["status"] = this.status;
        return data;
    }
}

export interface IInsertProjectActionRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    reportId: number;
    status: ReportItemStatusEnum;
}

export class InsertProjectBusinessRequest implements IInsertProjectBusinessRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    value?: number | undefined;

    constructor(data?: IInsertProjectBusinessRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): InsertProjectBusinessRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectBusinessRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["value"] = this.value;
        return data;
    }
}

export interface IInsertProjectBusinessRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    value?: number | undefined;
}

export class InsertProjectChangeRequestRequest implements IInsertProjectChangeRequestRequest {
    name!: string;
    description?: string | undefined;
    initiatedBy?: string | undefined;
    approvedByUserId?: number | undefined;
    requestedOn?: Date | undefined;
    priority!: ChangeRequestPriorityEnum;
    completitionOn?: Date | undefined;
    statusId!: number;
    effortInHours?: number | undefined;
    totalCost?: number | undefined;
    estimatedEffortInHours?: number | undefined;
    estimatedTotalCost?: number | undefined;
    goLiveCritical!: boolean;

    constructor(data?: IInsertProjectChangeRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.initiatedBy = _data["initiatedBy"];
            this.approvedByUserId = _data["approvedByUserId"];
            this.requestedOn = _data["requestedOn"] ? new Date(_data["requestedOn"].toString()) : undefined as any;
            this.priority = _data["priority"];
            this.completitionOn = _data["completitionOn"] ? new Date(_data["completitionOn"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.effortInHours = _data["effortInHours"];
            this.totalCost = _data["totalCost"];
            this.estimatedEffortInHours = _data["estimatedEffortInHours"];
            this.estimatedTotalCost = _data["estimatedTotalCost"];
            this.goLiveCritical = _data["goLiveCritical"];
        }
    }

    static fromJS(data: any): InsertProjectChangeRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectChangeRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["initiatedBy"] = this.initiatedBy;
        data["approvedByUserId"] = this.approvedByUserId;
        data["requestedOn"] = this.requestedOn ? formatDate(this.requestedOn) : undefined as any;
        data["priority"] = this.priority;
        data["completitionOn"] = this.completitionOn ? formatDate(this.completitionOn) : undefined as any;
        data["statusId"] = this.statusId;
        data["effortInHours"] = this.effortInHours;
        data["totalCost"] = this.totalCost;
        data["estimatedEffortInHours"] = this.estimatedEffortInHours;
        data["estimatedTotalCost"] = this.estimatedTotalCost;
        data["goLiveCritical"] = this.goLiveCritical;
        return data;
    }
}

export interface IInsertProjectChangeRequestRequest {
    name: string;
    description?: string | undefined;
    initiatedBy?: string | undefined;
    approvedByUserId?: number | undefined;
    requestedOn?: Date | undefined;
    priority: ChangeRequestPriorityEnum;
    completitionOn?: Date | undefined;
    statusId: number;
    effortInHours?: number | undefined;
    totalCost?: number | undefined;
    estimatedEffortInHours?: number | undefined;
    estimatedTotalCost?: number | undefined;
    goLiveCritical: boolean;
}

export class InsertProjectDeliverableRequest implements IInsertProjectDeliverableRequest {
    name!: string;
    description?: string | undefined;
    wbs!: string;
    complete?: number | undefined;
    finish?: Date | undefined;
    achievedDate?: Date | undefined;

    constructor(data?: IInsertProjectDeliverableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.wbs = _data["wbs"];
            this.complete = _data["complete"];
            this.finish = _data["finish"] ? new Date(_data["finish"].toString()) : undefined as any;
            this.achievedDate = _data["achievedDate"] ? new Date(_data["achievedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InsertProjectDeliverableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectDeliverableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["wbs"] = this.wbs;
        data["complete"] = this.complete;
        data["finish"] = this.finish ? formatDate(this.finish) : undefined as any;
        data["achievedDate"] = this.achievedDate ? formatDate(this.achievedDate) : undefined as any;
        return data;
    }
}

export interface IInsertProjectDeliverableRequest {
    name: string;
    description?: string | undefined;
    wbs: string;
    complete?: number | undefined;
    finish?: Date | undefined;
    achievedDate?: Date | undefined;
}

export class InsertProjectFinanceRequest implements IInsertProjectFinanceRequest {
    name!: string;
    description?: string | undefined;
    invoiceType!: InvoiceTypeEnum;
    invoiceNumber!: string;
    partnerId!: number;
    issueDate!: Date;
    due!: Date;
    amount!: number;
    taxAmount!: number;
    statusId!: number;

    constructor(data?: IInsertProjectFinanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.invoiceType = _data["invoiceType"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.partnerId = _data["partnerId"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            this.amount = _data["amount"];
            this.taxAmount = _data["taxAmount"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): InsertProjectFinanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectFinanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["invoiceType"] = this.invoiceType;
        data["invoiceNumber"] = this.invoiceNumber;
        data["partnerId"] = this.partnerId;
        data["issueDate"] = this.issueDate ? formatDate(this.issueDate) : undefined as any;
        data["due"] = this.due ? formatDate(this.due) : undefined as any;
        data["amount"] = this.amount;
        data["taxAmount"] = this.taxAmount;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface IInsertProjectFinanceRequest {
    name: string;
    description?: string | undefined;
    invoiceType: InvoiceTypeEnum;
    invoiceNumber: string;
    partnerId: number;
    issueDate: Date;
    due: Date;
    amount: number;
    taxAmount: number;
    statusId: number;
}

export class InsertProjectIssueRequest implements IInsertProjectIssueRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    impact?: string | undefined;
    solution?: string | undefined;
    resolution?: string | undefined;

    constructor(data?: IInsertProjectIssueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.impact = _data["impact"];
            this.solution = _data["solution"];
            this.resolution = _data["resolution"];
        }
    }

    static fromJS(data: any): InsertProjectIssueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectIssueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["impact"] = this.impact;
        data["solution"] = this.solution;
        data["resolution"] = this.resolution;
        return data;
    }
}

export interface IInsertProjectIssueRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    impact?: string | undefined;
    solution?: string | undefined;
    resolution?: string | undefined;
}

export class InsertProjectMilestoneRequest implements IInsertProjectMilestoneRequest {
    name!: string;
    description?: string | undefined;
    wbs!: string;
    duration?: number | undefined;
    complete?: number | undefined;
    start?: Date | undefined;
    finish?: Date | undefined;
    achievedDate?: Date | undefined;
    milestoneDeviation?: string | undefined;

    constructor(data?: IInsertProjectMilestoneRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.wbs = _data["wbs"];
            this.duration = _data["duration"];
            this.complete = _data["complete"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.finish = _data["finish"] ? new Date(_data["finish"].toString()) : undefined as any;
            this.achievedDate = _data["achievedDate"] ? new Date(_data["achievedDate"].toString()) : undefined as any;
            this.milestoneDeviation = _data["milestoneDeviation"];
        }
    }

    static fromJS(data: any): InsertProjectMilestoneRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectMilestoneRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["wbs"] = this.wbs;
        data["duration"] = this.duration;
        data["complete"] = this.complete;
        data["start"] = this.start ? formatDate(this.start) : undefined as any;
        data["finish"] = this.finish ? formatDate(this.finish) : undefined as any;
        data["achievedDate"] = this.achievedDate ? formatDate(this.achievedDate) : undefined as any;
        data["milestoneDeviation"] = this.milestoneDeviation;
        return data;
    }
}

export interface IInsertProjectMilestoneRequest {
    name: string;
    description?: string | undefined;
    wbs: string;
    duration?: number | undefined;
    complete?: number | undefined;
    start?: Date | undefined;
    finish?: Date | undefined;
    achievedDate?: Date | undefined;
    milestoneDeviation?: string | undefined;
}

export class InsertProjectQualityRequest implements IInsertProjectQualityRequest {
    name!: string;
    description?: string | undefined;
    wbs!: string;
    finish?: Date | undefined;
    achievedData?: Date | undefined;
    actions?: string | undefined;
    status!: ReportItemStatusEnum;

    constructor(data?: IInsertProjectQualityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.wbs = _data["wbs"];
            this.finish = _data["finish"] ? new Date(_data["finish"].toString()) : undefined as any;
            this.achievedData = _data["achievedData"] ? new Date(_data["achievedData"].toString()) : undefined as any;
            this.actions = _data["actions"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): InsertProjectQualityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectQualityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["wbs"] = this.wbs;
        data["finish"] = this.finish ? formatDate(this.finish) : undefined as any;
        data["achievedData"] = this.achievedData ? formatDate(this.achievedData) : undefined as any;
        data["actions"] = this.actions;
        data["status"] = this.status;
        return data;
    }
}

export interface IInsertProjectQualityRequest {
    name: string;
    description?: string | undefined;
    wbs: string;
    finish?: Date | undefined;
    achievedData?: Date | undefined;
    actions?: string | undefined;
    status: ReportItemStatusEnum;
}

export class InsertProjectReportRequest implements IInsertProjectReportRequest {
    from!: Date;
    to!: Date;
    statusId!: number;

    constructor(data?: IInsertProjectReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): InsertProjectReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface IInsertProjectReportRequest {
    from: Date;
    to: Date;
    statusId: number;
}

export class InsertProjectRequest implements IInsertProjectRequest {
    name!: string;
    pmId!: number;
    statusId!: number;
    description?: string | undefined;
    from!: Date;
    to!: Date;

    constructor(data?: IInsertProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.pmId = _data["pmId"];
            this.statusId = _data["statusId"];
            this.description = _data["description"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InsertProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["pmId"] = this.pmId;
        data["statusId"] = this.statusId;
        data["description"] = this.description;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        return data;
    }
}

export interface IInsertProjectRequest {
    name: string;
    pmId: number;
    statusId: number;
    description?: string | undefined;
    from: Date;
    to: Date;
}

export class InsertProjectRiskRequest implements IInsertProjectRiskRequest {
    name!: string;
    description?: string | undefined;
    consequneces?: string | undefined;
    effects?: string | undefined;
    grossImpact?: number | undefined;
    probability?: number | undefined;
    mitigation!: string;
    mitigationType!: MitigationTypeEnum;
    grossImpactAfterMitigation?: number | undefined;
    probabilityAfterMitigation?: number | undefined;
    responsibleUserId?: number | undefined;
    statusId!: number;
    dueDate?: Date | undefined;
    costOfMitigation?: number | undefined;

    constructor(data?: IInsertProjectRiskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.consequneces = _data["consequneces"];
            this.effects = _data["effects"];
            this.grossImpact = _data["grossImpact"];
            this.probability = _data["probability"];
            this.mitigation = _data["mitigation"];
            this.mitigationType = _data["mitigationType"];
            this.grossImpactAfterMitigation = _data["grossImpactAfterMitigation"];
            this.probabilityAfterMitigation = _data["probabilityAfterMitigation"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.statusId = _data["statusId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.costOfMitigation = _data["costOfMitigation"];
        }
    }

    static fromJS(data: any): InsertProjectRiskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectRiskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["consequneces"] = this.consequneces;
        data["effects"] = this.effects;
        data["grossImpact"] = this.grossImpact;
        data["probability"] = this.probability;
        data["mitigation"] = this.mitigation;
        data["mitigationType"] = this.mitigationType;
        data["grossImpactAfterMitigation"] = this.grossImpactAfterMitigation;
        data["probabilityAfterMitigation"] = this.probabilityAfterMitigation;
        data["responsibleUserId"] = this.responsibleUserId;
        data["statusId"] = this.statusId;
        data["dueDate"] = this.dueDate ? formatDate(this.dueDate) : undefined as any;
        data["costOfMitigation"] = this.costOfMitigation;
        return data;
    }
}

export interface IInsertProjectRiskRequest {
    name: string;
    description?: string | undefined;
    consequneces?: string | undefined;
    effects?: string | undefined;
    grossImpact?: number | undefined;
    probability?: number | undefined;
    mitigation: string;
    mitigationType: MitigationTypeEnum;
    grossImpactAfterMitigation?: number | undefined;
    probabilityAfterMitigation?: number | undefined;
    responsibleUserId?: number | undefined;
    statusId: number;
    dueDate?: Date | undefined;
    costOfMitigation?: number | undefined;
}

export class InsertProjectSubcontractorRequest implements IInsertProjectSubcontractorRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    deliverable!: string;
    status!: ReportItemStatusEnum;
    issue!: string;
    solution?: string | undefined;
    resolution?: string | undefined;
    achievedDate?: Date | undefined;

    constructor(data?: IInsertProjectSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.deliverable = _data["deliverable"];
            this.status = _data["status"];
            this.issue = _data["issue"];
            this.solution = _data["solution"];
            this.resolution = _data["resolution"];
            this.achievedDate = _data["achievedDate"] ? new Date(_data["achievedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InsertProjectSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["deliverable"] = this.deliverable;
        data["status"] = this.status;
        data["issue"] = this.issue;
        data["solution"] = this.solution;
        data["resolution"] = this.resolution;
        data["achievedDate"] = this.achievedDate ? formatDate(this.achievedDate) : undefined as any;
        return data;
    }
}

export interface IInsertProjectSubcontractorRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    deliverable: string;
    status: ReportItemStatusEnum;
    issue: string;
    solution?: string | undefined;
    resolution?: string | undefined;
    achievedDate?: Date | undefined;
}

export class InsertProjectTeamMemberRequest implements IInsertProjectTeamMemberRequest {
    userId!: number;
    projectRoleId!: number;
    projectTeamId!: number;
    statusId!: number;
    validUntil!: Date;

    constructor(data?: IInsertProjectTeamMemberRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.projectRoleId = _data["projectRoleId"];
            this.projectTeamId = _data["projectTeamId"];
            this.statusId = _data["statusId"];
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InsertProjectTeamMemberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectTeamMemberRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["projectRoleId"] = this.projectRoleId;
        data["projectTeamId"] = this.projectTeamId;
        data["statusId"] = this.statusId;
        data["validUntil"] = this.validUntil ? formatDate(this.validUntil) : undefined as any;
        return data;
    }
}

export interface IInsertProjectTeamMemberRequest {
    userId: number;
    projectRoleId: number;
    projectTeamId: number;
    statusId: number;
    validUntil: Date;
}

export class InsertProjectTeamMemberValidityPeriodRequest implements IInsertProjectTeamMemberValidityPeriodRequest {
    teamMemberId!: number;
    from!: Date;
    to!: Date;
    salesRate!: number;
    costRate!: number;

    constructor(data?: IInsertProjectTeamMemberValidityPeriodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamMemberId = _data["teamMemberId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.salesRate = _data["salesRate"];
            this.costRate = _data["costRate"];
        }
    }

    static fromJS(data: any): InsertProjectTeamMemberValidityPeriodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectTeamMemberValidityPeriodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamMemberId"] = this.teamMemberId;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["salesRate"] = this.salesRate;
        data["costRate"] = this.costRate;
        return data;
    }
}

export interface IInsertProjectTeamMemberValidityPeriodRequest {
    teamMemberId: number;
    from: Date;
    to: Date;
    salesRate: number;
    costRate: number;
}

export class InsertProjectTeamRequest implements IInsertProjectTeamRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    projectId!: number;
    salesRate?: number | undefined;
    costRate?: number | undefined;

    constructor(data?: IInsertProjectTeamRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.projectId = _data["projectId"];
            this.salesRate = _data["salesRate"];
            this.costRate = _data["costRate"];
        }
    }

    static fromJS(data: any): InsertProjectTeamRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectTeamRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["projectId"] = this.projectId;
        data["salesRate"] = this.salesRate;
        data["costRate"] = this.costRate;
        return data;
    }
}

export interface IInsertProjectTeamRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    projectId: number;
    salesRate?: number | undefined;
    costRate?: number | undefined;
}

export class InsertReminderRequest implements IInsertReminderRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    subject!: string;
    startDate!: Date;
    endDate!: Date;
    isRepeat!: boolean;
    repeatInterval!: RepeatIntervalEnum;
    repeatOnMonday!: boolean;
    repeatOnTuesday!: boolean;
    repeatOnWednesday!: boolean;
    repeatOnThursday!: boolean;
    repeatOnFriday!: boolean;
    repeatOnSaturday!: boolean;
    repeatOnSunday!: boolean;
    isPrivate!: boolean;
    sendEmail!: boolean;
    projectTeamId?: number | undefined;
    recipientUserIds?: number[] | undefined;

    constructor(data?: IInsertReminderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.subject = _data["subject"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.isRepeat = _data["isRepeat"];
            this.repeatInterval = _data["repeatInterval"];
            this.repeatOnMonday = _data["repeatOnMonday"];
            this.repeatOnTuesday = _data["repeatOnTuesday"];
            this.repeatOnWednesday = _data["repeatOnWednesday"];
            this.repeatOnThursday = _data["repeatOnThursday"];
            this.repeatOnFriday = _data["repeatOnFriday"];
            this.repeatOnSaturday = _data["repeatOnSaturday"];
            this.repeatOnSunday = _data["repeatOnSunday"];
            this.isPrivate = _data["isPrivate"];
            this.sendEmail = _data["sendEmail"];
            this.projectTeamId = _data["projectTeamId"];
            if (Array.isArray(_data["recipientUserIds"])) {
                this.recipientUserIds = [] as any;
                for (let item of _data["recipientUserIds"])
                    this.recipientUserIds!.push(item);
            }
        }
    }

    static fromJS(data: any): InsertReminderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertReminderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["subject"] = this.subject;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["isRepeat"] = this.isRepeat;
        data["repeatInterval"] = this.repeatInterval;
        data["repeatOnMonday"] = this.repeatOnMonday;
        data["repeatOnTuesday"] = this.repeatOnTuesday;
        data["repeatOnWednesday"] = this.repeatOnWednesday;
        data["repeatOnThursday"] = this.repeatOnThursday;
        data["repeatOnFriday"] = this.repeatOnFriday;
        data["repeatOnSaturday"] = this.repeatOnSaturday;
        data["repeatOnSunday"] = this.repeatOnSunday;
        data["isPrivate"] = this.isPrivate;
        data["sendEmail"] = this.sendEmail;
        data["projectTeamId"] = this.projectTeamId;
        if (Array.isArray(this.recipientUserIds)) {
            data["recipientUserIds"] = [];
            for (let item of this.recipientUserIds)
                data["recipientUserIds"].push(item);
        }
        return data;
    }
}

export interface IInsertReminderRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    subject: string;
    startDate: Date;
    endDate: Date;
    isRepeat: boolean;
    repeatInterval: RepeatIntervalEnum;
    repeatOnMonday: boolean;
    repeatOnTuesday: boolean;
    repeatOnWednesday: boolean;
    repeatOnThursday: boolean;
    repeatOnFriday: boolean;
    repeatOnSaturday: boolean;
    repeatOnSunday: boolean;
    isPrivate: boolean;
    sendEmail: boolean;
    projectTeamId?: number | undefined;
    recipientUserIds?: number[] | undefined;
}

export class InsertRiskRequest implements IInsertRiskRequest {
    name!: string;
    typeId?: number | undefined;
    consequneces?: string | undefined;
    effects?: string | undefined;
    responsibleUserId!: number;
    statusId!: number;
    dueDate!: Date;
    comment?: string | undefined;
    grossImpact?: number | undefined;
    probability?: number | undefined;
    mitigation?: string | undefined;
    mitigationType!: MitigationTypeEnum;
    mitigationCost?: number | undefined;
    grossImpactAfterMitigation?: number | undefined;
    probabilityAfterMitigation?: number | undefined;
    probabilityDescriptive?: RiskProbabilityEnum;
    impactDescriptive?: RiskImpactEnum;

    constructor(data?: IInsertRiskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.consequneces = _data["consequneces"];
            this.effects = _data["effects"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.statusId = _data["statusId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.comment = _data["comment"];
            this.grossImpact = _data["grossImpact"];
            this.probability = _data["probability"];
            this.mitigation = _data["mitigation"];
            this.mitigationType = _data["mitigationType"];
            this.mitigationCost = _data["mitigationCost"];
            this.grossImpactAfterMitigation = _data["grossImpactAfterMitigation"];
            this.probabilityAfterMitigation = _data["probabilityAfterMitigation"];
            this.probabilityDescriptive = _data["probabilityDescriptive"];
            this.impactDescriptive = _data["impactDescriptive"];
        }
    }

    static fromJS(data: any): InsertRiskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertRiskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["consequneces"] = this.consequneces;
        data["effects"] = this.effects;
        data["responsibleUserId"] = this.responsibleUserId;
        data["statusId"] = this.statusId;
        data["dueDate"] = this.dueDate ? formatDate(this.dueDate) : undefined as any;
        data["comment"] = this.comment;
        data["grossImpact"] = this.grossImpact;
        data["probability"] = this.probability;
        data["mitigation"] = this.mitigation;
        data["mitigationType"] = this.mitigationType;
        data["mitigationCost"] = this.mitigationCost;
        data["grossImpactAfterMitigation"] = this.grossImpactAfterMitigation;
        data["probabilityAfterMitigation"] = this.probabilityAfterMitigation;
        data["probabilityDescriptive"] = this.probabilityDescriptive;
        data["impactDescriptive"] = this.impactDescriptive;
        return data;
    }
}

export interface IInsertRiskRequest {
    name: string;
    typeId?: number | undefined;
    consequneces?: string | undefined;
    effects?: string | undefined;
    responsibleUserId: number;
    statusId: number;
    dueDate: Date;
    comment?: string | undefined;
    grossImpact?: number | undefined;
    probability?: number | undefined;
    mitigation?: string | undefined;
    mitigationType: MitigationTypeEnum;
    mitigationCost?: number | undefined;
    grossImpactAfterMitigation?: number | undefined;
    probabilityAfterMitigation?: number | undefined;
    probabilityDescriptive?: RiskProbabilityEnum;
    impactDescriptive?: RiskImpactEnum;
}

export class InsertSchedulePredecessorRequest implements IInsertSchedulePredecessorRequest {
    predecessorId!: number;
    descendantId!: number;
    type!: SchedulePredecessorTypeEnum;
    lag?: number | undefined;

    constructor(data?: IInsertSchedulePredecessorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predecessorId = _data["predecessorId"];
            this.descendantId = _data["descendantId"];
            this.type = _data["type"];
            this.lag = _data["lag"];
        }
    }

    static fromJS(data: any): InsertSchedulePredecessorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertSchedulePredecessorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predecessorId"] = this.predecessorId;
        data["descendantId"] = this.descendantId;
        data["type"] = this.type;
        data["lag"] = this.lag;
        return data;
    }
}

export interface IInsertSchedulePredecessorRequest {
    predecessorId: number;
    descendantId: number;
    type: SchedulePredecessorTypeEnum;
    lag?: number | undefined;
}

export class InsertScheduleRequest implements IInsertScheduleRequest {
    name!: string;
    description?: string | undefined;
    wbs!: string;
    start!: Date;
    finish!: Date;
    parentId?: number | undefined;
    percentOfCompletion?: number | undefined;
    achievedDate?: Date | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    customText3?: string | undefined;
    customText4?: string | undefined;
    customText5?: string | undefined;
    customText6?: string | undefined;
    customText7?: string | undefined;
    customText8?: string | undefined;
    customText9?: string | undefined;
    customText10?: string | undefined;
    projectRoleResponsibleId?: number | undefined;
    insertedResponsibleUserIds?: number[] | undefined;
    addAsTaskPerResponsibleUser!: boolean;
    projectRoleAccountableId?: number | undefined;
    insertedAccountableUserIds?: number[] | undefined;
    projectRoleConsultedId?: number | undefined;
    insertedConsultedUserIds?: number[] | undefined;
    projectRoleInformedId?: number | undefined;
    insertedInformedUserIds?: number[] | undefined;
    markAsMilestone!: boolean;
    markAsDeliverable!: boolean;
    markTaskForQualityGate!: boolean;

    constructor(data?: IInsertScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.wbs = _data["wbs"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.finish = _data["finish"] ? new Date(_data["finish"].toString()) : undefined as any;
            this.parentId = _data["parentId"];
            this.percentOfCompletion = _data["percentOfCompletion"];
            this.achievedDate = _data["achievedDate"] ? new Date(_data["achievedDate"].toString()) : undefined as any;
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.customText3 = _data["customText3"];
            this.customText4 = _data["customText4"];
            this.customText5 = _data["customText5"];
            this.customText6 = _data["customText6"];
            this.customText7 = _data["customText7"];
            this.customText8 = _data["customText8"];
            this.customText9 = _data["customText9"];
            this.customText10 = _data["customText10"];
            this.projectRoleResponsibleId = _data["projectRoleResponsibleId"];
            if (Array.isArray(_data["insertedResponsibleUserIds"])) {
                this.insertedResponsibleUserIds = [] as any;
                for (let item of _data["insertedResponsibleUserIds"])
                    this.insertedResponsibleUserIds!.push(item);
            }
            this.addAsTaskPerResponsibleUser = _data["addAsTaskPerResponsibleUser"];
            this.projectRoleAccountableId = _data["projectRoleAccountableId"];
            if (Array.isArray(_data["insertedAccountableUserIds"])) {
                this.insertedAccountableUserIds = [] as any;
                for (let item of _data["insertedAccountableUserIds"])
                    this.insertedAccountableUserIds!.push(item);
            }
            this.projectRoleConsultedId = _data["projectRoleConsultedId"];
            if (Array.isArray(_data["insertedConsultedUserIds"])) {
                this.insertedConsultedUserIds = [] as any;
                for (let item of _data["insertedConsultedUserIds"])
                    this.insertedConsultedUserIds!.push(item);
            }
            this.projectRoleInformedId = _data["projectRoleInformedId"];
            if (Array.isArray(_data["insertedInformedUserIds"])) {
                this.insertedInformedUserIds = [] as any;
                for (let item of _data["insertedInformedUserIds"])
                    this.insertedInformedUserIds!.push(item);
            }
            this.markAsMilestone = _data["markAsMilestone"];
            this.markAsDeliverable = _data["markAsDeliverable"];
            this.markTaskForQualityGate = _data["markTaskForQualityGate"];
        }
    }

    static fromJS(data: any): InsertScheduleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertScheduleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["wbs"] = this.wbs;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["finish"] = this.finish ? this.finish.toISOString() : undefined as any;
        data["parentId"] = this.parentId;
        data["percentOfCompletion"] = this.percentOfCompletion;
        data["achievedDate"] = this.achievedDate ? this.achievedDate.toISOString() : undefined as any;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["customText3"] = this.customText3;
        data["customText4"] = this.customText4;
        data["customText5"] = this.customText5;
        data["customText6"] = this.customText6;
        data["customText7"] = this.customText7;
        data["customText8"] = this.customText8;
        data["customText9"] = this.customText9;
        data["customText10"] = this.customText10;
        data["projectRoleResponsibleId"] = this.projectRoleResponsibleId;
        if (Array.isArray(this.insertedResponsibleUserIds)) {
            data["insertedResponsibleUserIds"] = [];
            for (let item of this.insertedResponsibleUserIds)
                data["insertedResponsibleUserIds"].push(item);
        }
        data["addAsTaskPerResponsibleUser"] = this.addAsTaskPerResponsibleUser;
        data["projectRoleAccountableId"] = this.projectRoleAccountableId;
        if (Array.isArray(this.insertedAccountableUserIds)) {
            data["insertedAccountableUserIds"] = [];
            for (let item of this.insertedAccountableUserIds)
                data["insertedAccountableUserIds"].push(item);
        }
        data["projectRoleConsultedId"] = this.projectRoleConsultedId;
        if (Array.isArray(this.insertedConsultedUserIds)) {
            data["insertedConsultedUserIds"] = [];
            for (let item of this.insertedConsultedUserIds)
                data["insertedConsultedUserIds"].push(item);
        }
        data["projectRoleInformedId"] = this.projectRoleInformedId;
        if (Array.isArray(this.insertedInformedUserIds)) {
            data["insertedInformedUserIds"] = [];
            for (let item of this.insertedInformedUserIds)
                data["insertedInformedUserIds"].push(item);
        }
        data["markAsMilestone"] = this.markAsMilestone;
        data["markAsDeliverable"] = this.markAsDeliverable;
        data["markTaskForQualityGate"] = this.markTaskForQualityGate;
        return data;
    }
}

export interface IInsertScheduleRequest {
    name: string;
    description?: string | undefined;
    wbs: string;
    start: Date;
    finish: Date;
    parentId?: number | undefined;
    percentOfCompletion?: number | undefined;
    achievedDate?: Date | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    customText3?: string | undefined;
    customText4?: string | undefined;
    customText5?: string | undefined;
    customText6?: string | undefined;
    customText7?: string | undefined;
    customText8?: string | undefined;
    customText9?: string | undefined;
    customText10?: string | undefined;
    projectRoleResponsibleId?: number | undefined;
    insertedResponsibleUserIds?: number[] | undefined;
    addAsTaskPerResponsibleUser: boolean;
    projectRoleAccountableId?: number | undefined;
    insertedAccountableUserIds?: number[] | undefined;
    projectRoleConsultedId?: number | undefined;
    insertedConsultedUserIds?: number[] | undefined;
    projectRoleInformedId?: number | undefined;
    insertedInformedUserIds?: number[] | undefined;
    markAsMilestone: boolean;
    markAsDeliverable: boolean;
    markTaskForQualityGate: boolean;
}

export class InsertScheduleResourcePlanRequest implements IInsertScheduleResourcePlanRequest {
    userOrProjectTeamId!: number;
    numberOfHours?: number | undefined;
    workload?: number | undefined;
    percentOfCompletion?: number | undefined;

    constructor(data?: IInsertScheduleResourcePlanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userOrProjectTeamId = _data["userOrProjectTeamId"];
            this.numberOfHours = _data["numberOfHours"];
            this.workload = _data["workload"];
            this.percentOfCompletion = _data["percentOfCompletion"];
        }
    }

    static fromJS(data: any): InsertScheduleResourcePlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertScheduleResourcePlanRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userOrProjectTeamId"] = this.userOrProjectTeamId;
        data["numberOfHours"] = this.numberOfHours;
        data["workload"] = this.workload;
        data["percentOfCompletion"] = this.percentOfCompletion;
        return data;
    }
}

export interface IInsertScheduleResourcePlanRequest {
    userOrProjectTeamId: number;
    numberOfHours?: number | undefined;
    workload?: number | undefined;
    percentOfCompletion?: number | undefined;
}

export class InsertScheduleResourcePlanRequestUpdateScheduleResourcePlanRequestDeleteScheduleResourcePlanRequestDeltaModel implements IInsertScheduleResourcePlanRequestUpdateScheduleResourcePlanRequestDeleteScheduleResourcePlanRequestDeltaModel {
    insert?: InsertScheduleResourcePlanRequest[] | undefined;
    update?: UpdateScheduleResourcePlanRequest[] | undefined;
    delete?: DeleteScheduleResourcePlanRequest[] | undefined;

    constructor(data?: IInsertScheduleResourcePlanRequestUpdateScheduleResourcePlanRequestDeleteScheduleResourcePlanRequestDeltaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertScheduleResourcePlanRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateScheduleResourcePlanRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteScheduleResourcePlanRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertScheduleResourcePlanRequestUpdateScheduleResourcePlanRequestDeleteScheduleResourcePlanRequestDeltaModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsertScheduleResourcePlanRequestUpdateScheduleResourcePlanRequestDeleteScheduleResourcePlanRequestDeltaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertScheduleResourcePlanRequestUpdateScheduleResourcePlanRequestDeleteScheduleResourcePlanRequestDeltaModel {
    insert?: InsertScheduleResourcePlanRequest[] | undefined;
    update?: UpdateScheduleResourcePlanRequest[] | undefined;
    delete?: DeleteScheduleResourcePlanRequest[] | undefined;
}

export class InsertScopeItemLevelRequest implements IInsertScopeItemLevelRequest {
    name!: string;
    description?: string | undefined;
    parentId?: number | undefined;
    processDescription?: string | undefined;
    ticketId?: number | undefined;
    processVariant!: boolean;
    relatedScopeItemLevelId?: number | undefined;
    regressionRelevant!: boolean;
    regressionDependecies?: string | undefined;
    stressTestRelevant!: boolean;
    environmentId?: number | undefined;
    inputDocument?: string | undefined;
    outputDocument?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    scopeDepartmentId?: number | undefined;
    scopeStepTypeId?: number | undefined;
    scopeUserRoleId?: number | undefined;
    isComplex!: boolean;
    complexForScopeItemId?: number | undefined;
    order!: number;
    insertedChangeRequestIds?: number[] | undefined;
    newDesignAttachments?: InsertAttachmentRequest[] | undefined;
    newTrainingAttachments?: InsertAttachmentRequest[] | undefined;
    newOtherAttachments?: InsertAttachmentRequest[] | undefined;

    constructor(data?: IInsertScopeItemLevelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.parentId = _data["parentId"];
            this.processDescription = _data["processDescription"];
            this.ticketId = _data["ticketId"];
            this.processVariant = _data["processVariant"];
            this.relatedScopeItemLevelId = _data["relatedScopeItemLevelId"];
            this.regressionRelevant = _data["regressionRelevant"];
            this.regressionDependecies = _data["regressionDependecies"];
            this.stressTestRelevant = _data["stressTestRelevant"];
            this.environmentId = _data["environmentId"];
            this.inputDocument = _data["inputDocument"];
            this.outputDocument = _data["outputDocument"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.scopeDepartmentId = _data["scopeDepartmentId"];
            this.scopeStepTypeId = _data["scopeStepTypeId"];
            this.scopeUserRoleId = _data["scopeUserRoleId"];
            this.isComplex = _data["isComplex"];
            this.complexForScopeItemId = _data["complexForScopeItemId"];
            this.order = _data["order"];
            if (Array.isArray(_data["insertedChangeRequestIds"])) {
                this.insertedChangeRequestIds = [] as any;
                for (let item of _data["insertedChangeRequestIds"])
                    this.insertedChangeRequestIds!.push(item);
            }
            if (Array.isArray(_data["newDesignAttachments"])) {
                this.newDesignAttachments = [] as any;
                for (let item of _data["newDesignAttachments"])
                    this.newDesignAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            if (Array.isArray(_data["newTrainingAttachments"])) {
                this.newTrainingAttachments = [] as any;
                for (let item of _data["newTrainingAttachments"])
                    this.newTrainingAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            if (Array.isArray(_data["newOtherAttachments"])) {
                this.newOtherAttachments = [] as any;
                for (let item of _data["newOtherAttachments"])
                    this.newOtherAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertScopeItemLevelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertScopeItemLevelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentId"] = this.parentId;
        data["processDescription"] = this.processDescription;
        data["ticketId"] = this.ticketId;
        data["processVariant"] = this.processVariant;
        data["relatedScopeItemLevelId"] = this.relatedScopeItemLevelId;
        data["regressionRelevant"] = this.regressionRelevant;
        data["regressionDependecies"] = this.regressionDependecies;
        data["stressTestRelevant"] = this.stressTestRelevant;
        data["environmentId"] = this.environmentId;
        data["inputDocument"] = this.inputDocument;
        data["outputDocument"] = this.outputDocument;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["scopeDepartmentId"] = this.scopeDepartmentId;
        data["scopeStepTypeId"] = this.scopeStepTypeId;
        data["scopeUserRoleId"] = this.scopeUserRoleId;
        data["isComplex"] = this.isComplex;
        data["complexForScopeItemId"] = this.complexForScopeItemId;
        data["order"] = this.order;
        if (Array.isArray(this.insertedChangeRequestIds)) {
            data["insertedChangeRequestIds"] = [];
            for (let item of this.insertedChangeRequestIds)
                data["insertedChangeRequestIds"].push(item);
        }
        if (Array.isArray(this.newDesignAttachments)) {
            data["newDesignAttachments"] = [];
            for (let item of this.newDesignAttachments)
                data["newDesignAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.newTrainingAttachments)) {
            data["newTrainingAttachments"] = [];
            for (let item of this.newTrainingAttachments)
                data["newTrainingAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.newOtherAttachments)) {
            data["newOtherAttachments"] = [];
            for (let item of this.newOtherAttachments)
                data["newOtherAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertScopeItemLevelRequest {
    name: string;
    description?: string | undefined;
    parentId?: number | undefined;
    processDescription?: string | undefined;
    ticketId?: number | undefined;
    processVariant: boolean;
    relatedScopeItemLevelId?: number | undefined;
    regressionRelevant: boolean;
    regressionDependecies?: string | undefined;
    stressTestRelevant: boolean;
    environmentId?: number | undefined;
    inputDocument?: string | undefined;
    outputDocument?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    scopeDepartmentId?: number | undefined;
    scopeStepTypeId?: number | undefined;
    scopeUserRoleId?: number | undefined;
    isComplex: boolean;
    complexForScopeItemId?: number | undefined;
    order: number;
    insertedChangeRequestIds?: number[] | undefined;
    newDesignAttachments?: InsertAttachmentRequest[] | undefined;
    newTrainingAttachments?: InsertAttachmentRequest[] | undefined;
    newOtherAttachments?: InsertAttachmentRequest[] | undefined;
}

export class InsertStatusReportRequest implements IInsertStatusReportRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    reportDate!: Date;
    from?: Date | undefined;
    to?: Date | undefined;
    responsibleUserId?: number | undefined;
    notifyResponsibleUser!: boolean;
    openIssues!: string;
    keyRisks!: string;
    nextSteps!: string;
    overallStatus!: ReportStatusAreaEnum;
    overallStatusAndKeyAchievements!: string;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;

    constructor(data?: IInsertStatusReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.reportDate = _data["reportDate"] ? new Date(_data["reportDate"].toString()) : undefined as any;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.responsibleUserId = _data["responsibleUserId"];
            this.notifyResponsibleUser = _data["notifyResponsibleUser"];
            this.openIssues = _data["openIssues"];
            this.keyRisks = _data["keyRisks"];
            this.nextSteps = _data["nextSteps"];
            this.overallStatus = _data["overallStatus"];
            this.overallStatusAndKeyAchievements = _data["overallStatusAndKeyAchievements"];
            this.projectTeamId = _data["projectTeamId"];
            this.projectOrganizationId = _data["projectOrganizationId"];
        }
    }

    static fromJS(data: any): InsertStatusReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertStatusReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["reportDate"] = this.reportDate ? formatDate(this.reportDate) : undefined as any;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["responsibleUserId"] = this.responsibleUserId;
        data["notifyResponsibleUser"] = this.notifyResponsibleUser;
        data["openIssues"] = this.openIssues;
        data["keyRisks"] = this.keyRisks;
        data["nextSteps"] = this.nextSteps;
        data["overallStatus"] = this.overallStatus;
        data["overallStatusAndKeyAchievements"] = this.overallStatusAndKeyAchievements;
        data["projectTeamId"] = this.projectTeamId;
        data["projectOrganizationId"] = this.projectOrganizationId;
        return data;
    }
}

export interface IInsertStatusReportRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    reportDate: Date;
    from?: Date | undefined;
    to?: Date | undefined;
    responsibleUserId?: number | undefined;
    notifyResponsibleUser: boolean;
    openIssues: string;
    keyRisks: string;
    nextSteps: string;
    overallStatus: ReportStatusAreaEnum;
    overallStatusAndKeyAchievements: string;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
}

export class InsertStatusRequest implements IInsertStatusRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    color!: string;
    order!: number;

    constructor(data?: IInsertStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.color = _data["color"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): InsertStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["color"] = this.color;
        data["order"] = this.order;
        return data;
    }
}

export interface IInsertStatusRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    color: string;
    order: number;
}

export class InsertSurveyParticipantAnswerRequest implements IInsertSurveyParticipantAnswerRequest {
    answer?: string | undefined;
    rating?: number | undefined;
    proposedAnswerId?: number | undefined;

    constructor(data?: IInsertSurveyParticipantAnswerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answer = _data["answer"];
            this.rating = _data["rating"];
            this.proposedAnswerId = _data["proposedAnswerId"];
        }
    }

    static fromJS(data: any): InsertSurveyParticipantAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertSurveyParticipantAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer;
        data["rating"] = this.rating;
        data["proposedAnswerId"] = this.proposedAnswerId;
        return data;
    }
}

export interface IInsertSurveyParticipantAnswerRequest {
    answer?: string | undefined;
    rating?: number | undefined;
    proposedAnswerId?: number | undefined;
}

export class InsertSurveyProposedAnswerRequest implements IInsertSurveyProposedAnswerRequest {
    answer!: string;
    points?: number | undefined;
    isCorrect!: boolean;

    constructor(data?: IInsertSurveyProposedAnswerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answer = _data["answer"];
            this.points = _data["points"];
            this.isCorrect = _data["isCorrect"];
        }
    }

    static fromJS(data: any): InsertSurveyProposedAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertSurveyProposedAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer;
        data["points"] = this.points;
        data["isCorrect"] = this.isCorrect;
        return data;
    }
}

export interface IInsertSurveyProposedAnswerRequest {
    answer: string;
    points?: number | undefined;
    isCorrect: boolean;
}

export class InsertSurveyQuestionRequest implements IInsertSurveyQuestionRequest {
    questionGroup?: string | undefined;
    question!: string;
    surveyType!: SurveyQuestionTypeEnum;
    answerRequired!: boolean;
    scoreQuestion!: boolean;
    order!: number;
    proposedAnswersDelta?: SurveyProposedAnswerDeltaRequest;

    constructor(data?: IInsertSurveyQuestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionGroup = _data["questionGroup"];
            this.question = _data["question"];
            this.surveyType = _data["surveyType"];
            this.answerRequired = _data["answerRequired"];
            this.scoreQuestion = _data["scoreQuestion"];
            this.order = _data["order"];
            this.proposedAnswersDelta = _data["proposedAnswersDelta"] ? SurveyProposedAnswerDeltaRequest.fromJS(_data["proposedAnswersDelta"]) : undefined as any;
        }
    }

    static fromJS(data: any): InsertSurveyQuestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertSurveyQuestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionGroup"] = this.questionGroup;
        data["question"] = this.question;
        data["surveyType"] = this.surveyType;
        data["answerRequired"] = this.answerRequired;
        data["scoreQuestion"] = this.scoreQuestion;
        data["order"] = this.order;
        data["proposedAnswersDelta"] = this.proposedAnswersDelta ? this.proposedAnswersDelta.toJSON() : undefined as any;
        return data;
    }
}

export interface IInsertSurveyQuestionRequest {
    questionGroup?: string | undefined;
    question: string;
    surveyType: SurveyQuestionTypeEnum;
    answerRequired: boolean;
    scoreQuestion: boolean;
    order: number;
    proposedAnswersDelta?: SurveyProposedAnswerDeltaRequest;
}

export class InsertSurveyRequest implements IInsertSurveyRequest {
    name!: string;
    description?: string | undefined;
    surveyType!: SurveyTypeEnum;

    constructor(data?: IInsertSurveyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.surveyType = _data["surveyType"];
        }
    }

    static fromJS(data: any): InsertSurveyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertSurveyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["surveyType"] = this.surveyType;
        return data;
    }
}

export interface IInsertSurveyRequest {
    name: string;
    description?: string | undefined;
    surveyType: SurveyTypeEnum;
}

export class InsertTaskCommentRequest implements IInsertTaskCommentRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    taskId!: number;
    comment!: string;

    constructor(data?: IInsertTaskCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.taskId = _data["taskId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): InsertTaskCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTaskCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["taskId"] = this.taskId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IInsertTaskCommentRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    taskId: number;
    comment: string;
}

export class InsertTaskRequest implements IInsertTaskRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    assignedToUserId!: number;
    due!: Date;
    isPrivate!: boolean;
    description?: string | undefined;
    parentTaskId?: number | undefined;
    riskId?: number | undefined;
    scopeItemLevelId?: number | undefined;
    changeRequestId?: number | undefined;
    ticketId?: number | undefined;
    meetingId?: number | undefined;
    scheduleId?: number | undefined;
    projectOrganizationId?: number | undefined;
    priority?: TaskPriorityEnum;
    estimatedEffort?: number | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;

    constructor(data?: IInsertTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            this.isPrivate = _data["isPrivate"];
            this.description = _data["description"];
            this.parentTaskId = _data["parentTaskId"];
            this.riskId = _data["riskId"];
            this.scopeItemLevelId = _data["scopeItemLevelId"];
            this.changeRequestId = _data["changeRequestId"];
            this.ticketId = _data["ticketId"];
            this.meetingId = _data["meetingId"];
            this.scheduleId = _data["scheduleId"];
            this.projectOrganizationId = _data["projectOrganizationId"];
            this.priority = _data["priority"];
            this.estimatedEffort = _data["estimatedEffort"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["assignedToUserId"] = this.assignedToUserId;
        data["due"] = this.due ? formatDate(this.due) : undefined as any;
        data["isPrivate"] = this.isPrivate;
        data["description"] = this.description;
        data["parentTaskId"] = this.parentTaskId;
        data["riskId"] = this.riskId;
        data["scopeItemLevelId"] = this.scopeItemLevelId;
        data["changeRequestId"] = this.changeRequestId;
        data["ticketId"] = this.ticketId;
        data["meetingId"] = this.meetingId;
        data["scheduleId"] = this.scheduleId;
        data["projectOrganizationId"] = this.projectOrganizationId;
        data["priority"] = this.priority;
        data["estimatedEffort"] = this.estimatedEffort;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertTaskRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    assignedToUserId: number;
    due: Date;
    isPrivate: boolean;
    description?: string | undefined;
    parentTaskId?: number | undefined;
    riskId?: number | undefined;
    scopeItemLevelId?: number | undefined;
    changeRequestId?: number | undefined;
    ticketId?: number | undefined;
    meetingId?: number | undefined;
    scheduleId?: number | undefined;
    projectOrganizationId?: number | undefined;
    priority?: TaskPriorityEnum;
    estimatedEffort?: number | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
}

export class InsertTaskTimesheetRequest implements IInsertTaskTimesheetRequest {
    userId!: number;
    date!: Date;
    effort!: number;
    estimatedTime?: number | undefined;

    constructor(data?: IInsertTaskTimesheetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.effort = _data["effort"];
            this.estimatedTime = _data["estimatedTime"];
        }
    }

    static fromJS(data: any): InsertTaskTimesheetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTaskTimesheetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["effort"] = this.effort;
        data["estimatedTime"] = this.estimatedTime;
        return data;
    }
}

export interface IInsertTaskTimesheetRequest {
    userId: number;
    date: Date;
    effort: number;
    estimatedTime?: number | undefined;
}

export class InsertTenantIsActiveOrderRequest implements IInsertTenantIsActiveOrderRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    order!: number;

    constructor(data?: IInsertTenantIsActiveOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): InsertTenantIsActiveOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTenantIsActiveOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["order"] = this.order;
        return data;
    }
}

export interface IInsertTenantIsActiveOrderRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    order: number;
}

export class InsertTenantIsActiveRequest implements IInsertTenantIsActiveRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: IInsertTenantIsActiveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): InsertTenantIsActiveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTenantIsActiveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IInsertTenantIsActiveRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
}

export class InsertTestStatusRequest implements IInsertTestStatusRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    color!: string;
    order!: number;
    semantics!: TestStatusEnum;

    constructor(data?: IInsertTestStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.color = _data["color"];
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): InsertTestStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTestStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["color"] = this.color;
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IInsertTestStatusRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    color: string;
    order: number;
    semantics: TestStatusEnum;
}

export class InsertTicketAssignedGroupRequest implements IInsertTicketAssignedGroupRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    supportOrganizationId!: number;
    defaultUserId?: number | undefined;
    emails?: string | undefined;
    userIds?: number[] | undefined;

    constructor(data?: IInsertTicketAssignedGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.supportOrganizationId = _data["supportOrganizationId"];
            this.defaultUserId = _data["defaultUserId"];
            this.emails = _data["emails"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
        }
    }

    static fromJS(data: any): InsertTicketAssignedGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTicketAssignedGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["supportOrganizationId"] = this.supportOrganizationId;
        data["defaultUserId"] = this.defaultUserId;
        data["emails"] = this.emails;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }
}

export interface IInsertTicketAssignedGroupRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    supportOrganizationId: number;
    defaultUserId?: number | undefined;
    emails?: string | undefined;
    userIds?: number[] | undefined;
}

export class InsertTicketCategoryRequest implements IInsertTicketCategoryRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    supportOrganizationId!: number;
    assignedGroupId?: number | undefined;
    parentId?: number | undefined;
    order!: number;

    constructor(data?: IInsertTicketCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.supportOrganizationId = _data["supportOrganizationId"];
            this.assignedGroupId = _data["assignedGroupId"];
            this.parentId = _data["parentId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): InsertTicketCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTicketCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["supportOrganizationId"] = this.supportOrganizationId;
        data["assignedGroupId"] = this.assignedGroupId;
        data["parentId"] = this.parentId;
        data["order"] = this.order;
        return data;
    }
}

export interface IInsertTicketCategoryRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    supportOrganizationId: number;
    assignedGroupId?: number | undefined;
    parentId?: number | undefined;
    order: number;
}

export class InsertTicketCommentRequest implements IInsertTicketCommentRequest {
    comment!: string;
    newAttachments?: InsertAttachmentRequest[] | undefined;

    constructor(data?: IInsertTicketCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertTicketCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTicketCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertTicketCommentRequest {
    comment: string;
    newAttachments?: InsertAttachmentRequest[] | undefined;
}

export class InsertTicketHelpDeskRequest implements IInsertTicketHelpDeskRequest {
    name!: string;
    description?: string | undefined;
    projectId!: number;
    categoryLevel1Id!: number;
    categoryLevel2Id?: number | undefined;
    categoryLevel3Id?: number | undefined;
    impactId!: number;
    urgencyId!: number;
    newAttachments?: InsertAttachmentRequest[] | undefined;

    constructor(data?: IInsertTicketHelpDeskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.projectId = _data["projectId"];
            this.categoryLevel1Id = _data["categoryLevel1Id"];
            this.categoryLevel2Id = _data["categoryLevel2Id"];
            this.categoryLevel3Id = _data["categoryLevel3Id"];
            this.impactId = _data["impactId"];
            this.urgencyId = _data["urgencyId"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertTicketHelpDeskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTicketHelpDeskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        data["categoryLevel1Id"] = this.categoryLevel1Id;
        data["categoryLevel2Id"] = this.categoryLevel2Id;
        data["categoryLevel3Id"] = this.categoryLevel3Id;
        data["impactId"] = this.impactId;
        data["urgencyId"] = this.urgencyId;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertTicketHelpDeskRequest {
    name: string;
    description?: string | undefined;
    projectId: number;
    categoryLevel1Id: number;
    categoryLevel2Id?: number | undefined;
    categoryLevel3Id?: number | undefined;
    impactId: number;
    urgencyId: number;
    newAttachments?: InsertAttachmentRequest[] | undefined;
}

export class InsertTicketRequest implements IInsertTicketRequest {
    name!: string;
    description?: string | undefined;
    projectId!: number;
    reportedBy!: string;
    reportedOn?: Date | undefined;
    typeId?: number | undefined;
    categoryLevel1Id!: number;
    categoryLevel2Id?: number | undefined;
    categoryLevel3Id?: number | undefined;
    ticketNumberExt?: string | undefined;
    statusId!: number;
    impactId!: number;
    urgencyId!: number;
    effort?: number | undefined;
    effortUnit?: TimeMeasureEnum;
    assignedGroupId?: number | undefined;
    expectedResolutionDate?: Date | undefined;
    environmentId?: number | undefined;
    scheduleId?: number | undefined;
    assignedToUserId!: number;
    parentTicketId?: number | undefined;
    changeRequestIdsDelta?: Int32Int32Int32DeltaModel;
    testPlanIdsDelta?: Int32Int32Int32DeltaModel;
    newAttachments?: InsertAttachmentRequest[] | undefined;

    constructor(data?: IInsertTicketRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.projectId = _data["projectId"];
            this.reportedBy = _data["reportedBy"];
            this.reportedOn = _data["reportedOn"] ? new Date(_data["reportedOn"].toString()) : undefined as any;
            this.typeId = _data["typeId"];
            this.categoryLevel1Id = _data["categoryLevel1Id"];
            this.categoryLevel2Id = _data["categoryLevel2Id"];
            this.categoryLevel3Id = _data["categoryLevel3Id"];
            this.ticketNumberExt = _data["ticketNumberExt"];
            this.statusId = _data["statusId"];
            this.impactId = _data["impactId"];
            this.urgencyId = _data["urgencyId"];
            this.effort = _data["effort"];
            this.effortUnit = _data["effortUnit"];
            this.assignedGroupId = _data["assignedGroupId"];
            this.expectedResolutionDate = _data["expectedResolutionDate"] ? new Date(_data["expectedResolutionDate"].toString()) : undefined as any;
            this.environmentId = _data["environmentId"];
            this.scheduleId = _data["scheduleId"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.parentTicketId = _data["parentTicketId"];
            this.changeRequestIdsDelta = _data["changeRequestIdsDelta"] ? Int32Int32Int32DeltaModel.fromJS(_data["changeRequestIdsDelta"]) : undefined as any;
            this.testPlanIdsDelta = _data["testPlanIdsDelta"] ? Int32Int32Int32DeltaModel.fromJS(_data["testPlanIdsDelta"]) : undefined as any;
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertTicketRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTicketRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        data["reportedBy"] = this.reportedBy;
        data["reportedOn"] = this.reportedOn ? formatDate(this.reportedOn) : undefined as any;
        data["typeId"] = this.typeId;
        data["categoryLevel1Id"] = this.categoryLevel1Id;
        data["categoryLevel2Id"] = this.categoryLevel2Id;
        data["categoryLevel3Id"] = this.categoryLevel3Id;
        data["ticketNumberExt"] = this.ticketNumberExt;
        data["statusId"] = this.statusId;
        data["impactId"] = this.impactId;
        data["urgencyId"] = this.urgencyId;
        data["effort"] = this.effort;
        data["effortUnit"] = this.effortUnit;
        data["assignedGroupId"] = this.assignedGroupId;
        data["expectedResolutionDate"] = this.expectedResolutionDate ? formatDate(this.expectedResolutionDate) : undefined as any;
        data["environmentId"] = this.environmentId;
        data["scheduleId"] = this.scheduleId;
        data["assignedToUserId"] = this.assignedToUserId;
        data["parentTicketId"] = this.parentTicketId;
        data["changeRequestIdsDelta"] = this.changeRequestIdsDelta ? this.changeRequestIdsDelta.toJSON() : undefined as any;
        data["testPlanIdsDelta"] = this.testPlanIdsDelta ? this.testPlanIdsDelta.toJSON() : undefined as any;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertTicketRequest {
    name: string;
    description?: string | undefined;
    projectId: number;
    reportedBy: string;
    reportedOn?: Date | undefined;
    typeId?: number | undefined;
    categoryLevel1Id: number;
    categoryLevel2Id?: number | undefined;
    categoryLevel3Id?: number | undefined;
    ticketNumberExt?: string | undefined;
    statusId: number;
    impactId: number;
    urgencyId: number;
    effort?: number | undefined;
    effortUnit?: TimeMeasureEnum;
    assignedGroupId?: number | undefined;
    expectedResolutionDate?: Date | undefined;
    environmentId?: number | undefined;
    scheduleId?: number | undefined;
    assignedToUserId: number;
    parentTicketId?: number | undefined;
    changeRequestIdsDelta?: Int32Int32Int32DeltaModel;
    testPlanIdsDelta?: Int32Int32Int32DeltaModel;
    newAttachments?: InsertAttachmentRequest[] | undefined;
}

export class InsertTicketStatusRequest implements IInsertTicketStatusRequest {
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    color!: string;
    order!: number;
    semantics!: TicketStatusEnum;

    constructor(data?: IInsertTicketStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.color = _data["color"];
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): InsertTicketStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTicketStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["color"] = this.color;
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IInsertTicketStatusRequest {
    name: string;
    description?: string | undefined;
    isActive: boolean;
    color: string;
    order: number;
    semantics: TicketStatusEnum;
}

export class InsertTicketSubtaskRequest implements IInsertTicketSubtaskRequest {
    createTask!: boolean;
    description?: string | undefined;
    assignedToUserId?: number | undefined;
    due?: Date | undefined;
    statusId?: number | undefined;

    constructor(data?: IInsertTicketSubtaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createTask = _data["createTask"];
            this.description = _data["description"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): InsertTicketSubtaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTicketSubtaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTask"] = this.createTask;
        data["description"] = this.description;
        data["assignedToUserId"] = this.assignedToUserId;
        data["due"] = this.due ? formatDate(this.due) : undefined as any;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface IInsertTicketSubtaskRequest {
    createTask: boolean;
    description?: string | undefined;
    assignedToUserId?: number | undefined;
    due?: Date | undefined;
    statusId?: number | undefined;
}

export class InsertTicketTimesheetRequest implements IInsertTicketTimesheetRequest {
    date!: Date;
    effort!: number;
    estimatedTime?: number | undefined;

    constructor(data?: IInsertTicketTimesheetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.effort = _data["effort"];
            this.estimatedTime = _data["estimatedTime"];
        }
    }

    static fromJS(data: any): InsertTicketTimesheetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTicketTimesheetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["effort"] = this.effort;
        data["estimatedTime"] = this.estimatedTime;
        return data;
    }
}

export interface IInsertTicketTimesheetRequest {
    date: Date;
    effort: number;
    estimatedTime?: number | undefined;
}

export class InsertTicketTimesheetRequestUpdateTicketTimesheetRequestInt32DeltaModel implements IInsertTicketTimesheetRequestUpdateTicketTimesheetRequestInt32DeltaModel {
    insert?: InsertTicketTimesheetRequest[] | undefined;
    update?: UpdateTicketTimesheetRequest[] | undefined;
    delete?: number[] | undefined;

    constructor(data?: IInsertTicketTimesheetRequestUpdateTicketTimesheetRequestInt32DeltaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertTicketTimesheetRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateTicketTimesheetRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(item);
            }
        }
    }

    static fromJS(data: any): InsertTicketTimesheetRequestUpdateTicketTimesheetRequestInt32DeltaModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTicketTimesheetRequestUpdateTicketTimesheetRequestInt32DeltaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item);
        }
        return data;
    }
}

export interface IInsertTicketTimesheetRequestUpdateTicketTimesheetRequestInt32DeltaModel {
    insert?: InsertTicketTimesheetRequest[] | undefined;
    update?: UpdateTicketTimesheetRequest[] | undefined;
    delete?: number[] | undefined;
}

export class InsertTimesheetRequest implements IInsertTimesheetRequest {
    date!: Date;
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    effort!: number;
    description?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    customText3?: string | undefined;
    changeRequestId?: number | undefined;
    ticketId?: number | undefined;
    taskId?: number | undefined;
    scheduleId?: number | undefined;
    projectTeamId?: number | undefined;

    constructor(data?: IInsertTimesheetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.effort = _data["effort"];
            this.description = _data["description"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.customText3 = _data["customText3"];
            this.changeRequestId = _data["changeRequestId"];
            this.ticketId = _data["ticketId"];
            this.taskId = _data["taskId"];
            this.scheduleId = _data["scheduleId"];
            this.projectTeamId = _data["projectTeamId"];
        }
    }

    static fromJS(data: any): InsertTimesheetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTimesheetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["effort"] = this.effort;
        data["description"] = this.description;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["customText3"] = this.customText3;
        data["changeRequestId"] = this.changeRequestId;
        data["ticketId"] = this.ticketId;
        data["taskId"] = this.taskId;
        data["scheduleId"] = this.scheduleId;
        data["projectTeamId"] = this.projectTeamId;
        return data;
    }
}

export interface IInsertTimesheetRequest {
    date: Date;
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    effort: number;
    description?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    customText3?: string | undefined;
    changeRequestId?: number | undefined;
    ticketId?: number | undefined;
    taskId?: number | undefined;
    scheduleId?: number | undefined;
    projectTeamId?: number | undefined;
}

export class InsertTravelExpenseItemRequest implements IInsertTravelExpenseItemRequest {
    costTypeId!: number;
    amountProjectCurrency!: number;
    receiptCurrencyId?: number | undefined;
    amountReceiptCurrency?: number | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;

    constructor(data?: IInsertTravelExpenseItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costTypeId = _data["costTypeId"];
            this.amountProjectCurrency = _data["amountProjectCurrency"];
            this.receiptCurrencyId = _data["receiptCurrencyId"];
            this.amountReceiptCurrency = _data["amountReceiptCurrency"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertTravelExpenseItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTravelExpenseItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costTypeId"] = this.costTypeId;
        data["amountProjectCurrency"] = this.amountProjectCurrency;
        data["receiptCurrencyId"] = this.receiptCurrencyId;
        data["amountReceiptCurrency"] = this.amountReceiptCurrency;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertTravelExpenseItemRequest {
    costTypeId: number;
    amountProjectCurrency: number;
    receiptCurrencyId?: number | undefined;
    amountReceiptCurrency?: number | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
}

export class InsertTravelExpenseItemRequestUpdateTravelExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel implements IInsertTravelExpenseItemRequestUpdateTravelExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel {
    insert?: InsertTravelExpenseItemRequest[] | undefined;
    update?: UpdateTravelExpenseItemRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;

    constructor(data?: IInsertTravelExpenseItemRequestUpdateTravelExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertTravelExpenseItemRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateTravelExpenseItemRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteTenantIndetifyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertTravelExpenseItemRequestUpdateTravelExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTravelExpenseItemRequestUpdateTravelExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertTravelExpenseItemRequestUpdateTravelExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel {
    insert?: InsertTravelExpenseItemRequest[] | undefined;
    update?: UpdateTravelExpenseItemRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;
}

export class InsertTravelExpenseRequest implements IInsertTravelExpenseRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    description!: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease!: boolean;
    travelRequestId?: number | undefined;
    destinationCountryId!: number;
    destinationCity!: string;
    estimatedCosts?: number | undefined;
    advancePayment?: number | undefined;
    freeMeals!: boolean;
    freeAccommodation!: boolean;
    travelBy!: TravelByEnum;
    regNumber?: string | undefined;
    distance?: string | undefined;
    startKilemeter?: string | undefined;
    endKilometer?: string | undefined;
    leaveDepartureDate!: Date;
    leaveDepartureTime!: number;
    leaveBorderCrossDate?: Date | undefined;
    leaveBorderCrossTime?: number | undefined;
    leaveArrivalDate?: Date | undefined;
    leaveArrivalTime?: number | undefined;
    returnDepartureDate?: Date | undefined;
    returnDepartureTime?: number | undefined;
    returnBorderCrossDate?: Date | undefined;
    returnBorderCrossTime?: number | undefined;
    returnArrivalDate!: Date;
    returnArrivalTime!: number;
    newTravelExpenses?: InsertTravelExpenseItemRequest[] | undefined;

    constructor(data?: IInsertTravelExpenseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.description = _data["description"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.isRelease = _data["isRelease"];
            this.travelRequestId = _data["travelRequestId"];
            this.destinationCountryId = _data["destinationCountryId"];
            this.destinationCity = _data["destinationCity"];
            this.estimatedCosts = _data["estimatedCosts"];
            this.advancePayment = _data["advancePayment"];
            this.freeMeals = _data["freeMeals"];
            this.freeAccommodation = _data["freeAccommodation"];
            this.travelBy = _data["travelBy"];
            this.regNumber = _data["regNumber"];
            this.distance = _data["distance"];
            this.startKilemeter = _data["startKilemeter"];
            this.endKilometer = _data["endKilometer"];
            this.leaveDepartureDate = _data["leaveDepartureDate"] ? new Date(_data["leaveDepartureDate"].toString()) : undefined as any;
            this.leaveDepartureTime = _data["leaveDepartureTime"];
            this.leaveBorderCrossDate = _data["leaveBorderCrossDate"] ? new Date(_data["leaveBorderCrossDate"].toString()) : undefined as any;
            this.leaveBorderCrossTime = _data["leaveBorderCrossTime"];
            this.leaveArrivalDate = _data["leaveArrivalDate"] ? new Date(_data["leaveArrivalDate"].toString()) : undefined as any;
            this.leaveArrivalTime = _data["leaveArrivalTime"];
            this.returnDepartureDate = _data["returnDepartureDate"] ? new Date(_data["returnDepartureDate"].toString()) : undefined as any;
            this.returnDepartureTime = _data["returnDepartureTime"];
            this.returnBorderCrossDate = _data["returnBorderCrossDate"] ? new Date(_data["returnBorderCrossDate"].toString()) : undefined as any;
            this.returnBorderCrossTime = _data["returnBorderCrossTime"];
            this.returnArrivalDate = _data["returnArrivalDate"] ? new Date(_data["returnArrivalDate"].toString()) : undefined as any;
            this.returnArrivalTime = _data["returnArrivalTime"];
            if (Array.isArray(_data["newTravelExpenses"])) {
                this.newTravelExpenses = [] as any;
                for (let item of _data["newTravelExpenses"])
                    this.newTravelExpenses!.push(InsertTravelExpenseItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertTravelExpenseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTravelExpenseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["description"] = this.description;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["isRelease"] = this.isRelease;
        data["travelRequestId"] = this.travelRequestId;
        data["destinationCountryId"] = this.destinationCountryId;
        data["destinationCity"] = this.destinationCity;
        data["estimatedCosts"] = this.estimatedCosts;
        data["advancePayment"] = this.advancePayment;
        data["freeMeals"] = this.freeMeals;
        data["freeAccommodation"] = this.freeAccommodation;
        data["travelBy"] = this.travelBy;
        data["regNumber"] = this.regNumber;
        data["distance"] = this.distance;
        data["startKilemeter"] = this.startKilemeter;
        data["endKilometer"] = this.endKilometer;
        data["leaveDepartureDate"] = this.leaveDepartureDate ? formatDate(this.leaveDepartureDate) : undefined as any;
        data["leaveDepartureTime"] = this.leaveDepartureTime;
        data["leaveBorderCrossDate"] = this.leaveBorderCrossDate ? formatDate(this.leaveBorderCrossDate) : undefined as any;
        data["leaveBorderCrossTime"] = this.leaveBorderCrossTime;
        data["leaveArrivalDate"] = this.leaveArrivalDate ? formatDate(this.leaveArrivalDate) : undefined as any;
        data["leaveArrivalTime"] = this.leaveArrivalTime;
        data["returnDepartureDate"] = this.returnDepartureDate ? formatDate(this.returnDepartureDate) : undefined as any;
        data["returnDepartureTime"] = this.returnDepartureTime;
        data["returnBorderCrossDate"] = this.returnBorderCrossDate ? formatDate(this.returnBorderCrossDate) : undefined as any;
        data["returnBorderCrossTime"] = this.returnBorderCrossTime;
        data["returnArrivalDate"] = this.returnArrivalDate ? formatDate(this.returnArrivalDate) : undefined as any;
        data["returnArrivalTime"] = this.returnArrivalTime;
        if (Array.isArray(this.newTravelExpenses)) {
            data["newTravelExpenses"] = [];
            for (let item of this.newTravelExpenses)
                data["newTravelExpenses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsertTravelExpenseRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    description: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease: boolean;
    travelRequestId?: number | undefined;
    destinationCountryId: number;
    destinationCity: string;
    estimatedCosts?: number | undefined;
    advancePayment?: number | undefined;
    freeMeals: boolean;
    freeAccommodation: boolean;
    travelBy: TravelByEnum;
    regNumber?: string | undefined;
    distance?: string | undefined;
    startKilemeter?: string | undefined;
    endKilometer?: string | undefined;
    leaveDepartureDate: Date;
    leaveDepartureTime: number;
    leaveBorderCrossDate?: Date | undefined;
    leaveBorderCrossTime?: number | undefined;
    leaveArrivalDate?: Date | undefined;
    leaveArrivalTime?: number | undefined;
    returnDepartureDate?: Date | undefined;
    returnDepartureTime?: number | undefined;
    returnBorderCrossDate?: Date | undefined;
    returnBorderCrossTime?: number | undefined;
    returnArrivalDate: Date;
    returnArrivalTime: number;
    newTravelExpenses?: InsertTravelExpenseItemRequest[] | undefined;
}

export class InsertTravelRequestRequest implements IInsertTravelRequestRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    description!: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease!: boolean;
    departure!: Date;
    return!: Date;
    destinationCountryId!: number;
    destinationCity!: string;
    estimatedCosts!: number;
    advancePayment?: number | undefined;
    freeMeals!: boolean;
    freeAccommodation!: boolean;
    travelBy!: TravelByEnum;

    constructor(data?: IInsertTravelRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.description = _data["description"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.isRelease = _data["isRelease"];
            this.departure = _data["departure"] ? new Date(_data["departure"].toString()) : undefined as any;
            this.return = _data["return"] ? new Date(_data["return"].toString()) : undefined as any;
            this.destinationCountryId = _data["destinationCountryId"];
            this.destinationCity = _data["destinationCity"];
            this.estimatedCosts = _data["estimatedCosts"];
            this.advancePayment = _data["advancePayment"];
            this.freeMeals = _data["freeMeals"];
            this.freeAccommodation = _data["freeAccommodation"];
            this.travelBy = _data["travelBy"];
        }
    }

    static fromJS(data: any): InsertTravelRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertTravelRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["description"] = this.description;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["isRelease"] = this.isRelease;
        data["departure"] = this.departure ? formatDate(this.departure) : undefined as any;
        data["return"] = this.return ? formatDate(this.return) : undefined as any;
        data["destinationCountryId"] = this.destinationCountryId;
        data["destinationCity"] = this.destinationCity;
        data["estimatedCosts"] = this.estimatedCosts;
        data["advancePayment"] = this.advancePayment;
        data["freeMeals"] = this.freeMeals;
        data["freeAccommodation"] = this.freeAccommodation;
        data["travelBy"] = this.travelBy;
        return data;
    }
}

export interface IInsertTravelRequestRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    description: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease: boolean;
    departure: Date;
    return: Date;
    destinationCountryId: number;
    destinationCity: string;
    estimatedCosts: number;
    advancePayment?: number | undefined;
    freeMeals: boolean;
    freeAccommodation: boolean;
    travelBy: TravelByEnum;
}

export class InsertUpdateUserTableViewConfigRequest implements IInsertUpdateUserTableViewConfigRequest {
    viewType!: string;
    content!: any;

    constructor(data?: IInsertUpdateUserTableViewConfigRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.viewType = _data["viewType"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): InsertUpdateUserTableViewConfigRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertUpdateUserTableViewConfigRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewType"] = this.viewType;
        data["content"] = this.content;
        return data;
    }
}

export interface IInsertUpdateUserTableViewConfigRequest {
    viewType: string;
    content: any;
}

export class InsertUserRequestModel implements IInsertUserRequestModel {
    firstName!: string;
    lastName!: string;
    birthDate?: Date | undefined;
    email!: string;
    officePhone?: string | undefined;
    mobilePhone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    organizationalUnitId?: number | undefined;
    department?: string | undefined;
    isGuest!: boolean;
    username!: string;
    partnerId?: number | undefined;
    helpDeskUser!: boolean;
    helpDeskProjectIds?: number[] | undefined;

    constructor(data?: IInsertUserRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined as any;
            this.email = _data["email"];
            this.officePhone = _data["officePhone"];
            this.mobilePhone = _data["mobilePhone"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.organizationalUnitId = _data["organizationalUnitId"];
            this.department = _data["department"];
            this.isGuest = _data["isGuest"];
            this.username = _data["username"];
            this.partnerId = _data["partnerId"];
            this.helpDeskUser = _data["helpDeskUser"];
            if (Array.isArray(_data["helpDeskProjectIds"])) {
                this.helpDeskProjectIds = [] as any;
                for (let item of _data["helpDeskProjectIds"])
                    this.helpDeskProjectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): InsertUserRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsertUserRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["email"] = this.email;
        data["officePhone"] = this.officePhone;
        data["mobilePhone"] = this.mobilePhone;
        data["address"] = this.address;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["organizationalUnitId"] = this.organizationalUnitId;
        data["department"] = this.department;
        data["isGuest"] = this.isGuest;
        data["username"] = this.username;
        data["partnerId"] = this.partnerId;
        data["helpDeskUser"] = this.helpDeskUser;
        if (Array.isArray(this.helpDeskProjectIds)) {
            data["helpDeskProjectIds"] = [];
            for (let item of this.helpDeskProjectIds)
                data["helpDeskProjectIds"].push(item);
        }
        return data;
    }
}

export interface IInsertUserRequestModel {
    firstName: string;
    lastName: string;
    birthDate?: Date | undefined;
    email: string;
    officePhone?: string | undefined;
    mobilePhone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    organizationalUnitId?: number | undefined;
    department?: string | undefined;
    isGuest: boolean;
    username: string;
    partnerId?: number | undefined;
    helpDeskUser: boolean;
    helpDeskProjectIds?: number[] | undefined;
}

export class InsertVacationRequestRequest implements IInsertVacationRequestRequest {
    from!: Date;
    to!: Date;
    note?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease!: boolean;

    constructor(data?: IInsertVacationRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.note = _data["note"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.isRelease = _data["isRelease"];
        }
    }

    static fromJS(data: any): InsertVacationRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertVacationRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["note"] = this.note;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["isRelease"] = this.isRelease;
        return data;
    }
}

export interface IInsertVacationRequestRequest {
    from: Date;
    to: Date;
    note?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease: boolean;
}

export class Int32Int32Int32DeltaModel implements IInt32Int32Int32DeltaModel {
    insert?: number[] | undefined;
    update?: number[] | undefined;
    delete?: number[] | undefined;

    constructor(data?: IInt32Int32Int32DeltaModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(item);
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(item);
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(item);
            }
        }
    }

    static fromJS(data: any): Int32Int32Int32DeltaModel {
        data = typeof data === 'object' ? data : {};
        let result = new Int32Int32Int32DeltaModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item);
        }
        return data;
    }
}

export interface IInt32Int32Int32DeltaModel {
    insert?: number[] | undefined;
    update?: number[] | undefined;
    delete?: number[] | undefined;
}

export class IntNewOld implements IIntNewOld {
    oldValue?: number | undefined;
    newValue?: number | undefined;

    constructor(data?: IIntNewOld) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): IntNewOld {
        data = typeof data === 'object' ? data : {};
        let result = new IntNewOld();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IIntNewOld {
    oldValue?: number | undefined;
    newValue?: number | undefined;
}

export class InvoiceCountsResponse implements IInvoiceCountsResponse {
    amountSum!: number;
    taxAmountSum!: number;
    totalAmountSum!: number;
    localCurrencyAmountSum?: number | undefined;
    localCurrencyTaxAmountSum?: number | undefined;
    localCurrencyTotalAmountSum?: number | undefined;

    constructor(data?: IInvoiceCountsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountSum = _data["amountSum"];
            this.taxAmountSum = _data["taxAmountSum"];
            this.totalAmountSum = _data["totalAmountSum"];
            this.localCurrencyAmountSum = _data["localCurrencyAmountSum"];
            this.localCurrencyTaxAmountSum = _data["localCurrencyTaxAmountSum"];
            this.localCurrencyTotalAmountSum = _data["localCurrencyTotalAmountSum"];
        }
    }

    static fromJS(data: any): InvoiceCountsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceCountsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountSum"] = this.amountSum;
        data["taxAmountSum"] = this.taxAmountSum;
        data["totalAmountSum"] = this.totalAmountSum;
        data["localCurrencyAmountSum"] = this.localCurrencyAmountSum;
        data["localCurrencyTaxAmountSum"] = this.localCurrencyTaxAmountSum;
        data["localCurrencyTotalAmountSum"] = this.localCurrencyTotalAmountSum;
        return data;
    }
}

export interface IInvoiceCountsResponse {
    amountSum: number;
    taxAmountSum: number;
    totalAmountSum: number;
    localCurrencyAmountSum?: number | undefined;
    localCurrencyTaxAmountSum?: number | undefined;
    localCurrencyTotalAmountSum?: number | undefined;
}

export class InvoiceCountsResponseSimpleResponseModel implements IInvoiceCountsResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: InvoiceCountsResponse;

    constructor(data?: IInvoiceCountsResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? InvoiceCountsResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): InvoiceCountsResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceCountsResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IInvoiceCountsResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: InvoiceCountsResponse;
}

export class InvoiceItemResponse implements IInvoiceItemResponse {
    id!: number;
    description!: string;
    amount!: number;
    taxAmount!: number;
    readonly totalAmount!: number;
    localCurrencyAmount?: number | undefined;
    localCurrencyTaxAmount?: number | undefined;
    readonly totalLocalCurrencyAmount?: number | undefined;

    constructor(data?: IInvoiceItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.taxAmount = _data["taxAmount"];
            (this as any).totalAmount = _data["totalAmount"];
            this.localCurrencyAmount = _data["localCurrencyAmount"];
            this.localCurrencyTaxAmount = _data["localCurrencyTaxAmount"];
            (this as any).totalLocalCurrencyAmount = _data["totalLocalCurrencyAmount"];
        }
    }

    static fromJS(data: any): InvoiceItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["taxAmount"] = this.taxAmount;
        data["totalAmount"] = this.totalAmount;
        data["localCurrencyAmount"] = this.localCurrencyAmount;
        data["localCurrencyTaxAmount"] = this.localCurrencyTaxAmount;
        data["totalLocalCurrencyAmount"] = this.totalLocalCurrencyAmount;
        return data;
    }
}

export interface IInvoiceItemResponse {
    id: number;
    description: string;
    amount: number;
    taxAmount: number;
    totalAmount: number;
    localCurrencyAmount?: number | undefined;
    localCurrencyTaxAmount?: number | undefined;
    totalLocalCurrencyAmount?: number | undefined;
}

export class InvoiceResponse implements IInvoiceResponse {
    id!: number;
    projectId!: number;
    partnerId!: number;
    invoiceNumber!: string;
    description?: string | undefined;
    invoiceType!: InvoiceTypeEnum;
    issueDate!: Date;
    due!: Date;
    overdueDays?: number | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    excludeFromBudget!: boolean;
    amount!: number;
    taxAmount!: number;
    readonly totalAmount!: number;
    localCurrencyId?: number | undefined;
    localCurrencyAmount?: number | undefined;
    localCurrencyTaxAmount?: number | undefined;
    readonly totalLocalCurrencyAmount?: number | undefined;
    comment?: string | undefined;
    changeRequestId?: number | undefined;
    statusId!: number;
    financeCategoryId!: number;
    invoiceItems?: InvoiceItemResponse[] | undefined;
    attachments?: AttachmentResponse[] | undefined;

    constructor(data?: IInvoiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.partnerId = _data["partnerId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.description = _data["description"];
            this.invoiceType = _data["invoiceType"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            this.overdueDays = _data["overdueDays"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.excludeFromBudget = _data["excludeFromBudget"];
            this.amount = _data["amount"];
            this.taxAmount = _data["taxAmount"];
            (this as any).totalAmount = _data["totalAmount"];
            this.localCurrencyId = _data["localCurrencyId"];
            this.localCurrencyAmount = _data["localCurrencyAmount"];
            this.localCurrencyTaxAmount = _data["localCurrencyTaxAmount"];
            (this as any).totalLocalCurrencyAmount = _data["totalLocalCurrencyAmount"];
            this.comment = _data["comment"];
            this.changeRequestId = _data["changeRequestId"];
            this.statusId = _data["statusId"];
            this.financeCategoryId = _data["financeCategoryId"];
            if (Array.isArray(_data["invoiceItems"])) {
                this.invoiceItems = [] as any;
                for (let item of _data["invoiceItems"])
                    this.invoiceItems!.push(InvoiceItemResponse.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["partnerId"] = this.partnerId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["description"] = this.description;
        data["invoiceType"] = this.invoiceType;
        data["issueDate"] = this.issueDate ? formatDate(this.issueDate) : undefined as any;
        data["due"] = this.due ? formatDate(this.due) : undefined as any;
        data["overdueDays"] = this.overdueDays;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["excludeFromBudget"] = this.excludeFromBudget;
        data["amount"] = this.amount;
        data["taxAmount"] = this.taxAmount;
        data["totalAmount"] = this.totalAmount;
        data["localCurrencyId"] = this.localCurrencyId;
        data["localCurrencyAmount"] = this.localCurrencyAmount;
        data["localCurrencyTaxAmount"] = this.localCurrencyTaxAmount;
        data["totalLocalCurrencyAmount"] = this.totalLocalCurrencyAmount;
        data["comment"] = this.comment;
        data["changeRequestId"] = this.changeRequestId;
        data["statusId"] = this.statusId;
        data["financeCategoryId"] = this.financeCategoryId;
        if (Array.isArray(this.invoiceItems)) {
            data["invoiceItems"] = [];
            for (let item of this.invoiceItems)
                data["invoiceItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvoiceResponse {
    id: number;
    projectId: number;
    partnerId: number;
    invoiceNumber: string;
    description?: string | undefined;
    invoiceType: InvoiceTypeEnum;
    issueDate: Date;
    due: Date;
    overdueDays?: number | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    excludeFromBudget: boolean;
    amount: number;
    taxAmount: number;
    totalAmount: number;
    localCurrencyId?: number | undefined;
    localCurrencyAmount?: number | undefined;
    localCurrencyTaxAmount?: number | undefined;
    totalLocalCurrencyAmount?: number | undefined;
    comment?: string | undefined;
    changeRequestId?: number | undefined;
    statusId: number;
    financeCategoryId: number;
    invoiceItems?: InvoiceItemResponse[] | undefined;
    attachments?: AttachmentResponse[] | undefined;
}

export class InvoiceResponseItemsResponseModel implements IInvoiceResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: InvoiceResponse[] | undefined;

    constructor(data?: IInvoiceResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InvoiceResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvoiceResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: InvoiceResponse[] | undefined;
}

export class InvoiceResponseSimpleResponseModel implements IInvoiceResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: InvoiceResponse;

    constructor(data?: IInvoiceResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? InvoiceResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): InvoiceResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IInvoiceResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: InvoiceResponse;
}

export enum InvoiceStatusEnum {
    Planned = "Planned",
    IssuedReceived = "IssuedReceived",
    Paid = "Paid",
}

export class InvoiceStatusResponse implements IInvoiceStatusResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isReadonly!: boolean;
    color!: string;
    isInitial!: boolean;
    nextStates?: number[] | undefined;
    order!: number;
    semantics!: InvoiceStatusEnum;

    constructor(data?: IInvoiceStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isReadonly = _data["isReadonly"];
            this.color = _data["color"];
            this.isInitial = _data["isInitial"];
            if (Array.isArray(_data["nextStates"])) {
                this.nextStates = [] as any;
                for (let item of _data["nextStates"])
                    this.nextStates!.push(item);
            }
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): InvoiceStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isReadonly"] = this.isReadonly;
        data["color"] = this.color;
        data["isInitial"] = this.isInitial;
        if (Array.isArray(this.nextStates)) {
            data["nextStates"] = [];
            for (let item of this.nextStates)
                data["nextStates"].push(item);
        }
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IInvoiceStatusResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isReadonly: boolean;
    color: string;
    isInitial: boolean;
    nextStates?: number[] | undefined;
    order: number;
    semantics: InvoiceStatusEnum;
}

export class InvoiceStatusResponseItemsResponseModel implements IInvoiceStatusResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: InvoiceStatusResponse[] | undefined;

    constructor(data?: IInvoiceStatusResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InvoiceStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceStatusResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceStatusResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvoiceStatusResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: InvoiceStatusResponse[] | undefined;
}

export enum InvoiceTypeEnum {
    Incoming = "Incoming",
    Outgoing = "Outgoing",
}

export enum LanguagesEnum {
    English = "English",
    Serbian = "Serbian",
}

export class LoginRequestModel implements ILoginRequestModel {
    username?: string | undefined;
    email?: string | undefined;
    domian!: string;
    password?: string | undefined;
    language!: LanguagesEnum;

    constructor(data?: ILoginRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.email = _data["email"];
            this.domian = _data["domian"];
            this.password = _data["password"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): LoginRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["email"] = this.email;
        data["domian"] = this.domian;
        data["password"] = this.password;
        data["language"] = this.language;
        return data;
    }
}

export interface ILoginRequestModel {
    username?: string | undefined;
    email?: string | undefined;
    domian: string;
    password?: string | undefined;
    language: LanguagesEnum;
}

export class MeetingCommentResponse implements IMeetingCommentResponse {
    id!: number;
    meetingId!: number;
    comment?: string | undefined;
    userId!: number;
    createdOn!: Date;
    meetingTopicId!: number;
    meetingTopicType!: MeetingTopicTypeEnum;

    constructor(data?: IMeetingCommentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meetingId = _data["meetingId"];
            this.comment = _data["comment"];
            this.userId = _data["userId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.meetingTopicId = _data["meetingTopicId"];
            this.meetingTopicType = _data["meetingTopicType"];
        }
    }

    static fromJS(data: any): MeetingCommentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingCommentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meetingId"] = this.meetingId;
        data["comment"] = this.comment;
        data["userId"] = this.userId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["meetingTopicId"] = this.meetingTopicId;
        data["meetingTopicType"] = this.meetingTopicType;
        return data;
    }
}

export interface IMeetingCommentResponse {
    id: number;
    meetingId: number;
    comment?: string | undefined;
    userId: number;
    createdOn: Date;
    meetingTopicId: number;
    meetingTopicType: MeetingTopicTypeEnum;
}

export class MeetingCommentResponseSimpleResponseModel implements IMeetingCommentResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: MeetingCommentResponse;

    constructor(data?: IMeetingCommentResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? MeetingCommentResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): MeetingCommentResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingCommentResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IMeetingCommentResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: MeetingCommentResponse;
}

export class MeetingDecisionResponse implements IMeetingDecisionResponse {
    id!: number;
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    meetingId!: number;
    description!: string;
    subject!: string;
    userId!: number;
    meetingTypeId?: number | undefined;
    statusId!: number;
    date!: Date;

    constructor(data?: IMeetingDecisionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.meetingId = _data["meetingId"];
            this.description = _data["description"];
            this.subject = _data["subject"];
            this.userId = _data["userId"];
            this.meetingTypeId = _data["meetingTypeId"];
            this.statusId = _data["statusId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MeetingDecisionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingDecisionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["meetingId"] = this.meetingId;
        data["description"] = this.description;
        data["subject"] = this.subject;
        data["userId"] = this.userId;
        data["meetingTypeId"] = this.meetingTypeId;
        data["statusId"] = this.statusId;
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        return data;
    }
}

export interface IMeetingDecisionResponse {
    id: number;
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    meetingId: number;
    description: string;
    subject: string;
    userId: number;
    meetingTypeId?: number | undefined;
    statusId: number;
    date: Date;
}

export class MeetingDecisionResponseItemsResponseModel implements IMeetingDecisionResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: MeetingDecisionResponse[] | undefined;

    constructor(data?: IMeetingDecisionResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeetingDecisionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeetingDecisionResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingDecisionResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMeetingDecisionResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: MeetingDecisionResponse[] | undefined;
}

export class MeetingGeneralConfigResponse implements IMeetingGeneralConfigResponse {
    id!: number;
    notifyWhenReleased!: boolean;
    enableEmailNotifications!: boolean;

    constructor(data?: IMeetingGeneralConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.notifyWhenReleased = _data["notifyWhenReleased"];
            this.enableEmailNotifications = _data["enableEmailNotifications"];
        }
    }

    static fromJS(data: any): MeetingGeneralConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingGeneralConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["notifyWhenReleased"] = this.notifyWhenReleased;
        data["enableEmailNotifications"] = this.enableEmailNotifications;
        return data;
    }
}

export interface IMeetingGeneralConfigResponse {
    id: number;
    notifyWhenReleased: boolean;
    enableEmailNotifications: boolean;
}

export class MeetingGeneralConfigResponseSimpleResponseModel implements IMeetingGeneralConfigResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: MeetingGeneralConfigResponse;

    constructor(data?: IMeetingGeneralConfigResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? MeetingGeneralConfigResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): MeetingGeneralConfigResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingGeneralConfigResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IMeetingGeneralConfigResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: MeetingGeneralConfigResponse;
}

export class MeetingResponse implements IMeetingResponse {
    id!: number;
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    subject!: string;
    userId!: number;
    location?: string | undefined;
    duration?: number | undefined;
    starts!: Date;
    ends!: Date;
    agenda!: string;
    additionallParticipants?: string | undefined;
    isPrivate!: boolean;
    statusId!: number;
    meetingTypeId?: number | undefined;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    participantUserIds?: number[] | undefined;
    topics?: MeetingTopicResponse[] | undefined;
    attachments?: AttachmentResponse[] | undefined;

    constructor(data?: IMeetingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.subject = _data["subject"];
            this.userId = _data["userId"];
            this.location = _data["location"];
            this.duration = _data["duration"];
            this.starts = _data["starts"] ? new Date(_data["starts"].toString()) : undefined as any;
            this.ends = _data["ends"] ? new Date(_data["ends"].toString()) : undefined as any;
            this.agenda = _data["agenda"];
            this.additionallParticipants = _data["additionallParticipants"];
            this.isPrivate = _data["isPrivate"];
            this.statusId = _data["statusId"];
            this.meetingTypeId = _data["meetingTypeId"];
            this.projectTeamId = _data["projectTeamId"];
            this.projectOrganizationId = _data["projectOrganizationId"];
            if (Array.isArray(_data["participantUserIds"])) {
                this.participantUserIds = [] as any;
                for (let item of _data["participantUserIds"])
                    this.participantUserIds!.push(item);
            }
            if (Array.isArray(_data["topics"])) {
                this.topics = [] as any;
                for (let item of _data["topics"])
                    this.topics!.push(MeetingTopicResponse.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeetingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["subject"] = this.subject;
        data["userId"] = this.userId;
        data["location"] = this.location;
        data["duration"] = this.duration;
        data["starts"] = this.starts ? this.starts.toISOString() : undefined as any;
        data["ends"] = this.ends ? this.ends.toISOString() : undefined as any;
        data["agenda"] = this.agenda;
        data["additionallParticipants"] = this.additionallParticipants;
        data["isPrivate"] = this.isPrivate;
        data["statusId"] = this.statusId;
        data["meetingTypeId"] = this.meetingTypeId;
        data["projectTeamId"] = this.projectTeamId;
        data["projectOrganizationId"] = this.projectOrganizationId;
        if (Array.isArray(this.participantUserIds)) {
            data["participantUserIds"] = [];
            for (let item of this.participantUserIds)
                data["participantUserIds"].push(item);
        }
        if (Array.isArray(this.topics)) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMeetingResponse {
    id: number;
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    subject: string;
    userId: number;
    location?: string | undefined;
    duration?: number | undefined;
    starts: Date;
    ends: Date;
    agenda: string;
    additionallParticipants?: string | undefined;
    isPrivate: boolean;
    statusId: number;
    meetingTypeId?: number | undefined;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    participantUserIds?: number[] | undefined;
    topics?: MeetingTopicResponse[] | undefined;
    attachments?: AttachmentResponse[] | undefined;
}

export class MeetingResponseItemsResponseModel implements IMeetingResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: MeetingResponse[] | undefined;

    constructor(data?: IMeetingResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeetingResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeetingResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMeetingResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: MeetingResponse[] | undefined;
}

export class MeetingResponseSimpleResponseModel implements IMeetingResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: MeetingResponse;

    constructor(data?: IMeetingResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? MeetingResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): MeetingResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IMeetingResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: MeetingResponse;
}

export enum MeetingStatusEnum {
    Created = "Created",
    Released = "Released",
}

export class MeetingStatusResponse implements IMeetingStatusResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isReadonly!: boolean;
    color!: string;
    isInitial!: boolean;
    nextStates?: number[] | undefined;
    order!: number;
    semantics!: MeetingStatusEnum;

    constructor(data?: IMeetingStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isReadonly = _data["isReadonly"];
            this.color = _data["color"];
            this.isInitial = _data["isInitial"];
            if (Array.isArray(_data["nextStates"])) {
                this.nextStates = [] as any;
                for (let item of _data["nextStates"])
                    this.nextStates!.push(item);
            }
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): MeetingStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isReadonly"] = this.isReadonly;
        data["color"] = this.color;
        data["isInitial"] = this.isInitial;
        if (Array.isArray(this.nextStates)) {
            data["nextStates"] = [];
            for (let item of this.nextStates)
                data["nextStates"].push(item);
        }
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IMeetingStatusResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isReadonly: boolean;
    color: string;
    isInitial: boolean;
    nextStates?: number[] | undefined;
    order: number;
    semantics: MeetingStatusEnum;
}

export class MeetingStatusResponseItemsResponseModel implements IMeetingStatusResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: MeetingStatusResponse[] | undefined;

    constructor(data?: IMeetingStatusResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeetingStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeetingStatusResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingStatusResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMeetingStatusResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: MeetingStatusResponse[] | undefined;
}

export class MeetingTopicResponse implements IMeetingTopicResponse {
    id!: number;
    generatedId?: string | undefined;
    description!: string;
    order!: number;
    type!: MeetingTopicTypeEnum;
    userId?: number | undefined;
    due?: Date | undefined;
    statusId?: number | undefined;
    comments?: MeetingCommentResponse[] | undefined;

    constructor(data?: IMeetingTopicResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.generatedId = _data["generatedId"];
            this.description = _data["description"];
            this.order = _data["order"];
            this.type = _data["type"];
            this.userId = _data["userId"];
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(MeetingCommentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeetingTopicResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingTopicResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["generatedId"] = this.generatedId;
        data["description"] = this.description;
        data["order"] = this.order;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["due"] = this.due ? formatDate(this.due) : undefined as any;
        data["statusId"] = this.statusId;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMeetingTopicResponse {
    id: number;
    generatedId?: string | undefined;
    description: string;
    order: number;
    type: MeetingTopicTypeEnum;
    userId?: number | undefined;
    due?: Date | undefined;
    statusId?: number | undefined;
    comments?: MeetingCommentResponse[] | undefined;
}

export enum MeetingTopicTypeEnum {
    Task = "Task",
    Information = "Information",
    Decision = "Decision",
}

export class MessageModel implements IMessageModel {
    message?: string | undefined;
    messageCode?: string | undefined;
    additionalInfo?: any[] | undefined;

    constructor(data?: IMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.messageCode = _data["messageCode"];
            if (Array.isArray(_data["additionalInfo"])) {
                this.additionalInfo = [] as any;
                for (let item of _data["additionalInfo"])
                    this.additionalInfo!.push(item);
            }
        }
    }

    static fromJS(data: any): MessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new MessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["messageCode"] = this.messageCode;
        if (Array.isArray(this.additionalInfo)) {
            data["additionalInfo"] = [];
            for (let item of this.additionalInfo)
                data["additionalInfo"].push(item);
        }
        return data;
    }
}

export interface IMessageModel {
    message?: string | undefined;
    messageCode?: string | undefined;
    additionalInfo?: any[] | undefined;
}

export enum MitigationTypeEnum {
    None = "None",
    Preventive = "Preventive",
    Corrective = "Corrective",
}

export enum ModuleActivityEnum {
    Project = "Project",
    Ticket = "Ticket",
    Time = "Time",
    Risk = "Risk",
    Communication = "Communication",
    Schedule = "Schedule",
    Scope = "Scope",
    Testing = "Testing",
    Training = "Training",
    Finance = "Finance",
    Reporting = "Reporting",
}

export enum MonthEnum {
    January = "January",
    February = "February",
    March = "March",
    April = "April",
    May = "May",
    June = "June",
    July = "July",
    August = "August",
    September = "September",
    October = "October",
    November = "November",
    December = "December",
}

export class MyExpenseDashboardResponse implements IMyExpenseDashboardResponse {
    expensesPerStatusCounts?: { [key: string]: number; } | undefined;
    notApprovedExpenses?: TimeTravelDashboardRowResponse[] | undefined;

    constructor(data?: IMyExpenseDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["expensesPerStatusCounts"]) {
                this.expensesPerStatusCounts = {} as any;
                for (let key in _data["expensesPerStatusCounts"]) {
                    if (_data["expensesPerStatusCounts"].hasOwnProperty(key))
                        (this.expensesPerStatusCounts as any)![key] = _data["expensesPerStatusCounts"][key];
                }
            }
            if (Array.isArray(_data["notApprovedExpenses"])) {
                this.notApprovedExpenses = [] as any;
                for (let item of _data["notApprovedExpenses"])
                    this.notApprovedExpenses!.push(TimeTravelDashboardRowResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyExpenseDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MyExpenseDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.expensesPerStatusCounts) {
            data["expensesPerStatusCounts"] = {};
            for (let key in this.expensesPerStatusCounts) {
                if (this.expensesPerStatusCounts.hasOwnProperty(key))
                    (data["expensesPerStatusCounts"] as any)[key] = (this.expensesPerStatusCounts as any)[key];
            }
        }
        if (Array.isArray(this.notApprovedExpenses)) {
            data["notApprovedExpenses"] = [];
            for (let item of this.notApprovedExpenses)
                data["notApprovedExpenses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMyExpenseDashboardResponse {
    expensesPerStatusCounts?: { [key: string]: number; } | undefined;
    notApprovedExpenses?: TimeTravelDashboardRowResponse[] | undefined;
}

export class MyProfileUpdateRequestModel implements IMyProfileUpdateRequestModel {
    firstName!: string;
    lastName!: string;
    birthDate?: Date | undefined;
    email!: string;
    officePhone?: string | undefined;
    mobilePhone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    organizationalUnitId?: number | undefined;
    department?: string | undefined;

    constructor(data?: IMyProfileUpdateRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined as any;
            this.email = _data["email"];
            this.officePhone = _data["officePhone"];
            this.mobilePhone = _data["mobilePhone"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.organizationalUnitId = _data["organizationalUnitId"];
            this.department = _data["department"];
        }
    }

    static fromJS(data: any): MyProfileUpdateRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new MyProfileUpdateRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["email"] = this.email;
        data["officePhone"] = this.officePhone;
        data["mobilePhone"] = this.mobilePhone;
        data["address"] = this.address;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["organizationalUnitId"] = this.organizationalUnitId;
        data["department"] = this.department;
        return data;
    }
}

export interface IMyProfileUpdateRequestModel {
    firstName: string;
    lastName: string;
    birthDate?: Date | undefined;
    email: string;
    officePhone?: string | undefined;
    mobilePhone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    organizationalUnitId?: number | undefined;
    department?: string | undefined;
}

export class MySurveyQuestionResponse implements IMySurveyQuestionResponse {
    id!: number;
    questionGroup?: string | undefined;
    question!: string;
    surveyType!: SurveyQuestionTypeEnum;
    answerRequired!: boolean;
    scoreQuestion!: boolean;
    order!: number;
    proposedAnswers?: SurveyProposedAnswerResponse[] | undefined;
    answers?: SurveyParticipantAnswerResponse[] | undefined;

    constructor(data?: IMySurveyQuestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionGroup = _data["questionGroup"];
            this.question = _data["question"];
            this.surveyType = _data["surveyType"];
            this.answerRequired = _data["answerRequired"];
            this.scoreQuestion = _data["scoreQuestion"];
            this.order = _data["order"];
            if (Array.isArray(_data["proposedAnswers"])) {
                this.proposedAnswers = [] as any;
                for (let item of _data["proposedAnswers"])
                    this.proposedAnswers!.push(SurveyProposedAnswerResponse.fromJS(item));
            }
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(SurveyParticipantAnswerResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MySurveyQuestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MySurveyQuestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionGroup"] = this.questionGroup;
        data["question"] = this.question;
        data["surveyType"] = this.surveyType;
        data["answerRequired"] = this.answerRequired;
        data["scoreQuestion"] = this.scoreQuestion;
        data["order"] = this.order;
        if (Array.isArray(this.proposedAnswers)) {
            data["proposedAnswers"] = [];
            for (let item of this.proposedAnswers)
                data["proposedAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMySurveyQuestionResponse {
    id: number;
    questionGroup?: string | undefined;
    question: string;
    surveyType: SurveyQuestionTypeEnum;
    answerRequired: boolean;
    scoreQuestion: boolean;
    order: number;
    proposedAnswers?: SurveyProposedAnswerResponse[] | undefined;
    answers?: SurveyParticipantAnswerResponse[] | undefined;
}

export class MySurveyQuestionResponseItemsResponseModel implements IMySurveyQuestionResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: MySurveyQuestionResponse[] | undefined;

    constructor(data?: IMySurveyQuestionResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MySurveyQuestionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MySurveyQuestionResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MySurveyQuestionResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMySurveyQuestionResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: MySurveyQuestionResponse[] | undefined;
}

export class MySurveyResponse implements IMySurveyResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    surveyType!: SurveyTypeEnum;
    statusId!: number;

    constructor(data?: IMySurveyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.surveyType = _data["surveyType"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): MySurveyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MySurveyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["surveyType"] = this.surveyType;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface IMySurveyResponse {
    id: number;
    name: string;
    description?: string | undefined;
    surveyType: SurveyTypeEnum;
    statusId: number;
}

export class MySurveyResponseItemsResponseModel implements IMySurveyResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: MySurveyResponse[] | undefined;

    constructor(data?: IMySurveyResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MySurveyResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MySurveyResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MySurveyResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMySurveyResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: MySurveyResponse[] | undefined;
}

export class MySurveyResponseSimpleResponseModel implements IMySurveyResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: MySurveyResponse;

    constructor(data?: IMySurveyResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? MySurveyResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): MySurveyResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MySurveyResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IMySurveyResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: MySurveyResponse;
}

export class MyTestPlanResponse implements IMyTestPlanResponse {
    id!: number;
    isActive!: boolean;
    level3ProcessId?: string | undefined;
    level3ProcessName?: string | undefined;
    plannedDate?: Date | undefined;
    plannedTime?: number | undefined;
    plannedTimeTo?: number | undefined;
    duration?: number | undefined;
    comments?: string | undefined;
    processStatusId!: number;
    processTesterUserId?: number | undefined;
    complexLevel2Name?: string | undefined;
    complexLevel2Description?: string | undefined;
    isComplex!: boolean;
    stepStatusId?: number | undefined;
    stepTesterUserId?: number | undefined;
    processStepId?: string | undefined;
    processStepName?: string | undefined;
    level1Order?: number | undefined;
    level2Order?: number | undefined;
    level3Order?: number | undefined;
    level4Order?: number | undefined;
    level1Id?: number | undefined;
    level2Id?: number | undefined;
    level3Id?: number | undefined;
    level4Id?: number | undefined;

    constructor(data?: IMyTestPlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.level3ProcessId = _data["level3ProcessId"];
            this.level3ProcessName = _data["level3ProcessName"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.plannedTime = _data["plannedTime"];
            this.plannedTimeTo = _data["plannedTimeTo"];
            this.duration = _data["duration"];
            this.comments = _data["comments"];
            this.processStatusId = _data["processStatusId"];
            this.processTesterUserId = _data["processTesterUserId"];
            this.complexLevel2Name = _data["complexLevel2Name"];
            this.complexLevel2Description = _data["complexLevel2Description"];
            this.isComplex = _data["isComplex"];
            this.stepStatusId = _data["stepStatusId"];
            this.stepTesterUserId = _data["stepTesterUserId"];
            this.processStepId = _data["processStepId"];
            this.processStepName = _data["processStepName"];
            this.level1Order = _data["level1Order"];
            this.level2Order = _data["level2Order"];
            this.level3Order = _data["level3Order"];
            this.level4Order = _data["level4Order"];
            this.level1Id = _data["level1Id"];
            this.level2Id = _data["level2Id"];
            this.level3Id = _data["level3Id"];
            this.level4Id = _data["level4Id"];
        }
    }

    static fromJS(data: any): MyTestPlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MyTestPlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["level3ProcessId"] = this.level3ProcessId;
        data["level3ProcessName"] = this.level3ProcessName;
        data["plannedDate"] = this.plannedDate ? this.plannedDate.toISOString() : undefined as any;
        data["plannedTime"] = this.plannedTime;
        data["plannedTimeTo"] = this.plannedTimeTo;
        data["duration"] = this.duration;
        data["comments"] = this.comments;
        data["processStatusId"] = this.processStatusId;
        data["processTesterUserId"] = this.processTesterUserId;
        data["complexLevel2Name"] = this.complexLevel2Name;
        data["complexLevel2Description"] = this.complexLevel2Description;
        data["isComplex"] = this.isComplex;
        data["stepStatusId"] = this.stepStatusId;
        data["stepTesterUserId"] = this.stepTesterUserId;
        data["processStepId"] = this.processStepId;
        data["processStepName"] = this.processStepName;
        data["level1Order"] = this.level1Order;
        data["level2Order"] = this.level2Order;
        data["level3Order"] = this.level3Order;
        data["level4Order"] = this.level4Order;
        data["level1Id"] = this.level1Id;
        data["level2Id"] = this.level2Id;
        data["level3Id"] = this.level3Id;
        data["level4Id"] = this.level4Id;
        return data;
    }
}

export interface IMyTestPlanResponse {
    id: number;
    isActive: boolean;
    level3ProcessId?: string | undefined;
    level3ProcessName?: string | undefined;
    plannedDate?: Date | undefined;
    plannedTime?: number | undefined;
    plannedTimeTo?: number | undefined;
    duration?: number | undefined;
    comments?: string | undefined;
    processStatusId: number;
    processTesterUserId?: number | undefined;
    complexLevel2Name?: string | undefined;
    complexLevel2Description?: string | undefined;
    isComplex: boolean;
    stepStatusId?: number | undefined;
    stepTesterUserId?: number | undefined;
    processStepId?: string | undefined;
    processStepName?: string | undefined;
    level1Order?: number | undefined;
    level2Order?: number | undefined;
    level3Order?: number | undefined;
    level4Order?: number | undefined;
    level1Id?: number | undefined;
    level2Id?: number | undefined;
    level3Id?: number | undefined;
    level4Id?: number | undefined;
}

export class MyTestPlanResponseItemsResponseModel implements IMyTestPlanResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: MyTestPlanResponse[] | undefined;

    constructor(data?: IMyTestPlanResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MyTestPlanResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyTestPlanResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MyTestPlanResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMyTestPlanResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: MyTestPlanResponse[] | undefined;
}

export class MyTimesheetDashboardResponse implements IMyTimesheetDashboardResponse {
    timesheetsPerStatusCounts?: { [key: string]: number; } | undefined;
    notApprovedTimesheets?: TimeTravelDashboardRowResponse[] | undefined;
    timesheetHoursPerProject?: { [key: string]: number; } | undefined;
    timesheetHoursPerNonProjectCategory?: { [key: string]: number; } | undefined;
    approvedHoursPerBillability?: { [key: string]: number; } | undefined;
    totalTimesheetHours!: number;
    totalProductiveTimesheetHours!: number;
    totalNotProductiveTimesheetHours!: number;

    constructor(data?: IMyTimesheetDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["timesheetsPerStatusCounts"]) {
                this.timesheetsPerStatusCounts = {} as any;
                for (let key in _data["timesheetsPerStatusCounts"]) {
                    if (_data["timesheetsPerStatusCounts"].hasOwnProperty(key))
                        (this.timesheetsPerStatusCounts as any)![key] = _data["timesheetsPerStatusCounts"][key];
                }
            }
            if (Array.isArray(_data["notApprovedTimesheets"])) {
                this.notApprovedTimesheets = [] as any;
                for (let item of _data["notApprovedTimesheets"])
                    this.notApprovedTimesheets!.push(TimeTravelDashboardRowResponse.fromJS(item));
            }
            if (_data["timesheetHoursPerProject"]) {
                this.timesheetHoursPerProject = {} as any;
                for (let key in _data["timesheetHoursPerProject"]) {
                    if (_data["timesheetHoursPerProject"].hasOwnProperty(key))
                        (this.timesheetHoursPerProject as any)![key] = _data["timesheetHoursPerProject"][key];
                }
            }
            if (_data["timesheetHoursPerNonProjectCategory"]) {
                this.timesheetHoursPerNonProjectCategory = {} as any;
                for (let key in _data["timesheetHoursPerNonProjectCategory"]) {
                    if (_data["timesheetHoursPerNonProjectCategory"].hasOwnProperty(key))
                        (this.timesheetHoursPerNonProjectCategory as any)![key] = _data["timesheetHoursPerNonProjectCategory"][key];
                }
            }
            if (_data["approvedHoursPerBillability"]) {
                this.approvedHoursPerBillability = {} as any;
                for (let key in _data["approvedHoursPerBillability"]) {
                    if (_data["approvedHoursPerBillability"].hasOwnProperty(key))
                        (this.approvedHoursPerBillability as any)![key] = _data["approvedHoursPerBillability"][key];
                }
            }
            this.totalTimesheetHours = _data["totalTimesheetHours"];
            this.totalProductiveTimesheetHours = _data["totalProductiveTimesheetHours"];
            this.totalNotProductiveTimesheetHours = _data["totalNotProductiveTimesheetHours"];
        }
    }

    static fromJS(data: any): MyTimesheetDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MyTimesheetDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.timesheetsPerStatusCounts) {
            data["timesheetsPerStatusCounts"] = {};
            for (let key in this.timesheetsPerStatusCounts) {
                if (this.timesheetsPerStatusCounts.hasOwnProperty(key))
                    (data["timesheetsPerStatusCounts"] as any)[key] = (this.timesheetsPerStatusCounts as any)[key];
            }
        }
        if (Array.isArray(this.notApprovedTimesheets)) {
            data["notApprovedTimesheets"] = [];
            for (let item of this.notApprovedTimesheets)
                data["notApprovedTimesheets"].push(item ? item.toJSON() : undefined as any);
        }
        if (this.timesheetHoursPerProject) {
            data["timesheetHoursPerProject"] = {};
            for (let key in this.timesheetHoursPerProject) {
                if (this.timesheetHoursPerProject.hasOwnProperty(key))
                    (data["timesheetHoursPerProject"] as any)[key] = (this.timesheetHoursPerProject as any)[key];
            }
        }
        if (this.timesheetHoursPerNonProjectCategory) {
            data["timesheetHoursPerNonProjectCategory"] = {};
            for (let key in this.timesheetHoursPerNonProjectCategory) {
                if (this.timesheetHoursPerNonProjectCategory.hasOwnProperty(key))
                    (data["timesheetHoursPerNonProjectCategory"] as any)[key] = (this.timesheetHoursPerNonProjectCategory as any)[key];
            }
        }
        if (this.approvedHoursPerBillability) {
            data["approvedHoursPerBillability"] = {};
            for (let key in this.approvedHoursPerBillability) {
                if (this.approvedHoursPerBillability.hasOwnProperty(key))
                    (data["approvedHoursPerBillability"] as any)[key] = (this.approvedHoursPerBillability as any)[key];
            }
        }
        data["totalTimesheetHours"] = this.totalTimesheetHours;
        data["totalProductiveTimesheetHours"] = this.totalProductiveTimesheetHours;
        data["totalNotProductiveTimesheetHours"] = this.totalNotProductiveTimesheetHours;
        return data;
    }
}

export interface IMyTimesheetDashboardResponse {
    timesheetsPerStatusCounts?: { [key: string]: number; } | undefined;
    notApprovedTimesheets?: TimeTravelDashboardRowResponse[] | undefined;
    timesheetHoursPerProject?: { [key: string]: number; } | undefined;
    timesheetHoursPerNonProjectCategory?: { [key: string]: number; } | undefined;
    approvedHoursPerBillability?: { [key: string]: number; } | undefined;
    totalTimesheetHours: number;
    totalProductiveTimesheetHours: number;
    totalNotProductiveTimesheetHours: number;
}

export class MyTimeTravelDashboardFilterRequest implements IMyTimeTravelDashboardFilterRequest {
    dateRange!: DateRangeRequest;

    constructor(data?: IMyTimeTravelDashboardFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dateRange = new DateRangeRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateRange = _data["dateRange"] ? DateRangeRequest.fromJS(_data["dateRange"]) : new DateRangeRequest();
        }
    }

    static fromJS(data: any): MyTimeTravelDashboardFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MyTimeTravelDashboardFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : undefined as any;
        return data;
    }
}

export interface IMyTimeTravelDashboardFilterRequest {
    dateRange: DateRangeRequest;
}

export class MyTimeTravelDashboardResponse implements IMyTimeTravelDashboardResponse {
    timesheets?: MyTimesheetDashboardResponse;
    travelRequests?: MyTravelRequestDashboardResponse;
    travelExpenses?: MyTravelExpenseDashboardResponse;
    expenses?: MyExpenseDashboardResponse;
    vacationRequests?: MyVacationRequestDashboardResponse;

    constructor(data?: IMyTimeTravelDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timesheets = _data["timesheets"] ? MyTimesheetDashboardResponse.fromJS(_data["timesheets"]) : undefined as any;
            this.travelRequests = _data["travelRequests"] ? MyTravelRequestDashboardResponse.fromJS(_data["travelRequests"]) : undefined as any;
            this.travelExpenses = _data["travelExpenses"] ? MyTravelExpenseDashboardResponse.fromJS(_data["travelExpenses"]) : undefined as any;
            this.expenses = _data["expenses"] ? MyExpenseDashboardResponse.fromJS(_data["expenses"]) : undefined as any;
            this.vacationRequests = _data["vacationRequests"] ? MyVacationRequestDashboardResponse.fromJS(_data["vacationRequests"]) : undefined as any;
        }
    }

    static fromJS(data: any): MyTimeTravelDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MyTimeTravelDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timesheets"] = this.timesheets ? this.timesheets.toJSON() : undefined as any;
        data["travelRequests"] = this.travelRequests ? this.travelRequests.toJSON() : undefined as any;
        data["travelExpenses"] = this.travelExpenses ? this.travelExpenses.toJSON() : undefined as any;
        data["expenses"] = this.expenses ? this.expenses.toJSON() : undefined as any;
        data["vacationRequests"] = this.vacationRequests ? this.vacationRequests.toJSON() : undefined as any;
        return data;
    }
}

export interface IMyTimeTravelDashboardResponse {
    timesheets?: MyTimesheetDashboardResponse;
    travelRequests?: MyTravelRequestDashboardResponse;
    travelExpenses?: MyTravelExpenseDashboardResponse;
    expenses?: MyExpenseDashboardResponse;
    vacationRequests?: MyVacationRequestDashboardResponse;
}

export class MyTimeTravelDashboardResponseSimpleResponseModel implements IMyTimeTravelDashboardResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: MyTimeTravelDashboardResponse;

    constructor(data?: IMyTimeTravelDashboardResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? MyTimeTravelDashboardResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): MyTimeTravelDashboardResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MyTimeTravelDashboardResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IMyTimeTravelDashboardResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: MyTimeTravelDashboardResponse;
}

export class MyTrainingPlanResponse implements IMyTrainingPlanResponse {
    id!: number;
    isActive!: boolean;
    cycleId!: number;
    scopeItemLevel3Id?: number | undefined;
    level3ProcessId?: string | undefined;
    level3ProcessName?: string | undefined;
    plannedDate?: Date | undefined;
    plannedTime?: number | undefined;
    plannedTimeTo?: number | undefined;
    duration?: number | undefined;
    linkToMaterial?: string | undefined;
    linkToVideo?: string | undefined;
    statusId!: number;
    scopeDesignAttachments?: AttachmentResponse[] | undefined;
    scopeTrainingAttachments?: AttachmentResponse[] | undefined;
    scopeOtherAttachments?: AttachmentResponse[] | undefined;

    constructor(data?: IMyTrainingPlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.cycleId = _data["cycleId"];
            this.scopeItemLevel3Id = _data["scopeItemLevel3Id"];
            this.level3ProcessId = _data["level3ProcessId"];
            this.level3ProcessName = _data["level3ProcessName"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.plannedTime = _data["plannedTime"];
            this.plannedTimeTo = _data["plannedTimeTo"];
            this.duration = _data["duration"];
            this.linkToMaterial = _data["linkToMaterial"];
            this.linkToVideo = _data["linkToVideo"];
            this.statusId = _data["statusId"];
            if (Array.isArray(_data["scopeDesignAttachments"])) {
                this.scopeDesignAttachments = [] as any;
                for (let item of _data["scopeDesignAttachments"])
                    this.scopeDesignAttachments!.push(AttachmentResponse.fromJS(item));
            }
            if (Array.isArray(_data["scopeTrainingAttachments"])) {
                this.scopeTrainingAttachments = [] as any;
                for (let item of _data["scopeTrainingAttachments"])
                    this.scopeTrainingAttachments!.push(AttachmentResponse.fromJS(item));
            }
            if (Array.isArray(_data["scopeOtherAttachments"])) {
                this.scopeOtherAttachments = [] as any;
                for (let item of _data["scopeOtherAttachments"])
                    this.scopeOtherAttachments!.push(AttachmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyTrainingPlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MyTrainingPlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["cycleId"] = this.cycleId;
        data["scopeItemLevel3Id"] = this.scopeItemLevel3Id;
        data["level3ProcessId"] = this.level3ProcessId;
        data["level3ProcessName"] = this.level3ProcessName;
        data["plannedDate"] = this.plannedDate ? this.plannedDate.toISOString() : undefined as any;
        data["plannedTime"] = this.plannedTime;
        data["plannedTimeTo"] = this.plannedTimeTo;
        data["duration"] = this.duration;
        data["linkToMaterial"] = this.linkToMaterial;
        data["linkToVideo"] = this.linkToVideo;
        data["statusId"] = this.statusId;
        if (Array.isArray(this.scopeDesignAttachments)) {
            data["scopeDesignAttachments"] = [];
            for (let item of this.scopeDesignAttachments)
                data["scopeDesignAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.scopeTrainingAttachments)) {
            data["scopeTrainingAttachments"] = [];
            for (let item of this.scopeTrainingAttachments)
                data["scopeTrainingAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.scopeOtherAttachments)) {
            data["scopeOtherAttachments"] = [];
            for (let item of this.scopeOtherAttachments)
                data["scopeOtherAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMyTrainingPlanResponse {
    id: number;
    isActive: boolean;
    cycleId: number;
    scopeItemLevel3Id?: number | undefined;
    level3ProcessId?: string | undefined;
    level3ProcessName?: string | undefined;
    plannedDate?: Date | undefined;
    plannedTime?: number | undefined;
    plannedTimeTo?: number | undefined;
    duration?: number | undefined;
    linkToMaterial?: string | undefined;
    linkToVideo?: string | undefined;
    statusId: number;
    scopeDesignAttachments?: AttachmentResponse[] | undefined;
    scopeTrainingAttachments?: AttachmentResponse[] | undefined;
    scopeOtherAttachments?: AttachmentResponse[] | undefined;
}

export class MyTrainingPlanResponseItemsResponseModel implements IMyTrainingPlanResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: MyTrainingPlanResponse[] | undefined;

    constructor(data?: IMyTrainingPlanResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MyTrainingPlanResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyTrainingPlanResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MyTrainingPlanResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMyTrainingPlanResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: MyTrainingPlanResponse[] | undefined;
}

export class MyTravelExpenseDashboardResponse implements IMyTravelExpenseDashboardResponse {
    travelExpensesPerStatusCounts?: { [key: string]: number; } | undefined;
    notApprovedTravelExpenses?: TimeTravelDashboardRowResponse[] | undefined;

    constructor(data?: IMyTravelExpenseDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["travelExpensesPerStatusCounts"]) {
                this.travelExpensesPerStatusCounts = {} as any;
                for (let key in _data["travelExpensesPerStatusCounts"]) {
                    if (_data["travelExpensesPerStatusCounts"].hasOwnProperty(key))
                        (this.travelExpensesPerStatusCounts as any)![key] = _data["travelExpensesPerStatusCounts"][key];
                }
            }
            if (Array.isArray(_data["notApprovedTravelExpenses"])) {
                this.notApprovedTravelExpenses = [] as any;
                for (let item of _data["notApprovedTravelExpenses"])
                    this.notApprovedTravelExpenses!.push(TimeTravelDashboardRowResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyTravelExpenseDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MyTravelExpenseDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.travelExpensesPerStatusCounts) {
            data["travelExpensesPerStatusCounts"] = {};
            for (let key in this.travelExpensesPerStatusCounts) {
                if (this.travelExpensesPerStatusCounts.hasOwnProperty(key))
                    (data["travelExpensesPerStatusCounts"] as any)[key] = (this.travelExpensesPerStatusCounts as any)[key];
            }
        }
        if (Array.isArray(this.notApprovedTravelExpenses)) {
            data["notApprovedTravelExpenses"] = [];
            for (let item of this.notApprovedTravelExpenses)
                data["notApprovedTravelExpenses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMyTravelExpenseDashboardResponse {
    travelExpensesPerStatusCounts?: { [key: string]: number; } | undefined;
    notApprovedTravelExpenses?: TimeTravelDashboardRowResponse[] | undefined;
}

export class MyTravelRequestDashboardResponse implements IMyTravelRequestDashboardResponse {
    travelRequestsPerStatusCounts?: { [key: string]: number; } | undefined;
    notApprovedTravelRequests?: TimeTravelDashboardRowResponse[] | undefined;

    constructor(data?: IMyTravelRequestDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["travelRequestsPerStatusCounts"]) {
                this.travelRequestsPerStatusCounts = {} as any;
                for (let key in _data["travelRequestsPerStatusCounts"]) {
                    if (_data["travelRequestsPerStatusCounts"].hasOwnProperty(key))
                        (this.travelRequestsPerStatusCounts as any)![key] = _data["travelRequestsPerStatusCounts"][key];
                }
            }
            if (Array.isArray(_data["notApprovedTravelRequests"])) {
                this.notApprovedTravelRequests = [] as any;
                for (let item of _data["notApprovedTravelRequests"])
                    this.notApprovedTravelRequests!.push(TimeTravelDashboardRowResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyTravelRequestDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MyTravelRequestDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.travelRequestsPerStatusCounts) {
            data["travelRequestsPerStatusCounts"] = {};
            for (let key in this.travelRequestsPerStatusCounts) {
                if (this.travelRequestsPerStatusCounts.hasOwnProperty(key))
                    (data["travelRequestsPerStatusCounts"] as any)[key] = (this.travelRequestsPerStatusCounts as any)[key];
            }
        }
        if (Array.isArray(this.notApprovedTravelRequests)) {
            data["notApprovedTravelRequests"] = [];
            for (let item of this.notApprovedTravelRequests)
                data["notApprovedTravelRequests"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMyTravelRequestDashboardResponse {
    travelRequestsPerStatusCounts?: { [key: string]: number; } | undefined;
    notApprovedTravelRequests?: TimeTravelDashboardRowResponse[] | undefined;
}

export class MyVacationRequestDashboardResponse implements IMyVacationRequestDashboardResponse {
    vacationRequestsPerStatusCounts?: { [key: string]: number; } | undefined;
    notApprovedVacationRequests?: TimeTravelDashboardRowResponse[] | undefined;
    totalVacationDays!: number;

    constructor(data?: IMyVacationRequestDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["vacationRequestsPerStatusCounts"]) {
                this.vacationRequestsPerStatusCounts = {} as any;
                for (let key in _data["vacationRequestsPerStatusCounts"]) {
                    if (_data["vacationRequestsPerStatusCounts"].hasOwnProperty(key))
                        (this.vacationRequestsPerStatusCounts as any)![key] = _data["vacationRequestsPerStatusCounts"][key];
                }
            }
            if (Array.isArray(_data["notApprovedVacationRequests"])) {
                this.notApprovedVacationRequests = [] as any;
                for (let item of _data["notApprovedVacationRequests"])
                    this.notApprovedVacationRequests!.push(TimeTravelDashboardRowResponse.fromJS(item));
            }
            this.totalVacationDays = _data["totalVacationDays"];
        }
    }

    static fromJS(data: any): MyVacationRequestDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MyVacationRequestDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.vacationRequestsPerStatusCounts) {
            data["vacationRequestsPerStatusCounts"] = {};
            for (let key in this.vacationRequestsPerStatusCounts) {
                if (this.vacationRequestsPerStatusCounts.hasOwnProperty(key))
                    (data["vacationRequestsPerStatusCounts"] as any)[key] = (this.vacationRequestsPerStatusCounts as any)[key];
            }
        }
        if (Array.isArray(this.notApprovedVacationRequests)) {
            data["notApprovedVacationRequests"] = [];
            for (let item of this.notApprovedVacationRequests)
                data["notApprovedVacationRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalVacationDays"] = this.totalVacationDays;
        return data;
    }
}

export interface IMyVacationRequestDashboardResponse {
    vacationRequestsPerStatusCounts?: { [key: string]: number; } | undefined;
    notApprovedVacationRequests?: TimeTravelDashboardRowResponse[] | undefined;
    totalVacationDays: number;
}

export class NonProjectCategoryDeltaRequest implements INonProjectCategoryDeltaRequest {
    insert?: InsertNonProjectCategoryRequest[] | undefined;
    update?: UpdateNonProjectCategoryRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;

    constructor(data?: INonProjectCategoryDeltaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertNonProjectCategoryRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateNonProjectCategoryRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteTenantIndetifyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NonProjectCategoryDeltaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NonProjectCategoryDeltaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INonProjectCategoryDeltaRequest {
    insert?: InsertNonProjectCategoryRequest[] | undefined;
    update?: UpdateNonProjectCategoryRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;
}

export class NonProjectCategoryResponse implements INonProjectCategoryResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    billable!: boolean;
    isReadOnly!: boolean;

    constructor(data?: INonProjectCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.billable = _data["billable"];
            this.isReadOnly = _data["isReadOnly"];
        }
    }

    static fromJS(data: any): NonProjectCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NonProjectCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["billable"] = this.billable;
        data["isReadOnly"] = this.isReadOnly;
        return data;
    }
}

export interface INonProjectCategoryResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    billable: boolean;
    isReadOnly: boolean;
}

export class NonProjectCategoryResponseItemsResponseModel implements INonProjectCategoryResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: NonProjectCategoryResponse[] | undefined;

    constructor(data?: INonProjectCategoryResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NonProjectCategoryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NonProjectCategoryResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new NonProjectCategoryResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INonProjectCategoryResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: NonProjectCategoryResponse[] | undefined;
}

export class OrganizationalUnitManagerResponse implements IOrganizationalUnitManagerResponse {
    id!: number;
    userId!: number;
    organizationalUnitId!: number;
    isResourceManager!: boolean;
    validUntil!: Date;

    constructor(data?: IOrganizationalUnitManagerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.organizationalUnitId = _data["organizationalUnitId"];
            this.isResourceManager = _data["isResourceManager"];
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): OrganizationalUnitManagerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalUnitManagerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["organizationalUnitId"] = this.organizationalUnitId;
        data["isResourceManager"] = this.isResourceManager;
        data["validUntil"] = this.validUntil ? formatDate(this.validUntil) : undefined as any;
        return data;
    }
}

export interface IOrganizationalUnitManagerResponse {
    id: number;
    userId: number;
    organizationalUnitId: number;
    isResourceManager: boolean;
    validUntil: Date;
}

export class OrganizationalUnitManagerResponseItemsResponseModel implements IOrganizationalUnitManagerResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: OrganizationalUnitManagerResponse[] | undefined;

    constructor(data?: IOrganizationalUnitManagerResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationalUnitManagerResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationalUnitManagerResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalUnitManagerResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrganizationalUnitManagerResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: OrganizationalUnitManagerResponse[] | undefined;
}

export class OrganizationalUnitManagerResponseSimpleResponseModel implements IOrganizationalUnitManagerResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: OrganizationalUnitManagerResponse;

    constructor(data?: IOrganizationalUnitManagerResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? OrganizationalUnitManagerResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): OrganizationalUnitManagerResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalUnitManagerResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrganizationalUnitManagerResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: OrganizationalUnitManagerResponse;
}

export class OrganizationalUnitResponse implements IOrganizationalUnitResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    parentId?: number | undefined;
    levelNumber!: number;
    order!: number;

    constructor(data?: IOrganizationalUnitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.parentId = _data["parentId"];
            this.levelNumber = _data["levelNumber"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): OrganizationalUnitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalUnitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentId"] = this.parentId;
        data["levelNumber"] = this.levelNumber;
        data["order"] = this.order;
        return data;
    }
}

export interface IOrganizationalUnitResponse {
    id: number;
    name: string;
    description?: string | undefined;
    parentId?: number | undefined;
    levelNumber: number;
    order: number;
}

export class OrganizationalUnitResponseItemsResponseModel implements IOrganizationalUnitResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: OrganizationalUnitResponse[] | undefined;

    constructor(data?: IOrganizationalUnitResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationalUnitResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationalUnitResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalUnitResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IOrganizationalUnitResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: OrganizationalUnitResponse[] | undefined;
}

export class OrganizationalUnitResponseSimpleResponseModel implements IOrganizationalUnitResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: OrganizationalUnitResponse;

    constructor(data?: IOrganizationalUnitResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? OrganizationalUnitResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): OrganizationalUnitResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationalUnitResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IOrganizationalUnitResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: OrganizationalUnitResponse;
}

export enum PartialTaskRequestEnum {
    My = "My",
    Overdue = "Overdue",
    ShowCompleted = "ShowCompleted",
    AssignedToMe = "AssignedToMe",
}

export class PartnersInvoicesDashboardResponse implements IPartnersInvoicesDashboardResponse {
    totalIncomingPlanned!: number;
    totalIncomingActual!: number;
    overdue1DayIncoming!: number;
    overdue30DaysIncoming!: number;
    overdue60DaysIncoming!: number;
    overdue90DaysIncoming!: number;
    totalOutgoingPlanned!: number;
    totalOutgoingActual!: number;
    overdue1DayOutgoing!: number;
    overdue30DaysOutgoing!: number;
    overdue60DaysOutgoing!: number;
    overdue90DaysOutgoing!: number;
    plannedIncomingOutgoingPerPartner?: { [key: string]: IncomingOutgoingDashboardResponse; } | undefined;
    actualIncomingOutgoingPerPartner?: { [key: string]: IncomingOutgoingDashboardResponse; } | undefined;
    incomingInvoicesPerPlannedActual?: { [key: string]: number; } | undefined;
    outgoingInvoicesPerPlannedActual?: { [key: string]: number; } | undefined;
    budgetVsActualIncomingInvoices?: BudgetVsActualPartnerRowDashboardResponse[] | undefined;
    budgetVsActualOutgoingInvoices?: BudgetVsActualPartnerRowDashboardResponse[] | undefined;

    constructor(data?: IPartnersInvoicesDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalIncomingPlanned = _data["totalIncomingPlanned"];
            this.totalIncomingActual = _data["totalIncomingActual"];
            this.overdue1DayIncoming = _data["overdue1DayIncoming"];
            this.overdue30DaysIncoming = _data["overdue30DaysIncoming"];
            this.overdue60DaysIncoming = _data["overdue60DaysIncoming"];
            this.overdue90DaysIncoming = _data["overdue90DaysIncoming"];
            this.totalOutgoingPlanned = _data["totalOutgoingPlanned"];
            this.totalOutgoingActual = _data["totalOutgoingActual"];
            this.overdue1DayOutgoing = _data["overdue1DayOutgoing"];
            this.overdue30DaysOutgoing = _data["overdue30DaysOutgoing"];
            this.overdue60DaysOutgoing = _data["overdue60DaysOutgoing"];
            this.overdue90DaysOutgoing = _data["overdue90DaysOutgoing"];
            if (_data["plannedIncomingOutgoingPerPartner"]) {
                this.plannedIncomingOutgoingPerPartner = {} as any;
                for (let key in _data["plannedIncomingOutgoingPerPartner"]) {
                    if (_data["plannedIncomingOutgoingPerPartner"].hasOwnProperty(key))
                        (this.plannedIncomingOutgoingPerPartner as any)![key] = _data["plannedIncomingOutgoingPerPartner"][key] ? IncomingOutgoingDashboardResponse.fromJS(_data["plannedIncomingOutgoingPerPartner"][key]) : new IncomingOutgoingDashboardResponse();
                }
            }
            if (_data["actualIncomingOutgoingPerPartner"]) {
                this.actualIncomingOutgoingPerPartner = {} as any;
                for (let key in _data["actualIncomingOutgoingPerPartner"]) {
                    if (_data["actualIncomingOutgoingPerPartner"].hasOwnProperty(key))
                        (this.actualIncomingOutgoingPerPartner as any)![key] = _data["actualIncomingOutgoingPerPartner"][key] ? IncomingOutgoingDashboardResponse.fromJS(_data["actualIncomingOutgoingPerPartner"][key]) : new IncomingOutgoingDashboardResponse();
                }
            }
            if (_data["incomingInvoicesPerPlannedActual"]) {
                this.incomingInvoicesPerPlannedActual = {} as any;
                for (let key in _data["incomingInvoicesPerPlannedActual"]) {
                    if (_data["incomingInvoicesPerPlannedActual"].hasOwnProperty(key))
                        (this.incomingInvoicesPerPlannedActual as any)![key] = _data["incomingInvoicesPerPlannedActual"][key];
                }
            }
            if (_data["outgoingInvoicesPerPlannedActual"]) {
                this.outgoingInvoicesPerPlannedActual = {} as any;
                for (let key in _data["outgoingInvoicesPerPlannedActual"]) {
                    if (_data["outgoingInvoicesPerPlannedActual"].hasOwnProperty(key))
                        (this.outgoingInvoicesPerPlannedActual as any)![key] = _data["outgoingInvoicesPerPlannedActual"][key];
                }
            }
            if (Array.isArray(_data["budgetVsActualIncomingInvoices"])) {
                this.budgetVsActualIncomingInvoices = [] as any;
                for (let item of _data["budgetVsActualIncomingInvoices"])
                    this.budgetVsActualIncomingInvoices!.push(BudgetVsActualPartnerRowDashboardResponse.fromJS(item));
            }
            if (Array.isArray(_data["budgetVsActualOutgoingInvoices"])) {
                this.budgetVsActualOutgoingInvoices = [] as any;
                for (let item of _data["budgetVsActualOutgoingInvoices"])
                    this.budgetVsActualOutgoingInvoices!.push(BudgetVsActualPartnerRowDashboardResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartnersInvoicesDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PartnersInvoicesDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalIncomingPlanned"] = this.totalIncomingPlanned;
        data["totalIncomingActual"] = this.totalIncomingActual;
        data["overdue1DayIncoming"] = this.overdue1DayIncoming;
        data["overdue30DaysIncoming"] = this.overdue30DaysIncoming;
        data["overdue60DaysIncoming"] = this.overdue60DaysIncoming;
        data["overdue90DaysIncoming"] = this.overdue90DaysIncoming;
        data["totalOutgoingPlanned"] = this.totalOutgoingPlanned;
        data["totalOutgoingActual"] = this.totalOutgoingActual;
        data["overdue1DayOutgoing"] = this.overdue1DayOutgoing;
        data["overdue30DaysOutgoing"] = this.overdue30DaysOutgoing;
        data["overdue60DaysOutgoing"] = this.overdue60DaysOutgoing;
        data["overdue90DaysOutgoing"] = this.overdue90DaysOutgoing;
        if (this.plannedIncomingOutgoingPerPartner) {
            data["plannedIncomingOutgoingPerPartner"] = {};
            for (let key in this.plannedIncomingOutgoingPerPartner) {
                if (this.plannedIncomingOutgoingPerPartner.hasOwnProperty(key))
                    (data["plannedIncomingOutgoingPerPartner"] as any)[key] = this.plannedIncomingOutgoingPerPartner[key] ? this.plannedIncomingOutgoingPerPartner[key].toJSON() : undefined as any;
            }
        }
        if (this.actualIncomingOutgoingPerPartner) {
            data["actualIncomingOutgoingPerPartner"] = {};
            for (let key in this.actualIncomingOutgoingPerPartner) {
                if (this.actualIncomingOutgoingPerPartner.hasOwnProperty(key))
                    (data["actualIncomingOutgoingPerPartner"] as any)[key] = this.actualIncomingOutgoingPerPartner[key] ? this.actualIncomingOutgoingPerPartner[key].toJSON() : undefined as any;
            }
        }
        if (this.incomingInvoicesPerPlannedActual) {
            data["incomingInvoicesPerPlannedActual"] = {};
            for (let key in this.incomingInvoicesPerPlannedActual) {
                if (this.incomingInvoicesPerPlannedActual.hasOwnProperty(key))
                    (data["incomingInvoicesPerPlannedActual"] as any)[key] = (this.incomingInvoicesPerPlannedActual as any)[key];
            }
        }
        if (this.outgoingInvoicesPerPlannedActual) {
            data["outgoingInvoicesPerPlannedActual"] = {};
            for (let key in this.outgoingInvoicesPerPlannedActual) {
                if (this.outgoingInvoicesPerPlannedActual.hasOwnProperty(key))
                    (data["outgoingInvoicesPerPlannedActual"] as any)[key] = (this.outgoingInvoicesPerPlannedActual as any)[key];
            }
        }
        if (Array.isArray(this.budgetVsActualIncomingInvoices)) {
            data["budgetVsActualIncomingInvoices"] = [];
            for (let item of this.budgetVsActualIncomingInvoices)
                data["budgetVsActualIncomingInvoices"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.budgetVsActualOutgoingInvoices)) {
            data["budgetVsActualOutgoingInvoices"] = [];
            for (let item of this.budgetVsActualOutgoingInvoices)
                data["budgetVsActualOutgoingInvoices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPartnersInvoicesDashboardResponse {
    totalIncomingPlanned: number;
    totalIncomingActual: number;
    overdue1DayIncoming: number;
    overdue30DaysIncoming: number;
    overdue60DaysIncoming: number;
    overdue90DaysIncoming: number;
    totalOutgoingPlanned: number;
    totalOutgoingActual: number;
    overdue1DayOutgoing: number;
    overdue30DaysOutgoing: number;
    overdue60DaysOutgoing: number;
    overdue90DaysOutgoing: number;
    plannedIncomingOutgoingPerPartner?: { [key: string]: IncomingOutgoingDashboardResponse; } | undefined;
    actualIncomingOutgoingPerPartner?: { [key: string]: IncomingOutgoingDashboardResponse; } | undefined;
    incomingInvoicesPerPlannedActual?: { [key: string]: number; } | undefined;
    outgoingInvoicesPerPlannedActual?: { [key: string]: number; } | undefined;
    budgetVsActualIncomingInvoices?: BudgetVsActualPartnerRowDashboardResponse[] | undefined;
    budgetVsActualOutgoingInvoices?: BudgetVsActualPartnerRowDashboardResponse[] | undefined;
}

export class PatchScheduleRequest implements IPatchScheduleRequest {
    id!: number;
    parentId?: number | undefined;
    name?: string | undefined;
    start?: Date | undefined;
    finish?: Date | undefined;
    percentOfCompletion?: number | undefined;

    constructor(data?: IPatchScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.name = _data["name"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.finish = _data["finish"] ? new Date(_data["finish"].toString()) : undefined as any;
            this.percentOfCompletion = _data["percentOfCompletion"];
        }
    }

    static fromJS(data: any): PatchScheduleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PatchScheduleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["finish"] = this.finish ? this.finish.toISOString() : undefined as any;
        data["percentOfCompletion"] = this.percentOfCompletion;
        return data;
    }
}

export interface IPatchScheduleRequest {
    id: number;
    parentId?: number | undefined;
    name?: string | undefined;
    start?: Date | undefined;
    finish?: Date | undefined;
    percentOfCompletion?: number | undefined;
}

export class PatchTenantIdentifyRequest implements IPatchTenantIdentifyRequest {
    id!: number;
    propertyName!: string;
    value?: any | undefined;

    constructor(data?: IPatchTenantIdentifyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.propertyName = _data["propertyName"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PatchTenantIdentifyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PatchTenantIdentifyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["propertyName"] = this.propertyName;
        data["value"] = this.value;
        return data;
    }
}

export interface IPatchTenantIdentifyRequest {
    id: number;
    propertyName: string;
    value?: any | undefined;
}

export class PaymentMethodResponse implements IPaymentMethodResponse {
    id?: string | undefined;
    brand?: string | undefined;
    isDefault!: boolean;
    last4Numbers?: string | undefined;
    expDate!: Date;

    constructor(data?: IPaymentMethodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.brand = _data["brand"];
            this.isDefault = _data["isDefault"];
            this.last4Numbers = _data["last4Numbers"];
            this.expDate = _data["expDate"] ? new Date(_data["expDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PaymentMethodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["brand"] = this.brand;
        data["isDefault"] = this.isDefault;
        data["last4Numbers"] = this.last4Numbers;
        data["expDate"] = this.expDate ? this.expDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IPaymentMethodResponse {
    id?: string | undefined;
    brand?: string | undefined;
    isDefault: boolean;
    last4Numbers?: string | undefined;
    expDate: Date;
}

export class PaymentMethodResponseItemsResponseModel implements IPaymentMethodResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: PaymentMethodResponse[] | undefined;

    constructor(data?: IPaymentMethodResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PaymentMethodResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentMethodResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPaymentMethodResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: PaymentMethodResponse[] | undefined;
}

export class PermissionCollectionRequest implements IPermissionCollectionRequest {
    teamMemberId!: number;
    isSubstituteProjectManager!: boolean;
    ticketPermission?: TicketPermission;
    timeTravelPermission?: TimeTravelPermission;
    scopePermission?: ScopePermission;
    testingPermission?: TestingPermission;
    trainingPermission?: TrainingPermission;
    schedulePermission?: SchedulePermission;
    riskPermission?: RiskPermission;

    constructor(data?: IPermissionCollectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamMemberId = _data["teamMemberId"];
            this.isSubstituteProjectManager = _data["isSubstituteProjectManager"];
            this.ticketPermission = _data["ticketPermission"] ? TicketPermission.fromJS(_data["ticketPermission"]) : undefined as any;
            this.timeTravelPermission = _data["timeTravelPermission"] ? TimeTravelPermission.fromJS(_data["timeTravelPermission"]) : undefined as any;
            this.scopePermission = _data["scopePermission"] ? ScopePermission.fromJS(_data["scopePermission"]) : undefined as any;
            this.testingPermission = _data["testingPermission"] ? TestingPermission.fromJS(_data["testingPermission"]) : undefined as any;
            this.trainingPermission = _data["trainingPermission"] ? TrainingPermission.fromJS(_data["trainingPermission"]) : undefined as any;
            this.schedulePermission = _data["schedulePermission"] ? SchedulePermission.fromJS(_data["schedulePermission"]) : undefined as any;
            this.riskPermission = _data["riskPermission"] ? RiskPermission.fromJS(_data["riskPermission"]) : undefined as any;
        }
    }

    static fromJS(data: any): PermissionCollectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionCollectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamMemberId"] = this.teamMemberId;
        data["isSubstituteProjectManager"] = this.isSubstituteProjectManager;
        data["ticketPermission"] = this.ticketPermission ? this.ticketPermission.toJSON() : undefined as any;
        data["timeTravelPermission"] = this.timeTravelPermission ? this.timeTravelPermission.toJSON() : undefined as any;
        data["scopePermission"] = this.scopePermission ? this.scopePermission.toJSON() : undefined as any;
        data["testingPermission"] = this.testingPermission ? this.testingPermission.toJSON() : undefined as any;
        data["trainingPermission"] = this.trainingPermission ? this.trainingPermission.toJSON() : undefined as any;
        data["schedulePermission"] = this.schedulePermission ? this.schedulePermission.toJSON() : undefined as any;
        data["riskPermission"] = this.riskPermission ? this.riskPermission.toJSON() : undefined as any;
        return data;
    }
}

export interface IPermissionCollectionRequest {
    teamMemberId: number;
    isSubstituteProjectManager: boolean;
    ticketPermission?: TicketPermission;
    timeTravelPermission?: TimeTravelPermission;
    scopePermission?: ScopePermission;
    testingPermission?: TestingPermission;
    trainingPermission?: TrainingPermission;
    schedulePermission?: SchedulePermission;
    riskPermission?: RiskPermission;
}

export class PermissionCollectionResponse implements IPermissionCollectionResponse {
    teamMemberId!: number;
    isProjectManager!: boolean;
    isSubstituteProjectManager!: boolean;
    ticketPermission?: TicketPermission;
    timeTravelPermission?: TimeTravelPermission;
    scopePermission?: ScopePermission;
    testingPermission?: TestingPermission;
    trainingPermission?: TrainingPermission;
    schedulePermission?: SchedulePermission;
    riskPermission?: RiskPermission;

    constructor(data?: IPermissionCollectionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamMemberId = _data["teamMemberId"];
            this.isProjectManager = _data["isProjectManager"];
            this.isSubstituteProjectManager = _data["isSubstituteProjectManager"];
            this.ticketPermission = _data["ticketPermission"] ? TicketPermission.fromJS(_data["ticketPermission"]) : undefined as any;
            this.timeTravelPermission = _data["timeTravelPermission"] ? TimeTravelPermission.fromJS(_data["timeTravelPermission"]) : undefined as any;
            this.scopePermission = _data["scopePermission"] ? ScopePermission.fromJS(_data["scopePermission"]) : undefined as any;
            this.testingPermission = _data["testingPermission"] ? TestingPermission.fromJS(_data["testingPermission"]) : undefined as any;
            this.trainingPermission = _data["trainingPermission"] ? TrainingPermission.fromJS(_data["trainingPermission"]) : undefined as any;
            this.schedulePermission = _data["schedulePermission"] ? SchedulePermission.fromJS(_data["schedulePermission"]) : undefined as any;
            this.riskPermission = _data["riskPermission"] ? RiskPermission.fromJS(_data["riskPermission"]) : undefined as any;
        }
    }

    static fromJS(data: any): PermissionCollectionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionCollectionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamMemberId"] = this.teamMemberId;
        data["isProjectManager"] = this.isProjectManager;
        data["isSubstituteProjectManager"] = this.isSubstituteProjectManager;
        data["ticketPermission"] = this.ticketPermission ? this.ticketPermission.toJSON() : undefined as any;
        data["timeTravelPermission"] = this.timeTravelPermission ? this.timeTravelPermission.toJSON() : undefined as any;
        data["scopePermission"] = this.scopePermission ? this.scopePermission.toJSON() : undefined as any;
        data["testingPermission"] = this.testingPermission ? this.testingPermission.toJSON() : undefined as any;
        data["trainingPermission"] = this.trainingPermission ? this.trainingPermission.toJSON() : undefined as any;
        data["schedulePermission"] = this.schedulePermission ? this.schedulePermission.toJSON() : undefined as any;
        data["riskPermission"] = this.riskPermission ? this.riskPermission.toJSON() : undefined as any;
        return data;
    }
}

export interface IPermissionCollectionResponse {
    teamMemberId: number;
    isProjectManager: boolean;
    isSubstituteProjectManager: boolean;
    ticketPermission?: TicketPermission;
    timeTravelPermission?: TimeTravelPermission;
    scopePermission?: ScopePermission;
    testingPermission?: TestingPermission;
    trainingPermission?: TrainingPermission;
    schedulePermission?: SchedulePermission;
    riskPermission?: RiskPermission;
}

export class PermissionCollectionResponseItemsResponseModel implements IPermissionCollectionResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: PermissionCollectionResponse[] | undefined;

    constructor(data?: IPermissionCollectionResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PermissionCollectionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionCollectionResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionCollectionResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPermissionCollectionResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: PermissionCollectionResponse[] | undefined;
}

export class PricelistRowResponse implements IPricelistRowResponse {
    id!: number;
    tenantId!: number;
    maxUsersFrom!: number;
    maxUsersTo!: number;
    maxGuestsFrom!: number;
    maxGuestsTo!: number;
    pricePerUserInEuro!: number;
    pricePerGuestInEuro!: number;

    constructor(data?: IPricelistRowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.maxUsersFrom = _data["maxUsersFrom"];
            this.maxUsersTo = _data["maxUsersTo"];
            this.maxGuestsFrom = _data["maxGuestsFrom"];
            this.maxGuestsTo = _data["maxGuestsTo"];
            this.pricePerUserInEuro = _data["pricePerUserInEuro"];
            this.pricePerGuestInEuro = _data["pricePerGuestInEuro"];
        }
    }

    static fromJS(data: any): PricelistRowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PricelistRowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["maxUsersFrom"] = this.maxUsersFrom;
        data["maxUsersTo"] = this.maxUsersTo;
        data["maxGuestsFrom"] = this.maxGuestsFrom;
        data["maxGuestsTo"] = this.maxGuestsTo;
        data["pricePerUserInEuro"] = this.pricePerUserInEuro;
        data["pricePerGuestInEuro"] = this.pricePerGuestInEuro;
        return data;
    }
}

export interface IPricelistRowResponse {
    id: number;
    tenantId: number;
    maxUsersFrom: number;
    maxUsersTo: number;
    maxGuestsFrom: number;
    maxGuestsTo: number;
    pricePerUserInEuro: number;
    pricePerGuestInEuro: number;
}

export class PricelistRowResponseItemsResponseModel implements IPricelistRowResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: PricelistRowResponse[] | undefined;

    constructor(data?: IPricelistRowResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PricelistRowResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PricelistRowResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PricelistRowResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPricelistRowResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: PricelistRowResponse[] | undefined;
}

export enum PricingPlanChangeTypeEnum {
    Cancelation = "Cancelation",
    UserReduction = "UserReduction",
    Reactivation = "Reactivation",
}

export class PricingPlanFullResponse implements IPricingPlanFullResponse {
    id!: number;
    isTrial!: boolean;
    isCanceled!: boolean;
    maxUsers!: number;
    maxGuests!: number;
    from!: Date;
    to!: Date;
    tenantId!: number;
    pendingChange?: PricingPlanPendingChangeResponse;
    numberSiteAdmins!: number;
    actualUsers!: number;
    actualGuests!: number;
    budgetInEuro!: number;
    budgetInEuroWithVat!: number;
    costsInEuro!: number;
    costsInEuroWithVat!: number;
    vatPercentage!: number;

    constructor(data?: IPricingPlanFullResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isTrial = _data["isTrial"];
            this.isCanceled = _data["isCanceled"];
            this.maxUsers = _data["maxUsers"];
            this.maxGuests = _data["maxGuests"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.pendingChange = _data["pendingChange"] ? PricingPlanPendingChangeResponse.fromJS(_data["pendingChange"]) : undefined as any;
            this.numberSiteAdmins = _data["numberSiteAdmins"];
            this.actualUsers = _data["actualUsers"];
            this.actualGuests = _data["actualGuests"];
            this.budgetInEuro = _data["budgetInEuro"];
            this.budgetInEuroWithVat = _data["budgetInEuroWithVat"];
            this.costsInEuro = _data["costsInEuro"];
            this.costsInEuroWithVat = _data["costsInEuroWithVat"];
            this.vatPercentage = _data["vatPercentage"];
        }
    }

    static fromJS(data: any): PricingPlanFullResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PricingPlanFullResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isTrial"] = this.isTrial;
        data["isCanceled"] = this.isCanceled;
        data["maxUsers"] = this.maxUsers;
        data["maxGuests"] = this.maxGuests;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["tenantId"] = this.tenantId;
        data["pendingChange"] = this.pendingChange ? this.pendingChange.toJSON() : undefined as any;
        data["numberSiteAdmins"] = this.numberSiteAdmins;
        data["actualUsers"] = this.actualUsers;
        data["actualGuests"] = this.actualGuests;
        data["budgetInEuro"] = this.budgetInEuro;
        data["budgetInEuroWithVat"] = this.budgetInEuroWithVat;
        data["costsInEuro"] = this.costsInEuro;
        data["costsInEuroWithVat"] = this.costsInEuroWithVat;
        data["vatPercentage"] = this.vatPercentage;
        return data;
    }
}

export interface IPricingPlanFullResponse {
    id: number;
    isTrial: boolean;
    isCanceled: boolean;
    maxUsers: number;
    maxGuests: number;
    from: Date;
    to: Date;
    tenantId: number;
    pendingChange?: PricingPlanPendingChangeResponse;
    numberSiteAdmins: number;
    actualUsers: number;
    actualGuests: number;
    budgetInEuro: number;
    budgetInEuroWithVat: number;
    costsInEuro: number;
    costsInEuroWithVat: number;
    vatPercentage: number;
}

export class PricingPlanFullResponseSimpleResponseModel implements IPricingPlanFullResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: PricingPlanFullResponse;

    constructor(data?: IPricingPlanFullResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? PricingPlanFullResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): PricingPlanFullResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PricingPlanFullResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IPricingPlanFullResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: PricingPlanFullResponse;
}

export class PricingPlanInvoiceResponse implements IPricingPlanInvoiceResponse {
    id!: number;
    dateCreated!: Date;
    activeUsersNo!: number;
    activeGuestsNo!: number;
    periodFrom!: Date;
    periodTo!: Date;
    pricePerUserInEuro!: number;
    pricePerGuestInEuro!: number;
    euroToRsdExchanged!: number;
    status!: PricingPlanInvoiceStatusEnum;
    name!: string;
    vatPercentage!: number;
    readonly userPriceEUR!: number;
    readonly guestPriceEUR!: number;
    readonly totalPriceEUR!: number;
    readonly vatPriceEUR!: number;
    readonly totalPriceWithVatEUR!: number;

    constructor(data?: IPricingPlanInvoiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.activeUsersNo = _data["activeUsersNo"];
            this.activeGuestsNo = _data["activeGuestsNo"];
            this.periodFrom = _data["periodFrom"] ? new Date(_data["periodFrom"].toString()) : undefined as any;
            this.periodTo = _data["periodTo"] ? new Date(_data["periodTo"].toString()) : undefined as any;
            this.pricePerUserInEuro = _data["pricePerUserInEuro"];
            this.pricePerGuestInEuro = _data["pricePerGuestInEuro"];
            this.euroToRsdExchanged = _data["euroToRsdExchanged"];
            this.status = _data["status"];
            this.name = _data["name"];
            this.vatPercentage = _data["vatPercentage"];
            (this as any).userPriceEUR = _data["userPriceEUR"];
            (this as any).guestPriceEUR = _data["guestPriceEUR"];
            (this as any).totalPriceEUR = _data["totalPriceEUR"];
            (this as any).vatPriceEUR = _data["vatPriceEUR"];
            (this as any).totalPriceWithVatEUR = _data["totalPriceWithVatEUR"];
        }
    }

    static fromJS(data: any): PricingPlanInvoiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PricingPlanInvoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateCreated"] = this.dateCreated ? formatDate(this.dateCreated) : undefined as any;
        data["activeUsersNo"] = this.activeUsersNo;
        data["activeGuestsNo"] = this.activeGuestsNo;
        data["periodFrom"] = this.periodFrom ? formatDate(this.periodFrom) : undefined as any;
        data["periodTo"] = this.periodTo ? formatDate(this.periodTo) : undefined as any;
        data["pricePerUserInEuro"] = this.pricePerUserInEuro;
        data["pricePerGuestInEuro"] = this.pricePerGuestInEuro;
        data["euroToRsdExchanged"] = this.euroToRsdExchanged;
        data["status"] = this.status;
        data["name"] = this.name;
        data["vatPercentage"] = this.vatPercentage;
        data["userPriceEUR"] = this.userPriceEUR;
        data["guestPriceEUR"] = this.guestPriceEUR;
        data["totalPriceEUR"] = this.totalPriceEUR;
        data["vatPriceEUR"] = this.vatPriceEUR;
        data["totalPriceWithVatEUR"] = this.totalPriceWithVatEUR;
        return data;
    }
}

export interface IPricingPlanInvoiceResponse {
    id: number;
    dateCreated: Date;
    activeUsersNo: number;
    activeGuestsNo: number;
    periodFrom: Date;
    periodTo: Date;
    pricePerUserInEuro: number;
    pricePerGuestInEuro: number;
    euroToRsdExchanged: number;
    status: PricingPlanInvoiceStatusEnum;
    name: string;
    vatPercentage: number;
    userPriceEUR: number;
    guestPriceEUR: number;
    totalPriceEUR: number;
    vatPriceEUR: number;
    totalPriceWithVatEUR: number;
}

export class PricingPlanInvoiceResponseItemsResponseModel implements IPricingPlanInvoiceResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: PricingPlanInvoiceResponse[] | undefined;

    constructor(data?: IPricingPlanInvoiceResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PricingPlanInvoiceResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PricingPlanInvoiceResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PricingPlanInvoiceResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPricingPlanInvoiceResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: PricingPlanInvoiceResponse[] | undefined;
}

export enum PricingPlanInvoiceStatusEnum {
    Created = "Created",
    Processing = "Processing",
    Failed = "Failed",
    Succeeded = "Succeeded",
}

export class PricingPlanPendingChangeResponse implements IPricingPlanPendingChangeResponse {
    id!: number;
    type!: PricingPlanChangeTypeEnum;
    userReductionData?: PricingPlanUserReductionData;
    tenantId!: number;

    constructor(data?: IPricingPlanPendingChangeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.userReductionData = _data["userReductionData"] ? PricingPlanUserReductionData.fromJS(_data["userReductionData"]) : undefined as any;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): PricingPlanPendingChangeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PricingPlanPendingChangeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["userReductionData"] = this.userReductionData ? this.userReductionData.toJSON() : undefined as any;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IPricingPlanPendingChangeResponse {
    id: number;
    type: PricingPlanChangeTypeEnum;
    userReductionData?: PricingPlanUserReductionData;
    tenantId: number;
}

export class PricingPlanRequestModel implements IPricingPlanRequestModel {
    maxUsers!: number;
    maxGuests!: number;
    userReductionData?: PricingPlanUserReductionDataRequestModel;

    constructor(data?: IPricingPlanRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxUsers = _data["maxUsers"];
            this.maxGuests = _data["maxGuests"];
            this.userReductionData = _data["userReductionData"] ? PricingPlanUserReductionDataRequestModel.fromJS(_data["userReductionData"]) : undefined as any;
        }
    }

    static fromJS(data: any): PricingPlanRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PricingPlanRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxUsers"] = this.maxUsers;
        data["maxGuests"] = this.maxGuests;
        data["userReductionData"] = this.userReductionData ? this.userReductionData.toJSON() : undefined as any;
        return data;
    }
}

export interface IPricingPlanRequestModel {
    maxUsers: number;
    maxGuests: number;
    userReductionData?: PricingPlanUserReductionDataRequestModel;
}

export class PricingPlanResponse implements IPricingPlanResponse {
    id!: number;
    isTrial!: boolean;
    isCanceled!: boolean;
    maxUsers!: number;
    maxGuests!: number;
    from!: Date;
    to!: Date;
    tenantId!: number;
    pendingChange?: PricingPlanPendingChangeResponse;

    constructor(data?: IPricingPlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isTrial = _data["isTrial"];
            this.isCanceled = _data["isCanceled"];
            this.maxUsers = _data["maxUsers"];
            this.maxGuests = _data["maxGuests"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.tenantId = _data["tenantId"];
            this.pendingChange = _data["pendingChange"] ? PricingPlanPendingChangeResponse.fromJS(_data["pendingChange"]) : undefined as any;
        }
    }

    static fromJS(data: any): PricingPlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PricingPlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isTrial"] = this.isTrial;
        data["isCanceled"] = this.isCanceled;
        data["maxUsers"] = this.maxUsers;
        data["maxGuests"] = this.maxGuests;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["tenantId"] = this.tenantId;
        data["pendingChange"] = this.pendingChange ? this.pendingChange.toJSON() : undefined as any;
        return data;
    }
}

export interface IPricingPlanResponse {
    id: number;
    isTrial: boolean;
    isCanceled: boolean;
    maxUsers: number;
    maxGuests: number;
    from: Date;
    to: Date;
    tenantId: number;
    pendingChange?: PricingPlanPendingChangeResponse;
}

export class PricingPlanResponseSimpleResponseModel implements IPricingPlanResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: PricingPlanResponse;

    constructor(data?: IPricingPlanResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? PricingPlanResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): PricingPlanResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PricingPlanResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IPricingPlanResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: PricingPlanResponse;
}

export class PricingPlanUserReductionData implements IPricingPlanUserReductionData {
    maxUsers?: number | undefined;
    maxGuests?: number | undefined;
    usersToRemainActive?: number[] | undefined;
    guestsToRemainActive?: number[] | undefined;

    constructor(data?: IPricingPlanUserReductionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxUsers = _data["maxUsers"];
            this.maxGuests = _data["maxGuests"];
            if (Array.isArray(_data["usersToRemainActive"])) {
                this.usersToRemainActive = [] as any;
                for (let item of _data["usersToRemainActive"])
                    this.usersToRemainActive!.push(item);
            }
            if (Array.isArray(_data["guestsToRemainActive"])) {
                this.guestsToRemainActive = [] as any;
                for (let item of _data["guestsToRemainActive"])
                    this.guestsToRemainActive!.push(item);
            }
        }
    }

    static fromJS(data: any): PricingPlanUserReductionData {
        data = typeof data === 'object' ? data : {};
        let result = new PricingPlanUserReductionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxUsers"] = this.maxUsers;
        data["maxGuests"] = this.maxGuests;
        if (Array.isArray(this.usersToRemainActive)) {
            data["usersToRemainActive"] = [];
            for (let item of this.usersToRemainActive)
                data["usersToRemainActive"].push(item);
        }
        if (Array.isArray(this.guestsToRemainActive)) {
            data["guestsToRemainActive"] = [];
            for (let item of this.guestsToRemainActive)
                data["guestsToRemainActive"].push(item);
        }
        return data;
    }
}

export interface IPricingPlanUserReductionData {
    maxUsers?: number | undefined;
    maxGuests?: number | undefined;
    usersToRemainActive?: number[] | undefined;
    guestsToRemainActive?: number[] | undefined;
}

export class PricingPlanUserReductionDataRequestModel implements IPricingPlanUserReductionDataRequestModel {
    usersToDeactivate?: number[] | undefined;
    guestsToDeactivate?: number[] | undefined;

    constructor(data?: IPricingPlanUserReductionDataRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["usersToDeactivate"])) {
                this.usersToDeactivate = [] as any;
                for (let item of _data["usersToDeactivate"])
                    this.usersToDeactivate!.push(item);
            }
            if (Array.isArray(_data["guestsToDeactivate"])) {
                this.guestsToDeactivate = [] as any;
                for (let item of _data["guestsToDeactivate"])
                    this.guestsToDeactivate!.push(item);
            }
        }
    }

    static fromJS(data: any): PricingPlanUserReductionDataRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new PricingPlanUserReductionDataRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.usersToDeactivate)) {
            data["usersToDeactivate"] = [];
            for (let item of this.usersToDeactivate)
                data["usersToDeactivate"].push(item);
        }
        if (Array.isArray(this.guestsToDeactivate)) {
            data["guestsToDeactivate"] = [];
            for (let item of this.guestsToDeactivate)
                data["guestsToDeactivate"].push(item);
        }
        return data;
    }
}

export interface IPricingPlanUserReductionDataRequestModel {
    usersToDeactivate?: number[] | undefined;
    guestsToDeactivate?: number[] | undefined;
}

export enum PriorityEnum {
    Critical = "Critical",
    High = "High",
    Medium = "Medium",
    Low = "Low",
}

export class PriorityNewOld implements IPriorityNewOld {
    oldValue?: PriorityEnum;
    newValue?: PriorityEnum;

    constructor(data?: IPriorityNewOld) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): PriorityNewOld {
        data = typeof data === 'object' ? data : {};
        let result = new PriorityNewOld();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IPriorityNewOld {
    oldValue?: PriorityEnum;
    newValue?: PriorityEnum;
}

export class PriorityResponse implements IPriorityResponse {
    id!: number;
    semantics!: PriorityEnum;
    name!: string;
    description?: string | undefined;
    urgencyImpactMapping!: UrgencyImpatPair[];

    constructor(data?: IPriorityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.urgencyImpactMapping = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.semantics = _data["semantics"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["urgencyImpactMapping"])) {
                this.urgencyImpactMapping = [] as any;
                for (let item of _data["urgencyImpactMapping"])
                    this.urgencyImpactMapping!.push(UrgencyImpatPair.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PriorityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PriorityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["semantics"] = this.semantics;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.urgencyImpactMapping)) {
            data["urgencyImpactMapping"] = [];
            for (let item of this.urgencyImpactMapping)
                data["urgencyImpactMapping"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPriorityResponse {
    id: number;
    semantics: PriorityEnum;
    name: string;
    description?: string | undefined;
    urgencyImpactMapping: UrgencyImpatPair[];
}

export class PriorityResponseItemsResponseModel implements IPriorityResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: PriorityResponse[] | undefined;

    constructor(data?: IPriorityResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PriorityResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PriorityResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriorityResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPriorityResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: PriorityResponse[] | undefined;
}

export class ProjectAccomplishmentResponse implements IProjectAccomplishmentResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    reportId!: number;
    plannedDate?: Date | undefined;
    status!: ReportItemStatusEnum;

    constructor(data?: IProjectAccomplishmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.reportId = _data["reportId"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProjectAccomplishmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAccomplishmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["reportId"] = this.reportId;
        data["plannedDate"] = this.plannedDate ? formatDate(this.plannedDate) : undefined as any;
        data["status"] = this.status;
        return data;
    }
}

export interface IProjectAccomplishmentResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    reportId: number;
    plannedDate?: Date | undefined;
    status: ReportItemStatusEnum;
}

export class ProjectAccomplishmentResponseItemsResponseModel implements IProjectAccomplishmentResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectAccomplishmentResponse[] | undefined;

    constructor(data?: IProjectAccomplishmentResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectAccomplishmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectAccomplishmentResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAccomplishmentResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectAccomplishmentResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectAccomplishmentResponse[] | undefined;
}

export class ProjectAccomplishmentResponseSimpleResponseModel implements IProjectAccomplishmentResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectAccomplishmentResponse;

    constructor(data?: IProjectAccomplishmentResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectAccomplishmentResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectAccomplishmentResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAccomplishmentResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectAccomplishmentResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectAccomplishmentResponse;
}

export class ProjectActionResponse implements IProjectActionResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    reportId!: number;
    status!: ReportItemStatusEnum;

    constructor(data?: IProjectActionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.reportId = _data["reportId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProjectActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectActionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["reportId"] = this.reportId;
        data["status"] = this.status;
        return data;
    }
}

export interface IProjectActionResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    reportId: number;
    status: ReportItemStatusEnum;
}

export class ProjectActionResponseItemsResponseModel implements IProjectActionResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectActionResponse[] | undefined;

    constructor(data?: IProjectActionResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectActionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectActionResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectActionResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectActionResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectActionResponse[] | undefined;
}

export class ProjectActionResponseSimpleResponseModel implements IProjectActionResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectActionResponse;

    constructor(data?: IProjectActionResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectActionResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectActionResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectActionResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectActionResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectActionResponse;
}

export class ProjectActualBudgetDashboardResponse implements IProjectActualBudgetDashboardResponse {
    actualBudgetPerProject?: { [key: string]: ActualBudgetResponse; } | undefined;
    incomePerProjectType?: { [key: string]: number; } | undefined;
    expensePerProjectType?: { [key: string]: number; } | undefined;
    profitPerProjectType?: { [key: string]: number; } | undefined;
    incomePerProjectCategory?: { [key: string]: number; } | undefined;
    expensePerProjectCategory?: { [key: string]: number; } | undefined;
    profitPerProjectCategory?: { [key: string]: number; } | undefined;

    constructor(data?: IProjectActualBudgetDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["actualBudgetPerProject"]) {
                this.actualBudgetPerProject = {} as any;
                for (let key in _data["actualBudgetPerProject"]) {
                    if (_data["actualBudgetPerProject"].hasOwnProperty(key))
                        (this.actualBudgetPerProject as any)![key] = _data["actualBudgetPerProject"][key] ? ActualBudgetResponse.fromJS(_data["actualBudgetPerProject"][key]) : new ActualBudgetResponse();
                }
            }
            if (_data["incomePerProjectType"]) {
                this.incomePerProjectType = {} as any;
                for (let key in _data["incomePerProjectType"]) {
                    if (_data["incomePerProjectType"].hasOwnProperty(key))
                        (this.incomePerProjectType as any)![key] = _data["incomePerProjectType"][key];
                }
            }
            if (_data["expensePerProjectType"]) {
                this.expensePerProjectType = {} as any;
                for (let key in _data["expensePerProjectType"]) {
                    if (_data["expensePerProjectType"].hasOwnProperty(key))
                        (this.expensePerProjectType as any)![key] = _data["expensePerProjectType"][key];
                }
            }
            if (_data["profitPerProjectType"]) {
                this.profitPerProjectType = {} as any;
                for (let key in _data["profitPerProjectType"]) {
                    if (_data["profitPerProjectType"].hasOwnProperty(key))
                        (this.profitPerProjectType as any)![key] = _data["profitPerProjectType"][key];
                }
            }
            if (_data["incomePerProjectCategory"]) {
                this.incomePerProjectCategory = {} as any;
                for (let key in _data["incomePerProjectCategory"]) {
                    if (_data["incomePerProjectCategory"].hasOwnProperty(key))
                        (this.incomePerProjectCategory as any)![key] = _data["incomePerProjectCategory"][key];
                }
            }
            if (_data["expensePerProjectCategory"]) {
                this.expensePerProjectCategory = {} as any;
                for (let key in _data["expensePerProjectCategory"]) {
                    if (_data["expensePerProjectCategory"].hasOwnProperty(key))
                        (this.expensePerProjectCategory as any)![key] = _data["expensePerProjectCategory"][key];
                }
            }
            if (_data["profitPerProjectCategory"]) {
                this.profitPerProjectCategory = {} as any;
                for (let key in _data["profitPerProjectCategory"]) {
                    if (_data["profitPerProjectCategory"].hasOwnProperty(key))
                        (this.profitPerProjectCategory as any)![key] = _data["profitPerProjectCategory"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProjectActualBudgetDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectActualBudgetDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.actualBudgetPerProject) {
            data["actualBudgetPerProject"] = {};
            for (let key in this.actualBudgetPerProject) {
                if (this.actualBudgetPerProject.hasOwnProperty(key))
                    (data["actualBudgetPerProject"] as any)[key] = this.actualBudgetPerProject[key] ? this.actualBudgetPerProject[key].toJSON() : undefined as any;
            }
        }
        if (this.incomePerProjectType) {
            data["incomePerProjectType"] = {};
            for (let key in this.incomePerProjectType) {
                if (this.incomePerProjectType.hasOwnProperty(key))
                    (data["incomePerProjectType"] as any)[key] = (this.incomePerProjectType as any)[key];
            }
        }
        if (this.expensePerProjectType) {
            data["expensePerProjectType"] = {};
            for (let key in this.expensePerProjectType) {
                if (this.expensePerProjectType.hasOwnProperty(key))
                    (data["expensePerProjectType"] as any)[key] = (this.expensePerProjectType as any)[key];
            }
        }
        if (this.profitPerProjectType) {
            data["profitPerProjectType"] = {};
            for (let key in this.profitPerProjectType) {
                if (this.profitPerProjectType.hasOwnProperty(key))
                    (data["profitPerProjectType"] as any)[key] = (this.profitPerProjectType as any)[key];
            }
        }
        if (this.incomePerProjectCategory) {
            data["incomePerProjectCategory"] = {};
            for (let key in this.incomePerProjectCategory) {
                if (this.incomePerProjectCategory.hasOwnProperty(key))
                    (data["incomePerProjectCategory"] as any)[key] = (this.incomePerProjectCategory as any)[key];
            }
        }
        if (this.expensePerProjectCategory) {
            data["expensePerProjectCategory"] = {};
            for (let key in this.expensePerProjectCategory) {
                if (this.expensePerProjectCategory.hasOwnProperty(key))
                    (data["expensePerProjectCategory"] as any)[key] = (this.expensePerProjectCategory as any)[key];
            }
        }
        if (this.profitPerProjectCategory) {
            data["profitPerProjectCategory"] = {};
            for (let key in this.profitPerProjectCategory) {
                if (this.profitPerProjectCategory.hasOwnProperty(key))
                    (data["profitPerProjectCategory"] as any)[key] = (this.profitPerProjectCategory as any)[key];
            }
        }
        return data;
    }
}

export interface IProjectActualBudgetDashboardResponse {
    actualBudgetPerProject?: { [key: string]: ActualBudgetResponse; } | undefined;
    incomePerProjectType?: { [key: string]: number; } | undefined;
    expensePerProjectType?: { [key: string]: number; } | undefined;
    profitPerProjectType?: { [key: string]: number; } | undefined;
    incomePerProjectCategory?: { [key: string]: number; } | undefined;
    expensePerProjectCategory?: { [key: string]: number; } | undefined;
    profitPerProjectCategory?: { [key: string]: number; } | undefined;
}

export class ProjectBusinessResponse implements IProjectBusinessResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    reportId!: number;
    value?: number | undefined;

    constructor(data?: IProjectBusinessResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.reportId = _data["reportId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ProjectBusinessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectBusinessResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["reportId"] = this.reportId;
        data["value"] = this.value;
        return data;
    }
}

export interface IProjectBusinessResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    reportId: number;
    value?: number | undefined;
}

export class ProjectBusinessResponseItemsResponseModel implements IProjectBusinessResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectBusinessResponse[] | undefined;

    constructor(data?: IProjectBusinessResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectBusinessResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectBusinessResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectBusinessResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectBusinessResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectBusinessResponse[] | undefined;
}

export class ProjectBusinessResponseSimpleResponseModel implements IProjectBusinessResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectBusinessResponse;

    constructor(data?: IProjectBusinessResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectBusinessResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectBusinessResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectBusinessResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectBusinessResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectBusinessResponse;
}

export class ProjectChangeRequestCountsResponse implements IProjectChangeRequestCountsResponse {
    totalCostSum!: number;
    totalEffortSum!: number;

    constructor(data?: IProjectChangeRequestCountsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCostSum = _data["totalCostSum"];
            this.totalEffortSum = _data["totalEffortSum"];
        }
    }

    static fromJS(data: any): ProjectChangeRequestCountsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectChangeRequestCountsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCostSum"] = this.totalCostSum;
        data["totalEffortSum"] = this.totalEffortSum;
        return data;
    }
}

export interface IProjectChangeRequestCountsResponse {
    totalCostSum: number;
    totalEffortSum: number;
}

export class ProjectChangeRequestCountsResponseSimpleResponseModel implements IProjectChangeRequestCountsResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectChangeRequestCountsResponse;

    constructor(data?: IProjectChangeRequestCountsResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectChangeRequestCountsResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectChangeRequestCountsResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectChangeRequestCountsResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectChangeRequestCountsResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectChangeRequestCountsResponse;
}

export class ProjectChangeRequestResponse implements IProjectChangeRequestResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    visibleId!: number;
    reportId!: number;
    isGenerated!: boolean;
    initiatedBy?: string | undefined;
    approvedByUserId?: number | undefined;
    requestedOn?: Date | undefined;
    priority!: ChangeRequestPriorityEnum;
    completitionOn?: Date | undefined;
    statusId!: number;
    effortInHours?: number | undefined;
    totalCost?: number | undefined;
    estimatedEffortInHours?: number | undefined;
    estimatedTotalCost?: number | undefined;
    goLiveCritical!: boolean;

    constructor(data?: IProjectChangeRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.visibleId = _data["visibleId"];
            this.reportId = _data["reportId"];
            this.isGenerated = _data["isGenerated"];
            this.initiatedBy = _data["initiatedBy"];
            this.approvedByUserId = _data["approvedByUserId"];
            this.requestedOn = _data["requestedOn"] ? new Date(_data["requestedOn"].toString()) : undefined as any;
            this.priority = _data["priority"];
            this.completitionOn = _data["completitionOn"] ? new Date(_data["completitionOn"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.effortInHours = _data["effortInHours"];
            this.totalCost = _data["totalCost"];
            this.estimatedEffortInHours = _data["estimatedEffortInHours"];
            this.estimatedTotalCost = _data["estimatedTotalCost"];
            this.goLiveCritical = _data["goLiveCritical"];
        }
    }

    static fromJS(data: any): ProjectChangeRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectChangeRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["visibleId"] = this.visibleId;
        data["reportId"] = this.reportId;
        data["isGenerated"] = this.isGenerated;
        data["initiatedBy"] = this.initiatedBy;
        data["approvedByUserId"] = this.approvedByUserId;
        data["requestedOn"] = this.requestedOn ? formatDate(this.requestedOn) : undefined as any;
        data["priority"] = this.priority;
        data["completitionOn"] = this.completitionOn ? formatDate(this.completitionOn) : undefined as any;
        data["statusId"] = this.statusId;
        data["effortInHours"] = this.effortInHours;
        data["totalCost"] = this.totalCost;
        data["estimatedEffortInHours"] = this.estimatedEffortInHours;
        data["estimatedTotalCost"] = this.estimatedTotalCost;
        data["goLiveCritical"] = this.goLiveCritical;
        return data;
    }
}

export interface IProjectChangeRequestResponse {
    id: number;
    name: string;
    description?: string | undefined;
    visibleId: number;
    reportId: number;
    isGenerated: boolean;
    initiatedBy?: string | undefined;
    approvedByUserId?: number | undefined;
    requestedOn?: Date | undefined;
    priority: ChangeRequestPriorityEnum;
    completitionOn?: Date | undefined;
    statusId: number;
    effortInHours?: number | undefined;
    totalCost?: number | undefined;
    estimatedEffortInHours?: number | undefined;
    estimatedTotalCost?: number | undefined;
    goLiveCritical: boolean;
}

export class ProjectChangeRequestResponseItemsResponseModel implements IProjectChangeRequestResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectChangeRequestResponse[] | undefined;

    constructor(data?: IProjectChangeRequestResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectChangeRequestResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectChangeRequestResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectChangeRequestResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectChangeRequestResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectChangeRequestResponse[] | undefined;
}

export class ProjectChangeRequestResponseSimpleResponseModel implements IProjectChangeRequestResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectChangeRequestResponse;

    constructor(data?: IProjectChangeRequestResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectChangeRequestResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectChangeRequestResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectChangeRequestResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectChangeRequestResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectChangeRequestResponse;
}

export class ProjectDashboardFilterRequest implements IProjectDashboardFilterRequest {
    projectId!: number;
    testCycleIds?: number[] | undefined;
    trainingCycleIds?: number[] | undefined;

    constructor(data?: IProjectDashboardFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["testCycleIds"])) {
                this.testCycleIds = [] as any;
                for (let item of _data["testCycleIds"])
                    this.testCycleIds!.push(item);
            }
            if (Array.isArray(_data["trainingCycleIds"])) {
                this.trainingCycleIds = [] as any;
                for (let item of _data["trainingCycleIds"])
                    this.trainingCycleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectDashboardFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDashboardFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.testCycleIds)) {
            data["testCycleIds"] = [];
            for (let item of this.testCycleIds)
                data["testCycleIds"].push(item);
        }
        if (Array.isArray(this.trainingCycleIds)) {
            data["trainingCycleIds"] = [];
            for (let item of this.trainingCycleIds)
                data["trainingCycleIds"].push(item);
        }
        return data;
    }
}

export interface IProjectDashboardFilterRequest {
    projectId: number;
    testCycleIds?: number[] | undefined;
    trainingCycleIds?: number[] | undefined;
}

export class ProjectDashboardResponse implements IProjectDashboardResponse {
    incomeExpenseProfit?: IncomeExpenseProfitDashboardResponse;
    incomingOutgoingOverdue?: IncomingOutgoingOverdueDashboardResponse;
    projectHoursPerPeriod?: ProjectHoursRowDashboardResponse[] | undefined;
    projectDurationCompletion?: ProjectDurationCompletionResponse;
    ticketsPerStatusCounts?: { [key: string]: number; } | undefined;
    tasksPerStatusCounts?: { [key: string]: number; } | undefined;
    testStatuses?: TestDashboardStatusesResponse[] | undefined;
    trainingStatusCounts?: { [key: string]: number; } | undefined;

    constructor(data?: IProjectDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.incomeExpenseProfit = _data["incomeExpenseProfit"] ? IncomeExpenseProfitDashboardResponse.fromJS(_data["incomeExpenseProfit"]) : undefined as any;
            this.incomingOutgoingOverdue = _data["incomingOutgoingOverdue"] ? IncomingOutgoingOverdueDashboardResponse.fromJS(_data["incomingOutgoingOverdue"]) : undefined as any;
            if (Array.isArray(_data["projectHoursPerPeriod"])) {
                this.projectHoursPerPeriod = [] as any;
                for (let item of _data["projectHoursPerPeriod"])
                    this.projectHoursPerPeriod!.push(ProjectHoursRowDashboardResponse.fromJS(item));
            }
            this.projectDurationCompletion = _data["projectDurationCompletion"] ? ProjectDurationCompletionResponse.fromJS(_data["projectDurationCompletion"]) : undefined as any;
            if (_data["ticketsPerStatusCounts"]) {
                this.ticketsPerStatusCounts = {} as any;
                for (let key in _data["ticketsPerStatusCounts"]) {
                    if (_data["ticketsPerStatusCounts"].hasOwnProperty(key))
                        (this.ticketsPerStatusCounts as any)![key] = _data["ticketsPerStatusCounts"][key];
                }
            }
            if (_data["tasksPerStatusCounts"]) {
                this.tasksPerStatusCounts = {} as any;
                for (let key in _data["tasksPerStatusCounts"]) {
                    if (_data["tasksPerStatusCounts"].hasOwnProperty(key))
                        (this.tasksPerStatusCounts as any)![key] = _data["tasksPerStatusCounts"][key];
                }
            }
            if (Array.isArray(_data["testStatuses"])) {
                this.testStatuses = [] as any;
                for (let item of _data["testStatuses"])
                    this.testStatuses!.push(TestDashboardStatusesResponse.fromJS(item));
            }
            if (_data["trainingStatusCounts"]) {
                this.trainingStatusCounts = {} as any;
                for (let key in _data["trainingStatusCounts"]) {
                    if (_data["trainingStatusCounts"].hasOwnProperty(key))
                        (this.trainingStatusCounts as any)![key] = _data["trainingStatusCounts"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProjectDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incomeExpenseProfit"] = this.incomeExpenseProfit ? this.incomeExpenseProfit.toJSON() : undefined as any;
        data["incomingOutgoingOverdue"] = this.incomingOutgoingOverdue ? this.incomingOutgoingOverdue.toJSON() : undefined as any;
        if (Array.isArray(this.projectHoursPerPeriod)) {
            data["projectHoursPerPeriod"] = [];
            for (let item of this.projectHoursPerPeriod)
                data["projectHoursPerPeriod"].push(item ? item.toJSON() : undefined as any);
        }
        data["projectDurationCompletion"] = this.projectDurationCompletion ? this.projectDurationCompletion.toJSON() : undefined as any;
        if (this.ticketsPerStatusCounts) {
            data["ticketsPerStatusCounts"] = {};
            for (let key in this.ticketsPerStatusCounts) {
                if (this.ticketsPerStatusCounts.hasOwnProperty(key))
                    (data["ticketsPerStatusCounts"] as any)[key] = (this.ticketsPerStatusCounts as any)[key];
            }
        }
        if (this.tasksPerStatusCounts) {
            data["tasksPerStatusCounts"] = {};
            for (let key in this.tasksPerStatusCounts) {
                if (this.tasksPerStatusCounts.hasOwnProperty(key))
                    (data["tasksPerStatusCounts"] as any)[key] = (this.tasksPerStatusCounts as any)[key];
            }
        }
        if (Array.isArray(this.testStatuses)) {
            data["testStatuses"] = [];
            for (let item of this.testStatuses)
                data["testStatuses"].push(item ? item.toJSON() : undefined as any);
        }
        if (this.trainingStatusCounts) {
            data["trainingStatusCounts"] = {};
            for (let key in this.trainingStatusCounts) {
                if (this.trainingStatusCounts.hasOwnProperty(key))
                    (data["trainingStatusCounts"] as any)[key] = (this.trainingStatusCounts as any)[key];
            }
        }
        return data;
    }
}

export interface IProjectDashboardResponse {
    incomeExpenseProfit?: IncomeExpenseProfitDashboardResponse;
    incomingOutgoingOverdue?: IncomingOutgoingOverdueDashboardResponse;
    projectHoursPerPeriod?: ProjectHoursRowDashboardResponse[] | undefined;
    projectDurationCompletion?: ProjectDurationCompletionResponse;
    ticketsPerStatusCounts?: { [key: string]: number; } | undefined;
    tasksPerStatusCounts?: { [key: string]: number; } | undefined;
    testStatuses?: TestDashboardStatusesResponse[] | undefined;
    trainingStatusCounts?: { [key: string]: number; } | undefined;
}

export class ProjectDashboardResponseSimpleResponseModel implements IProjectDashboardResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectDashboardResponse;

    constructor(data?: IProjectDashboardResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectDashboardResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectDashboardResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDashboardResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectDashboardResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectDashboardResponse;
}

export class ProjectDeliverableResponse implements IProjectDeliverableResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    reportId!: number;
    visibleId?: number | undefined;
    isGenerated!: boolean;
    wbs!: string;
    complete?: number | undefined;
    finish?: Date | undefined;
    achievedDate?: Date | undefined;

    constructor(data?: IProjectDeliverableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.reportId = _data["reportId"];
            this.visibleId = _data["visibleId"];
            this.isGenerated = _data["isGenerated"];
            this.wbs = _data["wbs"];
            this.complete = _data["complete"];
            this.finish = _data["finish"] ? new Date(_data["finish"].toString()) : undefined as any;
            this.achievedDate = _data["achievedDate"] ? new Date(_data["achievedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectDeliverableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDeliverableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["reportId"] = this.reportId;
        data["visibleId"] = this.visibleId;
        data["isGenerated"] = this.isGenerated;
        data["wbs"] = this.wbs;
        data["complete"] = this.complete;
        data["finish"] = this.finish ? formatDate(this.finish) : undefined as any;
        data["achievedDate"] = this.achievedDate ? formatDate(this.achievedDate) : undefined as any;
        return data;
    }
}

export interface IProjectDeliverableResponse {
    id: number;
    name: string;
    description?: string | undefined;
    reportId: number;
    visibleId?: number | undefined;
    isGenerated: boolean;
    wbs: string;
    complete?: number | undefined;
    finish?: Date | undefined;
    achievedDate?: Date | undefined;
}

export class ProjectDeliverableResponseItemsResponseModel implements IProjectDeliverableResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectDeliverableResponse[] | undefined;

    constructor(data?: IProjectDeliverableResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectDeliverableResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDeliverableResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDeliverableResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectDeliverableResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectDeliverableResponse[] | undefined;
}

export class ProjectDeliverableResponseSimpleResponseModel implements IProjectDeliverableResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectDeliverableResponse;

    constructor(data?: IProjectDeliverableResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectDeliverableResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectDeliverableResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDeliverableResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectDeliverableResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectDeliverableResponse;
}

export class ProjectDurationCompletionResponse implements IProjectDurationCompletionResponse {
    projectDurationInDays!: number;
    percentOfCompletion!: number;

    constructor(data?: IProjectDurationCompletionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectDurationInDays = _data["projectDurationInDays"];
            this.percentOfCompletion = _data["percentOfCompletion"];
        }
    }

    static fromJS(data: any): ProjectDurationCompletionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDurationCompletionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectDurationInDays"] = this.projectDurationInDays;
        data["percentOfCompletion"] = this.percentOfCompletion;
        return data;
    }
}

export interface IProjectDurationCompletionResponse {
    projectDurationInDays: number;
    percentOfCompletion: number;
}

export class ProjectFinanceCountsResponse implements IProjectFinanceCountsResponse {
    amountSum!: number;
    taxAmountSum!: number;
    totalAmountSum!: number;

    constructor(data?: IProjectFinanceCountsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountSum = _data["amountSum"];
            this.taxAmountSum = _data["taxAmountSum"];
            this.totalAmountSum = _data["totalAmountSum"];
        }
    }

    static fromJS(data: any): ProjectFinanceCountsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFinanceCountsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountSum"] = this.amountSum;
        data["taxAmountSum"] = this.taxAmountSum;
        data["totalAmountSum"] = this.totalAmountSum;
        return data;
    }
}

export interface IProjectFinanceCountsResponse {
    amountSum: number;
    taxAmountSum: number;
    totalAmountSum: number;
}

export class ProjectFinanceCountsResponseSimpleResponseModel implements IProjectFinanceCountsResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectFinanceCountsResponse;

    constructor(data?: IProjectFinanceCountsResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectFinanceCountsResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectFinanceCountsResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFinanceCountsResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectFinanceCountsResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectFinanceCountsResponse;
}

export class ProjectFinanceResponse implements IProjectFinanceResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    visibleId!: number;
    reportId!: number;
    isGenerated!: boolean;
    invoiceType!: InvoiceTypeEnum;
    invoiceNumber!: string;
    partnerId!: number;
    issueDate!: Date;
    due!: Date;
    readonly paymentTerm!: number;
    amount!: number;
    taxAmount!: number;
    readonly totalAmount!: number;
    statusId!: number;

    constructor(data?: IProjectFinanceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.visibleId = _data["visibleId"];
            this.reportId = _data["reportId"];
            this.isGenerated = _data["isGenerated"];
            this.invoiceType = _data["invoiceType"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.partnerId = _data["partnerId"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            (this as any).paymentTerm = _data["paymentTerm"];
            this.amount = _data["amount"];
            this.taxAmount = _data["taxAmount"];
            (this as any).totalAmount = _data["totalAmount"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): ProjectFinanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFinanceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["visibleId"] = this.visibleId;
        data["reportId"] = this.reportId;
        data["isGenerated"] = this.isGenerated;
        data["invoiceType"] = this.invoiceType;
        data["invoiceNumber"] = this.invoiceNumber;
        data["partnerId"] = this.partnerId;
        data["issueDate"] = this.issueDate ? formatDate(this.issueDate) : undefined as any;
        data["due"] = this.due ? formatDate(this.due) : undefined as any;
        data["paymentTerm"] = this.paymentTerm;
        data["amount"] = this.amount;
        data["taxAmount"] = this.taxAmount;
        data["totalAmount"] = this.totalAmount;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface IProjectFinanceResponse {
    id: number;
    name: string;
    description?: string | undefined;
    visibleId: number;
    reportId: number;
    isGenerated: boolean;
    invoiceType: InvoiceTypeEnum;
    invoiceNumber: string;
    partnerId: number;
    issueDate: Date;
    due: Date;
    paymentTerm: number;
    amount: number;
    taxAmount: number;
    totalAmount: number;
    statusId: number;
}

export class ProjectFinanceResponseItemsResponseModel implements IProjectFinanceResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectFinanceResponse[] | undefined;

    constructor(data?: IProjectFinanceResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectFinanceResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectFinanceResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFinanceResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectFinanceResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectFinanceResponse[] | undefined;
}

export class ProjectFinanceResponseSimpleResponseModel implements IProjectFinanceResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectFinanceResponse;

    constructor(data?: IProjectFinanceResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectFinanceResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectFinanceResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFinanceResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectFinanceResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectFinanceResponse;
}

export class ProjectGetAllResponse implements IProjectGetAllResponse {
    id!: number;
    name!: string;
    statusId!: number;
    pmId!: number;
    typeId?: number | undefined;
    categoryId?: number | undefined;
    organizationalUnitId?: number | undefined;
    supportOrganizationId?: number | undefined;
    description?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    partnerId?: number | undefined;
    roleId?: TokenTypeEnum;

    constructor(data?: IProjectGetAllResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.statusId = _data["statusId"];
            this.pmId = _data["pmId"];
            this.typeId = _data["typeId"];
            this.categoryId = _data["categoryId"];
            this.organizationalUnitId = _data["organizationalUnitId"];
            this.supportOrganizationId = _data["supportOrganizationId"];
            this.description = _data["description"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.partnerId = _data["partnerId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): ProjectGetAllResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectGetAllResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["statusId"] = this.statusId;
        data["pmId"] = this.pmId;
        data["typeId"] = this.typeId;
        data["categoryId"] = this.categoryId;
        data["organizationalUnitId"] = this.organizationalUnitId;
        data["supportOrganizationId"] = this.supportOrganizationId;
        data["description"] = this.description;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["partnerId"] = this.partnerId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IProjectGetAllResponse {
    id: number;
    name: string;
    statusId: number;
    pmId: number;
    typeId?: number | undefined;
    categoryId?: number | undefined;
    organizationalUnitId?: number | undefined;
    supportOrganizationId?: number | undefined;
    description?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    partnerId?: number | undefined;
    roleId?: TokenTypeEnum;
}

export class ProjectGetAllResponseItemsResponseModel implements IProjectGetAllResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectGetAllResponse[] | undefined;

    constructor(data?: IProjectGetAllResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectGetAllResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectGetAllResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectGetAllResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectGetAllResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectGetAllResponse[] | undefined;
}

export class ProjectHoursRowDashboardResponse implements IProjectHoursRowDashboardResponse {
    date!: Date;
    hours!: number;

    constructor(data?: IProjectHoursRowDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): ProjectHoursRowDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectHoursRowDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["hours"] = this.hours;
        return data;
    }
}

export interface IProjectHoursRowDashboardResponse {
    date: Date;
    hours: number;
}

export class ProjectIdRequest implements IProjectIdRequest {
    projectId!: number;

    constructor(data?: IProjectIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ProjectIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IProjectIdRequest {
    projectId: number;
}

export class ProjectIsActiveOrderResponse implements IProjectIsActiveOrderResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    projectId!: number;
    order!: number;

    constructor(data?: IProjectIsActiveOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.projectId = _data["projectId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): ProjectIsActiveOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectIsActiveOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["projectId"] = this.projectId;
        data["order"] = this.order;
        return data;
    }
}

export interface IProjectIsActiveOrderResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    projectId: number;
    order: number;
}

export class ProjectIsActiveOrderResponseItemsResponseModel implements IProjectIsActiveOrderResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectIsActiveOrderResponse[] | undefined;

    constructor(data?: IProjectIsActiveOrderResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectIsActiveOrderResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectIsActiveOrderResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectIsActiveOrderResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectIsActiveOrderResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectIsActiveOrderResponse[] | undefined;
}

export class ProjectIsActiveResponse implements IProjectIsActiveResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    projectId!: number;

    constructor(data?: IProjectIsActiveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ProjectIsActiveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectIsActiveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IProjectIsActiveResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    projectId: number;
}

export class ProjectIsActiveResponseItemsResponseModel implements IProjectIsActiveResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectIsActiveResponse[] | undefined;

    constructor(data?: IProjectIsActiveResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectIsActiveResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectIsActiveResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectIsActiveResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectIsActiveResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectIsActiveResponse[] | undefined;
}

export class ProjectIssueResponse implements IProjectIssueResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    reportId!: number;
    impact?: string | undefined;
    solution?: string | undefined;
    resolution?: string | undefined;

    constructor(data?: IProjectIssueResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.reportId = _data["reportId"];
            this.impact = _data["impact"];
            this.solution = _data["solution"];
            this.resolution = _data["resolution"];
        }
    }

    static fromJS(data: any): ProjectIssueResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectIssueResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["reportId"] = this.reportId;
        data["impact"] = this.impact;
        data["solution"] = this.solution;
        data["resolution"] = this.resolution;
        return data;
    }
}

export interface IProjectIssueResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    reportId: number;
    impact?: string | undefined;
    solution?: string | undefined;
    resolution?: string | undefined;
}

export class ProjectIssueResponseItemsResponseModel implements IProjectIssueResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectIssueResponse[] | undefined;

    constructor(data?: IProjectIssueResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectIssueResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectIssueResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectIssueResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectIssueResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectIssueResponse[] | undefined;
}

export class ProjectIssueResponseSimpleResponseModel implements IProjectIssueResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectIssueResponse;

    constructor(data?: IProjectIssueResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectIssueResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectIssueResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectIssueResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectIssueResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectIssueResponse;
}

export class ProjectMilestoneResponse implements IProjectMilestoneResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    reportId!: number;
    visibleId?: number | undefined;
    isGenerated!: boolean;
    wbs!: string;
    duration?: number | undefined;
    complete?: number | undefined;
    start?: Date | undefined;
    finish?: Date | undefined;
    achievedDate?: Date | undefined;
    milestoneDeviation?: string | undefined;

    constructor(data?: IProjectMilestoneResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.reportId = _data["reportId"];
            this.visibleId = _data["visibleId"];
            this.isGenerated = _data["isGenerated"];
            this.wbs = _data["wbs"];
            this.duration = _data["duration"];
            this.complete = _data["complete"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.finish = _data["finish"] ? new Date(_data["finish"].toString()) : undefined as any;
            this.achievedDate = _data["achievedDate"] ? new Date(_data["achievedDate"].toString()) : undefined as any;
            this.milestoneDeviation = _data["milestoneDeviation"];
        }
    }

    static fromJS(data: any): ProjectMilestoneResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectMilestoneResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["reportId"] = this.reportId;
        data["visibleId"] = this.visibleId;
        data["isGenerated"] = this.isGenerated;
        data["wbs"] = this.wbs;
        data["duration"] = this.duration;
        data["complete"] = this.complete;
        data["start"] = this.start ? formatDate(this.start) : undefined as any;
        data["finish"] = this.finish ? formatDate(this.finish) : undefined as any;
        data["achievedDate"] = this.achievedDate ? formatDate(this.achievedDate) : undefined as any;
        data["milestoneDeviation"] = this.milestoneDeviation;
        return data;
    }
}

export interface IProjectMilestoneResponse {
    id: number;
    name: string;
    description?: string | undefined;
    reportId: number;
    visibleId?: number | undefined;
    isGenerated: boolean;
    wbs: string;
    duration?: number | undefined;
    complete?: number | undefined;
    start?: Date | undefined;
    finish?: Date | undefined;
    achievedDate?: Date | undefined;
    milestoneDeviation?: string | undefined;
}

export class ProjectMilestoneResponseItemsResponseModel implements IProjectMilestoneResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectMilestoneResponse[] | undefined;

    constructor(data?: IProjectMilestoneResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectMilestoneResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectMilestoneResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectMilestoneResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectMilestoneResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectMilestoneResponse[] | undefined;
}

export class ProjectMilestoneResponseSimpleResponseModel implements IProjectMilestoneResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectMilestoneResponse;

    constructor(data?: IProjectMilestoneResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectMilestoneResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectMilestoneResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectMilestoneResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectMilestoneResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectMilestoneResponse;
}

export class ProjectQualityResponse implements IProjectQualityResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    reportId!: number;
    visibleId?: number | undefined;
    isGenerated!: boolean;
    wbs!: string;
    finish?: Date | undefined;
    achievedData?: Date | undefined;
    actions?: string | undefined;
    status!: ReportItemStatusEnum;

    constructor(data?: IProjectQualityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.reportId = _data["reportId"];
            this.visibleId = _data["visibleId"];
            this.isGenerated = _data["isGenerated"];
            this.wbs = _data["wbs"];
            this.finish = _data["finish"] ? new Date(_data["finish"].toString()) : undefined as any;
            this.achievedData = _data["achievedData"] ? new Date(_data["achievedData"].toString()) : undefined as any;
            this.actions = _data["actions"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProjectQualityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectQualityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["reportId"] = this.reportId;
        data["visibleId"] = this.visibleId;
        data["isGenerated"] = this.isGenerated;
        data["wbs"] = this.wbs;
        data["finish"] = this.finish ? formatDate(this.finish) : undefined as any;
        data["achievedData"] = this.achievedData ? formatDate(this.achievedData) : undefined as any;
        data["actions"] = this.actions;
        data["status"] = this.status;
        return data;
    }
}

export interface IProjectQualityResponse {
    id: number;
    name: string;
    description?: string | undefined;
    reportId: number;
    visibleId?: number | undefined;
    isGenerated: boolean;
    wbs: string;
    finish?: Date | undefined;
    achievedData?: Date | undefined;
    actions?: string | undefined;
    status: ReportItemStatusEnum;
}

export class ProjectQualityResponseItemsResponseModel implements IProjectQualityResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectQualityResponse[] | undefined;

    constructor(data?: IProjectQualityResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectQualityResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectQualityResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectQualityResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectQualityResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectQualityResponse[] | undefined;
}

export class ProjectQualityResponseSimpleResponseModel implements IProjectQualityResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectQualityResponse;

    constructor(data?: IProjectQualityResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectQualityResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectQualityResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectQualityResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectQualityResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectQualityResponse;
}

export class ProjectReportAreaRequest implements IProjectReportAreaRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    isActive!: boolean;
    status!: ReportStatusAreaEnum;

    constructor(data?: IProjectReportAreaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProjectReportAreaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectReportAreaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["status"] = this.status;
        return data;
    }
}

export interface IProjectReportAreaRequest {
    name: string;
    description?: string | undefined;
    id: number;
    isActive: boolean;
    status: ReportStatusAreaEnum;
}

export class ProjectReportAreaResponse implements IProjectReportAreaResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    status!: ReportStatusAreaEnum;
    order!: number;

    constructor(data?: IProjectReportAreaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.status = _data["status"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): ProjectReportAreaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectReportAreaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["status"] = this.status;
        data["order"] = this.order;
        return data;
    }
}

export interface IProjectReportAreaResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    status: ReportStatusAreaEnum;
    order: number;
}

export class ProjectReportResponse implements IProjectReportResponse {
    id!: number;
    projectId!: number;
    from!: Date;
    to!: Date;
    projectFrom?: Date | undefined;
    projectTo?: Date | undefined;
    statusId!: number;
    relationshipStatus?: string | undefined;
    staffing?: string | undefined;
    areaStatuses!: ProjectReportAreaResponse[];

    constructor(data?: IProjectReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.areaStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.projectFrom = _data["projectFrom"] ? new Date(_data["projectFrom"].toString()) : undefined as any;
            this.projectTo = _data["projectTo"] ? new Date(_data["projectTo"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.relationshipStatus = _data["relationshipStatus"];
            this.staffing = _data["staffing"];
            if (Array.isArray(_data["areaStatuses"])) {
                this.areaStatuses = [] as any;
                for (let item of _data["areaStatuses"])
                    this.areaStatuses!.push(ProjectReportAreaResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["projectFrom"] = this.projectFrom ? formatDate(this.projectFrom) : undefined as any;
        data["projectTo"] = this.projectTo ? formatDate(this.projectTo) : undefined as any;
        data["statusId"] = this.statusId;
        data["relationshipStatus"] = this.relationshipStatus;
        data["staffing"] = this.staffing;
        if (Array.isArray(this.areaStatuses)) {
            data["areaStatuses"] = [];
            for (let item of this.areaStatuses)
                data["areaStatuses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectReportResponse {
    id: number;
    projectId: number;
    from: Date;
    to: Date;
    projectFrom?: Date | undefined;
    projectTo?: Date | undefined;
    statusId: number;
    relationshipStatus?: string | undefined;
    staffing?: string | undefined;
    areaStatuses: ProjectReportAreaResponse[];
}

export class ProjectReportResponseItemsResponseModel implements IProjectReportResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectReportResponse[] | undefined;

    constructor(data?: IProjectReportResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectReportResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectReportResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectReportResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectReportResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectReportResponse[] | undefined;
}

export class ProjectReportResponseSimpleResponseModel implements IProjectReportResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectReportResponse;

    constructor(data?: IProjectReportResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectReportResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectReportResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectReportResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectReportResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectReportResponse;
}

export enum ProjectReportStatusEnum {
    Created = "Created",
    Released = "Released",
}

export class ProjectResponse implements IProjectResponse {
    id!: number;
    name!: string;
    statusId!: number;
    pmId!: number;
    typeId?: number | undefined;
    categoryId?: number | undefined;
    organizationalUnitId?: number | undefined;
    supportOrganizationId?: number | undefined;
    isOrganizationalUnitManager!: boolean;
    description?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    partnerId?: number | undefined;
    archaived!: boolean;
    activeModules?: ActiveModule[] | undefined;
    roleId?: TokenTypeEnum;
    permissions?: PermissionCollectionResponse;
    attachments?: AttachmentResponse[] | undefined;

    constructor(data?: IProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.statusId = _data["statusId"];
            this.pmId = _data["pmId"];
            this.typeId = _data["typeId"];
            this.categoryId = _data["categoryId"];
            this.organizationalUnitId = _data["organizationalUnitId"];
            this.supportOrganizationId = _data["supportOrganizationId"];
            this.isOrganizationalUnitManager = _data["isOrganizationalUnitManager"];
            this.description = _data["description"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.partnerId = _data["partnerId"];
            this.archaived = _data["archaived"];
            if (Array.isArray(_data["activeModules"])) {
                this.activeModules = [] as any;
                for (let item of _data["activeModules"])
                    this.activeModules!.push(ActiveModule.fromJS(item));
            }
            this.roleId = _data["roleId"];
            this.permissions = _data["permissions"] ? PermissionCollectionResponse.fromJS(_data["permissions"]) : undefined as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["statusId"] = this.statusId;
        data["pmId"] = this.pmId;
        data["typeId"] = this.typeId;
        data["categoryId"] = this.categoryId;
        data["organizationalUnitId"] = this.organizationalUnitId;
        data["supportOrganizationId"] = this.supportOrganizationId;
        data["isOrganizationalUnitManager"] = this.isOrganizationalUnitManager;
        data["description"] = this.description;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["partnerId"] = this.partnerId;
        data["archaived"] = this.archaived;
        if (Array.isArray(this.activeModules)) {
            data["activeModules"] = [];
            for (let item of this.activeModules)
                data["activeModules"].push(item ? item.toJSON() : undefined as any);
        }
        data["roleId"] = this.roleId;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : undefined as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectResponse {
    id: number;
    name: string;
    statusId: number;
    pmId: number;
    typeId?: number | undefined;
    categoryId?: number | undefined;
    organizationalUnitId?: number | undefined;
    supportOrganizationId?: number | undefined;
    isOrganizationalUnitManager: boolean;
    description?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    partnerId?: number | undefined;
    archaived: boolean;
    activeModules?: ActiveModule[] | undefined;
    roleId?: TokenTypeEnum;
    permissions?: PermissionCollectionResponse;
    attachments?: AttachmentResponse[] | undefined;
}

export class ProjectResponseItemsResponseModel implements IProjectResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectResponse[] | undefined;

    constructor(data?: IProjectResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectResponse[] | undefined;
}

export class ProjectResponseSimpleResponseModel implements IProjectResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectResponse;

    constructor(data?: IProjectResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectResponse;
}

export class ProjectRiskCountsResponse implements IProjectRiskCountsResponse {
    grossImpactSum!: number;
    netImpactSum!: number;
    mitigationCostSum!: number;
    grossImpactAfterMitigationSum!: number;
    netImpactAfterMitigationSum!: number;
    costBenefitSum!: number;
    riskInclusionSum!: number;

    constructor(data?: IProjectRiskCountsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grossImpactSum = _data["grossImpactSum"];
            this.netImpactSum = _data["netImpactSum"];
            this.mitigationCostSum = _data["mitigationCostSum"];
            this.grossImpactAfterMitigationSum = _data["grossImpactAfterMitigationSum"];
            this.netImpactAfterMitigationSum = _data["netImpactAfterMitigationSum"];
            this.costBenefitSum = _data["costBenefitSum"];
            this.riskInclusionSum = _data["riskInclusionSum"];
        }
    }

    static fromJS(data: any): ProjectRiskCountsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectRiskCountsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grossImpactSum"] = this.grossImpactSum;
        data["netImpactSum"] = this.netImpactSum;
        data["mitigationCostSum"] = this.mitigationCostSum;
        data["grossImpactAfterMitigationSum"] = this.grossImpactAfterMitigationSum;
        data["netImpactAfterMitigationSum"] = this.netImpactAfterMitigationSum;
        data["costBenefitSum"] = this.costBenefitSum;
        data["riskInclusionSum"] = this.riskInclusionSum;
        return data;
    }
}

export interface IProjectRiskCountsResponse {
    grossImpactSum: number;
    netImpactSum: number;
    mitigationCostSum: number;
    grossImpactAfterMitigationSum: number;
    netImpactAfterMitigationSum: number;
    costBenefitSum: number;
    riskInclusionSum: number;
}

export class ProjectRiskCountsResponseSimpleResponseModel implements IProjectRiskCountsResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectRiskCountsResponse;

    constructor(data?: IProjectRiskCountsResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectRiskCountsResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectRiskCountsResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectRiskCountsResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectRiskCountsResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectRiskCountsResponse;
}

export class ProjectRiskResponse implements IProjectRiskResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    visibleId!: number;
    reportId!: number;
    isGenerated!: boolean;
    consequneces?: string | undefined;
    effects?: string | undefined;
    grossImpact?: number | undefined;
    probability?: number | undefined;
    mitigation!: string;
    mitigationType!: MitigationTypeEnum;
    grossImpactAfterMitigation?: number | undefined;
    probabilityAfterMitigation?: number | undefined;
    responsibleUserId?: number | undefined;
    statusId!: number;
    dueDate?: Date | undefined;
    costOfMitigation?: number | undefined;

    constructor(data?: IProjectRiskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.visibleId = _data["visibleId"];
            this.reportId = _data["reportId"];
            this.isGenerated = _data["isGenerated"];
            this.consequneces = _data["consequneces"];
            this.effects = _data["effects"];
            this.grossImpact = _data["grossImpact"];
            this.probability = _data["probability"];
            this.mitigation = _data["mitigation"];
            this.mitigationType = _data["mitigationType"];
            this.grossImpactAfterMitigation = _data["grossImpactAfterMitigation"];
            this.probabilityAfterMitigation = _data["probabilityAfterMitigation"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.statusId = _data["statusId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.costOfMitigation = _data["costOfMitigation"];
        }
    }

    static fromJS(data: any): ProjectRiskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectRiskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["visibleId"] = this.visibleId;
        data["reportId"] = this.reportId;
        data["isGenerated"] = this.isGenerated;
        data["consequneces"] = this.consequneces;
        data["effects"] = this.effects;
        data["grossImpact"] = this.grossImpact;
        data["probability"] = this.probability;
        data["mitigation"] = this.mitigation;
        data["mitigationType"] = this.mitigationType;
        data["grossImpactAfterMitigation"] = this.grossImpactAfterMitigation;
        data["probabilityAfterMitigation"] = this.probabilityAfterMitigation;
        data["responsibleUserId"] = this.responsibleUserId;
        data["statusId"] = this.statusId;
        data["dueDate"] = this.dueDate ? formatDate(this.dueDate) : undefined as any;
        data["costOfMitigation"] = this.costOfMitigation;
        return data;
    }
}

export interface IProjectRiskResponse {
    id: number;
    name: string;
    description?: string | undefined;
    visibleId: number;
    reportId: number;
    isGenerated: boolean;
    consequneces?: string | undefined;
    effects?: string | undefined;
    grossImpact?: number | undefined;
    probability?: number | undefined;
    mitigation: string;
    mitigationType: MitigationTypeEnum;
    grossImpactAfterMitigation?: number | undefined;
    probabilityAfterMitigation?: number | undefined;
    responsibleUserId?: number | undefined;
    statusId: number;
    dueDate?: Date | undefined;
    costOfMitigation?: number | undefined;
}

export class ProjectRiskResponseItemsResponseModel implements IProjectRiskResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectRiskResponse[] | undefined;

    constructor(data?: IProjectRiskResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectRiskResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectRiskResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectRiskResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectRiskResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectRiskResponse[] | undefined;
}

export class ProjectRiskResponseSimpleResponseModel implements IProjectRiskResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectRiskResponse;

    constructor(data?: IProjectRiskResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectRiskResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectRiskResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectRiskResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectRiskResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectRiskResponse;
}

export class ProjectSLAResponse implements IProjectSLAResponse {
    projectId!: number;
    isActive!: boolean;
    supportOrganizationId?: number | undefined;
    closingStatus!: TicketStatusEnum;
    resolutionTimeCalculationStatus!: TicketStatusEnum;
    resolutionTimeBasedOn!: ResolutionTimeBasedOnEnum;
    excludeOnHoldTime!: boolean;
    timeMeasure!: TimeMeasureEnum;
    workWeekFrom!: WeekDayEnum;
    workWeekTo!: WeekDayEnum;
    workTimeFrom!: number;
    workTimeTo!: number;
    responseTimes!: ResponseTimeResponse[];

    constructor(data?: IProjectSLAResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.responseTimes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.isActive = _data["isActive"];
            this.supportOrganizationId = _data["supportOrganizationId"];
            this.closingStatus = _data["closingStatus"];
            this.resolutionTimeCalculationStatus = _data["resolutionTimeCalculationStatus"];
            this.resolutionTimeBasedOn = _data["resolutionTimeBasedOn"];
            this.excludeOnHoldTime = _data["excludeOnHoldTime"];
            this.timeMeasure = _data["timeMeasure"];
            this.workWeekFrom = _data["workWeekFrom"];
            this.workWeekTo = _data["workWeekTo"];
            this.workTimeFrom = _data["workTimeFrom"];
            this.workTimeTo = _data["workTimeTo"];
            if (Array.isArray(_data["responseTimes"])) {
                this.responseTimes = [] as any;
                for (let item of _data["responseTimes"])
                    this.responseTimes!.push(ResponseTimeResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectSLAResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSLAResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["isActive"] = this.isActive;
        data["supportOrganizationId"] = this.supportOrganizationId;
        data["closingStatus"] = this.closingStatus;
        data["resolutionTimeCalculationStatus"] = this.resolutionTimeCalculationStatus;
        data["resolutionTimeBasedOn"] = this.resolutionTimeBasedOn;
        data["excludeOnHoldTime"] = this.excludeOnHoldTime;
        data["timeMeasure"] = this.timeMeasure;
        data["workWeekFrom"] = this.workWeekFrom;
        data["workWeekTo"] = this.workWeekTo;
        data["workTimeFrom"] = this.workTimeFrom;
        data["workTimeTo"] = this.workTimeTo;
        if (Array.isArray(this.responseTimes)) {
            data["responseTimes"] = [];
            for (let item of this.responseTimes)
                data["responseTimes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectSLAResponse {
    projectId: number;
    isActive: boolean;
    supportOrganizationId?: number | undefined;
    closingStatus: TicketStatusEnum;
    resolutionTimeCalculationStatus: TicketStatusEnum;
    resolutionTimeBasedOn: ResolutionTimeBasedOnEnum;
    excludeOnHoldTime: boolean;
    timeMeasure: TimeMeasureEnum;
    workWeekFrom: WeekDayEnum;
    workWeekTo: WeekDayEnum;
    workTimeFrom: number;
    workTimeTo: number;
    responseTimes: ResponseTimeResponse[];
}

export class ProjectSLAResponseSimpleResponseModel implements IProjectSLAResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectSLAResponse;

    constructor(data?: IProjectSLAResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectSLAResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectSLAResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSLAResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectSLAResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectSLAResponse;
}

export enum ProjectStatusEnum {
    Planning = "Planning",
    Released = "Released",
    Completed = "Completed",
    Archived = "Archived",
}

export class ProjectStatusResponse implements IProjectStatusResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isReadonly!: boolean;
    color!: string;
    isInitial!: boolean;
    nextStates?: number[] | undefined;
    order!: number;
    semantics!: ProjectStatusEnum;

    constructor(data?: IProjectStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isReadonly = _data["isReadonly"];
            this.color = _data["color"];
            this.isInitial = _data["isInitial"];
            if (Array.isArray(_data["nextStates"])) {
                this.nextStates = [] as any;
                for (let item of _data["nextStates"])
                    this.nextStates!.push(item);
            }
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): ProjectStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isReadonly"] = this.isReadonly;
        data["color"] = this.color;
        data["isInitial"] = this.isInitial;
        if (Array.isArray(this.nextStates)) {
            data["nextStates"] = [];
            for (let item of this.nextStates)
                data["nextStates"].push(item);
        }
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IProjectStatusResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isReadonly: boolean;
    color: string;
    isInitial: boolean;
    nextStates?: number[] | undefined;
    order: number;
    semantics: ProjectStatusEnum;
}

export class ProjectStatusResponseItemsResponseModel implements IProjectStatusResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectStatusResponse[] | undefined;

    constructor(data?: IProjectStatusResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectStatusResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStatusResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectStatusResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectStatusResponse[] | undefined;
}

export class ProjectSubcontractorResponse implements IProjectSubcontractorResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    reportId!: number;
    deliverable!: string;
    status!: ReportItemStatusEnum;
    issue!: string;
    solution?: string | undefined;
    resolution?: string | undefined;
    achievedDate?: Date | undefined;

    constructor(data?: IProjectSubcontractorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.reportId = _data["reportId"];
            this.deliverable = _data["deliverable"];
            this.status = _data["status"];
            this.issue = _data["issue"];
            this.solution = _data["solution"];
            this.resolution = _data["resolution"];
            this.achievedDate = _data["achievedDate"] ? new Date(_data["achievedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectSubcontractorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSubcontractorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["reportId"] = this.reportId;
        data["deliverable"] = this.deliverable;
        data["status"] = this.status;
        data["issue"] = this.issue;
        data["solution"] = this.solution;
        data["resolution"] = this.resolution;
        data["achievedDate"] = this.achievedDate ? formatDate(this.achievedDate) : undefined as any;
        return data;
    }
}

export interface IProjectSubcontractorResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    reportId: number;
    deliverable: string;
    status: ReportItemStatusEnum;
    issue: string;
    solution?: string | undefined;
    resolution?: string | undefined;
    achievedDate?: Date | undefined;
}

export class ProjectSubcontractorResponseItemsResponseModel implements IProjectSubcontractorResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectSubcontractorResponse[] | undefined;

    constructor(data?: IProjectSubcontractorResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectSubcontractorResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectSubcontractorResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSubcontractorResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectSubcontractorResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectSubcontractorResponse[] | undefined;
}

export class ProjectSubcontractorResponseSimpleResponseModel implements IProjectSubcontractorResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectSubcontractorResponse;

    constructor(data?: IProjectSubcontractorResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectSubcontractorResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectSubcontractorResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSubcontractorResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectSubcontractorResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectSubcontractorResponse;
}

export class ProjectTeamDeltaRequest implements IProjectTeamDeltaRequest {
    insert?: InsertProjectTeamRequest[] | undefined;
    update?: UpdateProjectTeamRequest[] | undefined;
    delete?: DeleteProjectIdentifyRequest[] | undefined;

    constructor(data?: IProjectTeamDeltaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertProjectTeamRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateProjectTeamRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteProjectIdentifyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectTeamDeltaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTeamDeltaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTeamDeltaRequest {
    insert?: InsertProjectTeamRequest[] | undefined;
    update?: UpdateProjectTeamRequest[] | undefined;
    delete?: DeleteProjectIdentifyRequest[] | undefined;
}

export class ProjectTeamMemberResponse implements IProjectTeamMemberResponse {
    id!: number;
    projectId!: number;
    userId!: number;
    roleId!: TokenTypeEnum;
    projectRoleId?: number | undefined;
    projectTeamId?: number | undefined;
    statusId!: number;
    validUntil?: Date | undefined;
    isActive!: boolean;
    permissions?: PermissionCollectionResponse;
    validityPeriods?: ProjectTeamMemberValidityPeriodResponse[] | undefined;
    readonly isPm!: boolean;
    readonly isSubstitutePm!: boolean;
    readonly isPmOrSubstitutePm!: boolean;
    currentValidityPeriod?: ProjectTeamMemberValidityPeriodResponse;
    readonly rateValidFrom?: Date | undefined;
    readonly rateValidTo?: Date | undefined;
    readonly lastSalesRate?: number | undefined;
    readonly lastCostRate?: number | undefined;
    projectRoleName?: string | undefined;
    projectTeamName?: string | undefined;

    constructor(data?: IProjectTeamMemberResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.projectRoleId = _data["projectRoleId"];
            this.projectTeamId = _data["projectTeamId"];
            this.statusId = _data["statusId"];
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.permissions = _data["permissions"] ? PermissionCollectionResponse.fromJS(_data["permissions"]) : undefined as any;
            if (Array.isArray(_data["validityPeriods"])) {
                this.validityPeriods = [] as any;
                for (let item of _data["validityPeriods"])
                    this.validityPeriods!.push(ProjectTeamMemberValidityPeriodResponse.fromJS(item));
            }
            (this as any).isPm = _data["isPm"];
            (this as any).isSubstitutePm = _data["isSubstitutePm"];
            (this as any).isPmOrSubstitutePm = _data["isPmOrSubstitutePm"];
            this.currentValidityPeriod = _data["currentValidityPeriod"] ? ProjectTeamMemberValidityPeriodResponse.fromJS(_data["currentValidityPeriod"]) : undefined as any;
            (this as any).rateValidFrom = _data["rateValidFrom"] ? new Date(_data["rateValidFrom"].toString()) : undefined as any;
            (this as any).rateValidTo = _data["rateValidTo"] ? new Date(_data["rateValidTo"].toString()) : undefined as any;
            (this as any).lastSalesRate = _data["lastSalesRate"];
            (this as any).lastCostRate = _data["lastCostRate"];
            this.projectRoleName = _data["projectRoleName"];
            this.projectTeamName = _data["projectTeamName"];
        }
    }

    static fromJS(data: any): ProjectTeamMemberResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTeamMemberResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["projectRoleId"] = this.projectRoleId;
        data["projectTeamId"] = this.projectTeamId;
        data["statusId"] = this.statusId;
        data["validUntil"] = this.validUntil ? formatDate(this.validUntil) : undefined as any;
        data["isActive"] = this.isActive;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : undefined as any;
        if (Array.isArray(this.validityPeriods)) {
            data["validityPeriods"] = [];
            for (let item of this.validityPeriods)
                data["validityPeriods"].push(item ? item.toJSON() : undefined as any);
        }
        data["isPm"] = this.isPm;
        data["isSubstitutePm"] = this.isSubstitutePm;
        data["isPmOrSubstitutePm"] = this.isPmOrSubstitutePm;
        data["currentValidityPeriod"] = this.currentValidityPeriod ? this.currentValidityPeriod.toJSON() : undefined as any;
        data["rateValidFrom"] = this.rateValidFrom ? formatDate(this.rateValidFrom) : undefined as any;
        data["rateValidTo"] = this.rateValidTo ? formatDate(this.rateValidTo) : undefined as any;
        data["lastSalesRate"] = this.lastSalesRate;
        data["lastCostRate"] = this.lastCostRate;
        data["projectRoleName"] = this.projectRoleName;
        data["projectTeamName"] = this.projectTeamName;
        return data;
    }
}

export interface IProjectTeamMemberResponse {
    id: number;
    projectId: number;
    userId: number;
    roleId: TokenTypeEnum;
    projectRoleId?: number | undefined;
    projectTeamId?: number | undefined;
    statusId: number;
    validUntil?: Date | undefined;
    isActive: boolean;
    permissions?: PermissionCollectionResponse;
    validityPeriods?: ProjectTeamMemberValidityPeriodResponse[] | undefined;
    isPm: boolean;
    isSubstitutePm: boolean;
    isPmOrSubstitutePm: boolean;
    currentValidityPeriod?: ProjectTeamMemberValidityPeriodResponse;
    rateValidFrom?: Date | undefined;
    rateValidTo?: Date | undefined;
    lastSalesRate?: number | undefined;
    lastCostRate?: number | undefined;
    projectRoleName?: string | undefined;
    projectTeamName?: string | undefined;
}

export class ProjectTeamMemberResponseItemsResponseModel implements IProjectTeamMemberResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectTeamMemberResponse[] | undefined;

    constructor(data?: IProjectTeamMemberResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectTeamMemberResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectTeamMemberResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTeamMemberResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTeamMemberResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectTeamMemberResponse[] | undefined;
}

export class ProjectTeamMemberResponseSimpleResponseModel implements IProjectTeamMemberResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectTeamMemberResponse;

    constructor(data?: IProjectTeamMemberResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectTeamMemberResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectTeamMemberResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTeamMemberResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectTeamMemberResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectTeamMemberResponse;
}

export class ProjectTeamMemberUserResponse implements IProjectTeamMemberUserResponse {
    id!: number;
    projectId!: number;
    userId!: number;
    roleId!: TokenTypeEnum;
    projectRoleId?: number | undefined;
    projectTeamId?: number | undefined;
    statusId!: number;
    validUntil?: Date | undefined;
    isActive!: boolean;
    permissions?: PermissionCollectionResponse;
    validityPeriods?: ProjectTeamMemberValidityPeriodResponse[] | undefined;
    readonly isPm!: boolean;
    readonly isSubstitutePm!: boolean;
    readonly isPmOrSubstitutePm!: boolean;
    currentValidityPeriod?: ProjectTeamMemberValidityPeriodResponse;
    readonly rateValidFrom?: Date | undefined;
    readonly rateValidTo?: Date | undefined;
    readonly lastSalesRate?: number | undefined;
    readonly lastCostRate?: number | undefined;
    projectRoleName?: string | undefined;
    projectTeamName?: string | undefined;
    firstName!: string;
    lastName!: string;
    email!: string;
    birthDate?: Date | undefined;
    officePhone?: string | undefined;
    mobilePhone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    department?: string | undefined;
    username!: string;
    countryId?: number | undefined;
    partnerId?: number | undefined;
    organizationalUnitId?: number | undefined;
    readonly isGuest!: boolean;
    readonly fullName?: string | undefined;

    constructor(data?: IProjectTeamMemberUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
            this.projectRoleId = _data["projectRoleId"];
            this.projectTeamId = _data["projectTeamId"];
            this.statusId = _data["statusId"];
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : undefined as any;
            this.isActive = _data["isActive"];
            this.permissions = _data["permissions"] ? PermissionCollectionResponse.fromJS(_data["permissions"]) : undefined as any;
            if (Array.isArray(_data["validityPeriods"])) {
                this.validityPeriods = [] as any;
                for (let item of _data["validityPeriods"])
                    this.validityPeriods!.push(ProjectTeamMemberValidityPeriodResponse.fromJS(item));
            }
            (this as any).isPm = _data["isPm"];
            (this as any).isSubstitutePm = _data["isSubstitutePm"];
            (this as any).isPmOrSubstitutePm = _data["isPmOrSubstitutePm"];
            this.currentValidityPeriod = _data["currentValidityPeriod"] ? ProjectTeamMemberValidityPeriodResponse.fromJS(_data["currentValidityPeriod"]) : undefined as any;
            (this as any).rateValidFrom = _data["rateValidFrom"] ? new Date(_data["rateValidFrom"].toString()) : undefined as any;
            (this as any).rateValidTo = _data["rateValidTo"] ? new Date(_data["rateValidTo"].toString()) : undefined as any;
            (this as any).lastSalesRate = _data["lastSalesRate"];
            (this as any).lastCostRate = _data["lastCostRate"];
            this.projectRoleName = _data["projectRoleName"];
            this.projectTeamName = _data["projectTeamName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined as any;
            this.officePhone = _data["officePhone"];
            this.mobilePhone = _data["mobilePhone"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.department = _data["department"];
            this.username = _data["username"];
            this.countryId = _data["countryId"];
            this.partnerId = _data["partnerId"];
            this.organizationalUnitId = _data["organizationalUnitId"];
            (this as any).isGuest = _data["isGuest"];
            (this as any).fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): ProjectTeamMemberUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTeamMemberUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["projectRoleId"] = this.projectRoleId;
        data["projectTeamId"] = this.projectTeamId;
        data["statusId"] = this.statusId;
        data["validUntil"] = this.validUntil ? formatDate(this.validUntil) : undefined as any;
        data["isActive"] = this.isActive;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : undefined as any;
        if (Array.isArray(this.validityPeriods)) {
            data["validityPeriods"] = [];
            for (let item of this.validityPeriods)
                data["validityPeriods"].push(item ? item.toJSON() : undefined as any);
        }
        data["isPm"] = this.isPm;
        data["isSubstitutePm"] = this.isSubstitutePm;
        data["isPmOrSubstitutePm"] = this.isPmOrSubstitutePm;
        data["currentValidityPeriod"] = this.currentValidityPeriod ? this.currentValidityPeriod.toJSON() : undefined as any;
        data["rateValidFrom"] = this.rateValidFrom ? formatDate(this.rateValidFrom) : undefined as any;
        data["rateValidTo"] = this.rateValidTo ? formatDate(this.rateValidTo) : undefined as any;
        data["lastSalesRate"] = this.lastSalesRate;
        data["lastCostRate"] = this.lastCostRate;
        data["projectRoleName"] = this.projectRoleName;
        data["projectTeamName"] = this.projectTeamName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["officePhone"] = this.officePhone;
        data["mobilePhone"] = this.mobilePhone;
        data["address"] = this.address;
        data["city"] = this.city;
        data["department"] = this.department;
        data["username"] = this.username;
        data["countryId"] = this.countryId;
        data["partnerId"] = this.partnerId;
        data["organizationalUnitId"] = this.organizationalUnitId;
        data["isGuest"] = this.isGuest;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IProjectTeamMemberUserResponse {
    id: number;
    projectId: number;
    userId: number;
    roleId: TokenTypeEnum;
    projectRoleId?: number | undefined;
    projectTeamId?: number | undefined;
    statusId: number;
    validUntil?: Date | undefined;
    isActive: boolean;
    permissions?: PermissionCollectionResponse;
    validityPeriods?: ProjectTeamMemberValidityPeriodResponse[] | undefined;
    isPm: boolean;
    isSubstitutePm: boolean;
    isPmOrSubstitutePm: boolean;
    currentValidityPeriod?: ProjectTeamMemberValidityPeriodResponse;
    rateValidFrom?: Date | undefined;
    rateValidTo?: Date | undefined;
    lastSalesRate?: number | undefined;
    lastCostRate?: number | undefined;
    projectRoleName?: string | undefined;
    projectTeamName?: string | undefined;
    firstName: string;
    lastName: string;
    email: string;
    birthDate?: Date | undefined;
    officePhone?: string | undefined;
    mobilePhone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    department?: string | undefined;
    username: string;
    countryId?: number | undefined;
    partnerId?: number | undefined;
    organizationalUnitId?: number | undefined;
    isGuest: boolean;
    fullName?: string | undefined;
}

export class ProjectTeamMemberUserResponseItemsResponseModel implements IProjectTeamMemberUserResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectTeamMemberUserResponse[] | undefined;

    constructor(data?: IProjectTeamMemberUserResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectTeamMemberUserResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectTeamMemberUserResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTeamMemberUserResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTeamMemberUserResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectTeamMemberUserResponse[] | undefined;
}

export class ProjectTeamMemberValidityPeriodDeltaRequest implements IProjectTeamMemberValidityPeriodDeltaRequest {
    insert?: InsertProjectTeamMemberValidityPeriodRequest[] | undefined;
    update?: UpdateProjectTeamMemberValidityPeriodRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;

    constructor(data?: IProjectTeamMemberValidityPeriodDeltaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertProjectTeamMemberValidityPeriodRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateProjectTeamMemberValidityPeriodRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteTenantIndetifyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectTeamMemberValidityPeriodDeltaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTeamMemberValidityPeriodDeltaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTeamMemberValidityPeriodDeltaRequest {
    insert?: InsertProjectTeamMemberValidityPeriodRequest[] | undefined;
    update?: UpdateProjectTeamMemberValidityPeriodRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;
}

export class ProjectTeamMemberValidityPeriodResponse implements IProjectTeamMemberValidityPeriodResponse {
    id!: number;
    teamMemberId!: number;
    from!: Date;
    to!: Date;
    salesRate!: number;
    costRate!: number;

    constructor(data?: IProjectTeamMemberValidityPeriodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamMemberId = _data["teamMemberId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.salesRate = _data["salesRate"];
            this.costRate = _data["costRate"];
        }
    }

    static fromJS(data: any): ProjectTeamMemberValidityPeriodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTeamMemberValidityPeriodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamMemberId"] = this.teamMemberId;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["salesRate"] = this.salesRate;
        data["costRate"] = this.costRate;
        return data;
    }
}

export interface IProjectTeamMemberValidityPeriodResponse {
    id: number;
    teamMemberId: number;
    from: Date;
    to: Date;
    salesRate: number;
    costRate: number;
}

export class ProjectTeamMemberValidityPeriodResponseItemsResponseModel implements IProjectTeamMemberValidityPeriodResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectTeamMemberValidityPeriodResponse[] | undefined;

    constructor(data?: IProjectTeamMemberValidityPeriodResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectTeamMemberValidityPeriodResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectTeamMemberValidityPeriodResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTeamMemberValidityPeriodResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTeamMemberValidityPeriodResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectTeamMemberValidityPeriodResponse[] | undefined;
}

export class ProjectTeamProductivityDashboardResponse implements IProjectTeamProductivityDashboardResponse {
    hoursPerProject?: { [key: string]: number; } | undefined;
    hoursPerNonProjectCategory?: { [key: string]: number; } | undefined;
    hoursPerUserAndBillability?: { [key: string]: { [key: string]: number; }; } | undefined;
    hoursPerUserAndNotBillableNonProjectCategories?: { [key: string]: { [key: string]: number; }; } | undefined;
    hoursPerBillability?: { [key: string]: number; } | undefined;
    totalBillableTimesheetHours!: number;
    totalNonBillableTimesheetHours!: number;
    totalPotentialProductiveHours!: number;
    readonly totalNotProductiveHours!: number;
    totalTimesheetCostRate!: number;
    totalTimesheetBillingRate!: number;

    constructor(data?: IProjectTeamProductivityDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["hoursPerProject"]) {
                this.hoursPerProject = {} as any;
                for (let key in _data["hoursPerProject"]) {
                    if (_data["hoursPerProject"].hasOwnProperty(key))
                        (this.hoursPerProject as any)![key] = _data["hoursPerProject"][key];
                }
            }
            if (_data["hoursPerNonProjectCategory"]) {
                this.hoursPerNonProjectCategory = {} as any;
                for (let key in _data["hoursPerNonProjectCategory"]) {
                    if (_data["hoursPerNonProjectCategory"].hasOwnProperty(key))
                        (this.hoursPerNonProjectCategory as any)![key] = _data["hoursPerNonProjectCategory"][key];
                }
            }
            if (_data["hoursPerUserAndBillability"]) {
                this.hoursPerUserAndBillability = {} as any;
                for (let key in _data["hoursPerUserAndBillability"]) {
                    if (_data["hoursPerUserAndBillability"].hasOwnProperty(key))
                        (this.hoursPerUserAndBillability as any)![key] = _data["hoursPerUserAndBillability"][key] !== undefined ? _data["hoursPerUserAndBillability"][key] : {};
                }
            }
            if (_data["hoursPerUserAndNotBillableNonProjectCategories"]) {
                this.hoursPerUserAndNotBillableNonProjectCategories = {} as any;
                for (let key in _data["hoursPerUserAndNotBillableNonProjectCategories"]) {
                    if (_data["hoursPerUserAndNotBillableNonProjectCategories"].hasOwnProperty(key))
                        (this.hoursPerUserAndNotBillableNonProjectCategories as any)![key] = _data["hoursPerUserAndNotBillableNonProjectCategories"][key] !== undefined ? _data["hoursPerUserAndNotBillableNonProjectCategories"][key] : {};
                }
            }
            if (_data["hoursPerBillability"]) {
                this.hoursPerBillability = {} as any;
                for (let key in _data["hoursPerBillability"]) {
                    if (_data["hoursPerBillability"].hasOwnProperty(key))
                        (this.hoursPerBillability as any)![key] = _data["hoursPerBillability"][key];
                }
            }
            this.totalBillableTimesheetHours = _data["totalBillableTimesheetHours"];
            this.totalNonBillableTimesheetHours = _data["totalNonBillableTimesheetHours"];
            this.totalPotentialProductiveHours = _data["totalPotentialProductiveHours"];
            (this as any).totalNotProductiveHours = _data["totalNotProductiveHours"];
            this.totalTimesheetCostRate = _data["totalTimesheetCostRate"];
            this.totalTimesheetBillingRate = _data["totalTimesheetBillingRate"];
        }
    }

    static fromJS(data: any): ProjectTeamProductivityDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTeamProductivityDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.hoursPerProject) {
            data["hoursPerProject"] = {};
            for (let key in this.hoursPerProject) {
                if (this.hoursPerProject.hasOwnProperty(key))
                    (data["hoursPerProject"] as any)[key] = (this.hoursPerProject as any)[key];
            }
        }
        if (this.hoursPerNonProjectCategory) {
            data["hoursPerNonProjectCategory"] = {};
            for (let key in this.hoursPerNonProjectCategory) {
                if (this.hoursPerNonProjectCategory.hasOwnProperty(key))
                    (data["hoursPerNonProjectCategory"] as any)[key] = (this.hoursPerNonProjectCategory as any)[key];
            }
        }
        if (this.hoursPerUserAndBillability) {
            data["hoursPerUserAndBillability"] = {};
            for (let key in this.hoursPerUserAndBillability) {
                if (this.hoursPerUserAndBillability.hasOwnProperty(key))
                    (data["hoursPerUserAndBillability"] as any)[key] = (this.hoursPerUserAndBillability as any)[key];
            }
        }
        if (this.hoursPerUserAndNotBillableNonProjectCategories) {
            data["hoursPerUserAndNotBillableNonProjectCategories"] = {};
            for (let key in this.hoursPerUserAndNotBillableNonProjectCategories) {
                if (this.hoursPerUserAndNotBillableNonProjectCategories.hasOwnProperty(key))
                    (data["hoursPerUserAndNotBillableNonProjectCategories"] as any)[key] = (this.hoursPerUserAndNotBillableNonProjectCategories as any)[key];
            }
        }
        if (this.hoursPerBillability) {
            data["hoursPerBillability"] = {};
            for (let key in this.hoursPerBillability) {
                if (this.hoursPerBillability.hasOwnProperty(key))
                    (data["hoursPerBillability"] as any)[key] = (this.hoursPerBillability as any)[key];
            }
        }
        data["totalBillableTimesheetHours"] = this.totalBillableTimesheetHours;
        data["totalNonBillableTimesheetHours"] = this.totalNonBillableTimesheetHours;
        data["totalPotentialProductiveHours"] = this.totalPotentialProductiveHours;
        data["totalNotProductiveHours"] = this.totalNotProductiveHours;
        data["totalTimesheetCostRate"] = this.totalTimesheetCostRate;
        data["totalTimesheetBillingRate"] = this.totalTimesheetBillingRate;
        return data;
    }
}

export interface IProjectTeamProductivityDashboardResponse {
    hoursPerProject?: { [key: string]: number; } | undefined;
    hoursPerNonProjectCategory?: { [key: string]: number; } | undefined;
    hoursPerUserAndBillability?: { [key: string]: { [key: string]: number; }; } | undefined;
    hoursPerUserAndNotBillableNonProjectCategories?: { [key: string]: { [key: string]: number; }; } | undefined;
    hoursPerBillability?: { [key: string]: number; } | undefined;
    totalBillableTimesheetHours: number;
    totalNonBillableTimesheetHours: number;
    totalPotentialProductiveHours: number;
    totalNotProductiveHours: number;
    totalTimesheetCostRate: number;
    totalTimesheetBillingRate: number;
}

export class ProjectTeamResponse implements IProjectTeamResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    projectId!: number;
    salesRate?: number | undefined;
    costRate?: number | undefined;

    constructor(data?: IProjectTeamResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.projectId = _data["projectId"];
            this.salesRate = _data["salesRate"];
            this.costRate = _data["costRate"];
        }
    }

    static fromJS(data: any): ProjectTeamResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTeamResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["projectId"] = this.projectId;
        data["salesRate"] = this.salesRate;
        data["costRate"] = this.costRate;
        return data;
    }
}

export interface IProjectTeamResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    projectId: number;
    salesRate?: number | undefined;
    costRate?: number | undefined;
}

export class ProjectTeamResponseItemsResponseModel implements IProjectTeamResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectTeamResponse[] | undefined;

    constructor(data?: IProjectTeamResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectTeamResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectTeamResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTeamResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTeamResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ProjectTeamResponse[] | undefined;
}

export class ProjectTimesheetDashboardResponse implements IProjectTimesheetDashboardResponse {
    timesheetsPerStatusCounts?: { [key: string]: number; } | undefined;
    hoursPerPeriod?: { [key: string]: number; } | undefined;
    hourCostsPerPeriod?: { [key: string]: number; } | undefined;
    hourBillingsPerPeriod?: { [key: string]: number; } | undefined;
    hoursPerUserAndPeriod?: { [key: string]: { [key: string]: number; }; } | undefined;
    hourCostsPerUserAndPeriod?: { [key: string]: { [key: string]: number; }; } | undefined;
    hoursPerUserAndProject?: { [key: string]: { [key: string]: number; }; } | undefined;
    hourCostsPerUserAndProject?: { [key: string]: { [key: string]: number; }; } | undefined;
    hoursPerProject?: { [key: string]: number; } | undefined;
    hoursPerNonProjectCategory?: { [key: string]: number; } | undefined;
    totalTimesheetHours!: number;

    constructor(data?: IProjectTimesheetDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["timesheetsPerStatusCounts"]) {
                this.timesheetsPerStatusCounts = {} as any;
                for (let key in _data["timesheetsPerStatusCounts"]) {
                    if (_data["timesheetsPerStatusCounts"].hasOwnProperty(key))
                        (this.timesheetsPerStatusCounts as any)![key] = _data["timesheetsPerStatusCounts"][key];
                }
            }
            if (_data["hoursPerPeriod"]) {
                this.hoursPerPeriod = {} as any;
                for (let key in _data["hoursPerPeriod"]) {
                    if (_data["hoursPerPeriod"].hasOwnProperty(key))
                        (this.hoursPerPeriod as any)![key] = _data["hoursPerPeriod"][key];
                }
            }
            if (_data["hourCostsPerPeriod"]) {
                this.hourCostsPerPeriod = {} as any;
                for (let key in _data["hourCostsPerPeriod"]) {
                    if (_data["hourCostsPerPeriod"].hasOwnProperty(key))
                        (this.hourCostsPerPeriod as any)![key] = _data["hourCostsPerPeriod"][key];
                }
            }
            if (_data["hourBillingsPerPeriod"]) {
                this.hourBillingsPerPeriod = {} as any;
                for (let key in _data["hourBillingsPerPeriod"]) {
                    if (_data["hourBillingsPerPeriod"].hasOwnProperty(key))
                        (this.hourBillingsPerPeriod as any)![key] = _data["hourBillingsPerPeriod"][key];
                }
            }
            if (_data["hoursPerUserAndPeriod"]) {
                this.hoursPerUserAndPeriod = {} as any;
                for (let key in _data["hoursPerUserAndPeriod"]) {
                    if (_data["hoursPerUserAndPeriod"].hasOwnProperty(key))
                        (this.hoursPerUserAndPeriod as any)![key] = _data["hoursPerUserAndPeriod"][key] !== undefined ? _data["hoursPerUserAndPeriod"][key] : {};
                }
            }
            if (_data["hourCostsPerUserAndPeriod"]) {
                this.hourCostsPerUserAndPeriod = {} as any;
                for (let key in _data["hourCostsPerUserAndPeriod"]) {
                    if (_data["hourCostsPerUserAndPeriod"].hasOwnProperty(key))
                        (this.hourCostsPerUserAndPeriod as any)![key] = _data["hourCostsPerUserAndPeriod"][key] !== undefined ? _data["hourCostsPerUserAndPeriod"][key] : {};
                }
            }
            if (_data["hoursPerUserAndProject"]) {
                this.hoursPerUserAndProject = {} as any;
                for (let key in _data["hoursPerUserAndProject"]) {
                    if (_data["hoursPerUserAndProject"].hasOwnProperty(key))
                        (this.hoursPerUserAndProject as any)![key] = _data["hoursPerUserAndProject"][key] !== undefined ? _data["hoursPerUserAndProject"][key] : {};
                }
            }
            if (_data["hourCostsPerUserAndProject"]) {
                this.hourCostsPerUserAndProject = {} as any;
                for (let key in _data["hourCostsPerUserAndProject"]) {
                    if (_data["hourCostsPerUserAndProject"].hasOwnProperty(key))
                        (this.hourCostsPerUserAndProject as any)![key] = _data["hourCostsPerUserAndProject"][key] !== undefined ? _data["hourCostsPerUserAndProject"][key] : {};
                }
            }
            if (_data["hoursPerProject"]) {
                this.hoursPerProject = {} as any;
                for (let key in _data["hoursPerProject"]) {
                    if (_data["hoursPerProject"].hasOwnProperty(key))
                        (this.hoursPerProject as any)![key] = _data["hoursPerProject"][key];
                }
            }
            if (_data["hoursPerNonProjectCategory"]) {
                this.hoursPerNonProjectCategory = {} as any;
                for (let key in _data["hoursPerNonProjectCategory"]) {
                    if (_data["hoursPerNonProjectCategory"].hasOwnProperty(key))
                        (this.hoursPerNonProjectCategory as any)![key] = _data["hoursPerNonProjectCategory"][key];
                }
            }
            this.totalTimesheetHours = _data["totalTimesheetHours"];
        }
    }

    static fromJS(data: any): ProjectTimesheetDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTimesheetDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.timesheetsPerStatusCounts) {
            data["timesheetsPerStatusCounts"] = {};
            for (let key in this.timesheetsPerStatusCounts) {
                if (this.timesheetsPerStatusCounts.hasOwnProperty(key))
                    (data["timesheetsPerStatusCounts"] as any)[key] = (this.timesheetsPerStatusCounts as any)[key];
            }
        }
        if (this.hoursPerPeriod) {
            data["hoursPerPeriod"] = {};
            for (let key in this.hoursPerPeriod) {
                if (this.hoursPerPeriod.hasOwnProperty(key))
                    (data["hoursPerPeriod"] as any)[key] = (this.hoursPerPeriod as any)[key];
            }
        }
        if (this.hourCostsPerPeriod) {
            data["hourCostsPerPeriod"] = {};
            for (let key in this.hourCostsPerPeriod) {
                if (this.hourCostsPerPeriod.hasOwnProperty(key))
                    (data["hourCostsPerPeriod"] as any)[key] = (this.hourCostsPerPeriod as any)[key];
            }
        }
        if (this.hourBillingsPerPeriod) {
            data["hourBillingsPerPeriod"] = {};
            for (let key in this.hourBillingsPerPeriod) {
                if (this.hourBillingsPerPeriod.hasOwnProperty(key))
                    (data["hourBillingsPerPeriod"] as any)[key] = (this.hourBillingsPerPeriod as any)[key];
            }
        }
        if (this.hoursPerUserAndPeriod) {
            data["hoursPerUserAndPeriod"] = {};
            for (let key in this.hoursPerUserAndPeriod) {
                if (this.hoursPerUserAndPeriod.hasOwnProperty(key))
                    (data["hoursPerUserAndPeriod"] as any)[key] = (this.hoursPerUserAndPeriod as any)[key];
            }
        }
        if (this.hourCostsPerUserAndPeriod) {
            data["hourCostsPerUserAndPeriod"] = {};
            for (let key in this.hourCostsPerUserAndPeriod) {
                if (this.hourCostsPerUserAndPeriod.hasOwnProperty(key))
                    (data["hourCostsPerUserAndPeriod"] as any)[key] = (this.hourCostsPerUserAndPeriod as any)[key];
            }
        }
        if (this.hoursPerUserAndProject) {
            data["hoursPerUserAndProject"] = {};
            for (let key in this.hoursPerUserAndProject) {
                if (this.hoursPerUserAndProject.hasOwnProperty(key))
                    (data["hoursPerUserAndProject"] as any)[key] = (this.hoursPerUserAndProject as any)[key];
            }
        }
        if (this.hourCostsPerUserAndProject) {
            data["hourCostsPerUserAndProject"] = {};
            for (let key in this.hourCostsPerUserAndProject) {
                if (this.hourCostsPerUserAndProject.hasOwnProperty(key))
                    (data["hourCostsPerUserAndProject"] as any)[key] = (this.hourCostsPerUserAndProject as any)[key];
            }
        }
        if (this.hoursPerProject) {
            data["hoursPerProject"] = {};
            for (let key in this.hoursPerProject) {
                if (this.hoursPerProject.hasOwnProperty(key))
                    (data["hoursPerProject"] as any)[key] = (this.hoursPerProject as any)[key];
            }
        }
        if (this.hoursPerNonProjectCategory) {
            data["hoursPerNonProjectCategory"] = {};
            for (let key in this.hoursPerNonProjectCategory) {
                if (this.hoursPerNonProjectCategory.hasOwnProperty(key))
                    (data["hoursPerNonProjectCategory"] as any)[key] = (this.hoursPerNonProjectCategory as any)[key];
            }
        }
        data["totalTimesheetHours"] = this.totalTimesheetHours;
        return data;
    }
}

export interface IProjectTimesheetDashboardResponse {
    timesheetsPerStatusCounts?: { [key: string]: number; } | undefined;
    hoursPerPeriod?: { [key: string]: number; } | undefined;
    hourCostsPerPeriod?: { [key: string]: number; } | undefined;
    hourBillingsPerPeriod?: { [key: string]: number; } | undefined;
    hoursPerUserAndPeriod?: { [key: string]: { [key: string]: number; }; } | undefined;
    hourCostsPerUserAndPeriod?: { [key: string]: { [key: string]: number; }; } | undefined;
    hoursPerUserAndProject?: { [key: string]: { [key: string]: number; }; } | undefined;
    hourCostsPerUserAndProject?: { [key: string]: { [key: string]: number; }; } | undefined;
    hoursPerProject?: { [key: string]: number; } | undefined;
    hoursPerNonProjectCategory?: { [key: string]: number; } | undefined;
    totalTimesheetHours: number;
}

export class ProjectTimeTravelDashboardFilterRequest implements IProjectTimeTravelDashboardFilterRequest {
    dateRange!: DateRangeRequest;
    projectIds?: number[] | undefined;
    nonProjectCategoryIds?: number[] | undefined;
    userIds?: number[] | undefined;
    partnerIds?: number[] | undefined;
    organizationalUnitIds?: number[] | undefined;

    constructor(data?: IProjectTimeTravelDashboardFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dateRange = new DateRangeRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateRange = _data["dateRange"] ? DateRangeRequest.fromJS(_data["dateRange"]) : new DateRangeRequest();
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
            if (Array.isArray(_data["nonProjectCategoryIds"])) {
                this.nonProjectCategoryIds = [] as any;
                for (let item of _data["nonProjectCategoryIds"])
                    this.nonProjectCategoryIds!.push(item);
            }
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["partnerIds"])) {
                this.partnerIds = [] as any;
                for (let item of _data["partnerIds"])
                    this.partnerIds!.push(item);
            }
            if (Array.isArray(_data["organizationalUnitIds"])) {
                this.organizationalUnitIds = [] as any;
                for (let item of _data["organizationalUnitIds"])
                    this.organizationalUnitIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectTimeTravelDashboardFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTimeTravelDashboardFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : undefined as any;
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        if (Array.isArray(this.nonProjectCategoryIds)) {
            data["nonProjectCategoryIds"] = [];
            for (let item of this.nonProjectCategoryIds)
                data["nonProjectCategoryIds"].push(item);
        }
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.partnerIds)) {
            data["partnerIds"] = [];
            for (let item of this.partnerIds)
                data["partnerIds"].push(item);
        }
        if (Array.isArray(this.organizationalUnitIds)) {
            data["organizationalUnitIds"] = [];
            for (let item of this.organizationalUnitIds)
                data["organizationalUnitIds"].push(item);
        }
        return data;
    }
}

export interface IProjectTimeTravelDashboardFilterRequest {
    dateRange: DateRangeRequest;
    projectIds?: number[] | undefined;
    nonProjectCategoryIds?: number[] | undefined;
    userIds?: number[] | undefined;
    partnerIds?: number[] | undefined;
    organizationalUnitIds?: number[] | undefined;
}

export class ProjectTimeTravelDashboardResponse implements IProjectTimeTravelDashboardResponse {
    timesheets?: ProjectTimesheetDashboardResponse;
    travelRequests?: ProjectTravelRequestsDashboardResponse;
    travelExpenses?: ProjectTravelExpenseDashboardResponse;
    vacationRequests?: ProjectVacationRequestDashboardResponse;
    teamProductivity?: ProjectTeamProductivityDashboardResponse;

    constructor(data?: IProjectTimeTravelDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timesheets = _data["timesheets"] ? ProjectTimesheetDashboardResponse.fromJS(_data["timesheets"]) : undefined as any;
            this.travelRequests = _data["travelRequests"] ? ProjectTravelRequestsDashboardResponse.fromJS(_data["travelRequests"]) : undefined as any;
            this.travelExpenses = _data["travelExpenses"] ? ProjectTravelExpenseDashboardResponse.fromJS(_data["travelExpenses"]) : undefined as any;
            this.vacationRequests = _data["vacationRequests"] ? ProjectVacationRequestDashboardResponse.fromJS(_data["vacationRequests"]) : undefined as any;
            this.teamProductivity = _data["teamProductivity"] ? ProjectTeamProductivityDashboardResponse.fromJS(_data["teamProductivity"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectTimeTravelDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTimeTravelDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timesheets"] = this.timesheets ? this.timesheets.toJSON() : undefined as any;
        data["travelRequests"] = this.travelRequests ? this.travelRequests.toJSON() : undefined as any;
        data["travelExpenses"] = this.travelExpenses ? this.travelExpenses.toJSON() : undefined as any;
        data["vacationRequests"] = this.vacationRequests ? this.vacationRequests.toJSON() : undefined as any;
        data["teamProductivity"] = this.teamProductivity ? this.teamProductivity.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectTimeTravelDashboardResponse {
    timesheets?: ProjectTimesheetDashboardResponse;
    travelRequests?: ProjectTravelRequestsDashboardResponse;
    travelExpenses?: ProjectTravelExpenseDashboardResponse;
    vacationRequests?: ProjectVacationRequestDashboardResponse;
    teamProductivity?: ProjectTeamProductivityDashboardResponse;
}

export class ProjectTimeTravelDashboardResponseSimpleResponseModel implements IProjectTimeTravelDashboardResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectTimeTravelDashboardResponse;

    constructor(data?: IProjectTimeTravelDashboardResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ProjectTimeTravelDashboardResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectTimeTravelDashboardResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTimeTravelDashboardResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectTimeTravelDashboardResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ProjectTimeTravelDashboardResponse;
}

export class ProjectTravelExpenseDashboardResponse implements IProjectTravelExpenseDashboardResponse {
    travelExpensesPerStatusCounts?: { [key: string]: number; } | undefined;
    travelExpensesPerPeriod?: { [key: string]: number; } | undefined;
    travelExpenses?: TravelExpenseResponse[] | undefined;
    groupedTravelExpenses?: TravelExpenseResponse[] | undefined;

    constructor(data?: IProjectTravelExpenseDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["travelExpensesPerStatusCounts"]) {
                this.travelExpensesPerStatusCounts = {} as any;
                for (let key in _data["travelExpensesPerStatusCounts"]) {
                    if (_data["travelExpensesPerStatusCounts"].hasOwnProperty(key))
                        (this.travelExpensesPerStatusCounts as any)![key] = _data["travelExpensesPerStatusCounts"][key];
                }
            }
            if (_data["travelExpensesPerPeriod"]) {
                this.travelExpensesPerPeriod = {} as any;
                for (let key in _data["travelExpensesPerPeriod"]) {
                    if (_data["travelExpensesPerPeriod"].hasOwnProperty(key))
                        (this.travelExpensesPerPeriod as any)![key] = _data["travelExpensesPerPeriod"][key];
                }
            }
            if (Array.isArray(_data["travelExpenses"])) {
                this.travelExpenses = [] as any;
                for (let item of _data["travelExpenses"])
                    this.travelExpenses!.push(TravelExpenseResponse.fromJS(item));
            }
            if (Array.isArray(_data["groupedTravelExpenses"])) {
                this.groupedTravelExpenses = [] as any;
                for (let item of _data["groupedTravelExpenses"])
                    this.groupedTravelExpenses!.push(TravelExpenseResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectTravelExpenseDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTravelExpenseDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.travelExpensesPerStatusCounts) {
            data["travelExpensesPerStatusCounts"] = {};
            for (let key in this.travelExpensesPerStatusCounts) {
                if (this.travelExpensesPerStatusCounts.hasOwnProperty(key))
                    (data["travelExpensesPerStatusCounts"] as any)[key] = (this.travelExpensesPerStatusCounts as any)[key];
            }
        }
        if (this.travelExpensesPerPeriod) {
            data["travelExpensesPerPeriod"] = {};
            for (let key in this.travelExpensesPerPeriod) {
                if (this.travelExpensesPerPeriod.hasOwnProperty(key))
                    (data["travelExpensesPerPeriod"] as any)[key] = (this.travelExpensesPerPeriod as any)[key];
            }
        }
        if (Array.isArray(this.travelExpenses)) {
            data["travelExpenses"] = [];
            for (let item of this.travelExpenses)
                data["travelExpenses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.groupedTravelExpenses)) {
            data["groupedTravelExpenses"] = [];
            for (let item of this.groupedTravelExpenses)
                data["groupedTravelExpenses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTravelExpenseDashboardResponse {
    travelExpensesPerStatusCounts?: { [key: string]: number; } | undefined;
    travelExpensesPerPeriod?: { [key: string]: number; } | undefined;
    travelExpenses?: TravelExpenseResponse[] | undefined;
    groupedTravelExpenses?: TravelExpenseResponse[] | undefined;
}

export class ProjectTravelRequestsDashboardResponse implements IProjectTravelRequestsDashboardResponse {
    travelRequestsPerStatusCounts?: { [key: string]: number; } | undefined;

    constructor(data?: IProjectTravelRequestsDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["travelRequestsPerStatusCounts"]) {
                this.travelRequestsPerStatusCounts = {} as any;
                for (let key in _data["travelRequestsPerStatusCounts"]) {
                    if (_data["travelRequestsPerStatusCounts"].hasOwnProperty(key))
                        (this.travelRequestsPerStatusCounts as any)![key] = _data["travelRequestsPerStatusCounts"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProjectTravelRequestsDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTravelRequestsDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.travelRequestsPerStatusCounts) {
            data["travelRequestsPerStatusCounts"] = {};
            for (let key in this.travelRequestsPerStatusCounts) {
                if (this.travelRequestsPerStatusCounts.hasOwnProperty(key))
                    (data["travelRequestsPerStatusCounts"] as any)[key] = (this.travelRequestsPerStatusCounts as any)[key];
            }
        }
        return data;
    }
}

export interface IProjectTravelRequestsDashboardResponse {
    travelRequestsPerStatusCounts?: { [key: string]: number; } | undefined;
}

export class ProjectVacationRequestDashboardResponse implements IProjectVacationRequestDashboardResponse {
    vacationRequestsPerStatusCounts?: { [key: string]: number; } | undefined;
    vacationRequests?: VacationRequestResponse[] | undefined;
    calendar?: CommunicationCalendarResponse[] | undefined;

    constructor(data?: IProjectVacationRequestDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["vacationRequestsPerStatusCounts"]) {
                this.vacationRequestsPerStatusCounts = {} as any;
                for (let key in _data["vacationRequestsPerStatusCounts"]) {
                    if (_data["vacationRequestsPerStatusCounts"].hasOwnProperty(key))
                        (this.vacationRequestsPerStatusCounts as any)![key] = _data["vacationRequestsPerStatusCounts"][key];
                }
            }
            if (Array.isArray(_data["vacationRequests"])) {
                this.vacationRequests = [] as any;
                for (let item of _data["vacationRequests"])
                    this.vacationRequests!.push(VacationRequestResponse.fromJS(item));
            }
            if (Array.isArray(_data["calendar"])) {
                this.calendar = [] as any;
                for (let item of _data["calendar"])
                    this.calendar!.push(CommunicationCalendarResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectVacationRequestDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectVacationRequestDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.vacationRequestsPerStatusCounts) {
            data["vacationRequestsPerStatusCounts"] = {};
            for (let key in this.vacationRequestsPerStatusCounts) {
                if (this.vacationRequestsPerStatusCounts.hasOwnProperty(key))
                    (data["vacationRequestsPerStatusCounts"] as any)[key] = (this.vacationRequestsPerStatusCounts as any)[key];
            }
        }
        if (Array.isArray(this.vacationRequests)) {
            data["vacationRequests"] = [];
            for (let item of this.vacationRequests)
                data["vacationRequests"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.calendar)) {
            data["calendar"] = [];
            for (let item of this.calendar)
                data["calendar"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectVacationRequestDashboardResponse {
    vacationRequestsPerStatusCounts?: { [key: string]: number; } | undefined;
    vacationRequests?: VacationRequestResponse[] | undefined;
    calendar?: CommunicationCalendarResponse[] | undefined;
}

export class RatingPerQuestionDashboardResponse implements IRatingPerQuestionDashboardResponse {
    questionGroup?: string | undefined;
    ratingCount!: number;
    ratingSum!: number;
    readonly averageRating!: number;
    question!: string;

    constructor(data?: IRatingPerQuestionDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionGroup = _data["questionGroup"];
            this.ratingCount = _data["ratingCount"];
            this.ratingSum = _data["ratingSum"];
            (this as any).averageRating = _data["averageRating"];
            this.question = _data["question"];
        }
    }

    static fromJS(data: any): RatingPerQuestionDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RatingPerQuestionDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionGroup"] = this.questionGroup;
        data["ratingCount"] = this.ratingCount;
        data["ratingSum"] = this.ratingSum;
        data["averageRating"] = this.averageRating;
        data["question"] = this.question;
        return data;
    }
}

export interface IRatingPerQuestionDashboardResponse {
    questionGroup?: string | undefined;
    ratingCount: number;
    ratingSum: number;
    averageRating: number;
    question: string;
}

export class RatingPerQuestionGroupDashboardResponse implements IRatingPerQuestionGroupDashboardResponse {
    questionGroup?: string | undefined;
    ratingCount!: number;
    ratingSum!: number;
    readonly averageRating!: number;

    constructor(data?: IRatingPerQuestionGroupDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionGroup = _data["questionGroup"];
            this.ratingCount = _data["ratingCount"];
            this.ratingSum = _data["ratingSum"];
            (this as any).averageRating = _data["averageRating"];
        }
    }

    static fromJS(data: any): RatingPerQuestionGroupDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RatingPerQuestionGroupDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionGroup"] = this.questionGroup;
        data["ratingCount"] = this.ratingCount;
        data["ratingSum"] = this.ratingSum;
        data["averageRating"] = this.averageRating;
        return data;
    }
}

export interface IRatingPerQuestionGroupDashboardResponse {
    questionGroup?: string | undefined;
    ratingCount: number;
    ratingSum: number;
    averageRating: number;
}

export class RefreshTokenResponseModel implements IRefreshTokenResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    refreshToken?: string | undefined;
}

export class RefreshTokenWithTokenRequestModel implements IRefreshTokenWithTokenRequestModel {
    refreshToken!: string;

    constructor(data?: IRefreshTokenWithTokenRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenWithTokenRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenWithTokenRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenWithTokenRequestModel {
    refreshToken: string;
}

export class RejectApprovalRequest implements IRejectApprovalRequest {
    comment?: string | undefined;

    constructor(data?: IRejectApprovalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): RejectApprovalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RejectApprovalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        return data;
    }
}

export interface IRejectApprovalRequest {
    comment?: string | undefined;
}

export class ReminderResponse implements IReminderResponse {
    id!: number;
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    userId!: number;
    subject!: string;
    startDate!: Date;
    endDate!: Date;
    isRepeat!: boolean;
    repeatInterval!: RepeatIntervalEnum;
    readonly repeatOnMonday!: boolean;
    readonly repeatOnTuesday!: boolean;
    readonly repeatOnWednesday!: boolean;
    readonly repeatOnThursday!: boolean;
    readonly repeatOnFriday!: boolean;
    readonly repeatOnSaturday!: boolean;
    readonly repeatOnSunday!: boolean;
    repeatOnDays!: WeeklyDaysEnum;
    isPrivate!: boolean;
    sendEmail!: boolean;
    projectTeamId?: number | undefined;
    recipientUserIds?: number[] | undefined;

    constructor(data?: IReminderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.userId = _data["userId"];
            this.subject = _data["subject"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.isRepeat = _data["isRepeat"];
            this.repeatInterval = _data["repeatInterval"];
            (this as any).repeatOnMonday = _data["repeatOnMonday"];
            (this as any).repeatOnTuesday = _data["repeatOnTuesday"];
            (this as any).repeatOnWednesday = _data["repeatOnWednesday"];
            (this as any).repeatOnThursday = _data["repeatOnThursday"];
            (this as any).repeatOnFriday = _data["repeatOnFriday"];
            (this as any).repeatOnSaturday = _data["repeatOnSaturday"];
            (this as any).repeatOnSunday = _data["repeatOnSunday"];
            this.repeatOnDays = _data["repeatOnDays"];
            this.isPrivate = _data["isPrivate"];
            this.sendEmail = _data["sendEmail"];
            this.projectTeamId = _data["projectTeamId"];
            if (Array.isArray(_data["recipientUserIds"])) {
                this.recipientUserIds = [] as any;
                for (let item of _data["recipientUserIds"])
                    this.recipientUserIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ReminderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["userId"] = this.userId;
        data["subject"] = this.subject;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["isRepeat"] = this.isRepeat;
        data["repeatInterval"] = this.repeatInterval;
        data["repeatOnMonday"] = this.repeatOnMonday;
        data["repeatOnTuesday"] = this.repeatOnTuesday;
        data["repeatOnWednesday"] = this.repeatOnWednesday;
        data["repeatOnThursday"] = this.repeatOnThursday;
        data["repeatOnFriday"] = this.repeatOnFriday;
        data["repeatOnSaturday"] = this.repeatOnSaturday;
        data["repeatOnSunday"] = this.repeatOnSunday;
        data["repeatOnDays"] = this.repeatOnDays;
        data["isPrivate"] = this.isPrivate;
        data["sendEmail"] = this.sendEmail;
        data["projectTeamId"] = this.projectTeamId;
        if (Array.isArray(this.recipientUserIds)) {
            data["recipientUserIds"] = [];
            for (let item of this.recipientUserIds)
                data["recipientUserIds"].push(item);
        }
        return data;
    }
}

export interface IReminderResponse {
    id: number;
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    userId: number;
    subject: string;
    startDate: Date;
    endDate: Date;
    isRepeat: boolean;
    repeatInterval: RepeatIntervalEnum;
    repeatOnMonday: boolean;
    repeatOnTuesday: boolean;
    repeatOnWednesday: boolean;
    repeatOnThursday: boolean;
    repeatOnFriday: boolean;
    repeatOnSaturday: boolean;
    repeatOnSunday: boolean;
    repeatOnDays: WeeklyDaysEnum;
    isPrivate: boolean;
    sendEmail: boolean;
    projectTeamId?: number | undefined;
    recipientUserIds?: number[] | undefined;
}

export class ReminderResponseItemsResponseModel implements IReminderResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ReminderResponse[] | undefined;

    constructor(data?: IReminderResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReminderResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReminderResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReminderResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ReminderResponse[] | undefined;
}

export class ReminderResponseSimpleResponseModel implements IReminderResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ReminderResponse;

    constructor(data?: IReminderResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ReminderResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ReminderResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IReminderResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ReminderResponse;
}

export enum RepeatIntervalEnum {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
    Yearly = "Yearly",
}

export class ReportInnerTestResponse implements IReportInnerTestResponse {
    id!: number;
    processStepId?: string | undefined;
    processStepName?: string | undefined;
    stepStatusId!: number;
    stepTesterUserId?: number | undefined;

    constructor(data?: IReportInnerTestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processStepId = _data["processStepId"];
            this.processStepName = _data["processStepName"];
            this.stepStatusId = _data["stepStatusId"];
            this.stepTesterUserId = _data["stepTesterUserId"];
        }
    }

    static fromJS(data: any): ReportInnerTestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportInnerTestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processStepId"] = this.processStepId;
        data["processStepName"] = this.processStepName;
        data["stepStatusId"] = this.stepStatusId;
        data["stepTesterUserId"] = this.stepTesterUserId;
        return data;
    }
}

export interface IReportInnerTestResponse {
    id: number;
    processStepId?: string | undefined;
    processStepName?: string | undefined;
    stepStatusId: number;
    stepTesterUserId?: number | undefined;
}

export enum ReportItemStatusEnum {
    Open = "Open",
    InProgres = "InProgres",
    OnHold = "OnHold",
    Rejected = "Rejected",
    Closed = "Closed",
}

export enum ReportStatusAreaEnum {
    Green = "Green",
    Yellow = "Yellow",
    Red = "Red",
}

export class ReportStatusResponse implements IReportStatusResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isReadonly!: boolean;
    color!: string;
    isInitial!: boolean;
    nextStates?: number[] | undefined;
    order!: number;
    semantics!: ProjectReportStatusEnum;

    constructor(data?: IReportStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isReadonly = _data["isReadonly"];
            this.color = _data["color"];
            this.isInitial = _data["isInitial"];
            if (Array.isArray(_data["nextStates"])) {
                this.nextStates = [] as any;
                for (let item of _data["nextStates"])
                    this.nextStates!.push(item);
            }
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): ReportStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isReadonly"] = this.isReadonly;
        data["color"] = this.color;
        data["isInitial"] = this.isInitial;
        if (Array.isArray(this.nextStates)) {
            data["nextStates"] = [];
            for (let item of this.nextStates)
                data["nextStates"].push(item);
        }
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IReportStatusResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isReadonly: boolean;
    color: string;
    isInitial: boolean;
    nextStates?: number[] | undefined;
    order: number;
    semantics: ProjectReportStatusEnum;
}

export class ReportStatusResponseItemsResponseModel implements IReportStatusResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ReportStatusResponse[] | undefined;

    constructor(data?: IReportStatusResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportStatusResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportStatusResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReportStatusResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ReportStatusResponse[] | undefined;
}

export class ReportTestPlanResponse implements IReportTestPlanResponse {
    id!: number;
    level3ProcessId?: string | undefined;
    level3ProcessName?: string | undefined;
    processTesterUserId?: number | undefined;
    complexLevel2Id?: number | undefined;
    complexLevel2Name?: string | undefined;
    complexLevel2Description?: string | undefined;
    comment?: string | undefined;
    isComplex!: boolean;
    plannedDate?: Date | undefined;
    processStatusId!: number;
    tickets?: ReportTestTicketResponse[] | undefined;
    innerTestPlans?: ReportInnerTestResponse[] | undefined;
    ticketIds?: number[] | undefined;

    constructor(data?: IReportTestPlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.level3ProcessId = _data["level3ProcessId"];
            this.level3ProcessName = _data["level3ProcessName"];
            this.processTesterUserId = _data["processTesterUserId"];
            this.complexLevel2Id = _data["complexLevel2Id"];
            this.complexLevel2Name = _data["complexLevel2Name"];
            this.complexLevel2Description = _data["complexLevel2Description"];
            this.comment = _data["comment"];
            this.isComplex = _data["isComplex"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.processStatusId = _data["processStatusId"];
            if (Array.isArray(_data["tickets"])) {
                this.tickets = [] as any;
                for (let item of _data["tickets"])
                    this.tickets!.push(ReportTestTicketResponse.fromJS(item));
            }
            if (Array.isArray(_data["innerTestPlans"])) {
                this.innerTestPlans = [] as any;
                for (let item of _data["innerTestPlans"])
                    this.innerTestPlans!.push(ReportInnerTestResponse.fromJS(item));
            }
            if (Array.isArray(_data["ticketIds"])) {
                this.ticketIds = [] as any;
                for (let item of _data["ticketIds"])
                    this.ticketIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ReportTestPlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTestPlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["level3ProcessId"] = this.level3ProcessId;
        data["level3ProcessName"] = this.level3ProcessName;
        data["processTesterUserId"] = this.processTesterUserId;
        data["complexLevel2Id"] = this.complexLevel2Id;
        data["complexLevel2Name"] = this.complexLevel2Name;
        data["complexLevel2Description"] = this.complexLevel2Description;
        data["comment"] = this.comment;
        data["isComplex"] = this.isComplex;
        data["plannedDate"] = this.plannedDate ? formatDate(this.plannedDate) : undefined as any;
        data["processStatusId"] = this.processStatusId;
        if (Array.isArray(this.tickets)) {
            data["tickets"] = [];
            for (let item of this.tickets)
                data["tickets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.innerTestPlans)) {
            data["innerTestPlans"] = [];
            for (let item of this.innerTestPlans)
                data["innerTestPlans"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ticketIds)) {
            data["ticketIds"] = [];
            for (let item of this.ticketIds)
                data["ticketIds"].push(item);
        }
        return data;
    }
}

export interface IReportTestPlanResponse {
    id: number;
    level3ProcessId?: string | undefined;
    level3ProcessName?: string | undefined;
    processTesterUserId?: number | undefined;
    complexLevel2Id?: number | undefined;
    complexLevel2Name?: string | undefined;
    complexLevel2Description?: string | undefined;
    comment?: string | undefined;
    isComplex: boolean;
    plannedDate?: Date | undefined;
    processStatusId: number;
    tickets?: ReportTestTicketResponse[] | undefined;
    innerTestPlans?: ReportInnerTestResponse[] | undefined;
    ticketIds?: number[] | undefined;
}

export class ReportTestPlanResponseItemsResponseModel implements IReportTestPlanResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ReportTestPlanResponse[] | undefined;

    constructor(data?: IReportTestPlanResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReportTestPlanResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportTestPlanResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTestPlanResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReportTestPlanResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ReportTestPlanResponse[] | undefined;
}

export class ReportTestTicketResponse implements IReportTestTicketResponse {
    ticketId!: number;
    ticketStatusId!: number;
    ticketName!: string;

    constructor(data?: IReportTestTicketResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data["ticketId"];
            this.ticketStatusId = _data["ticketStatusId"];
            this.ticketName = _data["ticketName"];
        }
    }

    static fromJS(data: any): ReportTestTicketResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTestTicketResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketId"] = this.ticketId;
        data["ticketStatusId"] = this.ticketStatusId;
        data["ticketName"] = this.ticketName;
        return data;
    }
}

export interface IReportTestTicketResponse {
    ticketId: number;
    ticketStatusId: number;
    ticketName: string;
}

export enum ResolutionTimeBasedOnEnum {
    Hours24 = "Hours24",
    RegularWorkingHours = "RegularWorkingHours",
}

export class ResponseTimeResponse implements IResponseTimeResponse {
    id!: number;
    priority!: PriorityEnum;
    responseTime!: number;
    resolutionTime!: number;

    constructor(data?: IResponseTimeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.priority = _data["priority"];
            this.responseTime = _data["responseTime"];
            this.resolutionTime = _data["resolutionTime"];
        }
    }

    static fromJS(data: any): ResponseTimeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseTimeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["priority"] = this.priority;
        data["responseTime"] = this.responseTime;
        data["resolutionTime"] = this.resolutionTime;
        return data;
    }
}

export interface IResponseTimeResponse {
    id: number;
    priority: PriorityEnum;
    responseTime: number;
    resolutionTime: number;
}

export class RiskCountsResponse implements IRiskCountsResponse {
    grossImpactSum!: number;
    netImpactSum!: number;
    mitigationCostSum!: number;
    grossImpactAfterMitigationSum!: number;
    netImpactAfterMitigationSum!: number;
    costBenefitSum!: number;
    riskInclusionSum!: number;

    constructor(data?: IRiskCountsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grossImpactSum = _data["grossImpactSum"];
            this.netImpactSum = _data["netImpactSum"];
            this.mitigationCostSum = _data["mitigationCostSum"];
            this.grossImpactAfterMitigationSum = _data["grossImpactAfterMitigationSum"];
            this.netImpactAfterMitigationSum = _data["netImpactAfterMitigationSum"];
            this.costBenefitSum = _data["costBenefitSum"];
            this.riskInclusionSum = _data["riskInclusionSum"];
        }
    }

    static fromJS(data: any): RiskCountsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RiskCountsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grossImpactSum"] = this.grossImpactSum;
        data["netImpactSum"] = this.netImpactSum;
        data["mitigationCostSum"] = this.mitigationCostSum;
        data["grossImpactAfterMitigationSum"] = this.grossImpactAfterMitigationSum;
        data["netImpactAfterMitigationSum"] = this.netImpactAfterMitigationSum;
        data["costBenefitSum"] = this.costBenefitSum;
        data["riskInclusionSum"] = this.riskInclusionSum;
        return data;
    }
}

export interface IRiskCountsResponse {
    grossImpactSum: number;
    netImpactSum: number;
    mitigationCostSum: number;
    grossImpactAfterMitigationSum: number;
    netImpactAfterMitigationSum: number;
    costBenefitSum: number;
    riskInclusionSum: number;
}

export class RiskCountsResponseSimpleResponseModel implements IRiskCountsResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: RiskCountsResponse;

    constructor(data?: IRiskCountsResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? RiskCountsResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): RiskCountsResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskCountsResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IRiskCountsResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: RiskCountsResponse;
}

export class RiskDashboardFilterRequest implements IRiskDashboardFilterRequest {
    projectId!: number;
    dateRange!: DateRangeRequest;

    constructor(data?: IRiskDashboardFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dateRange = new DateRangeRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.dateRange = _data["dateRange"] ? DateRangeRequest.fromJS(_data["dateRange"]) : new DateRangeRequest();
        }
    }

    static fromJS(data: any): RiskDashboardFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RiskDashboardFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : undefined as any;
        return data;
    }
}

export interface IRiskDashboardFilterRequest {
    projectId: number;
    dateRange: DateRangeRequest;
}

export class RiskDashboardResponse implements IRiskDashboardResponse {
    grossImpactPerMitigationType?: { [key: string]: number; } | undefined;
    risks?: RiskResponse[] | undefined;
    totalGrossImpact!: number;
    totalGrossImpactAfterMitigation!: number;
    totalNetImpact!: number;
    totalRiskForInclusion!: number;

    constructor(data?: IRiskDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["grossImpactPerMitigationType"]) {
                this.grossImpactPerMitigationType = {} as any;
                for (let key in _data["grossImpactPerMitigationType"]) {
                    if (_data["grossImpactPerMitigationType"].hasOwnProperty(key))
                        (this.grossImpactPerMitigationType as any)![key] = _data["grossImpactPerMitigationType"][key];
                }
            }
            if (Array.isArray(_data["risks"])) {
                this.risks = [] as any;
                for (let item of _data["risks"])
                    this.risks!.push(RiskResponse.fromJS(item));
            }
            this.totalGrossImpact = _data["totalGrossImpact"];
            this.totalGrossImpactAfterMitigation = _data["totalGrossImpactAfterMitigation"];
            this.totalNetImpact = _data["totalNetImpact"];
            this.totalRiskForInclusion = _data["totalRiskForInclusion"];
        }
    }

    static fromJS(data: any): RiskDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RiskDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.grossImpactPerMitigationType) {
            data["grossImpactPerMitigationType"] = {};
            for (let key in this.grossImpactPerMitigationType) {
                if (this.grossImpactPerMitigationType.hasOwnProperty(key))
                    (data["grossImpactPerMitigationType"] as any)[key] = (this.grossImpactPerMitigationType as any)[key];
            }
        }
        if (Array.isArray(this.risks)) {
            data["risks"] = [];
            for (let item of this.risks)
                data["risks"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalGrossImpact"] = this.totalGrossImpact;
        data["totalGrossImpactAfterMitigation"] = this.totalGrossImpactAfterMitigation;
        data["totalNetImpact"] = this.totalNetImpact;
        data["totalRiskForInclusion"] = this.totalRiskForInclusion;
        return data;
    }
}

export interface IRiskDashboardResponse {
    grossImpactPerMitigationType?: { [key: string]: number; } | undefined;
    risks?: RiskResponse[] | undefined;
    totalGrossImpact: number;
    totalGrossImpactAfterMitigation: number;
    totalNetImpact: number;
    totalRiskForInclusion: number;
}

export class RiskDashboardResponseSimpleResponseModel implements IRiskDashboardResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: RiskDashboardResponse;

    constructor(data?: IRiskDashboardResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? RiskDashboardResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): RiskDashboardResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskDashboardResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IRiskDashboardResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: RiskDashboardResponse;
}

export enum RiskImpactEnum {
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export class RiskPermission implements IRiskPermission {
    dashboards!: boolean;
    viewRisks!: boolean;
    maintainRisks!: boolean;

    constructor(data?: IRiskPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboards = _data["dashboards"];
            this.viewRisks = _data["viewRisks"];
            this.maintainRisks = _data["maintainRisks"];
        }
    }

    static fromJS(data: any): RiskPermission {
        data = typeof data === 'object' ? data : {};
        let result = new RiskPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboards"] = this.dashboards;
        data["viewRisks"] = this.viewRisks;
        data["maintainRisks"] = this.maintainRisks;
        return data;
    }
}

export interface IRiskPermission {
    dashboards: boolean;
    viewRisks: boolean;
    maintainRisks: boolean;
}

export enum RiskProbabilityEnum {
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export class RiskResponse implements IRiskResponse {
    id!: number;
    projectId!: number;
    name!: string;
    consequneces?: string | undefined;
    effects?: string | undefined;
    responsibleUserId!: number;
    statusId!: number;
    typeId?: number | undefined;
    dueDate!: Date;
    comment?: string | undefined;
    grossImpact?: number | undefined;
    probability?: number | undefined;
    mitigation?: string | undefined;
    mitigationType!: MitigationTypeEnum;
    mitigationCost?: number | undefined;
    grossImpactAfterMitigation?: number | undefined;
    probabilityAfterMitigation?: number | undefined;
    probabilityDescriptive?: RiskProbabilityEnum;
    impactDescriptive?: RiskImpactEnum;
    netImpact?: number | undefined;
    netImpactAfterMitigation?: number | undefined;
    costBenefitAnalysis?: number | undefined;
    riskForInclusionInBudget?: number | undefined;

    constructor(data?: IRiskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.consequneces = _data["consequneces"];
            this.effects = _data["effects"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.statusId = _data["statusId"];
            this.typeId = _data["typeId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.comment = _data["comment"];
            this.grossImpact = _data["grossImpact"];
            this.probability = _data["probability"];
            this.mitigation = _data["mitigation"];
            this.mitigationType = _data["mitigationType"];
            this.mitigationCost = _data["mitigationCost"];
            this.grossImpactAfterMitigation = _data["grossImpactAfterMitigation"];
            this.probabilityAfterMitigation = _data["probabilityAfterMitigation"];
            this.probabilityDescriptive = _data["probabilityDescriptive"];
            this.impactDescriptive = _data["impactDescriptive"];
            this.netImpact = _data["netImpact"];
            this.netImpactAfterMitigation = _data["netImpactAfterMitigation"];
            this.costBenefitAnalysis = _data["costBenefitAnalysis"];
            this.riskForInclusionInBudget = _data["riskForInclusionInBudget"];
        }
    }

    static fromJS(data: any): RiskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RiskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["consequneces"] = this.consequneces;
        data["effects"] = this.effects;
        data["responsibleUserId"] = this.responsibleUserId;
        data["statusId"] = this.statusId;
        data["typeId"] = this.typeId;
        data["dueDate"] = this.dueDate ? formatDate(this.dueDate) : undefined as any;
        data["comment"] = this.comment;
        data["grossImpact"] = this.grossImpact;
        data["probability"] = this.probability;
        data["mitigation"] = this.mitigation;
        data["mitigationType"] = this.mitigationType;
        data["mitigationCost"] = this.mitigationCost;
        data["grossImpactAfterMitigation"] = this.grossImpactAfterMitigation;
        data["probabilityAfterMitigation"] = this.probabilityAfterMitigation;
        data["probabilityDescriptive"] = this.probabilityDescriptive;
        data["impactDescriptive"] = this.impactDescriptive;
        data["netImpact"] = this.netImpact;
        data["netImpactAfterMitigation"] = this.netImpactAfterMitigation;
        data["costBenefitAnalysis"] = this.costBenefitAnalysis;
        data["riskForInclusionInBudget"] = this.riskForInclusionInBudget;
        return data;
    }
}

export interface IRiskResponse {
    id: number;
    projectId: number;
    name: string;
    consequneces?: string | undefined;
    effects?: string | undefined;
    responsibleUserId: number;
    statusId: number;
    typeId?: number | undefined;
    dueDate: Date;
    comment?: string | undefined;
    grossImpact?: number | undefined;
    probability?: number | undefined;
    mitigation?: string | undefined;
    mitigationType: MitigationTypeEnum;
    mitigationCost?: number | undefined;
    grossImpactAfterMitigation?: number | undefined;
    probabilityAfterMitigation?: number | undefined;
    probabilityDescriptive?: RiskProbabilityEnum;
    impactDescriptive?: RiskImpactEnum;
    netImpact?: number | undefined;
    netImpactAfterMitigation?: number | undefined;
    costBenefitAnalysis?: number | undefined;
    riskForInclusionInBudget?: number | undefined;
}

export class RiskResponseItemsResponseModel implements IRiskResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: RiskResponse[] | undefined;

    constructor(data?: IRiskResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RiskResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RiskResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRiskResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: RiskResponse[] | undefined;
}

export class RiskResponseSimpleResponseModel implements IRiskResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: RiskResponse;

    constructor(data?: IRiskResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? RiskResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): RiskResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IRiskResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: RiskResponse;
}

export enum RiskStatusEnum {
    Open = "Open",
    InProgress = "InProgress",
    Completed = "Completed",
}

export class RiskStatusResponse implements IRiskStatusResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isReadonly!: boolean;
    color!: string;
    isInitial!: boolean;
    nextStates?: number[] | undefined;
    order!: number;
    semantics!: RiskStatusEnum;

    constructor(data?: IRiskStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isReadonly = _data["isReadonly"];
            this.color = _data["color"];
            this.isInitial = _data["isInitial"];
            if (Array.isArray(_data["nextStates"])) {
                this.nextStates = [] as any;
                for (let item of _data["nextStates"])
                    this.nextStates!.push(item);
            }
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): RiskStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RiskStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isReadonly"] = this.isReadonly;
        data["color"] = this.color;
        data["isInitial"] = this.isInitial;
        if (Array.isArray(this.nextStates)) {
            data["nextStates"] = [];
            for (let item of this.nextStates)
                data["nextStates"].push(item);
        }
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IRiskStatusResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isReadonly: boolean;
    color: string;
    isInitial: boolean;
    nextStates?: number[] | undefined;
    order: number;
    semantics: RiskStatusEnum;
}

export class RiskStatusResponseItemsResponseModel implements IRiskStatusResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: RiskStatusResponse[] | undefined;

    constructor(data?: IRiskStatusResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RiskStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RiskStatusResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskStatusResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRiskStatusResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: RiskStatusResponse[] | undefined;
}

export class ScheduleConfigurationRequest implements IScheduleConfigurationRequest {
    durationIn!: ScheduleDurationEnum;
    skipWeekends!: boolean;
    calculateDayDurationFromSettings!: boolean;
    autocompleteTaskWhenSubtasksCompleted!: boolean;
    deriveTaskDatesFromSubtasks!: boolean;
    planResources!: SchedulePlanResourcesEnum;
    workloadResourceUserPlan?: ScheduleWorkloadResourceUserPlanEnum;

    constructor(data?: IScheduleConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.durationIn = _data["durationIn"];
            this.skipWeekends = _data["skipWeekends"];
            this.calculateDayDurationFromSettings = _data["calculateDayDurationFromSettings"];
            this.autocompleteTaskWhenSubtasksCompleted = _data["autocompleteTaskWhenSubtasksCompleted"];
            this.deriveTaskDatesFromSubtasks = _data["deriveTaskDatesFromSubtasks"];
            this.planResources = _data["planResources"];
            this.workloadResourceUserPlan = _data["workloadResourceUserPlan"];
        }
    }

    static fromJS(data: any): ScheduleConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["durationIn"] = this.durationIn;
        data["skipWeekends"] = this.skipWeekends;
        data["calculateDayDurationFromSettings"] = this.calculateDayDurationFromSettings;
        data["autocompleteTaskWhenSubtasksCompleted"] = this.autocompleteTaskWhenSubtasksCompleted;
        data["deriveTaskDatesFromSubtasks"] = this.deriveTaskDatesFromSubtasks;
        data["planResources"] = this.planResources;
        data["workloadResourceUserPlan"] = this.workloadResourceUserPlan;
        return data;
    }
}

export interface IScheduleConfigurationRequest {
    durationIn: ScheduleDurationEnum;
    skipWeekends: boolean;
    calculateDayDurationFromSettings: boolean;
    autocompleteTaskWhenSubtasksCompleted: boolean;
    deriveTaskDatesFromSubtasks: boolean;
    planResources: SchedulePlanResourcesEnum;
    workloadResourceUserPlan?: ScheduleWorkloadResourceUserPlanEnum;
}

export class ScheduleConfigurationResponse implements IScheduleConfigurationResponse {
    projectId!: number;
    durationIn!: ScheduleDurationEnum;
    skipWeekends!: boolean;
    calculateDayDurationFromSettings!: boolean;
    autocompleteTaskWhenSubtasksCompleted!: boolean;
    deriveTaskDatesFromSubtasks!: boolean;
    planResources!: SchedulePlanResourcesEnum;
    workloadResourceUserPlan?: ScheduleWorkloadResourceUserPlanEnum;

    constructor(data?: IScheduleConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.durationIn = _data["durationIn"];
            this.skipWeekends = _data["skipWeekends"];
            this.calculateDayDurationFromSettings = _data["calculateDayDurationFromSettings"];
            this.autocompleteTaskWhenSubtasksCompleted = _data["autocompleteTaskWhenSubtasksCompleted"];
            this.deriveTaskDatesFromSubtasks = _data["deriveTaskDatesFromSubtasks"];
            this.planResources = _data["planResources"];
            this.workloadResourceUserPlan = _data["workloadResourceUserPlan"];
        }
    }

    static fromJS(data: any): ScheduleConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["durationIn"] = this.durationIn;
        data["skipWeekends"] = this.skipWeekends;
        data["calculateDayDurationFromSettings"] = this.calculateDayDurationFromSettings;
        data["autocompleteTaskWhenSubtasksCompleted"] = this.autocompleteTaskWhenSubtasksCompleted;
        data["deriveTaskDatesFromSubtasks"] = this.deriveTaskDatesFromSubtasks;
        data["planResources"] = this.planResources;
        data["workloadResourceUserPlan"] = this.workloadResourceUserPlan;
        return data;
    }
}

export interface IScheduleConfigurationResponse {
    projectId: number;
    durationIn: ScheduleDurationEnum;
    skipWeekends: boolean;
    calculateDayDurationFromSettings: boolean;
    autocompleteTaskWhenSubtasksCompleted: boolean;
    deriveTaskDatesFromSubtasks: boolean;
    planResources: SchedulePlanResourcesEnum;
    workloadResourceUserPlan?: ScheduleWorkloadResourceUserPlanEnum;
}

export class ScheduleConfigurationResponseSimpleResponseModel implements IScheduleConfigurationResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ScheduleConfigurationResponse;

    constructor(data?: IScheduleConfigurationResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ScheduleConfigurationResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduleConfigurationResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleConfigurationResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IScheduleConfigurationResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ScheduleConfigurationResponse;
}

export class ScheduleDashboardFilterRequest implements IScheduleDashboardFilterRequest {
    projectId!: number;
    from?: Date | undefined;
    to?: Date | undefined;

    constructor(data?: IScheduleDashboardFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduleDashboardFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDashboardFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        return data;
    }
}

export interface IScheduleDashboardFilterRequest {
    projectId: number;
    from?: Date | undefined;
    to?: Date | undefined;
}

export class ScheduleDashboardResponse implements IScheduleDashboardResponse {
    projectDurationInDays!: number;
    percentOfCompletion!: number;
    plannedNumberOfManHours!: number;
    actualNumberOfManHours!: number;
    projectTeamReport?: ScheduleDashboardRowResponse[] | undefined;
    userReport?: ScheduleDashboardRowResponse[] | undefined;
    hoursPerPlannedActualAndUser?: { [key: string]: { [key: string]: number; }; } | undefined;
    hoursPerPlannedActualAndProjectTeam?: { [key: string]: { [key: string]: number; }; } | undefined;
    projectUtilization?: ScheduleUtilizationRowDashboardResponse[] | undefined;
    wbsLevel1Items?: WbsLevel1ItemResponse[] | undefined;
    plannedHoursPerUserAndWbsLevel1?: { [key: string]: { [key: string]: number; }; } | undefined;
    actualHoursPerUserAndWbsLevel1?: { [key: string]: { [key: string]: number; }; } | undefined;
    plannedHoursPerProjectTeamAndWbsLevel1?: { [key: string]: { [key: string]: number; }; } | undefined;
    actualHoursPerProjectTeamAndWbsLevel1?: { [key: string]: { [key: string]: number; }; } | undefined;

    constructor(data?: IScheduleDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectDurationInDays = _data["projectDurationInDays"];
            this.percentOfCompletion = _data["percentOfCompletion"];
            this.plannedNumberOfManHours = _data["plannedNumberOfManHours"];
            this.actualNumberOfManHours = _data["actualNumberOfManHours"];
            if (Array.isArray(_data["projectTeamReport"])) {
                this.projectTeamReport = [] as any;
                for (let item of _data["projectTeamReport"])
                    this.projectTeamReport!.push(ScheduleDashboardRowResponse.fromJS(item));
            }
            if (Array.isArray(_data["userReport"])) {
                this.userReport = [] as any;
                for (let item of _data["userReport"])
                    this.userReport!.push(ScheduleDashboardRowResponse.fromJS(item));
            }
            if (_data["hoursPerPlannedActualAndUser"]) {
                this.hoursPerPlannedActualAndUser = {} as any;
                for (let key in _data["hoursPerPlannedActualAndUser"]) {
                    if (_data["hoursPerPlannedActualAndUser"].hasOwnProperty(key))
                        (this.hoursPerPlannedActualAndUser as any)![key] = _data["hoursPerPlannedActualAndUser"][key] !== undefined ? _data["hoursPerPlannedActualAndUser"][key] : {};
                }
            }
            if (_data["hoursPerPlannedActualAndProjectTeam"]) {
                this.hoursPerPlannedActualAndProjectTeam = {} as any;
                for (let key in _data["hoursPerPlannedActualAndProjectTeam"]) {
                    if (_data["hoursPerPlannedActualAndProjectTeam"].hasOwnProperty(key))
                        (this.hoursPerPlannedActualAndProjectTeam as any)![key] = _data["hoursPerPlannedActualAndProjectTeam"][key] !== undefined ? _data["hoursPerPlannedActualAndProjectTeam"][key] : {};
                }
            }
            if (Array.isArray(_data["projectUtilization"])) {
                this.projectUtilization = [] as any;
                for (let item of _data["projectUtilization"])
                    this.projectUtilization!.push(ScheduleUtilizationRowDashboardResponse.fromJS(item));
            }
            if (Array.isArray(_data["wbsLevel1Items"])) {
                this.wbsLevel1Items = [] as any;
                for (let item of _data["wbsLevel1Items"])
                    this.wbsLevel1Items!.push(WbsLevel1ItemResponse.fromJS(item));
            }
            if (_data["plannedHoursPerUserAndWbsLevel1"]) {
                this.plannedHoursPerUserAndWbsLevel1 = {} as any;
                for (let key in _data["plannedHoursPerUserAndWbsLevel1"]) {
                    if (_data["plannedHoursPerUserAndWbsLevel1"].hasOwnProperty(key))
                        (this.plannedHoursPerUserAndWbsLevel1 as any)![key] = _data["plannedHoursPerUserAndWbsLevel1"][key] !== undefined ? _data["plannedHoursPerUserAndWbsLevel1"][key] : {};
                }
            }
            if (_data["actualHoursPerUserAndWbsLevel1"]) {
                this.actualHoursPerUserAndWbsLevel1 = {} as any;
                for (let key in _data["actualHoursPerUserAndWbsLevel1"]) {
                    if (_data["actualHoursPerUserAndWbsLevel1"].hasOwnProperty(key))
                        (this.actualHoursPerUserAndWbsLevel1 as any)![key] = _data["actualHoursPerUserAndWbsLevel1"][key] !== undefined ? _data["actualHoursPerUserAndWbsLevel1"][key] : {};
                }
            }
            if (_data["plannedHoursPerProjectTeamAndWbsLevel1"]) {
                this.plannedHoursPerProjectTeamAndWbsLevel1 = {} as any;
                for (let key in _data["plannedHoursPerProjectTeamAndWbsLevel1"]) {
                    if (_data["plannedHoursPerProjectTeamAndWbsLevel1"].hasOwnProperty(key))
                        (this.plannedHoursPerProjectTeamAndWbsLevel1 as any)![key] = _data["plannedHoursPerProjectTeamAndWbsLevel1"][key] !== undefined ? _data["plannedHoursPerProjectTeamAndWbsLevel1"][key] : {};
                }
            }
            if (_data["actualHoursPerProjectTeamAndWbsLevel1"]) {
                this.actualHoursPerProjectTeamAndWbsLevel1 = {} as any;
                for (let key in _data["actualHoursPerProjectTeamAndWbsLevel1"]) {
                    if (_data["actualHoursPerProjectTeamAndWbsLevel1"].hasOwnProperty(key))
                        (this.actualHoursPerProjectTeamAndWbsLevel1 as any)![key] = _data["actualHoursPerProjectTeamAndWbsLevel1"][key] !== undefined ? _data["actualHoursPerProjectTeamAndWbsLevel1"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): ScheduleDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectDurationInDays"] = this.projectDurationInDays;
        data["percentOfCompletion"] = this.percentOfCompletion;
        data["plannedNumberOfManHours"] = this.plannedNumberOfManHours;
        data["actualNumberOfManHours"] = this.actualNumberOfManHours;
        if (Array.isArray(this.projectTeamReport)) {
            data["projectTeamReport"] = [];
            for (let item of this.projectTeamReport)
                data["projectTeamReport"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userReport)) {
            data["userReport"] = [];
            for (let item of this.userReport)
                data["userReport"].push(item ? item.toJSON() : undefined as any);
        }
        if (this.hoursPerPlannedActualAndUser) {
            data["hoursPerPlannedActualAndUser"] = {};
            for (let key in this.hoursPerPlannedActualAndUser) {
                if (this.hoursPerPlannedActualAndUser.hasOwnProperty(key))
                    (data["hoursPerPlannedActualAndUser"] as any)[key] = (this.hoursPerPlannedActualAndUser as any)[key];
            }
        }
        if (this.hoursPerPlannedActualAndProjectTeam) {
            data["hoursPerPlannedActualAndProjectTeam"] = {};
            for (let key in this.hoursPerPlannedActualAndProjectTeam) {
                if (this.hoursPerPlannedActualAndProjectTeam.hasOwnProperty(key))
                    (data["hoursPerPlannedActualAndProjectTeam"] as any)[key] = (this.hoursPerPlannedActualAndProjectTeam as any)[key];
            }
        }
        if (Array.isArray(this.projectUtilization)) {
            data["projectUtilization"] = [];
            for (let item of this.projectUtilization)
                data["projectUtilization"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wbsLevel1Items)) {
            data["wbsLevel1Items"] = [];
            for (let item of this.wbsLevel1Items)
                data["wbsLevel1Items"].push(item ? item.toJSON() : undefined as any);
        }
        if (this.plannedHoursPerUserAndWbsLevel1) {
            data["plannedHoursPerUserAndWbsLevel1"] = {};
            for (let key in this.plannedHoursPerUserAndWbsLevel1) {
                if (this.plannedHoursPerUserAndWbsLevel1.hasOwnProperty(key))
                    (data["plannedHoursPerUserAndWbsLevel1"] as any)[key] = (this.plannedHoursPerUserAndWbsLevel1 as any)[key];
            }
        }
        if (this.actualHoursPerUserAndWbsLevel1) {
            data["actualHoursPerUserAndWbsLevel1"] = {};
            for (let key in this.actualHoursPerUserAndWbsLevel1) {
                if (this.actualHoursPerUserAndWbsLevel1.hasOwnProperty(key))
                    (data["actualHoursPerUserAndWbsLevel1"] as any)[key] = (this.actualHoursPerUserAndWbsLevel1 as any)[key];
            }
        }
        if (this.plannedHoursPerProjectTeamAndWbsLevel1) {
            data["plannedHoursPerProjectTeamAndWbsLevel1"] = {};
            for (let key in this.plannedHoursPerProjectTeamAndWbsLevel1) {
                if (this.plannedHoursPerProjectTeamAndWbsLevel1.hasOwnProperty(key))
                    (data["plannedHoursPerProjectTeamAndWbsLevel1"] as any)[key] = (this.plannedHoursPerProjectTeamAndWbsLevel1 as any)[key];
            }
        }
        if (this.actualHoursPerProjectTeamAndWbsLevel1) {
            data["actualHoursPerProjectTeamAndWbsLevel1"] = {};
            for (let key in this.actualHoursPerProjectTeamAndWbsLevel1) {
                if (this.actualHoursPerProjectTeamAndWbsLevel1.hasOwnProperty(key))
                    (data["actualHoursPerProjectTeamAndWbsLevel1"] as any)[key] = (this.actualHoursPerProjectTeamAndWbsLevel1 as any)[key];
            }
        }
        return data;
    }
}

export interface IScheduleDashboardResponse {
    projectDurationInDays: number;
    percentOfCompletion: number;
    plannedNumberOfManHours: number;
    actualNumberOfManHours: number;
    projectTeamReport?: ScheduleDashboardRowResponse[] | undefined;
    userReport?: ScheduleDashboardRowResponse[] | undefined;
    hoursPerPlannedActualAndUser?: { [key: string]: { [key: string]: number; }; } | undefined;
    hoursPerPlannedActualAndProjectTeam?: { [key: string]: { [key: string]: number; }; } | undefined;
    projectUtilization?: ScheduleUtilizationRowDashboardResponse[] | undefined;
    wbsLevel1Items?: WbsLevel1ItemResponse[] | undefined;
    plannedHoursPerUserAndWbsLevel1?: { [key: string]: { [key: string]: number; }; } | undefined;
    actualHoursPerUserAndWbsLevel1?: { [key: string]: { [key: string]: number; }; } | undefined;
    plannedHoursPerProjectTeamAndWbsLevel1?: { [key: string]: { [key: string]: number; }; } | undefined;
    actualHoursPerProjectTeamAndWbsLevel1?: { [key: string]: { [key: string]: number; }; } | undefined;
}

export class ScheduleDashboardResponseSimpleResponseModel implements IScheduleDashboardResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ScheduleDashboardResponse;

    constructor(data?: IScheduleDashboardResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ScheduleDashboardResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduleDashboardResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDashboardResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IScheduleDashboardResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ScheduleDashboardResponse;
}

export class ScheduleDashboardRowResponse implements IScheduleDashboardRowResponse {
    projectId!: number;
    projectTypeId?: number | undefined;
    projectCategoryId?: number | undefined;
    wbs?: string | undefined;
    projectTeamId?: number | undefined;
    userId?: number | undefined;
    start!: Date;
    finish!: Date;
    percentOfCompletion?: number | undefined;
    plannedNumberOfHours!: number;
    actualNumberOfHours!: number;
    readonly differenceHours!: number;
    plannedCost!: number;
    actualCost!: number;
    readonly differenceCost!: number;
    readonly earnedValue!: number;

    constructor(data?: IScheduleDashboardRowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectTypeId = _data["projectTypeId"];
            this.projectCategoryId = _data["projectCategoryId"];
            this.wbs = _data["wbs"];
            this.projectTeamId = _data["projectTeamId"];
            this.userId = _data["userId"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.finish = _data["finish"] ? new Date(_data["finish"].toString()) : undefined as any;
            this.percentOfCompletion = _data["percentOfCompletion"];
            this.plannedNumberOfHours = _data["plannedNumberOfHours"];
            this.actualNumberOfHours = _data["actualNumberOfHours"];
            (this as any).differenceHours = _data["differenceHours"];
            this.plannedCost = _data["plannedCost"];
            this.actualCost = _data["actualCost"];
            (this as any).differenceCost = _data["differenceCost"];
            (this as any).earnedValue = _data["earnedValue"];
        }
    }

    static fromJS(data: any): ScheduleDashboardRowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDashboardRowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectTypeId"] = this.projectTypeId;
        data["projectCategoryId"] = this.projectCategoryId;
        data["wbs"] = this.wbs;
        data["projectTeamId"] = this.projectTeamId;
        data["userId"] = this.userId;
        data["start"] = this.start ? formatDate(this.start) : undefined as any;
        data["finish"] = this.finish ? formatDate(this.finish) : undefined as any;
        data["percentOfCompletion"] = this.percentOfCompletion;
        data["plannedNumberOfHours"] = this.plannedNumberOfHours;
        data["actualNumberOfHours"] = this.actualNumberOfHours;
        data["differenceHours"] = this.differenceHours;
        data["plannedCost"] = this.plannedCost;
        data["actualCost"] = this.actualCost;
        data["differenceCost"] = this.differenceCost;
        data["earnedValue"] = this.earnedValue;
        return data;
    }
}

export interface IScheduleDashboardRowResponse {
    projectId: number;
    projectTypeId?: number | undefined;
    projectCategoryId?: number | undefined;
    wbs?: string | undefined;
    projectTeamId?: number | undefined;
    userId?: number | undefined;
    start: Date;
    finish: Date;
    percentOfCompletion?: number | undefined;
    plannedNumberOfHours: number;
    actualNumberOfHours: number;
    differenceHours: number;
    plannedCost: number;
    actualCost: number;
    differenceCost: number;
    earnedValue: number;
}

export class ScheduleDayUtilizationDashboardResponse implements IScheduleDayUtilizationDashboardResponse {
    plannedHours!: number;
    actualHours!: number;
    readonly difference!: number;
    date!: Date;
    utilizationPerProject?: { [key: string]: ScheduleUtilizationDashboardResponse; } | undefined;

    constructor(data?: IScheduleDayUtilizationDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedHours = _data["plannedHours"];
            this.actualHours = _data["actualHours"];
            (this as any).difference = _data["difference"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            if (_data["utilizationPerProject"]) {
                this.utilizationPerProject = {} as any;
                for (let key in _data["utilizationPerProject"]) {
                    if (_data["utilizationPerProject"].hasOwnProperty(key))
                        (this.utilizationPerProject as any)![key] = _data["utilizationPerProject"][key] ? ScheduleUtilizationDashboardResponse.fromJS(_data["utilizationPerProject"][key]) : new ScheduleUtilizationDashboardResponse();
                }
            }
        }
    }

    static fromJS(data: any): ScheduleDayUtilizationDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDayUtilizationDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedHours"] = this.plannedHours;
        data["actualHours"] = this.actualHours;
        data["difference"] = this.difference;
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        if (this.utilizationPerProject) {
            data["utilizationPerProject"] = {};
            for (let key in this.utilizationPerProject) {
                if (this.utilizationPerProject.hasOwnProperty(key))
                    (data["utilizationPerProject"] as any)[key] = this.utilizationPerProject[key] ? this.utilizationPerProject[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IScheduleDayUtilizationDashboardResponse {
    plannedHours: number;
    actualHours: number;
    difference: number;
    date: Date;
    utilizationPerProject?: { [key: string]: ScheduleUtilizationDashboardResponse; } | undefined;
}

export enum ScheduleDurationEnum {
    Hours = "Hours",
    Days = "Days",
    Weeks = "Weeks",
    Months = "Months",
}

export class ScheduleGanttDashboardFilterRequest implements IScheduleGanttDashboardFilterRequest {
    projectIds?: number[] | undefined;

    constructor(data?: IScheduleGanttDashboardFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ScheduleGanttDashboardFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleGanttDashboardFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        return data;
    }
}

export interface IScheduleGanttDashboardFilterRequest {
    projectIds?: number[] | undefined;
}

export class ScheduleGanttDashboardResponse implements IScheduleGanttDashboardResponse {
    schedulesPerProject?: { [key: string]: ScheduleResponse[]; } | undefined;
    schedulesPredecessorsPerProject?: { [key: string]: SchedulePredecessorResponse[]; } | undefined;

    constructor(data?: IScheduleGanttDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["schedulesPerProject"]) {
                this.schedulesPerProject = {} as any;
                for (let key in _data["schedulesPerProject"]) {
                    if (_data["schedulesPerProject"].hasOwnProperty(key))
                        (this.schedulesPerProject as any)![key] = _data["schedulesPerProject"][key] ? _data["schedulesPerProject"][key].map((i: any) => ScheduleResponse.fromJS(i)) : [];
                }
            }
            if (_data["schedulesPredecessorsPerProject"]) {
                this.schedulesPredecessorsPerProject = {} as any;
                for (let key in _data["schedulesPredecessorsPerProject"]) {
                    if (_data["schedulesPredecessorsPerProject"].hasOwnProperty(key))
                        (this.schedulesPredecessorsPerProject as any)![key] = _data["schedulesPredecessorsPerProject"][key] ? _data["schedulesPredecessorsPerProject"][key].map((i: any) => SchedulePredecessorResponse.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): ScheduleGanttDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleGanttDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.schedulesPerProject) {
            data["schedulesPerProject"] = {};
            for (let key in this.schedulesPerProject) {
                if (this.schedulesPerProject.hasOwnProperty(key))
                    (data["schedulesPerProject"] as any)[key] = (this.schedulesPerProject as any)[key];
            }
        }
        if (this.schedulesPredecessorsPerProject) {
            data["schedulesPredecessorsPerProject"] = {};
            for (let key in this.schedulesPredecessorsPerProject) {
                if (this.schedulesPredecessorsPerProject.hasOwnProperty(key))
                    (data["schedulesPredecessorsPerProject"] as any)[key] = (this.schedulesPredecessorsPerProject as any)[key];
            }
        }
        return data;
    }
}

export interface IScheduleGanttDashboardResponse {
    schedulesPerProject?: { [key: string]: ScheduleResponse[]; } | undefined;
    schedulesPredecessorsPerProject?: { [key: string]: SchedulePredecessorResponse[]; } | undefined;
}

export class ScheduleGanttDashboardResponseSimpleResponseModel implements IScheduleGanttDashboardResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ScheduleGanttDashboardResponse;

    constructor(data?: IScheduleGanttDashboardResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ScheduleGanttDashboardResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduleGanttDashboardResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleGanttDashboardResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IScheduleGanttDashboardResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ScheduleGanttDashboardResponse;
}

export class SchedulePermission implements ISchedulePermission {
    viewSchedule!: boolean;
    maintainSchedule!: boolean;

    constructor(data?: ISchedulePermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.viewSchedule = _data["viewSchedule"];
            this.maintainSchedule = _data["maintainSchedule"];
        }
    }

    static fromJS(data: any): SchedulePermission {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulePermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewSchedule"] = this.viewSchedule;
        data["maintainSchedule"] = this.maintainSchedule;
        return data;
    }
}

export interface ISchedulePermission {
    viewSchedule: boolean;
    maintainSchedule: boolean;
}

export enum SchedulePlanResourcesEnum {
    PerUser = "PerUser",
    PerProjectTeam = "PerProjectTeam",
}

export class SchedulePredecessorResponse implements ISchedulePredecessorResponse {
    id!: number;
    predecessorId!: number;
    descendantId!: number;
    type!: SchedulePredecessorTypeEnum;
    lag?: number | undefined;

    constructor(data?: ISchedulePredecessorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.predecessorId = _data["predecessorId"];
            this.descendantId = _data["descendantId"];
            this.type = _data["type"];
            this.lag = _data["lag"];
        }
    }

    static fromJS(data: any): SchedulePredecessorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulePredecessorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["predecessorId"] = this.predecessorId;
        data["descendantId"] = this.descendantId;
        data["type"] = this.type;
        data["lag"] = this.lag;
        return data;
    }
}

export interface ISchedulePredecessorResponse {
    id: number;
    predecessorId: number;
    descendantId: number;
    type: SchedulePredecessorTypeEnum;
    lag?: number | undefined;
}

export class SchedulePredecessorResponseItemsResponseModel implements ISchedulePredecessorResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SchedulePredecessorResponse[] | undefined;

    constructor(data?: ISchedulePredecessorResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SchedulePredecessorResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchedulePredecessorResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulePredecessorResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISchedulePredecessorResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SchedulePredecessorResponse[] | undefined;
}

export class SchedulePredecessorResponseSimpleResponseModel implements ISchedulePredecessorResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: SchedulePredecessorResponse;

    constructor(data?: ISchedulePredecessorResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? SchedulePredecessorResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): SchedulePredecessorResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulePredecessorResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ISchedulePredecessorResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: SchedulePredecessorResponse;
}

export enum SchedulePredecessorTypeEnum {
    FinishToStart = "FinishToStart",
    StartToStart = "StartToStart",
    FinishToFinish = "FinishToFinish",
    StartToFinish = "StartToFinish",
}

export class ScheduleResourcePlanResponse implements IScheduleResourcePlanResponse {
    id!: number;
    userOrProjectTeamId!: number;
    numberOfHours?: number | undefined;
    workload?: number | undefined;
    percentOfCompletion?: number | undefined;

    constructor(data?: IScheduleResourcePlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userOrProjectTeamId = _data["userOrProjectTeamId"];
            this.numberOfHours = _data["numberOfHours"];
            this.workload = _data["workload"];
            this.percentOfCompletion = _data["percentOfCompletion"];
        }
    }

    static fromJS(data: any): ScheduleResourcePlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleResourcePlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userOrProjectTeamId"] = this.userOrProjectTeamId;
        data["numberOfHours"] = this.numberOfHours;
        data["workload"] = this.workload;
        data["percentOfCompletion"] = this.percentOfCompletion;
        return data;
    }
}

export interface IScheduleResourcePlanResponse {
    id: number;
    userOrProjectTeamId: number;
    numberOfHours?: number | undefined;
    workload?: number | undefined;
    percentOfCompletion?: number | undefined;
}

export class ScheduleResponse implements IScheduleResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    projectId!: number;
    wbs!: string;
    start!: Date;
    finish!: Date;
    duration!: number;
    parentId?: number | undefined;
    predecessorIds?: number[] | undefined;
    percentOfCompletion?: number | undefined;
    percentOfTaskCompletion?: number | undefined;
    achievedDate?: Date | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    customText3?: string | undefined;
    customText4?: string | undefined;
    customText5?: string | undefined;
    customText6?: string | undefined;
    customText7?: string | undefined;
    customText8?: string | undefined;
    customText9?: string | undefined;
    customText10?: string | undefined;
    projectRoleResponsibleId?: number | undefined;
    responsibleUserIds?: number[] | undefined;
    addAsTaskPerResponsibleUser!: boolean;
    projectRoleAccountableId?: number | undefined;
    accountableUserIds?: number[] | undefined;
    projectRoleConsultedId?: number | undefined;
    consultedUserIds?: number[] | undefined;
    projectRoleInformedId?: number | undefined;
    informedUserIds?: number[] | undefined;
    resourcePlanUsers?: ScheduleResourcePlanResponse[] | undefined;
    resourcePlanProjectTeams?: ScheduleResourcePlanResponse[] | undefined;
    markAsMilestone!: boolean;
    markAsDeliverable!: boolean;
    markTaskForQualityGate!: boolean;

    constructor(data?: IScheduleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.projectId = _data["projectId"];
            this.wbs = _data["wbs"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.finish = _data["finish"] ? new Date(_data["finish"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["predecessorIds"])) {
                this.predecessorIds = [] as any;
                for (let item of _data["predecessorIds"])
                    this.predecessorIds!.push(item);
            }
            this.percentOfCompletion = _data["percentOfCompletion"];
            this.percentOfTaskCompletion = _data["percentOfTaskCompletion"];
            this.achievedDate = _data["achievedDate"] ? new Date(_data["achievedDate"].toString()) : undefined as any;
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.customText3 = _data["customText3"];
            this.customText4 = _data["customText4"];
            this.customText5 = _data["customText5"];
            this.customText6 = _data["customText6"];
            this.customText7 = _data["customText7"];
            this.customText8 = _data["customText8"];
            this.customText9 = _data["customText9"];
            this.customText10 = _data["customText10"];
            this.projectRoleResponsibleId = _data["projectRoleResponsibleId"];
            if (Array.isArray(_data["responsibleUserIds"])) {
                this.responsibleUserIds = [] as any;
                for (let item of _data["responsibleUserIds"])
                    this.responsibleUserIds!.push(item);
            }
            this.addAsTaskPerResponsibleUser = _data["addAsTaskPerResponsibleUser"];
            this.projectRoleAccountableId = _data["projectRoleAccountableId"];
            if (Array.isArray(_data["accountableUserIds"])) {
                this.accountableUserIds = [] as any;
                for (let item of _data["accountableUserIds"])
                    this.accountableUserIds!.push(item);
            }
            this.projectRoleConsultedId = _data["projectRoleConsultedId"];
            if (Array.isArray(_data["consultedUserIds"])) {
                this.consultedUserIds = [] as any;
                for (let item of _data["consultedUserIds"])
                    this.consultedUserIds!.push(item);
            }
            this.projectRoleInformedId = _data["projectRoleInformedId"];
            if (Array.isArray(_data["informedUserIds"])) {
                this.informedUserIds = [] as any;
                for (let item of _data["informedUserIds"])
                    this.informedUserIds!.push(item);
            }
            if (Array.isArray(_data["resourcePlanUsers"])) {
                this.resourcePlanUsers = [] as any;
                for (let item of _data["resourcePlanUsers"])
                    this.resourcePlanUsers!.push(ScheduleResourcePlanResponse.fromJS(item));
            }
            if (Array.isArray(_data["resourcePlanProjectTeams"])) {
                this.resourcePlanProjectTeams = [] as any;
                for (let item of _data["resourcePlanProjectTeams"])
                    this.resourcePlanProjectTeams!.push(ScheduleResourcePlanResponse.fromJS(item));
            }
            this.markAsMilestone = _data["markAsMilestone"];
            this.markAsDeliverable = _data["markAsDeliverable"];
            this.markTaskForQualityGate = _data["markTaskForQualityGate"];
        }
    }

    static fromJS(data: any): ScheduleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        data["wbs"] = this.wbs;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["finish"] = this.finish ? this.finish.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.predecessorIds)) {
            data["predecessorIds"] = [];
            for (let item of this.predecessorIds)
                data["predecessorIds"].push(item);
        }
        data["percentOfCompletion"] = this.percentOfCompletion;
        data["percentOfTaskCompletion"] = this.percentOfTaskCompletion;
        data["achievedDate"] = this.achievedDate ? this.achievedDate.toISOString() : undefined as any;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["customText3"] = this.customText3;
        data["customText4"] = this.customText4;
        data["customText5"] = this.customText5;
        data["customText6"] = this.customText6;
        data["customText7"] = this.customText7;
        data["customText8"] = this.customText8;
        data["customText9"] = this.customText9;
        data["customText10"] = this.customText10;
        data["projectRoleResponsibleId"] = this.projectRoleResponsibleId;
        if (Array.isArray(this.responsibleUserIds)) {
            data["responsibleUserIds"] = [];
            for (let item of this.responsibleUserIds)
                data["responsibleUserIds"].push(item);
        }
        data["addAsTaskPerResponsibleUser"] = this.addAsTaskPerResponsibleUser;
        data["projectRoleAccountableId"] = this.projectRoleAccountableId;
        if (Array.isArray(this.accountableUserIds)) {
            data["accountableUserIds"] = [];
            for (let item of this.accountableUserIds)
                data["accountableUserIds"].push(item);
        }
        data["projectRoleConsultedId"] = this.projectRoleConsultedId;
        if (Array.isArray(this.consultedUserIds)) {
            data["consultedUserIds"] = [];
            for (let item of this.consultedUserIds)
                data["consultedUserIds"].push(item);
        }
        data["projectRoleInformedId"] = this.projectRoleInformedId;
        if (Array.isArray(this.informedUserIds)) {
            data["informedUserIds"] = [];
            for (let item of this.informedUserIds)
                data["informedUserIds"].push(item);
        }
        if (Array.isArray(this.resourcePlanUsers)) {
            data["resourcePlanUsers"] = [];
            for (let item of this.resourcePlanUsers)
                data["resourcePlanUsers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.resourcePlanProjectTeams)) {
            data["resourcePlanProjectTeams"] = [];
            for (let item of this.resourcePlanProjectTeams)
                data["resourcePlanProjectTeams"].push(item ? item.toJSON() : undefined as any);
        }
        data["markAsMilestone"] = this.markAsMilestone;
        data["markAsDeliverable"] = this.markAsDeliverable;
        data["markTaskForQualityGate"] = this.markTaskForQualityGate;
        return data;
    }
}

export interface IScheduleResponse {
    id: number;
    name: string;
    description?: string | undefined;
    projectId: number;
    wbs: string;
    start: Date;
    finish: Date;
    duration: number;
    parentId?: number | undefined;
    predecessorIds?: number[] | undefined;
    percentOfCompletion?: number | undefined;
    percentOfTaskCompletion?: number | undefined;
    achievedDate?: Date | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    customText3?: string | undefined;
    customText4?: string | undefined;
    customText5?: string | undefined;
    customText6?: string | undefined;
    customText7?: string | undefined;
    customText8?: string | undefined;
    customText9?: string | undefined;
    customText10?: string | undefined;
    projectRoleResponsibleId?: number | undefined;
    responsibleUserIds?: number[] | undefined;
    addAsTaskPerResponsibleUser: boolean;
    projectRoleAccountableId?: number | undefined;
    accountableUserIds?: number[] | undefined;
    projectRoleConsultedId?: number | undefined;
    consultedUserIds?: number[] | undefined;
    projectRoleInformedId?: number | undefined;
    informedUserIds?: number[] | undefined;
    resourcePlanUsers?: ScheduleResourcePlanResponse[] | undefined;
    resourcePlanProjectTeams?: ScheduleResourcePlanResponse[] | undefined;
    markAsMilestone: boolean;
    markAsDeliverable: boolean;
    markTaskForQualityGate: boolean;
}

export class ScheduleResponseItemsResponseModel implements IScheduleResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ScheduleResponse[] | undefined;

    constructor(data?: IScheduleResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScheduleResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduleResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScheduleResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ScheduleResponse[] | undefined;
}

export class ScheduleResponseSimpleResponseModel implements IScheduleResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ScheduleResponse;

    constructor(data?: IScheduleResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ScheduleResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduleResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IScheduleResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ScheduleResponse;
}

export class ScheduleUtilizationDashboardFilterRequest implements IScheduleUtilizationDashboardFilterRequest {
    organizationalUnitIds?: number[] | undefined;
    from?: Date | undefined;
    to?: Date | undefined;

    constructor(data?: IScheduleUtilizationDashboardFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizationalUnitIds"])) {
                this.organizationalUnitIds = [] as any;
                for (let item of _data["organizationalUnitIds"])
                    this.organizationalUnitIds!.push(item);
            }
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduleUtilizationDashboardFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleUtilizationDashboardFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizationalUnitIds)) {
            data["organizationalUnitIds"] = [];
            for (let item of this.organizationalUnitIds)
                data["organizationalUnitIds"].push(item);
        }
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        return data;
    }
}

export interface IScheduleUtilizationDashboardFilterRequest {
    organizationalUnitIds?: number[] | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
}

export class ScheduleUtilizationDashboardResponse implements IScheduleUtilizationDashboardResponse {
    plannedHours!: number;
    actualHours!: number;
    readonly difference!: number;

    constructor(data?: IScheduleUtilizationDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedHours = _data["plannedHours"];
            this.actualHours = _data["actualHours"];
            (this as any).difference = _data["difference"];
        }
    }

    static fromJS(data: any): ScheduleUtilizationDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleUtilizationDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedHours"] = this.plannedHours;
        data["actualHours"] = this.actualHours;
        data["difference"] = this.difference;
        return data;
    }
}

export interface IScheduleUtilizationDashboardResponse {
    plannedHours: number;
    actualHours: number;
    difference: number;
}

export class ScheduleUtilizationRowDashboardResponse implements IScheduleUtilizationRowDashboardResponse {
    userId!: number;
    totalPotentialHours!: number;
    totalPlannedHours!: number;
    totalActualHours!: number;
    readonly plannedUtilization!: number;
    readonly actualUtilization!: number;
    daysHours?: ScheduleDayUtilizationDashboardResponse[] | undefined;

    constructor(data?: IScheduleUtilizationRowDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.totalPotentialHours = _data["totalPotentialHours"];
            this.totalPlannedHours = _data["totalPlannedHours"];
            this.totalActualHours = _data["totalActualHours"];
            (this as any).plannedUtilization = _data["plannedUtilization"];
            (this as any).actualUtilization = _data["actualUtilization"];
            if (Array.isArray(_data["daysHours"])) {
                this.daysHours = [] as any;
                for (let item of _data["daysHours"])
                    this.daysHours!.push(ScheduleDayUtilizationDashboardResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduleUtilizationRowDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleUtilizationRowDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["totalPotentialHours"] = this.totalPotentialHours;
        data["totalPlannedHours"] = this.totalPlannedHours;
        data["totalActualHours"] = this.totalActualHours;
        data["plannedUtilization"] = this.plannedUtilization;
        data["actualUtilization"] = this.actualUtilization;
        if (Array.isArray(this.daysHours)) {
            data["daysHours"] = [];
            for (let item of this.daysHours)
                data["daysHours"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScheduleUtilizationRowDashboardResponse {
    userId: number;
    totalPotentialHours: number;
    totalPlannedHours: number;
    totalActualHours: number;
    plannedUtilization: number;
    actualUtilization: number;
    daysHours?: ScheduleDayUtilizationDashboardResponse[] | undefined;
}

export class ScheduleUtilizationRowDashboardResponseItemsResponseModel implements IScheduleUtilizationRowDashboardResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ScheduleUtilizationRowDashboardResponse[] | undefined;

    constructor(data?: IScheduleUtilizationRowDashboardResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScheduleUtilizationRowDashboardResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduleUtilizationRowDashboardResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleUtilizationRowDashboardResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScheduleUtilizationRowDashboardResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ScheduleUtilizationRowDashboardResponse[] | undefined;
}

export enum ScheduleWorkloadResourceUserPlanEnum {
    PlanWorkload = "PlanWorkload",
    PlanPerUserHours = "PlanPerUserHours",
}

export class ScopeChangeRequestsDashboardFilterRequest implements IScopeChangeRequestsDashboardFilterRequest {
    statusId?: number | undefined;
    typeId?: number | undefined;
    goLiveCritical?: boolean | undefined;
    priorityId?: number | undefined;

    constructor(data?: IScopeChangeRequestsDashboardFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusId = _data["statusId"];
            this.typeId = _data["typeId"];
            this.goLiveCritical = _data["goLiveCritical"];
            this.priorityId = _data["priorityId"];
        }
    }

    static fromJS(data: any): ScopeChangeRequestsDashboardFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeChangeRequestsDashboardFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusId"] = this.statusId;
        data["typeId"] = this.typeId;
        data["goLiveCritical"] = this.goLiveCritical;
        data["priorityId"] = this.priorityId;
        return data;
    }
}

export interface IScopeChangeRequestsDashboardFilterRequest {
    statusId?: number | undefined;
    typeId?: number | undefined;
    goLiveCritical?: boolean | undefined;
    priorityId?: number | undefined;
}

export class ScopeChangeRequestsDashboardResponse implements IScopeChangeRequestsDashboardResponse {
    countPerStatus?: { [key: string]: number; } | undefined;
    countPerType?: { [key: string]: number; } | undefined;
    countPerPriority?: { [key: string]: number; } | undefined;
    countPerCriticality?: { [key: string]: number; } | undefined;

    constructor(data?: IScopeChangeRequestsDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["countPerStatus"]) {
                this.countPerStatus = {} as any;
                for (let key in _data["countPerStatus"]) {
                    if (_data["countPerStatus"].hasOwnProperty(key))
                        (this.countPerStatus as any)![key] = _data["countPerStatus"][key];
                }
            }
            if (_data["countPerType"]) {
                this.countPerType = {} as any;
                for (let key in _data["countPerType"]) {
                    if (_data["countPerType"].hasOwnProperty(key))
                        (this.countPerType as any)![key] = _data["countPerType"][key];
                }
            }
            if (_data["countPerPriority"]) {
                this.countPerPriority = {} as any;
                for (let key in _data["countPerPriority"]) {
                    if (_data["countPerPriority"].hasOwnProperty(key))
                        (this.countPerPriority as any)![key] = _data["countPerPriority"][key];
                }
            }
            if (_data["countPerCriticality"]) {
                this.countPerCriticality = {} as any;
                for (let key in _data["countPerCriticality"]) {
                    if (_data["countPerCriticality"].hasOwnProperty(key))
                        (this.countPerCriticality as any)![key] = _data["countPerCriticality"][key];
                }
            }
        }
    }

    static fromJS(data: any): ScopeChangeRequestsDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeChangeRequestsDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.countPerStatus) {
            data["countPerStatus"] = {};
            for (let key in this.countPerStatus) {
                if (this.countPerStatus.hasOwnProperty(key))
                    (data["countPerStatus"] as any)[key] = (this.countPerStatus as any)[key];
            }
        }
        if (this.countPerType) {
            data["countPerType"] = {};
            for (let key in this.countPerType) {
                if (this.countPerType.hasOwnProperty(key))
                    (data["countPerType"] as any)[key] = (this.countPerType as any)[key];
            }
        }
        if (this.countPerPriority) {
            data["countPerPriority"] = {};
            for (let key in this.countPerPriority) {
                if (this.countPerPriority.hasOwnProperty(key))
                    (data["countPerPriority"] as any)[key] = (this.countPerPriority as any)[key];
            }
        }
        if (this.countPerCriticality) {
            data["countPerCriticality"] = {};
            for (let key in this.countPerCriticality) {
                if (this.countPerCriticality.hasOwnProperty(key))
                    (data["countPerCriticality"] as any)[key] = (this.countPerCriticality as any)[key];
            }
        }
        return data;
    }
}

export interface IScopeChangeRequestsDashboardResponse {
    countPerStatus?: { [key: string]: number; } | undefined;
    countPerType?: { [key: string]: number; } | undefined;
    countPerPriority?: { [key: string]: number; } | undefined;
    countPerCriticality?: { [key: string]: number; } | undefined;
}

export class ScopeChangeRequestsDashboardResponseSimpleResponseModel implements IScopeChangeRequestsDashboardResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ScopeChangeRequestsDashboardResponse;

    constructor(data?: IScopeChangeRequestsDashboardResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ScopeChangeRequestsDashboardResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScopeChangeRequestsDashboardResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeChangeRequestsDashboardResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IScopeChangeRequestsDashboardResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ScopeChangeRequestsDashboardResponse;
}

export class ScopeItemLevelHasDiagramResponse implements IScopeItemLevelHasDiagramResponse {
    id!: number;
    levelNumber!: number;
    level1Name?: string | undefined;
    level1Description?: string | undefined;
    level2Name?: string | undefined;
    level2Description?: string | undefined;
    processId?: string | undefined;
    level3Description?: string | undefined;
    level1Order?: number | undefined;
    level2Order?: number | undefined;
    level3Order?: number | undefined;

    constructor(data?: IScopeItemLevelHasDiagramResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.levelNumber = _data["levelNumber"];
            this.level1Name = _data["level1Name"];
            this.level1Description = _data["level1Description"];
            this.level2Name = _data["level2Name"];
            this.level2Description = _data["level2Description"];
            this.processId = _data["processId"];
            this.level3Description = _data["level3Description"];
            this.level1Order = _data["level1Order"];
            this.level2Order = _data["level2Order"];
            this.level3Order = _data["level3Order"];
        }
    }

    static fromJS(data: any): ScopeItemLevelHasDiagramResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeItemLevelHasDiagramResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["levelNumber"] = this.levelNumber;
        data["level1Name"] = this.level1Name;
        data["level1Description"] = this.level1Description;
        data["level2Name"] = this.level2Name;
        data["level2Description"] = this.level2Description;
        data["processId"] = this.processId;
        data["level3Description"] = this.level3Description;
        data["level1Order"] = this.level1Order;
        data["level2Order"] = this.level2Order;
        data["level3Order"] = this.level3Order;
        return data;
    }
}

export interface IScopeItemLevelHasDiagramResponse {
    id: number;
    levelNumber: number;
    level1Name?: string | undefined;
    level1Description?: string | undefined;
    level2Name?: string | undefined;
    level2Description?: string | undefined;
    processId?: string | undefined;
    level3Description?: string | undefined;
    level1Order?: number | undefined;
    level2Order?: number | undefined;
    level3Order?: number | undefined;
}

export class ScopeItemLevelHasDiagramResponseItemsResponseModel implements IScopeItemLevelHasDiagramResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ScopeItemLevelHasDiagramResponse[] | undefined;

    constructor(data?: IScopeItemLevelHasDiagramResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScopeItemLevelHasDiagramResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScopeItemLevelHasDiagramResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeItemLevelHasDiagramResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScopeItemLevelHasDiagramResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ScopeItemLevelHasDiagramResponse[] | undefined;
}

export class ScopeItemLevelReportResponse implements IScopeItemLevelReportResponse {
    id!: number;
    level1Id!: number;
    level1Name?: string | undefined;
    level1Description?: string | undefined;
    level1HasDiagram!: boolean;
    level2Id!: number;
    level2Name?: string | undefined;
    level2Description?: string | undefined;
    level2HasDiagram!: boolean;
    level3Name?: string | undefined;
    level3Description?: string | undefined;
    level3HasDiagram!: boolean;
    processDescription?: string | undefined;
    ticketId?: number | undefined;
    processVariant!: boolean;
    relatedScopeItemLevelId?: number | undefined;
    regressionRelevant!: boolean;
    regressionDependecies?: string | undefined;
    stressTestRelevant!: boolean;
    environmentId?: number | undefined;
    level3CustomText1?: string | undefined;
    level3CustomText2?: string | undefined;
    processId?: string | undefined;
    level4Id?: string | undefined;
    level4Name?: string | undefined;
    scopeDepartmentId?: number | undefined;
    scopeStepTypeId?: number | undefined;
    scopeUserRoleId?: number | undefined;
    level4InputDocument?: string | undefined;
    level4OutputDocument?: string | undefined;
    level4CustomText1?: string | undefined;
    level4CustomText2?: string | undefined;
    level1Order?: number | undefined;
    level2Order?: number | undefined;
    level3Order?: number | undefined;
    level4Order?: number | undefined;
    changeRequestIds?: number[] | undefined;
    designAttachments?: AttachmentResponse[] | undefined;

    constructor(data?: IScopeItemLevelReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.level1Id = _data["level1Id"];
            this.level1Name = _data["level1Name"];
            this.level1Description = _data["level1Description"];
            this.level1HasDiagram = _data["level1HasDiagram"];
            this.level2Id = _data["level2Id"];
            this.level2Name = _data["level2Name"];
            this.level2Description = _data["level2Description"];
            this.level2HasDiagram = _data["level2HasDiagram"];
            this.level3Name = _data["level3Name"];
            this.level3Description = _data["level3Description"];
            this.level3HasDiagram = _data["level3HasDiagram"];
            this.processDescription = _data["processDescription"];
            this.ticketId = _data["ticketId"];
            this.processVariant = _data["processVariant"];
            this.relatedScopeItemLevelId = _data["relatedScopeItemLevelId"];
            this.regressionRelevant = _data["regressionRelevant"];
            this.regressionDependecies = _data["regressionDependecies"];
            this.stressTestRelevant = _data["stressTestRelevant"];
            this.environmentId = _data["environmentId"];
            this.level3CustomText1 = _data["level3CustomText1"];
            this.level3CustomText2 = _data["level3CustomText2"];
            this.processId = _data["processId"];
            this.level4Id = _data["level4Id"];
            this.level4Name = _data["level4Name"];
            this.scopeDepartmentId = _data["scopeDepartmentId"];
            this.scopeStepTypeId = _data["scopeStepTypeId"];
            this.scopeUserRoleId = _data["scopeUserRoleId"];
            this.level4InputDocument = _data["level4InputDocument"];
            this.level4OutputDocument = _data["level4OutputDocument"];
            this.level4CustomText1 = _data["level4CustomText1"];
            this.level4CustomText2 = _data["level4CustomText2"];
            this.level1Order = _data["level1Order"];
            this.level2Order = _data["level2Order"];
            this.level3Order = _data["level3Order"];
            this.level4Order = _data["level4Order"];
            if (Array.isArray(_data["changeRequestIds"])) {
                this.changeRequestIds = [] as any;
                for (let item of _data["changeRequestIds"])
                    this.changeRequestIds!.push(item);
            }
            if (Array.isArray(_data["designAttachments"])) {
                this.designAttachments = [] as any;
                for (let item of _data["designAttachments"])
                    this.designAttachments!.push(AttachmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScopeItemLevelReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeItemLevelReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["level1Id"] = this.level1Id;
        data["level1Name"] = this.level1Name;
        data["level1Description"] = this.level1Description;
        data["level1HasDiagram"] = this.level1HasDiagram;
        data["level2Id"] = this.level2Id;
        data["level2Name"] = this.level2Name;
        data["level2Description"] = this.level2Description;
        data["level2HasDiagram"] = this.level2HasDiagram;
        data["level3Name"] = this.level3Name;
        data["level3Description"] = this.level3Description;
        data["level3HasDiagram"] = this.level3HasDiagram;
        data["processDescription"] = this.processDescription;
        data["ticketId"] = this.ticketId;
        data["processVariant"] = this.processVariant;
        data["relatedScopeItemLevelId"] = this.relatedScopeItemLevelId;
        data["regressionRelevant"] = this.regressionRelevant;
        data["regressionDependecies"] = this.regressionDependecies;
        data["stressTestRelevant"] = this.stressTestRelevant;
        data["environmentId"] = this.environmentId;
        data["level3CustomText1"] = this.level3CustomText1;
        data["level3CustomText2"] = this.level3CustomText2;
        data["processId"] = this.processId;
        data["level4Id"] = this.level4Id;
        data["level4Name"] = this.level4Name;
        data["scopeDepartmentId"] = this.scopeDepartmentId;
        data["scopeStepTypeId"] = this.scopeStepTypeId;
        data["scopeUserRoleId"] = this.scopeUserRoleId;
        data["level4InputDocument"] = this.level4InputDocument;
        data["level4OutputDocument"] = this.level4OutputDocument;
        data["level4CustomText1"] = this.level4CustomText1;
        data["level4CustomText2"] = this.level4CustomText2;
        data["level1Order"] = this.level1Order;
        data["level2Order"] = this.level2Order;
        data["level3Order"] = this.level3Order;
        data["level4Order"] = this.level4Order;
        if (Array.isArray(this.changeRequestIds)) {
            data["changeRequestIds"] = [];
            for (let item of this.changeRequestIds)
                data["changeRequestIds"].push(item);
        }
        if (Array.isArray(this.designAttachments)) {
            data["designAttachments"] = [];
            for (let item of this.designAttachments)
                data["designAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScopeItemLevelReportResponse {
    id: number;
    level1Id: number;
    level1Name?: string | undefined;
    level1Description?: string | undefined;
    level1HasDiagram: boolean;
    level2Id: number;
    level2Name?: string | undefined;
    level2Description?: string | undefined;
    level2HasDiagram: boolean;
    level3Name?: string | undefined;
    level3Description?: string | undefined;
    level3HasDiagram: boolean;
    processDescription?: string | undefined;
    ticketId?: number | undefined;
    processVariant: boolean;
    relatedScopeItemLevelId?: number | undefined;
    regressionRelevant: boolean;
    regressionDependecies?: string | undefined;
    stressTestRelevant: boolean;
    environmentId?: number | undefined;
    level3CustomText1?: string | undefined;
    level3CustomText2?: string | undefined;
    processId?: string | undefined;
    level4Id?: string | undefined;
    level4Name?: string | undefined;
    scopeDepartmentId?: number | undefined;
    scopeStepTypeId?: number | undefined;
    scopeUserRoleId?: number | undefined;
    level4InputDocument?: string | undefined;
    level4OutputDocument?: string | undefined;
    level4CustomText1?: string | undefined;
    level4CustomText2?: string | undefined;
    level1Order?: number | undefined;
    level2Order?: number | undefined;
    level3Order?: number | undefined;
    level4Order?: number | undefined;
    changeRequestIds?: number[] | undefined;
    designAttachments?: AttachmentResponse[] | undefined;
}

export class ScopeItemLevelReportResponseItemsResponseModel implements IScopeItemLevelReportResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ScopeItemLevelReportResponse[] | undefined;

    constructor(data?: IScopeItemLevelReportResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScopeItemLevelReportResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScopeItemLevelReportResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeItemLevelReportResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScopeItemLevelReportResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ScopeItemLevelReportResponse[] | undefined;
}

export class ScopeItemLevelResponse implements IScopeItemLevelResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    projectId!: number;
    fullname?: string | undefined;
    parentId?: number | undefined;
    levelNumber!: number;
    processDescription?: string | undefined;
    ticketId?: number | undefined;
    processVariant!: boolean;
    relatedScopeItemLevelId?: number | undefined;
    regressionRelevant!: boolean;
    regressionDependecies?: string | undefined;
    stressTestRelevant!: boolean;
    environmentId?: number | undefined;
    inputDocument?: string | undefined;
    outputDocument?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    hasDiagram!: boolean;
    scopeDepartmentId?: number | undefined;
    scopeStepTypeId?: number | undefined;
    scopeUserRoleId?: number | undefined;
    isComplex!: boolean;
    order!: number;
    complexForScopeItemId?: number | undefined;
    changeRequestIds?: number[] | undefined;
    designAttachments?: AttachmentResponse[] | undefined;
    trainingAttachments?: AttachmentResponse[] | undefined;
    otherAttachments?: AttachmentResponse[] | undefined;

    constructor(data?: IScopeItemLevelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.projectId = _data["projectId"];
            this.fullname = _data["fullname"];
            this.parentId = _data["parentId"];
            this.levelNumber = _data["levelNumber"];
            this.processDescription = _data["processDescription"];
            this.ticketId = _data["ticketId"];
            this.processVariant = _data["processVariant"];
            this.relatedScopeItemLevelId = _data["relatedScopeItemLevelId"];
            this.regressionRelevant = _data["regressionRelevant"];
            this.regressionDependecies = _data["regressionDependecies"];
            this.stressTestRelevant = _data["stressTestRelevant"];
            this.environmentId = _data["environmentId"];
            this.inputDocument = _data["inputDocument"];
            this.outputDocument = _data["outputDocument"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.hasDiagram = _data["hasDiagram"];
            this.scopeDepartmentId = _data["scopeDepartmentId"];
            this.scopeStepTypeId = _data["scopeStepTypeId"];
            this.scopeUserRoleId = _data["scopeUserRoleId"];
            this.isComplex = _data["isComplex"];
            this.order = _data["order"];
            this.complexForScopeItemId = _data["complexForScopeItemId"];
            if (Array.isArray(_data["changeRequestIds"])) {
                this.changeRequestIds = [] as any;
                for (let item of _data["changeRequestIds"])
                    this.changeRequestIds!.push(item);
            }
            if (Array.isArray(_data["designAttachments"])) {
                this.designAttachments = [] as any;
                for (let item of _data["designAttachments"])
                    this.designAttachments!.push(AttachmentResponse.fromJS(item));
            }
            if (Array.isArray(_data["trainingAttachments"])) {
                this.trainingAttachments = [] as any;
                for (let item of _data["trainingAttachments"])
                    this.trainingAttachments!.push(AttachmentResponse.fromJS(item));
            }
            if (Array.isArray(_data["otherAttachments"])) {
                this.otherAttachments = [] as any;
                for (let item of _data["otherAttachments"])
                    this.otherAttachments!.push(AttachmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScopeItemLevelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeItemLevelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        data["fullname"] = this.fullname;
        data["parentId"] = this.parentId;
        data["levelNumber"] = this.levelNumber;
        data["processDescription"] = this.processDescription;
        data["ticketId"] = this.ticketId;
        data["processVariant"] = this.processVariant;
        data["relatedScopeItemLevelId"] = this.relatedScopeItemLevelId;
        data["regressionRelevant"] = this.regressionRelevant;
        data["regressionDependecies"] = this.regressionDependecies;
        data["stressTestRelevant"] = this.stressTestRelevant;
        data["environmentId"] = this.environmentId;
        data["inputDocument"] = this.inputDocument;
        data["outputDocument"] = this.outputDocument;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["hasDiagram"] = this.hasDiagram;
        data["scopeDepartmentId"] = this.scopeDepartmentId;
        data["scopeStepTypeId"] = this.scopeStepTypeId;
        data["scopeUserRoleId"] = this.scopeUserRoleId;
        data["isComplex"] = this.isComplex;
        data["order"] = this.order;
        data["complexForScopeItemId"] = this.complexForScopeItemId;
        if (Array.isArray(this.changeRequestIds)) {
            data["changeRequestIds"] = [];
            for (let item of this.changeRequestIds)
                data["changeRequestIds"].push(item);
        }
        if (Array.isArray(this.designAttachments)) {
            data["designAttachments"] = [];
            for (let item of this.designAttachments)
                data["designAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.trainingAttachments)) {
            data["trainingAttachments"] = [];
            for (let item of this.trainingAttachments)
                data["trainingAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.otherAttachments)) {
            data["otherAttachments"] = [];
            for (let item of this.otherAttachments)
                data["otherAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScopeItemLevelResponse {
    id: number;
    name: string;
    description?: string | undefined;
    projectId: number;
    fullname?: string | undefined;
    parentId?: number | undefined;
    levelNumber: number;
    processDescription?: string | undefined;
    ticketId?: number | undefined;
    processVariant: boolean;
    relatedScopeItemLevelId?: number | undefined;
    regressionRelevant: boolean;
    regressionDependecies?: string | undefined;
    stressTestRelevant: boolean;
    environmentId?: number | undefined;
    inputDocument?: string | undefined;
    outputDocument?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    hasDiagram: boolean;
    scopeDepartmentId?: number | undefined;
    scopeStepTypeId?: number | undefined;
    scopeUserRoleId?: number | undefined;
    isComplex: boolean;
    order: number;
    complexForScopeItemId?: number | undefined;
    changeRequestIds?: number[] | undefined;
    designAttachments?: AttachmentResponse[] | undefined;
    trainingAttachments?: AttachmentResponse[] | undefined;
    otherAttachments?: AttachmentResponse[] | undefined;
}

export class ScopeItemLevelResponseItemsResponseModel implements IScopeItemLevelResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ScopeItemLevelResponse[] | undefined;

    constructor(data?: IScopeItemLevelResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScopeItemLevelResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScopeItemLevelResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeItemLevelResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScopeItemLevelResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ScopeItemLevelResponse[] | undefined;
}

export class ScopeItemLevelResponseSimpleResponseModel implements IScopeItemLevelResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ScopeItemLevelResponse;

    constructor(data?: IScopeItemLevelResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ScopeItemLevelResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScopeItemLevelResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeItemLevelResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IScopeItemLevelResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ScopeItemLevelResponse;
}

export class ScopeLevelAttachmentResponse implements IScopeLevelAttachmentResponse {
    id!: number;
    accessType!: AttachmentAccessEnum;
    uri?: string | undefined;
    contentType?: string | undefined;
    userId!: number;
    date!: Date;
    levelNumber!: number;
    processId!: string;
    processName!: string;
    processDocumentName?: string | undefined;
    stepId?: string | undefined;
    stepName?: string | undefined;
    stepDocumentName?: string | undefined;

    constructor(data?: IScopeLevelAttachmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accessType = _data["accessType"];
            this.uri = _data["uri"];
            this.contentType = _data["contentType"];
            this.userId = _data["userId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.levelNumber = _data["levelNumber"];
            this.processId = _data["processId"];
            this.processName = _data["processName"];
            this.processDocumentName = _data["processDocumentName"];
            this.stepId = _data["stepId"];
            this.stepName = _data["stepName"];
            this.stepDocumentName = _data["stepDocumentName"];
        }
    }

    static fromJS(data: any): ScopeLevelAttachmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeLevelAttachmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accessType"] = this.accessType;
        data["uri"] = this.uri;
        data["contentType"] = this.contentType;
        data["userId"] = this.userId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["levelNumber"] = this.levelNumber;
        data["processId"] = this.processId;
        data["processName"] = this.processName;
        data["processDocumentName"] = this.processDocumentName;
        data["stepId"] = this.stepId;
        data["stepName"] = this.stepName;
        data["stepDocumentName"] = this.stepDocumentName;
        return data;
    }
}

export interface IScopeLevelAttachmentResponse {
    id: number;
    accessType: AttachmentAccessEnum;
    uri?: string | undefined;
    contentType?: string | undefined;
    userId: number;
    date: Date;
    levelNumber: number;
    processId: string;
    processName: string;
    processDocumentName?: string | undefined;
    stepId?: string | undefined;
    stepName?: string | undefined;
    stepDocumentName?: string | undefined;
}

export class ScopeLevelAttachmentResponseItemsResponseModel implements IScopeLevelAttachmentResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ScopeLevelAttachmentResponse[] | undefined;

    constructor(data?: IScopeLevelAttachmentResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScopeLevelAttachmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScopeLevelAttachmentResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeLevelAttachmentResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScopeLevelAttachmentResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: ScopeLevelAttachmentResponse[] | undefined;
}

export class ScopePermission implements IScopePermission {
    scope!: boolean;
    maintainScope!: boolean;
    viewAllChangeRequests!: boolean;

    constructor(data?: IScopePermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scope = _data["scope"];
            this.maintainScope = _data["maintainScope"];
            this.viewAllChangeRequests = _data["viewAllChangeRequests"];
        }
    }

    static fromJS(data: any): ScopePermission {
        data = typeof data === 'object' ? data : {};
        let result = new ScopePermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scope"] = this.scope;
        data["maintainScope"] = this.maintainScope;
        data["viewAllChangeRequests"] = this.viewAllChangeRequests;
        return data;
    }
}

export interface IScopePermission {
    scope: boolean;
    maintainScope: boolean;
    viewAllChangeRequests: boolean;
}

export class ScopeProcessesDashboardFilterRequest implements IScopeProcessesDashboardFilterRequest {
    lvl1Id?: number | undefined;
    lvl2Id?: number | undefined;

    constructor(data?: IScopeProcessesDashboardFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lvl1Id = _data["lvl1Id"];
            this.lvl2Id = _data["lvl2Id"];
        }
    }

    static fromJS(data: any): ScopeProcessesDashboardFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeProcessesDashboardFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lvl1Id"] = this.lvl1Id;
        data["lvl2Id"] = this.lvl2Id;
        return data;
    }
}

export interface IScopeProcessesDashboardFilterRequest {
    lvl1Id?: number | undefined;
    lvl2Id?: number | undefined;
}

export class ScopeProcessesDashboardResponse implements IScopeProcessesDashboardResponse {
    processesPerLvl1?: { [key: string]: number; } | undefined;
    lvl1sCount!: number;
    lvl2sCount!: number;
    lvl3sCount!: number;
    lvl4sCount!: number;

    constructor(data?: IScopeProcessesDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["processesPerLvl1"]) {
                this.processesPerLvl1 = {} as any;
                for (let key in _data["processesPerLvl1"]) {
                    if (_data["processesPerLvl1"].hasOwnProperty(key))
                        (this.processesPerLvl1 as any)![key] = _data["processesPerLvl1"][key];
                }
            }
            this.lvl1sCount = _data["lvl1sCount"];
            this.lvl2sCount = _data["lvl2sCount"];
            this.lvl3sCount = _data["lvl3sCount"];
            this.lvl4sCount = _data["lvl4sCount"];
        }
    }

    static fromJS(data: any): ScopeProcessesDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeProcessesDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.processesPerLvl1) {
            data["processesPerLvl1"] = {};
            for (let key in this.processesPerLvl1) {
                if (this.processesPerLvl1.hasOwnProperty(key))
                    (data["processesPerLvl1"] as any)[key] = (this.processesPerLvl1 as any)[key];
            }
        }
        data["lvl1sCount"] = this.lvl1sCount;
        data["lvl2sCount"] = this.lvl2sCount;
        data["lvl3sCount"] = this.lvl3sCount;
        data["lvl4sCount"] = this.lvl4sCount;
        return data;
    }
}

export interface IScopeProcessesDashboardResponse {
    processesPerLvl1?: { [key: string]: number; } | undefined;
    lvl1sCount: number;
    lvl2sCount: number;
    lvl3sCount: number;
    lvl4sCount: number;
}

export class ScopeProcessesDashboardResponseSimpleResponseModel implements IScopeProcessesDashboardResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ScopeProcessesDashboardResponse;

    constructor(data?: IScopeProcessesDashboardResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? ScopeProcessesDashboardResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScopeProcessesDashboardResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeProcessesDashboardResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IScopeProcessesDashboardResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: ScopeProcessesDashboardResponse;
}

export class SendEmailRequestModel implements ISendEmailRequestModel {
    templateName?: string | undefined;
    languageCode?: string | undefined;
    templateVariables?: { [key: string]: string; } | undefined;
    emails?: string[] | undefined;

    constructor(data?: ISendEmailRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateName = _data["templateName"];
            this.languageCode = _data["languageCode"];
            if (_data["templateVariables"]) {
                this.templateVariables = {} as any;
                for (let key in _data["templateVariables"]) {
                    if (_data["templateVariables"].hasOwnProperty(key))
                        (this.templateVariables as any)![key] = _data["templateVariables"][key];
                }
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): SendEmailRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateName"] = this.templateName;
        data["languageCode"] = this.languageCode;
        if (this.templateVariables) {
            data["templateVariables"] = {};
            for (let key in this.templateVariables) {
                if (this.templateVariables.hasOwnProperty(key))
                    (data["templateVariables"] as any)[key] = (this.templateVariables as any)[key];
            }
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export interface ISendEmailRequestModel {
    templateName?: string | undefined;
    languageCode?: string | undefined;
    templateVariables?: { [key: string]: string; } | undefined;
    emails?: string[] | undefined;
}

export class SetDefaultProjectRequest implements ISetDefaultProjectRequest {
    userId!: number;
    projectId!: number;

    constructor(data?: ISetDefaultProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): SetDefaultProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ISetDefaultProjectRequest {
    userId: number;
    projectId: number;
}

export enum ShowTestStatusEnum {
    ShowTestStatus = "ShowTestStatus",
    ShowProcessSteps = "ShowProcessSteps",
    ShowMultipleTickets = "ShowMultipleTickets",
}

export class SimpleChangeRequestResponse implements ISimpleChangeRequestResponse {
    id!: number;
    name!: string;
    projectId!: number;
    statusId!: number;

    constructor(data?: ISimpleChangeRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): SimpleChangeRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleChangeRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface ISimpleChangeRequestResponse {
    id: number;
    name: string;
    projectId: number;
    statusId: number;
}

export class SimpleChangeRequestResponseItemsResponseModel implements ISimpleChangeRequestResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SimpleChangeRequestResponse[] | undefined;

    constructor(data?: ISimpleChangeRequestResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SimpleChangeRequestResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimpleChangeRequestResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleChangeRequestResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISimpleChangeRequestResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SimpleChangeRequestResponse[] | undefined;
}

export class SimpleChangeRequestResponseSimpleResponseModel implements ISimpleChangeRequestResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: SimpleChangeRequestResponse;

    constructor(data?: ISimpleChangeRequestResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? SimpleChangeRequestResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): SimpleChangeRequestResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleChangeRequestResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ISimpleChangeRequestResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: SimpleChangeRequestResponse;
}

export class SimpleIdNameModel implements ISimpleIdNameModel {
    id!: number;
    name?: string | undefined;

    constructor(data?: ISimpleIdNameModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SimpleIdNameModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleIdNameModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISimpleIdNameModel {
    id: number;
    name?: string | undefined;
}

export class SimpleIdNameModelItemsResponseModel implements ISimpleIdNameModelItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SimpleIdNameModel[] | undefined;

    constructor(data?: ISimpleIdNameModelItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SimpleIdNameModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimpleIdNameModelItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleIdNameModelItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISimpleIdNameModelItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SimpleIdNameModel[] | undefined;
}

export class SimpleScheduleResponse implements ISimpleScheduleResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    wbs?: string | undefined;
    projectId!: number;

    constructor(data?: ISimpleScheduleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.wbs = _data["wbs"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): SimpleScheduleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleScheduleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["wbs"] = this.wbs;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ISimpleScheduleResponse {
    id: number;
    name: string;
    description?: string | undefined;
    wbs?: string | undefined;
    projectId: number;
}

export class SimpleScheduleResponseItemsResponseModel implements ISimpleScheduleResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SimpleScheduleResponse[] | undefined;

    constructor(data?: ISimpleScheduleResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SimpleScheduleResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimpleScheduleResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleScheduleResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISimpleScheduleResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SimpleScheduleResponse[] | undefined;
}

export class SimpleStatusRequest implements ISimpleStatusRequest {
    id!: number;
    description?: string | undefined;
    color!: string;
    order!: number;

    constructor(data?: ISimpleStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): SimpleStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["color"] = this.color;
        data["order"] = this.order;
        return data;
    }
}

export interface ISimpleStatusRequest {
    id: number;
    description?: string | undefined;
    color: string;
    order: number;
}

export class SimpleStatusRequestUpdateSimpleStatusRequestItems implements ISimpleStatusRequestUpdateSimpleStatusRequestItems {
    statuses!: SimpleStatusRequest[];

    constructor(data?: ISimpleStatusRequestUpdateSimpleStatusRequestItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.statuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(SimpleStatusRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimpleStatusRequestUpdateSimpleStatusRequestItems {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleStatusRequestUpdateSimpleStatusRequestItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISimpleStatusRequestUpdateSimpleStatusRequestItems {
    statuses: SimpleStatusRequest[];
}

export class SimpleUserIdProjectIdPair implements ISimpleUserIdProjectIdPair {
    userId!: number;
    projectId!: number;

    constructor(data?: ISimpleUserIdProjectIdPair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): SimpleUserIdProjectIdPair {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleUserIdProjectIdPair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ISimpleUserIdProjectIdPair {
    userId: number;
    projectId: number;
}

export class SimpleUserIdProjectIdPairItemsResponseModel implements ISimpleUserIdProjectIdPairItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SimpleUserIdProjectIdPair[] | undefined;

    constructor(data?: ISimpleUserIdProjectIdPairItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SimpleUserIdProjectIdPair.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimpleUserIdProjectIdPairItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleUserIdProjectIdPairItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISimpleUserIdProjectIdPairItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SimpleUserIdProjectIdPair[] | undefined;
}

export class StatusDeltaRequest implements IStatusDeltaRequest {
    insert?: InsertStatusRequest[] | undefined;
    update?: UpdateStatusRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;

    constructor(data?: IStatusDeltaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertStatusRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateStatusRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteTenantIndetifyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatusDeltaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatusDeltaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStatusDeltaRequest {
    insert?: InsertStatusRequest[] | undefined;
    update?: UpdateStatusRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;
}

export class StatusReportGeneralConfigResponse implements IStatusReportGeneralConfigResponse {
    id!: number;
    enableNotifications!: boolean;

    constructor(data?: IStatusReportGeneralConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enableNotifications = _data["enableNotifications"];
        }
    }

    static fromJS(data: any): StatusReportGeneralConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusReportGeneralConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enableNotifications"] = this.enableNotifications;
        return data;
    }
}

export interface IStatusReportGeneralConfigResponse {
    id: number;
    enableNotifications: boolean;
}

export class StatusReportGeneralConfigResponseSimpleResponseModel implements IStatusReportGeneralConfigResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: StatusReportGeneralConfigResponse;

    constructor(data?: IStatusReportGeneralConfigResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? StatusReportGeneralConfigResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): StatusReportGeneralConfigResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatusReportGeneralConfigResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IStatusReportGeneralConfigResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: StatusReportGeneralConfigResponse;
}

export class StatusReportResponse implements IStatusReportResponse {
    id!: number;
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    statusId!: number;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    reportDate!: Date;
    from?: Date | undefined;
    to?: Date | undefined;
    createdByUserId!: number;
    releasedByUserId?: number | undefined;
    alignedByUserId?: number | undefined;
    responsibleUserId?: number | undefined;
    notifyResponsibleUser!: boolean;
    openIssues!: string;
    keyRisks!: string;
    nextSteps!: string;
    overallStatus!: ReportStatusAreaEnum;
    overallStatusAndKeyAchievements!: string;

    constructor(data?: IStatusReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.statusId = _data["statusId"];
            this.projectTeamId = _data["projectTeamId"];
            this.projectOrganizationId = _data["projectOrganizationId"];
            this.reportDate = _data["reportDate"] ? new Date(_data["reportDate"].toString()) : undefined as any;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.createdByUserId = _data["createdByUserId"];
            this.releasedByUserId = _data["releasedByUserId"];
            this.alignedByUserId = _data["alignedByUserId"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.notifyResponsibleUser = _data["notifyResponsibleUser"];
            this.openIssues = _data["openIssues"];
            this.keyRisks = _data["keyRisks"];
            this.nextSteps = _data["nextSteps"];
            this.overallStatus = _data["overallStatus"];
            this.overallStatusAndKeyAchievements = _data["overallStatusAndKeyAchievements"];
        }
    }

    static fromJS(data: any): StatusReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["statusId"] = this.statusId;
        data["projectTeamId"] = this.projectTeamId;
        data["projectOrganizationId"] = this.projectOrganizationId;
        data["reportDate"] = this.reportDate ? formatDate(this.reportDate) : undefined as any;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["createdByUserId"] = this.createdByUserId;
        data["releasedByUserId"] = this.releasedByUserId;
        data["alignedByUserId"] = this.alignedByUserId;
        data["responsibleUserId"] = this.responsibleUserId;
        data["notifyResponsibleUser"] = this.notifyResponsibleUser;
        data["openIssues"] = this.openIssues;
        data["keyRisks"] = this.keyRisks;
        data["nextSteps"] = this.nextSteps;
        data["overallStatus"] = this.overallStatus;
        data["overallStatusAndKeyAchievements"] = this.overallStatusAndKeyAchievements;
        return data;
    }
}

export interface IStatusReportResponse {
    id: number;
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    statusId: number;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    reportDate: Date;
    from?: Date | undefined;
    to?: Date | undefined;
    createdByUserId: number;
    releasedByUserId?: number | undefined;
    alignedByUserId?: number | undefined;
    responsibleUserId?: number | undefined;
    notifyResponsibleUser: boolean;
    openIssues: string;
    keyRisks: string;
    nextSteps: string;
    overallStatus: ReportStatusAreaEnum;
    overallStatusAndKeyAchievements: string;
}

export class StatusReportResponseItemsResponseModel implements IStatusReportResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: StatusReportResponse[] | undefined;

    constructor(data?: IStatusReportResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StatusReportResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatusReportResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatusReportResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStatusReportResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: StatusReportResponse[] | undefined;
}

export class StatusReportResponseSimpleResponseModel implements IStatusReportResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: StatusReportResponse;

    constructor(data?: IStatusReportResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? StatusReportResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): StatusReportResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatusReportResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IStatusReportResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: StatusReportResponse;
}

export enum StatusReportStatusEnum {
    Created = "Created",
    Released = "Released",
    Aligned = "Aligned",
}

export class StatusReportStatusResponse implements IStatusReportStatusResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isReadonly!: boolean;
    color!: string;
    isInitial!: boolean;
    nextStates?: number[] | undefined;
    order!: number;
    semantics!: StatusReportStatusEnum;

    constructor(data?: IStatusReportStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isReadonly = _data["isReadonly"];
            this.color = _data["color"];
            this.isInitial = _data["isInitial"];
            if (Array.isArray(_data["nextStates"])) {
                this.nextStates = [] as any;
                for (let item of _data["nextStates"])
                    this.nextStates!.push(item);
            }
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): StatusReportStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusReportStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isReadonly"] = this.isReadonly;
        data["color"] = this.color;
        data["isInitial"] = this.isInitial;
        if (Array.isArray(this.nextStates)) {
            data["nextStates"] = [];
            for (let item of this.nextStates)
                data["nextStates"].push(item);
        }
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IStatusReportStatusResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isReadonly: boolean;
    color: string;
    isInitial: boolean;
    nextStates?: number[] | undefined;
    order: number;
    semantics: StatusReportStatusEnum;
}

export class StatusReportStatusResponseItemsResponseModel implements IStatusReportStatusResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: StatusReportStatusResponse[] | undefined;

    constructor(data?: IStatusReportStatusResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StatusReportStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatusReportStatusResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatusReportStatusResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IStatusReportStatusResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: StatusReportStatusResponse[] | undefined;
}

export class StringNewOld implements IStringNewOld {
    oldValue?: string | undefined;
    newValue?: string | undefined;

    constructor(data?: IStringNewOld) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): StringNewOld {
        data = typeof data === 'object' ? data : {};
        let result = new StringNewOld();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IStringNewOld {
    oldValue?: string | undefined;
    newValue?: string | undefined;
}

export class StringSimpleResponseModel implements IStringSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: string | undefined;

    constructor(data?: IStringSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StringSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new StringSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value;
        return data;
    }
}

export interface IStringSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: string | undefined;
}

export class SubmitMySurveyRequest implements ISubmitMySurveyRequest {
    answers!: { [key: string]: InsertSurveyParticipantAnswerRequest[]; };

    constructor(data?: ISubmitMySurveyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.answers = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["answers"]) {
                this.answers = {} as any;
                for (let key in _data["answers"]) {
                    if (_data["answers"].hasOwnProperty(key))
                        (this.answers as any)![key] = _data["answers"][key] ? _data["answers"][key].map((i: any) => InsertSurveyParticipantAnswerRequest.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): SubmitMySurveyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitMySurveyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.answers) {
            data["answers"] = {};
            for (let key in this.answers) {
                if (this.answers.hasOwnProperty(key))
                    (data["answers"] as any)[key] = (this.answers as any)[key];
            }
        }
        return data;
    }
}

export interface ISubmitMySurveyRequest {
    answers: { [key: string]: InsertSurveyParticipantAnswerRequest[]; };
}

export class SurveyAnswerResponse implements ISurveyAnswerResponse {
    userId!: number;
    questionGroup?: string | undefined;
    question!: string;
    questionType!: SurveyQuestionTypeEnum;
    answer?: string | undefined;
    score?: number | undefined;

    constructor(data?: ISurveyAnswerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.questionGroup = _data["questionGroup"];
            this.question = _data["question"];
            this.questionType = _data["questionType"];
            this.answer = _data["answer"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): SurveyAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["questionGroup"] = this.questionGroup;
        data["question"] = this.question;
        data["questionType"] = this.questionType;
        data["answer"] = this.answer;
        data["score"] = this.score;
        return data;
    }
}

export interface ISurveyAnswerResponse {
    userId: number;
    questionGroup?: string | undefined;
    question: string;
    questionType: SurveyQuestionTypeEnum;
    answer?: string | undefined;
    score?: number | undefined;
}

export class SurveyAnswerResponseItemsResponseModel implements ISurveyAnswerResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SurveyAnswerResponse[] | undefined;

    constructor(data?: ISurveyAnswerResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SurveyAnswerResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyAnswerResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISurveyAnswerResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SurveyAnswerResponse[] | undefined;
}

export class SurveyDashboardFilterRequest implements ISurveyDashboardFilterRequest {
    userIds?: number[] | undefined;
    projectTeamIds?: number[] | undefined;
    projectRoleIds?: number[] | undefined;

    constructor(data?: ISurveyDashboardFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["projectTeamIds"])) {
                this.projectTeamIds = [] as any;
                for (let item of _data["projectTeamIds"])
                    this.projectTeamIds!.push(item);
            }
            if (Array.isArray(_data["projectRoleIds"])) {
                this.projectRoleIds = [] as any;
                for (let item of _data["projectRoleIds"])
                    this.projectRoleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SurveyDashboardFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyDashboardFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.projectTeamIds)) {
            data["projectTeamIds"] = [];
            for (let item of this.projectTeamIds)
                data["projectTeamIds"].push(item);
        }
        if (Array.isArray(this.projectRoleIds)) {
            data["projectRoleIds"] = [];
            for (let item of this.projectRoleIds)
                data["projectRoleIds"].push(item);
        }
        return data;
    }
}

export interface ISurveyDashboardFilterRequest {
    userIds?: number[] | undefined;
    projectTeamIds?: number[] | undefined;
    projectRoleIds?: number[] | undefined;
}

export class SurveyDashboardResponse implements ISurveyDashboardResponse {
    surveyType!: SurveyTypeEnum;
    surveysStatusCounts?: { [key: string]: number; } | undefined;
    averageRatingPerTeam?: { [key: string]: number; } | undefined;
    averageRatingPerRole?: { [key: string]: number; } | undefined;
    averageRatings?: RatingPerQuestionDashboardResponse[] | undefined;
    questionGroupAverageRatings?: RatingPerQuestionGroupDashboardResponse[] | undefined;
    textAnswers?: TextAnswersDashboardResponse[] | undefined;
    overallRating!: number;

    constructor(data?: ISurveyDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyType = _data["surveyType"];
            if (_data["surveysStatusCounts"]) {
                this.surveysStatusCounts = {} as any;
                for (let key in _data["surveysStatusCounts"]) {
                    if (_data["surveysStatusCounts"].hasOwnProperty(key))
                        (this.surveysStatusCounts as any)![key] = _data["surveysStatusCounts"][key];
                }
            }
            if (_data["averageRatingPerTeam"]) {
                this.averageRatingPerTeam = {} as any;
                for (let key in _data["averageRatingPerTeam"]) {
                    if (_data["averageRatingPerTeam"].hasOwnProperty(key))
                        (this.averageRatingPerTeam as any)![key] = _data["averageRatingPerTeam"][key];
                }
            }
            if (_data["averageRatingPerRole"]) {
                this.averageRatingPerRole = {} as any;
                for (let key in _data["averageRatingPerRole"]) {
                    if (_data["averageRatingPerRole"].hasOwnProperty(key))
                        (this.averageRatingPerRole as any)![key] = _data["averageRatingPerRole"][key];
                }
            }
            if (Array.isArray(_data["averageRatings"])) {
                this.averageRatings = [] as any;
                for (let item of _data["averageRatings"])
                    this.averageRatings!.push(RatingPerQuestionDashboardResponse.fromJS(item));
            }
            if (Array.isArray(_data["questionGroupAverageRatings"])) {
                this.questionGroupAverageRatings = [] as any;
                for (let item of _data["questionGroupAverageRatings"])
                    this.questionGroupAverageRatings!.push(RatingPerQuestionGroupDashboardResponse.fromJS(item));
            }
            if (Array.isArray(_data["textAnswers"])) {
                this.textAnswers = [] as any;
                for (let item of _data["textAnswers"])
                    this.textAnswers!.push(TextAnswersDashboardResponse.fromJS(item));
            }
            this.overallRating = _data["overallRating"];
        }
    }

    static fromJS(data: any): SurveyDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyType"] = this.surveyType;
        if (this.surveysStatusCounts) {
            data["surveysStatusCounts"] = {};
            for (let key in this.surveysStatusCounts) {
                if (this.surveysStatusCounts.hasOwnProperty(key))
                    (data["surveysStatusCounts"] as any)[key] = (this.surveysStatusCounts as any)[key];
            }
        }
        if (this.averageRatingPerTeam) {
            data["averageRatingPerTeam"] = {};
            for (let key in this.averageRatingPerTeam) {
                if (this.averageRatingPerTeam.hasOwnProperty(key))
                    (data["averageRatingPerTeam"] as any)[key] = (this.averageRatingPerTeam as any)[key];
            }
        }
        if (this.averageRatingPerRole) {
            data["averageRatingPerRole"] = {};
            for (let key in this.averageRatingPerRole) {
                if (this.averageRatingPerRole.hasOwnProperty(key))
                    (data["averageRatingPerRole"] as any)[key] = (this.averageRatingPerRole as any)[key];
            }
        }
        if (Array.isArray(this.averageRatings)) {
            data["averageRatings"] = [];
            for (let item of this.averageRatings)
                data["averageRatings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.questionGroupAverageRatings)) {
            data["questionGroupAverageRatings"] = [];
            for (let item of this.questionGroupAverageRatings)
                data["questionGroupAverageRatings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.textAnswers)) {
            data["textAnswers"] = [];
            for (let item of this.textAnswers)
                data["textAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        data["overallRating"] = this.overallRating;
        return data;
    }
}

export interface ISurveyDashboardResponse {
    surveyType: SurveyTypeEnum;
    surveysStatusCounts?: { [key: string]: number; } | undefined;
    averageRatingPerTeam?: { [key: string]: number; } | undefined;
    averageRatingPerRole?: { [key: string]: number; } | undefined;
    averageRatings?: RatingPerQuestionDashboardResponse[] | undefined;
    questionGroupAverageRatings?: RatingPerQuestionGroupDashboardResponse[] | undefined;
    textAnswers?: TextAnswersDashboardResponse[] | undefined;
    overallRating: number;
}

export class SurveyDashboardResponseSimpleResponseModel implements ISurveyDashboardResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: SurveyDashboardResponse;

    constructor(data?: ISurveyDashboardResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? SurveyDashboardResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): SurveyDashboardResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyDashboardResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ISurveyDashboardResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: SurveyDashboardResponse;
}

export class SurveyParticipantAnswerResponse implements ISurveyParticipantAnswerResponse {
    id!: number;
    answer?: string | undefined;
    rating?: number | undefined;
    proposedAnswerId?: number | undefined;

    constructor(data?: ISurveyParticipantAnswerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.answer = _data["answer"];
            this.rating = _data["rating"];
            this.proposedAnswerId = _data["proposedAnswerId"];
        }
    }

    static fromJS(data: any): SurveyParticipantAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyParticipantAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["answer"] = this.answer;
        data["rating"] = this.rating;
        data["proposedAnswerId"] = this.proposedAnswerId;
        return data;
    }
}

export interface ISurveyParticipantAnswerResponse {
    id: number;
    answer?: string | undefined;
    rating?: number | undefined;
    proposedAnswerId?: number | undefined;
}

export class SurveyParticipantResponse implements ISurveyParticipantResponse {
    id!: number;
    participantUserId!: number;
    statusId!: number;

    constructor(data?: ISurveyParticipantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.participantUserId = _data["participantUserId"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): SurveyParticipantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyParticipantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["participantUserId"] = this.participantUserId;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface ISurveyParticipantResponse {
    id: number;
    participantUserId: number;
    statusId: number;
}

export class SurveyParticipantResponseItemsResponseModel implements ISurveyParticipantResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SurveyParticipantResponse[] | undefined;

    constructor(data?: ISurveyParticipantResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SurveyParticipantResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyParticipantResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyParticipantResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISurveyParticipantResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SurveyParticipantResponse[] | undefined;
}

export class SurveyProposedAnswerDeltaRequest implements ISurveyProposedAnswerDeltaRequest {
    insert?: InsertSurveyProposedAnswerRequest[] | undefined;
    update?: UpdateSurveyProposedAnswerRequest[] | undefined;
    delete?: DeleteSurveyProposedAnswerRequest[] | undefined;

    constructor(data?: ISurveyProposedAnswerDeltaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertSurveyProposedAnswerRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateSurveyProposedAnswerRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteSurveyProposedAnswerRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyProposedAnswerDeltaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyProposedAnswerDeltaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISurveyProposedAnswerDeltaRequest {
    insert?: InsertSurveyProposedAnswerRequest[] | undefined;
    update?: UpdateSurveyProposedAnswerRequest[] | undefined;
    delete?: DeleteSurveyProposedAnswerRequest[] | undefined;
}

export class SurveyProposedAnswerResponse implements ISurveyProposedAnswerResponse {
    id!: number;
    answer!: string;
    points?: number | undefined;
    isCorrect!: boolean;

    constructor(data?: ISurveyProposedAnswerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.answer = _data["answer"];
            this.points = _data["points"];
            this.isCorrect = _data["isCorrect"];
        }
    }

    static fromJS(data: any): SurveyProposedAnswerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyProposedAnswerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["answer"] = this.answer;
        data["points"] = this.points;
        data["isCorrect"] = this.isCorrect;
        return data;
    }
}

export interface ISurveyProposedAnswerResponse {
    id: number;
    answer: string;
    points?: number | undefined;
    isCorrect: boolean;
}

export class SurveyQuestionResponse implements ISurveyQuestionResponse {
    id!: number;
    questionGroup?: string | undefined;
    question!: string;
    surveyType!: SurveyQuestionTypeEnum;
    answerRequired!: boolean;
    scoreQuestion!: boolean;
    order!: number;
    proposedAnswers?: SurveyProposedAnswerResponse[] | undefined;

    constructor(data?: ISurveyQuestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionGroup = _data["questionGroup"];
            this.question = _data["question"];
            this.surveyType = _data["surveyType"];
            this.answerRequired = _data["answerRequired"];
            this.scoreQuestion = _data["scoreQuestion"];
            this.order = _data["order"];
            if (Array.isArray(_data["proposedAnswers"])) {
                this.proposedAnswers = [] as any;
                for (let item of _data["proposedAnswers"])
                    this.proposedAnswers!.push(SurveyProposedAnswerResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyQuestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionGroup"] = this.questionGroup;
        data["question"] = this.question;
        data["surveyType"] = this.surveyType;
        data["answerRequired"] = this.answerRequired;
        data["scoreQuestion"] = this.scoreQuestion;
        data["order"] = this.order;
        if (Array.isArray(this.proposedAnswers)) {
            data["proposedAnswers"] = [];
            for (let item of this.proposedAnswers)
                data["proposedAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISurveyQuestionResponse {
    id: number;
    questionGroup?: string | undefined;
    question: string;
    surveyType: SurveyQuestionTypeEnum;
    answerRequired: boolean;
    scoreQuestion: boolean;
    order: number;
    proposedAnswers?: SurveyProposedAnswerResponse[] | undefined;
}

export class SurveyQuestionResponseItemsResponseModel implements ISurveyQuestionResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SurveyQuestionResponse[] | undefined;

    constructor(data?: ISurveyQuestionResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SurveyQuestionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyQuestionResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISurveyQuestionResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SurveyQuestionResponse[] | undefined;
}

export class SurveyQuestionResponseSimpleResponseModel implements ISurveyQuestionResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: SurveyQuestionResponse;

    constructor(data?: ISurveyQuestionResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? SurveyQuestionResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): SurveyQuestionResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ISurveyQuestionResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: SurveyQuestionResponse;
}

export enum SurveyQuestionTypeEnum {
    Rating = "Rating",
    MultipleChoice = "MultipleChoice",
    SingleChoice = "SingleChoice",
    Answer = "Answer",
}

export class SurveyResponse implements ISurveyResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    projectId!: number;
    surveyType!: SurveyTypeEnum;
    status!: SurveyStatusEnum;

    constructor(data?: ISurveyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.projectId = _data["projectId"];
            this.surveyType = _data["surveyType"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SurveyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        data["surveyType"] = this.surveyType;
        data["status"] = this.status;
        return data;
    }
}

export interface ISurveyResponse {
    id: number;
    name: string;
    description?: string | undefined;
    projectId: number;
    surveyType: SurveyTypeEnum;
    status: SurveyStatusEnum;
}

export class SurveyResponseItemsResponseModel implements ISurveyResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SurveyResponse[] | undefined;

    constructor(data?: ISurveyResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SurveyResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISurveyResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: SurveyResponse[] | undefined;
}

export class SurveyResponseSimpleResponseModel implements ISurveyResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: SurveyResponse;

    constructor(data?: ISurveyResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? SurveyResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): SurveyResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ISurveyResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: SurveyResponse;
}

export enum SurveyStatusEnum {
    Created = "Created",
    Released = "Released",
}

export enum SurveyTypeEnum {
    Quiz = "Quiz",
    Survey = "Survey",
}

export class TaskCommentResponse implements ITaskCommentResponse {
    id!: number;
    taskId!: number;
    comment!: string;
    userId!: number;
    createdOn!: Date;

    constructor(data?: ITaskCommentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskId = _data["taskId"];
            this.comment = _data["comment"];
            this.userId = _data["userId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TaskCommentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCommentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskId"] = this.taskId;
        data["comment"] = this.comment;
        data["userId"] = this.userId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface ITaskCommentResponse {
    id: number;
    taskId: number;
    comment: string;
    userId: number;
    createdOn: Date;
}

export class TaskCommentResponseItemsResponseModel implements ITaskCommentResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TaskCommentResponse[] | undefined;

    constructor(data?: ITaskCommentResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TaskCommentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskCommentResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCommentResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskCommentResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TaskCommentResponse[] | undefined;
}

export class TaskCommentResponseSimpleResponseModel implements ITaskCommentResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TaskCommentResponse;

    constructor(data?: ITaskCommentResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TaskCommentResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TaskCommentResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCommentResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaskCommentResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TaskCommentResponse;
}

export class TaskGeneralConfigResponse implements ITaskGeneralConfigResponse {
    id!: number;
    notifyWhenAssignedToUser!: boolean;
    enableEmailNotifications!: boolean;

    constructor(data?: ITaskGeneralConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.notifyWhenAssignedToUser = _data["notifyWhenAssignedToUser"];
            this.enableEmailNotifications = _data["enableEmailNotifications"];
        }
    }

    static fromJS(data: any): TaskGeneralConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskGeneralConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["notifyWhenAssignedToUser"] = this.notifyWhenAssignedToUser;
        data["enableEmailNotifications"] = this.enableEmailNotifications;
        return data;
    }
}

export interface ITaskGeneralConfigResponse {
    id: number;
    notifyWhenAssignedToUser: boolean;
    enableEmailNotifications: boolean;
}

export class TaskGeneralConfigResponseSimpleResponseModel implements ITaskGeneralConfigResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TaskGeneralConfigResponse;

    constructor(data?: ITaskGeneralConfigResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TaskGeneralConfigResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TaskGeneralConfigResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskGeneralConfigResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaskGeneralConfigResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TaskGeneralConfigResponse;
}

export class TaskHistoryResponse implements ITaskHistoryResponse {
    taskId!: number;
    userId!: number;
    updatedOn!: Date;
    assignedToUserId?: IntNewOld;
    createdByUserId?: IntNewOld;
    closedByUserId?: IntNewOld;
    due?: DateTimeNewOld;
    createdOn?: DateTimeNewOld;
    closedOn?: DateTimeNewOld;
    isPrivate!: BoolNewOld;
    description!: StringNewOld;
    statusId?: IntNewOld;
    parentTaskId?: IntNewOld;
    riskId?: IntNewOld;
    scopeItemLevelId?: IntNewOld;
    changeRequestId?: IntNewOld;
    ticketId?: IntNewOld;
    meetingId?: IntNewOld;
    nonProjectCategoryId?: IntNewOld;

    constructor(data?: ITaskHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.isPrivate = new BoolNewOld();
            this.description = new StringNewOld();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.userId = _data["userId"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.assignedToUserId = _data["assignedToUserId"] ? IntNewOld.fromJS(_data["assignedToUserId"]) : undefined as any;
            this.createdByUserId = _data["createdByUserId"] ? IntNewOld.fromJS(_data["createdByUserId"]) : undefined as any;
            this.closedByUserId = _data["closedByUserId"] ? IntNewOld.fromJS(_data["closedByUserId"]) : undefined as any;
            this.due = _data["due"] ? DateTimeNewOld.fromJS(_data["due"]) : undefined as any;
            this.createdOn = _data["createdOn"] ? DateTimeNewOld.fromJS(_data["createdOn"]) : undefined as any;
            this.closedOn = _data["closedOn"] ? DateTimeNewOld.fromJS(_data["closedOn"]) : undefined as any;
            this.isPrivate = _data["isPrivate"] ? BoolNewOld.fromJS(_data["isPrivate"]) : new BoolNewOld();
            this.description = _data["description"] ? StringNewOld.fromJS(_data["description"]) : new StringNewOld();
            this.statusId = _data["statusId"] ? IntNewOld.fromJS(_data["statusId"]) : undefined as any;
            this.parentTaskId = _data["parentTaskId"] ? IntNewOld.fromJS(_data["parentTaskId"]) : undefined as any;
            this.riskId = _data["riskId"] ? IntNewOld.fromJS(_data["riskId"]) : undefined as any;
            this.scopeItemLevelId = _data["scopeItemLevelId"] ? IntNewOld.fromJS(_data["scopeItemLevelId"]) : undefined as any;
            this.changeRequestId = _data["changeRequestId"] ? IntNewOld.fromJS(_data["changeRequestId"]) : undefined as any;
            this.ticketId = _data["ticketId"] ? IntNewOld.fromJS(_data["ticketId"]) : undefined as any;
            this.meetingId = _data["meetingId"] ? IntNewOld.fromJS(_data["meetingId"]) : undefined as any;
            this.nonProjectCategoryId = _data["nonProjectCategoryId"] ? IntNewOld.fromJS(_data["nonProjectCategoryId"]) : undefined as any;
        }
    }

    static fromJS(data: any): TaskHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["userId"] = this.userId;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["assignedToUserId"] = this.assignedToUserId ? this.assignedToUserId.toJSON() : undefined as any;
        data["createdByUserId"] = this.createdByUserId ? this.createdByUserId.toJSON() : undefined as any;
        data["closedByUserId"] = this.closedByUserId ? this.closedByUserId.toJSON() : undefined as any;
        data["due"] = this.due ? this.due.toJSON() : undefined as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toJSON() : undefined as any;
        data["closedOn"] = this.closedOn ? this.closedOn.toJSON() : undefined as any;
        data["isPrivate"] = this.isPrivate ? this.isPrivate.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["statusId"] = this.statusId ? this.statusId.toJSON() : undefined as any;
        data["parentTaskId"] = this.parentTaskId ? this.parentTaskId.toJSON() : undefined as any;
        data["riskId"] = this.riskId ? this.riskId.toJSON() : undefined as any;
        data["scopeItemLevelId"] = this.scopeItemLevelId ? this.scopeItemLevelId.toJSON() : undefined as any;
        data["changeRequestId"] = this.changeRequestId ? this.changeRequestId.toJSON() : undefined as any;
        data["ticketId"] = this.ticketId ? this.ticketId.toJSON() : undefined as any;
        data["meetingId"] = this.meetingId ? this.meetingId.toJSON() : undefined as any;
        data["nonProjectCategoryId"] = this.nonProjectCategoryId ? this.nonProjectCategoryId.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaskHistoryResponse {
    taskId: number;
    userId: number;
    updatedOn: Date;
    assignedToUserId?: IntNewOld;
    createdByUserId?: IntNewOld;
    closedByUserId?: IntNewOld;
    due?: DateTimeNewOld;
    createdOn?: DateTimeNewOld;
    closedOn?: DateTimeNewOld;
    isPrivate: BoolNewOld;
    description: StringNewOld;
    statusId?: IntNewOld;
    parentTaskId?: IntNewOld;
    riskId?: IntNewOld;
    scopeItemLevelId?: IntNewOld;
    changeRequestId?: IntNewOld;
    ticketId?: IntNewOld;
    meetingId?: IntNewOld;
    nonProjectCategoryId?: IntNewOld;
}

export class TaskHistoryResponseItemsResponseModel implements ITaskHistoryResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TaskHistoryResponse[] | undefined;

    constructor(data?: ITaskHistoryResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TaskHistoryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskHistoryResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskHistoryResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskHistoryResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TaskHistoryResponse[] | undefined;
}

export enum TaskPriorityEnum {
    Low = "Low",
    Medium = "Medium",
    High = "High",
    VeryHigh = "VeryHigh",
    Critical = "Critical",
}

export class TaskResponse implements ITaskResponse {
    id!: number;
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    assignedToUserId!: number;
    createdByUserId!: number;
    closedByUserId?: number | undefined;
    due!: Date;
    createdOn!: Date;
    closedOn?: Date | undefined;
    isPrivate!: boolean;
    description?: string | undefined;
    statusId!: number;
    parentTaskId?: number | undefined;
    riskId?: number | undefined;
    scopeItemLevelId?: number | undefined;
    changeRequestId?: number | undefined;
    ticketId?: number | undefined;
    meetingId?: number | undefined;
    scheduleId?: number | undefined;
    projectOrganizationId?: number | undefined;
    isScheduleGenerated!: boolean;
    isMeetingGenerated!: boolean;
    isTicketGenerated!: boolean;
    priority?: TaskPriorityEnum;
    estimatedEffort?: number | undefined;
    follow!: boolean;
    totalEffort?: number | undefined;
    projectTypeId?: number | undefined;
    projectCategoryId?: number | undefined;
    organizationalUnitId?: number | undefined;
    attachments?: AttachmentResponse[] | undefined;

    constructor(data?: ITaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.createdByUserId = _data["createdByUserId"];
            this.closedByUserId = _data["closedByUserId"];
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.closedOn = _data["closedOn"] ? new Date(_data["closedOn"].toString()) : undefined as any;
            this.isPrivate = _data["isPrivate"];
            this.description = _data["description"];
            this.statusId = _data["statusId"];
            this.parentTaskId = _data["parentTaskId"];
            this.riskId = _data["riskId"];
            this.scopeItemLevelId = _data["scopeItemLevelId"];
            this.changeRequestId = _data["changeRequestId"];
            this.ticketId = _data["ticketId"];
            this.meetingId = _data["meetingId"];
            this.scheduleId = _data["scheduleId"];
            this.projectOrganizationId = _data["projectOrganizationId"];
            this.isScheduleGenerated = _data["isScheduleGenerated"];
            this.isMeetingGenerated = _data["isMeetingGenerated"];
            this.isTicketGenerated = _data["isTicketGenerated"];
            this.priority = _data["priority"];
            this.estimatedEffort = _data["estimatedEffort"];
            this.follow = _data["follow"];
            this.totalEffort = _data["totalEffort"];
            this.projectTypeId = _data["projectTypeId"];
            this.projectCategoryId = _data["projectCategoryId"];
            this.organizationalUnitId = _data["organizationalUnitId"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["assignedToUserId"] = this.assignedToUserId;
        data["createdByUserId"] = this.createdByUserId;
        data["closedByUserId"] = this.closedByUserId;
        data["due"] = this.due ? formatDate(this.due) : undefined as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["closedOn"] = this.closedOn ? this.closedOn.toISOString() : undefined as any;
        data["isPrivate"] = this.isPrivate;
        data["description"] = this.description;
        data["statusId"] = this.statusId;
        data["parentTaskId"] = this.parentTaskId;
        data["riskId"] = this.riskId;
        data["scopeItemLevelId"] = this.scopeItemLevelId;
        data["changeRequestId"] = this.changeRequestId;
        data["ticketId"] = this.ticketId;
        data["meetingId"] = this.meetingId;
        data["scheduleId"] = this.scheduleId;
        data["projectOrganizationId"] = this.projectOrganizationId;
        data["isScheduleGenerated"] = this.isScheduleGenerated;
        data["isMeetingGenerated"] = this.isMeetingGenerated;
        data["isTicketGenerated"] = this.isTicketGenerated;
        data["priority"] = this.priority;
        data["estimatedEffort"] = this.estimatedEffort;
        data["follow"] = this.follow;
        data["totalEffort"] = this.totalEffort;
        data["projectTypeId"] = this.projectTypeId;
        data["projectCategoryId"] = this.projectCategoryId;
        data["organizationalUnitId"] = this.organizationalUnitId;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskResponse {
    id: number;
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    assignedToUserId: number;
    createdByUserId: number;
    closedByUserId?: number | undefined;
    due: Date;
    createdOn: Date;
    closedOn?: Date | undefined;
    isPrivate: boolean;
    description?: string | undefined;
    statusId: number;
    parentTaskId?: number | undefined;
    riskId?: number | undefined;
    scopeItemLevelId?: number | undefined;
    changeRequestId?: number | undefined;
    ticketId?: number | undefined;
    meetingId?: number | undefined;
    scheduleId?: number | undefined;
    projectOrganizationId?: number | undefined;
    isScheduleGenerated: boolean;
    isMeetingGenerated: boolean;
    isTicketGenerated: boolean;
    priority?: TaskPriorityEnum;
    estimatedEffort?: number | undefined;
    follow: boolean;
    totalEffort?: number | undefined;
    projectTypeId?: number | undefined;
    projectCategoryId?: number | undefined;
    organizationalUnitId?: number | undefined;
    attachments?: AttachmentResponse[] | undefined;
}

export class TaskResponseItemsResponseModel implements ITaskResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TaskResponse[] | undefined;

    constructor(data?: ITaskResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TaskResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TaskResponse[] | undefined;
}

export class TaskResponseSimpleResponseModel implements ITaskResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TaskResponse;

    constructor(data?: ITaskResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TaskResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TaskResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaskResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TaskResponse;
}

export enum TaskStatusEnum {
    Open = "Open",
    InProgress = "InProgress",
    Completed = "Completed",
    Canceled = "Canceled",
}

export class TaskStatusResponse implements ITaskStatusResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isReadonly!: boolean;
    color!: string;
    isInitial!: boolean;
    nextStates?: number[] | undefined;
    order!: number;
    semantics!: TaskStatusEnum;

    constructor(data?: ITaskStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isReadonly = _data["isReadonly"];
            this.color = _data["color"];
            this.isInitial = _data["isInitial"];
            if (Array.isArray(_data["nextStates"])) {
                this.nextStates = [] as any;
                for (let item of _data["nextStates"])
                    this.nextStates!.push(item);
            }
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): TaskStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isReadonly"] = this.isReadonly;
        data["color"] = this.color;
        data["isInitial"] = this.isInitial;
        if (Array.isArray(this.nextStates)) {
            data["nextStates"] = [];
            for (let item of this.nextStates)
                data["nextStates"].push(item);
        }
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface ITaskStatusResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isReadonly: boolean;
    color: string;
    isInitial: boolean;
    nextStates?: number[] | undefined;
    order: number;
    semantics: TaskStatusEnum;
}

export class TaskStatusResponseItemsResponseModel implements ITaskStatusResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TaskStatusResponse[] | undefined;

    constructor(data?: ITaskStatusResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TaskStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskStatusResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskStatusResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskStatusResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TaskStatusResponse[] | undefined;
}

export class TaskTimesheetDeltaRequest implements ITaskTimesheetDeltaRequest {
    insert?: InsertTaskTimesheetRequest[] | undefined;
    update?: UpdateTaskTimesheetRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;

    constructor(data?: ITaskTimesheetDeltaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertTaskTimesheetRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateTaskTimesheetRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteTenantIndetifyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskTimesheetDeltaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TaskTimesheetDeltaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskTimesheetDeltaRequest {
    insert?: InsertTaskTimesheetRequest[] | undefined;
    update?: UpdateTaskTimesheetRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;
}

export class TaskTimesheetResponse implements ITaskTimesheetResponse {
    id!: number;
    projectId!: number;
    userId!: number;
    date!: Date;
    statusId!: number;
    effort!: number;
    estimatedTime?: number | undefined;

    constructor(data?: ITaskTimesheetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.effort = _data["effort"];
            this.estimatedTime = _data["estimatedTime"];
        }
    }

    static fromJS(data: any): TaskTimesheetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskTimesheetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["statusId"] = this.statusId;
        data["effort"] = this.effort;
        data["estimatedTime"] = this.estimatedTime;
        return data;
    }
}

export interface ITaskTimesheetResponse {
    id: number;
    projectId: number;
    userId: number;
    date: Date;
    statusId: number;
    effort: number;
    estimatedTime?: number | undefined;
}

export class TaskTimesheetResponseItemsResponseModel implements ITaskTimesheetResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TaskTimesheetResponse[] | undefined;

    constructor(data?: ITaskTimesheetResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TaskTimesheetResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskTimesheetResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskTimesheetResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskTimesheetResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TaskTimesheetResponse[] | undefined;
}

export class TenantIsActiveDeltaRequest implements ITenantIsActiveDeltaRequest {
    insert?: InsertTenantIsActiveRequest[] | undefined;
    update?: UpdateTenantIsActiveRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;

    constructor(data?: ITenantIsActiveDeltaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertTenantIsActiveRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateTenantIsActiveRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteTenantIndetifyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantIsActiveDeltaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TenantIsActiveDeltaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITenantIsActiveDeltaRequest {
    insert?: InsertTenantIsActiveRequest[] | undefined;
    update?: UpdateTenantIsActiveRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;
}

export class TenantIsActiveOrderDeltaRequest implements ITenantIsActiveOrderDeltaRequest {
    insert?: InsertTenantIsActiveOrderRequest[] | undefined;
    update?: UpdateTenantIsActiveOrderRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;

    constructor(data?: ITenantIsActiveOrderDeltaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertTenantIsActiveOrderRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateTenantIsActiveOrderRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteTenantIndetifyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantIsActiveOrderDeltaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TenantIsActiveOrderDeltaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITenantIsActiveOrderDeltaRequest {
    insert?: InsertTenantIsActiveOrderRequest[] | undefined;
    update?: UpdateTenantIsActiveOrderRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;
}

export class TenantIsActiveResponse implements ITenantIsActiveResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;

    constructor(data?: ITenantIsActiveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TenantIsActiveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantIsActiveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITenantIsActiveResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
}

export class TenantIsActiveResponseItemsResponseModel implements ITenantIsActiveResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TenantIsActiveResponse[] | undefined;

    constructor(data?: ITenantIsActiveResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantIsActiveResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantIsActiveResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantIsActiveResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITenantIsActiveResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TenantIsActiveResponse[] | undefined;
}

export class TenantIsActiveResponseSimpleResponseModel implements ITenantIsActiveResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TenantIsActiveResponse;

    constructor(data?: ITenantIsActiveResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TenantIsActiveResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TenantIsActiveResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantIsActiveResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITenantIsActiveResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TenantIsActiveResponse;
}

export class TenantRegistrationConfirmRequestModel implements ITenantRegistrationConfirmRequestModel {
    token!: string;
    userId!: number;
    tenantId!: number;

    constructor(data?: ITenantRegistrationConfirmRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): TenantRegistrationConfirmRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantRegistrationConfirmRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ITenantRegistrationConfirmRequestModel {
    token: string;
    userId: number;
    tenantId: number;
}

export class TenantRegistrationConfirmStatusResponseModel implements ITenantRegistrationConfirmStatusResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    isInProgress!: boolean;
    isFinished!: boolean;
    link!: string;

    constructor(data?: ITenantRegistrationConfirmStatusResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.isInProgress = _data["isInProgress"];
            this.isFinished = _data["isFinished"];
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): TenantRegistrationConfirmStatusResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantRegistrationConfirmStatusResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["isInProgress"] = this.isInProgress;
        data["isFinished"] = this.isFinished;
        data["link"] = this.link;
        return data;
    }
}

export interface ITenantRegistrationConfirmStatusResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    isInProgress: boolean;
    isFinished: boolean;
    link: string;
}

export class TenantRegistrationRequestModel implements ITenantRegistrationRequestModel {
    domain!: string;
    email!: string;
    teamSizeId!: number;
    phone?: string | undefined;
    password?: string | undefined;
    username!: string;

    constructor(data?: ITenantRegistrationRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domain = _data["domain"];
            this.email = _data["email"];
            this.teamSizeId = _data["teamSizeId"];
            this.phone = _data["phone"];
            this.password = _data["password"];
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): TenantRegistrationRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantRegistrationRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        data["email"] = this.email;
        data["teamSizeId"] = this.teamSizeId;
        data["phone"] = this.phone;
        data["password"] = this.password;
        data["username"] = this.username;
        return data;
    }
}

export interface ITenantRegistrationRequestModel {
    domain: string;
    email: string;
    teamSizeId: number;
    phone?: string | undefined;
    password?: string | undefined;
    username: string;
}

export class TenantResponseModel implements ITenantResponseModel {
    id!: number;
    domain!: string;
    industryId!: number;
    countryId!: number;
    currencyId!: number;
    teamSizeId!: number;
    language!: LanguagesEnum;
    datePatternId!: number;
    timePatternId!: number;
    timeZoneIncrement!: number;
    timeZoneName?: string | undefined;
    numberFormat?: string | undefined;
    isInitialized!: boolean;
    datePattern?: DateTimePatternResponse;
    timePattern?: DateTimePatternResponse;

    constructor(data?: ITenantResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.domain = _data["domain"];
            this.industryId = _data["industryId"];
            this.countryId = _data["countryId"];
            this.currencyId = _data["currencyId"];
            this.teamSizeId = _data["teamSizeId"];
            this.language = _data["language"];
            this.datePatternId = _data["datePatternId"];
            this.timePatternId = _data["timePatternId"];
            this.timeZoneIncrement = _data["timeZoneIncrement"];
            this.timeZoneName = _data["timeZoneName"];
            this.numberFormat = _data["numberFormat"];
            this.isInitialized = _data["isInitialized"];
            this.datePattern = _data["datePattern"] ? DateTimePatternResponse.fromJS(_data["datePattern"]) : undefined as any;
            this.timePattern = _data["timePattern"] ? DateTimePatternResponse.fromJS(_data["timePattern"]) : undefined as any;
        }
    }

    static fromJS(data: any): TenantResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["domain"] = this.domain;
        data["industryId"] = this.industryId;
        data["countryId"] = this.countryId;
        data["currencyId"] = this.currencyId;
        data["teamSizeId"] = this.teamSizeId;
        data["language"] = this.language;
        data["datePatternId"] = this.datePatternId;
        data["timePatternId"] = this.timePatternId;
        data["timeZoneIncrement"] = this.timeZoneIncrement;
        data["timeZoneName"] = this.timeZoneName;
        data["numberFormat"] = this.numberFormat;
        data["isInitialized"] = this.isInitialized;
        data["datePattern"] = this.datePattern ? this.datePattern.toJSON() : undefined as any;
        data["timePattern"] = this.timePattern ? this.timePattern.toJSON() : undefined as any;
        return data;
    }
}

export interface ITenantResponseModel {
    id: number;
    domain: string;
    industryId: number;
    countryId: number;
    currencyId: number;
    teamSizeId: number;
    language: LanguagesEnum;
    datePatternId: number;
    timePatternId: number;
    timeZoneIncrement: number;
    timeZoneName?: string | undefined;
    numberFormat?: string | undefined;
    isInitialized: boolean;
    datePattern?: DateTimePatternResponse;
    timePattern?: DateTimePatternResponse;
}

export class TenantResponseModelSimpleResponseModel implements ITenantResponseModelSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TenantResponseModel;

    constructor(data?: ITenantResponseModelSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TenantResponseModel.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TenantResponseModelSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantResponseModelSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITenantResponseModelSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TenantResponseModel;
}

export class TenantUpdateRequestModel implements ITenantUpdateRequestModel {
    id!: number;
    industryId!: number;
    countryId!: number;
    currencyId!: number;
    teamSizeId!: number;
    timeZoneIncrement!: number;
    timeZoneName!: string;
    numberFormat!: string;
    language!: LanguagesEnum;
    datePatternId!: number;
    timePatternId!: number;

    constructor(data?: ITenantUpdateRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.industryId = _data["industryId"];
            this.countryId = _data["countryId"];
            this.currencyId = _data["currencyId"];
            this.teamSizeId = _data["teamSizeId"];
            this.timeZoneIncrement = _data["timeZoneIncrement"];
            this.timeZoneName = _data["timeZoneName"];
            this.numberFormat = _data["numberFormat"];
            this.language = _data["language"];
            this.datePatternId = _data["datePatternId"];
            this.timePatternId = _data["timePatternId"];
        }
    }

    static fromJS(data: any): TenantUpdateRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUpdateRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["industryId"] = this.industryId;
        data["countryId"] = this.countryId;
        data["currencyId"] = this.currencyId;
        data["teamSizeId"] = this.teamSizeId;
        data["timeZoneIncrement"] = this.timeZoneIncrement;
        data["timeZoneName"] = this.timeZoneName;
        data["numberFormat"] = this.numberFormat;
        data["language"] = this.language;
        data["datePatternId"] = this.datePatternId;
        data["timePatternId"] = this.timePatternId;
        return data;
    }
}

export interface ITenantUpdateRequestModel {
    id: number;
    industryId: number;
    countryId: number;
    currencyId: number;
    teamSizeId: number;
    timeZoneIncrement: number;
    timeZoneName: string;
    numberFormat: string;
    language: LanguagesEnum;
    datePatternId: number;
    timePatternId: number;
}

export class TestDashboardFilterRequest implements ITestDashboardFilterRequest {
    level1Ids?: number[] | undefined;
    level2Ids?: number[] | undefined;
    processTesterIds?: number[] | undefined;
    stepTesterIds?: number[] | undefined;

    constructor(data?: ITestDashboardFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["level1Ids"])) {
                this.level1Ids = [] as any;
                for (let item of _data["level1Ids"])
                    this.level1Ids!.push(item);
            }
            if (Array.isArray(_data["level2Ids"])) {
                this.level2Ids = [] as any;
                for (let item of _data["level2Ids"])
                    this.level2Ids!.push(item);
            }
            if (Array.isArray(_data["processTesterIds"])) {
                this.processTesterIds = [] as any;
                for (let item of _data["processTesterIds"])
                    this.processTesterIds!.push(item);
            }
            if (Array.isArray(_data["stepTesterIds"])) {
                this.stepTesterIds = [] as any;
                for (let item of _data["stepTesterIds"])
                    this.stepTesterIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TestDashboardFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TestDashboardFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.level1Ids)) {
            data["level1Ids"] = [];
            for (let item of this.level1Ids)
                data["level1Ids"].push(item);
        }
        if (Array.isArray(this.level2Ids)) {
            data["level2Ids"] = [];
            for (let item of this.level2Ids)
                data["level2Ids"].push(item);
        }
        if (Array.isArray(this.processTesterIds)) {
            data["processTesterIds"] = [];
            for (let item of this.processTesterIds)
                data["processTesterIds"].push(item);
        }
        if (Array.isArray(this.stepTesterIds)) {
            data["stepTesterIds"] = [];
            for (let item of this.stepTesterIds)
                data["stepTesterIds"].push(item);
        }
        return data;
    }
}

export interface ITestDashboardFilterRequest {
    level1Ids?: number[] | undefined;
    level2Ids?: number[] | undefined;
    processTesterIds?: number[] | undefined;
    stepTesterIds?: number[] | undefined;
}

export class TestDashboardResponse implements ITestDashboardResponse {
    statuses?: TestDashboardStatusesResponse[] | undefined;
    testCasesCount!: number;
    processTestersCount!: number;
    stepTestersCount!: number;
    ticketsCount!: number;
    plannedDateCount!: number;
    actualDateCount!: number;

    constructor(data?: ITestDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(TestDashboardStatusesResponse.fromJS(item));
            }
            this.testCasesCount = _data["testCasesCount"];
            this.processTestersCount = _data["processTestersCount"];
            this.stepTestersCount = _data["stepTestersCount"];
            this.ticketsCount = _data["ticketsCount"];
            this.plannedDateCount = _data["plannedDateCount"];
            this.actualDateCount = _data["actualDateCount"];
        }
    }

    static fromJS(data: any): TestDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TestDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : undefined as any);
        }
        data["testCasesCount"] = this.testCasesCount;
        data["processTestersCount"] = this.processTestersCount;
        data["stepTestersCount"] = this.stepTestersCount;
        data["ticketsCount"] = this.ticketsCount;
        data["plannedDateCount"] = this.plannedDateCount;
        data["actualDateCount"] = this.actualDateCount;
        return data;
    }
}

export interface ITestDashboardResponse {
    statuses?: TestDashboardStatusesResponse[] | undefined;
    testCasesCount: number;
    processTestersCount: number;
    stepTestersCount: number;
    ticketsCount: number;
    plannedDateCount: number;
    actualDateCount: number;
}

export class TestDashboardResponseSimpleResponseModel implements ITestDashboardResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TestDashboardResponse;

    constructor(data?: ITestDashboardResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TestDashboardResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TestDashboardResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TestDashboardResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITestDashboardResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TestDashboardResponse;
}

export class TestDashboardStatusesResponse implements ITestDashboardStatusesResponse {
    level1Id!: number;
    level1Name?: string | undefined;
    statusCounts?: { [key: string]: number; } | undefined;

    constructor(data?: ITestDashboardStatusesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level1Id = _data["level1Id"];
            this.level1Name = _data["level1Name"];
            if (_data["statusCounts"]) {
                this.statusCounts = {} as any;
                for (let key in _data["statusCounts"]) {
                    if (_data["statusCounts"].hasOwnProperty(key))
                        (this.statusCounts as any)![key] = _data["statusCounts"][key];
                }
            }
        }
    }

    static fromJS(data: any): TestDashboardStatusesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TestDashboardStatusesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level1Id"] = this.level1Id;
        data["level1Name"] = this.level1Name;
        if (this.statusCounts) {
            data["statusCounts"] = {};
            for (let key in this.statusCounts) {
                if (this.statusCounts.hasOwnProperty(key))
                    (data["statusCounts"] as any)[key] = (this.statusCounts as any)[key];
            }
        }
        return data;
    }
}

export interface ITestDashboardStatusesResponse {
    level1Id: number;
    level1Name?: string | undefined;
    statusCounts?: { [key: string]: number; } | undefined;
}

export class TestingPermission implements ITestingPermission {
    testing!: boolean;
    createTestCycle!: boolean;
    maintainTestPlan!: boolean;

    constructor(data?: ITestingPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.testing = _data["testing"];
            this.createTestCycle = _data["createTestCycle"];
            this.maintainTestPlan = _data["maintainTestPlan"];
        }
    }

    static fromJS(data: any): TestingPermission {
        data = typeof data === 'object' ? data : {};
        let result = new TestingPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testing"] = this.testing;
        data["createTestCycle"] = this.createTestCycle;
        data["maintainTestPlan"] = this.maintainTestPlan;
        return data;
    }
}

export interface ITestingPermission {
    testing: boolean;
    createTestCycle: boolean;
    maintainTestPlan: boolean;
}

export class TestPlanHistoryResponse implements ITestPlanHistoryResponse {
    testPlanId!: number;
    processOrStepId?: string | undefined;
    userId!: number;
    updatedOn!: Date;
    statusId?: IntNewOld;

    constructor(data?: ITestPlanHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.testPlanId = _data["testPlanId"];
            this.processOrStepId = _data["processOrStepId"];
            this.userId = _data["userId"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.statusId = _data["statusId"] ? IntNewOld.fromJS(_data["statusId"]) : undefined as any;
        }
    }

    static fromJS(data: any): TestPlanHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TestPlanHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testPlanId"] = this.testPlanId;
        data["processOrStepId"] = this.processOrStepId;
        data["userId"] = this.userId;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["statusId"] = this.statusId ? this.statusId.toJSON() : undefined as any;
        return data;
    }
}

export interface ITestPlanHistoryResponse {
    testPlanId: number;
    processOrStepId?: string | undefined;
    userId: number;
    updatedOn: Date;
    statusId?: IntNewOld;
}

export class TestPlanHistoryResponseItemsResponseModel implements ITestPlanHistoryResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TestPlanHistoryResponse[] | undefined;

    constructor(data?: ITestPlanHistoryResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TestPlanHistoryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TestPlanHistoryResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TestPlanHistoryResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITestPlanHistoryResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TestPlanHistoryResponse[] | undefined;
}

export class TestPlanResponse implements ITestPlanResponse {
    id!: number;
    testCycleId!: number;
    level1Id?: string | undefined;
    level1Name?: string | undefined;
    level2Id?: string | undefined;
    level2Name?: string | undefined;
    level3ProcessId?: string | undefined;
    level3ProcessName?: string | undefined;
    processDescription?: string | undefined;
    processTesterUserId?: number | undefined;
    processStatusId!: number;
    comments?: string | undefined;
    lastChangedByUserId?: number | undefined;
    lastChanged?: Date | undefined;
    plannedDate?: Date | undefined;
    plannedTime?: number | undefined;
    plannedTimeTo?: number | undefined;
    duration?: number | undefined;
    changeRequestIds?: number[] | undefined;
    ticketIds?: number[] | undefined;
    scopeDesignAttachments?: AttachmentResponse[] | undefined;
    scopeTrainingAttachments?: AttachmentResponse[] | undefined;
    scopeOtherAttachments?: AttachmentResponse[] | undefined;
    testPlanAttachments?: AttachmentResponse[] | undefined;
    innerTestPlans?: InnerTestPlanResponse[] | undefined;

    constructor(data?: ITestPlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.testCycleId = _data["testCycleId"];
            this.level1Id = _data["level1Id"];
            this.level1Name = _data["level1Name"];
            this.level2Id = _data["level2Id"];
            this.level2Name = _data["level2Name"];
            this.level3ProcessId = _data["level3ProcessId"];
            this.level3ProcessName = _data["level3ProcessName"];
            this.processDescription = _data["processDescription"];
            this.processTesterUserId = _data["processTesterUserId"];
            this.processStatusId = _data["processStatusId"];
            this.comments = _data["comments"];
            this.lastChangedByUserId = _data["lastChangedByUserId"];
            this.lastChanged = _data["lastChanged"] ? new Date(_data["lastChanged"].toString()) : undefined as any;
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.plannedTime = _data["plannedTime"];
            this.plannedTimeTo = _data["plannedTimeTo"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["changeRequestIds"])) {
                this.changeRequestIds = [] as any;
                for (let item of _data["changeRequestIds"])
                    this.changeRequestIds!.push(item);
            }
            if (Array.isArray(_data["ticketIds"])) {
                this.ticketIds = [] as any;
                for (let item of _data["ticketIds"])
                    this.ticketIds!.push(item);
            }
            if (Array.isArray(_data["scopeDesignAttachments"])) {
                this.scopeDesignAttachments = [] as any;
                for (let item of _data["scopeDesignAttachments"])
                    this.scopeDesignAttachments!.push(AttachmentResponse.fromJS(item));
            }
            if (Array.isArray(_data["scopeTrainingAttachments"])) {
                this.scopeTrainingAttachments = [] as any;
                for (let item of _data["scopeTrainingAttachments"])
                    this.scopeTrainingAttachments!.push(AttachmentResponse.fromJS(item));
            }
            if (Array.isArray(_data["scopeOtherAttachments"])) {
                this.scopeOtherAttachments = [] as any;
                for (let item of _data["scopeOtherAttachments"])
                    this.scopeOtherAttachments!.push(AttachmentResponse.fromJS(item));
            }
            if (Array.isArray(_data["testPlanAttachments"])) {
                this.testPlanAttachments = [] as any;
                for (let item of _data["testPlanAttachments"])
                    this.testPlanAttachments!.push(AttachmentResponse.fromJS(item));
            }
            if (Array.isArray(_data["innerTestPlans"])) {
                this.innerTestPlans = [] as any;
                for (let item of _data["innerTestPlans"])
                    this.innerTestPlans!.push(InnerTestPlanResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TestPlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TestPlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["testCycleId"] = this.testCycleId;
        data["level1Id"] = this.level1Id;
        data["level1Name"] = this.level1Name;
        data["level2Id"] = this.level2Id;
        data["level2Name"] = this.level2Name;
        data["level3ProcessId"] = this.level3ProcessId;
        data["level3ProcessName"] = this.level3ProcessName;
        data["processDescription"] = this.processDescription;
        data["processTesterUserId"] = this.processTesterUserId;
        data["processStatusId"] = this.processStatusId;
        data["comments"] = this.comments;
        data["lastChangedByUserId"] = this.lastChangedByUserId;
        data["lastChanged"] = this.lastChanged ? formatDate(this.lastChanged) : undefined as any;
        data["plannedDate"] = this.plannedDate ? formatDate(this.plannedDate) : undefined as any;
        data["plannedTime"] = this.plannedTime;
        data["plannedTimeTo"] = this.plannedTimeTo;
        data["duration"] = this.duration;
        if (Array.isArray(this.changeRequestIds)) {
            data["changeRequestIds"] = [];
            for (let item of this.changeRequestIds)
                data["changeRequestIds"].push(item);
        }
        if (Array.isArray(this.ticketIds)) {
            data["ticketIds"] = [];
            for (let item of this.ticketIds)
                data["ticketIds"].push(item);
        }
        if (Array.isArray(this.scopeDesignAttachments)) {
            data["scopeDesignAttachments"] = [];
            for (let item of this.scopeDesignAttachments)
                data["scopeDesignAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.scopeTrainingAttachments)) {
            data["scopeTrainingAttachments"] = [];
            for (let item of this.scopeTrainingAttachments)
                data["scopeTrainingAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.scopeOtherAttachments)) {
            data["scopeOtherAttachments"] = [];
            for (let item of this.scopeOtherAttachments)
                data["scopeOtherAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.testPlanAttachments)) {
            data["testPlanAttachments"] = [];
            for (let item of this.testPlanAttachments)
                data["testPlanAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.innerTestPlans)) {
            data["innerTestPlans"] = [];
            for (let item of this.innerTestPlans)
                data["innerTestPlans"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITestPlanResponse {
    id: number;
    testCycleId: number;
    level1Id?: string | undefined;
    level1Name?: string | undefined;
    level2Id?: string | undefined;
    level2Name?: string | undefined;
    level3ProcessId?: string | undefined;
    level3ProcessName?: string | undefined;
    processDescription?: string | undefined;
    processTesterUserId?: number | undefined;
    processStatusId: number;
    comments?: string | undefined;
    lastChangedByUserId?: number | undefined;
    lastChanged?: Date | undefined;
    plannedDate?: Date | undefined;
    plannedTime?: number | undefined;
    plannedTimeTo?: number | undefined;
    duration?: number | undefined;
    changeRequestIds?: number[] | undefined;
    ticketIds?: number[] | undefined;
    scopeDesignAttachments?: AttachmentResponse[] | undefined;
    scopeTrainingAttachments?: AttachmentResponse[] | undefined;
    scopeOtherAttachments?: AttachmentResponse[] | undefined;
    testPlanAttachments?: AttachmentResponse[] | undefined;
    innerTestPlans?: InnerTestPlanResponse[] | undefined;
}

export class TestPlanResponseSimpleResponseModel implements ITestPlanResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TestPlanResponse;

    constructor(data?: ITestPlanResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TestPlanResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TestPlanResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TestPlanResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITestPlanResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TestPlanResponse;
}

export class TestPlanRowResponse implements ITestPlanRowResponse {
    id!: number;
    testCycleId!: number;
    isActive!: boolean;
    processTesterUserId?: number | undefined;
    location?: string | undefined;
    plannedDate?: Date | undefined;
    plannedTime?: number | undefined;
    plannedTimeTo?: number | undefined;
    duration?: number | undefined;
    complexLevel2Id?: number | undefined;
    complexLevel2Name?: string | undefined;
    complexLevel2Description?: string | undefined;
    isComplex!: boolean;
    complexForScopeItemLevel3Id?: number | undefined;
    level3Id?: number | undefined;
    level3ProcessId?: string | undefined;
    level3ProcessName?: string | undefined;
    innerTestPlans?: InnerTestRowPlanResponse[] | undefined;

    constructor(data?: ITestPlanRowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.testCycleId = _data["testCycleId"];
            this.isActive = _data["isActive"];
            this.processTesterUserId = _data["processTesterUserId"];
            this.location = _data["location"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.plannedTime = _data["plannedTime"];
            this.plannedTimeTo = _data["plannedTimeTo"];
            this.duration = _data["duration"];
            this.complexLevel2Id = _data["complexLevel2Id"];
            this.complexLevel2Name = _data["complexLevel2Name"];
            this.complexLevel2Description = _data["complexLevel2Description"];
            this.isComplex = _data["isComplex"];
            this.complexForScopeItemLevel3Id = _data["complexForScopeItemLevel3Id"];
            this.level3Id = _data["level3Id"];
            this.level3ProcessId = _data["level3ProcessId"];
            this.level3ProcessName = _data["level3ProcessName"];
            if (Array.isArray(_data["innerTestPlans"])) {
                this.innerTestPlans = [] as any;
                for (let item of _data["innerTestPlans"])
                    this.innerTestPlans!.push(InnerTestRowPlanResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TestPlanRowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TestPlanRowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["testCycleId"] = this.testCycleId;
        data["isActive"] = this.isActive;
        data["processTesterUserId"] = this.processTesterUserId;
        data["location"] = this.location;
        data["plannedDate"] = this.plannedDate ? formatDate(this.plannedDate) : undefined as any;
        data["plannedTime"] = this.plannedTime;
        data["plannedTimeTo"] = this.plannedTimeTo;
        data["duration"] = this.duration;
        data["complexLevel2Id"] = this.complexLevel2Id;
        data["complexLevel2Name"] = this.complexLevel2Name;
        data["complexLevel2Description"] = this.complexLevel2Description;
        data["isComplex"] = this.isComplex;
        data["complexForScopeItemLevel3Id"] = this.complexForScopeItemLevel3Id;
        data["level3Id"] = this.level3Id;
        data["level3ProcessId"] = this.level3ProcessId;
        data["level3ProcessName"] = this.level3ProcessName;
        if (Array.isArray(this.innerTestPlans)) {
            data["innerTestPlans"] = [];
            for (let item of this.innerTestPlans)
                data["innerTestPlans"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITestPlanRowResponse {
    id: number;
    testCycleId: number;
    isActive: boolean;
    processTesterUserId?: number | undefined;
    location?: string | undefined;
    plannedDate?: Date | undefined;
    plannedTime?: number | undefined;
    plannedTimeTo?: number | undefined;
    duration?: number | undefined;
    complexLevel2Id?: number | undefined;
    complexLevel2Name?: string | undefined;
    complexLevel2Description?: string | undefined;
    isComplex: boolean;
    complexForScopeItemLevel3Id?: number | undefined;
    level3Id?: number | undefined;
    level3ProcessId?: string | undefined;
    level3ProcessName?: string | undefined;
    innerTestPlans?: InnerTestRowPlanResponse[] | undefined;
}

export class TestPlanRowResponseItemsResponseModel implements ITestPlanRowResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TestPlanRowResponse[] | undefined;

    constructor(data?: ITestPlanRowResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TestPlanRowResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TestPlanRowResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TestPlanRowResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITestPlanRowResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TestPlanRowResponse[] | undefined;
}

export class TestStatusDeltaRequest implements ITestStatusDeltaRequest {
    insert?: InsertTestStatusRequest[] | undefined;
    update?: UpdateTestStatusRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;

    constructor(data?: ITestStatusDeltaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertTestStatusRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateTestStatusRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteTenantIndetifyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TestStatusDeltaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TestStatusDeltaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITestStatusDeltaRequest {
    insert?: InsertTestStatusRequest[] | undefined;
    update?: UpdateTestStatusRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;
}

export enum TestStatusEnum {
    NotStarted = "NotStarted",
    InProgress = "InProgress",
    Passed = "Passed",
    Failed = "Failed",
}

export class TestStatusResponse implements ITestStatusResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isReadonly!: boolean;
    color!: string;
    isInitial!: boolean;
    nextStates?: number[] | undefined;
    order!: number;
    semantics!: TestStatusEnum;

    constructor(data?: ITestStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isReadonly = _data["isReadonly"];
            this.color = _data["color"];
            this.isInitial = _data["isInitial"];
            if (Array.isArray(_data["nextStates"])) {
                this.nextStates = [] as any;
                for (let item of _data["nextStates"])
                    this.nextStates!.push(item);
            }
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): TestStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TestStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isReadonly"] = this.isReadonly;
        data["color"] = this.color;
        data["isInitial"] = this.isInitial;
        if (Array.isArray(this.nextStates)) {
            data["nextStates"] = [];
            for (let item of this.nextStates)
                data["nextStates"].push(item);
        }
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface ITestStatusResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isReadonly: boolean;
    color: string;
    isInitial: boolean;
    nextStates?: number[] | undefined;
    order: number;
    semantics: TestStatusEnum;
}

export class TestStatusResponseItemsResponseModel implements ITestStatusResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TestStatusResponse[] | undefined;

    constructor(data?: ITestStatusResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TestStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TestStatusResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TestStatusResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITestStatusResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TestStatusResponse[] | undefined;
}

export class TextAnswersDashboardResponse implements ITextAnswersDashboardResponse {
    questionGroup?: string | undefined;
    question!: string;
    userId!: number;
    textAnswer?: string | undefined;

    constructor(data?: ITextAnswersDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionGroup = _data["questionGroup"];
            this.question = _data["question"];
            this.userId = _data["userId"];
            this.textAnswer = _data["textAnswer"];
        }
    }

    static fromJS(data: any): TextAnswersDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TextAnswersDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionGroup"] = this.questionGroup;
        data["question"] = this.question;
        data["userId"] = this.userId;
        data["textAnswer"] = this.textAnswer;
        return data;
    }
}

export interface ITextAnswersDashboardResponse {
    questionGroup?: string | undefined;
    question: string;
    userId: number;
    textAnswer?: string | undefined;
}

export class TicketAssignedGroupResponse implements ITicketAssignedGroupResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    supportOrganizationId!: number;
    defaultUserId?: number | undefined;
    emails?: string | undefined;
    userIds?: number[] | undefined;

    constructor(data?: ITicketAssignedGroupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.supportOrganizationId = _data["supportOrganizationId"];
            this.defaultUserId = _data["defaultUserId"];
            this.emails = _data["emails"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TicketAssignedGroupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAssignedGroupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["supportOrganizationId"] = this.supportOrganizationId;
        data["defaultUserId"] = this.defaultUserId;
        data["emails"] = this.emails;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }
}

export interface ITicketAssignedGroupResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    supportOrganizationId: number;
    defaultUserId?: number | undefined;
    emails?: string | undefined;
    userIds?: number[] | undefined;
}

export class TicketAssignedGroupResponseItemsResponseModel implements ITicketAssignedGroupResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketAssignedGroupResponse[] | undefined;

    constructor(data?: ITicketAssignedGroupResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketAssignedGroupResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketAssignedGroupResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAssignedGroupResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketAssignedGroupResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketAssignedGroupResponse[] | undefined;
}

export class TicketAssignedGroupResponseSimpleResponseModel implements ITicketAssignedGroupResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketAssignedGroupResponse;

    constructor(data?: ITicketAssignedGroupResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TicketAssignedGroupResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TicketAssignedGroupResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketAssignedGroupResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITicketAssignedGroupResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketAssignedGroupResponse;
}

export class TicketBreach implements ITicketBreach {
    satisfied!: number;
    breach!: number;

    constructor(data?: ITicketBreach) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.satisfied = _data["satisfied"];
            this.breach = _data["breach"];
        }
    }

    static fromJS(data: any): TicketBreach {
        data = typeof data === 'object' ? data : {};
        let result = new TicketBreach();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["satisfied"] = this.satisfied;
        data["breach"] = this.breach;
        return data;
    }
}

export interface ITicketBreach {
    satisfied: number;
    breach: number;
}

export class TicketCategoryResponse implements ITicketCategoryResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    supportOrganizationId!: number;
    assignedGroupId?: number | undefined;
    parentId?: number | undefined;
    levelNumber!: number;
    order!: number;

    constructor(data?: ITicketCategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.supportOrganizationId = _data["supportOrganizationId"];
            this.assignedGroupId = _data["assignedGroupId"];
            this.parentId = _data["parentId"];
            this.levelNumber = _data["levelNumber"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): TicketCategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketCategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["supportOrganizationId"] = this.supportOrganizationId;
        data["assignedGroupId"] = this.assignedGroupId;
        data["parentId"] = this.parentId;
        data["levelNumber"] = this.levelNumber;
        data["order"] = this.order;
        return data;
    }
}

export interface ITicketCategoryResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    supportOrganizationId: number;
    assignedGroupId?: number | undefined;
    parentId?: number | undefined;
    levelNumber: number;
    order: number;
}

export class TicketCategoryResponseItemsResponseModel implements ITicketCategoryResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketCategoryResponse[] | undefined;

    constructor(data?: ITicketCategoryResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketCategoryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketCategoryResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketCategoryResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketCategoryResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketCategoryResponse[] | undefined;
}

export class TicketCategoryResponseSimpleResponseModel implements ITicketCategoryResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketCategoryResponse;

    constructor(data?: ITicketCategoryResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TicketCategoryResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TicketCategoryResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketCategoryResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITicketCategoryResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketCategoryResponse;
}

export class TicketClosingResponse implements ITicketClosingResponse {
    id!: number;
    projectId!: number;
    closingId?: number | undefined;
    closingNote?: string | undefined;
    workaround?: string | undefined;
    closedByUserId?: number | undefined;
    designAttachments?: AttachmentResponse[] | undefined;
    developmentSpecificationAttachments?: AttachmentResponse[] | undefined;
    trainingManualAttachments?: AttachmentResponse[] | undefined;
    testEvidenceAttachments?: AttachmentResponse[] | undefined;

    constructor(data?: ITicketClosingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.closingId = _data["closingId"];
            this.closingNote = _data["closingNote"];
            this.workaround = _data["workaround"];
            this.closedByUserId = _data["closedByUserId"];
            if (Array.isArray(_data["designAttachments"])) {
                this.designAttachments = [] as any;
                for (let item of _data["designAttachments"])
                    this.designAttachments!.push(AttachmentResponse.fromJS(item));
            }
            if (Array.isArray(_data["developmentSpecificationAttachments"])) {
                this.developmentSpecificationAttachments = [] as any;
                for (let item of _data["developmentSpecificationAttachments"])
                    this.developmentSpecificationAttachments!.push(AttachmentResponse.fromJS(item));
            }
            if (Array.isArray(_data["trainingManualAttachments"])) {
                this.trainingManualAttachments = [] as any;
                for (let item of _data["trainingManualAttachments"])
                    this.trainingManualAttachments!.push(AttachmentResponse.fromJS(item));
            }
            if (Array.isArray(_data["testEvidenceAttachments"])) {
                this.testEvidenceAttachments = [] as any;
                for (let item of _data["testEvidenceAttachments"])
                    this.testEvidenceAttachments!.push(AttachmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketClosingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketClosingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["closingId"] = this.closingId;
        data["closingNote"] = this.closingNote;
        data["workaround"] = this.workaround;
        data["closedByUserId"] = this.closedByUserId;
        if (Array.isArray(this.designAttachments)) {
            data["designAttachments"] = [];
            for (let item of this.designAttachments)
                data["designAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.developmentSpecificationAttachments)) {
            data["developmentSpecificationAttachments"] = [];
            for (let item of this.developmentSpecificationAttachments)
                data["developmentSpecificationAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.trainingManualAttachments)) {
            data["trainingManualAttachments"] = [];
            for (let item of this.trainingManualAttachments)
                data["trainingManualAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.testEvidenceAttachments)) {
            data["testEvidenceAttachments"] = [];
            for (let item of this.testEvidenceAttachments)
                data["testEvidenceAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketClosingResponse {
    id: number;
    projectId: number;
    closingId?: number | undefined;
    closingNote?: string | undefined;
    workaround?: string | undefined;
    closedByUserId?: number | undefined;
    designAttachments?: AttachmentResponse[] | undefined;
    developmentSpecificationAttachments?: AttachmentResponse[] | undefined;
    trainingManualAttachments?: AttachmentResponse[] | undefined;
    testEvidenceAttachments?: AttachmentResponse[] | undefined;
}

export class TicketClosingResponseSimpleResponseModel implements ITicketClosingResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketClosingResponse;

    constructor(data?: ITicketClosingResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TicketClosingResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TicketClosingResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketClosingResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITicketClosingResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketClosingResponse;
}

export class TicketCommentResponse implements ITicketCommentResponse {
    id!: number;
    ticketId!: number;
    comment!: string;
    userId!: number;
    createdOn!: Date;
    attachments?: AttachmentResponse[] | undefined;

    constructor(data?: ITicketCommentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketId = _data["ticketId"];
            this.comment = _data["comment"];
            this.userId = _data["userId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketCommentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketCommentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketId"] = this.ticketId;
        data["comment"] = this.comment;
        data["userId"] = this.userId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketCommentResponse {
    id: number;
    ticketId: number;
    comment: string;
    userId: number;
    createdOn: Date;
    attachments?: AttachmentResponse[] | undefined;
}

export class TicketCommentResponseItemsResponseModel implements ITicketCommentResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketCommentResponse[] | undefined;

    constructor(data?: ITicketCommentResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketCommentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketCommentResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketCommentResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketCommentResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketCommentResponse[] | undefined;
}

export class TicketCommentResponseSimpleResponseModel implements ITicketCommentResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketCommentResponse;

    constructor(data?: ITicketCommentResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TicketCommentResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TicketCommentResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketCommentResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITicketCommentResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketCommentResponse;
}

export class TicketDashboardFilterRequest implements ITicketDashboardFilterRequest {
    projectStatusIds?: number[] | undefined;
    projectIds?: number[] | undefined;
    ticketIds?: number[] | undefined;
    ticketStatusIds?: number[] | undefined;
    ticketTypeIds?: number[] | undefined;
    ticketPriorities?: PriorityEnum[] | undefined;
    assignedToUserIds?: number[] | undefined;
    assignedGroupIds?: number[] | undefined;
    categoryLevel1Ids?: number[] | undefined;
    categoryLevel2Ids?: number[] | undefined;
    testCycleIds?: number[] | undefined;
    organizationalUnitIds?: number[] | undefined;
    dateRange!: DateRangeRequest;

    constructor(data?: ITicketDashboardFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dateRange = new DateRangeRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectStatusIds"])) {
                this.projectStatusIds = [] as any;
                for (let item of _data["projectStatusIds"])
                    this.projectStatusIds!.push(item);
            }
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
            if (Array.isArray(_data["ticketIds"])) {
                this.ticketIds = [] as any;
                for (let item of _data["ticketIds"])
                    this.ticketIds!.push(item);
            }
            if (Array.isArray(_data["ticketStatusIds"])) {
                this.ticketStatusIds = [] as any;
                for (let item of _data["ticketStatusIds"])
                    this.ticketStatusIds!.push(item);
            }
            if (Array.isArray(_data["ticketTypeIds"])) {
                this.ticketTypeIds = [] as any;
                for (let item of _data["ticketTypeIds"])
                    this.ticketTypeIds!.push(item);
            }
            if (Array.isArray(_data["ticketPriorities"])) {
                this.ticketPriorities = [] as any;
                for (let item of _data["ticketPriorities"])
                    this.ticketPriorities!.push(item);
            }
            if (Array.isArray(_data["assignedToUserIds"])) {
                this.assignedToUserIds = [] as any;
                for (let item of _data["assignedToUserIds"])
                    this.assignedToUserIds!.push(item);
            }
            if (Array.isArray(_data["assignedGroupIds"])) {
                this.assignedGroupIds = [] as any;
                for (let item of _data["assignedGroupIds"])
                    this.assignedGroupIds!.push(item);
            }
            if (Array.isArray(_data["categoryLevel1Ids"])) {
                this.categoryLevel1Ids = [] as any;
                for (let item of _data["categoryLevel1Ids"])
                    this.categoryLevel1Ids!.push(item);
            }
            if (Array.isArray(_data["categoryLevel2Ids"])) {
                this.categoryLevel2Ids = [] as any;
                for (let item of _data["categoryLevel2Ids"])
                    this.categoryLevel2Ids!.push(item);
            }
            if (Array.isArray(_data["testCycleIds"])) {
                this.testCycleIds = [] as any;
                for (let item of _data["testCycleIds"])
                    this.testCycleIds!.push(item);
            }
            if (Array.isArray(_data["organizationalUnitIds"])) {
                this.organizationalUnitIds = [] as any;
                for (let item of _data["organizationalUnitIds"])
                    this.organizationalUnitIds!.push(item);
            }
            this.dateRange = _data["dateRange"] ? DateRangeRequest.fromJS(_data["dateRange"]) : new DateRangeRequest();
        }
    }

    static fromJS(data: any): TicketDashboardFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TicketDashboardFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectStatusIds)) {
            data["projectStatusIds"] = [];
            for (let item of this.projectStatusIds)
                data["projectStatusIds"].push(item);
        }
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        if (Array.isArray(this.ticketIds)) {
            data["ticketIds"] = [];
            for (let item of this.ticketIds)
                data["ticketIds"].push(item);
        }
        if (Array.isArray(this.ticketStatusIds)) {
            data["ticketStatusIds"] = [];
            for (let item of this.ticketStatusIds)
                data["ticketStatusIds"].push(item);
        }
        if (Array.isArray(this.ticketTypeIds)) {
            data["ticketTypeIds"] = [];
            for (let item of this.ticketTypeIds)
                data["ticketTypeIds"].push(item);
        }
        if (Array.isArray(this.ticketPriorities)) {
            data["ticketPriorities"] = [];
            for (let item of this.ticketPriorities)
                data["ticketPriorities"].push(item);
        }
        if (Array.isArray(this.assignedToUserIds)) {
            data["assignedToUserIds"] = [];
            for (let item of this.assignedToUserIds)
                data["assignedToUserIds"].push(item);
        }
        if (Array.isArray(this.assignedGroupIds)) {
            data["assignedGroupIds"] = [];
            for (let item of this.assignedGroupIds)
                data["assignedGroupIds"].push(item);
        }
        if (Array.isArray(this.categoryLevel1Ids)) {
            data["categoryLevel1Ids"] = [];
            for (let item of this.categoryLevel1Ids)
                data["categoryLevel1Ids"].push(item);
        }
        if (Array.isArray(this.categoryLevel2Ids)) {
            data["categoryLevel2Ids"] = [];
            for (let item of this.categoryLevel2Ids)
                data["categoryLevel2Ids"].push(item);
        }
        if (Array.isArray(this.testCycleIds)) {
            data["testCycleIds"] = [];
            for (let item of this.testCycleIds)
                data["testCycleIds"].push(item);
        }
        if (Array.isArray(this.organizationalUnitIds)) {
            data["organizationalUnitIds"] = [];
            for (let item of this.organizationalUnitIds)
                data["organizationalUnitIds"].push(item);
        }
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : undefined as any;
        return data;
    }
}

export interface ITicketDashboardFilterRequest {
    projectStatusIds?: number[] | undefined;
    projectIds?: number[] | undefined;
    ticketIds?: number[] | undefined;
    ticketStatusIds?: number[] | undefined;
    ticketTypeIds?: number[] | undefined;
    ticketPriorities?: PriorityEnum[] | undefined;
    assignedToUserIds?: number[] | undefined;
    assignedGroupIds?: number[] | undefined;
    categoryLevel1Ids?: number[] | undefined;
    categoryLevel2Ids?: number[] | undefined;
    testCycleIds?: number[] | undefined;
    organizationalUnitIds?: number[] | undefined;
    dateRange: DateRangeRequest;
}

export class TicketDashboardResponse implements ITicketDashboardResponse {
    ticketsPerStatusCounts?: { [key: string]: number; } | undefined;
    ticketsPerTypeCounts?: { [key: string]: number; } | undefined;
    ticketsPerProjectAndPriorityCounts?: { [key: string]: { [key: string]: number; }; } | undefined;
    ticketsPerAssignedUserAndStatusCounts?: { [key: string]: { [key: string]: number; }; } | undefined;
    ticketsPerAssignedGroupAndStatusCounts?: { [key: string]: { [key: string]: number; }; } | undefined;
    responseTime?: TicketBreach;
    resolutionTime?: TicketBreach;
    averageResponseTimeInMinutes!: number;
    averageResolutionTimeInMinutes!: number;
    newTicketsCount!: number;
    openTicketsCount!: number;
    closedTicketsCount!: number;
    totalTicketCount!: number;

    constructor(data?: ITicketDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["ticketsPerStatusCounts"]) {
                this.ticketsPerStatusCounts = {} as any;
                for (let key in _data["ticketsPerStatusCounts"]) {
                    if (_data["ticketsPerStatusCounts"].hasOwnProperty(key))
                        (this.ticketsPerStatusCounts as any)![key] = _data["ticketsPerStatusCounts"][key];
                }
            }
            if (_data["ticketsPerTypeCounts"]) {
                this.ticketsPerTypeCounts = {} as any;
                for (let key in _data["ticketsPerTypeCounts"]) {
                    if (_data["ticketsPerTypeCounts"].hasOwnProperty(key))
                        (this.ticketsPerTypeCounts as any)![key] = _data["ticketsPerTypeCounts"][key];
                }
            }
            if (_data["ticketsPerProjectAndPriorityCounts"]) {
                this.ticketsPerProjectAndPriorityCounts = {} as any;
                for (let key in _data["ticketsPerProjectAndPriorityCounts"]) {
                    if (_data["ticketsPerProjectAndPriorityCounts"].hasOwnProperty(key))
                        (this.ticketsPerProjectAndPriorityCounts as any)![key] = _data["ticketsPerProjectAndPriorityCounts"][key] !== undefined ? _data["ticketsPerProjectAndPriorityCounts"][key] : {};
                }
            }
            if (_data["ticketsPerAssignedUserAndStatusCounts"]) {
                this.ticketsPerAssignedUserAndStatusCounts = {} as any;
                for (let key in _data["ticketsPerAssignedUserAndStatusCounts"]) {
                    if (_data["ticketsPerAssignedUserAndStatusCounts"].hasOwnProperty(key))
                        (this.ticketsPerAssignedUserAndStatusCounts as any)![key] = _data["ticketsPerAssignedUserAndStatusCounts"][key] !== undefined ? _data["ticketsPerAssignedUserAndStatusCounts"][key] : {};
                }
            }
            if (_data["ticketsPerAssignedGroupAndStatusCounts"]) {
                this.ticketsPerAssignedGroupAndStatusCounts = {} as any;
                for (let key in _data["ticketsPerAssignedGroupAndStatusCounts"]) {
                    if (_data["ticketsPerAssignedGroupAndStatusCounts"].hasOwnProperty(key))
                        (this.ticketsPerAssignedGroupAndStatusCounts as any)![key] = _data["ticketsPerAssignedGroupAndStatusCounts"][key] !== undefined ? _data["ticketsPerAssignedGroupAndStatusCounts"][key] : {};
                }
            }
            this.responseTime = _data["responseTime"] ? TicketBreach.fromJS(_data["responseTime"]) : undefined as any;
            this.resolutionTime = _data["resolutionTime"] ? TicketBreach.fromJS(_data["resolutionTime"]) : undefined as any;
            this.averageResponseTimeInMinutes = _data["averageResponseTimeInMinutes"];
            this.averageResolutionTimeInMinutes = _data["averageResolutionTimeInMinutes"];
            this.newTicketsCount = _data["newTicketsCount"];
            this.openTicketsCount = _data["openTicketsCount"];
            this.closedTicketsCount = _data["closedTicketsCount"];
            this.totalTicketCount = _data["totalTicketCount"];
        }
    }

    static fromJS(data: any): TicketDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ticketsPerStatusCounts) {
            data["ticketsPerStatusCounts"] = {};
            for (let key in this.ticketsPerStatusCounts) {
                if (this.ticketsPerStatusCounts.hasOwnProperty(key))
                    (data["ticketsPerStatusCounts"] as any)[key] = (this.ticketsPerStatusCounts as any)[key];
            }
        }
        if (this.ticketsPerTypeCounts) {
            data["ticketsPerTypeCounts"] = {};
            for (let key in this.ticketsPerTypeCounts) {
                if (this.ticketsPerTypeCounts.hasOwnProperty(key))
                    (data["ticketsPerTypeCounts"] as any)[key] = (this.ticketsPerTypeCounts as any)[key];
            }
        }
        if (this.ticketsPerProjectAndPriorityCounts) {
            data["ticketsPerProjectAndPriorityCounts"] = {};
            for (let key in this.ticketsPerProjectAndPriorityCounts) {
                if (this.ticketsPerProjectAndPriorityCounts.hasOwnProperty(key))
                    (data["ticketsPerProjectAndPriorityCounts"] as any)[key] = (this.ticketsPerProjectAndPriorityCounts as any)[key];
            }
        }
        if (this.ticketsPerAssignedUserAndStatusCounts) {
            data["ticketsPerAssignedUserAndStatusCounts"] = {};
            for (let key in this.ticketsPerAssignedUserAndStatusCounts) {
                if (this.ticketsPerAssignedUserAndStatusCounts.hasOwnProperty(key))
                    (data["ticketsPerAssignedUserAndStatusCounts"] as any)[key] = (this.ticketsPerAssignedUserAndStatusCounts as any)[key];
            }
        }
        if (this.ticketsPerAssignedGroupAndStatusCounts) {
            data["ticketsPerAssignedGroupAndStatusCounts"] = {};
            for (let key in this.ticketsPerAssignedGroupAndStatusCounts) {
                if (this.ticketsPerAssignedGroupAndStatusCounts.hasOwnProperty(key))
                    (data["ticketsPerAssignedGroupAndStatusCounts"] as any)[key] = (this.ticketsPerAssignedGroupAndStatusCounts as any)[key];
            }
        }
        data["responseTime"] = this.responseTime ? this.responseTime.toJSON() : undefined as any;
        data["resolutionTime"] = this.resolutionTime ? this.resolutionTime.toJSON() : undefined as any;
        data["averageResponseTimeInMinutes"] = this.averageResponseTimeInMinutes;
        data["averageResolutionTimeInMinutes"] = this.averageResolutionTimeInMinutes;
        data["newTicketsCount"] = this.newTicketsCount;
        data["openTicketsCount"] = this.openTicketsCount;
        data["closedTicketsCount"] = this.closedTicketsCount;
        data["totalTicketCount"] = this.totalTicketCount;
        return data;
    }
}

export interface ITicketDashboardResponse {
    ticketsPerStatusCounts?: { [key: string]: number; } | undefined;
    ticketsPerTypeCounts?: { [key: string]: number; } | undefined;
    ticketsPerProjectAndPriorityCounts?: { [key: string]: { [key: string]: number; }; } | undefined;
    ticketsPerAssignedUserAndStatusCounts?: { [key: string]: { [key: string]: number; }; } | undefined;
    ticketsPerAssignedGroupAndStatusCounts?: { [key: string]: { [key: string]: number; }; } | undefined;
    responseTime?: TicketBreach;
    resolutionTime?: TicketBreach;
    averageResponseTimeInMinutes: number;
    averageResolutionTimeInMinutes: number;
    newTicketsCount: number;
    openTicketsCount: number;
    closedTicketsCount: number;
    totalTicketCount: number;
}

export class TicketDashboardResponseSimpleResponseModel implements ITicketDashboardResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketDashboardResponse;

    constructor(data?: ITicketDashboardResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TicketDashboardResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TicketDashboardResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketDashboardResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITicketDashboardResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketDashboardResponse;
}

export class TicketEffortResponse implements ITicketEffortResponse {
    id!: number;
    projectId!: number;
    effort?: number | undefined;
    effortUnit?: TimeMeasureEnum;
    timesheets?: TicketTimesheetResponse[] | undefined;

    constructor(data?: ITicketEffortResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.effort = _data["effort"];
            this.effortUnit = _data["effortUnit"];
            if (Array.isArray(_data["timesheets"])) {
                this.timesheets = [] as any;
                for (let item of _data["timesheets"])
                    this.timesheets!.push(TicketTimesheetResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketEffortResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketEffortResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["effort"] = this.effort;
        data["effortUnit"] = this.effortUnit;
        if (Array.isArray(this.timesheets)) {
            data["timesheets"] = [];
            for (let item of this.timesheets)
                data["timesheets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketEffortResponse {
    id: number;
    projectId: number;
    effort?: number | undefined;
    effortUnit?: TimeMeasureEnum;
    timesheets?: TicketTimesheetResponse[] | undefined;
}

export class TicketEffortResponseSimpleResponseModel implements ITicketEffortResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketEffortResponse;

    constructor(data?: ITicketEffortResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TicketEffortResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TicketEffortResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketEffortResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITicketEffortResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketEffortResponse;
}

export class TicketHelpDeskResponse implements ITicketHelpDeskResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    projectId!: number;
    statusId!: number;
    priority!: PriorityEnum;
    assignedToUserId!: number;
    createdOn!: Date;

    constructor(data?: ITicketHelpDeskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.projectId = _data["projectId"];
            this.statusId = _data["statusId"];
            this.priority = _data["priority"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TicketHelpDeskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHelpDeskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        data["statusId"] = this.statusId;
        data["priority"] = this.priority;
        data["assignedToUserId"] = this.assignedToUserId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        return data;
    }
}

export interface ITicketHelpDeskResponse {
    id: number;
    name: string;
    description?: string | undefined;
    projectId: number;
    statusId: number;
    priority: PriorityEnum;
    assignedToUserId: number;
    createdOn: Date;
}

export class TicketHelpDeskResponseItemsResponseModel implements ITicketHelpDeskResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketHelpDeskResponse[] | undefined;

    constructor(data?: ITicketHelpDeskResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHelpDeskResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketHelpDeskResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHelpDeskResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketHelpDeskResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketHelpDeskResponse[] | undefined;
}

export class TicketHelpDeskResponseSimpleResponseModel implements ITicketHelpDeskResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketHelpDeskResponse;

    constructor(data?: ITicketHelpDeskResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TicketHelpDeskResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TicketHelpDeskResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHelpDeskResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITicketHelpDeskResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketHelpDeskResponse;
}

export class TicketHistoryResponse implements ITicketHistoryResponse {
    ticketId!: number;
    userId!: number;
    updatedOn!: Date;
    createdByUserId?: IntNewOld;
    projectId?: IntNewOld;
    reportedBy?: StringNewOld;
    reportedOn?: DateTimeNewOld;
    typeId?: IntNewOld;
    environmentId?: IntNewOld;
    scheduleId?: IntNewOld;
    categoryLevel1Id?: IntNewOld;
    categoryLevel2Id?: IntNewOld;
    categoryLevel3Id?: IntNewOld;
    numberExt?: StringNewOld;
    statusId?: IntNewOld;
    impactId?: IntNewOld;
    urgencyId?: IntNewOld;
    priority?: PriorityNewOld;
    effort?: FloatOldNew;
    effortUnit?: TimeMeasureNewOld;
    assignedGroupId?: IntNewOld;
    assignedToUserId?: IntNewOld;
    createdOn?: DateTimeNewOld;
    closingId?: IntNewOld;
    closingNote?: StringNewOld;
    workaround?: StringNewOld;
    parentTicketId?: IntNewOld;
    changeRequestId?: IntNewOld;

    constructor(data?: ITicketHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketId = _data["ticketId"];
            this.userId = _data["userId"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.createdByUserId = _data["createdByUserId"] ? IntNewOld.fromJS(_data["createdByUserId"]) : undefined as any;
            this.projectId = _data["projectId"] ? IntNewOld.fromJS(_data["projectId"]) : undefined as any;
            this.reportedBy = _data["reportedBy"] ? StringNewOld.fromJS(_data["reportedBy"]) : undefined as any;
            this.reportedOn = _data["reportedOn"] ? DateTimeNewOld.fromJS(_data["reportedOn"]) : undefined as any;
            this.typeId = _data["typeId"] ? IntNewOld.fromJS(_data["typeId"]) : undefined as any;
            this.environmentId = _data["environmentId"] ? IntNewOld.fromJS(_data["environmentId"]) : undefined as any;
            this.scheduleId = _data["scheduleId"] ? IntNewOld.fromJS(_data["scheduleId"]) : undefined as any;
            this.categoryLevel1Id = _data["categoryLevel1Id"] ? IntNewOld.fromJS(_data["categoryLevel1Id"]) : undefined as any;
            this.categoryLevel2Id = _data["categoryLevel2Id"] ? IntNewOld.fromJS(_data["categoryLevel2Id"]) : undefined as any;
            this.categoryLevel3Id = _data["categoryLevel3Id"] ? IntNewOld.fromJS(_data["categoryLevel3Id"]) : undefined as any;
            this.numberExt = _data["numberExt"] ? StringNewOld.fromJS(_data["numberExt"]) : undefined as any;
            this.statusId = _data["statusId"] ? IntNewOld.fromJS(_data["statusId"]) : undefined as any;
            this.impactId = _data["impactId"] ? IntNewOld.fromJS(_data["impactId"]) : undefined as any;
            this.urgencyId = _data["urgencyId"] ? IntNewOld.fromJS(_data["urgencyId"]) : undefined as any;
            this.priority = _data["priority"] ? PriorityNewOld.fromJS(_data["priority"]) : undefined as any;
            this.effort = _data["effort"] ? FloatOldNew.fromJS(_data["effort"]) : undefined as any;
            this.effortUnit = _data["effortUnit"] ? TimeMeasureNewOld.fromJS(_data["effortUnit"]) : undefined as any;
            this.assignedGroupId = _data["assignedGroupId"] ? IntNewOld.fromJS(_data["assignedGroupId"]) : undefined as any;
            this.assignedToUserId = _data["assignedToUserId"] ? IntNewOld.fromJS(_data["assignedToUserId"]) : undefined as any;
            this.createdOn = _data["createdOn"] ? DateTimeNewOld.fromJS(_data["createdOn"]) : undefined as any;
            this.closingId = _data["closingId"] ? IntNewOld.fromJS(_data["closingId"]) : undefined as any;
            this.closingNote = _data["closingNote"] ? StringNewOld.fromJS(_data["closingNote"]) : undefined as any;
            this.workaround = _data["workaround"] ? StringNewOld.fromJS(_data["workaround"]) : undefined as any;
            this.parentTicketId = _data["parentTicketId"] ? IntNewOld.fromJS(_data["parentTicketId"]) : undefined as any;
            this.changeRequestId = _data["changeRequestId"] ? IntNewOld.fromJS(_data["changeRequestId"]) : undefined as any;
        }
    }

    static fromJS(data: any): TicketHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketId"] = this.ticketId;
        data["userId"] = this.userId;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["createdByUserId"] = this.createdByUserId ? this.createdByUserId.toJSON() : undefined as any;
        data["projectId"] = this.projectId ? this.projectId.toJSON() : undefined as any;
        data["reportedBy"] = this.reportedBy ? this.reportedBy.toJSON() : undefined as any;
        data["reportedOn"] = this.reportedOn ? this.reportedOn.toJSON() : undefined as any;
        data["typeId"] = this.typeId ? this.typeId.toJSON() : undefined as any;
        data["environmentId"] = this.environmentId ? this.environmentId.toJSON() : undefined as any;
        data["scheduleId"] = this.scheduleId ? this.scheduleId.toJSON() : undefined as any;
        data["categoryLevel1Id"] = this.categoryLevel1Id ? this.categoryLevel1Id.toJSON() : undefined as any;
        data["categoryLevel2Id"] = this.categoryLevel2Id ? this.categoryLevel2Id.toJSON() : undefined as any;
        data["categoryLevel3Id"] = this.categoryLevel3Id ? this.categoryLevel3Id.toJSON() : undefined as any;
        data["numberExt"] = this.numberExt ? this.numberExt.toJSON() : undefined as any;
        data["statusId"] = this.statusId ? this.statusId.toJSON() : undefined as any;
        data["impactId"] = this.impactId ? this.impactId.toJSON() : undefined as any;
        data["urgencyId"] = this.urgencyId ? this.urgencyId.toJSON() : undefined as any;
        data["priority"] = this.priority ? this.priority.toJSON() : undefined as any;
        data["effort"] = this.effort ? this.effort.toJSON() : undefined as any;
        data["effortUnit"] = this.effortUnit ? this.effortUnit.toJSON() : undefined as any;
        data["assignedGroupId"] = this.assignedGroupId ? this.assignedGroupId.toJSON() : undefined as any;
        data["assignedToUserId"] = this.assignedToUserId ? this.assignedToUserId.toJSON() : undefined as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toJSON() : undefined as any;
        data["closingId"] = this.closingId ? this.closingId.toJSON() : undefined as any;
        data["closingNote"] = this.closingNote ? this.closingNote.toJSON() : undefined as any;
        data["workaround"] = this.workaround ? this.workaround.toJSON() : undefined as any;
        data["parentTicketId"] = this.parentTicketId ? this.parentTicketId.toJSON() : undefined as any;
        data["changeRequestId"] = this.changeRequestId ? this.changeRequestId.toJSON() : undefined as any;
        return data;
    }
}

export interface ITicketHistoryResponse {
    ticketId: number;
    userId: number;
    updatedOn: Date;
    createdByUserId?: IntNewOld;
    projectId?: IntNewOld;
    reportedBy?: StringNewOld;
    reportedOn?: DateTimeNewOld;
    typeId?: IntNewOld;
    environmentId?: IntNewOld;
    scheduleId?: IntNewOld;
    categoryLevel1Id?: IntNewOld;
    categoryLevel2Id?: IntNewOld;
    categoryLevel3Id?: IntNewOld;
    numberExt?: StringNewOld;
    statusId?: IntNewOld;
    impactId?: IntNewOld;
    urgencyId?: IntNewOld;
    priority?: PriorityNewOld;
    effort?: FloatOldNew;
    effortUnit?: TimeMeasureNewOld;
    assignedGroupId?: IntNewOld;
    assignedToUserId?: IntNewOld;
    createdOn?: DateTimeNewOld;
    closingId?: IntNewOld;
    closingNote?: StringNewOld;
    workaround?: StringNewOld;
    parentTicketId?: IntNewOld;
    changeRequestId?: IntNewOld;
}

export class TicketHistoryResponseItemsResponseModel implements ITicketHistoryResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketHistoryResponse[] | undefined;

    constructor(data?: ITicketHistoryResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketHistoryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketHistoryResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketHistoryResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketHistoryResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketHistoryResponse[] | undefined;
}

export class TicketPermission implements ITicketPermission {
    tickets!: boolean;
    helpDesk!: boolean;
    teamCommunication!: boolean;

    constructor(data?: ITicketPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tickets = _data["tickets"];
            this.helpDesk = _data["helpDesk"];
            this.teamCommunication = _data["teamCommunication"];
        }
    }

    static fromJS(data: any): TicketPermission {
        data = typeof data === 'object' ? data : {};
        let result = new TicketPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tickets"] = this.tickets;
        data["helpDesk"] = this.helpDesk;
        data["teamCommunication"] = this.teamCommunication;
        return data;
    }
}

export interface ITicketPermission {
    tickets: boolean;
    helpDesk: boolean;
    teamCommunication: boolean;
}

export class TicketPriorityDescriptionRequest implements ITicketPriorityDescriptionRequest {
    impactHighDescription!: string;
    impactMediumDescription!: string;
    impactLowDescription!: string;
    urgencyUrgentDescription!: string;
    urgencyNormalDescription!: string;

    constructor(data?: ITicketPriorityDescriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impactHighDescription = _data["impactHighDescription"];
            this.impactMediumDescription = _data["impactMediumDescription"];
            this.impactLowDescription = _data["impactLowDescription"];
            this.urgencyUrgentDescription = _data["urgencyUrgentDescription"];
            this.urgencyNormalDescription = _data["urgencyNormalDescription"];
        }
    }

    static fromJS(data: any): TicketPriorityDescriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TicketPriorityDescriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impactHighDescription"] = this.impactHighDescription;
        data["impactMediumDescription"] = this.impactMediumDescription;
        data["impactLowDescription"] = this.impactLowDescription;
        data["urgencyUrgentDescription"] = this.urgencyUrgentDescription;
        data["urgencyNormalDescription"] = this.urgencyNormalDescription;
        return data;
    }
}

export interface ITicketPriorityDescriptionRequest {
    impactHighDescription: string;
    impactMediumDescription: string;
    impactLowDescription: string;
    urgencyUrgentDescription: string;
    urgencyNormalDescription: string;
}

export class TicketPriorityDescriptionResponse implements ITicketPriorityDescriptionResponse {
    impactHighDescription!: string;
    impactMediumDescription!: string;
    impactLowDescription!: string;
    urgencyUrgentDescription!: string;
    urgencyNormalDescription!: string;

    constructor(data?: ITicketPriorityDescriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impactHighDescription = _data["impactHighDescription"];
            this.impactMediumDescription = _data["impactMediumDescription"];
            this.impactLowDescription = _data["impactLowDescription"];
            this.urgencyUrgentDescription = _data["urgencyUrgentDescription"];
            this.urgencyNormalDescription = _data["urgencyNormalDescription"];
        }
    }

    static fromJS(data: any): TicketPriorityDescriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketPriorityDescriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impactHighDescription"] = this.impactHighDescription;
        data["impactMediumDescription"] = this.impactMediumDescription;
        data["impactLowDescription"] = this.impactLowDescription;
        data["urgencyUrgentDescription"] = this.urgencyUrgentDescription;
        data["urgencyNormalDescription"] = this.urgencyNormalDescription;
        return data;
    }
}

export interface ITicketPriorityDescriptionResponse {
    impactHighDescription: string;
    impactMediumDescription: string;
    impactLowDescription: string;
    urgencyUrgentDescription: string;
    urgencyNormalDescription: string;
}

export class TicketPriorityDescriptionResponseSimpleResponseModel implements ITicketPriorityDescriptionResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketPriorityDescriptionResponse;

    constructor(data?: ITicketPriorityDescriptionResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TicketPriorityDescriptionResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TicketPriorityDescriptionResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketPriorityDescriptionResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITicketPriorityDescriptionResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketPriorityDescriptionResponse;
}

export class TicketResponse implements ITicketResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    projectId!: number;
    createdByUserId!: number;
    reportedBy!: string;
    reportedOn?: Date | undefined;
    typeId?: number | undefined;
    categoryLevel1Id!: number;
    categoryLevel2Id?: number | undefined;
    categoryLevel3Id?: number | undefined;
    ticketNumberExt?: string | undefined;
    statusId!: number;
    impactId!: number;
    urgencyId!: number;
    priority!: PriorityEnum;
    assignedGroupId?: number | undefined;
    assignedToUserId!: number;
    createdOn!: Date;
    updateByUserId!: number;
    updatedOn!: Date;
    parentTicketId?: number | undefined;
    effort?: number | undefined;
    effortUnit?: TimeMeasureEnum;
    acceptedOn?: Date | undefined;
    resolvedOn?: Date | undefined;
    expectedResolutionDate?: Date | undefined;
    environmentId?: number | undefined;
    scheduleId?: number | undefined;
    closingId?: number | undefined;
    closingNote?: string | undefined;
    workaround?: string | undefined;
    closedByUserId?: number | undefined;
    projectTypeId?: number | undefined;
    projectCategoryId?: number | undefined;
    organizationalUnitId?: number | undefined;
    dayDurationInMinutes?: number | undefined;
    responseTimeInMinutes?: number | undefined;
    resolutionTimeInMinutes?: number | undefined;
    responseTimeBreachInMinutes?: number | undefined;
    resolutionTimeBreachInMinutes?: number | undefined;
    onHoldInMinutes?: number | undefined;
    followTicket!: boolean;
    testCycleNames?: string[] | undefined;
    changeRequestIds?: number[] | undefined;
    timesheets?: TicketTimesheetResponse[] | undefined;
    testPlans?: TicketTestPlansResponse[] | undefined;
    attachments?: AttachmentResponse[] | undefined;

    constructor(data?: ITicketResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.projectId = _data["projectId"];
            this.createdByUserId = _data["createdByUserId"];
            this.reportedBy = _data["reportedBy"];
            this.reportedOn = _data["reportedOn"] ? new Date(_data["reportedOn"].toString()) : undefined as any;
            this.typeId = _data["typeId"];
            this.categoryLevel1Id = _data["categoryLevel1Id"];
            this.categoryLevel2Id = _data["categoryLevel2Id"];
            this.categoryLevel3Id = _data["categoryLevel3Id"];
            this.ticketNumberExt = _data["ticketNumberExt"];
            this.statusId = _data["statusId"];
            this.impactId = _data["impactId"];
            this.urgencyId = _data["urgencyId"];
            this.priority = _data["priority"];
            this.assignedGroupId = _data["assignedGroupId"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updateByUserId = _data["updateByUserId"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.parentTicketId = _data["parentTicketId"];
            this.effort = _data["effort"];
            this.effortUnit = _data["effortUnit"];
            this.acceptedOn = _data["acceptedOn"] ? new Date(_data["acceptedOn"].toString()) : undefined as any;
            this.resolvedOn = _data["resolvedOn"] ? new Date(_data["resolvedOn"].toString()) : undefined as any;
            this.expectedResolutionDate = _data["expectedResolutionDate"] ? new Date(_data["expectedResolutionDate"].toString()) : undefined as any;
            this.environmentId = _data["environmentId"];
            this.scheduleId = _data["scheduleId"];
            this.closingId = _data["closingId"];
            this.closingNote = _data["closingNote"];
            this.workaround = _data["workaround"];
            this.closedByUserId = _data["closedByUserId"];
            this.projectTypeId = _data["projectTypeId"];
            this.projectCategoryId = _data["projectCategoryId"];
            this.organizationalUnitId = _data["organizationalUnitId"];
            this.dayDurationInMinutes = _data["dayDurationInMinutes"];
            this.responseTimeInMinutes = _data["responseTimeInMinutes"];
            this.resolutionTimeInMinutes = _data["resolutionTimeInMinutes"];
            this.responseTimeBreachInMinutes = _data["responseTimeBreachInMinutes"];
            this.resolutionTimeBreachInMinutes = _data["resolutionTimeBreachInMinutes"];
            this.onHoldInMinutes = _data["onHoldInMinutes"];
            this.followTicket = _data["followTicket"];
            if (Array.isArray(_data["testCycleNames"])) {
                this.testCycleNames = [] as any;
                for (let item of _data["testCycleNames"])
                    this.testCycleNames!.push(item);
            }
            if (Array.isArray(_data["changeRequestIds"])) {
                this.changeRequestIds = [] as any;
                for (let item of _data["changeRequestIds"])
                    this.changeRequestIds!.push(item);
            }
            if (Array.isArray(_data["timesheets"])) {
                this.timesheets = [] as any;
                for (let item of _data["timesheets"])
                    this.timesheets!.push(TicketTimesheetResponse.fromJS(item));
            }
            if (Array.isArray(_data["testPlans"])) {
                this.testPlans = [] as any;
                for (let item of _data["testPlans"])
                    this.testPlans!.push(TicketTestPlansResponse.fromJS(item));
            }
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["projectId"] = this.projectId;
        data["createdByUserId"] = this.createdByUserId;
        data["reportedBy"] = this.reportedBy;
        data["reportedOn"] = this.reportedOn ? formatDate(this.reportedOn) : undefined as any;
        data["typeId"] = this.typeId;
        data["categoryLevel1Id"] = this.categoryLevel1Id;
        data["categoryLevel2Id"] = this.categoryLevel2Id;
        data["categoryLevel3Id"] = this.categoryLevel3Id;
        data["ticketNumberExt"] = this.ticketNumberExt;
        data["statusId"] = this.statusId;
        data["impactId"] = this.impactId;
        data["urgencyId"] = this.urgencyId;
        data["priority"] = this.priority;
        data["assignedGroupId"] = this.assignedGroupId;
        data["assignedToUserId"] = this.assignedToUserId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updateByUserId"] = this.updateByUserId;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["parentTicketId"] = this.parentTicketId;
        data["effort"] = this.effort;
        data["effortUnit"] = this.effortUnit;
        data["acceptedOn"] = this.acceptedOn ? this.acceptedOn.toISOString() : undefined as any;
        data["resolvedOn"] = this.resolvedOn ? this.resolvedOn.toISOString() : undefined as any;
        data["expectedResolutionDate"] = this.expectedResolutionDate ? formatDate(this.expectedResolutionDate) : undefined as any;
        data["environmentId"] = this.environmentId;
        data["scheduleId"] = this.scheduleId;
        data["closingId"] = this.closingId;
        data["closingNote"] = this.closingNote;
        data["workaround"] = this.workaround;
        data["closedByUserId"] = this.closedByUserId;
        data["projectTypeId"] = this.projectTypeId;
        data["projectCategoryId"] = this.projectCategoryId;
        data["organizationalUnitId"] = this.organizationalUnitId;
        data["dayDurationInMinutes"] = this.dayDurationInMinutes;
        data["responseTimeInMinutes"] = this.responseTimeInMinutes;
        data["resolutionTimeInMinutes"] = this.resolutionTimeInMinutes;
        data["responseTimeBreachInMinutes"] = this.responseTimeBreachInMinutes;
        data["resolutionTimeBreachInMinutes"] = this.resolutionTimeBreachInMinutes;
        data["onHoldInMinutes"] = this.onHoldInMinutes;
        data["followTicket"] = this.followTicket;
        if (Array.isArray(this.testCycleNames)) {
            data["testCycleNames"] = [];
            for (let item of this.testCycleNames)
                data["testCycleNames"].push(item);
        }
        if (Array.isArray(this.changeRequestIds)) {
            data["changeRequestIds"] = [];
            for (let item of this.changeRequestIds)
                data["changeRequestIds"].push(item);
        }
        if (Array.isArray(this.timesheets)) {
            data["timesheets"] = [];
            for (let item of this.timesheets)
                data["timesheets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.testPlans)) {
            data["testPlans"] = [];
            for (let item of this.testPlans)
                data["testPlans"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketResponse {
    id: number;
    name: string;
    description?: string | undefined;
    projectId: number;
    createdByUserId: number;
    reportedBy: string;
    reportedOn?: Date | undefined;
    typeId?: number | undefined;
    categoryLevel1Id: number;
    categoryLevel2Id?: number | undefined;
    categoryLevel3Id?: number | undefined;
    ticketNumberExt?: string | undefined;
    statusId: number;
    impactId: number;
    urgencyId: number;
    priority: PriorityEnum;
    assignedGroupId?: number | undefined;
    assignedToUserId: number;
    createdOn: Date;
    updateByUserId: number;
    updatedOn: Date;
    parentTicketId?: number | undefined;
    effort?: number | undefined;
    effortUnit?: TimeMeasureEnum;
    acceptedOn?: Date | undefined;
    resolvedOn?: Date | undefined;
    expectedResolutionDate?: Date | undefined;
    environmentId?: number | undefined;
    scheduleId?: number | undefined;
    closingId?: number | undefined;
    closingNote?: string | undefined;
    workaround?: string | undefined;
    closedByUserId?: number | undefined;
    projectTypeId?: number | undefined;
    projectCategoryId?: number | undefined;
    organizationalUnitId?: number | undefined;
    dayDurationInMinutes?: number | undefined;
    responseTimeInMinutes?: number | undefined;
    resolutionTimeInMinutes?: number | undefined;
    responseTimeBreachInMinutes?: number | undefined;
    resolutionTimeBreachInMinutes?: number | undefined;
    onHoldInMinutes?: number | undefined;
    followTicket: boolean;
    testCycleNames?: string[] | undefined;
    changeRequestIds?: number[] | undefined;
    timesheets?: TicketTimesheetResponse[] | undefined;
    testPlans?: TicketTestPlansResponse[] | undefined;
    attachments?: AttachmentResponse[] | undefined;
}

export class TicketResponseItemsResponseModel implements ITicketResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketResponse[] | undefined;

    constructor(data?: ITicketResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketResponse[] | undefined;
}

export class TicketResponseSimpleResponseModel implements ITicketResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketResponse;

    constructor(data?: ITicketResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TicketResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TicketResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITicketResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketResponse;
}

export class TicketSlaResponse implements ITicketSlaResponse {
    id!: number;
    projectId!: number;
    statusDurations?: TicketStatusDurationResponse[] | undefined;
    isSlaActive!: boolean;
    timeMeasure?: TimeMeasureEnum;
    dayDurationInMinutes?: number | undefined;
    responseTimeInMinutes?: number | undefined;
    resolutionTimeInMinutes?: number | undefined;
    responseTimeBreachInMinutes?: number | undefined;
    resolutionTimeBreachInMinutes?: number | undefined;
    onHoldInMinutes?: number | undefined;

    constructor(data?: ITicketSlaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["statusDurations"])) {
                this.statusDurations = [] as any;
                for (let item of _data["statusDurations"])
                    this.statusDurations!.push(TicketStatusDurationResponse.fromJS(item));
            }
            this.isSlaActive = _data["isSlaActive"];
            this.timeMeasure = _data["timeMeasure"];
            this.dayDurationInMinutes = _data["dayDurationInMinutes"];
            this.responseTimeInMinutes = _data["responseTimeInMinutes"];
            this.resolutionTimeInMinutes = _data["resolutionTimeInMinutes"];
            this.responseTimeBreachInMinutes = _data["responseTimeBreachInMinutes"];
            this.resolutionTimeBreachInMinutes = _data["resolutionTimeBreachInMinutes"];
            this.onHoldInMinutes = _data["onHoldInMinutes"];
        }
    }

    static fromJS(data: any): TicketSlaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketSlaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.statusDurations)) {
            data["statusDurations"] = [];
            for (let item of this.statusDurations)
                data["statusDurations"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSlaActive"] = this.isSlaActive;
        data["timeMeasure"] = this.timeMeasure;
        data["dayDurationInMinutes"] = this.dayDurationInMinutes;
        data["responseTimeInMinutes"] = this.responseTimeInMinutes;
        data["resolutionTimeInMinutes"] = this.resolutionTimeInMinutes;
        data["responseTimeBreachInMinutes"] = this.responseTimeBreachInMinutes;
        data["resolutionTimeBreachInMinutes"] = this.resolutionTimeBreachInMinutes;
        data["onHoldInMinutes"] = this.onHoldInMinutes;
        return data;
    }
}

export interface ITicketSlaResponse {
    id: number;
    projectId: number;
    statusDurations?: TicketStatusDurationResponse[] | undefined;
    isSlaActive: boolean;
    timeMeasure?: TimeMeasureEnum;
    dayDurationInMinutes?: number | undefined;
    responseTimeInMinutes?: number | undefined;
    resolutionTimeInMinutes?: number | undefined;
    responseTimeBreachInMinutes?: number | undefined;
    resolutionTimeBreachInMinutes?: number | undefined;
    onHoldInMinutes?: number | undefined;
}

export class TicketSlaResponseSimpleResponseModel implements ITicketSlaResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketSlaResponse;

    constructor(data?: ITicketSlaResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TicketSlaResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TicketSlaResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketSlaResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITicketSlaResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketSlaResponse;
}

export class TicketStatusDeltaRequest implements ITicketStatusDeltaRequest {
    insert?: InsertTicketStatusRequest[] | undefined;
    update?: UpdateTicketStatusRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;

    constructor(data?: ITicketStatusDeltaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertTicketStatusRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateTicketStatusRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteTenantIndetifyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketStatusDeltaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TicketStatusDeltaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketStatusDeltaRequest {
    insert?: InsertTicketStatusRequest[] | undefined;
    update?: UpdateTicketStatusRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;
}

export class TicketStatusDurationResponse implements ITicketStatusDurationResponse {
    userId!: number;
    statusId!: number;
    duration!: number;

    constructor(data?: ITicketStatusDurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.statusId = _data["statusId"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): TicketStatusDurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketStatusDurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["statusId"] = this.statusId;
        data["duration"] = this.duration;
        return data;
    }
}

export interface ITicketStatusDurationResponse {
    userId: number;
    statusId: number;
    duration: number;
}

export enum TicketStatusEnum {
    New = "New",
    Accepted = "Accepted",
    InProgress = "InProgress",
    OnHold = "OnHold",
    Resolved = "Resolved",
    Rejected = "Rejected",
    Closed = "Closed",
}

export class TicketStatusResponse implements ITicketStatusResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isReadonly!: boolean;
    color!: string;
    isInitial!: boolean;
    nextStates?: number[] | undefined;
    order!: number;
    semantics!: TicketStatusEnum;

    constructor(data?: ITicketStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isReadonly = _data["isReadonly"];
            this.color = _data["color"];
            this.isInitial = _data["isInitial"];
            if (Array.isArray(_data["nextStates"])) {
                this.nextStates = [] as any;
                for (let item of _data["nextStates"])
                    this.nextStates!.push(item);
            }
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): TicketStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isReadonly"] = this.isReadonly;
        data["color"] = this.color;
        data["isInitial"] = this.isInitial;
        if (Array.isArray(this.nextStates)) {
            data["nextStates"] = [];
            for (let item of this.nextStates)
                data["nextStates"].push(item);
        }
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface ITicketStatusResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isReadonly: boolean;
    color: string;
    isInitial: boolean;
    nextStates?: number[] | undefined;
    order: number;
    semantics: TicketStatusEnum;
}

export class TicketStatusResponseItemsResponseModel implements ITicketStatusResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketStatusResponse[] | undefined;

    constructor(data?: ITicketStatusResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketStatusResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketStatusResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketStatusResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketStatusResponse[] | undefined;
}

export class TicketSubtaskResponse implements ITicketSubtaskResponse {
    id!: number;
    ticketId!: number;
    createTask!: boolean;
    isUserCreated!: boolean;
    description?: string | undefined;
    assignedToUserId?: number | undefined;
    due?: Date | undefined;
    statusId?: number | undefined;
    taskId?: number | undefined;

    constructor(data?: ITicketSubtaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticketId = _data["ticketId"];
            this.createTask = _data["createTask"];
            this.isUserCreated = _data["isUserCreated"];
            this.description = _data["description"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.taskId = _data["taskId"];
        }
    }

    static fromJS(data: any): TicketSubtaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketSubtaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticketId"] = this.ticketId;
        data["createTask"] = this.createTask;
        data["isUserCreated"] = this.isUserCreated;
        data["description"] = this.description;
        data["assignedToUserId"] = this.assignedToUserId;
        data["due"] = this.due ? formatDate(this.due) : undefined as any;
        data["statusId"] = this.statusId;
        data["taskId"] = this.taskId;
        return data;
    }
}

export interface ITicketSubtaskResponse {
    id: number;
    ticketId: number;
    createTask: boolean;
    isUserCreated: boolean;
    description?: string | undefined;
    assignedToUserId?: number | undefined;
    due?: Date | undefined;
    statusId?: number | undefined;
    taskId?: number | undefined;
}

export class TicketSubtaskResponseItemsResponseModel implements ITicketSubtaskResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketSubtaskResponse[] | undefined;

    constructor(data?: ITicketSubtaskResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TicketSubtaskResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TicketSubtaskResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketSubtaskResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITicketSubtaskResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TicketSubtaskResponse[] | undefined;
}

export class TicketSubtaskResponseSimpleResponseModel implements ITicketSubtaskResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketSubtaskResponse;

    constructor(data?: ITicketSubtaskResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TicketSubtaskResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TicketSubtaskResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TicketSubtaskResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITicketSubtaskResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TicketSubtaskResponse;
}

export class TicketTestPlansResponse implements ITicketTestPlansResponse {
    testPlanId!: number;
    testCycleId!: number;
    projectId!: number;
    level3ProcessId?: string | undefined;
    testCycleName?: string | undefined;

    constructor(data?: ITicketTestPlansResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.testPlanId = _data["testPlanId"];
            this.testCycleId = _data["testCycleId"];
            this.projectId = _data["projectId"];
            this.level3ProcessId = _data["level3ProcessId"];
            this.testCycleName = _data["testCycleName"];
        }
    }

    static fromJS(data: any): TicketTestPlansResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketTestPlansResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testPlanId"] = this.testPlanId;
        data["testCycleId"] = this.testCycleId;
        data["projectId"] = this.projectId;
        data["level3ProcessId"] = this.level3ProcessId;
        data["testCycleName"] = this.testCycleName;
        return data;
    }
}

export interface ITicketTestPlansResponse {
    testPlanId: number;
    testCycleId: number;
    projectId: number;
    level3ProcessId?: string | undefined;
    testCycleName?: string | undefined;
}

export class TicketTimesheetResponse implements ITicketTimesheetResponse {
    id!: number;
    userId!: number;
    date!: Date;
    effort!: number;
    statusId!: number;

    constructor(data?: ITicketTimesheetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.effort = _data["effort"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): TicketTimesheetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TicketTimesheetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["effort"] = this.effort;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface ITicketTimesheetResponse {
    id: number;
    userId: number;
    date: Date;
    effort: number;
    statusId: number;
}

export enum TimeFrequency {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export enum TimeMeasureEnum {
    Days = "Days",
    Minutes = "Minutes",
    Hours = "Hours",
}

export class TimeMeasureNewOld implements ITimeMeasureNewOld {
    oldValue?: TimeMeasureEnum;
    newValue?: TimeMeasureEnum;

    constructor(data?: ITimeMeasureNewOld) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): TimeMeasureNewOld {
        data = typeof data === 'object' ? data : {};
        let result = new TimeMeasureNewOld();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface ITimeMeasureNewOld {
    oldValue?: TimeMeasureEnum;
    newValue?: TimeMeasureEnum;
}

export class TimesheetDashboardResponse implements ITimesheetDashboardResponse {
    date!: Date;
    userId!: number;
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    description?: string | undefined;
    hours!: number;
    hourCostRate!: number;
    hourSalesRate!: number;
    customText1?: string | undefined;
    customText2?: string | undefined;
    customText3?: string | undefined;
    readonly totalCost!: number;
    readonly totalSales!: number;
    changeRequestId?: number | undefined;
    ticketId?: number | undefined;
    taskId?: number | undefined;
    scheduleId?: number | undefined;
    partnerId?: number | undefined;

    constructor(data?: ITimesheetDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.description = _data["description"];
            this.hours = _data["hours"];
            this.hourCostRate = _data["hourCostRate"];
            this.hourSalesRate = _data["hourSalesRate"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.customText3 = _data["customText3"];
            (this as any).totalCost = _data["totalCost"];
            (this as any).totalSales = _data["totalSales"];
            this.changeRequestId = _data["changeRequestId"];
            this.ticketId = _data["ticketId"];
            this.taskId = _data["taskId"];
            this.scheduleId = _data["scheduleId"];
            this.partnerId = _data["partnerId"];
        }
    }

    static fromJS(data: any): TimesheetDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["userId"] = this.userId;
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["description"] = this.description;
        data["hours"] = this.hours;
        data["hourCostRate"] = this.hourCostRate;
        data["hourSalesRate"] = this.hourSalesRate;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["customText3"] = this.customText3;
        data["totalCost"] = this.totalCost;
        data["totalSales"] = this.totalSales;
        data["changeRequestId"] = this.changeRequestId;
        data["ticketId"] = this.ticketId;
        data["taskId"] = this.taskId;
        data["scheduleId"] = this.scheduleId;
        data["partnerId"] = this.partnerId;
        return data;
    }
}

export interface ITimesheetDashboardResponse {
    date: Date;
    userId: number;
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    description?: string | undefined;
    hours: number;
    hourCostRate: number;
    hourSalesRate: number;
    customText1?: string | undefined;
    customText2?: string | undefined;
    customText3?: string | undefined;
    totalCost: number;
    totalSales: number;
    changeRequestId?: number | undefined;
    ticketId?: number | undefined;
    taskId?: number | undefined;
    scheduleId?: number | undefined;
    partnerId?: number | undefined;
}

export class TimesheetDashboardResponseItemsResponseModel implements ITimesheetDashboardResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TimesheetDashboardResponse[] | undefined;

    constructor(data?: ITimesheetDashboardResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TimesheetDashboardResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimesheetDashboardResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetDashboardResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITimesheetDashboardResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TimesheetDashboardResponse[] | undefined;
}

export class TimesheetDeltaRequest implements ITimesheetDeltaRequest {
    insert?: InsertTimesheetRequest[] | undefined;
    update?: UpdateTimesheetRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;

    constructor(data?: ITimesheetDeltaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insert"])) {
                this.insert = [] as any;
                for (let item of _data["insert"])
                    this.insert!.push(InsertTimesheetRequest.fromJS(item));
            }
            if (Array.isArray(_data["update"])) {
                this.update = [] as any;
                for (let item of _data["update"])
                    this.update!.push(UpdateTimesheetRequest.fromJS(item));
            }
            if (Array.isArray(_data["delete"])) {
                this.delete = [] as any;
                for (let item of _data["delete"])
                    this.delete!.push(DeleteTenantIndetifyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimesheetDeltaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetDeltaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insert)) {
            data["insert"] = [];
            for (let item of this.insert)
                data["insert"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.update)) {
            data["update"] = [];
            for (let item of this.update)
                data["update"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.delete)) {
            data["delete"] = [];
            for (let item of this.delete)
                data["delete"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITimesheetDeltaRequest {
    insert?: InsertTimesheetRequest[] | undefined;
    update?: UpdateTimesheetRequest[] | undefined;
    delete?: DeleteTenantIndetifyRequest[] | undefined;
}

export class TimesheetMergedResponse implements ITimesheetMergedResponse {
    userId!: number;
    projectId!: number;
    statusId!: number;
    totalEffort!: number;

    constructor(data?: ITimesheetMergedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.statusId = _data["statusId"];
            this.totalEffort = _data["totalEffort"];
        }
    }

    static fromJS(data: any): TimesheetMergedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetMergedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["statusId"] = this.statusId;
        data["totalEffort"] = this.totalEffort;
        return data;
    }
}

export interface ITimesheetMergedResponse {
    userId: number;
    projectId: number;
    statusId: number;
    totalEffort: number;
}

export class TimesheetMergedResponseItemsResponseModel implements ITimesheetMergedResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TimesheetMergedResponse[] | undefined;

    constructor(data?: ITimesheetMergedResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TimesheetMergedResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimesheetMergedResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetMergedResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITimesheetMergedResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TimesheetMergedResponse[] | undefined;
}

export class TimesheetRecordedStatusResponse implements ITimesheetRecordedStatusResponse {
    date!: Date;
    totalEffort!: number;
    isFinished!: boolean;
    isWorkingDay!: boolean;
    isReleaseable!: boolean;

    constructor(data?: ITimesheetRecordedStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.totalEffort = _data["totalEffort"];
            this.isFinished = _data["isFinished"];
            this.isWorkingDay = _data["isWorkingDay"];
            this.isReleaseable = _data["isReleaseable"];
        }
    }

    static fromJS(data: any): TimesheetRecordedStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetRecordedStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["totalEffort"] = this.totalEffort;
        data["isFinished"] = this.isFinished;
        data["isWorkingDay"] = this.isWorkingDay;
        data["isReleaseable"] = this.isReleaseable;
        return data;
    }
}

export interface ITimesheetRecordedStatusResponse {
    date: Date;
    totalEffort: number;
    isFinished: boolean;
    isWorkingDay: boolean;
    isReleaseable: boolean;
}

export class TimesheetRecordedStatusResponseItemsResponseModel implements ITimesheetRecordedStatusResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TimesheetRecordedStatusResponse[] | undefined;

    constructor(data?: ITimesheetRecordedStatusResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TimesheetRecordedStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimesheetRecordedStatusResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetRecordedStatusResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITimesheetRecordedStatusResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TimesheetRecordedStatusResponse[] | undefined;
}

export class TimesheetRequiredFieldsRequest implements ITimesheetRequiredFieldsRequest {
    description!: boolean;
    changeRequestId!: boolean;
    ticketId!: boolean;
    taskId!: boolean;
    scheduleId!: boolean;
    projectTeamId!: boolean;

    constructor(data?: ITimesheetRequiredFieldsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.changeRequestId = _data["changeRequestId"];
            this.ticketId = _data["ticketId"];
            this.taskId = _data["taskId"];
            this.scheduleId = _data["scheduleId"];
            this.projectTeamId = _data["projectTeamId"];
        }
    }

    static fromJS(data: any): TimesheetRequiredFieldsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetRequiredFieldsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["changeRequestId"] = this.changeRequestId;
        data["ticketId"] = this.ticketId;
        data["taskId"] = this.taskId;
        data["scheduleId"] = this.scheduleId;
        data["projectTeamId"] = this.projectTeamId;
        return data;
    }
}

export interface ITimesheetRequiredFieldsRequest {
    description: boolean;
    changeRequestId: boolean;
    ticketId: boolean;
    taskId: boolean;
    scheduleId: boolean;
    projectTeamId: boolean;
}

export class TimesheetRequiredFieldsResponse implements ITimesheetRequiredFieldsResponse {
    projectId!: number;
    description!: boolean;
    changeRequestId!: boolean;
    ticketId!: boolean;
    taskId!: boolean;
    scheduleId!: boolean;
    projectTeamId!: boolean;

    constructor(data?: ITimesheetRequiredFieldsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.description = _data["description"];
            this.changeRequestId = _data["changeRequestId"];
            this.ticketId = _data["ticketId"];
            this.taskId = _data["taskId"];
            this.scheduleId = _data["scheduleId"];
            this.projectTeamId = _data["projectTeamId"];
        }
    }

    static fromJS(data: any): TimesheetRequiredFieldsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetRequiredFieldsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["description"] = this.description;
        data["changeRequestId"] = this.changeRequestId;
        data["ticketId"] = this.ticketId;
        data["taskId"] = this.taskId;
        data["scheduleId"] = this.scheduleId;
        data["projectTeamId"] = this.projectTeamId;
        return data;
    }
}

export interface ITimesheetRequiredFieldsResponse {
    projectId: number;
    description: boolean;
    changeRequestId: boolean;
    ticketId: boolean;
    taskId: boolean;
    scheduleId: boolean;
    projectTeamId: boolean;
}

export class TimesheetRequiredFieldsResponseSimpleResponseModel implements ITimesheetRequiredFieldsResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TimesheetRequiredFieldsResponse;

    constructor(data?: ITimesheetRequiredFieldsResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TimesheetRequiredFieldsResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TimesheetRequiredFieldsResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetRequiredFieldsResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITimesheetRequiredFieldsResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TimesheetRequiredFieldsResponse;
}

export class TimesheetResponse implements ITimesheetResponse {
    id!: number;
    date!: Date;
    userId!: number;
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    effort!: number;
    description?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    customText3?: string | undefined;
    changeRequestId?: number | undefined;
    ticketId?: number | undefined;
    statusId?: number | undefined;
    taskId?: number | undefined;
    scheduleId?: number | undefined;
    projectTeamId?: number | undefined;
    approvedOrRejectedByUserId?: number | undefined;

    constructor(data?: ITimesheetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.effort = _data["effort"];
            this.description = _data["description"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.customText3 = _data["customText3"];
            this.changeRequestId = _data["changeRequestId"];
            this.ticketId = _data["ticketId"];
            this.statusId = _data["statusId"];
            this.taskId = _data["taskId"];
            this.scheduleId = _data["scheduleId"];
            this.projectTeamId = _data["projectTeamId"];
            this.approvedOrRejectedByUserId = _data["approvedOrRejectedByUserId"];
        }
    }

    static fromJS(data: any): TimesheetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["userId"] = this.userId;
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["effort"] = this.effort;
        data["description"] = this.description;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["customText3"] = this.customText3;
        data["changeRequestId"] = this.changeRequestId;
        data["ticketId"] = this.ticketId;
        data["statusId"] = this.statusId;
        data["taskId"] = this.taskId;
        data["scheduleId"] = this.scheduleId;
        data["projectTeamId"] = this.projectTeamId;
        data["approvedOrRejectedByUserId"] = this.approvedOrRejectedByUserId;
        return data;
    }
}

export interface ITimesheetResponse {
    id: number;
    date: Date;
    userId: number;
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    effort: number;
    description?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    customText3?: string | undefined;
    changeRequestId?: number | undefined;
    ticketId?: number | undefined;
    statusId?: number | undefined;
    taskId?: number | undefined;
    scheduleId?: number | undefined;
    projectTeamId?: number | undefined;
    approvedOrRejectedByUserId?: number | undefined;
}

export class TimesheetResponseItemsResponseModel implements ITimesheetResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TimesheetResponse[] | undefined;

    constructor(data?: ITimesheetResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TimesheetResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimesheetResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITimesheetResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TimesheetResponse[] | undefined;
}

export class TimesheetResponseSimpleResponseModel implements ITimesheetResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TimesheetResponse;

    constructor(data?: ITimesheetResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TimesheetResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TimesheetResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITimesheetResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TimesheetResponse;
}

export class TimesheetsConfigResponse implements ITimesheetsConfigResponse {
    id!: number;
    enableApprovalProcess!: boolean;
    enableEmailNotifications!: boolean;
    notifyWhenSubmitted!: boolean;
    notifyWhenApproved!: boolean;
    notifyWhenRejected!: boolean;
    requireCommentsWhenRejecting!: boolean;
    approvalFrequency!: TimeFrequency;
    minimumRecord!: number;
    minimumWorkingHoursPerDay!: number;
    allowOvertimeWeekendHolidayWork!: boolean;

    constructor(data?: ITimesheetsConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enableApprovalProcess = _data["enableApprovalProcess"];
            this.enableEmailNotifications = _data["enableEmailNotifications"];
            this.notifyWhenSubmitted = _data["notifyWhenSubmitted"];
            this.notifyWhenApproved = _data["notifyWhenApproved"];
            this.notifyWhenRejected = _data["notifyWhenRejected"];
            this.requireCommentsWhenRejecting = _data["requireCommentsWhenRejecting"];
            this.approvalFrequency = _data["approvalFrequency"];
            this.minimumRecord = _data["minimumRecord"];
            this.minimumWorkingHoursPerDay = _data["minimumWorkingHoursPerDay"];
            this.allowOvertimeWeekendHolidayWork = _data["allowOvertimeWeekendHolidayWork"];
        }
    }

    static fromJS(data: any): TimesheetsConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetsConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enableApprovalProcess"] = this.enableApprovalProcess;
        data["enableEmailNotifications"] = this.enableEmailNotifications;
        data["notifyWhenSubmitted"] = this.notifyWhenSubmitted;
        data["notifyWhenApproved"] = this.notifyWhenApproved;
        data["notifyWhenRejected"] = this.notifyWhenRejected;
        data["requireCommentsWhenRejecting"] = this.requireCommentsWhenRejecting;
        data["approvalFrequency"] = this.approvalFrequency;
        data["minimumRecord"] = this.minimumRecord;
        data["minimumWorkingHoursPerDay"] = this.minimumWorkingHoursPerDay;
        data["allowOvertimeWeekendHolidayWork"] = this.allowOvertimeWeekendHolidayWork;
        return data;
    }
}

export interface ITimesheetsConfigResponse {
    id: number;
    enableApprovalProcess: boolean;
    enableEmailNotifications: boolean;
    notifyWhenSubmitted: boolean;
    notifyWhenApproved: boolean;
    notifyWhenRejected: boolean;
    requireCommentsWhenRejecting: boolean;
    approvalFrequency: TimeFrequency;
    minimumRecord: number;
    minimumWorkingHoursPerDay: number;
    allowOvertimeWeekendHolidayWork: boolean;
}

export class TimesheetsConfigResponseSimpleResponseModel implements ITimesheetsConfigResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TimesheetsConfigResponse;

    constructor(data?: ITimesheetsConfigResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TimesheetsConfigResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TimesheetsConfigResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetsConfigResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITimesheetsConfigResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TimesheetsConfigResponse;
}

export class TimesheetsOneDayRequest implements ITimesheetsOneDayRequest {
    date!: Date;

    constructor(data?: ITimesheetsOneDayRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TimesheetsOneDayRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetsOneDayRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        return data;
    }
}

export interface ITimesheetsOneDayRequest {
    date: Date;
}

export class TimesheetsPeriodRequest implements ITimesheetsPeriodRequest {
    from!: Date;
    to!: Date;

    constructor(data?: ITimesheetsPeriodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TimesheetsPeriodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TimesheetsPeriodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        return data;
    }
}

export interface ITimesheetsPeriodRequest {
    from: Date;
    to: Date;
}

export class TimeTravelConfigResponse implements ITimeTravelConfigResponse {
    id!: number;
    enableApprovalProcess!: boolean;
    enableEmailNotifications!: boolean;
    notifyWhenSubmitted!: boolean;
    notifyWhenApproved!: boolean;
    notifyWhenRejected!: boolean;
    requireCommentsWhenRejecting!: boolean;

    constructor(data?: ITimeTravelConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.enableApprovalProcess = _data["enableApprovalProcess"];
            this.enableEmailNotifications = _data["enableEmailNotifications"];
            this.notifyWhenSubmitted = _data["notifyWhenSubmitted"];
            this.notifyWhenApproved = _data["notifyWhenApproved"];
            this.notifyWhenRejected = _data["notifyWhenRejected"];
            this.requireCommentsWhenRejecting = _data["requireCommentsWhenRejecting"];
        }
    }

    static fromJS(data: any): TimeTravelConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TimeTravelConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["enableApprovalProcess"] = this.enableApprovalProcess;
        data["enableEmailNotifications"] = this.enableEmailNotifications;
        data["notifyWhenSubmitted"] = this.notifyWhenSubmitted;
        data["notifyWhenApproved"] = this.notifyWhenApproved;
        data["notifyWhenRejected"] = this.notifyWhenRejected;
        data["requireCommentsWhenRejecting"] = this.requireCommentsWhenRejecting;
        return data;
    }
}

export interface ITimeTravelConfigResponse {
    id: number;
    enableApprovalProcess: boolean;
    enableEmailNotifications: boolean;
    notifyWhenSubmitted: boolean;
    notifyWhenApproved: boolean;
    notifyWhenRejected: boolean;
    requireCommentsWhenRejecting: boolean;
}

export class TimeTravelConfigResponseSimpleResponseModel implements ITimeTravelConfigResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TimeTravelConfigResponse;

    constructor(data?: ITimeTravelConfigResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TimeTravelConfigResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TimeTravelConfigResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeTravelConfigResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITimeTravelConfigResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TimeTravelConfigResponse;
}

export class TimeTravelDashboardRowResponse implements ITimeTravelDashboardRowResponse {
    id!: number;
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    year!: number;
    month!: MonthEnum;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    amount!: number;

    constructor(data?: ITimeTravelDashboardRowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): TimeTravelDashboardRowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TimeTravelDashboardRowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["year"] = this.year;
        data["month"] = this.month;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["amount"] = this.amount;
        return data;
    }
}

export interface ITimeTravelDashboardRowResponse {
    id: number;
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    year: number;
    month: MonthEnum;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    amount: number;
}

export class TimeTravelPermission implements ITimeTravelPermission {
    timeAndTravel!: boolean;

    constructor(data?: ITimeTravelPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeAndTravel = _data["timeAndTravel"];
        }
    }

    static fromJS(data: any): TimeTravelPermission {
        data = typeof data === 'object' ? data : {};
        let result = new TimeTravelPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeAndTravel"] = this.timeAndTravel;
        return data;
    }
}

export interface ITimeTravelPermission {
    timeAndTravel: boolean;
}

export enum TimeTravelStatusEnum {
    Created = "Created",
    Released = "Released",
    Approved = "Approved",
    Rejected = "Rejected",
}

export class TimeTravelStatusResponse implements ITimeTravelStatusResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isReadonly!: boolean;
    color!: string;
    isInitial!: boolean;
    nextStates?: number[] | undefined;
    order!: number;
    semantics!: TimeTravelStatusEnum;

    constructor(data?: ITimeTravelStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isReadonly = _data["isReadonly"];
            this.color = _data["color"];
            this.isInitial = _data["isInitial"];
            if (Array.isArray(_data["nextStates"])) {
                this.nextStates = [] as any;
                for (let item of _data["nextStates"])
                    this.nextStates!.push(item);
            }
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): TimeTravelStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TimeTravelStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isReadonly"] = this.isReadonly;
        data["color"] = this.color;
        data["isInitial"] = this.isInitial;
        if (Array.isArray(this.nextStates)) {
            data["nextStates"] = [];
            for (let item of this.nextStates)
                data["nextStates"].push(item);
        }
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface ITimeTravelStatusResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isReadonly: boolean;
    color: string;
    isInitial: boolean;
    nextStates?: number[] | undefined;
    order: number;
    semantics: TimeTravelStatusEnum;
}

export class TimeTravelStatusResponseItemsResponseModel implements ITimeTravelStatusResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TimeTravelStatusResponse[] | undefined;

    constructor(data?: ITimeTravelStatusResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TimeTravelStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeTravelStatusResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeTravelStatusResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITimeTravelStatusResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TimeTravelStatusResponse[] | undefined;
}

export class TokenResponseModel implements ITokenResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    token?: string | undefined;
    isTenantInitialized?: boolean | undefined;
    user?: UserModel;

    constructor(data?: ITokenResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.token = _data["token"];
            this.isTenantInitialized = _data["isTenantInitialized"];
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): TokenResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["token"] = this.token;
        data["isTenantInitialized"] = this.isTenantInitialized;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface ITokenResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    token?: string | undefined;
    isTenantInitialized?: boolean | undefined;
    user?: UserModel;
}

export enum TokenTypeEnum {
    Guest = "Guest",
    User = "User",
    ServerAdmin = "ServerAdmin",
    SiteAdmin = "SiteAdmin",
    ProjectManager = "ProjectManager",
    ProjectManagerSubstitute = "ProjectManagerSubstitute",
}

export class TotalTimesheetDashboardResponse implements ITotalTimesheetDashboardResponse {
    hours!: number;
    cost!: number;
    sales!: number;

    constructor(data?: ITotalTimesheetDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hours = _data["hours"];
            this.cost = _data["cost"];
            this.sales = _data["sales"];
        }
    }

    static fromJS(data: any): TotalTimesheetDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TotalTimesheetDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hours"] = this.hours;
        data["cost"] = this.cost;
        data["sales"] = this.sales;
        return data;
    }
}

export interface ITotalTimesheetDashboardResponse {
    hours: number;
    cost: number;
    sales: number;
}

export class TotalTimesheetDashboardResponseSimpleResponseModel implements ITotalTimesheetDashboardResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TotalTimesheetDashboardResponse;

    constructor(data?: ITotalTimesheetDashboardResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TotalTimesheetDashboardResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TotalTimesheetDashboardResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TotalTimesheetDashboardResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITotalTimesheetDashboardResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TotalTimesheetDashboardResponse;
}

export class TrainingDashboardFilterRequest implements ITrainingDashboardFilterRequest {
    participants?: number[] | undefined;
    projectTeamIds?: number[] | undefined;
    projectRoleIds?: number[] | undefined;

    constructor(data?: ITrainingDashboardFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(item);
            }
            if (Array.isArray(_data["projectTeamIds"])) {
                this.projectTeamIds = [] as any;
                for (let item of _data["projectTeamIds"])
                    this.projectTeamIds!.push(item);
            }
            if (Array.isArray(_data["projectRoleIds"])) {
                this.projectRoleIds = [] as any;
                for (let item of _data["projectRoleIds"])
                    this.projectRoleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TrainingDashboardFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingDashboardFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item);
        }
        if (Array.isArray(this.projectTeamIds)) {
            data["projectTeamIds"] = [];
            for (let item of this.projectTeamIds)
                data["projectTeamIds"].push(item);
        }
        if (Array.isArray(this.projectRoleIds)) {
            data["projectRoleIds"] = [];
            for (let item of this.projectRoleIds)
                data["projectRoleIds"].push(item);
        }
        return data;
    }
}

export interface ITrainingDashboardFilterRequest {
    participants?: number[] | undefined;
    projectTeamIds?: number[] | undefined;
    projectRoleIds?: number[] | undefined;
}

export class TrainingDashboardResponse implements ITrainingDashboardResponse {
    trainingsPerStatusCounts?: { [key: string]: number; } | undefined;
    trainingsPerParticipantsAndStatusCounts?: { [key: string]: { [key: string]: number; }; } | undefined;
    participantsCount!: number;

    constructor(data?: ITrainingDashboardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["trainingsPerStatusCounts"]) {
                this.trainingsPerStatusCounts = {} as any;
                for (let key in _data["trainingsPerStatusCounts"]) {
                    if (_data["trainingsPerStatusCounts"].hasOwnProperty(key))
                        (this.trainingsPerStatusCounts as any)![key] = _data["trainingsPerStatusCounts"][key];
                }
            }
            if (_data["trainingsPerParticipantsAndStatusCounts"]) {
                this.trainingsPerParticipantsAndStatusCounts = {} as any;
                for (let key in _data["trainingsPerParticipantsAndStatusCounts"]) {
                    if (_data["trainingsPerParticipantsAndStatusCounts"].hasOwnProperty(key))
                        (this.trainingsPerParticipantsAndStatusCounts as any)![key] = _data["trainingsPerParticipantsAndStatusCounts"][key] !== undefined ? _data["trainingsPerParticipantsAndStatusCounts"][key] : {};
                }
            }
            this.participantsCount = _data["participantsCount"];
        }
    }

    static fromJS(data: any): TrainingDashboardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingDashboardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.trainingsPerStatusCounts) {
            data["trainingsPerStatusCounts"] = {};
            for (let key in this.trainingsPerStatusCounts) {
                if (this.trainingsPerStatusCounts.hasOwnProperty(key))
                    (data["trainingsPerStatusCounts"] as any)[key] = (this.trainingsPerStatusCounts as any)[key];
            }
        }
        if (this.trainingsPerParticipantsAndStatusCounts) {
            data["trainingsPerParticipantsAndStatusCounts"] = {};
            for (let key in this.trainingsPerParticipantsAndStatusCounts) {
                if (this.trainingsPerParticipantsAndStatusCounts.hasOwnProperty(key))
                    (data["trainingsPerParticipantsAndStatusCounts"] as any)[key] = (this.trainingsPerParticipantsAndStatusCounts as any)[key];
            }
        }
        data["participantsCount"] = this.participantsCount;
        return data;
    }
}

export interface ITrainingDashboardResponse {
    trainingsPerStatusCounts?: { [key: string]: number; } | undefined;
    trainingsPerParticipantsAndStatusCounts?: { [key: string]: { [key: string]: number; }; } | undefined;
    participantsCount: number;
}

export class TrainingDashboardResponseSimpleResponseModel implements ITrainingDashboardResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TrainingDashboardResponse;

    constructor(data?: ITrainingDashboardResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TrainingDashboardResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TrainingDashboardResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingDashboardResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITrainingDashboardResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TrainingDashboardResponse;
}

export class TrainingPermission implements ITrainingPermission {
    training!: boolean;
    createTrainingCycle!: boolean;
    maintainTrainingPlan!: boolean;
    createSurveys!: boolean;

    constructor(data?: ITrainingPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.training = _data["training"];
            this.createTrainingCycle = _data["createTrainingCycle"];
            this.maintainTrainingPlan = _data["maintainTrainingPlan"];
            this.createSurveys = _data["createSurveys"];
        }
    }

    static fromJS(data: any): TrainingPermission {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["training"] = this.training;
        data["createTrainingCycle"] = this.createTrainingCycle;
        data["maintainTrainingPlan"] = this.maintainTrainingPlan;
        data["createSurveys"] = this.createSurveys;
        return data;
    }
}

export interface ITrainingPermission {
    training: boolean;
    createTrainingCycle: boolean;
    maintainTrainingPlan: boolean;
    createSurveys: boolean;
}

export class TrainingPlanRowResponse implements ITrainingPlanRowResponse {
    id!: number;
    isActive!: boolean;
    trainingCycleId!: number;
    trainerUserId?: number | undefined;
    location?: string | undefined;
    plannedDate?: Date | undefined;
    plannedTime?: number | undefined;
    plannedTimeTo?: number | undefined;
    duration?: number | undefined;
    linkToMaterial?: string | undefined;
    linkToVideo?: string | undefined;
    level3ProcessId?: string | undefined;
    level3ProcessName?: string | undefined;
    participantUserIds?: number[] | undefined;

    constructor(data?: ITrainingPlanRowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.trainingCycleId = _data["trainingCycleId"];
            this.trainerUserId = _data["trainerUserId"];
            this.location = _data["location"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.plannedTime = _data["plannedTime"];
            this.plannedTimeTo = _data["plannedTimeTo"];
            this.duration = _data["duration"];
            this.linkToMaterial = _data["linkToMaterial"];
            this.linkToVideo = _data["linkToVideo"];
            this.level3ProcessId = _data["level3ProcessId"];
            this.level3ProcessName = _data["level3ProcessName"];
            if (Array.isArray(_data["participantUserIds"])) {
                this.participantUserIds = [] as any;
                for (let item of _data["participantUserIds"])
                    this.participantUserIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TrainingPlanRowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingPlanRowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["trainingCycleId"] = this.trainingCycleId;
        data["trainerUserId"] = this.trainerUserId;
        data["location"] = this.location;
        data["plannedDate"] = this.plannedDate ? formatDate(this.plannedDate) : undefined as any;
        data["plannedTime"] = this.plannedTime;
        data["plannedTimeTo"] = this.plannedTimeTo;
        data["duration"] = this.duration;
        data["linkToMaterial"] = this.linkToMaterial;
        data["linkToVideo"] = this.linkToVideo;
        data["level3ProcessId"] = this.level3ProcessId;
        data["level3ProcessName"] = this.level3ProcessName;
        if (Array.isArray(this.participantUserIds)) {
            data["participantUserIds"] = [];
            for (let item of this.participantUserIds)
                data["participantUserIds"].push(item);
        }
        return data;
    }
}

export interface ITrainingPlanRowResponse {
    id: number;
    isActive: boolean;
    trainingCycleId: number;
    trainerUserId?: number | undefined;
    location?: string | undefined;
    plannedDate?: Date | undefined;
    plannedTime?: number | undefined;
    plannedTimeTo?: number | undefined;
    duration?: number | undefined;
    linkToMaterial?: string | undefined;
    linkToVideo?: string | undefined;
    level3ProcessId?: string | undefined;
    level3ProcessName?: string | undefined;
    participantUserIds?: number[] | undefined;
}

export class TrainingPlanRowResponseItemsResponseModel implements ITrainingPlanRowResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TrainingPlanRowResponse[] | undefined;

    constructor(data?: ITrainingPlanRowResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TrainingPlanRowResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrainingPlanRowResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingPlanRowResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITrainingPlanRowResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TrainingPlanRowResponse[] | undefined;
}

export class TrainingPlanRowResponseSimpleResponseModel implements ITrainingPlanRowResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TrainingPlanRowResponse;

    constructor(data?: ITrainingPlanRowResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TrainingPlanRowResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TrainingPlanRowResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingPlanRowResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITrainingPlanRowResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TrainingPlanRowResponse;
}

export enum TrainingStatusEnum {
    NotStarted = "NotStarted",
    InProgress = "InProgress",
    Completed = "Completed",
}

export class TrainingStatusResponse implements ITrainingStatusResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isReadonly!: boolean;
    color!: string;
    isInitial!: boolean;
    nextStates?: number[] | undefined;
    order!: number;
    semantics!: TrainingStatusEnum;

    constructor(data?: ITrainingStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isReadonly = _data["isReadonly"];
            this.color = _data["color"];
            this.isInitial = _data["isInitial"];
            if (Array.isArray(_data["nextStates"])) {
                this.nextStates = [] as any;
                for (let item of _data["nextStates"])
                    this.nextStates!.push(item);
            }
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): TrainingStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isReadonly"] = this.isReadonly;
        data["color"] = this.color;
        data["isInitial"] = this.isInitial;
        if (Array.isArray(this.nextStates)) {
            data["nextStates"] = [];
            for (let item of this.nextStates)
                data["nextStates"].push(item);
        }
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface ITrainingStatusResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isReadonly: boolean;
    color: string;
    isInitial: boolean;
    nextStates?: number[] | undefined;
    order: number;
    semantics: TrainingStatusEnum;
}

export class TrainingStatusResponseItemsResponseModel implements ITrainingStatusResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TrainingStatusResponse[] | undefined;

    constructor(data?: ITrainingStatusResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TrainingStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrainingStatusResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingStatusResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITrainingStatusResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TrainingStatusResponse[] | undefined;
}

export enum TravelByEnum {
    CompanyCar = "CompanyCar",
    Bus = "Bus",
    Train = "Train",
    Plane = "Plane",
    PrivateCar = "PrivateCar",
    Other = "Other",
}

export class TravelExpenseItemResponse implements ITravelExpenseItemResponse {
    id!: number;
    costTypeId!: number;
    amountProjectCurrency!: number;
    receiptCurrencyId?: number | undefined;
    amountReceiptCurrency?: number | undefined;
    attachments?: AttachmentResponse[] | undefined;

    constructor(data?: ITravelExpenseItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.costTypeId = _data["costTypeId"];
            this.amountProjectCurrency = _data["amountProjectCurrency"];
            this.receiptCurrencyId = _data["receiptCurrencyId"];
            this.amountReceiptCurrency = _data["amountReceiptCurrency"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AttachmentResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TravelExpenseItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TravelExpenseItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["costTypeId"] = this.costTypeId;
        data["amountProjectCurrency"] = this.amountProjectCurrency;
        data["receiptCurrencyId"] = this.receiptCurrencyId;
        data["amountReceiptCurrency"] = this.amountReceiptCurrency;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITravelExpenseItemResponse {
    id: number;
    costTypeId: number;
    amountProjectCurrency: number;
    receiptCurrencyId?: number | undefined;
    amountReceiptCurrency?: number | undefined;
    attachments?: AttachmentResponse[] | undefined;
}

export class TravelExpenseResponse implements ITravelExpenseResponse {
    id!: number;
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    description!: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    statusId!: number;
    userId!: number;
    approvedOrRejectedByUserId?: number | undefined;
    approvedOrRejectedOn?: Date | undefined;
    travelRequestId?: number | undefined;
    destinationCountryId!: number;
    destinationCity!: string;
    estimatedCosts?: number | undefined;
    advancePayment?: number | undefined;
    amount!: number;
    freeMeals!: boolean;
    freeAccommodation!: boolean;
    travelBy!: TravelByEnum;
    regNumber?: string | undefined;
    distance?: string | undefined;
    startKilemeter?: string | undefined;
    endKilometer?: string | undefined;
    leaveDepartureDate!: Date;
    leaveDepartureTime!: number;
    leaveBorderCrossDate?: Date | undefined;
    leaveBorderCrossTime?: number | undefined;
    leaveArrivalDate?: Date | undefined;
    leaveArrivalTime?: number | undefined;
    readonly leaveTravelTimeInMinutes?: number | undefined;
    returnDepartureDate?: Date | undefined;
    returnDepartureTime?: number | undefined;
    returnBorderCrossDate?: Date | undefined;
    returnBorderCrossTime?: number | undefined;
    returnArrivalDate!: Date;
    returnArrivalTime!: number;
    readonly returnTravelTimeInMinutes?: number | undefined;
    readonly totalTravelDurationInMinutes!: number;
    travelExpenseItems?: TravelExpenseItemResponse[] | undefined;

    constructor(data?: ITravelExpenseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.description = _data["description"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.statusId = _data["statusId"];
            this.userId = _data["userId"];
            this.approvedOrRejectedByUserId = _data["approvedOrRejectedByUserId"];
            this.approvedOrRejectedOn = _data["approvedOrRejectedOn"] ? new Date(_data["approvedOrRejectedOn"].toString()) : undefined as any;
            this.travelRequestId = _data["travelRequestId"];
            this.destinationCountryId = _data["destinationCountryId"];
            this.destinationCity = _data["destinationCity"];
            this.estimatedCosts = _data["estimatedCosts"];
            this.advancePayment = _data["advancePayment"];
            this.amount = _data["amount"];
            this.freeMeals = _data["freeMeals"];
            this.freeAccommodation = _data["freeAccommodation"];
            this.travelBy = _data["travelBy"];
            this.regNumber = _data["regNumber"];
            this.distance = _data["distance"];
            this.startKilemeter = _data["startKilemeter"];
            this.endKilometer = _data["endKilometer"];
            this.leaveDepartureDate = _data["leaveDepartureDate"] ? new Date(_data["leaveDepartureDate"].toString()) : undefined as any;
            this.leaveDepartureTime = _data["leaveDepartureTime"];
            this.leaveBorderCrossDate = _data["leaveBorderCrossDate"] ? new Date(_data["leaveBorderCrossDate"].toString()) : undefined as any;
            this.leaveBorderCrossTime = _data["leaveBorderCrossTime"];
            this.leaveArrivalDate = _data["leaveArrivalDate"] ? new Date(_data["leaveArrivalDate"].toString()) : undefined as any;
            this.leaveArrivalTime = _data["leaveArrivalTime"];
            (this as any).leaveTravelTimeInMinutes = _data["leaveTravelTimeInMinutes"];
            this.returnDepartureDate = _data["returnDepartureDate"] ? new Date(_data["returnDepartureDate"].toString()) : undefined as any;
            this.returnDepartureTime = _data["returnDepartureTime"];
            this.returnBorderCrossDate = _data["returnBorderCrossDate"] ? new Date(_data["returnBorderCrossDate"].toString()) : undefined as any;
            this.returnBorderCrossTime = _data["returnBorderCrossTime"];
            this.returnArrivalDate = _data["returnArrivalDate"] ? new Date(_data["returnArrivalDate"].toString()) : undefined as any;
            this.returnArrivalTime = _data["returnArrivalTime"];
            (this as any).returnTravelTimeInMinutes = _data["returnTravelTimeInMinutes"];
            (this as any).totalTravelDurationInMinutes = _data["totalTravelDurationInMinutes"];
            if (Array.isArray(_data["travelExpenseItems"])) {
                this.travelExpenseItems = [] as any;
                for (let item of _data["travelExpenseItems"])
                    this.travelExpenseItems!.push(TravelExpenseItemResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TravelExpenseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TravelExpenseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["description"] = this.description;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["statusId"] = this.statusId;
        data["userId"] = this.userId;
        data["approvedOrRejectedByUserId"] = this.approvedOrRejectedByUserId;
        data["approvedOrRejectedOn"] = this.approvedOrRejectedOn ? this.approvedOrRejectedOn.toISOString() : undefined as any;
        data["travelRequestId"] = this.travelRequestId;
        data["destinationCountryId"] = this.destinationCountryId;
        data["destinationCity"] = this.destinationCity;
        data["estimatedCosts"] = this.estimatedCosts;
        data["advancePayment"] = this.advancePayment;
        data["amount"] = this.amount;
        data["freeMeals"] = this.freeMeals;
        data["freeAccommodation"] = this.freeAccommodation;
        data["travelBy"] = this.travelBy;
        data["regNumber"] = this.regNumber;
        data["distance"] = this.distance;
        data["startKilemeter"] = this.startKilemeter;
        data["endKilometer"] = this.endKilometer;
        data["leaveDepartureDate"] = this.leaveDepartureDate ? formatDate(this.leaveDepartureDate) : undefined as any;
        data["leaveDepartureTime"] = this.leaveDepartureTime;
        data["leaveBorderCrossDate"] = this.leaveBorderCrossDate ? formatDate(this.leaveBorderCrossDate) : undefined as any;
        data["leaveBorderCrossTime"] = this.leaveBorderCrossTime;
        data["leaveArrivalDate"] = this.leaveArrivalDate ? formatDate(this.leaveArrivalDate) : undefined as any;
        data["leaveArrivalTime"] = this.leaveArrivalTime;
        data["leaveTravelTimeInMinutes"] = this.leaveTravelTimeInMinutes;
        data["returnDepartureDate"] = this.returnDepartureDate ? formatDate(this.returnDepartureDate) : undefined as any;
        data["returnDepartureTime"] = this.returnDepartureTime;
        data["returnBorderCrossDate"] = this.returnBorderCrossDate ? formatDate(this.returnBorderCrossDate) : undefined as any;
        data["returnBorderCrossTime"] = this.returnBorderCrossTime;
        data["returnArrivalDate"] = this.returnArrivalDate ? formatDate(this.returnArrivalDate) : undefined as any;
        data["returnArrivalTime"] = this.returnArrivalTime;
        data["returnTravelTimeInMinutes"] = this.returnTravelTimeInMinutes;
        data["totalTravelDurationInMinutes"] = this.totalTravelDurationInMinutes;
        if (Array.isArray(this.travelExpenseItems)) {
            data["travelExpenseItems"] = [];
            for (let item of this.travelExpenseItems)
                data["travelExpenseItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITravelExpenseResponse {
    id: number;
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    description: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    statusId: number;
    userId: number;
    approvedOrRejectedByUserId?: number | undefined;
    approvedOrRejectedOn?: Date | undefined;
    travelRequestId?: number | undefined;
    destinationCountryId: number;
    destinationCity: string;
    estimatedCosts?: number | undefined;
    advancePayment?: number | undefined;
    amount: number;
    freeMeals: boolean;
    freeAccommodation: boolean;
    travelBy: TravelByEnum;
    regNumber?: string | undefined;
    distance?: string | undefined;
    startKilemeter?: string | undefined;
    endKilometer?: string | undefined;
    leaveDepartureDate: Date;
    leaveDepartureTime: number;
    leaveBorderCrossDate?: Date | undefined;
    leaveBorderCrossTime?: number | undefined;
    leaveArrivalDate?: Date | undefined;
    leaveArrivalTime?: number | undefined;
    leaveTravelTimeInMinutes?: number | undefined;
    returnDepartureDate?: Date | undefined;
    returnDepartureTime?: number | undefined;
    returnBorderCrossDate?: Date | undefined;
    returnBorderCrossTime?: number | undefined;
    returnArrivalDate: Date;
    returnArrivalTime: number;
    returnTravelTimeInMinutes?: number | undefined;
    totalTravelDurationInMinutes: number;
    travelExpenseItems?: TravelExpenseItemResponse[] | undefined;
}

export class TravelExpenseResponseItemsResponseModel implements ITravelExpenseResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TravelExpenseResponse[] | undefined;

    constructor(data?: ITravelExpenseResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TravelExpenseResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TravelExpenseResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TravelExpenseResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITravelExpenseResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TravelExpenseResponse[] | undefined;
}

export class TravelExpenseResponseSimpleResponseModel implements ITravelExpenseResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TravelExpenseResponse;

    constructor(data?: ITravelExpenseResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TravelExpenseResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TravelExpenseResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TravelExpenseResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITravelExpenseResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TravelExpenseResponse;
}

export class TravelExpenseTotalsResponse implements ITravelExpenseTotalsResponse {
    totalEstimatedCosts!: number;
    totalAmounts!: number;
    totalTravelDurationInMinutes!: number;
    totalLeaveTravelTimeInMinutes!: number;
    totalReturnTravelTimeInMinutes!: number;

    constructor(data?: ITravelExpenseTotalsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalEstimatedCosts = _data["totalEstimatedCosts"];
            this.totalAmounts = _data["totalAmounts"];
            this.totalTravelDurationInMinutes = _data["totalTravelDurationInMinutes"];
            this.totalLeaveTravelTimeInMinutes = _data["totalLeaveTravelTimeInMinutes"];
            this.totalReturnTravelTimeInMinutes = _data["totalReturnTravelTimeInMinutes"];
        }
    }

    static fromJS(data: any): TravelExpenseTotalsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TravelExpenseTotalsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalEstimatedCosts"] = this.totalEstimatedCosts;
        data["totalAmounts"] = this.totalAmounts;
        data["totalTravelDurationInMinutes"] = this.totalTravelDurationInMinutes;
        data["totalLeaveTravelTimeInMinutes"] = this.totalLeaveTravelTimeInMinutes;
        data["totalReturnTravelTimeInMinutes"] = this.totalReturnTravelTimeInMinutes;
        return data;
    }
}

export interface ITravelExpenseTotalsResponse {
    totalEstimatedCosts: number;
    totalAmounts: number;
    totalTravelDurationInMinutes: number;
    totalLeaveTravelTimeInMinutes: number;
    totalReturnTravelTimeInMinutes: number;
}

export class TravelExpenseTotalsResponseSimpleResponseModel implements ITravelExpenseTotalsResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TravelExpenseTotalsResponse;

    constructor(data?: ITravelExpenseTotalsResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TravelExpenseTotalsResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TravelExpenseTotalsResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TravelExpenseTotalsResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITravelExpenseTotalsResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TravelExpenseTotalsResponse;
}

export class TravelRequestResponse implements ITravelRequestResponse {
    id!: number;
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    description!: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    statusId!: number;
    userId!: number;
    approvedOrRejectedByUserId?: number | undefined;
    approvedOrRejectedOn?: Date | undefined;
    destinationCountryId!: number;
    destinationCity!: string;
    departure!: Date;
    return!: Date;
    estimatedCosts!: number;
    advancePayment?: number | undefined;
    freeMeals!: boolean;
    freeAccommodation!: boolean;
    travelBy!: TravelByEnum;

    constructor(data?: ITravelRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.description = _data["description"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.statusId = _data["statusId"];
            this.userId = _data["userId"];
            this.approvedOrRejectedByUserId = _data["approvedOrRejectedByUserId"];
            this.approvedOrRejectedOn = _data["approvedOrRejectedOn"] ? new Date(_data["approvedOrRejectedOn"].toString()) : undefined as any;
            this.destinationCountryId = _data["destinationCountryId"];
            this.destinationCity = _data["destinationCity"];
            this.departure = _data["departure"] ? new Date(_data["departure"].toString()) : undefined as any;
            this.return = _data["return"] ? new Date(_data["return"].toString()) : undefined as any;
            this.estimatedCosts = _data["estimatedCosts"];
            this.advancePayment = _data["advancePayment"];
            this.freeMeals = _data["freeMeals"];
            this.freeAccommodation = _data["freeAccommodation"];
            this.travelBy = _data["travelBy"];
        }
    }

    static fromJS(data: any): TravelRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["description"] = this.description;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["statusId"] = this.statusId;
        data["userId"] = this.userId;
        data["approvedOrRejectedByUserId"] = this.approvedOrRejectedByUserId;
        data["approvedOrRejectedOn"] = this.approvedOrRejectedOn ? this.approvedOrRejectedOn.toISOString() : undefined as any;
        data["destinationCountryId"] = this.destinationCountryId;
        data["destinationCity"] = this.destinationCity;
        data["departure"] = this.departure ? formatDate(this.departure) : undefined as any;
        data["return"] = this.return ? formatDate(this.return) : undefined as any;
        data["estimatedCosts"] = this.estimatedCosts;
        data["advancePayment"] = this.advancePayment;
        data["freeMeals"] = this.freeMeals;
        data["freeAccommodation"] = this.freeAccommodation;
        data["travelBy"] = this.travelBy;
        return data;
    }
}

export interface ITravelRequestResponse {
    id: number;
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    description: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    statusId: number;
    userId: number;
    approvedOrRejectedByUserId?: number | undefined;
    approvedOrRejectedOn?: Date | undefined;
    destinationCountryId: number;
    destinationCity: string;
    departure: Date;
    return: Date;
    estimatedCosts: number;
    advancePayment?: number | undefined;
    freeMeals: boolean;
    freeAccommodation: boolean;
    travelBy: TravelByEnum;
}

export class TravelRequestResponseItemsResponseModel implements ITravelRequestResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TravelRequestResponse[] | undefined;

    constructor(data?: ITravelRequestResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TravelRequestResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TravelRequestResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITravelRequestResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: TravelRequestResponse[] | undefined;
}

export class TravelRequestResponseSimpleResponseModel implements ITravelRequestResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TravelRequestResponse;

    constructor(data?: ITravelRequestResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TravelRequestResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TravelRequestResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITravelRequestResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TravelRequestResponse;
}

export class TravelRequestTotalsResponse implements ITravelRequestTotalsResponse {
    totalEstimatedCosts!: number;

    constructor(data?: ITravelRequestTotalsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalEstimatedCosts = _data["totalEstimatedCosts"];
        }
    }

    static fromJS(data: any): TravelRequestTotalsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestTotalsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalEstimatedCosts"] = this.totalEstimatedCosts;
        return data;
    }
}

export interface ITravelRequestTotalsResponse {
    totalEstimatedCosts: number;
}

export class TravelRequestTotalsResponseSimpleResponseModel implements ITravelRequestTotalsResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TravelRequestTotalsResponse;

    constructor(data?: ITravelRequestTotalsResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? TravelRequestTotalsResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): TravelRequestTotalsResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TravelRequestTotalsResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface ITravelRequestTotalsResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: TravelRequestTotalsResponse;
}

export class UpdateBudgetConfigurationRequest implements IUpdateBudgetConfigurationRequest {
    planFrom!: Date;
    planTo!: Date;
    includeRiskInBudget!: boolean;
    includePlannedInvoicesInBudget!: boolean;
    includeApprovedChangeRequestsInBudget!: boolean;
    includeScheduleInBudget!: boolean;
    includeCompletedChangeRequests!: boolean;
    includeApprovedTimesheetsInActual!: boolean;
    includeApprovedGuestTimesheetsInActual!: boolean;
    includeApprovedTravelExpensesInActual!: boolean;
    includeIssuedReceivedAndPayedInvoicesInActual!: boolean;
    actualsTimesheetsPerUser!: boolean;
    actualsTravelExpensesPerUser!: boolean;
    actualsInvoicesPerPartner!: boolean;
    id!: number;

    constructor(data?: IUpdateBudgetConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planFrom = _data["planFrom"] ? new Date(_data["planFrom"].toString()) : undefined as any;
            this.planTo = _data["planTo"] ? new Date(_data["planTo"].toString()) : undefined as any;
            this.includeRiskInBudget = _data["includeRiskInBudget"];
            this.includePlannedInvoicesInBudget = _data["includePlannedInvoicesInBudget"];
            this.includeApprovedChangeRequestsInBudget = _data["includeApprovedChangeRequestsInBudget"];
            this.includeScheduleInBudget = _data["includeScheduleInBudget"];
            this.includeCompletedChangeRequests = _data["includeCompletedChangeRequests"];
            this.includeApprovedTimesheetsInActual = _data["includeApprovedTimesheetsInActual"];
            this.includeApprovedGuestTimesheetsInActual = _data["includeApprovedGuestTimesheetsInActual"];
            this.includeApprovedTravelExpensesInActual = _data["includeApprovedTravelExpensesInActual"];
            this.includeIssuedReceivedAndPayedInvoicesInActual = _data["includeIssuedReceivedAndPayedInvoicesInActual"];
            this.actualsTimesheetsPerUser = _data["actualsTimesheetsPerUser"];
            this.actualsTravelExpensesPerUser = _data["actualsTravelExpensesPerUser"];
            this.actualsInvoicesPerPartner = _data["actualsInvoicesPerPartner"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateBudgetConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBudgetConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planFrom"] = this.planFrom ? formatDate(this.planFrom) : undefined as any;
        data["planTo"] = this.planTo ? formatDate(this.planTo) : undefined as any;
        data["includeRiskInBudget"] = this.includeRiskInBudget;
        data["includePlannedInvoicesInBudget"] = this.includePlannedInvoicesInBudget;
        data["includeApprovedChangeRequestsInBudget"] = this.includeApprovedChangeRequestsInBudget;
        data["includeScheduleInBudget"] = this.includeScheduleInBudget;
        data["includeCompletedChangeRequests"] = this.includeCompletedChangeRequests;
        data["includeApprovedTimesheetsInActual"] = this.includeApprovedTimesheetsInActual;
        data["includeApprovedGuestTimesheetsInActual"] = this.includeApprovedGuestTimesheetsInActual;
        data["includeApprovedTravelExpensesInActual"] = this.includeApprovedTravelExpensesInActual;
        data["includeIssuedReceivedAndPayedInvoicesInActual"] = this.includeIssuedReceivedAndPayedInvoicesInActual;
        data["actualsTimesheetsPerUser"] = this.actualsTimesheetsPerUser;
        data["actualsTravelExpensesPerUser"] = this.actualsTravelExpensesPerUser;
        data["actualsInvoicesPerPartner"] = this.actualsInvoicesPerPartner;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateBudgetConfigurationRequest {
    planFrom: Date;
    planTo: Date;
    includeRiskInBudget: boolean;
    includePlannedInvoicesInBudget: boolean;
    includeApprovedChangeRequestsInBudget: boolean;
    includeScheduleInBudget: boolean;
    includeCompletedChangeRequests: boolean;
    includeApprovedTimesheetsInActual: boolean;
    includeApprovedGuestTimesheetsInActual: boolean;
    includeApprovedTravelExpensesInActual: boolean;
    includeIssuedReceivedAndPayedInvoicesInActual: boolean;
    actualsTimesheetsPerUser: boolean;
    actualsTravelExpensesPerUser: boolean;
    actualsInvoicesPerPartner: boolean;
    id: number;
}

export class UpdateBudgetRowRequest implements IUpdateBudgetRowRequest {
    financeCategoryId!: number;
    userId?: number | undefined;
    partnerId?: number | undefined;
    incomeExpense!: IncomeExpenseEnum;
    customField?: string | undefined;
    budgetDateValues?: BudgetDateValueRequest[] | undefined;
    id!: number;

    constructor(data?: IUpdateBudgetRowRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financeCategoryId = _data["financeCategoryId"];
            this.userId = _data["userId"];
            this.partnerId = _data["partnerId"];
            this.incomeExpense = _data["incomeExpense"];
            this.customField = _data["customField"];
            if (Array.isArray(_data["budgetDateValues"])) {
                this.budgetDateValues = [] as any;
                for (let item of _data["budgetDateValues"])
                    this.budgetDateValues!.push(BudgetDateValueRequest.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateBudgetRowRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBudgetRowRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financeCategoryId"] = this.financeCategoryId;
        data["userId"] = this.userId;
        data["partnerId"] = this.partnerId;
        data["incomeExpense"] = this.incomeExpense;
        data["customField"] = this.customField;
        if (Array.isArray(this.budgetDateValues)) {
            data["budgetDateValues"] = [];
            for (let item of this.budgetDateValues)
                data["budgetDateValues"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateBudgetRowRequest {
    financeCategoryId: number;
    userId?: number | undefined;
    partnerId?: number | undefined;
    incomeExpense: IncomeExpenseEnum;
    customField?: string | undefined;
    budgetDateValues?: BudgetDateValueRequest[] | undefined;
    id: number;
}

export class UpdateChangeRequestActivityRequest implements IUpdateChangeRequestActivityRequest {
    name!: string;
    expectedDeliveryOn?: Date | undefined;
    effortInHours?: number | undefined;
    cost?: number | undefined;
    order!: number;
    id!: number;

    constructor(data?: IUpdateChangeRequestActivityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.expectedDeliveryOn = _data["expectedDeliveryOn"] ? new Date(_data["expectedDeliveryOn"].toString()) : undefined as any;
            this.effortInHours = _data["effortInHours"];
            this.cost = _data["cost"];
            this.order = _data["order"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateChangeRequestActivityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChangeRequestActivityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["expectedDeliveryOn"] = this.expectedDeliveryOn ? formatDate(this.expectedDeliveryOn) : undefined as any;
        data["effortInHours"] = this.effortInHours;
        data["cost"] = this.cost;
        data["order"] = this.order;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateChangeRequestActivityRequest {
    name: string;
    expectedDeliveryOn?: Date | undefined;
    effortInHours?: number | undefined;
    cost?: number | undefined;
    order: number;
    id: number;
}

export class UpdateChangeRequestRequest implements IUpdateChangeRequestRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    analysisUserId?: number | undefined;
    initiatedBy?: string | undefined;
    requestedOn?: Date | undefined;
    typeId?: number | undefined;
    goLiveCritical!: boolean;
    impactId!: number;
    urgencyId!: number;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    expectedCompletionDate?: Date | undefined;
    scopeItemLevelIdsToAdd?: number[] | undefined;
    scopeItemLevelIdsToRemove?: number[] | undefined;
    ticketIdsToAdd?: number[] | undefined;
    ticketIdsToRemove?: number[] | undefined;
    reasonOfChange?: string | undefined;
    expectedBenefit?: string | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    isInitiate!: boolean;
    sendEmail!: boolean;

    constructor(data?: IUpdateChangeRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.analysisUserId = _data["analysisUserId"];
            this.initiatedBy = _data["initiatedBy"];
            this.requestedOn = _data["requestedOn"] ? new Date(_data["requestedOn"].toString()) : undefined as any;
            this.typeId = _data["typeId"];
            this.goLiveCritical = _data["goLiveCritical"];
            this.impactId = _data["impactId"];
            this.urgencyId = _data["urgencyId"];
            this.projectTeamId = _data["projectTeamId"];
            this.projectOrganizationId = _data["projectOrganizationId"];
            this.expectedCompletionDate = _data["expectedCompletionDate"] ? new Date(_data["expectedCompletionDate"].toString()) : undefined as any;
            if (Array.isArray(_data["scopeItemLevelIdsToAdd"])) {
                this.scopeItemLevelIdsToAdd = [] as any;
                for (let item of _data["scopeItemLevelIdsToAdd"])
                    this.scopeItemLevelIdsToAdd!.push(item);
            }
            if (Array.isArray(_data["scopeItemLevelIdsToRemove"])) {
                this.scopeItemLevelIdsToRemove = [] as any;
                for (let item of _data["scopeItemLevelIdsToRemove"])
                    this.scopeItemLevelIdsToRemove!.push(item);
            }
            if (Array.isArray(_data["ticketIdsToAdd"])) {
                this.ticketIdsToAdd = [] as any;
                for (let item of _data["ticketIdsToAdd"])
                    this.ticketIdsToAdd!.push(item);
            }
            if (Array.isArray(_data["ticketIdsToRemove"])) {
                this.ticketIdsToRemove = [] as any;
                for (let item of _data["ticketIdsToRemove"])
                    this.ticketIdsToRemove!.push(item);
            }
            this.reasonOfChange = _data["reasonOfChange"];
            this.expectedBenefit = _data["expectedBenefit"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            this.isInitiate = _data["isInitiate"];
            this.sendEmail = _data["sendEmail"];
        }
    }

    static fromJS(data: any): UpdateChangeRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChangeRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["analysisUserId"] = this.analysisUserId;
        data["initiatedBy"] = this.initiatedBy;
        data["requestedOn"] = this.requestedOn ? formatDate(this.requestedOn) : undefined as any;
        data["typeId"] = this.typeId;
        data["goLiveCritical"] = this.goLiveCritical;
        data["impactId"] = this.impactId;
        data["urgencyId"] = this.urgencyId;
        data["projectTeamId"] = this.projectTeamId;
        data["projectOrganizationId"] = this.projectOrganizationId;
        data["expectedCompletionDate"] = this.expectedCompletionDate ? formatDate(this.expectedCompletionDate) : undefined as any;
        if (Array.isArray(this.scopeItemLevelIdsToAdd)) {
            data["scopeItemLevelIdsToAdd"] = [];
            for (let item of this.scopeItemLevelIdsToAdd)
                data["scopeItemLevelIdsToAdd"].push(item);
        }
        if (Array.isArray(this.scopeItemLevelIdsToRemove)) {
            data["scopeItemLevelIdsToRemove"] = [];
            for (let item of this.scopeItemLevelIdsToRemove)
                data["scopeItemLevelIdsToRemove"].push(item);
        }
        if (Array.isArray(this.ticketIdsToAdd)) {
            data["ticketIdsToAdd"] = [];
            for (let item of this.ticketIdsToAdd)
                data["ticketIdsToAdd"].push(item);
        }
        if (Array.isArray(this.ticketIdsToRemove)) {
            data["ticketIdsToRemove"] = [];
            for (let item of this.ticketIdsToRemove)
                data["ticketIdsToRemove"].push(item);
        }
        data["reasonOfChange"] = this.reasonOfChange;
        data["expectedBenefit"] = this.expectedBenefit;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["isInitiate"] = this.isInitiate;
        data["sendEmail"] = this.sendEmail;
        return data;
    }
}

export interface IUpdateChangeRequestRequest {
    name: string;
    description?: string | undefined;
    id: number;
    analysisUserId?: number | undefined;
    initiatedBy?: string | undefined;
    requestedOn?: Date | undefined;
    typeId?: number | undefined;
    goLiveCritical: boolean;
    impactId: number;
    urgencyId: number;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    expectedCompletionDate?: Date | undefined;
    scopeItemLevelIdsToAdd?: number[] | undefined;
    scopeItemLevelIdsToRemove?: number[] | undefined;
    ticketIdsToAdd?: number[] | undefined;
    ticketIdsToRemove?: number[] | undefined;
    reasonOfChange?: string | undefined;
    expectedBenefit?: string | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    isInitiate: boolean;
    sendEmail: boolean;
}

export class UpdateCostExpenseTypeRequest implements IUpdateCostExpenseTypeRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    isActive!: boolean;
    mandatoryAttachments!: boolean;

    constructor(data?: IUpdateCostExpenseTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.mandatoryAttachments = _data["mandatoryAttachments"];
        }
    }

    static fromJS(data: any): UpdateCostExpenseTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCostExpenseTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["mandatoryAttachments"] = this.mandatoryAttachments;
        return data;
    }
}

export interface IUpdateCostExpenseTypeRequest {
    name: string;
    description?: string | undefined;
    id: number;
    isActive: boolean;
    mandatoryAttachments: boolean;
}

export class UpdateEmailTemplateRequestModel implements IUpdateEmailTemplateRequestModel {
    id!: number;
    name?: string | undefined;
    readonly pKs?: any[] | undefined;

    constructor(data?: IUpdateEmailTemplateRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["pKs"])) {
                (this as any).pKs = [] as any;
                for (let item of _data["pKs"])
                    (this as any).pKs!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateEmailTemplateRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmailTemplateRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.pKs)) {
            data["pKs"] = [];
            for (let item of this.pKs)
                data["pKs"].push(item);
        }
        return data;
    }
}

export interface IUpdateEmailTemplateRequestModel {
    id: number;
    name?: string | undefined;
    pKs?: any[] | undefined;
}

export class UpdateExpenseItemRequest implements IUpdateExpenseItemRequest {
    expenseTypeId!: number;
    amountProjectCurrency!: number;
    receiptCurrencyId?: number | undefined;
    amountReceiptCurrency?: number | undefined;
    comment?: string | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    id!: number;
    removedAttachments?: number[] | undefined;

    constructor(data?: IUpdateExpenseItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expenseTypeId = _data["expenseTypeId"];
            this.amountProjectCurrency = _data["amountProjectCurrency"];
            this.receiptCurrencyId = _data["receiptCurrencyId"];
            this.amountReceiptCurrency = _data["amountReceiptCurrency"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            this.id = _data["id"];
            if (Array.isArray(_data["removedAttachments"])) {
                this.removedAttachments = [] as any;
                for (let item of _data["removedAttachments"])
                    this.removedAttachments!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateExpenseItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExpenseItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expenseTypeId"] = this.expenseTypeId;
        data["amountProjectCurrency"] = this.amountProjectCurrency;
        data["receiptCurrencyId"] = this.receiptCurrencyId;
        data["amountReceiptCurrency"] = this.amountReceiptCurrency;
        data["comment"] = this.comment;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        if (Array.isArray(this.removedAttachments)) {
            data["removedAttachments"] = [];
            for (let item of this.removedAttachments)
                data["removedAttachments"].push(item);
        }
        return data;
    }
}

export interface IUpdateExpenseItemRequest {
    expenseTypeId: number;
    amountProjectCurrency: number;
    receiptCurrencyId?: number | undefined;
    amountReceiptCurrency?: number | undefined;
    comment?: string | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    id: number;
    removedAttachments?: number[] | undefined;
}

export class UpdateExpenseRequest implements IUpdateExpenseRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    description!: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease!: boolean;
    id!: number;
    date!: Date;
    expenseItemsDelta?: InsertExpenseItemRequestUpdateExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel;

    constructor(data?: IUpdateExpenseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.description = _data["description"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.isRelease = _data["isRelease"];
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.expenseItemsDelta = _data["expenseItemsDelta"] ? InsertExpenseItemRequestUpdateExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel.fromJS(_data["expenseItemsDelta"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateExpenseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExpenseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["description"] = this.description;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["isRelease"] = this.isRelease;
        data["id"] = this.id;
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["expenseItemsDelta"] = this.expenseItemsDelta ? this.expenseItemsDelta.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateExpenseRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    description: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease: boolean;
    id: number;
    date: Date;
    expenseItemsDelta?: InsertExpenseItemRequestUpdateExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel;
}

export class UpdateFinanceGeneralConfigRequest implements IUpdateFinanceGeneralConfigRequest {
    planingInterval!: FinancePlaningIntervalEnum;
    id!: number;

    constructor(data?: IUpdateFinanceGeneralConfigRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planingInterval = _data["planingInterval"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateFinanceGeneralConfigRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinanceGeneralConfigRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planingInterval"] = this.planingInterval;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateFinanceGeneralConfigRequest {
    planingInterval: FinancePlaningIntervalEnum;
    id: number;
}

export class UpdateGeneratedProjectMilestoneRequest implements IUpdateGeneratedProjectMilestoneRequest {
    id!: number;
    milestoneDeviation?: string | undefined;

    constructor(data?: IUpdateGeneratedProjectMilestoneRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.milestoneDeviation = _data["milestoneDeviation"];
        }
    }

    static fromJS(data: any): UpdateGeneratedProjectMilestoneRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeneratedProjectMilestoneRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["milestoneDeviation"] = this.milestoneDeviation;
        return data;
    }
}

export interface IUpdateGeneratedProjectMilestoneRequest {
    id: number;
    milestoneDeviation?: string | undefined;
}

export class UpdateGeneratedProjectQualityRequest implements IUpdateGeneratedProjectQualityRequest {
    id!: number;
    actions?: string | undefined;
    status!: ReportItemStatusEnum;

    constructor(data?: IUpdateGeneratedProjectQualityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actions = _data["actions"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateGeneratedProjectQualityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGeneratedProjectQualityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actions"] = this.actions;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateGeneratedProjectQualityRequest {
    id: number;
    actions?: string | undefined;
    status: ReportItemStatusEnum;
}

export class UpdateHolidayRequest implements IUpdateHolidayRequest {
    isActive!: boolean;
    name!: string;
    from!: Date;
    to!: Date;
    reccuringEntry!: boolean;
    id!: number;

    constructor(data?: IUpdateHolidayRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.name = _data["name"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.reccuringEntry = _data["reccuringEntry"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateHolidayRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHolidayRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["reccuringEntry"] = this.reccuringEntry;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateHolidayRequest {
    isActive: boolean;
    name: string;
    from: Date;
    to: Date;
    reccuringEntry: boolean;
    id: number;
}

export class UpdateInnerTestPlanRequest implements IUpdateInnerTestPlanRequest {
    id!: number;
    expectedResults?: string | undefined;
    documentsCreated?: string | undefined;
    comment?: string | undefined;
    stepStatusId!: number;
    rejectionComment?: string | undefined;

    constructor(data?: IUpdateInnerTestPlanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.expectedResults = _data["expectedResults"];
            this.documentsCreated = _data["documentsCreated"];
            this.comment = _data["comment"];
            this.stepStatusId = _data["stepStatusId"];
            this.rejectionComment = _data["rejectionComment"];
        }
    }

    static fromJS(data: any): UpdateInnerTestPlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInnerTestPlanRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expectedResults"] = this.expectedResults;
        data["documentsCreated"] = this.documentsCreated;
        data["comment"] = this.comment;
        data["stepStatusId"] = this.stepStatusId;
        data["rejectionComment"] = this.rejectionComment;
        return data;
    }
}

export interface IUpdateInnerTestPlanRequest {
    id: number;
    expectedResults?: string | undefined;
    documentsCreated?: string | undefined;
    comment?: string | undefined;
    stepStatusId: number;
    rejectionComment?: string | undefined;
}

export class UpdateInvoiceItemRequest implements IUpdateInvoiceItemRequest {
    description!: string;
    amount!: number;
    taxAmount!: number;
    localCurrencyAmount?: number | undefined;
    localCurrencyTaxAmount?: number | undefined;
    id!: number;

    constructor(data?: IUpdateInvoiceItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.taxAmount = _data["taxAmount"];
            this.localCurrencyAmount = _data["localCurrencyAmount"];
            this.localCurrencyTaxAmount = _data["localCurrencyTaxAmount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateInvoiceItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["taxAmount"] = this.taxAmount;
        data["localCurrencyAmount"] = this.localCurrencyAmount;
        data["localCurrencyTaxAmount"] = this.localCurrencyTaxAmount;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateInvoiceItemRequest {
    description: string;
    amount: number;
    taxAmount: number;
    localCurrencyAmount?: number | undefined;
    localCurrencyTaxAmount?: number | undefined;
    id: number;
}

export class UpdateInvoiceRequest implements IUpdateInvoiceRequest {
    partnerId!: number;
    invoiceNumber!: string;
    description?: string | undefined;
    invoiceType!: InvoiceTypeEnum;
    issueDate!: Date;
    due!: Date;
    overdueDays?: number | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    excludeFromBudget!: boolean;
    amount!: number;
    taxAmount!: number;
    localCurrencyId?: number | undefined;
    localCurrencyAmount?: number | undefined;
    localCurrencyTaxAmount?: number | undefined;
    comment?: string | undefined;
    changeRequestId?: number | undefined;
    financeCategoryId!: number;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    invoiceItemsDelta?: InsertInvoiceItemRequestUpdateInvoiceItemRequestDeleteTenantIndetifyRequestDeltaModel;
    id!: number;
    statusId!: number;

    constructor(data?: IUpdateInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.description = _data["description"];
            this.invoiceType = _data["invoiceType"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            this.overdueDays = _data["overdueDays"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.excludeFromBudget = _data["excludeFromBudget"];
            this.amount = _data["amount"];
            this.taxAmount = _data["taxAmount"];
            this.localCurrencyId = _data["localCurrencyId"];
            this.localCurrencyAmount = _data["localCurrencyAmount"];
            this.localCurrencyTaxAmount = _data["localCurrencyTaxAmount"];
            this.comment = _data["comment"];
            this.changeRequestId = _data["changeRequestId"];
            this.financeCategoryId = _data["financeCategoryId"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            this.invoiceItemsDelta = _data["invoiceItemsDelta"] ? InsertInvoiceItemRequestUpdateInvoiceItemRequestDeleteTenantIndetifyRequestDeltaModel.fromJS(_data["invoiceItemsDelta"]) : undefined as any;
            this.id = _data["id"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): UpdateInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["description"] = this.description;
        data["invoiceType"] = this.invoiceType;
        data["issueDate"] = this.issueDate ? formatDate(this.issueDate) : undefined as any;
        data["due"] = this.due ? formatDate(this.due) : undefined as any;
        data["overdueDays"] = this.overdueDays;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["excludeFromBudget"] = this.excludeFromBudget;
        data["amount"] = this.amount;
        data["taxAmount"] = this.taxAmount;
        data["localCurrencyId"] = this.localCurrencyId;
        data["localCurrencyAmount"] = this.localCurrencyAmount;
        data["localCurrencyTaxAmount"] = this.localCurrencyTaxAmount;
        data["comment"] = this.comment;
        data["changeRequestId"] = this.changeRequestId;
        data["financeCategoryId"] = this.financeCategoryId;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["invoiceItemsDelta"] = this.invoiceItemsDelta ? this.invoiceItemsDelta.toJSON() : undefined as any;
        data["id"] = this.id;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface IUpdateInvoiceRequest {
    partnerId: number;
    invoiceNumber: string;
    description?: string | undefined;
    invoiceType: InvoiceTypeEnum;
    issueDate: Date;
    due: Date;
    overdueDays?: number | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    excludeFromBudget: boolean;
    amount: number;
    taxAmount: number;
    localCurrencyId?: number | undefined;
    localCurrencyAmount?: number | undefined;
    localCurrencyTaxAmount?: number | undefined;
    comment?: string | undefined;
    changeRequestId?: number | undefined;
    financeCategoryId: number;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    invoiceItemsDelta?: InsertInvoiceItemRequestUpdateInvoiceItemRequestDeleteTenantIndetifyRequestDeltaModel;
    id: number;
    statusId: number;
}

export class UpdateLevel3TestPlanRequest implements IUpdateLevel3TestPlanRequest {
    id!: number;
    isActive!: boolean;
    processTesterUserId?: number | undefined;
    location?: string | undefined;
    plannedDate?: Date | undefined;
    plannedTime?: number | undefined;
    plannedTimeTo?: number | undefined;

    constructor(data?: IUpdateLevel3TestPlanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.processTesterUserId = _data["processTesterUserId"];
            this.location = _data["location"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.plannedTime = _data["plannedTime"];
            this.plannedTimeTo = _data["plannedTimeTo"];
        }
    }

    static fromJS(data: any): UpdateLevel3TestPlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLevel3TestPlanRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["processTesterUserId"] = this.processTesterUserId;
        data["location"] = this.location;
        data["plannedDate"] = this.plannedDate ? formatDate(this.plannedDate) : undefined as any;
        data["plannedTime"] = this.plannedTime;
        data["plannedTimeTo"] = this.plannedTimeTo;
        return data;
    }
}

export interface IUpdateLevel3TestPlanRequest {
    id: number;
    isActive: boolean;
    processTesterUserId?: number | undefined;
    location?: string | undefined;
    plannedDate?: Date | undefined;
    plannedTime?: number | undefined;
    plannedTimeTo?: number | undefined;
}

export class UpdateLevel4TestPlanRequest implements IUpdateLevel4TestPlanRequest {
    id!: number;
    stepTesterUserId?: number | undefined;

    constructor(data?: IUpdateLevel4TestPlanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stepTesterUserId = _data["stepTesterUserId"];
        }
    }

    static fromJS(data: any): UpdateLevel4TestPlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLevel4TestPlanRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stepTesterUserId"] = this.stepTesterUserId;
        return data;
    }
}

export interface IUpdateLevel4TestPlanRequest {
    id: number;
    stepTesterUserId?: number | undefined;
}

export class UpdateMeetingCommentRequest implements IUpdateMeetingCommentRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    meetingId!: number;
    comment!: string;
    meetingTopicId!: number;
    meetingTopicType!: MeetingTopicTypeEnum;
    id!: number;

    constructor(data?: IUpdateMeetingCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.meetingId = _data["meetingId"];
            this.comment = _data["comment"];
            this.meetingTopicId = _data["meetingTopicId"];
            this.meetingTopicType = _data["meetingTopicType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateMeetingCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeetingCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["meetingId"] = this.meetingId;
        data["comment"] = this.comment;
        data["meetingTopicId"] = this.meetingTopicId;
        data["meetingTopicType"] = this.meetingTopicType;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateMeetingCommentRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    meetingId: number;
    comment: string;
    meetingTopicId: number;
    meetingTopicType: MeetingTopicTypeEnum;
    id: number;
}

export class UpdateMeetingGeneralConfigRequest implements IUpdateMeetingGeneralConfigRequest {
    notifyWhenReleased!: boolean;
    enableEmailNotifications!: boolean;
    id!: number;

    constructor(data?: IUpdateMeetingGeneralConfigRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notifyWhenReleased = _data["notifyWhenReleased"];
            this.enableEmailNotifications = _data["enableEmailNotifications"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateMeetingGeneralConfigRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeetingGeneralConfigRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notifyWhenReleased"] = this.notifyWhenReleased;
        data["enableEmailNotifications"] = this.enableEmailNotifications;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateMeetingGeneralConfigRequest {
    notifyWhenReleased: boolean;
    enableEmailNotifications: boolean;
    id: number;
}

export class UpdateMeetingRequest implements IUpdateMeetingRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    subject!: string;
    location?: string | undefined;
    duration?: number | undefined;
    starts!: Date;
    ends!: Date;
    agenda!: string;
    additionallParticipants?: string | undefined;
    isPrivate!: boolean;
    meetingTypeId?: number | undefined;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    participantUserIds?: number[] | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    topicsDelta?: InsertMeetingTopicRequestUpdateMeetingTopicRequestDeleteMeetingTopicRequestDeltaModel;
    id!: number;

    constructor(data?: IUpdateMeetingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.subject = _data["subject"];
            this.location = _data["location"];
            this.duration = _data["duration"];
            this.starts = _data["starts"] ? new Date(_data["starts"].toString()) : undefined as any;
            this.ends = _data["ends"] ? new Date(_data["ends"].toString()) : undefined as any;
            this.agenda = _data["agenda"];
            this.additionallParticipants = _data["additionallParticipants"];
            this.isPrivate = _data["isPrivate"];
            this.meetingTypeId = _data["meetingTypeId"];
            this.projectTeamId = _data["projectTeamId"];
            this.projectOrganizationId = _data["projectOrganizationId"];
            if (Array.isArray(_data["participantUserIds"])) {
                this.participantUserIds = [] as any;
                for (let item of _data["participantUserIds"])
                    this.participantUserIds!.push(item);
            }
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            this.topicsDelta = _data["topicsDelta"] ? InsertMeetingTopicRequestUpdateMeetingTopicRequestDeleteMeetingTopicRequestDeltaModel.fromJS(_data["topicsDelta"]) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateMeetingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeetingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["subject"] = this.subject;
        data["location"] = this.location;
        data["duration"] = this.duration;
        data["starts"] = this.starts ? this.starts.toISOString() : undefined as any;
        data["ends"] = this.ends ? this.ends.toISOString() : undefined as any;
        data["agenda"] = this.agenda;
        data["additionallParticipants"] = this.additionallParticipants;
        data["isPrivate"] = this.isPrivate;
        data["meetingTypeId"] = this.meetingTypeId;
        data["projectTeamId"] = this.projectTeamId;
        data["projectOrganizationId"] = this.projectOrganizationId;
        if (Array.isArray(this.participantUserIds)) {
            data["participantUserIds"] = [];
            for (let item of this.participantUserIds)
                data["participantUserIds"].push(item);
        }
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["topicsDelta"] = this.topicsDelta ? this.topicsDelta.toJSON() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateMeetingRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    subject: string;
    location?: string | undefined;
    duration?: number | undefined;
    starts: Date;
    ends: Date;
    agenda: string;
    additionallParticipants?: string | undefined;
    isPrivate: boolean;
    meetingTypeId?: number | undefined;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    participantUserIds?: number[] | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    topicsDelta?: InsertMeetingTopicRequestUpdateMeetingTopicRequestDeleteMeetingTopicRequestDeltaModel;
    id: number;
}

export class UpdateMeetingTopicRequest implements IUpdateMeetingTopicRequest {
    description!: string;
    type!: MeetingTopicTypeEnum;
    order!: number;
    userId?: number | undefined;
    due?: Date | undefined;
    statusId?: number | undefined;
    id!: number;
    initialType!: MeetingTopicTypeEnum;

    constructor(data?: IUpdateMeetingTopicRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.type = _data["type"];
            this.order = _data["order"];
            this.userId = _data["userId"];
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.id = _data["id"];
            this.initialType = _data["initialType"];
        }
    }

    static fromJS(data: any): UpdateMeetingTopicRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeetingTopicRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["type"] = this.type;
        data["order"] = this.order;
        data["userId"] = this.userId;
        data["due"] = this.due ? formatDate(this.due) : undefined as any;
        data["statusId"] = this.statusId;
        data["id"] = this.id;
        data["initialType"] = this.initialType;
        return data;
    }
}

export interface IUpdateMeetingTopicRequest {
    description: string;
    type: MeetingTopicTypeEnum;
    order: number;
    userId?: number | undefined;
    due?: Date | undefined;
    statusId?: number | undefined;
    id: number;
    initialType: MeetingTopicTypeEnum;
}

export class UpdateNonProjectCategoryRequest implements IUpdateNonProjectCategoryRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    isActive!: boolean;
    billable!: boolean;

    constructor(data?: IUpdateNonProjectCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.billable = _data["billable"];
        }
    }

    static fromJS(data: any): UpdateNonProjectCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNonProjectCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["billable"] = this.billable;
        return data;
    }
}

export interface IUpdateNonProjectCategoryRequest {
    name: string;
    description?: string | undefined;
    id: number;
    isActive: boolean;
    billable: boolean;
}

export class UpdateOrderRequest implements IUpdateOrderRequest {
    id!: number;
    order!: number;

    constructor(data?: IUpdateOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UpdateOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        return data;
    }
}

export interface IUpdateOrderRequest {
    id: number;
    order: number;
}

export class UpdateOrganizationalUnitManagerRequest implements IUpdateOrganizationalUnitManagerRequest {
    userId!: number;
    organizationalUnitId!: number;
    validUntil!: Date;
    isResourceManager!: boolean;
    id!: number;

    constructor(data?: IUpdateOrganizationalUnitManagerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.organizationalUnitId = _data["organizationalUnitId"];
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : undefined as any;
            this.isResourceManager = _data["isResourceManager"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateOrganizationalUnitManagerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationalUnitManagerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["organizationalUnitId"] = this.organizationalUnitId;
        data["validUntil"] = this.validUntil ? formatDate(this.validUntil) : undefined as any;
        data["isResourceManager"] = this.isResourceManager;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateOrganizationalUnitManagerRequest {
    userId: number;
    organizationalUnitId: number;
    validUntil: Date;
    isResourceManager: boolean;
    id: number;
}

export class UpdateOrganizationalUnitRequest implements IUpdateOrganizationalUnitRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    order!: number;

    constructor(data?: IUpdateOrganizationalUnitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UpdateOrganizationalUnitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationalUnitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["order"] = this.order;
        return data;
    }
}

export interface IUpdateOrganizationalUnitRequest {
    name: string;
    description?: string | undefined;
    id: number;
    order: number;
}

export class UpdateProjectAccomplishmentRequest implements IUpdateProjectAccomplishmentRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    isActive!: boolean;
    plannedDate?: Date | undefined;
    status!: ReportItemStatusEnum;

    constructor(data?: IUpdateProjectAccomplishmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateProjectAccomplishmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectAccomplishmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["plannedDate"] = this.plannedDate ? formatDate(this.plannedDate) : undefined as any;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateProjectAccomplishmentRequest {
    name: string;
    description?: string | undefined;
    id: number;
    isActive: boolean;
    plannedDate?: Date | undefined;
    status: ReportItemStatusEnum;
}

export class UpdateProjectActionRequest implements IUpdateProjectActionRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    isActive!: boolean;
    reportId!: number;
    status!: ReportItemStatusEnum;

    constructor(data?: IUpdateProjectActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.reportId = _data["reportId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateProjectActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["reportId"] = this.reportId;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateProjectActionRequest {
    name: string;
    description?: string | undefined;
    id: number;
    isActive: boolean;
    reportId: number;
    status: ReportItemStatusEnum;
}

export class UpdateProjectBusinessRequest implements IUpdateProjectBusinessRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    isActive!: boolean;
    value?: number | undefined;

    constructor(data?: IUpdateProjectBusinessRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateProjectBusinessRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectBusinessRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateProjectBusinessRequest {
    name: string;
    description?: string | undefined;
    id: number;
    isActive: boolean;
    value?: number | undefined;
}

export class UpdateProjectChangeRequestRequest implements IUpdateProjectChangeRequestRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    initiatedBy?: string | undefined;
    approvedByUserId?: number | undefined;
    requestedOn?: Date | undefined;
    priority!: ChangeRequestPriorityEnum;
    completitionOn?: Date | undefined;
    statusId!: number;
    effortInHours?: number | undefined;
    totalCost?: number | undefined;
    estimatedEffortInHours?: number | undefined;
    estimatedTotalCost?: number | undefined;
    goLiveCritical!: boolean;

    constructor(data?: IUpdateProjectChangeRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.initiatedBy = _data["initiatedBy"];
            this.approvedByUserId = _data["approvedByUserId"];
            this.requestedOn = _data["requestedOn"] ? new Date(_data["requestedOn"].toString()) : undefined as any;
            this.priority = _data["priority"];
            this.completitionOn = _data["completitionOn"] ? new Date(_data["completitionOn"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.effortInHours = _data["effortInHours"];
            this.totalCost = _data["totalCost"];
            this.estimatedEffortInHours = _data["estimatedEffortInHours"];
            this.estimatedTotalCost = _data["estimatedTotalCost"];
            this.goLiveCritical = _data["goLiveCritical"];
        }
    }

    static fromJS(data: any): UpdateProjectChangeRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectChangeRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["initiatedBy"] = this.initiatedBy;
        data["approvedByUserId"] = this.approvedByUserId;
        data["requestedOn"] = this.requestedOn ? formatDate(this.requestedOn) : undefined as any;
        data["priority"] = this.priority;
        data["completitionOn"] = this.completitionOn ? formatDate(this.completitionOn) : undefined as any;
        data["statusId"] = this.statusId;
        data["effortInHours"] = this.effortInHours;
        data["totalCost"] = this.totalCost;
        data["estimatedEffortInHours"] = this.estimatedEffortInHours;
        data["estimatedTotalCost"] = this.estimatedTotalCost;
        data["goLiveCritical"] = this.goLiveCritical;
        return data;
    }
}

export interface IUpdateProjectChangeRequestRequest {
    name: string;
    description?: string | undefined;
    id: number;
    initiatedBy?: string | undefined;
    approvedByUserId?: number | undefined;
    requestedOn?: Date | undefined;
    priority: ChangeRequestPriorityEnum;
    completitionOn?: Date | undefined;
    statusId: number;
    effortInHours?: number | undefined;
    totalCost?: number | undefined;
    estimatedEffortInHours?: number | undefined;
    estimatedTotalCost?: number | undefined;
    goLiveCritical: boolean;
}

export class UpdateProjectDataRequest implements IUpdateProjectDataRequest {
    projectId!: number;
    name!: string;
    description?: string | undefined;
    projectStatusId!: number;
    projectCategoryId?: number | undefined;
    projectTypeId?: number | undefined;
    organizationalUnitId?: number | undefined;
    from!: Date;
    to!: Date;
    partnerId?: number | undefined;
    activeModules?: ActiveModule[] | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;

    constructor(data?: IUpdateProjectDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.projectStatusId = _data["projectStatusId"];
            this.projectCategoryId = _data["projectCategoryId"];
            this.projectTypeId = _data["projectTypeId"];
            this.organizationalUnitId = _data["organizationalUnitId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.partnerId = _data["partnerId"];
            if (Array.isArray(_data["activeModules"])) {
                this.activeModules = [] as any;
                for (let item of _data["activeModules"])
                    this.activeModules!.push(ActiveModule.fromJS(item));
            }
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateProjectDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["projectStatusId"] = this.projectStatusId;
        data["projectCategoryId"] = this.projectCategoryId;
        data["projectTypeId"] = this.projectTypeId;
        data["organizationalUnitId"] = this.organizationalUnitId;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["partnerId"] = this.partnerId;
        if (Array.isArray(this.activeModules)) {
            data["activeModules"] = [];
            for (let item of this.activeModules)
                data["activeModules"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateProjectDataRequest {
    projectId: number;
    name: string;
    description?: string | undefined;
    projectStatusId: number;
    projectCategoryId?: number | undefined;
    projectTypeId?: number | undefined;
    organizationalUnitId?: number | undefined;
    from: Date;
    to: Date;
    partnerId?: number | undefined;
    activeModules?: ActiveModule[] | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
}

export class UpdateProjectDeliverableRequest implements IUpdateProjectDeliverableRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    wbs!: string;
    complete?: number | undefined;
    finish?: Date | undefined;
    achievedDate?: Date | undefined;

    constructor(data?: IUpdateProjectDeliverableRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.wbs = _data["wbs"];
            this.complete = _data["complete"];
            this.finish = _data["finish"] ? new Date(_data["finish"].toString()) : undefined as any;
            this.achievedDate = _data["achievedDate"] ? new Date(_data["achievedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateProjectDeliverableRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectDeliverableRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["wbs"] = this.wbs;
        data["complete"] = this.complete;
        data["finish"] = this.finish ? formatDate(this.finish) : undefined as any;
        data["achievedDate"] = this.achievedDate ? formatDate(this.achievedDate) : undefined as any;
        return data;
    }
}

export interface IUpdateProjectDeliverableRequest {
    name: string;
    description?: string | undefined;
    id: number;
    wbs: string;
    complete?: number | undefined;
    finish?: Date | undefined;
    achievedDate?: Date | undefined;
}

export class UpdateProjectFinanceRequest implements IUpdateProjectFinanceRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    invoiceType!: InvoiceTypeEnum;
    invoiceNumber!: string;
    partnerId!: number;
    issueDate!: Date;
    due!: Date;
    amount!: number;
    taxAmount!: number;
    statusId!: number;

    constructor(data?: IUpdateProjectFinanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.invoiceType = _data["invoiceType"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.partnerId = _data["partnerId"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            this.amount = _data["amount"];
            this.taxAmount = _data["taxAmount"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): UpdateProjectFinanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectFinanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["invoiceType"] = this.invoiceType;
        data["invoiceNumber"] = this.invoiceNumber;
        data["partnerId"] = this.partnerId;
        data["issueDate"] = this.issueDate ? formatDate(this.issueDate) : undefined as any;
        data["due"] = this.due ? formatDate(this.due) : undefined as any;
        data["amount"] = this.amount;
        data["taxAmount"] = this.taxAmount;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface IUpdateProjectFinanceRequest {
    name: string;
    description?: string | undefined;
    id: number;
    invoiceType: InvoiceTypeEnum;
    invoiceNumber: string;
    partnerId: number;
    issueDate: Date;
    due: Date;
    amount: number;
    taxAmount: number;
    statusId: number;
}

export class UpdateProjectInformationRequest implements IUpdateProjectInformationRequest {
    information?: string | undefined;

    constructor(data?: IUpdateProjectInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.information = _data["information"];
        }
    }

    static fromJS(data: any): UpdateProjectInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["information"] = this.information;
        return data;
    }
}

export interface IUpdateProjectInformationRequest {
    information?: string | undefined;
}

export class UpdateProjectIssueRequest implements IUpdateProjectIssueRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    isActive!: boolean;
    impact?: string | undefined;
    solution?: string | undefined;
    resolution?: string | undefined;

    constructor(data?: IUpdateProjectIssueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.impact = _data["impact"];
            this.solution = _data["solution"];
            this.resolution = _data["resolution"];
        }
    }

    static fromJS(data: any): UpdateProjectIssueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectIssueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["impact"] = this.impact;
        data["solution"] = this.solution;
        data["resolution"] = this.resolution;
        return data;
    }
}

export interface IUpdateProjectIssueRequest {
    name: string;
    description?: string | undefined;
    id: number;
    isActive: boolean;
    impact?: string | undefined;
    solution?: string | undefined;
    resolution?: string | undefined;
}

export class UpdateProjectMilestoneRequest implements IUpdateProjectMilestoneRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    wbs!: string;
    duration?: number | undefined;
    complete?: number | undefined;
    start?: Date | undefined;
    finish?: Date | undefined;
    achievedDate?: Date | undefined;
    milestoneDeviation?: string | undefined;

    constructor(data?: IUpdateProjectMilestoneRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.wbs = _data["wbs"];
            this.duration = _data["duration"];
            this.complete = _data["complete"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.finish = _data["finish"] ? new Date(_data["finish"].toString()) : undefined as any;
            this.achievedDate = _data["achievedDate"] ? new Date(_data["achievedDate"].toString()) : undefined as any;
            this.milestoneDeviation = _data["milestoneDeviation"];
        }
    }

    static fromJS(data: any): UpdateProjectMilestoneRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectMilestoneRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["wbs"] = this.wbs;
        data["duration"] = this.duration;
        data["complete"] = this.complete;
        data["start"] = this.start ? formatDate(this.start) : undefined as any;
        data["finish"] = this.finish ? formatDate(this.finish) : undefined as any;
        data["achievedDate"] = this.achievedDate ? formatDate(this.achievedDate) : undefined as any;
        data["milestoneDeviation"] = this.milestoneDeviation;
        return data;
    }
}

export interface IUpdateProjectMilestoneRequest {
    name: string;
    description?: string | undefined;
    id: number;
    wbs: string;
    duration?: number | undefined;
    complete?: number | undefined;
    start?: Date | undefined;
    finish?: Date | undefined;
    achievedDate?: Date | undefined;
    milestoneDeviation?: string | undefined;
}

export class UpdateProjectQualityRequest implements IUpdateProjectQualityRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    wbs!: string;
    finish?: Date | undefined;
    achievedData?: Date | undefined;
    actions?: string | undefined;
    status!: ReportItemStatusEnum;

    constructor(data?: IUpdateProjectQualityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.wbs = _data["wbs"];
            this.finish = _data["finish"] ? new Date(_data["finish"].toString()) : undefined as any;
            this.achievedData = _data["achievedData"] ? new Date(_data["achievedData"].toString()) : undefined as any;
            this.actions = _data["actions"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateProjectQualityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectQualityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["wbs"] = this.wbs;
        data["finish"] = this.finish ? formatDate(this.finish) : undefined as any;
        data["achievedData"] = this.achievedData ? formatDate(this.achievedData) : undefined as any;
        data["actions"] = this.actions;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateProjectQualityRequest {
    name: string;
    description?: string | undefined;
    id: number;
    wbs: string;
    finish?: Date | undefined;
    achievedData?: Date | undefined;
    actions?: string | undefined;
    status: ReportItemStatusEnum;
}

export class UpdateProjectReportRequest implements IUpdateProjectReportRequest {
    id!: number;
    projectId!: number;
    from!: Date;
    to!: Date;
    statusId!: number;
    relationshipStatus?: string | undefined;
    staffing?: string | undefined;
    areaStatuses!: ProjectReportAreaRequest[];

    constructor(data?: IUpdateProjectReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.areaStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.relationshipStatus = _data["relationshipStatus"];
            this.staffing = _data["staffing"];
            if (Array.isArray(_data["areaStatuses"])) {
                this.areaStatuses = [] as any;
                for (let item of _data["areaStatuses"])
                    this.areaStatuses!.push(ProjectReportAreaRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateProjectReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["statusId"] = this.statusId;
        data["relationshipStatus"] = this.relationshipStatus;
        data["staffing"] = this.staffing;
        if (Array.isArray(this.areaStatuses)) {
            data["areaStatuses"] = [];
            for (let item of this.areaStatuses)
                data["areaStatuses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateProjectReportRequest {
    id: number;
    projectId: number;
    from: Date;
    to: Date;
    statusId: number;
    relationshipStatus?: string | undefined;
    staffing?: string | undefined;
    areaStatuses: ProjectReportAreaRequest[];
}

export class UpdateProjectRequest implements IUpdateProjectRequest {
    id!: number;
    name!: string;
    pmId?: number | undefined;
    description?: string | undefined;
    from!: Date;
    to!: Date;

    constructor(data?: IUpdateProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pmId = _data["pmId"];
            this.description = _data["description"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pmId"] = this.pmId;
        data["description"] = this.description;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        return data;
    }
}

export interface IUpdateProjectRequest {
    id: number;
    name: string;
    pmId?: number | undefined;
    description?: string | undefined;
    from: Date;
    to: Date;
}

export class UpdateProjectRiskRequest implements IUpdateProjectRiskRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    consequneces?: string | undefined;
    effects?: string | undefined;
    grossImpact?: number | undefined;
    probability?: number | undefined;
    mitigation!: string;
    mitigationType!: MitigationTypeEnum;
    grossImpactAfterMitigation?: number | undefined;
    probabilityAfterMitigation?: number | undefined;
    responsibleUserId?: number | undefined;
    statusId!: number;
    dueDate?: Date | undefined;
    costOfMitigation?: number | undefined;

    constructor(data?: IUpdateProjectRiskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.consequneces = _data["consequneces"];
            this.effects = _data["effects"];
            this.grossImpact = _data["grossImpact"];
            this.probability = _data["probability"];
            this.mitigation = _data["mitigation"];
            this.mitigationType = _data["mitigationType"];
            this.grossImpactAfterMitigation = _data["grossImpactAfterMitigation"];
            this.probabilityAfterMitigation = _data["probabilityAfterMitigation"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.statusId = _data["statusId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.costOfMitigation = _data["costOfMitigation"];
        }
    }

    static fromJS(data: any): UpdateProjectRiskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectRiskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["consequneces"] = this.consequneces;
        data["effects"] = this.effects;
        data["grossImpact"] = this.grossImpact;
        data["probability"] = this.probability;
        data["mitigation"] = this.mitigation;
        data["mitigationType"] = this.mitigationType;
        data["grossImpactAfterMitigation"] = this.grossImpactAfterMitigation;
        data["probabilityAfterMitigation"] = this.probabilityAfterMitigation;
        data["responsibleUserId"] = this.responsibleUserId;
        data["statusId"] = this.statusId;
        data["dueDate"] = this.dueDate ? formatDate(this.dueDate) : undefined as any;
        data["costOfMitigation"] = this.costOfMitigation;
        return data;
    }
}

export interface IUpdateProjectRiskRequest {
    name: string;
    description?: string | undefined;
    id: number;
    consequneces?: string | undefined;
    effects?: string | undefined;
    grossImpact?: number | undefined;
    probability?: number | undefined;
    mitigation: string;
    mitigationType: MitigationTypeEnum;
    grossImpactAfterMitigation?: number | undefined;
    probabilityAfterMitigation?: number | undefined;
    responsibleUserId?: number | undefined;
    statusId: number;
    dueDate?: Date | undefined;
    costOfMitigation?: number | undefined;
}

export class UpdateProjectSLARequest implements IUpdateProjectSLARequest {
    isActive!: boolean;
    supportOrganizationId?: number | undefined;
    timeMeasure!: TimeMeasureEnum;
    closingStatus!: TicketStatusEnum;
    resolutionTimeCalculationStatus!: TicketStatusEnum;
    resolutionTimeBasedOn!: ResolutionTimeBasedOnEnum;
    excludeOnHoldTime!: boolean;
    workWeekFrom!: WeekDayEnum;
    workWeekTo!: WeekDayEnum;
    workTimeFrom!: number;
    workTimeTo!: number;
    times?: UpdateSLAResponseTimeRequest[] | undefined;

    constructor(data?: IUpdateProjectSLARequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.supportOrganizationId = _data["supportOrganizationId"];
            this.timeMeasure = _data["timeMeasure"];
            this.closingStatus = _data["closingStatus"];
            this.resolutionTimeCalculationStatus = _data["resolutionTimeCalculationStatus"];
            this.resolutionTimeBasedOn = _data["resolutionTimeBasedOn"];
            this.excludeOnHoldTime = _data["excludeOnHoldTime"];
            this.workWeekFrom = _data["workWeekFrom"];
            this.workWeekTo = _data["workWeekTo"];
            this.workTimeFrom = _data["workTimeFrom"];
            this.workTimeTo = _data["workTimeTo"];
            if (Array.isArray(_data["times"])) {
                this.times = [] as any;
                for (let item of _data["times"])
                    this.times!.push(UpdateSLAResponseTimeRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateProjectSLARequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectSLARequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["supportOrganizationId"] = this.supportOrganizationId;
        data["timeMeasure"] = this.timeMeasure;
        data["closingStatus"] = this.closingStatus;
        data["resolutionTimeCalculationStatus"] = this.resolutionTimeCalculationStatus;
        data["resolutionTimeBasedOn"] = this.resolutionTimeBasedOn;
        data["excludeOnHoldTime"] = this.excludeOnHoldTime;
        data["workWeekFrom"] = this.workWeekFrom;
        data["workWeekTo"] = this.workWeekTo;
        data["workTimeFrom"] = this.workTimeFrom;
        data["workTimeTo"] = this.workTimeTo;
        if (Array.isArray(this.times)) {
            data["times"] = [];
            for (let item of this.times)
                data["times"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateProjectSLARequest {
    isActive: boolean;
    supportOrganizationId?: number | undefined;
    timeMeasure: TimeMeasureEnum;
    closingStatus: TicketStatusEnum;
    resolutionTimeCalculationStatus: TicketStatusEnum;
    resolutionTimeBasedOn: ResolutionTimeBasedOnEnum;
    excludeOnHoldTime: boolean;
    workWeekFrom: WeekDayEnum;
    workWeekTo: WeekDayEnum;
    workTimeFrom: number;
    workTimeTo: number;
    times?: UpdateSLAResponseTimeRequest[] | undefined;
}

export class UpdateProjectSubcontractorRequest implements IUpdateProjectSubcontractorRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    isActive!: boolean;
    deliverable!: string;
    status!: ReportItemStatusEnum;
    issue!: string;
    solution?: string | undefined;
    resolution?: string | undefined;
    achievedDate?: Date | undefined;

    constructor(data?: IUpdateProjectSubcontractorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.deliverable = _data["deliverable"];
            this.status = _data["status"];
            this.issue = _data["issue"];
            this.solution = _data["solution"];
            this.resolution = _data["resolution"];
            this.achievedDate = _data["achievedDate"] ? new Date(_data["achievedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateProjectSubcontractorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectSubcontractorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["deliverable"] = this.deliverable;
        data["status"] = this.status;
        data["issue"] = this.issue;
        data["solution"] = this.solution;
        data["resolution"] = this.resolution;
        data["achievedDate"] = this.achievedDate ? formatDate(this.achievedDate) : undefined as any;
        return data;
    }
}

export interface IUpdateProjectSubcontractorRequest {
    name: string;
    description?: string | undefined;
    id: number;
    isActive: boolean;
    deliverable: string;
    status: ReportItemStatusEnum;
    issue: string;
    solution?: string | undefined;
    resolution?: string | undefined;
    achievedDate?: Date | undefined;
}

export class UpdateProjectTeamMemberRequest implements IUpdateProjectTeamMemberRequest {
    id!: number;
    userId!: number;
    projectRoleId!: number;
    projectTeamId!: number;
    statusId!: number;
    validUntil!: Date;

    constructor(data?: IUpdateProjectTeamMemberRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.projectRoleId = _data["projectRoleId"];
            this.projectTeamId = _data["projectTeamId"];
            this.statusId = _data["statusId"];
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateProjectTeamMemberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectTeamMemberRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["projectRoleId"] = this.projectRoleId;
        data["projectTeamId"] = this.projectTeamId;
        data["statusId"] = this.statusId;
        data["validUntil"] = this.validUntil ? formatDate(this.validUntil) : undefined as any;
        return data;
    }
}

export interface IUpdateProjectTeamMemberRequest {
    id: number;
    userId: number;
    projectRoleId: number;
    projectTeamId: number;
    statusId: number;
    validUntil: Date;
}

export class UpdateProjectTeamMemberValidityPeriodRequest implements IUpdateProjectTeamMemberValidityPeriodRequest {
    teamMemberId!: number;
    from!: Date;
    to!: Date;
    salesRate!: number;
    costRate!: number;
    id!: number;

    constructor(data?: IUpdateProjectTeamMemberValidityPeriodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamMemberId = _data["teamMemberId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.salesRate = _data["salesRate"];
            this.costRate = _data["costRate"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateProjectTeamMemberValidityPeriodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectTeamMemberValidityPeriodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamMemberId"] = this.teamMemberId;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["salesRate"] = this.salesRate;
        data["costRate"] = this.costRate;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateProjectTeamMemberValidityPeriodRequest {
    teamMemberId: number;
    from: Date;
    to: Date;
    salesRate: number;
    costRate: number;
    id: number;
}

export class UpdateProjectTeamRequest implements IUpdateProjectTeamRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    isActive!: boolean;
    projectId!: number;
    salesRate?: number | undefined;
    costRate?: number | undefined;

    constructor(data?: IUpdateProjectTeamRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.projectId = _data["projectId"];
            this.salesRate = _data["salesRate"];
            this.costRate = _data["costRate"];
        }
    }

    static fromJS(data: any): UpdateProjectTeamRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectTeamRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["projectId"] = this.projectId;
        data["salesRate"] = this.salesRate;
        data["costRate"] = this.costRate;
        return data;
    }
}

export interface IUpdateProjectTeamRequest {
    name: string;
    description?: string | undefined;
    id: number;
    isActive: boolean;
    projectId: number;
    salesRate?: number | undefined;
    costRate?: number | undefined;
}

export class UpdateReminderRequest implements IUpdateReminderRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    subject!: string;
    startDate!: Date;
    endDate!: Date;
    isRepeat!: boolean;
    repeatInterval!: RepeatIntervalEnum;
    repeatOnMonday!: boolean;
    repeatOnTuesday!: boolean;
    repeatOnWednesday!: boolean;
    repeatOnThursday!: boolean;
    repeatOnFriday!: boolean;
    repeatOnSaturday!: boolean;
    repeatOnSunday!: boolean;
    isPrivate!: boolean;
    sendEmail!: boolean;
    projectTeamId?: number | undefined;
    recipientUserIds?: number[] | undefined;
    id!: number;

    constructor(data?: IUpdateReminderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.subject = _data["subject"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.isRepeat = _data["isRepeat"];
            this.repeatInterval = _data["repeatInterval"];
            this.repeatOnMonday = _data["repeatOnMonday"];
            this.repeatOnTuesday = _data["repeatOnTuesday"];
            this.repeatOnWednesday = _data["repeatOnWednesday"];
            this.repeatOnThursday = _data["repeatOnThursday"];
            this.repeatOnFriday = _data["repeatOnFriday"];
            this.repeatOnSaturday = _data["repeatOnSaturday"];
            this.repeatOnSunday = _data["repeatOnSunday"];
            this.isPrivate = _data["isPrivate"];
            this.sendEmail = _data["sendEmail"];
            this.projectTeamId = _data["projectTeamId"];
            if (Array.isArray(_data["recipientUserIds"])) {
                this.recipientUserIds = [] as any;
                for (let item of _data["recipientUserIds"])
                    this.recipientUserIds!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateReminderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReminderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["subject"] = this.subject;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["isRepeat"] = this.isRepeat;
        data["repeatInterval"] = this.repeatInterval;
        data["repeatOnMonday"] = this.repeatOnMonday;
        data["repeatOnTuesday"] = this.repeatOnTuesday;
        data["repeatOnWednesday"] = this.repeatOnWednesday;
        data["repeatOnThursday"] = this.repeatOnThursday;
        data["repeatOnFriday"] = this.repeatOnFriday;
        data["repeatOnSaturday"] = this.repeatOnSaturday;
        data["repeatOnSunday"] = this.repeatOnSunday;
        data["isPrivate"] = this.isPrivate;
        data["sendEmail"] = this.sendEmail;
        data["projectTeamId"] = this.projectTeamId;
        if (Array.isArray(this.recipientUserIds)) {
            data["recipientUserIds"] = [];
            for (let item of this.recipientUserIds)
                data["recipientUserIds"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateReminderRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    subject: string;
    startDate: Date;
    endDate: Date;
    isRepeat: boolean;
    repeatInterval: RepeatIntervalEnum;
    repeatOnMonday: boolean;
    repeatOnTuesday: boolean;
    repeatOnWednesday: boolean;
    repeatOnThursday: boolean;
    repeatOnFriday: boolean;
    repeatOnSaturday: boolean;
    repeatOnSunday: boolean;
    isPrivate: boolean;
    sendEmail: boolean;
    projectTeamId?: number | undefined;
    recipientUserIds?: number[] | undefined;
    id: number;
}

export class UpdateRiskRequest implements IUpdateRiskRequest {
    name!: string;
    typeId?: number | undefined;
    consequneces?: string | undefined;
    effects?: string | undefined;
    responsibleUserId!: number;
    statusId!: number;
    dueDate!: Date;
    comment?: string | undefined;
    grossImpact?: number | undefined;
    probability?: number | undefined;
    mitigation?: string | undefined;
    mitigationType!: MitigationTypeEnum;
    mitigationCost?: number | undefined;
    grossImpactAfterMitigation?: number | undefined;
    probabilityAfterMitigation?: number | undefined;
    probabilityDescriptive?: RiskProbabilityEnum;
    impactDescriptive?: RiskImpactEnum;
    id!: number;

    constructor(data?: IUpdateRiskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.typeId = _data["typeId"];
            this.consequneces = _data["consequneces"];
            this.effects = _data["effects"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.statusId = _data["statusId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.comment = _data["comment"];
            this.grossImpact = _data["grossImpact"];
            this.probability = _data["probability"];
            this.mitigation = _data["mitigation"];
            this.mitigationType = _data["mitigationType"];
            this.mitigationCost = _data["mitigationCost"];
            this.grossImpactAfterMitigation = _data["grossImpactAfterMitigation"];
            this.probabilityAfterMitigation = _data["probabilityAfterMitigation"];
            this.probabilityDescriptive = _data["probabilityDescriptive"];
            this.impactDescriptive = _data["impactDescriptive"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateRiskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRiskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["typeId"] = this.typeId;
        data["consequneces"] = this.consequneces;
        data["effects"] = this.effects;
        data["responsibleUserId"] = this.responsibleUserId;
        data["statusId"] = this.statusId;
        data["dueDate"] = this.dueDate ? formatDate(this.dueDate) : undefined as any;
        data["comment"] = this.comment;
        data["grossImpact"] = this.grossImpact;
        data["probability"] = this.probability;
        data["mitigation"] = this.mitigation;
        data["mitigationType"] = this.mitigationType;
        data["mitigationCost"] = this.mitigationCost;
        data["grossImpactAfterMitigation"] = this.grossImpactAfterMitigation;
        data["probabilityAfterMitigation"] = this.probabilityAfterMitigation;
        data["probabilityDescriptive"] = this.probabilityDescriptive;
        data["impactDescriptive"] = this.impactDescriptive;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateRiskRequest {
    name: string;
    typeId?: number | undefined;
    consequneces?: string | undefined;
    effects?: string | undefined;
    responsibleUserId: number;
    statusId: number;
    dueDate: Date;
    comment?: string | undefined;
    grossImpact?: number | undefined;
    probability?: number | undefined;
    mitigation?: string | undefined;
    mitigationType: MitigationTypeEnum;
    mitigationCost?: number | undefined;
    grossImpactAfterMitigation?: number | undefined;
    probabilityAfterMitigation?: number | undefined;
    probabilityDescriptive?: RiskProbabilityEnum;
    impactDescriptive?: RiskImpactEnum;
    id: number;
}

export class UpdateScheduleRequest implements IUpdateScheduleRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    wbs!: string;
    start!: Date;
    finish!: Date;
    parentId?: number | undefined;
    percentOfCompletion?: number | undefined;
    achievedDate?: Date | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    customText3?: string | undefined;
    customText4?: string | undefined;
    customText5?: string | undefined;
    customText6?: string | undefined;
    customText7?: string | undefined;
    customText8?: string | undefined;
    customText9?: string | undefined;
    customText10?: string | undefined;
    projectRoleResponsibleId?: number | undefined;
    insertedResponsibleUserIds?: number[] | undefined;
    addAsTaskPerResponsibleUser!: boolean;
    projectRoleAccountableId?: number | undefined;
    insertedAccountableUserIds?: number[] | undefined;
    projectRoleConsultedId?: number | undefined;
    insertedConsultedUserIds?: number[] | undefined;
    projectRoleInformedId?: number | undefined;
    insertedInformedUserIds?: number[] | undefined;
    markAsMilestone!: boolean;
    markAsDeliverable!: boolean;
    markTaskForQualityGate!: boolean;
    removedResponsibleUserIds?: number[] | undefined;
    removedAccountableUserIds?: number[] | undefined;
    removedConsultedUserIds?: number[] | undefined;
    removedInformedUserIds?: number[] | undefined;

    constructor(data?: IUpdateScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.wbs = _data["wbs"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.finish = _data["finish"] ? new Date(_data["finish"].toString()) : undefined as any;
            this.parentId = _data["parentId"];
            this.percentOfCompletion = _data["percentOfCompletion"];
            this.achievedDate = _data["achievedDate"] ? new Date(_data["achievedDate"].toString()) : undefined as any;
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.customText3 = _data["customText3"];
            this.customText4 = _data["customText4"];
            this.customText5 = _data["customText5"];
            this.customText6 = _data["customText6"];
            this.customText7 = _data["customText7"];
            this.customText8 = _data["customText8"];
            this.customText9 = _data["customText9"];
            this.customText10 = _data["customText10"];
            this.projectRoleResponsibleId = _data["projectRoleResponsibleId"];
            if (Array.isArray(_data["insertedResponsibleUserIds"])) {
                this.insertedResponsibleUserIds = [] as any;
                for (let item of _data["insertedResponsibleUserIds"])
                    this.insertedResponsibleUserIds!.push(item);
            }
            this.addAsTaskPerResponsibleUser = _data["addAsTaskPerResponsibleUser"];
            this.projectRoleAccountableId = _data["projectRoleAccountableId"];
            if (Array.isArray(_data["insertedAccountableUserIds"])) {
                this.insertedAccountableUserIds = [] as any;
                for (let item of _data["insertedAccountableUserIds"])
                    this.insertedAccountableUserIds!.push(item);
            }
            this.projectRoleConsultedId = _data["projectRoleConsultedId"];
            if (Array.isArray(_data["insertedConsultedUserIds"])) {
                this.insertedConsultedUserIds = [] as any;
                for (let item of _data["insertedConsultedUserIds"])
                    this.insertedConsultedUserIds!.push(item);
            }
            this.projectRoleInformedId = _data["projectRoleInformedId"];
            if (Array.isArray(_data["insertedInformedUserIds"])) {
                this.insertedInformedUserIds = [] as any;
                for (let item of _data["insertedInformedUserIds"])
                    this.insertedInformedUserIds!.push(item);
            }
            this.markAsMilestone = _data["markAsMilestone"];
            this.markAsDeliverable = _data["markAsDeliverable"];
            this.markTaskForQualityGate = _data["markTaskForQualityGate"];
            if (Array.isArray(_data["removedResponsibleUserIds"])) {
                this.removedResponsibleUserIds = [] as any;
                for (let item of _data["removedResponsibleUserIds"])
                    this.removedResponsibleUserIds!.push(item);
            }
            if (Array.isArray(_data["removedAccountableUserIds"])) {
                this.removedAccountableUserIds = [] as any;
                for (let item of _data["removedAccountableUserIds"])
                    this.removedAccountableUserIds!.push(item);
            }
            if (Array.isArray(_data["removedConsultedUserIds"])) {
                this.removedConsultedUserIds = [] as any;
                for (let item of _data["removedConsultedUserIds"])
                    this.removedConsultedUserIds!.push(item);
            }
            if (Array.isArray(_data["removedInformedUserIds"])) {
                this.removedInformedUserIds = [] as any;
                for (let item of _data["removedInformedUserIds"])
                    this.removedInformedUserIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateScheduleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["wbs"] = this.wbs;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["finish"] = this.finish ? this.finish.toISOString() : undefined as any;
        data["parentId"] = this.parentId;
        data["percentOfCompletion"] = this.percentOfCompletion;
        data["achievedDate"] = this.achievedDate ? this.achievedDate.toISOString() : undefined as any;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["customText3"] = this.customText3;
        data["customText4"] = this.customText4;
        data["customText5"] = this.customText5;
        data["customText6"] = this.customText6;
        data["customText7"] = this.customText7;
        data["customText8"] = this.customText8;
        data["customText9"] = this.customText9;
        data["customText10"] = this.customText10;
        data["projectRoleResponsibleId"] = this.projectRoleResponsibleId;
        if (Array.isArray(this.insertedResponsibleUserIds)) {
            data["insertedResponsibleUserIds"] = [];
            for (let item of this.insertedResponsibleUserIds)
                data["insertedResponsibleUserIds"].push(item);
        }
        data["addAsTaskPerResponsibleUser"] = this.addAsTaskPerResponsibleUser;
        data["projectRoleAccountableId"] = this.projectRoleAccountableId;
        if (Array.isArray(this.insertedAccountableUserIds)) {
            data["insertedAccountableUserIds"] = [];
            for (let item of this.insertedAccountableUserIds)
                data["insertedAccountableUserIds"].push(item);
        }
        data["projectRoleConsultedId"] = this.projectRoleConsultedId;
        if (Array.isArray(this.insertedConsultedUserIds)) {
            data["insertedConsultedUserIds"] = [];
            for (let item of this.insertedConsultedUserIds)
                data["insertedConsultedUserIds"].push(item);
        }
        data["projectRoleInformedId"] = this.projectRoleInformedId;
        if (Array.isArray(this.insertedInformedUserIds)) {
            data["insertedInformedUserIds"] = [];
            for (let item of this.insertedInformedUserIds)
                data["insertedInformedUserIds"].push(item);
        }
        data["markAsMilestone"] = this.markAsMilestone;
        data["markAsDeliverable"] = this.markAsDeliverable;
        data["markTaskForQualityGate"] = this.markTaskForQualityGate;
        if (Array.isArray(this.removedResponsibleUserIds)) {
            data["removedResponsibleUserIds"] = [];
            for (let item of this.removedResponsibleUserIds)
                data["removedResponsibleUserIds"].push(item);
        }
        if (Array.isArray(this.removedAccountableUserIds)) {
            data["removedAccountableUserIds"] = [];
            for (let item of this.removedAccountableUserIds)
                data["removedAccountableUserIds"].push(item);
        }
        if (Array.isArray(this.removedConsultedUserIds)) {
            data["removedConsultedUserIds"] = [];
            for (let item of this.removedConsultedUserIds)
                data["removedConsultedUserIds"].push(item);
        }
        if (Array.isArray(this.removedInformedUserIds)) {
            data["removedInformedUserIds"] = [];
            for (let item of this.removedInformedUserIds)
                data["removedInformedUserIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateScheduleRequest {
    name: string;
    description?: string | undefined;
    id: number;
    wbs: string;
    start: Date;
    finish: Date;
    parentId?: number | undefined;
    percentOfCompletion?: number | undefined;
    achievedDate?: Date | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    customText3?: string | undefined;
    customText4?: string | undefined;
    customText5?: string | undefined;
    customText6?: string | undefined;
    customText7?: string | undefined;
    customText8?: string | undefined;
    customText9?: string | undefined;
    customText10?: string | undefined;
    projectRoleResponsibleId?: number | undefined;
    insertedResponsibleUserIds?: number[] | undefined;
    addAsTaskPerResponsibleUser: boolean;
    projectRoleAccountableId?: number | undefined;
    insertedAccountableUserIds?: number[] | undefined;
    projectRoleConsultedId?: number | undefined;
    insertedConsultedUserIds?: number[] | undefined;
    projectRoleInformedId?: number | undefined;
    insertedInformedUserIds?: number[] | undefined;
    markAsMilestone: boolean;
    markAsDeliverable: boolean;
    markTaskForQualityGate: boolean;
    removedResponsibleUserIds?: number[] | undefined;
    removedAccountableUserIds?: number[] | undefined;
    removedConsultedUserIds?: number[] | undefined;
    removedInformedUserIds?: number[] | undefined;
}

export class UpdateScheduleResourcePlanRequest implements IUpdateScheduleResourcePlanRequest {
    userOrProjectTeamId!: number;
    numberOfHours?: number | undefined;
    workload?: number | undefined;
    percentOfCompletion?: number | undefined;
    id!: number;

    constructor(data?: IUpdateScheduleResourcePlanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userOrProjectTeamId = _data["userOrProjectTeamId"];
            this.numberOfHours = _data["numberOfHours"];
            this.workload = _data["workload"];
            this.percentOfCompletion = _data["percentOfCompletion"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateScheduleResourcePlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduleResourcePlanRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userOrProjectTeamId"] = this.userOrProjectTeamId;
        data["numberOfHours"] = this.numberOfHours;
        data["workload"] = this.workload;
        data["percentOfCompletion"] = this.percentOfCompletion;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateScheduleResourcePlanRequest {
    userOrProjectTeamId: number;
    numberOfHours?: number | undefined;
    workload?: number | undefined;
    percentOfCompletion?: number | undefined;
    id: number;
}

export class UpdateScheduleResourcePlansRequest implements IUpdateScheduleResourcePlansRequest {
    id?: number | undefined;
    resourcePlanUsersDelta?: InsertScheduleResourcePlanRequestUpdateScheduleResourcePlanRequestDeleteScheduleResourcePlanRequestDeltaModel;
    resourcePlanProjectTeamsDelta?: InsertScheduleResourcePlanRequestUpdateScheduleResourcePlanRequestDeleteScheduleResourcePlanRequestDeltaModel;

    constructor(data?: IUpdateScheduleResourcePlansRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resourcePlanUsersDelta = _data["resourcePlanUsersDelta"] ? InsertScheduleResourcePlanRequestUpdateScheduleResourcePlanRequestDeleteScheduleResourcePlanRequestDeltaModel.fromJS(_data["resourcePlanUsersDelta"]) : undefined as any;
            this.resourcePlanProjectTeamsDelta = _data["resourcePlanProjectTeamsDelta"] ? InsertScheduleResourcePlanRequestUpdateScheduleResourcePlanRequestDeleteScheduleResourcePlanRequestDeltaModel.fromJS(_data["resourcePlanProjectTeamsDelta"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateScheduleResourcePlansRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduleResourcePlansRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resourcePlanUsersDelta"] = this.resourcePlanUsersDelta ? this.resourcePlanUsersDelta.toJSON() : undefined as any;
        data["resourcePlanProjectTeamsDelta"] = this.resourcePlanProjectTeamsDelta ? this.resourcePlanProjectTeamsDelta.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateScheduleResourcePlansRequest {
    id?: number | undefined;
    resourcePlanUsersDelta?: InsertScheduleResourcePlanRequestUpdateScheduleResourcePlanRequestDeleteScheduleResourcePlanRequestDeltaModel;
    resourcePlanProjectTeamsDelta?: InsertScheduleResourcePlanRequestUpdateScheduleResourcePlanRequestDeleteScheduleResourcePlanRequestDeltaModel;
}

export class UpdateScopeItemLevelRequest implements IUpdateScopeItemLevelRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    processDescription?: string | undefined;
    ticketId?: number | undefined;
    processVariant!: boolean;
    relatedScopeItemLevelId?: number | undefined;
    regressionRelevant!: boolean;
    regressionDependecies?: string | undefined;
    stressTestRelevant!: boolean;
    environmentId?: number | undefined;
    inputDocument?: string | undefined;
    outputDocument?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    scopeDepartmentId?: number | undefined;
    scopeStepTypeId?: number | undefined;
    scopeUserRoleId?: number | undefined;
    isComplex!: boolean;
    complexForScopeItemId?: number | undefined;
    order!: number;
    insertedChangeRequestIds?: number[] | undefined;
    removedChangeRequestIds?: number[] | undefined;
    newDesignAttachments?: InsertAttachmentRequest[] | undefined;
    newTrainingAttachments?: InsertAttachmentRequest[] | undefined;
    newOtherAttachments?: InsertAttachmentRequest[] | undefined;

    constructor(data?: IUpdateScopeItemLevelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.processDescription = _data["processDescription"];
            this.ticketId = _data["ticketId"];
            this.processVariant = _data["processVariant"];
            this.relatedScopeItemLevelId = _data["relatedScopeItemLevelId"];
            this.regressionRelevant = _data["regressionRelevant"];
            this.regressionDependecies = _data["regressionDependecies"];
            this.stressTestRelevant = _data["stressTestRelevant"];
            this.environmentId = _data["environmentId"];
            this.inputDocument = _data["inputDocument"];
            this.outputDocument = _data["outputDocument"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.scopeDepartmentId = _data["scopeDepartmentId"];
            this.scopeStepTypeId = _data["scopeStepTypeId"];
            this.scopeUserRoleId = _data["scopeUserRoleId"];
            this.isComplex = _data["isComplex"];
            this.complexForScopeItemId = _data["complexForScopeItemId"];
            this.order = _data["order"];
            if (Array.isArray(_data["insertedChangeRequestIds"])) {
                this.insertedChangeRequestIds = [] as any;
                for (let item of _data["insertedChangeRequestIds"])
                    this.insertedChangeRequestIds!.push(item);
            }
            if (Array.isArray(_data["removedChangeRequestIds"])) {
                this.removedChangeRequestIds = [] as any;
                for (let item of _data["removedChangeRequestIds"])
                    this.removedChangeRequestIds!.push(item);
            }
            if (Array.isArray(_data["newDesignAttachments"])) {
                this.newDesignAttachments = [] as any;
                for (let item of _data["newDesignAttachments"])
                    this.newDesignAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            if (Array.isArray(_data["newTrainingAttachments"])) {
                this.newTrainingAttachments = [] as any;
                for (let item of _data["newTrainingAttachments"])
                    this.newTrainingAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            if (Array.isArray(_data["newOtherAttachments"])) {
                this.newOtherAttachments = [] as any;
                for (let item of _data["newOtherAttachments"])
                    this.newOtherAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateScopeItemLevelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScopeItemLevelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["processDescription"] = this.processDescription;
        data["ticketId"] = this.ticketId;
        data["processVariant"] = this.processVariant;
        data["relatedScopeItemLevelId"] = this.relatedScopeItemLevelId;
        data["regressionRelevant"] = this.regressionRelevant;
        data["regressionDependecies"] = this.regressionDependecies;
        data["stressTestRelevant"] = this.stressTestRelevant;
        data["environmentId"] = this.environmentId;
        data["inputDocument"] = this.inputDocument;
        data["outputDocument"] = this.outputDocument;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["scopeDepartmentId"] = this.scopeDepartmentId;
        data["scopeStepTypeId"] = this.scopeStepTypeId;
        data["scopeUserRoleId"] = this.scopeUserRoleId;
        data["isComplex"] = this.isComplex;
        data["complexForScopeItemId"] = this.complexForScopeItemId;
        data["order"] = this.order;
        if (Array.isArray(this.insertedChangeRequestIds)) {
            data["insertedChangeRequestIds"] = [];
            for (let item of this.insertedChangeRequestIds)
                data["insertedChangeRequestIds"].push(item);
        }
        if (Array.isArray(this.removedChangeRequestIds)) {
            data["removedChangeRequestIds"] = [];
            for (let item of this.removedChangeRequestIds)
                data["removedChangeRequestIds"].push(item);
        }
        if (Array.isArray(this.newDesignAttachments)) {
            data["newDesignAttachments"] = [];
            for (let item of this.newDesignAttachments)
                data["newDesignAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.newTrainingAttachments)) {
            data["newTrainingAttachments"] = [];
            for (let item of this.newTrainingAttachments)
                data["newTrainingAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.newOtherAttachments)) {
            data["newOtherAttachments"] = [];
            for (let item of this.newOtherAttachments)
                data["newOtherAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateScopeItemLevelRequest {
    name: string;
    description?: string | undefined;
    id: number;
    processDescription?: string | undefined;
    ticketId?: number | undefined;
    processVariant: boolean;
    relatedScopeItemLevelId?: number | undefined;
    regressionRelevant: boolean;
    regressionDependecies?: string | undefined;
    stressTestRelevant: boolean;
    environmentId?: number | undefined;
    inputDocument?: string | undefined;
    outputDocument?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    scopeDepartmentId?: number | undefined;
    scopeStepTypeId?: number | undefined;
    scopeUserRoleId?: number | undefined;
    isComplex: boolean;
    complexForScopeItemId?: number | undefined;
    order: number;
    insertedChangeRequestIds?: number[] | undefined;
    removedChangeRequestIds?: number[] | undefined;
    newDesignAttachments?: InsertAttachmentRequest[] | undefined;
    newTrainingAttachments?: InsertAttachmentRequest[] | undefined;
    newOtherAttachments?: InsertAttachmentRequest[] | undefined;
}

export class UpdateSLAResponseTimeRequest implements IUpdateSLAResponseTimeRequest {
    id!: number;
    resolutionTime!: number;
    responseTime!: number;

    constructor(data?: IUpdateSLAResponseTimeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resolutionTime = _data["resolutionTime"];
            this.responseTime = _data["responseTime"];
        }
    }

    static fromJS(data: any): UpdateSLAResponseTimeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSLAResponseTimeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resolutionTime"] = this.resolutionTime;
        data["responseTime"] = this.responseTime;
        return data;
    }
}

export interface IUpdateSLAResponseTimeRequest {
    id: number;
    resolutionTime: number;
    responseTime: number;
}

export class UpdateStatusReportGeneralConfigRequest implements IUpdateStatusReportGeneralConfigRequest {
    enableNotifications!: boolean;
    id!: number;

    constructor(data?: IUpdateStatusReportGeneralConfigRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableNotifications = _data["enableNotifications"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateStatusReportGeneralConfigRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusReportGeneralConfigRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableNotifications"] = this.enableNotifications;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateStatusReportGeneralConfigRequest {
    enableNotifications: boolean;
    id: number;
}

export class UpdateStatusReportRequest implements IUpdateStatusReportRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    reportDate!: Date;
    from?: Date | undefined;
    to?: Date | undefined;
    responsibleUserId?: number | undefined;
    notifyResponsibleUser!: boolean;
    openIssues!: string;
    keyRisks!: string;
    nextSteps!: string;
    overallStatus!: ReportStatusAreaEnum;
    overallStatusAndKeyAchievements!: string;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    id!: number;

    constructor(data?: IUpdateStatusReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.reportDate = _data["reportDate"] ? new Date(_data["reportDate"].toString()) : undefined as any;
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.responsibleUserId = _data["responsibleUserId"];
            this.notifyResponsibleUser = _data["notifyResponsibleUser"];
            this.openIssues = _data["openIssues"];
            this.keyRisks = _data["keyRisks"];
            this.nextSteps = _data["nextSteps"];
            this.overallStatus = _data["overallStatus"];
            this.overallStatusAndKeyAchievements = _data["overallStatusAndKeyAchievements"];
            this.projectTeamId = _data["projectTeamId"];
            this.projectOrganizationId = _data["projectOrganizationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateStatusReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["reportDate"] = this.reportDate ? formatDate(this.reportDate) : undefined as any;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["responsibleUserId"] = this.responsibleUserId;
        data["notifyResponsibleUser"] = this.notifyResponsibleUser;
        data["openIssues"] = this.openIssues;
        data["keyRisks"] = this.keyRisks;
        data["nextSteps"] = this.nextSteps;
        data["overallStatus"] = this.overallStatus;
        data["overallStatusAndKeyAchievements"] = this.overallStatusAndKeyAchievements;
        data["projectTeamId"] = this.projectTeamId;
        data["projectOrganizationId"] = this.projectOrganizationId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateStatusReportRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    reportDate: Date;
    from?: Date | undefined;
    to?: Date | undefined;
    responsibleUserId?: number | undefined;
    notifyResponsibleUser: boolean;
    openIssues: string;
    keyRisks: string;
    nextSteps: string;
    overallStatus: ReportStatusAreaEnum;
    overallStatusAndKeyAchievements: string;
    projectTeamId?: number | undefined;
    projectOrganizationId?: number | undefined;
    id: number;
}

export class UpdateStatusRequest implements IUpdateStatusRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    isActive!: boolean;
    color!: string;
    order!: number;

    constructor(data?: IUpdateStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.color = _data["color"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UpdateStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["color"] = this.color;
        data["order"] = this.order;
        return data;
    }
}

export interface IUpdateStatusRequest {
    name: string;
    description?: string | undefined;
    id: number;
    isActive: boolean;
    color: string;
    order: number;
}

export class UpdateSurveyParticipantsRequest implements IUpdateSurveyParticipantsRequest {
    insertUserIds?: number[] | undefined;
    deleteUserIds?: number[] | undefined;

    constructor(data?: IUpdateSurveyParticipantsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insertUserIds"])) {
                this.insertUserIds = [] as any;
                for (let item of _data["insertUserIds"])
                    this.insertUserIds!.push(item);
            }
            if (Array.isArray(_data["deleteUserIds"])) {
                this.deleteUserIds = [] as any;
                for (let item of _data["deleteUserIds"])
                    this.deleteUserIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSurveyParticipantsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSurveyParticipantsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insertUserIds)) {
            data["insertUserIds"] = [];
            for (let item of this.insertUserIds)
                data["insertUserIds"].push(item);
        }
        if (Array.isArray(this.deleteUserIds)) {
            data["deleteUserIds"] = [];
            for (let item of this.deleteUserIds)
                data["deleteUserIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateSurveyParticipantsRequest {
    insertUserIds?: number[] | undefined;
    deleteUserIds?: number[] | undefined;
}

export class UpdateSurveyProposedAnswerRequest implements IUpdateSurveyProposedAnswerRequest {
    id!: number;
    answer!: string;
    points?: number | undefined;
    isCorrect!: boolean;

    constructor(data?: IUpdateSurveyProposedAnswerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.answer = _data["answer"];
            this.points = _data["points"];
            this.isCorrect = _data["isCorrect"];
        }
    }

    static fromJS(data: any): UpdateSurveyProposedAnswerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSurveyProposedAnswerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["answer"] = this.answer;
        data["points"] = this.points;
        data["isCorrect"] = this.isCorrect;
        return data;
    }
}

export interface IUpdateSurveyProposedAnswerRequest {
    id: number;
    answer: string;
    points?: number | undefined;
    isCorrect: boolean;
}

export class UpdateSurveyQuestionRequest implements IUpdateSurveyQuestionRequest {
    id!: number;
    questionGroup?: string | undefined;
    question!: string;
    surveyType!: SurveyQuestionTypeEnum;
    answerRequired!: boolean;
    scoreQuestion!: boolean;
    order!: number;
    proposedAnswersDelta?: SurveyProposedAnswerDeltaRequest;

    constructor(data?: IUpdateSurveyQuestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionGroup = _data["questionGroup"];
            this.question = _data["question"];
            this.surveyType = _data["surveyType"];
            this.answerRequired = _data["answerRequired"];
            this.scoreQuestion = _data["scoreQuestion"];
            this.order = _data["order"];
            this.proposedAnswersDelta = _data["proposedAnswersDelta"] ? SurveyProposedAnswerDeltaRequest.fromJS(_data["proposedAnswersDelta"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateSurveyQuestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSurveyQuestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionGroup"] = this.questionGroup;
        data["question"] = this.question;
        data["surveyType"] = this.surveyType;
        data["answerRequired"] = this.answerRequired;
        data["scoreQuestion"] = this.scoreQuestion;
        data["order"] = this.order;
        data["proposedAnswersDelta"] = this.proposedAnswersDelta ? this.proposedAnswersDelta.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateSurveyQuestionRequest {
    id: number;
    questionGroup?: string | undefined;
    question: string;
    surveyType: SurveyQuestionTypeEnum;
    answerRequired: boolean;
    scoreQuestion: boolean;
    order: number;
    proposedAnswersDelta?: SurveyProposedAnswerDeltaRequest;
}

export class UpdateTaskCalendarItemRequest implements IUpdateTaskCalendarItemRequest {
    taskId!: number;
    from!: Date;
    to?: Date | undefined;

    constructor(data?: IUpdateTaskCalendarItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateTaskCalendarItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskCalendarItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["from"] = this.from ? this.from.toISOString() : undefined as any;
        data["to"] = this.to ? this.to.toISOString() : undefined as any;
        return data;
    }
}

export interface IUpdateTaskCalendarItemRequest {
    taskId: number;
    from: Date;
    to?: Date | undefined;
}

export class UpdateTaskCommentRequest implements IUpdateTaskCommentRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    taskId!: number;
    comment!: string;
    id!: number;

    constructor(data?: IUpdateTaskCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.taskId = _data["taskId"];
            this.comment = _data["comment"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTaskCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["taskId"] = this.taskId;
        data["comment"] = this.comment;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTaskCommentRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    taskId: number;
    comment: string;
    id: number;
}

export class UpdateTaskGeneralConfigRequest implements IUpdateTaskGeneralConfigRequest {
    notifyWhenAssignedToUser!: boolean;
    enableEmailNotifications!: boolean;
    id!: number;

    constructor(data?: IUpdateTaskGeneralConfigRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notifyWhenAssignedToUser = _data["notifyWhenAssignedToUser"];
            this.enableEmailNotifications = _data["enableEmailNotifications"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTaskGeneralConfigRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskGeneralConfigRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notifyWhenAssignedToUser"] = this.notifyWhenAssignedToUser;
        data["enableEmailNotifications"] = this.enableEmailNotifications;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTaskGeneralConfigRequest {
    notifyWhenAssignedToUser: boolean;
    enableEmailNotifications: boolean;
    id: number;
}

export class UpdateTaskRequest implements IUpdateTaskRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    assignedToUserId!: number;
    due!: Date;
    isPrivate!: boolean;
    description?: string | undefined;
    parentTaskId?: number | undefined;
    riskId?: number | undefined;
    scopeItemLevelId?: number | undefined;
    changeRequestId?: number | undefined;
    ticketId?: number | undefined;
    meetingId?: number | undefined;
    scheduleId?: number | undefined;
    projectOrganizationId?: number | undefined;
    priority?: TaskPriorityEnum;
    estimatedEffort?: number | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    id!: number;
    statusId!: number;

    constructor(data?: IUpdateTaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            this.isPrivate = _data["isPrivate"];
            this.description = _data["description"];
            this.parentTaskId = _data["parentTaskId"];
            this.riskId = _data["riskId"];
            this.scopeItemLevelId = _data["scopeItemLevelId"];
            this.changeRequestId = _data["changeRequestId"];
            this.ticketId = _data["ticketId"];
            this.meetingId = _data["meetingId"];
            this.scheduleId = _data["scheduleId"];
            this.projectOrganizationId = _data["projectOrganizationId"];
            this.priority = _data["priority"];
            this.estimatedEffort = _data["estimatedEffort"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            this.id = _data["id"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): UpdateTaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["assignedToUserId"] = this.assignedToUserId;
        data["due"] = this.due ? formatDate(this.due) : undefined as any;
        data["isPrivate"] = this.isPrivate;
        data["description"] = this.description;
        data["parentTaskId"] = this.parentTaskId;
        data["riskId"] = this.riskId;
        data["scopeItemLevelId"] = this.scopeItemLevelId;
        data["changeRequestId"] = this.changeRequestId;
        data["ticketId"] = this.ticketId;
        data["meetingId"] = this.meetingId;
        data["scheduleId"] = this.scheduleId;
        data["projectOrganizationId"] = this.projectOrganizationId;
        data["priority"] = this.priority;
        data["estimatedEffort"] = this.estimatedEffort;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface IUpdateTaskRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    assignedToUserId: number;
    due: Date;
    isPrivate: boolean;
    description?: string | undefined;
    parentTaskId?: number | undefined;
    riskId?: number | undefined;
    scopeItemLevelId?: number | undefined;
    changeRequestId?: number | undefined;
    ticketId?: number | undefined;
    meetingId?: number | undefined;
    scheduleId?: number | undefined;
    projectOrganizationId?: number | undefined;
    priority?: TaskPriorityEnum;
    estimatedEffort?: number | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    id: number;
    statusId: number;
}

export class UpdateTaskTimesheetRequest implements IUpdateTaskTimesheetRequest {
    userId!: number;
    date!: Date;
    effort!: number;
    estimatedTime?: number | undefined;
    id!: number;

    constructor(data?: IUpdateTaskTimesheetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.effort = _data["effort"];
            this.estimatedTime = _data["estimatedTime"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTaskTimesheetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskTimesheetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["effort"] = this.effort;
        data["estimatedTime"] = this.estimatedTime;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTaskTimesheetRequest {
    userId: number;
    date: Date;
    effort: number;
    estimatedTime?: number | undefined;
    id: number;
}

export class UpdateTeamMemberApprovalRequest implements IUpdateTeamMemberApprovalRequest {
    projectTeamId?: number | undefined;
    projectRoleId?: number | undefined;
    memberValidUntil?: Date | undefined;

    constructor(data?: IUpdateTeamMemberApprovalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectTeamId = _data["projectTeamId"];
            this.projectRoleId = _data["projectRoleId"];
            this.memberValidUntil = _data["memberValidUntil"] ? new Date(_data["memberValidUntil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateTeamMemberApprovalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamMemberApprovalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectTeamId"] = this.projectTeamId;
        data["projectRoleId"] = this.projectRoleId;
        data["memberValidUntil"] = this.memberValidUntil ? formatDate(this.memberValidUntil) : undefined as any;
        return data;
    }
}

export interface IUpdateTeamMemberApprovalRequest {
    projectTeamId?: number | undefined;
    projectRoleId?: number | undefined;
    memberValidUntil?: Date | undefined;
}

export class UpdateTenantDescriptiveRequest implements IUpdateTenantDescriptiveRequest {
    name!: string;
    description?: string | undefined;
    id!: number;

    constructor(data?: IUpdateTenantDescriptiveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTenantDescriptiveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantDescriptiveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTenantDescriptiveRequest {
    name: string;
    description?: string | undefined;
    id: number;
}

export class UpdateTenantIsActiveOrderRequest implements IUpdateTenantIsActiveOrderRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    isActive!: boolean;
    order!: number;

    constructor(data?: IUpdateTenantIsActiveOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UpdateTenantIsActiveOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantIsActiveOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["order"] = this.order;
        return data;
    }
}

export interface IUpdateTenantIsActiveOrderRequest {
    name: string;
    description?: string | undefined;
    id: number;
    isActive: boolean;
    order: number;
}

export class UpdateTenantIsActiveRequest implements IUpdateTenantIsActiveRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    isActive!: boolean;

    constructor(data?: IUpdateTenantIsActiveRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateTenantIsActiveRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantIsActiveRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateTenantIsActiveRequest {
    name: string;
    description?: string | undefined;
    id: number;
    isActive: boolean;
}

export class UpdateTestPlanRequest implements IUpdateTestPlanRequest {
    id!: number;
    processStatusId!: number;
    comments?: string | undefined;
    ticketIdsDelta?: Int32Int32Int32DeltaModel;
    innerTestPlans?: UpdateInnerTestPlanRequest[] | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;

    constructor(data?: IUpdateTestPlanRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processStatusId = _data["processStatusId"];
            this.comments = _data["comments"];
            this.ticketIdsDelta = _data["ticketIdsDelta"] ? Int32Int32Int32DeltaModel.fromJS(_data["ticketIdsDelta"]) : undefined as any;
            if (Array.isArray(_data["innerTestPlans"])) {
                this.innerTestPlans = [] as any;
                for (let item of _data["innerTestPlans"])
                    this.innerTestPlans!.push(UpdateInnerTestPlanRequest.fromJS(item));
            }
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTestPlanRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTestPlanRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processStatusId"] = this.processStatusId;
        data["comments"] = this.comments;
        data["ticketIdsDelta"] = this.ticketIdsDelta ? this.ticketIdsDelta.toJSON() : undefined as any;
        if (Array.isArray(this.innerTestPlans)) {
            data["innerTestPlans"] = [];
            for (let item of this.innerTestPlans)
                data["innerTestPlans"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateTestPlanRequest {
    id: number;
    processStatusId: number;
    comments?: string | undefined;
    ticketIdsDelta?: Int32Int32Int32DeltaModel;
    innerTestPlans?: UpdateInnerTestPlanRequest[] | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
}

export class UpdateTestStatusRequest implements IUpdateTestStatusRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    isActive!: boolean;
    color!: string;
    order!: number;
    semantics!: TestStatusEnum;

    constructor(data?: IUpdateTestStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.color = _data["color"];
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): UpdateTestStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTestStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["color"] = this.color;
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IUpdateTestStatusRequest {
    name: string;
    description?: string | undefined;
    id: number;
    isActive: boolean;
    color: string;
    order: number;
    semantics: TestStatusEnum;
}

export class UpdateTicketCategoryRequest implements IUpdateTicketCategoryRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    isActive!: boolean;
    assignedGroupId?: number | undefined;
    order!: number;

    constructor(data?: IUpdateTicketCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.assignedGroupId = _data["assignedGroupId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UpdateTicketCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["assignedGroupId"] = this.assignedGroupId;
        data["order"] = this.order;
        return data;
    }
}

export interface IUpdateTicketCategoryRequest {
    name: string;
    description?: string | undefined;
    id: number;
    isActive: boolean;
    assignedGroupId?: number | undefined;
    order: number;
}

export class UpdateTicketClosingRequest implements IUpdateTicketClosingRequest {
    id!: number;
    closingId?: number | undefined;
    closingNote?: string | undefined;
    workaround?: string | undefined;
    newDesignAttachments?: InsertAttachmentRequest[] | undefined;
    newDevelopmentSpecificationAttachments?: InsertAttachmentRequest[] | undefined;
    newTrainingManualAttachments?: InsertAttachmentRequest[] | undefined;
    newTestEvidenceAttachments?: InsertAttachmentRequest[] | undefined;

    constructor(data?: IUpdateTicketClosingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.closingId = _data["closingId"];
            this.closingNote = _data["closingNote"];
            this.workaround = _data["workaround"];
            if (Array.isArray(_data["newDesignAttachments"])) {
                this.newDesignAttachments = [] as any;
                for (let item of _data["newDesignAttachments"])
                    this.newDesignAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            if (Array.isArray(_data["newDevelopmentSpecificationAttachments"])) {
                this.newDevelopmentSpecificationAttachments = [] as any;
                for (let item of _data["newDevelopmentSpecificationAttachments"])
                    this.newDevelopmentSpecificationAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            if (Array.isArray(_data["newTrainingManualAttachments"])) {
                this.newTrainingManualAttachments = [] as any;
                for (let item of _data["newTrainingManualAttachments"])
                    this.newTrainingManualAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            if (Array.isArray(_data["newTestEvidenceAttachments"])) {
                this.newTestEvidenceAttachments = [] as any;
                for (let item of _data["newTestEvidenceAttachments"])
                    this.newTestEvidenceAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTicketClosingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketClosingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["closingId"] = this.closingId;
        data["closingNote"] = this.closingNote;
        data["workaround"] = this.workaround;
        if (Array.isArray(this.newDesignAttachments)) {
            data["newDesignAttachments"] = [];
            for (let item of this.newDesignAttachments)
                data["newDesignAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.newDevelopmentSpecificationAttachments)) {
            data["newDevelopmentSpecificationAttachments"] = [];
            for (let item of this.newDevelopmentSpecificationAttachments)
                data["newDevelopmentSpecificationAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.newTrainingManualAttachments)) {
            data["newTrainingManualAttachments"] = [];
            for (let item of this.newTrainingManualAttachments)
                data["newTrainingManualAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.newTestEvidenceAttachments)) {
            data["newTestEvidenceAttachments"] = [];
            for (let item of this.newTestEvidenceAttachments)
                data["newTestEvidenceAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateTicketClosingRequest {
    id: number;
    closingId?: number | undefined;
    closingNote?: string | undefined;
    workaround?: string | undefined;
    newDesignAttachments?: InsertAttachmentRequest[] | undefined;
    newDevelopmentSpecificationAttachments?: InsertAttachmentRequest[] | undefined;
    newTrainingManualAttachments?: InsertAttachmentRequest[] | undefined;
    newTestEvidenceAttachments?: InsertAttachmentRequest[] | undefined;
}

export class UpdateTicketCommentRequest implements IUpdateTicketCommentRequest {
    comment!: string;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    id!: number;

    constructor(data?: IUpdateTicketCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTicketCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTicketCommentRequest {
    comment: string;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    id: number;
}

export class UpdateTicketEffortRequest implements IUpdateTicketEffortRequest {
    id!: number;
    effort?: number | undefined;
    effortUnit?: TimeMeasureEnum;
    timesheetsDelta?: InsertTicketTimesheetRequestUpdateTicketTimesheetRequestInt32DeltaModel;

    constructor(data?: IUpdateTicketEffortRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.effort = _data["effort"];
            this.effortUnit = _data["effortUnit"];
            this.timesheetsDelta = _data["timesheetsDelta"] ? InsertTicketTimesheetRequestUpdateTicketTimesheetRequestInt32DeltaModel.fromJS(_data["timesheetsDelta"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateTicketEffortRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketEffortRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["effort"] = this.effort;
        data["effortUnit"] = this.effortUnit;
        data["timesheetsDelta"] = this.timesheetsDelta ? this.timesheetsDelta.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateTicketEffortRequest {
    id: number;
    effort?: number | undefined;
    effortUnit?: TimeMeasureEnum;
    timesheetsDelta?: InsertTicketTimesheetRequestUpdateTicketTimesheetRequestInt32DeltaModel;
}

export class UpdateTicketHelpDeskRequest implements IUpdateTicketHelpDeskRequest {
    id!: number;
    projectId!: number;
    statusId!: number;

    constructor(data?: IUpdateTicketHelpDeskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): UpdateTicketHelpDeskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketHelpDeskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface IUpdateTicketHelpDeskRequest {
    id: number;
    projectId: number;
    statusId: number;
}

export class UpdateTicketRequest implements IUpdateTicketRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    projectId!: number;
    reportedBy!: string;
    reportedOn?: Date | undefined;
    typeId?: number | undefined;
    categoryLevel1Id!: number;
    categoryLevel2Id?: number | undefined;
    categoryLevel3Id?: number | undefined;
    ticketNumberExt?: string | undefined;
    statusId!: number;
    impactId!: number;
    urgencyId!: number;
    parentTicketId?: number | undefined;
    changeRequestIdsDelta?: Int32Int32Int32DeltaModel;
    testPlanIdsDelta?: Int32Int32Int32DeltaModel;
    assignedGroupId?: number | undefined;
    expectedResolutionDate?: Date | undefined;
    environmentId?: number | undefined;
    scheduleId?: number | undefined;
    assignedToUserId!: number;
    newAttachments?: InsertAttachmentRequest[] | undefined;

    constructor(data?: IUpdateTicketRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.reportedBy = _data["reportedBy"];
            this.reportedOn = _data["reportedOn"] ? new Date(_data["reportedOn"].toString()) : undefined as any;
            this.typeId = _data["typeId"];
            this.categoryLevel1Id = _data["categoryLevel1Id"];
            this.categoryLevel2Id = _data["categoryLevel2Id"];
            this.categoryLevel3Id = _data["categoryLevel3Id"];
            this.ticketNumberExt = _data["ticketNumberExt"];
            this.statusId = _data["statusId"];
            this.impactId = _data["impactId"];
            this.urgencyId = _data["urgencyId"];
            this.parentTicketId = _data["parentTicketId"];
            this.changeRequestIdsDelta = _data["changeRequestIdsDelta"] ? Int32Int32Int32DeltaModel.fromJS(_data["changeRequestIdsDelta"]) : undefined as any;
            this.testPlanIdsDelta = _data["testPlanIdsDelta"] ? Int32Int32Int32DeltaModel.fromJS(_data["testPlanIdsDelta"]) : undefined as any;
            this.assignedGroupId = _data["assignedGroupId"];
            this.expectedResolutionDate = _data["expectedResolutionDate"] ? new Date(_data["expectedResolutionDate"].toString()) : undefined as any;
            this.environmentId = _data["environmentId"];
            this.scheduleId = _data["scheduleId"];
            this.assignedToUserId = _data["assignedToUserId"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTicketRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["reportedBy"] = this.reportedBy;
        data["reportedOn"] = this.reportedOn ? formatDate(this.reportedOn) : undefined as any;
        data["typeId"] = this.typeId;
        data["categoryLevel1Id"] = this.categoryLevel1Id;
        data["categoryLevel2Id"] = this.categoryLevel2Id;
        data["categoryLevel3Id"] = this.categoryLevel3Id;
        data["ticketNumberExt"] = this.ticketNumberExt;
        data["statusId"] = this.statusId;
        data["impactId"] = this.impactId;
        data["urgencyId"] = this.urgencyId;
        data["parentTicketId"] = this.parentTicketId;
        data["changeRequestIdsDelta"] = this.changeRequestIdsDelta ? this.changeRequestIdsDelta.toJSON() : undefined as any;
        data["testPlanIdsDelta"] = this.testPlanIdsDelta ? this.testPlanIdsDelta.toJSON() : undefined as any;
        data["assignedGroupId"] = this.assignedGroupId;
        data["expectedResolutionDate"] = this.expectedResolutionDate ? formatDate(this.expectedResolutionDate) : undefined as any;
        data["environmentId"] = this.environmentId;
        data["scheduleId"] = this.scheduleId;
        data["assignedToUserId"] = this.assignedToUserId;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateTicketRequest {
    name: string;
    description?: string | undefined;
    id: number;
    projectId: number;
    reportedBy: string;
    reportedOn?: Date | undefined;
    typeId?: number | undefined;
    categoryLevel1Id: number;
    categoryLevel2Id?: number | undefined;
    categoryLevel3Id?: number | undefined;
    ticketNumberExt?: string | undefined;
    statusId: number;
    impactId: number;
    urgencyId: number;
    parentTicketId?: number | undefined;
    changeRequestIdsDelta?: Int32Int32Int32DeltaModel;
    testPlanIdsDelta?: Int32Int32Int32DeltaModel;
    assignedGroupId?: number | undefined;
    expectedResolutionDate?: Date | undefined;
    environmentId?: number | undefined;
    scheduleId?: number | undefined;
    assignedToUserId: number;
    newAttachments?: InsertAttachmentRequest[] | undefined;
}

export class UpdateTicketStatusRequest implements IUpdateTicketStatusRequest {
    name!: string;
    description?: string | undefined;
    id!: number;
    isActive!: boolean;
    color!: string;
    order!: number;
    semantics!: TicketStatusEnum;

    constructor(data?: IUpdateTicketStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.color = _data["color"];
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): UpdateTicketStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["color"] = this.color;
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IUpdateTicketStatusRequest {
    name: string;
    description?: string | undefined;
    id: number;
    isActive: boolean;
    color: string;
    order: number;
    semantics: TicketStatusEnum;
}

export class UpdateTicketSubtaskRequest implements IUpdateTicketSubtaskRequest {
    createTask!: boolean;
    description?: string | undefined;
    assignedToUserId?: number | undefined;
    due?: Date | undefined;
    statusId?: number | undefined;
    id!: number;

    constructor(data?: IUpdateTicketSubtaskRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createTask = _data["createTask"];
            this.description = _data["description"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.due = _data["due"] ? new Date(_data["due"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTicketSubtaskRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketSubtaskRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTask"] = this.createTask;
        data["description"] = this.description;
        data["assignedToUserId"] = this.assignedToUserId;
        data["due"] = this.due ? formatDate(this.due) : undefined as any;
        data["statusId"] = this.statusId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTicketSubtaskRequest {
    createTask: boolean;
    description?: string | undefined;
    assignedToUserId?: number | undefined;
    due?: Date | undefined;
    statusId?: number | undefined;
    id: number;
}

export class UpdateTicketTimesheetRequest implements IUpdateTicketTimesheetRequest {
    date!: Date;
    effort!: number;
    estimatedTime?: number | undefined;
    id!: number;

    constructor(data?: IUpdateTicketTimesheetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.effort = _data["effort"];
            this.estimatedTime = _data["estimatedTime"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTicketTimesheetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTicketTimesheetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["effort"] = this.effort;
        data["estimatedTime"] = this.estimatedTime;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTicketTimesheetRequest {
    date: Date;
    effort: number;
    estimatedTime?: number | undefined;
    id: number;
}

export class UpdateTimesheetRequest implements IUpdateTimesheetRequest {
    date!: Date;
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    effort!: number;
    description?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    customText3?: string | undefined;
    changeRequestId?: number | undefined;
    ticketId?: number | undefined;
    taskId?: number | undefined;
    scheduleId?: number | undefined;
    projectTeamId?: number | undefined;
    id!: number;

    constructor(data?: IUpdateTimesheetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.effort = _data["effort"];
            this.description = _data["description"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.customText3 = _data["customText3"];
            this.changeRequestId = _data["changeRequestId"];
            this.ticketId = _data["ticketId"];
            this.taskId = _data["taskId"];
            this.scheduleId = _data["scheduleId"];
            this.projectTeamId = _data["projectTeamId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTimesheetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTimesheetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["effort"] = this.effort;
        data["description"] = this.description;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["customText3"] = this.customText3;
        data["changeRequestId"] = this.changeRequestId;
        data["ticketId"] = this.ticketId;
        data["taskId"] = this.taskId;
        data["scheduleId"] = this.scheduleId;
        data["projectTeamId"] = this.projectTeamId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTimesheetRequest {
    date: Date;
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    effort: number;
    description?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    customText3?: string | undefined;
    changeRequestId?: number | undefined;
    ticketId?: number | undefined;
    taskId?: number | undefined;
    scheduleId?: number | undefined;
    projectTeamId?: number | undefined;
    id: number;
}

export class UpdateTimesheetsConfigRequest implements IUpdateTimesheetsConfigRequest {
    enableApprovalProcess!: boolean;
    enableEmailNotifications!: boolean;
    notifyWhenSubmitted!: boolean;
    notifyWhenApproved!: boolean;
    notifyWhenRejected!: boolean;
    requireCommentsWhenRejecting!: boolean;
    id!: number;
    approvalFrequency!: TimeFrequency;
    minimumRecord!: number;
    minimumWorkingHoursPerDay!: number;
    allowOvertimeWeekendHolidayWork!: boolean;

    constructor(data?: IUpdateTimesheetsConfigRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableApprovalProcess = _data["enableApprovalProcess"];
            this.enableEmailNotifications = _data["enableEmailNotifications"];
            this.notifyWhenSubmitted = _data["notifyWhenSubmitted"];
            this.notifyWhenApproved = _data["notifyWhenApproved"];
            this.notifyWhenRejected = _data["notifyWhenRejected"];
            this.requireCommentsWhenRejecting = _data["requireCommentsWhenRejecting"];
            this.id = _data["id"];
            this.approvalFrequency = _data["approvalFrequency"];
            this.minimumRecord = _data["minimumRecord"];
            this.minimumWorkingHoursPerDay = _data["minimumWorkingHoursPerDay"];
            this.allowOvertimeWeekendHolidayWork = _data["allowOvertimeWeekendHolidayWork"];
        }
    }

    static fromJS(data: any): UpdateTimesheetsConfigRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTimesheetsConfigRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableApprovalProcess"] = this.enableApprovalProcess;
        data["enableEmailNotifications"] = this.enableEmailNotifications;
        data["notifyWhenSubmitted"] = this.notifyWhenSubmitted;
        data["notifyWhenApproved"] = this.notifyWhenApproved;
        data["notifyWhenRejected"] = this.notifyWhenRejected;
        data["requireCommentsWhenRejecting"] = this.requireCommentsWhenRejecting;
        data["id"] = this.id;
        data["approvalFrequency"] = this.approvalFrequency;
        data["minimumRecord"] = this.minimumRecord;
        data["minimumWorkingHoursPerDay"] = this.minimumWorkingHoursPerDay;
        data["allowOvertimeWeekendHolidayWork"] = this.allowOvertimeWeekendHolidayWork;
        return data;
    }
}

export interface IUpdateTimesheetsConfigRequest {
    enableApprovalProcess: boolean;
    enableEmailNotifications: boolean;
    notifyWhenSubmitted: boolean;
    notifyWhenApproved: boolean;
    notifyWhenRejected: boolean;
    requireCommentsWhenRejecting: boolean;
    id: number;
    approvalFrequency: TimeFrequency;
    minimumRecord: number;
    minimumWorkingHoursPerDay: number;
    allowOvertimeWeekendHolidayWork: boolean;
}

export class UpdateTimeTravelConfigRequest implements IUpdateTimeTravelConfigRequest {
    enableApprovalProcess!: boolean;
    enableEmailNotifications!: boolean;
    notifyWhenSubmitted!: boolean;
    notifyWhenApproved!: boolean;
    notifyWhenRejected!: boolean;
    requireCommentsWhenRejecting!: boolean;
    id!: number;

    constructor(data?: IUpdateTimeTravelConfigRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableApprovalProcess = _data["enableApprovalProcess"];
            this.enableEmailNotifications = _data["enableEmailNotifications"];
            this.notifyWhenSubmitted = _data["notifyWhenSubmitted"];
            this.notifyWhenApproved = _data["notifyWhenApproved"];
            this.notifyWhenRejected = _data["notifyWhenRejected"];
            this.requireCommentsWhenRejecting = _data["requireCommentsWhenRejecting"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTimeTravelConfigRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTimeTravelConfigRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableApprovalProcess"] = this.enableApprovalProcess;
        data["enableEmailNotifications"] = this.enableEmailNotifications;
        data["notifyWhenSubmitted"] = this.notifyWhenSubmitted;
        data["notifyWhenApproved"] = this.notifyWhenApproved;
        data["notifyWhenRejected"] = this.notifyWhenRejected;
        data["requireCommentsWhenRejecting"] = this.requireCommentsWhenRejecting;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTimeTravelConfigRequest {
    enableApprovalProcess: boolean;
    enableEmailNotifications: boolean;
    notifyWhenSubmitted: boolean;
    notifyWhenApproved: boolean;
    notifyWhenRejected: boolean;
    requireCommentsWhenRejecting: boolean;
    id: number;
}

export class UpdateTrainingPlanStatusRequest implements IUpdateTrainingPlanStatusRequest {
    trainingPlanId!: number;
    statusId!: number;

    constructor(data?: IUpdateTrainingPlanStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingPlanId = _data["trainingPlanId"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): UpdateTrainingPlanStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrainingPlanStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingPlanId"] = this.trainingPlanId;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface IUpdateTrainingPlanStatusRequest {
    trainingPlanId: number;
    statusId: number;
}

export class UpdateTravelExpenseItemRequest implements IUpdateTravelExpenseItemRequest {
    costTypeId!: number;
    amountProjectCurrency!: number;
    receiptCurrencyId?: number | undefined;
    amountReceiptCurrency?: number | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    id!: number;
    removedAttachments?: number[] | undefined;

    constructor(data?: IUpdateTravelExpenseItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costTypeId = _data["costTypeId"];
            this.amountProjectCurrency = _data["amountProjectCurrency"];
            this.receiptCurrencyId = _data["receiptCurrencyId"];
            this.amountReceiptCurrency = _data["amountReceiptCurrency"];
            if (Array.isArray(_data["newAttachments"])) {
                this.newAttachments = [] as any;
                for (let item of _data["newAttachments"])
                    this.newAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
            this.id = _data["id"];
            if (Array.isArray(_data["removedAttachments"])) {
                this.removedAttachments = [] as any;
                for (let item of _data["removedAttachments"])
                    this.removedAttachments!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateTravelExpenseItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTravelExpenseItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costTypeId"] = this.costTypeId;
        data["amountProjectCurrency"] = this.amountProjectCurrency;
        data["receiptCurrencyId"] = this.receiptCurrencyId;
        data["amountReceiptCurrency"] = this.amountReceiptCurrency;
        if (Array.isArray(this.newAttachments)) {
            data["newAttachments"] = [];
            for (let item of this.newAttachments)
                data["newAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        if (Array.isArray(this.removedAttachments)) {
            data["removedAttachments"] = [];
            for (let item of this.removedAttachments)
                data["removedAttachments"].push(item);
        }
        return data;
    }
}

export interface IUpdateTravelExpenseItemRequest {
    costTypeId: number;
    amountProjectCurrency: number;
    receiptCurrencyId?: number | undefined;
    amountReceiptCurrency?: number | undefined;
    newAttachments?: InsertAttachmentRequest[] | undefined;
    id: number;
    removedAttachments?: number[] | undefined;
}

export class UpdateTravelExpenseRequest implements IUpdateTravelExpenseRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    description!: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease!: boolean;
    id!: number;
    travelRequestId?: number | undefined;
    destinationCountryId!: number;
    destinationCity!: string;
    estimatedCosts?: number | undefined;
    advancePayment?: number | undefined;
    freeMeals!: boolean;
    freeAccommodation!: boolean;
    travelBy!: TravelByEnum;
    regNumber?: string | undefined;
    distance?: string | undefined;
    startKilemeter?: string | undefined;
    endKilometer?: string | undefined;
    leaveDepartureDate!: Date;
    leaveDepartureTime!: number;
    leaveBorderCrossDate?: Date | undefined;
    leaveBorderCrossTime?: number | undefined;
    leaveArrivalDate?: Date | undefined;
    leaveArrivalTime?: number | undefined;
    returnDepartureDate?: Date | undefined;
    returnDepartureTime?: number | undefined;
    returnBorderCrossDate?: Date | undefined;
    returnBorderCrossTime?: number | undefined;
    returnArrivalDate!: Date;
    returnArrivalTime!: number;
    travelExpenseItemsDelta?: InsertTravelExpenseItemRequestUpdateTravelExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel;

    constructor(data?: IUpdateTravelExpenseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.description = _data["description"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.isRelease = _data["isRelease"];
            this.id = _data["id"];
            this.travelRequestId = _data["travelRequestId"];
            this.destinationCountryId = _data["destinationCountryId"];
            this.destinationCity = _data["destinationCity"];
            this.estimatedCosts = _data["estimatedCosts"];
            this.advancePayment = _data["advancePayment"];
            this.freeMeals = _data["freeMeals"];
            this.freeAccommodation = _data["freeAccommodation"];
            this.travelBy = _data["travelBy"];
            this.regNumber = _data["regNumber"];
            this.distance = _data["distance"];
            this.startKilemeter = _data["startKilemeter"];
            this.endKilometer = _data["endKilometer"];
            this.leaveDepartureDate = _data["leaveDepartureDate"] ? new Date(_data["leaveDepartureDate"].toString()) : undefined as any;
            this.leaveDepartureTime = _data["leaveDepartureTime"];
            this.leaveBorderCrossDate = _data["leaveBorderCrossDate"] ? new Date(_data["leaveBorderCrossDate"].toString()) : undefined as any;
            this.leaveBorderCrossTime = _data["leaveBorderCrossTime"];
            this.leaveArrivalDate = _data["leaveArrivalDate"] ? new Date(_data["leaveArrivalDate"].toString()) : undefined as any;
            this.leaveArrivalTime = _data["leaveArrivalTime"];
            this.returnDepartureDate = _data["returnDepartureDate"] ? new Date(_data["returnDepartureDate"].toString()) : undefined as any;
            this.returnDepartureTime = _data["returnDepartureTime"];
            this.returnBorderCrossDate = _data["returnBorderCrossDate"] ? new Date(_data["returnBorderCrossDate"].toString()) : undefined as any;
            this.returnBorderCrossTime = _data["returnBorderCrossTime"];
            this.returnArrivalDate = _data["returnArrivalDate"] ? new Date(_data["returnArrivalDate"].toString()) : undefined as any;
            this.returnArrivalTime = _data["returnArrivalTime"];
            this.travelExpenseItemsDelta = _data["travelExpenseItemsDelta"] ? InsertTravelExpenseItemRequestUpdateTravelExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel.fromJS(_data["travelExpenseItemsDelta"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateTravelExpenseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTravelExpenseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["description"] = this.description;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["isRelease"] = this.isRelease;
        data["id"] = this.id;
        data["travelRequestId"] = this.travelRequestId;
        data["destinationCountryId"] = this.destinationCountryId;
        data["destinationCity"] = this.destinationCity;
        data["estimatedCosts"] = this.estimatedCosts;
        data["advancePayment"] = this.advancePayment;
        data["freeMeals"] = this.freeMeals;
        data["freeAccommodation"] = this.freeAccommodation;
        data["travelBy"] = this.travelBy;
        data["regNumber"] = this.regNumber;
        data["distance"] = this.distance;
        data["startKilemeter"] = this.startKilemeter;
        data["endKilometer"] = this.endKilometer;
        data["leaveDepartureDate"] = this.leaveDepartureDate ? formatDate(this.leaveDepartureDate) : undefined as any;
        data["leaveDepartureTime"] = this.leaveDepartureTime;
        data["leaveBorderCrossDate"] = this.leaveBorderCrossDate ? formatDate(this.leaveBorderCrossDate) : undefined as any;
        data["leaveBorderCrossTime"] = this.leaveBorderCrossTime;
        data["leaveArrivalDate"] = this.leaveArrivalDate ? formatDate(this.leaveArrivalDate) : undefined as any;
        data["leaveArrivalTime"] = this.leaveArrivalTime;
        data["returnDepartureDate"] = this.returnDepartureDate ? formatDate(this.returnDepartureDate) : undefined as any;
        data["returnDepartureTime"] = this.returnDepartureTime;
        data["returnBorderCrossDate"] = this.returnBorderCrossDate ? formatDate(this.returnBorderCrossDate) : undefined as any;
        data["returnBorderCrossTime"] = this.returnBorderCrossTime;
        data["returnArrivalDate"] = this.returnArrivalDate ? formatDate(this.returnArrivalDate) : undefined as any;
        data["returnArrivalTime"] = this.returnArrivalTime;
        data["travelExpenseItemsDelta"] = this.travelExpenseItemsDelta ? this.travelExpenseItemsDelta.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateTravelExpenseRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    description: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease: boolean;
    id: number;
    travelRequestId?: number | undefined;
    destinationCountryId: number;
    destinationCity: string;
    estimatedCosts?: number | undefined;
    advancePayment?: number | undefined;
    freeMeals: boolean;
    freeAccommodation: boolean;
    travelBy: TravelByEnum;
    regNumber?: string | undefined;
    distance?: string | undefined;
    startKilemeter?: string | undefined;
    endKilometer?: string | undefined;
    leaveDepartureDate: Date;
    leaveDepartureTime: number;
    leaveBorderCrossDate?: Date | undefined;
    leaveBorderCrossTime?: number | undefined;
    leaveArrivalDate?: Date | undefined;
    leaveArrivalTime?: number | undefined;
    returnDepartureDate?: Date | undefined;
    returnDepartureTime?: number | undefined;
    returnBorderCrossDate?: Date | undefined;
    returnBorderCrossTime?: number | undefined;
    returnArrivalDate: Date;
    returnArrivalTime: number;
    travelExpenseItemsDelta?: InsertTravelExpenseItemRequestUpdateTravelExpenseItemRequestDeleteTenantIndetifyRequestDeltaModel;
}

export class UpdateTravelRequestRequest implements IUpdateTravelRequestRequest {
    projectOrCategoryId!: number;
    isProjectConnected!: boolean;
    description!: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease!: boolean;
    id!: number;
    departure!: Date;
    return!: Date;
    destinationCountryId!: number;
    destinationCity!: string;
    estimatedCosts!: number;
    advancePayment?: number | undefined;
    freeMeals!: boolean;
    freeAccommodation!: boolean;
    travelBy!: TravelByEnum;

    constructor(data?: IUpdateTravelRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectOrCategoryId = _data["projectOrCategoryId"];
            this.isProjectConnected = _data["isProjectConnected"];
            this.description = _data["description"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.isRelease = _data["isRelease"];
            this.id = _data["id"];
            this.departure = _data["departure"] ? new Date(_data["departure"].toString()) : undefined as any;
            this.return = _data["return"] ? new Date(_data["return"].toString()) : undefined as any;
            this.destinationCountryId = _data["destinationCountryId"];
            this.destinationCity = _data["destinationCity"];
            this.estimatedCosts = _data["estimatedCosts"];
            this.advancePayment = _data["advancePayment"];
            this.freeMeals = _data["freeMeals"];
            this.freeAccommodation = _data["freeAccommodation"];
            this.travelBy = _data["travelBy"];
        }
    }

    static fromJS(data: any): UpdateTravelRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTravelRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectOrCategoryId"] = this.projectOrCategoryId;
        data["isProjectConnected"] = this.isProjectConnected;
        data["description"] = this.description;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["isRelease"] = this.isRelease;
        data["id"] = this.id;
        data["departure"] = this.departure ? formatDate(this.departure) : undefined as any;
        data["return"] = this.return ? formatDate(this.return) : undefined as any;
        data["destinationCountryId"] = this.destinationCountryId;
        data["destinationCity"] = this.destinationCity;
        data["estimatedCosts"] = this.estimatedCosts;
        data["advancePayment"] = this.advancePayment;
        data["freeMeals"] = this.freeMeals;
        data["freeAccommodation"] = this.freeAccommodation;
        data["travelBy"] = this.travelBy;
        return data;
    }
}

export interface IUpdateTravelRequestRequest {
    projectOrCategoryId: number;
    isProjectConnected: boolean;
    description: string;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease: boolean;
    id: number;
    departure: Date;
    return: Date;
    destinationCountryId: number;
    destinationCity: string;
    estimatedCosts: number;
    advancePayment?: number | undefined;
    freeMeals: boolean;
    freeAccommodation: boolean;
    travelBy: TravelByEnum;
}

export class UpdateUserActivityRequestModel implements IUpdateUserActivityRequestModel {
    id!: number;
    isActive!: boolean;

    constructor(data?: IUpdateUserActivityRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateUserActivityRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserActivityRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateUserActivityRequestModel {
    id: number;
    isActive: boolean;
}

export class UpdateUserAlertConfigurationRequest implements IUpdateUserAlertConfigurationRequest {
    enabled!: boolean;
    sendEmail!: boolean;
    entityIds?: number[] | undefined;
    id!: number;

    constructor(data?: IUpdateUserAlertConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enabled = _data["enabled"];
            this.sendEmail = _data["sendEmail"];
            if (Array.isArray(_data["entityIds"])) {
                this.entityIds = [] as any;
                for (let item of _data["entityIds"])
                    this.entityIds!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateUserAlertConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserAlertConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enabled"] = this.enabled;
        data["sendEmail"] = this.sendEmail;
        if (Array.isArray(this.entityIds)) {
            data["entityIds"] = [];
            for (let item of this.entityIds)
                data["entityIds"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateUserAlertConfigurationRequest {
    enabled: boolean;
    sendEmail: boolean;
    entityIds?: number[] | undefined;
    id: number;
}

export class UpdateUserDataRequestModel implements IUpdateUserDataRequestModel {
    firstName!: string;
    lastName!: string;
    birthDate?: Date | undefined;
    email!: string;
    officePhone?: string | undefined;
    mobilePhone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    organizationalUnitId?: number | undefined;
    department?: string | undefined;
    id!: number;
    isGuest!: boolean;
    partnerId?: number | undefined;
    helpDeskUser!: boolean;
    helpDeskProjectIds?: number[] | undefined;

    constructor(data?: IUpdateUserDataRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined as any;
            this.email = _data["email"];
            this.officePhone = _data["officePhone"];
            this.mobilePhone = _data["mobilePhone"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.countryId = _data["countryId"];
            this.organizationalUnitId = _data["organizationalUnitId"];
            this.department = _data["department"];
            this.id = _data["id"];
            this.isGuest = _data["isGuest"];
            this.partnerId = _data["partnerId"];
            this.helpDeskUser = _data["helpDeskUser"];
            if (Array.isArray(_data["helpDeskProjectIds"])) {
                this.helpDeskProjectIds = [] as any;
                for (let item of _data["helpDeskProjectIds"])
                    this.helpDeskProjectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserDataRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDataRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["email"] = this.email;
        data["officePhone"] = this.officePhone;
        data["mobilePhone"] = this.mobilePhone;
        data["address"] = this.address;
        data["city"] = this.city;
        data["countryId"] = this.countryId;
        data["organizationalUnitId"] = this.organizationalUnitId;
        data["department"] = this.department;
        data["id"] = this.id;
        data["isGuest"] = this.isGuest;
        data["partnerId"] = this.partnerId;
        data["helpDeskUser"] = this.helpDeskUser;
        if (Array.isArray(this.helpDeskProjectIds)) {
            data["helpDeskProjectIds"] = [];
            for (let item of this.helpDeskProjectIds)
                data["helpDeskProjectIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserDataRequestModel {
    firstName: string;
    lastName: string;
    birthDate?: Date | undefined;
    email: string;
    officePhone?: string | undefined;
    mobilePhone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    countryId?: number | undefined;
    organizationalUnitId?: number | undefined;
    department?: string | undefined;
    id: number;
    isGuest: boolean;
    partnerId?: number | undefined;
    helpDeskUser: boolean;
    helpDeskProjectIds?: number[] | undefined;
}

export class UpdateUserPictureRequestModel implements IUpdateUserPictureRequestModel {
    picture!: string;

    constructor(data?: IUpdateUserPictureRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.picture = _data["picture"];
        }
    }

    static fromJS(data: any): UpdateUserPictureRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPictureRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["picture"] = this.picture;
        return data;
    }
}

export interface IUpdateUserPictureRequestModel {
    picture: string;
}

export class UpdateVacationRequestRequest implements IUpdateVacationRequestRequest {
    from!: Date;
    to!: Date;
    note?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease!: boolean;
    id!: number;

    constructor(data?: IUpdateVacationRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.note = _data["note"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.isRelease = _data["isRelease"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateVacationRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVacationRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["note"] = this.note;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["isRelease"] = this.isRelease;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateVacationRequestRequest {
    from: Date;
    to: Date;
    note?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    isRelease: boolean;
    id: number;
}

export class UpdateWbsRequest implements IUpdateWbsRequest {
    id!: number;
    wbs!: string;

    constructor(data?: IUpdateWbsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wbs = _data["wbs"];
        }
    }

    static fromJS(data: any): UpdateWbsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWbsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wbs"] = this.wbs;
        return data;
    }
}

export interface IUpdateWbsRequest {
    id: number;
    wbs: string;
}

export class UploadExcelFileRequest implements IUploadExcelFileRequest {
    excelAttachments?: InsertAttachmentRequest[] | undefined;

    constructor(data?: IUploadExcelFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["excelAttachments"])) {
                this.excelAttachments = [] as any;
                for (let item of _data["excelAttachments"])
                    this.excelAttachments!.push(InsertAttachmentRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UploadExcelFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UploadExcelFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.excelAttachments)) {
            data["excelAttachments"] = [];
            for (let item of this.excelAttachments)
                data["excelAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUploadExcelFileRequest {
    excelAttachments?: InsertAttachmentRequest[] | undefined;
}

export class UploadLanguagesExcelRequestModel implements IUploadLanguagesExcelRequestModel {
    fileContent?: string | undefined;

    constructor(data?: IUploadLanguagesExcelRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileContent = _data["fileContent"];
        }
    }

    static fromJS(data: any): UploadLanguagesExcelRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UploadLanguagesExcelRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileContent"] = this.fileContent;
        return data;
    }
}

export interface IUploadLanguagesExcelRequestModel {
    fileContent?: string | undefined;
}

export enum UrgencyEnum {
    Urgent = "Urgent",
    Normal = "Normal",
}

export class UrgencyImpatPair implements IUrgencyImpatPair {
    urgencyId!: number;
    impactId!: number;

    constructor(data?: IUrgencyImpatPair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.urgencyId = _data["urgencyId"];
            this.impactId = _data["impactId"];
        }
    }

    static fromJS(data: any): UrgencyImpatPair {
        data = typeof data === 'object' ? data : {};
        let result = new UrgencyImpatPair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["urgencyId"] = this.urgencyId;
        data["impactId"] = this.impactId;
        return data;
    }
}

export interface IUrgencyImpatPair {
    urgencyId: number;
    impactId: number;
}

export class UrgencyResponse implements IUrgencyResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    semantics!: UrgencyEnum;

    constructor(data?: IUrgencyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): UrgencyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UrgencyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IUrgencyResponse {
    id: number;
    name: string;
    description?: string | undefined;
    semantics: UrgencyEnum;
}

export class UrgencyResponseItemsResponseModel implements IUrgencyResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: UrgencyResponse[] | undefined;

    constructor(data?: IUrgencyResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UrgencyResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UrgencyResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UrgencyResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUrgencyResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: UrgencyResponse[] | undefined;
}

export enum UserActivityStatusEnum {
    Active = "Active",
    Inactive = "Inactive",
    Blocked = "Blocked",
}

export class UserAlertConfigurationResponse implements IUserAlertConfigurationResponse {
    id!: number;
    tenantId!: number;
    userId!: number;
    entity!: AlertEntitiesEnum;
    trigger!: AlertTriggersEnum;
    enabled!: boolean;
    sendEmail!: boolean;
    entityIds?: number[] | undefined;

    constructor(data?: IUserAlertConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.entity = _data["entity"];
            this.trigger = _data["trigger"];
            this.enabled = _data["enabled"];
            this.sendEmail = _data["sendEmail"];
            if (Array.isArray(_data["entityIds"])) {
                this.entityIds = [] as any;
                for (let item of _data["entityIds"])
                    this.entityIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserAlertConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserAlertConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["entity"] = this.entity;
        data["trigger"] = this.trigger;
        data["enabled"] = this.enabled;
        data["sendEmail"] = this.sendEmail;
        if (Array.isArray(this.entityIds)) {
            data["entityIds"] = [];
            for (let item of this.entityIds)
                data["entityIds"].push(item);
        }
        return data;
    }
}

export interface IUserAlertConfigurationResponse {
    id: number;
    tenantId: number;
    userId: number;
    entity: AlertEntitiesEnum;
    trigger: AlertTriggersEnum;
    enabled: boolean;
    sendEmail: boolean;
    entityIds?: number[] | undefined;
}

export class UserAlertConfigurationResponseItemsResponseModel implements IUserAlertConfigurationResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: UserAlertConfigurationResponse[] | undefined;

    constructor(data?: IUserAlertConfigurationResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserAlertConfigurationResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserAlertConfigurationResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAlertConfigurationResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserAlertConfigurationResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: UserAlertConfigurationResponse[] | undefined;
}

export class UserModel implements IUserModel {
    id!: number;
    isActive!: boolean;
    tenantId!: number;
    firstName!: string;
    lastName!: string;
    email!: string;
    birthDate?: Date | undefined;
    officePhone?: string | undefined;
    mobilePhone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    department?: string | undefined;
    picture?: string | undefined;
    username!: string;
    roleId!: TokenTypeEnum;
    countryId?: number | undefined;
    partnerId?: number | undefined;
    organizationalUnitId?: number | undefined;
    readonly isGuest!: boolean;
    confirmationExpiredAt?: Date | undefined;
    additional?: { [key: string]: any; } | undefined;
    activityStatus!: UserActivityStatusEnum;
    helpDeskUser?: boolean | undefined;
    helpDeskProjectIds?: number[] | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.tenantId = _data["tenantId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : undefined as any;
            this.officePhone = _data["officePhone"];
            this.mobilePhone = _data["mobilePhone"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.department = _data["department"];
            this.picture = _data["picture"];
            this.username = _data["username"];
            this.roleId = _data["roleId"];
            this.countryId = _data["countryId"];
            this.partnerId = _data["partnerId"];
            this.organizationalUnitId = _data["organizationalUnitId"];
            (this as any).isGuest = _data["isGuest"];
            this.confirmationExpiredAt = _data["confirmationExpiredAt"] ? new Date(_data["confirmationExpiredAt"].toString()) : undefined as any;
            if (_data["additional"]) {
                this.additional = {} as any;
                for (let key in _data["additional"]) {
                    if (_data["additional"].hasOwnProperty(key))
                        (this.additional as any)![key] = _data["additional"][key];
                }
            }
            this.activityStatus = _data["activityStatus"];
            this.helpDeskUser = _data["helpDeskUser"];
            if (Array.isArray(_data["helpDeskProjectIds"])) {
                this.helpDeskProjectIds = [] as any;
                for (let item of _data["helpDeskProjectIds"])
                    this.helpDeskProjectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["tenantId"] = this.tenantId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["officePhone"] = this.officePhone;
        data["mobilePhone"] = this.mobilePhone;
        data["address"] = this.address;
        data["city"] = this.city;
        data["department"] = this.department;
        data["picture"] = this.picture;
        data["username"] = this.username;
        data["roleId"] = this.roleId;
        data["countryId"] = this.countryId;
        data["partnerId"] = this.partnerId;
        data["organizationalUnitId"] = this.organizationalUnitId;
        data["isGuest"] = this.isGuest;
        data["confirmationExpiredAt"] = this.confirmationExpiredAt ? this.confirmationExpiredAt.toISOString() : undefined as any;
        if (this.additional) {
            data["additional"] = {};
            for (let key in this.additional) {
                if (this.additional.hasOwnProperty(key))
                    (data["additional"] as any)[key] = (this.additional as any)[key];
            }
        }
        data["activityStatus"] = this.activityStatus;
        data["helpDeskUser"] = this.helpDeskUser;
        if (Array.isArray(this.helpDeskProjectIds)) {
            data["helpDeskProjectIds"] = [];
            for (let item of this.helpDeskProjectIds)
                data["helpDeskProjectIds"].push(item);
        }
        return data;
    }
}

export interface IUserModel {
    id: number;
    isActive: boolean;
    tenantId: number;
    firstName: string;
    lastName: string;
    email: string;
    birthDate?: Date | undefined;
    officePhone?: string | undefined;
    mobilePhone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    department?: string | undefined;
    picture?: string | undefined;
    username: string;
    roleId: TokenTypeEnum;
    countryId?: number | undefined;
    partnerId?: number | undefined;
    organizationalUnitId?: number | undefined;
    isGuest: boolean;
    confirmationExpiredAt?: Date | undefined;
    additional?: { [key: string]: any; } | undefined;
    activityStatus: UserActivityStatusEnum;
    helpDeskUser?: boolean | undefined;
    helpDeskProjectIds?: number[] | undefined;
}

export class UserModelItemsResponseModel implements IUserModelItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: UserModel[] | undefined;

    constructor(data?: IUserModelItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserModelItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModelItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserModelItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: UserModel[] | undefined;
}

export class UserModelSimpleResponseModel implements IUserModelSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: UserModel;

    constructor(data?: IUserModelSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? UserModel.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserModelSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModelSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserModelSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: UserModel;
}

export enum UserStatusEnum {
    Active = "Active",
    Inactive = "Inactive",
}

export class UserStatusResponse implements IUserStatusResponse {
    id!: number;
    name!: string;
    description?: string | undefined;
    isActive!: boolean;
    isReadonly!: boolean;
    color!: string;
    isInitial!: boolean;
    nextStates?: number[] | undefined;
    order!: number;
    semantics!: UserStatusEnum;

    constructor(data?: IUserStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.isReadonly = _data["isReadonly"];
            this.color = _data["color"];
            this.isInitial = _data["isInitial"];
            if (Array.isArray(_data["nextStates"])) {
                this.nextStates = [] as any;
                for (let item of _data["nextStates"])
                    this.nextStates!.push(item);
            }
            this.order = _data["order"];
            this.semantics = _data["semantics"];
        }
    }

    static fromJS(data: any): UserStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["isReadonly"] = this.isReadonly;
        data["color"] = this.color;
        data["isInitial"] = this.isInitial;
        if (Array.isArray(this.nextStates)) {
            data["nextStates"] = [];
            for (let item of this.nextStates)
                data["nextStates"].push(item);
        }
        data["order"] = this.order;
        data["semantics"] = this.semantics;
        return data;
    }
}

export interface IUserStatusResponse {
    id: number;
    name: string;
    description?: string | undefined;
    isActive: boolean;
    isReadonly: boolean;
    color: string;
    isInitial: boolean;
    nextStates?: number[] | undefined;
    order: number;
    semantics: UserStatusEnum;
}

export class UserStatusResponseItemsResponseModel implements IUserStatusResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: UserStatusResponse[] | undefined;

    constructor(data?: IUserStatusResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserStatusResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserStatusResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: UserStatusResponse[] | undefined;
}

export class UserTableViewConfigFilter implements IUserTableViewConfigFilter {
    viewType?: string | undefined;
    offset!: number;
    limit!: number;

    constructor(data?: IUserTableViewConfigFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.viewType = _data["viewType"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): UserTableViewConfigFilter {
        data = typeof data === 'object' ? data : {};
        let result = new UserTableViewConfigFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["viewType"] = this.viewType;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IUserTableViewConfigFilter {
    viewType?: string | undefined;
    offset: number;
    limit: number;
}

export class UserTableViewConfigResponse implements IUserTableViewConfigResponse {
    userId?: number | undefined;
    viewType!: string;
    content!: any;

    constructor(data?: IUserTableViewConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.viewType = _data["viewType"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): UserTableViewConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserTableViewConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["viewType"] = this.viewType;
        data["content"] = this.content;
        return data;
    }
}

export interface IUserTableViewConfigResponse {
    userId?: number | undefined;
    viewType: string;
    content: any;
}

export class UserTableViewConfigResponseItemsResponseModel implements IUserTableViewConfigResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: UserTableViewConfigResponse[] | undefined;

    constructor(data?: IUserTableViewConfigResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserTableViewConfigResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserTableViewConfigResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserTableViewConfigResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserTableViewConfigResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: UserTableViewConfigResponse[] | undefined;
}

export class UserTableViewConfigResponseSimpleResponseModel implements IUserTableViewConfigResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: UserTableViewConfigResponse;

    constructor(data?: IUserTableViewConfigResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? UserTableViewConfigResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserTableViewConfigResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserTableViewConfigResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserTableViewConfigResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: UserTableViewConfigResponse;
}

export class VacationRequestResponse implements IVacationRequestResponse {
    id!: number;
    from!: Date;
    to!: Date;
    numberOfDays!: number;
    note?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    userId!: number;
    calculatedStatusId!: number;
    readonly year!: number;
    statuses?: VacationRequestStatusResponse[] | undefined;

    constructor(data?: IVacationRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.numberOfDays = _data["numberOfDays"];
            this.note = _data["note"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.userId = _data["userId"];
            this.calculatedStatusId = _data["calculatedStatusId"];
            (this as any).year = _data["year"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(VacationRequestStatusResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VacationRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VacationRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["numberOfDays"] = this.numberOfDays;
        data["note"] = this.note;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["userId"] = this.userId;
        data["calculatedStatusId"] = this.calculatedStatusId;
        data["year"] = this.year;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVacationRequestResponse {
    id: number;
    from: Date;
    to: Date;
    numberOfDays: number;
    note?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    userId: number;
    calculatedStatusId: number;
    year: number;
    statuses?: VacationRequestStatusResponse[] | undefined;
}

export class VacationRequestResponseItemsResponseModel implements IVacationRequestResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: VacationRequestResponse[] | undefined;

    constructor(data?: IVacationRequestResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VacationRequestResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VacationRequestResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new VacationRequestResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVacationRequestResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: VacationRequestResponse[] | undefined;
}

export class VacationRequestResponseSimpleResponseModel implements IVacationRequestResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: VacationRequestResponse;

    constructor(data?: IVacationRequestResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? VacationRequestResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): VacationRequestResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new VacationRequestResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IVacationRequestResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: VacationRequestResponse;
}

export class VacationRequestStatusFullResponse implements IVacationRequestStatusFullResponse {
    id!: number;
    vacationRequestId!: number;
    approvedOrRejectedByUserId?: number | undefined;
    projectManagerUserId!: number;
    projectId!: number;
    statusId!: number;
    from!: Date;
    to!: Date;
    note?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    userId!: number;

    constructor(data?: IVacationRequestStatusFullResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vacationRequestId = _data["vacationRequestId"];
            this.approvedOrRejectedByUserId = _data["approvedOrRejectedByUserId"];
            this.projectManagerUserId = _data["projectManagerUserId"];
            this.projectId = _data["projectId"];
            this.statusId = _data["statusId"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : undefined as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : undefined as any;
            this.note = _data["note"];
            this.customText1 = _data["customText1"];
            this.customText2 = _data["customText2"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): VacationRequestStatusFullResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VacationRequestStatusFullResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vacationRequestId"] = this.vacationRequestId;
        data["approvedOrRejectedByUserId"] = this.approvedOrRejectedByUserId;
        data["projectManagerUserId"] = this.projectManagerUserId;
        data["projectId"] = this.projectId;
        data["statusId"] = this.statusId;
        data["from"] = this.from ? formatDate(this.from) : undefined as any;
        data["to"] = this.to ? formatDate(this.to) : undefined as any;
        data["note"] = this.note;
        data["customText1"] = this.customText1;
        data["customText2"] = this.customText2;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IVacationRequestStatusFullResponse {
    id: number;
    vacationRequestId: number;
    approvedOrRejectedByUserId?: number | undefined;
    projectManagerUserId: number;
    projectId: number;
    statusId: number;
    from: Date;
    to: Date;
    note?: string | undefined;
    customText1?: string | undefined;
    customText2?: string | undefined;
    userId: number;
}

export class VacationRequestStatusFullResponseItemsResponseModel implements IVacationRequestStatusFullResponseItemsResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: VacationRequestStatusFullResponse[] | undefined;

    constructor(data?: IVacationRequestStatusFullResponseItemsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VacationRequestStatusFullResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VacationRequestStatusFullResponseItemsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new VacationRequestStatusFullResponseItemsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVacationRequestStatusFullResponseItemsResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    count?: number | undefined;
    items?: VacationRequestStatusFullResponse[] | undefined;
}

export class VacationRequestStatusResponse implements IVacationRequestStatusResponse {
    id!: number;
    vacationRequestId!: number;
    approvedOrRejectedByUserId?: number | undefined;
    projectManagerUserId!: number;
    projectId!: number;
    statusId!: number;

    constructor(data?: IVacationRequestStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vacationRequestId = _data["vacationRequestId"];
            this.approvedOrRejectedByUserId = _data["approvedOrRejectedByUserId"];
            this.projectManagerUserId = _data["projectManagerUserId"];
            this.projectId = _data["projectId"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): VacationRequestStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VacationRequestStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vacationRequestId"] = this.vacationRequestId;
        data["approvedOrRejectedByUserId"] = this.approvedOrRejectedByUserId;
        data["projectManagerUserId"] = this.projectManagerUserId;
        data["projectId"] = this.projectId;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface IVacationRequestStatusResponse {
    id: number;
    vacationRequestId: number;
    approvedOrRejectedByUserId?: number | undefined;
    projectManagerUserId: number;
    projectId: number;
    statusId: number;
}

export class VacationRequestStatusResponseSimpleResponseModel implements IVacationRequestStatusResponseSimpleResponseModel {
    readonly success!: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: VacationRequestStatusResponse;

    constructor(data?: IVacationRequestStatusResponseSimpleResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).success = _data["success"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] ? MessageModel.fromJS(_data["errors"][key]) : new MessageModel();
                }
            }
            this.value = _data["value"] ? VacationRequestStatusResponse.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): VacationRequestStatusResponseSimpleResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new VacationRequestStatusResponseSimpleResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] ? this.errors[key].toJSON() : undefined as any;
            }
        }
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IVacationRequestStatusResponseSimpleResponseModel {
    success: boolean;
    errors?: { [key: string]: MessageModel; } | undefined;
    value?: VacationRequestStatusResponse;
}

export class WbsLevel1ItemResponse implements IWbsLevel1ItemResponse {
    id!: number;
    wbs?: string | undefined;
    name?: string | undefined;

    constructor(data?: IWbsLevel1ItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.wbs = _data["wbs"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WbsLevel1ItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WbsLevel1ItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["wbs"] = this.wbs;
        data["name"] = this.name;
        return data;
    }
}

export interface IWbsLevel1ItemResponse {
    id: number;
    wbs?: string | undefined;
    name?: string | undefined;
}

export enum WeekDayEnum {
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
    Sunday = "Sunday",
}

export enum WeeklyDaysEnum {
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
    Sunday = "Sunday",
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}